import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: any;
  Coordinates: any;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** An arbitrary-precision Decimal type */
  Decimal: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  Timestamp: any;
  TimestampWithTimezone: any;
  /** A field whose value is a generic Universally Unique Identifier: https://en.wikipedia.org/wiki/Universally_unique_identifier. */
  UUID: any;
};

export type AcceptNetworkOffer = {
  claim?: InputMaybe<Scalars['Boolean']>;
  driverId?: InputMaybe<Scalars['UUID']>;
  tripId: Scalars['UUID'];
  vehicleId?: InputMaybe<Scalars['UUID']>;
  vendorExternalId?: InputMaybe<Scalars['UUID']>;
};

export type Account = {
  __typename?: 'Account';
  accountAdjustments: Array<AccountAdjustment>;
  accountOwner?: Maybe<Contact>;
  activeCardProcessor?: Maybe<CreditCardProcessor>;
  bodilyInjuryPerAccident?: Maybe<Scalars['Float']>;
  bodilyInjuryPerPerson?: Maybe<Scalars['Float']>;
  bookingToken?: Maybe<Scalars['String']>;
  bookingToolEnabled?: Maybe<Scalars['Boolean']>;
  childSeat?: Maybe<Scalars['Boolean']>;
  contacts?: Maybe<Array<Contact>>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  description?: Maybe<Scalars['String']>;
  displayRatesInBookingTool?: Maybe<Scalars['Boolean']>;
  drivers: Array<Driver>;
  established?: Maybe<Scalars['TimestampWithTimezone']>;
  externalId?: Maybe<Scalars['UUID']>;
  facebookUrl?: Maybe<Scalars['String']>;
  favoriteDriver?: Maybe<Array<FavoriteDriver>>;
  garages: Array<Garage>;
  id: Scalars['UUID'];
  instagramUrl?: Maybe<Scalars['String']>;
  insuranceCombinedSingleLimitPerAccident?: Maybe<Scalars['Float']>;
  isFavorite?: Maybe<Scalars['Boolean']>;
  isInternal?: Maybe<Scalars['Boolean']>;
  legalName?: Maybe<Scalars['String']>;
  licensesAndCertifications?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  locations: Array<Location>;
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  petPolicy?: Maybe<Scalars['String']>;
  primaryEmailAddress?: Maybe<Scalars['String']>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  propertyDamagePerAccident?: Maybe<Scalars['Float']>;
  providerAccount?: Maybe<ProviderAccountSource>;
  rateSets: Array<RateSet>;
  rateTypes: Array<RateType>;
  rates: Array<Rate>;
  salesPitch?: Maybe<Scalars['String']>;
  spokenLanguages: Array<Scalars['String']>;
  squareAccessToken?: Maybe<Scalars['String']>;
  squareMerchantId?: Maybe<Scalars['String']>;
  squareRefreshToken?: Maybe<Scalars['String']>;
  squareTokenExpiresAt?: Maybe<Scalars['String']>;
  stripeAccountCanCharge?: Maybe<Scalars['Boolean']>;
  stripeAccountId?: Maybe<Scalars['String']>;
  twitterUrl?: Maybe<Scalars['String']>;
  updatedAt: Scalars['TimestampWithTimezone'];
  vehicleClasses?: Maybe<Array<VehicleClass>>;
  vehicles?: Maybe<Array<Vehicle>>;
  venmoHandle?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
  videoUrl?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  workersCompensantionLiabilityCoverage?: Maybe<Scalars['Boolean']>;
  yearsInBusiness?: Maybe<Scalars['Int']>;
  zelleHandle?: Maybe<Scalars['String']>;
};

export type AccountAdjustment = {
  __typename?: 'AccountAdjustment';
  account: Account;
  accountId: Scalars['UUID'];
  active?: Maybe<Scalars['Boolean']>;
  amount: Scalars['Float'];
  calculation?: Maybe<AdjustmentCalculation>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  rateType: RateType;
  rateTypeId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type AccountAdjustmentCollectionResult = {
  __typename?: 'AccountAdjustmentCollectionResult';
  items: Array<AccountAdjustment>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type AccountAdjustmentQueries = {
  __typename?: 'AccountAdjustmentQueries';
  all: AccountAdjustmentCollectionResult;
  byId?: Maybe<AccountAdjustment>;
};


export type AccountAdjustmentQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type AccountAdjustmentQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type AccountCollectionResult = {
  __typename?: 'AccountCollectionResult';
  items: Array<Account>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type AccountDefaultNotifications = {
  __typename?: 'AccountDefaultNotifications';
  account: Account;
  accountId: Scalars['UUID'];
  channels: Array<MessageChannel>;
  createdAt: Scalars['TimestampWithTimezone'];
  customerRole: CustomerRole;
  customerType: CustomerType;
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['UUID'];
  notificationType: TripNotificationType;
  tripNotificationTypeId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type AccountDefaultNotificationsCollectionResult = {
  __typename?: 'AccountDefaultNotificationsCollectionResult';
  items: Array<AccountDefaultNotifications>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type AccountDefaultNotificationsQueries = {
  __typename?: 'AccountDefaultNotificationsQueries';
  all: AccountDefaultNotificationsCollectionResult;
  byId?: Maybe<AccountDefaultNotifications>;
};


export type AccountDefaultNotificationsQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type AccountDefaultNotificationsQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type AccountEntity = {
  account: Account;
  accountId: Scalars['UUID'];
};

export type AccountQueries = {
  __typename?: 'AccountQueries';
  all: AccountCollectionResult;
  byId?: Maybe<Account>;
  getProviderAccount?: Maybe<Account>;
  publicDetailsAccount?: Maybe<Account>;
  search: AccountCollectionResult;
  searchByTrip: AccountCollectionResult;
};


export type AccountQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type AccountQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type AccountQueriesGetProviderAccountArgs = {
  providerSource: ProviderAccountSource;
};


export type AccountQueriesPublicDetailsAccountArgs = {
  bookingToken: Scalars['String'];
};


export type AccountQueriesSearchArgs = {
  includeFavorites?: InputMaybe<Scalars['Boolean']>;
  networkPartners?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type AccountQueriesSearchByTripArgs = {
  includeFavorites?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  range?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  systemClassId?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  tripId: Scalars['UUID'];
};

export type AccountTemplateResult = {
  __typename?: 'AccountTemplateResult';
  account?: Maybe<Account>;
  errorMessage?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type AddTripWaypoint = {
  distanceAndTime: DistancesAndTime;
  tripId: Scalars['UUID'];
  waypoint: UpsertTripWaypointInput;
};

export enum AddonCode {
  CapitalDrivePlatinumSharedTripsAddon = 'CAPITAL_DRIVE_PLATINUM_SHARED_TRIPS_ADDON',
  CapitalDrivePremiumSharedTripsAddon = 'CAPITAL_DRIVE_PREMIUM_SHARED_TRIPS_ADDON'
}

export enum AddonType {
  SharedTrips = 'SHARED_TRIPS'
}

export type AddonUsageRecord = {
  __typename?: 'AddonUsageRecord';
  SHARED_TRIPS?: Maybe<Scalars['Float']>;
};

export type Address = {
  __typename?: 'Address';
  line1?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<LocationCategory>;
  city?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['Coordinates']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  placeId: Scalars['String'];
  placeName: Scalars['String'];
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export enum AddressTypeEnum {
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Work = 'WORK'
}

export enum AdjustmentCalculation {
  Flat = 'Flat',
  Percentage = 'Percentage'
}

export type Airline = {
  __typename?: 'Airline';
  IATA: Scalars['String'];
  ICAO: Scalars['String'];
  callsign?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  hub?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
  website?: Maybe<Scalars['String']>;
};

export type AirlineCollectionResult = {
  __typename?: 'AirlineCollectionResult';
  items: Array<Airline>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type AirlineLabel = {
  __typename?: 'AirlineLabel';
  id: Scalars['UUID'];
  label: Scalars['String'];
};

export type AirlineQueries = {
  __typename?: 'AirlineQueries';
  airlinesAutocomplete: Array<Maybe<AirlineLabel>>;
  all: AirlineCollectionResult;
  byIcaoCode?: Maybe<Airline>;
  byId?: Maybe<Airline>;
};


export type AirlineQueriesAirlinesAutocompleteArgs = {
  query: Scalars['String'];
};


export type AirlineQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type AirlineQueriesByIcaoCodeArgs = {
  icao: Scalars['String'];
};


export type AirlineQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type AmountMoney = {
  amount: Scalars['Int'];
  currency: Scalars['String'];
};

export type AppliedRate = {
  __typename?: 'AppliedRate';
  addon?: Maybe<TripAddon>;
  comment?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  rate?: Maybe<AppliedRateDefinition>;
  ratePolicy?: Maybe<AppliedRatePolicyDefinition>;
  revertedToDynamicPricing?: Maybe<Scalars['Boolean']>;
  total: Scalars['Float'];
  tripLeg?: Maybe<TripWaypointRole>;
  unitPrice: Scalars['Float'];
  vehicleClassOverride?: Maybe<VehicleClassOverride>;
};

export type AppliedRateDefinition = {
  __typename?: 'AppliedRateDefinition';
  amount?: Maybe<Scalars['Float']>;
  calculation?: Maybe<RateCalculation>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  meteredRateIncrement?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  rateType: AppliedRateTypeDefinition;
  revertToDynamicForExcessWaitTime?: Maybe<Scalars['Boolean']>;
};

export type AppliedRateDefinitions = {
  __typename?: 'AppliedRateDefinitions';
  baseRate?: Maybe<AppliedRateDefinition>;
  defaultBillingIncrement?: Maybe<Scalars['Int']>;
  policies: AppliedRatePolicyDefinitionSet;
  revertToDynamicForExcessWaitTime?: Maybe<Scalars['Boolean']>;
  vehicleClassId?: Maybe<Scalars['UUID']>;
};

export type AppliedRateGroup = {
  __typename?: 'AppliedRateGroup';
  group: RateGroup;
  groupTotal: Scalars['Float'];
  rates: Array<AppliedRate>;
  subtotal: Scalars['Float'];
};

export type AppliedRatePolicyDefinition = {
  __typename?: 'AppliedRatePolicyDefinition';
  feePercentage?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  isApplied?: Maybe<Scalars['Boolean']>;
  thresholdValue?: Maybe<Scalars['Float']>;
  thresholdValue2?: Maybe<Scalars['Float']>;
  type: RatePolicyType;
};

export type AppliedRatePolicyDefinitionSet = {
  __typename?: 'AppliedRatePolicyDefinitionSet';
  airportWaitTime?: Maybe<AppliedRatePolicyDefinition>;
  cancellation?: Maybe<AppliedRatePolicyDefinition>;
  garageTime?: Maybe<AppliedRatePolicyDefinition>;
  minimumCharge?: Maybe<AppliedRatePolicyDefinition>;
  waitTime?: Maybe<AppliedRatePolicyDefinition>;
};

export type AppliedRateTypeDefinition = {
  __typename?: 'AppliedRateTypeDefinition';
  category: RateCategory;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
};

export type AppliedRates = {
  __typename?: 'AppliedRates';
  baseGroup: AppliedRateGroup;
  definitions: AppliedRateDefinitions;
  invoiceType: InvoiceType;
  subtotalGroup: AppliedRateGroup;
  times?: Maybe<BillingTimes>;
  total: Scalars['Float'];
  totalGroup: AppliedRateGroup;
  tripId: Scalars['UUID'];
};

export type ApplyFlatRateOverride = {
  flateRate: Scalars['Float'];
  tripId: Scalars['UUID'];
};

export type ApplyRefund = {
  amountRefunded: Scalars['Float'];
  note?: InputMaybe<Scalars['String']>;
  refundReason: Scalars['String'];
  tripId: Scalars['UUID'];
};

export enum AreaType {
  CustomGeofence = 'CustomGeofence',
  Place = 'Place',
  Radius = 'Radius'
}

export type ArriveDropoff = {
  location?: InputMaybe<TripCommandLocation>;
  tripId: Scalars['UUID'];
};

export type ArriveGarage = {
  location?: InputMaybe<TripCommandLocation>;
  tripId: Scalars['UUID'];
};

export type ArrivePickup = {
  location?: InputMaybe<TripCommandLocation>;
  stagingNotes?: InputMaybe<Scalars['String']>;
  tripId: Scalars['UUID'];
};

export type ArriveStop = {
  location?: InputMaybe<TripCommandLocation>;
  tripId: Scalars['UUID'];
};

export type AssignTrip = {
  driverId?: InputMaybe<Scalars['UUID']>;
  tripId: Scalars['UUID'];
  vehicleId?: InputMaybe<Scalars['UUID']>;
};

export type AvailabilityQueryCriteria = {
  accountId: Scalars['UUID'];
  conflictBufferInMinutes?: InputMaybe<Scalars['Int']>;
  driverId?: InputMaybe<Scalars['UUID']>;
  endTime: Scalars['DateTime'];
  relatedTripId: Scalars['UUID'];
  startTime: Scalars['DateTime'];
  vehicleClassId?: InputMaybe<Scalars['UUID']>;
  vehicleId?: InputMaybe<Scalars['UUID']>;
};

export type AvailableDriver = {
  __typename?: 'AvailableDriver';
  id: Scalars['UUID'];
  imageUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type AvailableDriverCriteria = {
  conflictBufferInMinutes?: InputMaybe<Scalars['Int']>;
  tripId: Scalars['UUID'];
};

export type AvailableDrivers = {
  __typename?: 'AvailableDrivers';
  internal: Array<DriverAvailabilitySummary>;
};

export type AvailableVehicle = {
  __typename?: 'AvailableVehicle';
  id: Scalars['UUID'];
  licenseNumber?: Maybe<Scalars['String']>;
  makeName?: Maybe<Scalars['String']>;
  modelName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  vehicleClassId: Scalars['UUID'];
  vehicleClassName?: Maybe<Scalars['String']>;
  vehicleSystemClass?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type AvailableVehicles = {
  __typename?: 'AvailableVehicles';
  internal: Array<VehicleAvailabilitySummary>;
};

export type BaseRateOverriddenEvent = TripEvent & {
  __typename?: 'BaseRateOverriddenEvent';
  id: Scalars['UUID'];
  newBaseRate?: Maybe<Scalars['Float']>;
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type BillingTimes = {
  __typename?: 'BillingTimes';
  actualDuration?: Maybe<Scalars['Int']>;
  billableDuration?: Maybe<Scalars['Int']>;
  driverOnsite?: Maybe<BillingTimestamps>;
  garageIn?: Maybe<BillingTimestamps>;
  garageOut?: Maybe<BillingTimestamps>;
  passengerDropped?: Maybe<BillingTimestamps>;
  pickupTime?: Maybe<BillingTimestamps>;
  tripCancelled?: Maybe<BillingTimestamps>;
};

export type BillingTimestamps = {
  __typename?: 'BillingTimestamps';
  actualTime?: Maybe<Scalars['DateTime']>;
  reportedTime?: Maybe<Scalars['DateTime']>;
  timestamp?: Maybe<Scalars['DateTime']>;
};

export type Booking = {
  __typename?: 'Booking';
  account?: Maybe<Account>;
  accountId: Scalars['UUID'];
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  sentAt: Scalars['DateTime'];
  status: BookingStatus;
  token: Scalars['String'];
  tripId?: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type BookingCollectionResult = {
  __typename?: 'BookingCollectionResult';
  items: Array<Booking>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type BookingQueries = {
  __typename?: 'BookingQueries';
  all: BookingCollectionResult;
  byId?: Maybe<Booking>;
  byToken?: Maybe<Booking>;
};


export type BookingQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type BookingQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type BookingQueriesByTokenArgs = {
  bookingToken: Scalars['UUID'];
};

export enum BookingStatus {
  Cancelled = 'Cancelled',
  Created = 'Created',
  Done = 'Done',
  Expired = 'Expired',
  Sent = 'Sent'
}

export type BulkClientPaymentProcessorInput = {
  clientId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  externalCustomerId: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  paymentProcessor: PaymentProcessor;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type BulkCompanyInput = {
  accountId: Scalars['UUID'];
  addresses?: InputMaybe<Array<ClientAddressInput>>;
  createdAt?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<ClientEmailInput>>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<ClientPhoneInput>>;
  rates?: InputMaybe<Array<CompanyRateInput>>;
  type: CompanyTypeEnum;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type BulkInsertClientsInput = {
  accountId: Scalars['UUID'];
  addresses?: InputMaybe<Array<ClientAddressInput>>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<ClientEmailInput>>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<ClientPhoneInput>>;
  primaryRole: ClientRole;
  rates?: InputMaybe<Array<ClientRateInput>>;
  title?: InputMaybe<Scalars['String']>;
  tripClient?: InputMaybe<TripClientInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type BulkTripClientInput = {
  clientId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPrimary: Scalars['Boolean'];
  role: ClientRole;
  tripId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type CancelSavoyaSharedTripOffer = {
  reservationCancelled: Scalars['Boolean'];
  tripId: Scalars['UUID'];
  vendorExternalId?: InputMaybe<Scalars['UUID']>;
};

export type CancelTrip = {
  notes?: InputMaybe<Scalars['String']>;
  reason: TripCancellationReason;
  tripId: Scalars['UUID'];
};

export type ChangeLog = {
  __typename?: 'ChangeLog';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['UUID']>;
  changeType: ChangeType;
  changes: Scalars['JSON'];
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  entityId: Scalars['UUID'];
  entityType: Scalars['String'];
  id: Scalars['UUID'];
  metadata?: Maybe<Scalars['JSON']>;
  trip?: Maybe<Trip>;
  tripId?: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type ChangeLogCollectionResult = {
  __typename?: 'ChangeLogCollectionResult';
  items: Array<ChangeLog>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type ChangeLogQueries = {
  __typename?: 'ChangeLogQueries';
  all: ChangeLogCollectionResult;
  byId?: Maybe<ChangeLog>;
};


export type ChangeLogQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type ChangeLogQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type ChangeLogResult = {
  __typename?: 'ChangeLogResult';
  changed?: Maybe<Scalars['Boolean']>;
  changes?: Maybe<ChangeLog>;
};

export enum ChangeType {
  Add = 'Add',
  Remove = 'Remove',
  Update = 'Update'
}

export type Circling = {
  location?: InputMaybe<TripCommandLocation>;
  tripId: Scalars['UUID'];
};

export type ClientAddressInput = {
  addressLineFour?: InputMaybe<Scalars['String']>;
  addressLineOne: Scalars['String'];
  addressLineThree?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  createdAt?: InputMaybe<Scalars['String']>;
  locality: Scalars['String'];
  postalCode: Scalars['String'];
  region: Scalars['String'];
  type: AddressTypeEnum;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type ClientAddressRecord = {
  __typename?: 'ClientAddressRecord';
  addressLineFour?: Maybe<Scalars['String']>;
  addressLineOne: Scalars['String'];
  addressLineThree?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  formattedAddress: Scalars['String'];
  id: Scalars['UUID'];
  locality: Scalars['String'];
  postalCode: Scalars['String'];
  region: Scalars['String'];
  type: AddressTypeEnum;
};

export type ClientEmailInput = {
  email: Scalars['String'];
  type: EmailTypeEnum;
};

export type ClientEmailRecord = {
  __typename?: 'ClientEmailRecord';
  email: Scalars['String'];
  id: Scalars['UUID'];
  type: EmailTypeEnum;
};

export enum ClientImportSource {
  LimoAnywhere = 'LimoAnywhere'
}

export type ClientMutationError = {
  __typename?: 'ClientMutationError';
  code?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type ClientPaymentProcessorRecord = {
  __typename?: 'ClientPaymentProcessorRecord';
  clientId: Scalars['UUID'];
  createdAt?: Maybe<Scalars['DateTime']>;
  externalCustomerId: Scalars['String'];
  id: Scalars['UUID'];
  paymentProcessor: PaymentProcessor;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientPhoneInput = {
  phoneNumber: Scalars['String'];
  type: PhoneTypeEnum;
};

export type ClientPhoneRecord = {
  __typename?: 'ClientPhoneRecord';
  id: Scalars['UUID'];
  phoneNumber: Scalars['String'];
  type: PhoneTypeEnum;
};

export type ClientRateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  rateSetId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type ClientRateSetRecord = {
  __typename?: 'ClientRateSetRecord';
  client?: Maybe<ClientRecord>;
  clientId: Scalars['UUID'];
  id: Scalars['UUID'];
  rateSetId: Scalars['UUID'];
};

export type ClientRecord = {
  __typename?: 'ClientRecord';
  accountId: Scalars['String'];
  addresses?: Maybe<Array<ClientAddressRecord>>;
  bookers?: Maybe<Array<ClientRecord>>;
  companies?: Maybe<Array<CompanyRecord>>;
  emails?: Maybe<Array<ClientEmailRecord>>;
  id: Scalars['UUID'];
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  passengers?: Maybe<Array<ClientRecord>>;
  phoneNumbers?: Maybe<Array<ClientPhoneRecord>>;
  primaryRole: ClientRole;
  rates?: Maybe<Array<ClientRateSetRecord>>;
  sourceProduct: ProductType;
  title?: Maybe<Scalars['String']>;
  tripClients?: Maybe<Array<TripClientRecord>>;
};

export enum ClientRole {
  Booker = 'BOOKER',
  Passenger = 'PASSENGER'
}

export type ClientSearchResponse = {
  __typename?: 'ClientSearchResponse';
  items: Array<ClientRecord>;
  total: Scalars['Float'];
};

export type ClientsByRateResponse = {
  __typename?: 'ClientsByRateResponse';
  clients: Array<ClientRecord>;
  rateSetId: Scalars['UUID'];
};

export type ClientsQueries = {
  __typename?: 'ClientsQueries';
  getByEmailAndAccount?: Maybe<Array<ClientRecord>>;
  getByNameAndAccount?: Maybe<Array<ClientRecord>>;
  getClientById?: Maybe<ClientRecord>;
  getClientsByAccountId?: Maybe<Array<ClientRecord>>;
  getClientsByCompanyId?: Maybe<Array<ClientRecord>>;
  getClientsByName?: Maybe<Array<ClientRecord>>;
  getClientsByRateSetIds?: Maybe<Array<ClientsByRateResponse>>;
  getTripBookerClient?: Maybe<ClientRecord>;
  getTripClient?: Maybe<TripClientRecord>;
  getTripClientsByClient?: Maybe<Array<TripClientRecord>>;
  getTripClientsByCompany?: Maybe<Array<TripClientRecord>>;
  getTripClientsByTrip?: Maybe<Array<TripClientRecord>>;
  getTripClientsByTripIds?: Maybe<Array<TripClientRecord>>;
  getTripPassengerClient?: Maybe<ClientRecord>;
  searchClients?: Maybe<ClientSearchResponse>;
};


export type ClientsQueriesGetByEmailAndAccountArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  skip?: Scalars['Float'];
  take?: Scalars['Float'];
};


export type ClientsQueriesGetByNameAndAccountArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  skip?: Scalars['Float'];
  take?: Scalars['Float'];
};


export type ClientsQueriesGetClientByIdArgs = {
  clientId: Scalars['UUID'];
};


export type ClientsQueriesGetClientsByAccountIdArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  skip?: Scalars['Float'];
  take?: Scalars['Float'];
};


export type ClientsQueriesGetClientsByCompanyIdArgs = {
  companyId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  skip?: Scalars['Float'];
  take?: Scalars['Float'];
};


export type ClientsQueriesGetClientsByNameArgs = {
  companyId?: InputMaybe<Scalars['UUID']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  skip?: Scalars['Float'];
  take?: Scalars['Float'];
};


export type ClientsQueriesGetClientsByRateSetIdsArgs = {
  rateSetIds: Array<Scalars['UUID']>;
};


export type ClientsQueriesGetTripBookerClientArgs = {
  tripId: Scalars['UUID'];
};


export type ClientsQueriesGetTripClientArgs = {
  tripClientId: Scalars['UUID'];
};


export type ClientsQueriesGetTripClientsByClientArgs = {
  clientId: Scalars['UUID'];
};


export type ClientsQueriesGetTripClientsByCompanyArgs = {
  companyId: Scalars['UUID'];
};


export type ClientsQueriesGetTripClientsByTripArgs = {
  tripId: Scalars['UUID'];
};


export type ClientsQueriesGetTripClientsByTripIdsArgs = {
  tripIds: Array<Scalars['UUID']>;
};


export type ClientsQueriesGetTripPassengerClientArgs = {
  tripId: Scalars['UUID'];
};


export type ClientsQueriesSearchClientsArgs = {
  accountId?: InputMaybe<Scalars['UUID']>;
  clientId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderByDirection>;
  primaryRole?: InputMaybe<ClientRole>;
  rateSetId?: InputMaybe<Scalars['UUID']>;
  skip?: Scalars['Float'];
  take?: Scalars['Float'];
  tripIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type CloseTrip = {
  tripId: Scalars['UUID'];
};

export type ColumnOptions = {
  enum?: InputMaybe<Array<Scalars['String']>>;
  length?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  nullable?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  unique?: InputMaybe<Scalars['Boolean']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type CompaniesByRateResponse = {
  __typename?: 'CompaniesByRateResponse';
  companies: Array<CompanyRecord>;
  rateSetId: Scalars['UUID'];
};

export type CompanyAddressRecord = {
  __typename?: 'CompanyAddressRecord';
  addressLineFour?: Maybe<Scalars['String']>;
  addressLineOne: Scalars['String'];
  addressLineThree?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  formattedAddress: Scalars['String'];
  id: Scalars['UUID'];
  locality: Scalars['String'];
  postalCode: Scalars['String'];
  region: Scalars['String'];
  type: AddressTypeEnum;
};

export type CompanyEmailRecord = {
  __typename?: 'CompanyEmailRecord';
  email: Scalars['String'];
  id: Scalars['UUID'];
  type: EmailTypeEnum;
};

export type CompanyPhoneRecord = {
  __typename?: 'CompanyPhoneRecord';
  id: Scalars['UUID'];
  phoneNumber: Scalars['String'];
  type: PhoneTypeEnum;
};

export type CompanyQueries = {
  __typename?: 'CompanyQueries';
  findByAccount?: Maybe<Array<CompanyRecord>>;
  findByAccountAndName?: Maybe<Array<CompanyRecord>>;
  getById?: Maybe<CompanyRecord>;
  getCompaniesByRateSets?: Maybe<Array<CompaniesByRateResponse>>;
  search?: Maybe<CompanySearchResponse>;
};


export type CompanyQueriesFindByAccountArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderByDirection>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type CompanyQueriesFindByAccountAndNameArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
};


export type CompanyQueriesGetByIdArgs = {
  companyId: Scalars['UUID'];
};


export type CompanyQueriesGetCompaniesByRateSetsArgs = {
  rateSetIds: Array<Scalars['UUID']>;
};


export type CompanyQueriesSearchArgs = {
  accountId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderByDirection>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  rateSetId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Float']>;
  take?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<CompanyTypeEnum>;
};

export type CompanyRateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  rateSetId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type CompanyRateSetRecord = {
  __typename?: 'CompanyRateSetRecord';
  company?: Maybe<CompanyRecord>;
  companyId: Scalars['UUID'];
  id: Scalars['UUID'];
  rateSetId: Scalars['UUID'];
};

export type CompanyRecord = {
  __typename?: 'CompanyRecord';
  accountId: Scalars['String'];
  addresses?: Maybe<Array<CompanyAddressRecord>>;
  clients?: Maybe<Array<ClientRecord>>;
  emails?: Maybe<Array<CompanyEmailRecord>>;
  id: Scalars['UUID'];
  isActive?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<CompanyPhoneRecord>>;
  rates?: Maybe<Array<CompanyRateSetRecord>>;
  sourceProduct: ProductType;
  type: CompanyTypeEnum;
};

export type CompanySearchResponse = {
  __typename?: 'CompanySearchResponse';
  items: Array<CompanyRecord>;
  total: Scalars['Float'];
};

export enum CompanyTypeEnum {
  Organization = 'ORGANIZATION'
}

export type ConfirmNetworkRequest = {
  claim?: InputMaybe<Scalars['Boolean']>;
  driverId?: InputMaybe<Scalars['UUID']>;
  tripId: Scalars['UUID'];
  vehicleId?: InputMaybe<Scalars['UUID']>;
  vendorExternalId?: InputMaybe<Scalars['UUID']>;
};

export type Contact = {
  __typename?: 'Contact';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['UUID']>;
  addresses?: Maybe<Array<Location>>;
  analyticsToken?: Maybe<Scalars['String']>;
  contactType: ContactType;
  createdAt: Scalars['TimestampWithTimezone'];
  customerContact?: Maybe<CustomerContact>;
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  driver?: Maybe<Driver>;
  email: Scalars['String'];
  favoriteDrivers?: Maybe<Array<FavoriteDriver>>;
  firebaseToken?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  tripContacts?: Maybe<Array<TripContact>>;
  updatedAt: Scalars['TimestampWithTimezone'];
  userRole: UserRole;
  version: Scalars['Int'];
};

export type ContactCollectionResult = {
  __typename?: 'ContactCollectionResult';
  items: Array<Contact>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type ContactQueries = {
  __typename?: 'ContactQueries';
  all: ContactCollectionResult;
  byEmail?: Maybe<Contact>;
  byEmailAndAccount?: Maybe<Contact>;
  byId?: Maybe<Contact>;
  byType: ContactCollectionResult;
  getAccountId?: Maybe<Scalars['String']>;
  me?: Maybe<Contact>;
  search: ContactCollectionResult;
  usersByAccount: ContactCollectionResult;
};


export type ContactQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type ContactQueriesByEmailArgs = {
  email: Scalars['String'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type ContactQueriesByEmailAndAccountArgs = {
  accountId: Scalars['UUID'];
  email: Scalars['String'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
};


export type ContactQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type ContactQueriesByTypeArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  type: ContactType;
};


export type ContactQueriesSearchArgs = {
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderByDirection>;
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ContactType>;
  userId?: InputMaybe<Scalars['UUID']>;
  userRole?: InputMaybe<UserRole>;
};


export type ContactQueriesUsersByAccountArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export enum ContactType {
  Contact = 'Contact',
  User = 'User'
}

export type CoordsInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type CorrectTripTimestamp = {
  newTimestamp: Scalars['DateTime'];
  note?: InputMaybe<Scalars['String']>;
  reason: TripStatusTimeCorrectionReason;
  timestampId: Scalars['UUID'];
};

export type CreateOrUpdateInvoice = {
  tripId: Scalars['UUID'];
  type?: InputMaybe<InvoiceType>;
};

export type CreatePaymentInput = {
  amountMoney: AmountMoney;
  customerId?: InputMaybe<Scalars['String']>;
  referenceId: Scalars['String'];
  sourceId: Scalars['String'];
};

export type CreatePaymentResponse = MutationResult & {
  __typename?: 'CreatePaymentResponse';
  errors?: Maybe<Array<MutationError>>;
  squareId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreateSquareCardInput = {
  card: SquareCardInput;
  sourceId: Scalars['String'];
  verificationToken?: InputMaybe<Scalars['String']>;
};

export type CreateSquareCardResponse = MutationResult & {
  __typename?: 'CreateSquareCardResponse';
  errors?: Maybe<Array<MutationError>>;
  squareId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreateSquareCustomerResponse = MutationResult & {
  __typename?: 'CreateSquareCustomerResponse';
  errors?: Maybe<Array<MutationError>>;
  squareId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CreateTripCompanyInput = {
  name: Scalars['String'];
};

export type CreateTripContactInput = {
  clientId?: InputMaybe<Scalars['UUID']>;
  clientNote?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notificationSubscriptions?: InputMaybe<Array<CreateTripNotificationSubscription>>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type CreateTripNotificationSubscription = {
  channels: Array<MessageChannel>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationTypeId: Scalars['UUID'];
  tripContactId?: InputMaybe<Scalars['UUID']>;
};

export enum CreditCardProcessor {
  Square = 'Square',
  Stripe = 'Stripe'
}

export enum CurrencyCode {
  Cad = 'CAD',
  Eur = 'EUR',
  Usd = 'USD'
}

export type Customer = {
  __typename?: 'Customer';
  account: Account;
  accountId: Scalars['UUID'];
  contacts: Array<CustomerContact>;
  createdAt: Scalars['TimestampWithTimezone'];
  customerRateSets: Array<CustomerRateSet>;
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  discount?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  stripeCustomerId?: Maybe<Scalars['String']>;
  trips: Array<Trip>;
  type: CustomerType;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type CustomerCollectionResult = {
  __typename?: 'CustomerCollectionResult';
  items: Array<Customer>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type CustomerContact = {
  __typename?: 'CustomerContact';
  contact: Contact;
  contactId: Scalars['UUID'];
  createdAt: Scalars['TimestampWithTimezone'];
  customer: Customer;
  customerId: Scalars['UUID'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  note?: Maybe<Scalars['String']>;
  primaryRole: CustomerRole;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type CustomerContactCollectionResult = {
  __typename?: 'CustomerContactCollectionResult';
  items: Array<CustomerContact>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type CustomerContactInput = {
  email: Scalars['String'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CustomerContactQueries = {
  __typename?: 'CustomerContactQueries';
  all: CustomerContactCollectionResult;
  byContactId: Array<Maybe<CustomerContact>>;
  byId?: Maybe<CustomerContact>;
  search: CustomerContactCollectionResult;
  searchByAccountId: CustomerContactCollectionResult;
  searchByContactEmailAndAccountId: CustomerContactCollectionResult;
  searchByContactName: CustomerContactCollectionResult;
  searchByContactNameAndAccountId: CustomerContactCollectionResult;
  searchByIndex: CustomerContactSearchResult;
};


export type CustomerContactQueriesAllArgs = {
  customerId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type CustomerContactQueriesByContactIdArgs = {
  contactId: Scalars['UUID'];
};


export type CustomerContactQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type CustomerContactQueriesSearchArgs = {
  accountId: Scalars['UUID'];
  contactId?: InputMaybe<Scalars['UUID']>;
  customerId?: InputMaybe<Scalars['UUID']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderByDirection>;
  primaryRole?: InputMaybe<CustomerRole>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type CustomerContactQueriesSearchByAccountIdArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type CustomerContactQueriesSearchByContactEmailAndAccountIdArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type CustomerContactQueriesSearchByContactNameArgs = {
  customerId?: InputMaybe<Scalars['UUID']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
};


export type CustomerContactQueriesSearchByContactNameAndAccountIdArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type CustomerContactQueriesSearchByIndexArgs = {
  accountId: Scalars['UUID'];
  filter?: InputMaybe<Scalars['String']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderByDirection>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type CustomerContactSearchResult = {
  __typename?: 'CustomerContactSearchResult';
  customerContacts?: Maybe<CustomerContactCollectionResult>;
  customers?: Maybe<CustomerCollectionResult>;
};

export type CustomerQueries = {
  __typename?: 'CustomerQueries';
  all: CustomerCollectionResult;
  byId?: Maybe<Customer>;
  search: CustomerCollectionResult;
  searchByName: CustomerCollectionResult;
};


export type CustomerQueriesAllArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type CustomerQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type CustomerQueriesSearchArgs = {
  accountId: Scalars['UUID'];
  customerId?: InputMaybe<Scalars['UUID']>;
  customerType?: InputMaybe<CustomerType>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderByDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type CustomerQueriesSearchByNameArgs = {
  accountId?: InputMaybe<Scalars['UUID']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
};

export type CustomerRateSet = {
  __typename?: 'CustomerRateSet';
  createdAt: Scalars['TimestampWithTimezone'];
  customer: Customer;
  customerId: Scalars['UUID'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['UUID'];
  rateSet: RateSet;
  rateSetId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type CustomerRateSetCollectionResult = {
  __typename?: 'CustomerRateSetCollectionResult';
  items: Array<CustomerRateSet>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type CustomerRateSetQueries = {
  __typename?: 'CustomerRateSetQueries';
  byId?: Maybe<CustomerRateSet>;
};


export type CustomerRateSetQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export enum CustomerRole {
  Billing = 'Billing',
  Booker = 'Booker',
  Observer = 'Observer',
  Passenger = 'Passenger'
}

export enum CustomerType {
  Affiliate = 'Affiliate',
  Individual = 'Individual',
  Organization = 'Organization',
  Reseller = 'Reseller'
}

export type DeclineNetworkConfirmationRequest = {
  note?: InputMaybe<Scalars['String']>;
  tripId: Scalars['UUID'];
  vendorExternalId?: InputMaybe<Scalars['UUID']>;
};

export type DeclineNetworkOffer = {
  note?: InputMaybe<Scalars['String']>;
  tripId: Scalars['UUID'];
};

export type DeleteAccount = {
  id: Scalars['UUID'];
};

export type DeleteAccountAdjustment = {
  id: Scalars['UUID'];
};

export type DeleteAccountAdjustmentResult = MutationResult & {
  __typename?: 'DeleteAccountAdjustmentResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteAccountDefaultNotifications = {
  id: Scalars['UUID'];
};

export type DeleteAccountDefaultNotificationsResult = MutationResult & {
  __typename?: 'DeleteAccountDefaultNotificationsResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteAccountResult = {
  __typename?: 'DeleteAccountResult';
  success: Scalars['Boolean'];
};

export type DeleteAirline = {
  id: Scalars['UUID'];
};

export type DeleteAirlineResult = MutationResult & {
  __typename?: 'DeleteAirlineResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteBooking = {
  id: Scalars['UUID'];
};

export type DeleteBookingResult = MutationResult & {
  __typename?: 'DeleteBookingResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteContact = {
  id: Scalars['UUID'];
};

export type DeleteContactResult = MutationResult & {
  __typename?: 'DeleteContactResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteCustomer = {
  id: Scalars['UUID'];
};

export type DeleteCustomerContact = {
  id: Scalars['UUID'];
};

export type DeleteCustomerContactResult = MutationResult & {
  __typename?: 'DeleteCustomerContactResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteCustomerRateSet = {
  id: Scalars['UUID'];
};

export type DeleteCustomerRateSetResult = MutationResult & {
  __typename?: 'DeleteCustomerRateSetResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteCustomerResult = MutationResult & {
  __typename?: 'DeleteCustomerResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteDriver = {
  id: Scalars['UUID'];
};

export type DeleteDriverResult = MutationResult & {
  __typename?: 'DeleteDriverResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteFavoriteDriver = {
  id: Scalars['UUID'];
};

export type DeleteFavoriteDriverAccount = {
  accountId?: InputMaybe<Scalars['UUID']>;
  accountOwnerId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
};

export type DeleteFavoriteDriverResult = MutationResult & {
  __typename?: 'DeleteFavoriteDriverResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteFbo = {
  id: Scalars['UUID'];
};

export type DeleteFboResult = MutationResult & {
  __typename?: 'DeleteFboResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteFileResult = MutationResult & {
  __typename?: 'DeleteFileResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteGarage = {
  id: Scalars['UUID'];
};

export type DeleteGarageResult = MutationResult & {
  __typename?: 'DeleteGarageResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteInvoice = {
  id: Scalars['UUID'];
};

export type DeleteInvoiceResult = MutationResult & {
  __typename?: 'DeleteInvoiceResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteLocation = {
  id: Scalars['UUID'];
};

export type DeleteLocationResult = MutationResult & {
  __typename?: 'DeleteLocationResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteMarket = {
  id: Scalars['UUID'];
};

export type DeleteMarketResult = MutationResult & {
  __typename?: 'DeleteMarketResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteNetworkInvitation = {
  id: Scalars['UUID'];
};

export type DeleteNetworkInvitationResult = MutationResult & {
  __typename?: 'DeleteNetworkInvitationResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteNetworkRelationship = {
  id: Scalars['UUID'];
};

export type DeleteNetworkRelationshipResult = MutationResult & {
  __typename?: 'DeleteNetworkRelationshipResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeletePaymentMethod = {
  id: Scalars['UUID'];
};

export type DeletePaymentMethodResult = MutationResult & {
  __typename?: 'DeletePaymentMethodResult';
  deletedMethodId?: Maybe<Scalars['UUID']>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteRate = {
  id: Scalars['UUID'];
};

export type DeleteRatePolicy = {
  id: Scalars['UUID'];
};

export type DeleteRatePolicyResult = MutationResult & {
  __typename?: 'DeleteRatePolicyResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteRateResult = MutationResult & {
  __typename?: 'DeleteRateResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteRateSet = {
  id: Scalars['UUID'];
};

export type DeleteRateSetResult = MutationResult & {
  __typename?: 'DeleteRateSetResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteRateType = {
  id: Scalars['UUID'];
};

export type DeleteRateTypeResult = MutationResult & {
  __typename?: 'DeleteRateTypeResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteSharedTrip = {
  id: Scalars['UUID'];
};

export type DeleteSharedTripResult = MutationResult & {
  __typename?: 'DeleteSharedTripResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteSystemVehicleClass = {
  id: Scalars['String'];
};

export type DeleteSystemVehicleClassResult = MutationResult & {
  __typename?: 'DeleteSystemVehicleClassResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteTodo = {
  id: Scalars['UUID'];
};

export type DeleteTodoResult = MutationResult & {
  __typename?: 'DeleteTodoResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteTodoSpec = {
  id: Scalars['UUID'];
};

export type DeleteTodoSpecResult = MutationResult & {
  __typename?: 'DeleteTodoSpecResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteTrip = {
  id: Scalars['UUID'];
};

export type DeleteTripAddon = {
  id: Scalars['UUID'];
};

export type DeleteTripAddonResult = MutationResult & {
  __typename?: 'DeleteTripAddonResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteTripContact = {
  id: Scalars['UUID'];
};

export type DeleteTripContactResult = MutationResult & {
  __typename?: 'DeleteTripContactResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteTripNote = {
  id: Scalars['UUID'];
};

export type DeleteTripNoteResult = MutationResult & {
  __typename?: 'DeleteTripNoteResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteTripNotificationAttempt = {
  id: Scalars['UUID'];
};

export type DeleteTripNotificationAttemptResult = MutationResult & {
  __typename?: 'DeleteTripNotificationAttemptResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteTripNotificationSubscription = {
  id: Scalars['UUID'];
};

export type DeleteTripNotificationSubscriptionResult = MutationResult & {
  __typename?: 'DeleteTripNotificationSubscriptionResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteTripNotificationType = {
  id: Scalars['UUID'];
};

export type DeleteTripNotificationTypeResult = MutationResult & {
  __typename?: 'DeleteTripNotificationTypeResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteTripResult = MutationResult & {
  __typename?: 'DeleteTripResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteTripRule = {
  id: Scalars['UUID'];
};

export type DeleteTripRuleResult = MutationResult & {
  __typename?: 'DeleteTripRuleResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteUserIdentity = {
  id: Scalars['String'];
};

export type DeleteUserIdentityResult = {
  __typename?: 'DeleteUserIdentityResult';
  success: Scalars['Boolean'];
};

export type DeleteVehicle = {
  id: Scalars['UUID'];
};

export type DeleteVehicleClass = {
  id: Scalars['UUID'];
};

export type DeleteVehicleClassOverride = {
  id: Scalars['UUID'];
};

export type DeleteVehicleClassOverrideResult = MutationResult & {
  __typename?: 'DeleteVehicleClassOverrideResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteVehicleClassResult = MutationResult & {
  __typename?: 'DeleteVehicleClassResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteVehicleMake = {
  id: Scalars['String'];
};

export type DeleteVehicleMakeResult = MutationResult & {
  __typename?: 'DeleteVehicleMakeResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteVehicleModel = {
  id: Scalars['UUID'];
};

export type DeleteVehicleModelResult = MutationResult & {
  __typename?: 'DeleteVehicleModelResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteVehicleResult = MutationResult & {
  __typename?: 'DeleteVehicleResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeleteVehicleSensorReading = {
  id: Scalars['UUID'];
};

export type DeleteVehicleSensorReadingResult = MutationResult & {
  __typename?: 'DeleteVehicleSensorReadingResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type DeletedResult = {
  __typename?: 'DeletedResult';
  deleted: Scalars['Boolean'];
};

export enum DeliveryResult {
  Failed = 'Failed',
  Pending = 'Pending',
  Succeeded = 'Succeeded'
}

export type DepartPickup = {
  location?: InputMaybe<TripCommandLocation>;
  tripId: Scalars['UUID'];
};

export type DepartStop = {
  location?: InputMaybe<TripCommandLocation>;
  tripId: Scalars['UUID'];
};

export type DisconnectUserResponse = MutationResult & {
  __typename?: 'DisconnectUserResponse';
  chargesEnabled?: Maybe<Scalars['Boolean']>;
  detailsSubmitted?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<MutationError>>;
  onboardingStarted?: Maybe<Scalars['Boolean']>;
  pendingVerification?: Maybe<Scalars['Boolean']>;
  success: Scalars['Boolean'];
};

export type DistancesAndTime = {
  distance?: InputMaybe<Scalars['Float']>;
  duration?: InputMaybe<Scalars['Float']>;
};

export type Driver = AccountEntity & {
  __typename?: 'Driver';
  account: Account;
  accountId: Scalars['UUID'];
  contact: Contact;
  contactId: Scalars['UUID'];
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  drivingSince?: Maybe<Scalars['DateTime']>;
  externalId?: Maybe<Scalars['UUID']>;
  garage?: Maybe<Garage>;
  garageId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  marketingDescription?: Maybe<Scalars['String']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  trips: Array<Trip>;
  updatedAt: Scalars['TimestampWithTimezone'];
  vehicleSensorReadings: Array<VehicleSensorReading>;
  version: Scalars['Int'];
  videoUrl?: Maybe<Scalars['String']>;
};

export enum DriverAvailability {
  Available = 'Available',
  Committed = 'Committed',
  OffDuty = 'OffDuty'
}

export type DriverAvailabilitySummary = {
  __typename?: 'DriverAvailabilitySummary';
  availability: DriverAvailability;
  driver: AvailableDriver;
  next?: Maybe<UnavailablePeriod>;
  overlapping: Array<UnavailablePeriod>;
  previous?: Maybe<UnavailablePeriod>;
};

export type DriverCollectionResult = {
  __typename?: 'DriverCollectionResult';
  items: Array<Driver>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type DriverCreateArgs = {
  bio?: InputMaybe<Scalars['String']>;
  capitalDriveProvider?: InputMaybe<DriverProviderInputArgs>;
  email?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileImageFilename?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  savoyaProvider?: InputMaybe<DriverProviderInputArgs>;
  skipCoreReplication?: InputMaybe<Scalars['Boolean']>;
  skipUserIdentityCreation?: InputMaybe<Scalars['Boolean']>;
  vendorId: Scalars['UUID'];
};

export type DriverDeleteFileArgs = {
  key: Scalars['String'];
};

export type DriverFilesUploadArgs = {
  driverId: Scalars['UUID'];
  files: Array<FileUploadArgs>;
};

export type DriverProviderInputArgs = {
  agentProfileFilename?: InputMaybe<Scalars['String']>;
  agentProfileUrl?: InputMaybe<Scalars['String']>;
  approved?: InputMaybe<Scalars['Boolean']>;
  backgroundCheckDate?: InputMaybe<Scalars['DateTime']>;
  drugTestDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['UUID']>;
  profileImageVerified?: InputMaybe<Scalars['Boolean']>;
  providerType: ProviderType;
  rejectionReason?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DriverStatus>;
};

export type DriverProviderRecord = {
  __typename?: 'DriverProviderRecord';
  agentProfileFileUpdatedAt?: Maybe<Scalars['DateTime']>;
  agentProfileSignedUrl?: Maybe<Scalars['String']>;
  agentProfileUrl?: Maybe<Scalars['String']>;
  approved?: Maybe<Scalars['Boolean']>;
  backgroundCheckDate?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deleted?: Maybe<Scalars['DateTime']>;
  driverId: Scalars['UUID'];
  drugTestDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  profileImageVerified?: Maybe<Scalars['Boolean']>;
  providerType: ProviderType;
  rejectionReason?: Maybe<Scalars['String']>;
  status: DriverStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type DriverQueries = {
  __typename?: 'DriverQueries';
  all: DriverCollectionResult;
  available: Array<DriverAvailabilitySummary>;
  byId?: Maybe<Driver>;
  byIds?: Maybe<Array<Maybe<Driver>>>;
};


export type DriverQueriesAllArgs = {
  accountId: Scalars['UUID'];
  driverId?: InputMaybe<Scalars['UUID']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderByDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userRole?: InputMaybe<UserRole>;
};


export type DriverQueriesAvailableArgs = {
  criteria: AvailabilityQueryCriteria;
};


export type DriverQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type DriverQueriesByIdsArgs = {
  ids: Array<Scalars['String']>;
};

export type DriverRecord = {
  __typename?: 'DriverRecord';
  bio?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deleted?: Maybe<Scalars['DateTime']>;
  driverProviders?: Maybe<Array<DriverProviderRecord>>;
  drivingSince?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive?: Maybe<Scalars['Boolean']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profileImageSignedUrl?: Maybe<Scalars['String']>;
  profileImageUpdatedAt?: Maybe<Scalars['DateTime']>;
  profileImageUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['UUID']>;
  vendor?: Maybe<VendorRecord>;
  vendorId: Scalars['UUID'];
};

export enum DriverStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  SavoyaDeleted = 'SAVOYA_DELETED'
}

export type DriverSummary = {
  __typename?: 'DriverSummary';
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
};

export type DriverUpdateArgs = {
  bio?: InputMaybe<Scalars['String']>;
  capitalDriveProvider?: InputMaybe<DriverProviderInputArgs>;
  drivingSince?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileImageFilename?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  savoyaProvider?: InputMaybe<DriverProviderInputArgs>;
  skipCoreReplication?: InputMaybe<Scalars['Boolean']>;
  vendorId: Scalars['UUID'];
};

export type DriversQueries = {
  __typename?: 'DriversQueries';
  driverFiles?: Maybe<FilesResponse>;
  getDriverById?: Maybe<DriverRecord>;
  getDriverByName?: Maybe<DriverRecord>;
  getDriverByToken?: Maybe<DriverRecord>;
  getDriversByIds?: Maybe<Array<DriverRecord>>;
  getDriversByProviderType?: Maybe<Array<DriverRecord>>;
  getDriversByVendorId?: Maybe<Array<DriverRecord>>;
  searchDrivers?: Maybe<Array<DriverRecord>>;
};


export type DriversQueriesDriverFilesArgs = {
  id: Scalars['UUID'];
};


export type DriversQueriesGetDriverByIdArgs = {
  id: Scalars['UUID'];
};


export type DriversQueriesGetDriverByNameArgs = {
  fullname: Scalars['String'];
};


export type DriversQueriesGetDriversByIdsArgs = {
  ids: Array<Scalars['UUID']>;
};


export type DriversQueriesGetDriversByProviderTypeArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  includeInactive?: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderByDirection>;
  providerType?: InputMaybe<ProviderType>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<DriverStatus>;
  take?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['UUID']>;
};


export type DriversQueriesGetDriversByVendorIdArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  includeInactive?: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderByDirection>;
  providerType?: InputMaybe<ProviderType>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<DriverStatus>;
  take?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['UUID']>;
};


export type DriversQueriesSearchDriversArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  includeInactive?: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderByDirection>;
  providerType?: InputMaybe<ProviderType>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<DriverStatus>;
  take?: InputMaybe<Scalars['Int']>;
  vendorId?: InputMaybe<Scalars['UUID']>;
};

export enum EmailTypeEnum {
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Work = 'WORK'
}

export type EnRouteToPickup = {
  location?: InputMaybe<TripCommandLocation>;
  tripId: Scalars['UUID'];
};

export type EntityOptions = {
  /** Overides the name used by the ORM instead of the type name. */
  name?: InputMaybe<Scalars['String']>;
  /** The pluralized name of the entity */
  pluralName?: InputMaybe<Scalars['String']>;
};

export type ExpireQuote = {
  tripId: Scalars['UUID'];
};

export type ExportAnalyticsCsvResult = MutationResult & {
  __typename?: 'ExportAnalyticsCSVResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
};

export type FavoriteDriver = {
  __typename?: 'FavoriteDriver';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['UUID']>;
  accountOwner?: Maybe<Contact>;
  accountOwnerId: Scalars['UUID'];
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type FavoriteDriverCollectionResult = {
  __typename?: 'FavoriteDriverCollectionResult';
  items: Array<FavoriteDriver>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type FavoriteDriverQueries = {
  __typename?: 'FavoriteDriverQueries';
  byId?: Maybe<FavoriteDriver>;
  search: FavoriteDriverCollectionResult;
};


export type FavoriteDriverQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type FavoriteDriverQueriesSearchArgs = {
  criteria?: InputMaybe<FavoriteDriverSearchQueryCriteria>;
};

export type FavoriteDriverSearchQueryCriteria = {
  accountId?: InputMaybe<Scalars['UUID']>;
  contactId?: InputMaybe<Scalars['UUID']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderByDirection>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type Fbo = {
  __typename?: 'Fbo';
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  fbo_address?: Maybe<Scalars['String']>;
  fbo_name?: Maybe<Scalars['String']>;
  fbo_postal_code?: Maybe<Scalars['String']>;
  iata_code?: Maybe<Scalars['String']>;
  icao_code?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type FboCollectionResult = {
  __typename?: 'FboCollectionResult';
  items: Array<Fbo>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type FboQueries = {
  __typename?: 'FboQueries';
  all: FboCollectionResult;
  byIataCode?: Maybe<FboCollectionResult>;
  byId?: Maybe<Fbo>;
};


export type FboQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type FboQueriesByIataCodeArgs = {
  iata: Scalars['String'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type FboQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type FeedParams = {
  id: Scalars['UUID'];
};

export type FileData = {
  key: Scalars['String'];
  metadata?: InputMaybe<FileMetadataInput>;
};

export type FileInfo = {
  __typename?: 'FileInfo';
  signedUrls: Array<Maybe<SignedUrl>>;
};

export type FileMetadata = {
  __typename?: 'FileMetadata';
  type?: Maybe<Scalars['String']>;
};

export type FileMetadataInput = {
  type?: InputMaybe<Scalars['String']>;
};

export type FileSignedUrl = {
  __typename?: 'FileSignedUrl';
  filename?: Maybe<Scalars['String']>;
  filetype: FileTypeEnum;
  key?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  signedUrl: Scalars['String'];
};

export enum FileTypeEnum {
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Other = 'OTHER'
}

export type FileUploadArgs = {
  filename: Scalars['String'];
  filetype: FileTypeEnum;
};

export type FilesLocation = {
  bucket: Scalars['String'];
  key: Scalars['String'];
};

export type FilesParams = {
  bucket: Scalars['String'];
  files: Array<FileData>;
};

export type FilesResponse = {
  __typename?: 'FilesResponse';
  documents?: Maybe<Array<SignedUrlResponse>>;
  images?: Maybe<Array<SignedUrlResponse>>;
};

export type FlatRateAppliedEvent = TripEvent & {
  __typename?: 'FlatRateAppliedEvent';
  flatRate?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type FlightChanged = {
  alert: Scalars['JSON'];
  tripId: Scalars['UUID'];
};

export enum FlightType {
  Arrival = 'Arrival',
  Departure = 'Departure'
}

export type ForceTripStatus = {
  newStatus: TripStatus;
  tripId: Scalars['UUID'];
};

export type Garage = AccountEntity & {
  __typename?: 'Garage';
  account: Account;
  accountId: Scalars['UUID'];
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  drivers?: Maybe<Array<Maybe<Driver>>>;
  id: Scalars['UUID'];
  location: Location;
  name: Scalars['String'];
  updatedAt: Scalars['TimestampWithTimezone'];
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
  version: Scalars['Int'];
};

export type GarageCollectionResult = {
  __typename?: 'GarageCollectionResult';
  items: Array<Garage>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type GarageQueries = {
  __typename?: 'GarageQueries';
  all: GarageCollectionResult;
  byId?: Maybe<Garage>;
  current?: Maybe<Garage>;
};


export type GarageQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type GarageQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type GarageQueriesCurrentArgs = {
  accountId: Scalars['UUID'];
  driverId?: InputMaybe<Scalars['UUID']>;
};

export type GarageTimeOverriddenEvent = TripEvent & {
  __typename?: 'GarageTimeOverriddenEvent';
  from?: Maybe<Scalars['Float']>;
  garageTimeType: TripWaypointRole;
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  to: Scalars['Float'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type GenericDriver = {
  __typename?: 'GenericDriver';
  accountId: Scalars['UUID'];
  drivingSince?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  imageUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
};

export type GenericVehicle = {
  __typename?: 'GenericVehicle';
  accountId: Scalars['UUID'];
  color: Scalars['String'];
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  licenseNumber?: Maybe<Scalars['String']>;
  makeName: Scalars['String'];
  middleSeatType?: Maybe<Scalars['String']>;
  modelName: Scalars['String'];
  name: Scalars['String'];
  vehicleClass: GenericVehicleClass;
  vehicleClassId: Scalars['UUID'];
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type GenericVehicleClass = {
  __typename?: 'GenericVehicleClass';
  accountId?: Maybe<Scalars['UUID']>;
  cancellationPolicyHours?: Maybe<Scalars['Int']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  luggageCount?: Maybe<Scalars['Int']>;
  minimumHours?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  passengerCount?: Maybe<Scalars['Int']>;
  systemClassId: Scalars['String'];
};

export type GetSetupClientIdForTripResponse = {
  __typename?: 'GetSetupClientIdForTripResponse';
  clientSecret?: Maybe<Scalars['String']>;
};

export type GetSquareAuthTokenResponse = {
  __typename?: 'GetSquareAuthTokenResponse';
  link: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};

export type GetSquareCardsInput = {
  customerId?: InputMaybe<Scalars['String']>;
  referenceId?: InputMaybe<Scalars['String']>;
};

export type GetStripInvoiceLinksResponse = {
  __typename?: 'GetStripInvoiceLinksResponse';
  invoiceLink?: Maybe<Scalars['String']>;
  invoiceLinkPDF?: Maybe<Scalars['String']>;
};

export type GetstreamQueries = {
  __typename?: 'GetstreamQueries';
  getFeedToken?: Maybe<TokenResult>;
};


export type GetstreamQueriesGetFeedTokenArgs = {
  feed: FeedParams;
};

export type GoogleAddressComponent = {
  __typename?: 'GoogleAddressComponent';
  long_name?: Maybe<Scalars['String']>;
  short_name?: Maybe<Scalars['String']>;
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GoogleGeoLocation = {
  __typename?: 'GoogleGeoLocation';
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
};

export type GoogleGeometry = {
  __typename?: 'GoogleGeometry';
  location?: Maybe<GoogleGeoLocation>;
  viewport?: Maybe<GoogleViewport>;
};

export type GooglePlaceResponse = {
  __typename?: 'GooglePlaceResponse';
  address_components?: Maybe<Array<Maybe<GoogleAddressComponent>>>;
  formatted_address?: Maybe<Scalars['String']>;
  geometry?: Maybe<GoogleGeometry>;
  name?: Maybe<Scalars['String']>;
  place_id?: Maybe<Scalars['String']>;
  types?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type GoogleViewport = {
  __typename?: 'GoogleViewport';
  east?: Maybe<Scalars['Float']>;
  north?: Maybe<Scalars['Float']>;
  south?: Maybe<Scalars['Float']>;
  west?: Maybe<Scalars['Float']>;
};

export enum IdentityProvider {
  Auth0 = 'AUTH0'
}

export type ImportClientsResult = {
  __typename?: 'ImportClientsResult';
  errors?: Maybe<Array<ClientMutationError>>;
  importDuplicates?: Maybe<Scalars['Float']>;
  importErrors?: Maybe<Scalars['Float']>;
  success: Scalars['Boolean'];
  totalImported: Scalars['Float'];
};

export type ImportContactsInput = {
  data: Array<Scalars['JSON']>;
  source: ImportCustomerSource;
};

export type ImportContactsResult = MutationResult & {
  __typename?: 'ImportContactsResult';
  errors?: Maybe<Array<MutationError>>;
  importDuplicates?: Maybe<Scalars['Int']>;
  importErrors?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
  totalImported: Scalars['Int'];
};

export enum ImportCustomerSource {
  LimoAnywhere = 'LimoAnywhere'
}

export type InactivateVehicleClassResult = MutationResult & {
  __typename?: 'InactivateVehicleClassResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicleClass?: Maybe<VehicleClass>;
};

export type InactivateVehicleResult = MutationResult & {
  __typename?: 'InactivateVehicleResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicle?: Maybe<Vehicle>;
};

export type IndependentOperatorOnboardingTemplate = {
  businessLocation: AddressInput;
  businessName: Scalars['String'];
  businessPhoneNumber: Scalars['String'];
  cancellationWindow: Scalars['Float'];
  color: VehicleColor;
  contactId: Scalars['UUID'];
  fullName: Scalars['String'];
  hourlyMinimum: Scalars['Int'];
  hourlyRate: Scalars['Float'];
  licenseNumber: Scalars['String'];
  marketId: Scalars['UUID'];
  middleSeatType: VehicleMiddleSeatType;
  systemVehicleClassId: Scalars['UUID'];
  vehicleMakeName: Scalars['String'];
  vehicleModelId?: InputMaybe<Scalars['UUID']>;
  vehicleModelName: Scalars['String'];
  vehicleYear: Scalars['Int'];
};

export type InsertAccount = {
  activeCardProcessor?: InputMaybe<CreditCardProcessor>;
  bodilyInjuryPerAccident?: InputMaybe<Scalars['Float']>;
  bodilyInjuryPerPerson?: InputMaybe<Scalars['Float']>;
  bookingToken?: InputMaybe<Scalars['String']>;
  bookingToolEnabled?: InputMaybe<Scalars['Boolean']>;
  childSeat?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  displayRatesInBookingTool?: InputMaybe<Scalars['Boolean']>;
  established?: InputMaybe<Scalars['TimestampWithTimezone']>;
  externalId?: InputMaybe<Scalars['UUID']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  insuranceCombinedSingleLimitPerAccident?: InputMaybe<Scalars['Float']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  isInternal?: InputMaybe<Scalars['Boolean']>;
  legalName?: InputMaybe<Scalars['String']>;
  licensesAndCertifications?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  petPolicy?: InputMaybe<Scalars['String']>;
  primaryEmailAddress?: InputMaybe<Scalars['String']>;
  primaryPhoneNumber?: InputMaybe<Scalars['String']>;
  propertyDamagePerAccident?: InputMaybe<Scalars['Float']>;
  providerAccount?: InputMaybe<ProviderAccountSource>;
  salesPitch?: InputMaybe<Scalars['String']>;
  spokenLanguages: Array<Scalars['String']>;
  squareAccessToken?: InputMaybe<Scalars['String']>;
  squareMerchantId?: InputMaybe<Scalars['String']>;
  squareRefreshToken?: InputMaybe<Scalars['String']>;
  squareTokenExpiresAt?: InputMaybe<Scalars['String']>;
  stripeAccountCanCharge?: InputMaybe<Scalars['Boolean']>;
  stripeAccountId?: InputMaybe<Scalars['String']>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  venmoHandle?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  workersCompensantionLiabilityCoverage?: InputMaybe<Scalars['Boolean']>;
  yearsInBusiness?: InputMaybe<Scalars['Int']>;
  zelleHandle?: InputMaybe<Scalars['String']>;
};

export type InsertAccountAdjustment = {
  accountId: Scalars['UUID'];
  active?: InputMaybe<Scalars['Boolean']>;
  amount: Scalars['Float'];
  calculation?: InputMaybe<AdjustmentCalculation>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  rateTypeId: Scalars['UUID'];
};

export type InsertAccountAdjustmentResult = MutationResult & {
  __typename?: 'InsertAccountAdjustmentResult';
  accountAdjustment?: Maybe<AccountAdjustment>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type InsertAccountDefaultNotifications = {
  accountId: Scalars['UUID'];
  channels: Array<MessageChannel>;
  customerRole: CustomerRole;
  customerType: CustomerType;
  id?: InputMaybe<Scalars['UUID']>;
  tripNotificationTypeId: Scalars['UUID'];
};

export type InsertAccountDefaultNotificationsResult = MutationResult & {
  __typename?: 'InsertAccountDefaultNotificationsResult';
  accountDefaultNotifications?: Maybe<AccountDefaultNotifications>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type InsertAccountResult = MutationResult & {
  __typename?: 'InsertAccountResult';
  account?: Maybe<Account>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type InsertAirline = {
  IATA: Scalars['String'];
  ICAO: Scalars['String'];
  callsign?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  hub?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type InsertAirlineResult = MutationResult & {
  __typename?: 'InsertAirlineResult';
  airline?: Maybe<Airline>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type InsertBooking = {
  accountId: Scalars['UUID'];
  contactId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']>;
  sentAt: Scalars['DateTime'];
  status: BookingStatus;
  token: Scalars['String'];
  tripId?: InputMaybe<Scalars['UUID']>;
};

export type InsertBookingResult = MutationResult & {
  __typename?: 'InsertBookingResult';
  booking?: Maybe<Booking>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type InsertContact = {
  accountId?: InputMaybe<Scalars['UUID']>;
  addresses?: InputMaybe<Array<AddressInput>>;
  analyticsToken?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<LocationCategory>;
  contactType: ContactType;
  email: Scalars['String'];
  firebaseToken?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userRole: UserRole;
};

export type InsertContactResult = MutationResult & {
  __typename?: 'InsertContactResult';
  contact?: Maybe<Contact>;
  errors?: Maybe<Array<MutationError>>;
  existingContact?: Maybe<Contact>;
  success: Scalars['Boolean'];
};

export type InsertCustomer = {
  accountId: Scalars['UUID'];
  customerContacts?: InputMaybe<Array<InputMaybe<InsertCustomerContactWithoutCustomer>>>;
  discount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  type: CustomerType;
};

export type InsertCustomerContact = {
  contact: CustomerContactInput;
  customerId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  primaryRole: CustomerRole;
};

export type InsertCustomerContactResult = MutationResult & {
  __typename?: 'InsertCustomerContactResult';
  customerContact?: Maybe<CustomerContact>;
  errors?: Maybe<Array<MutationError>>;
  existingContact?: Maybe<Contact>;
  success: Scalars['Boolean'];
};

export type InsertCustomerContactWithoutCustomer = {
  contact: CustomerContactInput;
  customerId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  primaryRole: CustomerRole;
};

export type InsertCustomerRateSet = {
  customerId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
  rateSetId: Scalars['UUID'];
};

export type InsertCustomerRateSetResult = MutationResult & {
  __typename?: 'InsertCustomerRateSetResult';
  customerRateSet?: Maybe<CustomerRateSet>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type InsertCustomerResult = MutationResult & {
  __typename?: 'InsertCustomerResult';
  customer?: Maybe<Customer>;
  customerContact?: Maybe<Array<CustomerContact>>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type InsertDriver = {
  accountId: Scalars['UUID'];
  contactId: Scalars['UUID'];
  drivingSince?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<Scalars['UUID']>;
  garageId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive: Scalars['Boolean'];
  marketingDescription?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
};

export type InsertDriverResult = MutationResult & {
  __typename?: 'InsertDriverResult';
  driver?: Maybe<Driver>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type InsertFavoriteDriver = {
  accountId?: InputMaybe<Scalars['UUID']>;
  accountOwnerId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
};

export type InsertFavoriteDriverInput = {
  accountId?: InputMaybe<Scalars['UUID']>;
  accountOwnerId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
};

export type InsertFavoriteDriverResult = MutationResult & {
  __typename?: 'InsertFavoriteDriverResult';
  errors?: Maybe<Array<MutationError>>;
  favoriteDriver?: Maybe<FavoriteDriver>;
  success: Scalars['Boolean'];
};

export type InsertFbo = {
  fbo_address?: InputMaybe<Scalars['String']>;
  fbo_name?: InputMaybe<Scalars['String']>;
  fbo_postal_code?: InputMaybe<Scalars['String']>;
  iata_code?: InputMaybe<Scalars['String']>;
  icao_code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
};

export type InsertFboResult = MutationResult & {
  __typename?: 'InsertFboResult';
  errors?: Maybe<Array<MutationError>>;
  fbo?: Maybe<Fbo>;
  success: Scalars['Boolean'];
};

export type InsertGarage = {
  accountId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};

export type InsertGarageResult = MutationResult & {
  __typename?: 'InsertGarageResult';
  errors?: Maybe<Array<MutationError>>;
  garage?: Maybe<Garage>;
  success: Scalars['Boolean'];
};

export type InsertGarageWithLocation = {
  accountId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
  location: OwnedLocationInput;
  name: Scalars['String'];
};

export type InsertLocation = {
  abbreviation?: InputMaybe<Scalars['String']>;
  accountId?: InputMaybe<Scalars['UUID']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<LocationCategory>;
  city?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['UUID']>;
  coordinates: Scalars['Coordinates'];
  country?: InputMaybe<Scalars['String']>;
  garageId?: InputMaybe<Scalars['UUID']>;
  geoType: AreaType;
  id?: InputMaybe<Scalars['UUID']>;
  marketId?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  placeCategory?: InputMaybe<Scalars['String']>;
  placeFoursquareId?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  placeName?: InputMaybe<Scalars['String']>;
  placeType?: InputMaybe<Scalars['String']>;
  placeWikidataId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  radiusInKm?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  zoneType: ZoneType;
};

export type InsertLocationResult = MutationResult & {
  __typename?: 'InsertLocationResult';
  errors?: Maybe<Array<MutationError>>;
  location?: Maybe<Location>;
  success: Scalars['Boolean'];
};

export type InsertMarket = {
  abbreviation: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};

export type InsertMarketResult = MutationResult & {
  __typename?: 'InsertMarketResult';
  errors?: Maybe<Array<MutationError>>;
  market?: Maybe<Market>;
  success: Scalars['Boolean'];
};

export type InsertMarketWithLocation = {
  abbreviation: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  location: OwnedLocationInput;
  name: Scalars['String'];
};

export type InsertNetworkInvitation = {
  accountId: Scalars['UUID'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  fromContactId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<Scalars['String']>;
  relationshipId?: InputMaybe<Scalars['UUID']>;
  resentAt?: InputMaybe<Scalars['DateTime']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']>;
  sentAt: Scalars['DateTime'];
  status: NetworkInvitationStatus;
  toContactId?: InputMaybe<Scalars['UUID']>;
  toEmail: Scalars['String'];
  toName: Scalars['String'];
  token: Scalars['String'];
};

export type InsertNetworkInvitationResult = MutationResult & {
  __typename?: 'InsertNetworkInvitationResult';
  errors?: Maybe<Array<MutationError>>;
  networkInvitation?: Maybe<NetworkInvitation>;
  success: Scalars['Boolean'];
};

export type InsertNetworkRelationship = {
  accountId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
  invitationId?: InputMaybe<Scalars['UUID']>;
  isReciprocal: Scalars['Boolean'];
  toAccountId: Scalars['UUID'];
};

export type InsertNetworkRelationshipResult = MutationResult & {
  __typename?: 'InsertNetworkRelationshipResult';
  errors?: Maybe<Array<MutationError>>;
  networkRelationship?: Maybe<NetworkRelationship>;
  success: Scalars['Boolean'];
};

export type InsertPaymentMethod = {
  customerContactId?: InputMaybe<Scalars['UUID']>;
  description: Scalars['String'];
  externalPaymentMethodId: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  reusable?: InputMaybe<Scalars['Boolean']>;
  source: CreditCardProcessor;
};

export type InsertPaymentMethodResult = MutationResult & {
  __typename?: 'InsertPaymentMethodResult';
  errors?: Maybe<Array<MutationError>>;
  paymentMethodDescription?: Maybe<Scalars['String']>;
  paymentMethodId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type InsertRate = {
  accountId: Scalars['UUID'];
  amount?: InputMaybe<Scalars['Float']>;
  calculation?: InputMaybe<RateCalculation>;
  defaultRate?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPerVehicle: Scalars['Boolean'];
  meteredBillingStrategy?: InputMaybe<MeteredBillingStrategy>;
  meteredRateIncrement?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  rateSetId: Scalars['UUID'];
  rateTypeId: Scalars['UUID'];
  revertToDynamicForExcessWaitTime?: InputMaybe<Scalars['Boolean']>;
  revertToDynamicForUnquotedStops?: InputMaybe<Scalars['Boolean']>;
  targetRateGroup?: InputMaybe<RateGroup>;
};

export type InsertRatePolicy = {
  feePercentage?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['UUID']>;
  rateId: Scalars['UUID'];
  thresholdValue?: InputMaybe<Scalars['Float']>;
  thresholdValue2?: InputMaybe<Scalars['Float']>;
  type: RatePolicyType;
};

export type InsertRatePolicyResult = MutationResult & {
  __typename?: 'InsertRatePolicyResult';
  errors?: Maybe<Array<MutationError>>;
  ratePolicy?: Maybe<RatePolicy>;
  success: Scalars['Boolean'];
};

export type InsertRateResult = MutationResult & {
  __typename?: 'InsertRateResult';
  errors?: Maybe<Array<MutationError>>;
  rate?: Maybe<Rate>;
  success: Scalars['Boolean'];
};

export type InsertRateSet = {
  accountId: Scalars['UUID'];
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isCustomerRate?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  tripRuleId?: InputMaybe<Scalars['UUID']>;
};

export type InsertRateSetResult = MutationResult & {
  __typename?: 'InsertRateSetResult';
  errors?: Maybe<Array<MutationError>>;
  rateSet?: Maybe<RateSet>;
  success: Scalars['Boolean'];
};

export type InsertRateType = {
  accountId: Scalars['UUID'];
  category: RateCategory;
  description?: InputMaybe<Scalars['String']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
};

export type InsertRateTypeResult = MutationResult & {
  __typename?: 'InsertRateTypeResult';
  errors?: Maybe<Array<MutationError>>;
  rateType?: Maybe<RateType>;
  success: Scalars['Boolean'];
};

export type InsertSharedTrip = {
  amount: Scalars['Float'];
  contactId?: InputMaybe<Scalars['UUID']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['UUID']>;
  message?: InputMaybe<Scalars['String']>;
  networkRelationshipId?: InputMaybe<Scalars['UUID']>;
  paymentMethodId?: InputMaybe<Scalars['UUID']>;
  paymentMethodType: PaymentMethodType;
  resentAt?: InputMaybe<Scalars['DateTime']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']>;
  savoyaAssignmentStatus?: InputMaybe<SavoyaSharedTripStatus>;
  savoyaAvailableTrip?: InputMaybe<Scalars['Boolean']>;
  savoyaQuotedTime?: InputMaybe<Scalars['Float']>;
  sentAt: Scalars['DateTime'];
  status: SharedTripStatus;
  token: Scalars['String'];
  tripId: Scalars['UUID'];
  vendorExternalId?: InputMaybe<Scalars['UUID']>;
};

export type InsertSharedTripResult = MutationResult & {
  __typename?: 'InsertSharedTripResult';
  errors?: Maybe<Array<MutationError>>;
  sharedTrip?: Maybe<SharedTrip>;
  success: Scalars['Boolean'];
};

export type InsertSystemVehicleClass = {
  defaultCostMultiplier: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type InsertSystemVehicleClassResult = MutationResult & {
  __typename?: 'InsertSystemVehicleClassResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  systemVehicleClass?: Maybe<SystemVehicleClass>;
};

export type InsertTodo = {
  accountId: Scalars['UUID'];
  actionUrl?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  effectiveDate: Scalars['DateTime'];
  entityId: Scalars['UUID'];
  entityType: Scalars['String'];
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  infoText?: InputMaybe<Scalars['String']>;
  priority: TodoPriority;
  resolvedAt?: InputMaybe<Scalars['DateTime']>;
  resolvedById?: InputMaybe<Scalars['UUID']>;
  specId?: InputMaybe<Scalars['UUID']>;
  status: TodoStatus;
  title: Scalars['String'];
  type: TodoType;
};

export type InsertTodoResult = MutationResult & {
  __typename?: 'InsertTodoResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  todo?: Maybe<Todo>;
};

export type InsertTodoSpec = {
  accountId?: InputMaybe<Scalars['UUID']>;
  actionUrlTemplate?: InputMaybe<Scalars['String']>;
  activationRule?: InputMaybe<Scalars['String']>;
  activationType: TodoActivationType;
  bodyTemplate?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  dueInDays?: InputMaybe<Scalars['Int']>;
  effectiveInDays?: InputMaybe<Scalars['Int']>;
  entityType: Scalars['String'];
  expiresInDays?: InputMaybe<Scalars['Int']>;
  iconUrlTemplate?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  infoTextTemplate?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  priority: TodoPriority;
  titleTemplate: Scalars['String'];
  type: TodoType;
};

export type InsertTodoSpecResult = MutationResult & {
  __typename?: 'InsertTodoSpecResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  todoSpec?: Maybe<TodoSpec>;
};

export type InsertTransferRate = {
  accountId: Scalars['UUID'];
  amount?: InputMaybe<Scalars['Float']>;
  calculation?: InputMaybe<RateCalculation>;
  description?: InputMaybe<Scalars['String']>;
  isPerVehicle?: InputMaybe<Scalars['Boolean']>;
  meteredBillingStrategy?: InputMaybe<MeteredBillingStrategy>;
  meteredRateIncrement?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  rateSetId: Scalars['UUID'];
  rateTypeId?: InputMaybe<Scalars['UUID']>;
  revertToDynamicForExcessWaitTime?: InputMaybe<Scalars['Boolean']>;
  revertToDynamicForUnquotedStops?: InputMaybe<Scalars['Boolean']>;
  targetRateGroup?: InputMaybe<RateGroup>;
  vehicleClassOverride: Array<VehicleClassOverrideLite>;
};

export type InsertTransferRateSet = {
  accountId: Scalars['UUID'];
  clients?: InputMaybe<Array<Scalars['UUID']>>;
  companies?: InputMaybe<Array<Scalars['UUID']>>;
  customers?: InputMaybe<Array<Scalars['UUID']>>;
  description?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  firstLocation?: InputMaybe<UpsertPlaceInput>;
  firstLocationGeoType?: InputMaybe<AreaType>;
  firstLocationMatchType?: InputMaybe<LocationMatchType>;
  firstLocationRadiusInKm?: InputMaybe<Scalars['Float']>;
  firstLocationZoneType?: InputMaybe<ZoneType>;
  id?: InputMaybe<Scalars['UUID']>;
  maxStops?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  secondLocation?: InputMaybe<UpsertPlaceInput>;
  secondLocationGeoType?: InputMaybe<AreaType>;
  secondLocationMatchType?: InputMaybe<LocationMatchType>;
  secondLocationRadiusInKm?: InputMaybe<Scalars['Float']>;
  secondLocationZoneType?: InputMaybe<ZoneType>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  vehicleClassOverride: Array<VehicleClassOverrideLite>;
};

export type InsertTrip = {
  accountId: Scalars['UUID'];
  bookingContact?: InputMaybe<CreateTripContactInput>;
  bookingToolTrip?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  distancesAndTime?: InputMaybe<Array<DistancesAndTime>>;
  driverId?: InputMaybe<Scalars['UUID']>;
  estimatedDurationInMinutesOverride?: InputMaybe<Scalars['Float']>;
  estimatedSpotTimeInMinutes?: InputMaybe<Scalars['Int']>;
  groundworkTrip?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  isDirected?: InputMaybe<Scalars['Boolean']>;
  luggageCount?: InputMaybe<Scalars['Int']>;
  newCompanyData?: InputMaybe<CreateTripCompanyInput>;
  passengerContact: CreateTripContactInput;
  passengerCount?: InputMaybe<Scalars['Int']>;
  pickupTime?: InputMaybe<Scalars['DateTime']>;
  preferredVehicleClassId?: InputMaybe<Scalars['UUID']>;
  /**
   * The external id of the trip in the provider system
   * It can be a UUID, a string or a number
   */
  providerExternalId?: InputMaybe<Scalars['String']>;
  providerSource?: InputMaybe<TripProviderSource>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TripStatus>;
  submit?: InputMaybe<Scalars['Boolean']>;
  tripNumber?: InputMaybe<Scalars['Int']>;
  vehicleId?: InputMaybe<Scalars['UUID']>;
  wasBookedByPassenger?: InputMaybe<Scalars['Boolean']>;
  waypoints: Array<UpsertTripWaypointInput>;
};

export type InsertTripAddon = {
  calculation?: InputMaybe<AdjustmentCalculation>;
  id?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  quantity: Scalars['Float'];
  rateTypeId: Scalars['UUID'];
  total: Scalars['Float'];
  tripId: Scalars['UUID'];
  unitPrice: Scalars['Float'];
};

export type InsertTripAddonResult = MutationResult & {
  __typename?: 'InsertTripAddonResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripAddon?: Maybe<TripAddon>;
};

export type InsertTripContact = {
  accountId: Scalars['UUID'];
  customerContactId?: InputMaybe<Scalars['UUID']>;
  customerContactNote?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  existingContactId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  notificationSubscriptions?: InputMaybe<Array<CreateTripNotificationSubscription>>;
  overrideCustomerContactInfo?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  role: CustomerRole;
  tripId: Scalars['UUID'];
};

export type InsertTripContactResult = MutationResult & {
  __typename?: 'InsertTripContactResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripContact?: Maybe<TripContact>;
};

export type InsertTripNote = {
  authorId?: InputMaybe<Scalars['UUID']>;
  content: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  time: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
};

export type InsertTripNoteResult = MutationResult & {
  __typename?: 'InsertTripNoteResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripNote?: Maybe<TripNote>;
};

export type InsertTripNotificationAttempt = {
  id?: InputMaybe<Scalars['UUID']>;
  payload?: InputMaybe<Scalars['JSON']>;
  provider: NotificationProvider;
  response?: InputMaybe<Scalars['String']>;
  responseCode?: InputMaybe<Scalars['String']>;
  result: DeliveryResult;
  subscriptionId: Scalars['UUID'];
};

export type InsertTripNotificationAttemptResult = MutationResult & {
  __typename?: 'InsertTripNotificationAttemptResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripNotificationAttempt?: Maybe<TripNotificationAttempt>;
};

export type InsertTripNotificationSubscription = {
  channels: Array<MessageChannel>;
  id?: InputMaybe<Scalars['UUID']>;
  notificationTypeId: Scalars['UUID'];
  tripContactId: Scalars['UUID'];
};

export type InsertTripNotificationSubscriptionResult = MutationResult & {
  __typename?: 'InsertTripNotificationSubscriptionResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripNotificationSubscription?: Maybe<TripNotificationSubscription>;
};

export type InsertTripNotificationType = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  name: Scalars['String'];
  trigger: TripEventType;
};

export type InsertTripNotificationTypeResult = MutationResult & {
  __typename?: 'InsertTripNotificationTypeResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripNotificationType?: Maybe<TripNotificationType>;
};

export type InsertTripResult = MutationResult & {
  __typename?: 'InsertTripResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  trip?: Maybe<Trip>;
};

export type InsertTripRule = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  firstLocationId?: InputMaybe<Scalars['UUID']>;
  firstLocationMatchType?: InputMaybe<LocationMatchType>;
  id?: InputMaybe<Scalars['UUID']>;
  maxStops?: InputMaybe<Scalars['Int']>;
  secondLocationId?: InputMaybe<Scalars['UUID']>;
  secondLocationMatchType?: InputMaybe<LocationMatchType>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type InsertTripRuleResult = MutationResult & {
  __typename?: 'InsertTripRuleResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripRule?: Maybe<TripRule>;
};

export type InsertTripRuleWithLocation = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  firstLocation: UpsertPlaceInput;
  firstLocationGeoType?: InputMaybe<AreaType>;
  firstLocationMatchType: LocationMatchType;
  firstLocationRadiusInKm?: InputMaybe<Scalars['Int']>;
  firstLocationZoneType?: InputMaybe<ZoneType>;
  maxStops?: InputMaybe<Scalars['Int']>;
  secondLocation: UpsertPlaceInput;
  secondLocationGeoType?: InputMaybe<AreaType>;
  secondLocationMatchType: LocationMatchType;
  secondLocationRadiusInKm?: InputMaybe<Scalars['Int']>;
  secondLocationZoneType?: InputMaybe<ZoneType>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type InsertTripWaypointInput = {
  airlineId?: InputMaybe<Scalars['UUID']>;
  flightNumber?: InputMaybe<Scalars['String']>;
  place: UpsertPlaceInput;
  role: TripWaypointRole;
};

export type InsertUser = {
  accountId?: InputMaybe<Scalars['UUID']>;
  addresses?: InputMaybe<Array<AddressInput>>;
  analyticsToken?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<LocationCategory>;
  email?: InputMaybe<Scalars['String']>;
  firebaseToken?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userRole?: InputMaybe<UserRole>;
};

export type InsertUserIdentity = {
  contactId: Scalars['UUID'];
  email?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['String']>;
};

export type InsertUserIdentityResult = {
  __typename?: 'InsertUserIdentityResult';
  userIdentity?: Maybe<UserIdentity>;
};

export type InsertUserResult = MutationResult & {
  __typename?: 'InsertUserResult';
  contact?: Maybe<Contact>;
  errors?: Maybe<Array<MutationError>>;
  existingContact?: Maybe<Contact>;
  signedUrl?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type InsertVehicle = {
  accountId: Scalars['UUID'];
  availability: VehicleAvailability;
  availabilityComments?: InputMaybe<Scalars['String']>;
  availabilityEstEndTime?: InputMaybe<Scalars['TimestampWithTimezone']>;
  availabilityStartTime?: InputMaybe<Scalars['TimestampWithTimezone']>;
  color: Scalars['String'];
  externalId?: InputMaybe<Scalars['UUID']>;
  garageId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive: Scalars['Boolean'];
  licenseNumber?: InputMaybe<Scalars['String']>;
  middleSeatType?: InputMaybe<VehicleMiddleSeatType>;
  modelId: Scalars['UUID'];
  vehicleClassId: Scalars['UUID'];
  vin?: InputMaybe<Scalars['String']>;
  year: Scalars['Int'];
};

export type InsertVehicleClass = {
  accountId: Scalars['UUID'];
  cancellationPolicyHours?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['UUID']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['UUID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  luggageCount: Scalars['Int'];
  minimumHours?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  passengerCount: Scalars['Int'];
  systemClassId: Scalars['String'];
  systemCreated?: InputMaybe<Scalars['Boolean']>;
};

export type InsertVehicleClassOverride = {
  amount: Scalars['Float'];
  id?: InputMaybe<Scalars['UUID']>;
  rateId: Scalars['UUID'];
  vehicleClassId: Scalars['UUID'];
};

export type InsertVehicleClassOverrideResult = MutationResult & {
  __typename?: 'InsertVehicleClassOverrideResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicleClassOverride?: Maybe<VehicleClassOverride>;
};

export type InsertVehicleClassResult = MutationResult & {
  __typename?: 'InsertVehicleClassResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicleClass?: Maybe<VehicleClass>;
};

export type InsertVehicleInput = {
  accountId: Scalars['UUID'];
  availability: VehicleAvailability;
  availabilityComments?: InputMaybe<Scalars['String']>;
  availabilityEstEndTime?: InputMaybe<Scalars['TimestampWithTimezone']>;
  availabilityStartTime?: InputMaybe<Scalars['TimestampWithTimezone']>;
  color: Scalars['String'];
  garageId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  makeName: Scalars['String'];
  middleSeatType?: InputMaybe<VehicleMiddleSeatType>;
  modelId?: InputMaybe<Scalars['UUID']>;
  modelName: Scalars['String'];
  vehicleClassId: Scalars['UUID'];
  vin?: InputMaybe<Scalars['String']>;
  year: Scalars['Int'];
};

export type InsertVehicleMake = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type InsertVehicleMakeResult = MutationResult & {
  __typename?: 'InsertVehicleMakeResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicleMake?: Maybe<VehicleMake>;
};

export type InsertVehicleModel = {
  endYear?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  makeId: Scalars['String'];
  name: Scalars['String'];
  startYear: Scalars['Int'];
};

export type InsertVehicleModelResult = MutationResult & {
  __typename?: 'InsertVehicleModelResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicleModel?: Maybe<VehicleModel>;
};

export type InsertVehicleResult = MutationResult & {
  __typename?: 'InsertVehicleResult';
  errors?: Maybe<Array<MutationError>>;
  signedUrl?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  vehicle?: Maybe<Vehicle>;
};

export type InsertVehicleSensorReading = {
  accountId: Scalars['UUID'];
  coordinates: Scalars['Coordinates'];
  driverId?: InputMaybe<Scalars['UUID']>;
  heading: Scalars['Float'];
  id?: InputMaybe<Scalars['UUID']>;
  sensorTimestamp: Scalars['TimestampWithTimezone'];
  source?: InputMaybe<SensorReadingSource>;
  speed: Scalars['Float'];
  tripId?: InputMaybe<Scalars['UUID']>;
  vehicleId?: InputMaybe<Scalars['UUID']>;
};

export type InsertVehicleSensorReadingResult = MutationResult & {
  __typename?: 'InsertVehicleSensorReadingResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicleSensorReading?: Maybe<VehicleSensorReading>;
};

export type Invoice = {
  __typename?: 'Invoice';
  account: Account;
  accountId: Scalars['UUID'];
  balance?: Maybe<Scalars['Float']>;
  basetotal?: Maybe<Scalars['Float']>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  externalId?: Maybe<Scalars['String']>;
  externalInvoiceLink?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  invoiceNumber?: Maybe<Scalars['Int']>;
  invoiceProcessor?: Maybe<CreditCardProcessor>;
  lineItems: Array<LineItem>;
  payments?: Maybe<Scalars['Float']>;
  status: InvoiceStatus;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  transactions: Array<Transaction>;
  trip: Trip;
  tripId: Scalars['UUID'];
  type: InvoiceType;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type InvoiceCollectionResult = {
  __typename?: 'InvoiceCollectionResult';
  items: Array<Invoice>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type InvoiceDeliveryRequested = {
  invoiceType?: InputMaybe<InvoiceType>;
  toEmailAddress: Scalars['String'];
  tripId: Scalars['UUID'];
};

export type InvoiceDeliveryRequestedEvent = TripEvent & {
  __typename?: 'InvoiceDeliveryRequestedEvent';
  id: Scalars['UUID'];
  invoiceId: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  toEmailAddress: Scalars['String'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type InvoicePaid = {
  tripId: Scalars['UUID'];
};

export type InvoiceQueries = {
  __typename?: 'InvoiceQueries';
  all: InvoiceCollectionResult;
  byId?: Maybe<Invoice>;
  getEstimatedSummary: InvoiceSummary;
  getPDF: Scalars['String'];
  getSummary: InvoiceSummary;
  getSummaryByTripId: InvoiceSummary;
};


export type InvoiceQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type InvoiceQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type InvoiceQueriesGetEstimatedSummaryArgs = {
  tripId: Scalars['UUID'];
  vehicleClassId?: InputMaybe<Scalars['UUID']>;
};


export type InvoiceQueriesGetPdfArgs = {
  id: Scalars['UUID'];
  timeZone?: InputMaybe<Scalars['String']>;
};


export type InvoiceQueriesGetSummaryArgs = {
  id: Scalars['UUID'];
};


export type InvoiceQueriesGetSummaryByTripIdArgs = {
  tripId: Scalars['UUID'];
};

export enum InvoiceStatus {
  Abandoned = 'Abandoned',
  Created = 'Created',
  Paid = 'Paid',
  PartiallyPaid = 'PartiallyPaid',
  Sent = 'Sent'
}

export type InvoiceSubmitted = {
  sendToBooker?: InputMaybe<Scalars['Boolean']>;
  tripId: Scalars['UUID'];
};

export type InvoiceSummary = {
  __typename?: 'InvoiceSummary';
  balance?: Maybe<Scalars['Float']>;
  baseQuantity: Scalars['Float'];
  baseTotal: Scalars['Float'];
  baseUnitPrice: Scalars['Float'];
  calculation: RateCalculation;
  dropoffGarageTime?: Maybe<Scalars['Float']>;
  dropoffTime?: Maybe<InvoiceTime>;
  id: Scalars['UUID'];
  otherItems: Array<OtherItemSummary>;
  payments?: Maybe<Scalars['Float']>;
  pickupGarageTime?: Maybe<Scalars['Float']>;
  pickupTime?: Maybe<InvoiceTime>;
  rateId?: Maybe<Scalars['UUID']>;
  total: Scalars['Float'];
  transactions: Array<TransactionItemSummary>;
  tripCompletedTime?: Maybe<InvoiceTime>;
  tripStartedTime?: Maybe<InvoiceTime>;
  type?: Maybe<InvoiceType>;
  waitQuantity?: Maybe<Scalars['Float']>;
  waitTotal?: Maybe<Scalars['Float']>;
  waitUnitPrice?: Maybe<Scalars['Float']>;
};

export type InvoiceTime = {
  __typename?: 'InvoiceTime';
  billedTime?: Maybe<Scalars['DateTime']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
};

export enum InvoiceType {
  Payable = 'Payable',
  Quote = 'Quote'
}

export type InvoiceUpdatedEvent = TripEvent & {
  __typename?: 'InvoiceUpdatedEvent';
  id: Scalars['UUID'];
  invoiceId: Scalars['UUID'];
  invoiceType: InvoiceType;
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId: Scalars['UUID'];
};

export type LineItem = {
  __typename?: 'LineItem';
  addon?: Maybe<TripAddon>;
  addonId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  invoice: Invoice;
  invoiceId: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  rate?: Maybe<Rate>;
  rateGroup: RateGroup;
  rateId?: Maybe<Scalars['UUID']>;
  ratePolicy?: Maybe<RatePolicy>;
  ratePolicyId?: Maybe<Scalars['UUID']>;
  rateType: RateType;
  rateTypeId: Scalars['UUID'];
  total: Scalars['Float'];
  tripLeg?: Maybe<TripWaypointRole>;
  type: LineItemType;
  unitPrice: Scalars['Float'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type LineItemCollectionResult = {
  __typename?: 'LineItemCollectionResult';
  items: Array<LineItem>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type LineItemQueries = {
  __typename?: 'LineItemQueries';
  all: LineItemCollectionResult;
  byId?: Maybe<LineItem>;
};


export type LineItemQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type LineItemQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export enum LineItemType {
  Charge = 'Charge',
  Credit = 'Credit'
}

export type LinkUserIdentityResult = {
  __typename?: 'LinkUserIdentityResult';
  userIdentity?: Maybe<UserIdentity>;
};

export type Location = {
  __typename?: 'Location';
  abbreviation?: Maybe<Scalars['String']>;
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['UUID']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  category?: Maybe<LocationCategory>;
  city?: Maybe<Scalars['String']>;
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['UUID']>;
  coordinates: Scalars['Coordinates'];
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  garage?: Maybe<Garage>;
  garageId?: Maybe<Scalars['UUID']>;
  geoType: AreaType;
  id: Scalars['UUID'];
  market?: Maybe<Market>;
  marketId?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  placeCategory?: Maybe<Scalars['String']>;
  placeFoursquareId?: Maybe<Scalars['String']>;
  /** Place Data - should come from geoprovider */
  placeId?: Maybe<Scalars['String']>;
  placeName?: Maybe<Scalars['String']>;
  placeType?: Maybe<Scalars['String']>;
  placeWikidataId?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  radiusInKm?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
  waypoints: Array<TripWaypoint>;
  zoneType: ZoneType;
};

export enum LocationCategory {
  Address = 'Address',
  Airport = 'Airport',
  HomeAddress = 'Home_Address',
  Other = 'Other',
  Seaport = 'Seaport',
  WorkAddress = 'Work_Address'
}

export type LocationCollectionResult = {
  __typename?: 'LocationCollectionResult';
  items: Array<Location>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export enum LocationMatchType {
  From = 'From',
  FromOrTo = 'FromOrTo',
  To = 'To'
}

export type LocationQueries = {
  __typename?: 'LocationQueries';
  all: LocationCollectionResult;
  byId?: Maybe<Location>;
  getPlaceInfo: GooglePlaceResponse;
  getPredictions: Array<PlacePrediction>;
  timeZones?: Maybe<TimeZonesResult>;
};


export type LocationQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type LocationQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type LocationQueriesGetPlaceInfoArgs = {
  placeId: Scalars['String'];
};


export type LocationQueriesGetPredictionsArgs = {
  predictionInput: PredictionInput;
};


export type LocationQueriesTimeZonesArgs = {
  timeZoneInput: MapTimeZoneInput;
};

export type MapTimeZoneInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type Market = {
  __typename?: 'Market';
  abbreviation: Scalars['String'];
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['UUID'];
  location: Location;
  name: Scalars['String'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type MarketCollectionResult = {
  __typename?: 'MarketCollectionResult';
  items: Array<Market>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type MarketQueries = {
  __typename?: 'MarketQueries';
  all: MarketCollectionResult;
  byId?: Maybe<Market>;
};


export type MarketQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type MarketQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type MediaQueries = {
  __typename?: 'MediaQueries';
  filesFromPath?: Maybe<FileInfo>;
  signedUrl: Array<Maybe<SignedUrl>>;
};


export type MediaQueriesFilesFromPathArgs = {
  fileInfo: FilesLocation;
};


export type MediaQueriesSignedUrlArgs = {
  fileInfo: FilesParams;
};

export enum MessageChannel {
  Email = 'Email',
  PushNotification = 'PushNotification',
  Sms = 'Sms'
}

export enum MeteredBillingStrategy {
  AsQuoted = 'AsQuoted',
  Dynamic = 'Dynamic'
}

export type MonitoringSummary = {
  __typename?: 'MonitoringSummary';
  accountName?: Maybe<Scalars['String']>;
  destination?: Maybe<TripWaypoint>;
  driver?: Maybe<DriverSummary>;
  position?: Maybe<VehicleSensorReading>;
  stagingNotes?: Maybe<Scalars['String']>;
  status?: Maybe<TripStatus>;
  vehicle?: Maybe<VehicleSummary>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _default?: Maybe<Scalars['String']>;
  acceptNetworkInvitation?: Maybe<NetworkInvitationResult>;
  bulkInsertClients: Scalars['Float'];
  bulkInsertCompanies: Scalars['Float'];
  bulkInsertTripClient: Scalars['Float'];
  bulkUpsertClientPaymentProcessor: Scalars['Float'];
  cancelSubscription: SubscriptionRecord;
  createAccountFromTemplate?: Maybe<AccountTemplateResult>;
  createDriverFilesUploadSignedUrls: Array<FileSignedUrl>;
  createDriverRecord: DriverRecord;
  createOrUpdateInvoiceSummaryForTrip: InvoiceSummary;
  createOrUpdateSubscription: SubscriptionRecord;
  createOrUpdateUserRecord: UserRecord;
  createOrUpdateVehicleClass: VehicleClassRecord;
  createSharedTrip?: Maybe<SharedTripResult>;
  createSquareCard?: Maybe<CreateSquareCardResponse>;
  createSquareCustomer?: Maybe<CreateSquareCustomerResponse>;
  createSquarePayment?: Maybe<CreatePaymentResponse>;
  createUserAuthIdentity: UserRecord;
  createVehicleFilesUploadSignedUrls: Array<FileSignedUrl>;
  createVehicleRecord: VehicleRecord;
  createVendor: VendorRecord;
  declineNetworkInvitation?: Maybe<NetworkInvitationResult>;
  deleteAccount?: Maybe<DeleteAccountResult>;
  deleteAccountAdjustment?: Maybe<DeleteAccountAdjustmentResult>;
  deleteAccountDefaultNotifications?: Maybe<DeleteAccountDefaultNotificationsResult>;
  deleteAirline?: Maybe<DeleteAirlineResult>;
  deleteBooking?: Maybe<DeleteBookingResult>;
  deleteClientRate: Scalars['Boolean'];
  deleteCompanyRate: Scalars['Boolean'];
  deleteContact?: Maybe<DeleteContactResult>;
  deleteCustomer?: Maybe<DeleteCustomerResult>;
  deleteCustomerContact?: Maybe<DeleteCustomerContactResult>;
  deleteCustomerRateSet?: Maybe<DeleteCustomerRateSetResult>;
  deleteDriver?: Maybe<DeleteDriverResult>;
  deleteDriverFile: DeletedResult;
  deleteDriverRecord: DeletedResult;
  deleteFavoriteDriver?: Maybe<DeleteFavoriteDriverResult>;
  deleteFbo?: Maybe<DeleteFboResult>;
  deleteFile?: Maybe<DeleteFileResult>;
  deleteGarage?: Maybe<DeleteGarageResult>;
  deleteInvoice?: Maybe<DeleteInvoiceResult>;
  deleteLocation?: Maybe<DeleteLocationResult>;
  deleteMarket?: Maybe<DeleteMarketResult>;
  deleteNetworkInvitation?: Maybe<DeleteNetworkInvitationResult>;
  deleteNetworkRelationship?: Maybe<DeleteNetworkRelationshipResult>;
  deletePaymentMethod?: Maybe<DeletePaymentMethodResult>;
  deleteRate?: Maybe<DeleteRateResult>;
  deleteRatePolicy?: Maybe<DeleteRatePolicyResult>;
  deleteRateSet?: Maybe<DeleteRateSetResult>;
  deleteRateType?: Maybe<DeleteRateTypeResult>;
  deleteSavoyaDriver: DeletedResult;
  deleteSavoyaVehicle: DeletedResult;
  deleteSharedTrip?: Maybe<DeleteSharedTripResult>;
  deleteSystemVehicleClass?: Maybe<DeleteSystemVehicleClassResult>;
  deleteTodo?: Maybe<DeleteTodoResult>;
  deleteTodoSpec?: Maybe<DeleteTodoSpecResult>;
  deleteTrip?: Maybe<DeleteTripResult>;
  deleteTripAddon?: Maybe<DeleteTripAddonResult>;
  deleteTripClient: Scalars['Boolean'];
  deleteTripContact?: Maybe<DeleteTripContactResult>;
  deleteTripNote?: Maybe<DeleteTripNoteResult>;
  deleteTripNotificationAttempt?: Maybe<DeleteTripNotificationAttemptResult>;
  deleteTripNotificationSubscription?: Maybe<DeleteTripNotificationSubscriptionResult>;
  deleteTripNotificationType?: Maybe<DeleteTripNotificationTypeResult>;
  deleteTripRule?: Maybe<DeleteTripRuleResult>;
  deleteTripWaypoint: TripItineraryUpdatedResult;
  deleteUserIdentity?: Maybe<DeleteUserIdentityResult>;
  deleteUserRecord: UserDeletedResult;
  deleteVehicle?: Maybe<DeleteVehicleResult>;
  deleteVehicleClass?: Maybe<DeleteVehicleClassResult>;
  deleteVehicleClassOverride?: Maybe<DeleteVehicleClassOverrideResult>;
  deleteVehicleClassRecord: DeletedResult;
  deleteVehicleFile: Scalars['Boolean'];
  deleteVehicleMake?: Maybe<DeleteVehicleMakeResult>;
  deleteVehicleModel?: Maybe<DeleteVehicleModelResult>;
  deleteVehicleRecord: DeletedResult;
  deleteVehicleSensorReading?: Maybe<DeleteVehicleSensorReadingResult>;
  deleteVendorRecord: DeletedResult;
  disconnectUser?: Maybe<DisconnectUserResponse>;
  executeAcceptNetworkOffer: TripCommandResult;
  executeAddTripWaypoint: TripCommandResult;
  executeApplyFlatRateOverride: TripCommandResult;
  executeApplyFlightAlert: TripCommandResult;
  executeApplyRefund: TripCommandResult;
  executeArriveDropoff: TripCommandResult;
  executeArriveGarage: TripCommandResult;
  executeArrivePickup: TripCommandResult;
  executeArriveStop: TripCommandResult;
  executeAssignTrip: TripCommandResult;
  executeBeginPaymentMethodSetup: TripCommandResult;
  executeCancelSavoyaSharedTripOffer: TripCommandResult;
  executeCancelTrip: TripCommandResult;
  executeCircling: TripCommandResult;
  executeCloseTrip: TripCommandResult;
  executeConfirmNetworkRequest: TripCommandResult;
  executeCorrectTripTimestamp: TripCommandResult;
  executeCreateInvoiceDeliveryRequest: TripCommandResult;
  executeCreateOrUpdateInvoice: TripCommandResult;
  executeCreatePaymentMethod: TripCommandResult;
  executeDeclineNetworkConfirmationRequest: TripCommandResult;
  executeDeclineNetworkOffer: TripCommandResult;
  executeDepartPickup: TripCommandResult;
  executeDepartStop: TripCommandResult;
  executeEnRouteToPickup: TripCommandResult;
  executeExpireQuote: TripCommandResult;
  executeForceTripStatus: TripCommandResult;
  executeInvoicePaid: TripCommandResult;
  executeInvoiceSubmitted: TripCommandResult;
  executeOfferToNetwork: TripCommandResult;
  executeOverrideBaseRate: TripCommandResult;
  executeOverrideGarageTime: TripCommandResult;
  executeOverrideWaitTime: TripCommandResult;
  executeProcessPayment: TripCommandResult;
  executeReassignmentRequested: TripCommandResult;
  executeRecordTransaction: TripCommandResult;
  executeRequestNetworkConfirmation: TripCommandResult;
  executeResetSavoyaSharedTrip: TripCommandResult;
  executeRevokeNetworkSharedTrip: TripCommandResult;
  executeRollbackToOnsite: TripCommandResult;
  executeRollbackVendorPayment: TripCommandResult;
  executeSendQuote: TripCommandResult;
  executeSendTripReminders: Array<TripCommandResult>;
  executeSetPaymentMethod: TripCommandResult;
  executeSubmitTripRequest: TripCommandResult;
  executeUpdateEstimatedRevenueIfRequired: TripCommandResult;
  executeUseDifferentClassRate: TripCommandResult;
  executeWaiting: TripCommandResult;
  exportAnalyticsCSV: ExportAnalyticsCsvResult;
  importClients: ImportClientsResult;
  importContacts?: Maybe<ImportContactsResult>;
  inactivateVehicle?: Maybe<InactivateVehicleResult>;
  inactivateVehicleClass?: Maybe<InactivateVehicleClassResult>;
  insertAccount?: Maybe<InsertAccountResult>;
  insertAccountAdjustment?: Maybe<InsertAccountAdjustmentResult>;
  insertAccountDefaultNotifications?: Maybe<InsertAccountDefaultNotificationsResult>;
  insertAirline?: Maybe<InsertAirlineResult>;
  insertBooking?: Maybe<InsertBookingResult>;
  insertClient: ClientRecord;
  insertClientRate: ClientRateSetRecord;
  insertCompany: CompanyRecord;
  insertCompanyRate: CompanyRateSetRecord;
  insertContact?: Maybe<InsertContactResult>;
  insertCustomer?: Maybe<InsertCustomerResult>;
  insertCustomerContact?: Maybe<InsertCustomerContactResult>;
  insertCustomerRateSet?: Maybe<InsertCustomerRateSetResult>;
  insertDriver?: Maybe<InsertDriverResult>;
  insertFavoriteDriver?: Maybe<InsertFavoriteDriverResult>;
  insertFbo?: Maybe<InsertFboResult>;
  insertGarage?: Maybe<InsertGarageResult>;
  insertLocation?: Maybe<InsertLocationResult>;
  insertMarket?: Maybe<InsertMarketResult>;
  insertNetworkInvitation?: Maybe<InsertNetworkInvitationResult>;
  insertNetworkRelationship?: Maybe<InsertNetworkRelationshipResult>;
  insertPaymentMethod?: Maybe<InsertPaymentMethodResult>;
  insertRate?: Maybe<InsertRateResult>;
  insertRatePolicy?: Maybe<InsertRatePolicyResult>;
  insertRateSet?: Maybe<InsertRateSetResult>;
  insertRateType?: Maybe<InsertRateTypeResult>;
  insertSharedTrip?: Maybe<InsertSharedTripResult>;
  insertSystemVehicleClass?: Maybe<InsertSystemVehicleClassResult>;
  insertTodo?: Maybe<InsertTodoResult>;
  insertTodoSpec?: Maybe<InsertTodoSpecResult>;
  insertTransferRateSet?: Maybe<InsertRateSetResult>;
  insertTrip?: Maybe<InsertTripResult>;
  insertTripAddon?: Maybe<InsertTripAddonResult>;
  insertTripClient: TripClientRecord;
  insertTripContact?: Maybe<InsertTripContactResult>;
  insertTripNote?: Maybe<InsertTripNoteResult>;
  insertTripNotificationAttempt?: Maybe<InsertTripNotificationAttemptResult>;
  insertTripNotificationSubscription?: Maybe<InsertTripNotificationSubscriptionResult>;
  insertTripNotificationType?: Maybe<InsertTripNotificationTypeResult>;
  insertTripRule?: Maybe<InsertTripRuleResult>;
  insertTripWaypoint: TripItineraryUpdatedResult;
  insertUser?: Maybe<InsertUserResult>;
  insertUserIdentity?: Maybe<InsertUserIdentityResult>;
  insertVehicle?: Maybe<InsertVehicleResult>;
  insertVehicleClass?: Maybe<InsertVehicleClassResult>;
  insertVehicleClassOverride?: Maybe<InsertVehicleClassOverrideResult>;
  insertVehicleMake?: Maybe<InsertVehicleMakeResult>;
  insertVehicleModel?: Maybe<InsertVehicleModelResult>;
  insertVehicleSensorReading?: Maybe<InsertVehicleSensorReadingResult>;
  inviteNetworkAssociate?: Maybe<NetworkInvitationResult>;
  linkUserIdentity?: Maybe<LinkUserIdentityResult>;
  mutateSharedTripStatus?: Maybe<SharedTripResult>;
  onboardUser?: Maybe<OnboardUserResponse>;
  reportAddonUsage: Scalars['Float'];
  resendVerificationEmail?: Maybe<ResendVerificaitonEmailResult>;
  resolveTodo: ResolveTodoResult;
  revokeNetworkInvitation?: Maybe<NetworkInvitationResult>;
  revokeSharedTripFromVendor?: Maybe<SharedTripResult>;
  revokeSquareToken?: Maybe<RevokeSquareTokenResponse>;
  setVehicleAvailability?: Maybe<SetVehicleAvailabilityResult>;
  shareTripWithContact?: Maybe<SharedTripResult>;
  shareTripWithVendor?: Maybe<SharedTripResult>;
  startPaymentMethodSetup?: Maybe<StartPaymentMethodSetupResponse>;
  subscriptionGetNewSetupIntent?: Maybe<Scalars['String']>;
  syncActiveTodos: TodoCollectionResult;
  syncSavoyaTripClients: Scalars['Boolean'];
  updateAccount?: Maybe<UpdateAccountResult>;
  updateAccountAdjustment?: Maybe<UpdateAccountAdjustmentResult>;
  updateAccountDefaultNotifications?: Maybe<UpdateAccountDefaultNotificationsResult>;
  updateAirline?: Maybe<UpdateAirlineResult>;
  updateBooking?: Maybe<UpdateBookingResult>;
  updateClient: ClientRecord;
  updateClientPaymentProcessor: ClientPaymentProcessorRecord;
  updateCompany: CompanyRecord;
  updateConfirmationStatus: UpdateConfirmationStatusResult;
  updateContact?: Maybe<UpdateContactResult>;
  updateContactNote?: Maybe<UpdateContactNoteResult>;
  updateCustomer?: Maybe<UpdateCustomerResult>;
  updateDriver?: Maybe<UpdateDriverResult>;
  updateDriverExternalId?: Maybe<UpdateDriverExternalIdResult>;
  updateDriverRecord: DriverRecord;
  updateFbo?: Maybe<UpdateFboResult>;
  updateGarage?: Maybe<UpdateGarageResult>;
  updateLocation?: Maybe<UpdateLocationResult>;
  updateMarket?: Maybe<UpdateMarketResult>;
  updateNetworkInvitation?: Maybe<UpdateNetworkInvitationResult>;
  updateNetworkRelationship?: Maybe<UpdateNetworkRelationshipResult>;
  updateRate?: Maybe<UpdateRateResult>;
  updateRatePolicy?: Maybe<UpdateRatePolicyResult>;
  updateRateSet?: Maybe<UpdateRateSetResult>;
  updateRateType?: Maybe<UpdateRateTypeResult>;
  updateSharedTrip?: Maybe<UpdateSharedTripResult>;
  updateSystemVehicleClass?: Maybe<UpdateSystemVehicleClassResult>;
  updateTodo?: Maybe<UpdateTodoResult>;
  updateTodoSpec?: Maybe<UpdateTodoSpecResult>;
  updateTransferRateSet?: Maybe<UpdateRateSetResult>;
  updateTrip?: Maybe<UpdateTripResult>;
  updateTripAddon?: Maybe<UpdateTripAddonResult>;
  updateTripContact?: Maybe<UpdateTripContactResult>;
  updateTripNote?: Maybe<UpdateTripNoteResult>;
  updateTripNotificationAttempt?: Maybe<UpdateTripNotificationAttemptResult>;
  updateTripNotificationSubscription?: Maybe<UpdateTripNotificationSubscriptionResult>;
  updateTripNotificationSubscriptionByTripClient?: Maybe<UpdateTripNotificationSubscriptionsByTripClientResult>;
  updateTripNotificationType?: Maybe<UpdateTripNotificationTypeResult>;
  updateTripRate?: Maybe<UpdateTripRateResult>;
  updateTripRule?: Maybe<UpdateTripRuleResult>;
  updateTripWaypoint: TripItineraryUpdatedResult;
  updateUserAuthIdentity: UserRecord;
  updateVehicle?: Maybe<UpdateVehicleResult>;
  updateVehicleClass?: Maybe<UpdateVehicleClassResult>;
  updateVehicleClassOverride?: Maybe<UpdateVehicleClassOverrideResult>;
  updateVehicleExternalId?: Maybe<UpdateVehicleExternalIdResult>;
  updateVehicleMake?: Maybe<UpdateVehicleMakeResult>;
  updateVehicleModel?: Maybe<UpdateVehicleModelResult>;
  updateVehicleRecord: VehicleRecord;
  updateVendor: VendorRecord;
  upsertClient: ClientRecord;
  upsertClientDiscount?: Maybe<UpsertClientDiscountResult>;
  upsertClientPaymentProcessor: ClientPaymentProcessorRecord;
  upsertCustomerDiscount?: Maybe<UpsertCustomerDiscountResult>;
  verifyTripWaypointFlight: VerifiedFlightResult;
  verifyUser?: Maybe<VerifyUserResponse>;
};


export type MutationAcceptNetworkInvitationArgs = {
  invitationToken: Scalars['String'];
};


export type MutationBulkInsertClientsArgs = {
  clients?: InputMaybe<Array<BulkInsertClientsInput>>;
};


export type MutationBulkInsertCompaniesArgs = {
  companies?: InputMaybe<Array<BulkCompanyInput>>;
};


export type MutationBulkInsertTripClientArgs = {
  tripClients?: InputMaybe<Array<BulkTripClientInput>>;
};


export type MutationBulkUpsertClientPaymentProcessorArgs = {
  clientPaymentProcessors: Array<BulkClientPaymentProcessorInput>;
};


export type MutationCancelSubscriptionArgs = {
  accountId?: InputMaybe<Scalars['UUID']>;
  accountName?: InputMaybe<Scalars['String']>;
  cancel?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  selectedTier?: InputMaybe<TierType>;
};


export type MutationCreateAccountFromTemplateArgs = {
  template: IndependentOperatorOnboardingTemplate;
};


export type MutationCreateDriverFilesUploadSignedUrlsArgs = {
  driverFilesUploadArgs: DriverFilesUploadArgs;
};


export type MutationCreateDriverRecordArgs = {
  driverCreateArgs: DriverCreateArgs;
};


export type MutationCreateOrUpdateInvoiceSummaryForTripArgs = {
  tripId: Scalars['UUID'];
};


export type MutationCreateOrUpdateSubscriptionArgs = {
  accountId?: InputMaybe<Scalars['UUID']>;
  accountName?: InputMaybe<Scalars['String']>;
  cancel?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  selectedTier?: InputMaybe<TierType>;
};


export type MutationCreateOrUpdateUserRecordArgs = {
  userCreateArgs: UserCreateArgs;
};


export type MutationCreateOrUpdateVehicleClassArgs = {
  vehicleClassInputArgs: VehicleClassInputArgs;
};


export type MutationCreateSharedTripArgs = {
  amount: Scalars['Float'];
  email?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  paymentMethodType: PaymentMethodType;
  tripId: Scalars['UUID'];
};


export type MutationCreateSquareCardArgs = {
  input: CreateSquareCardInput;
};


export type MutationCreateSquareCustomerArgs = {
  customerContactId: Scalars['UUID'];
};


export type MutationCreateSquarePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreateUserAuthIdentityArgs = {
  userCreateArgs: UserCreateArgs;
};


export type MutationCreateVehicleFilesUploadSignedUrlsArgs = {
  vehicleFilesUploadArgs: VehicleFilesUploadArgs;
};


export type MutationCreateVehicleRecordArgs = {
  vehicleCreateArgs: VehicleCreateArgs;
};


export type MutationCreateVendorArgs = {
  vendorCreateArgs: VendorCreateArgs;
};


export type MutationDeclineNetworkInvitationArgs = {
  invitationToken: Scalars['String'];
};


export type MutationDeleteAccountArgs = {
  account: DeleteAccount;
};


export type MutationDeleteAccountAdjustmentArgs = {
  accountAdjustment: DeleteAccountAdjustment;
};


export type MutationDeleteAccountDefaultNotificationsArgs = {
  accountDefaultNotifications: DeleteAccountDefaultNotifications;
};


export type MutationDeleteAirlineArgs = {
  airline: DeleteAirline;
};


export type MutationDeleteBookingArgs = {
  booking: DeleteBooking;
};


export type MutationDeleteClientRateArgs = {
  clientId: Scalars['UUID'];
  rateSetId: Scalars['UUID'];
};


export type MutationDeleteCompanyRateArgs = {
  companyId: Scalars['UUID'];
  rateSetId: Scalars['UUID'];
};


export type MutationDeleteContactArgs = {
  contact: DeleteContact;
};


export type MutationDeleteCustomerArgs = {
  customer: DeleteCustomer;
};


export type MutationDeleteCustomerContactArgs = {
  customerContact: DeleteCustomerContact;
};


export type MutationDeleteCustomerRateSetArgs = {
  customerRateSet: DeleteCustomerRateSet;
};


export type MutationDeleteDriverArgs = {
  driver: DeleteDriver;
};


export type MutationDeleteDriverFileArgs = {
  deleteDriverFileArgs: DriverDeleteFileArgs;
};


export type MutationDeleteDriverRecordArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteFavoriteDriverArgs = {
  favoriteDriver: DeleteFavoriteDriverAccount;
};


export type MutationDeleteFboArgs = {
  fbo: DeleteFbo;
};


export type MutationDeleteFileArgs = {
  fileInfo: FilesLocation;
};


export type MutationDeleteGarageArgs = {
  garage: DeleteGarage;
};


export type MutationDeleteInvoiceArgs = {
  invoice: DeleteInvoice;
};


export type MutationDeleteLocationArgs = {
  location: DeleteLocation;
};


export type MutationDeleteMarketArgs = {
  market: DeleteMarket;
};


export type MutationDeleteNetworkInvitationArgs = {
  networkInvitation: DeleteNetworkInvitation;
};


export type MutationDeleteNetworkRelationshipArgs = {
  networkRelationship: DeleteNetworkRelationship;
};


export type MutationDeletePaymentMethodArgs = {
  paymentMethodId: Scalars['UUID'];
};


export type MutationDeleteRateArgs = {
  rate: DeleteRate;
};


export type MutationDeleteRatePolicyArgs = {
  ratePolicy: DeleteRatePolicy;
};


export type MutationDeleteRateSetArgs = {
  rateSet: DeleteRateSet;
};


export type MutationDeleteRateTypeArgs = {
  rateType: DeleteRateType;
};


export type MutationDeleteSavoyaDriverArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteSavoyaVehicleArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteSharedTripArgs = {
  sharedTrip: DeleteSharedTrip;
};


export type MutationDeleteSystemVehicleClassArgs = {
  systemVehicleClass: DeleteSystemVehicleClass;
};


export type MutationDeleteTodoArgs = {
  todo: DeleteTodo;
};


export type MutationDeleteTodoSpecArgs = {
  todoSpec: DeleteTodoSpec;
};


export type MutationDeleteTripArgs = {
  trip: DeleteTrip;
};


export type MutationDeleteTripAddonArgs = {
  tripAddon: DeleteTripAddon;
};


export type MutationDeleteTripClientArgs = {
  tripClientId: Scalars['UUID'];
};


export type MutationDeleteTripContactArgs = {
  tripContact: DeleteTripContact;
};


export type MutationDeleteTripNoteArgs = {
  tripNote: DeleteTripNote;
};


export type MutationDeleteTripNotificationAttemptArgs = {
  tripNotificationAttempt: DeleteTripNotificationAttempt;
};


export type MutationDeleteTripNotificationSubscriptionArgs = {
  tripNotificationSubscription: DeleteTripNotificationSubscription;
};


export type MutationDeleteTripNotificationTypeArgs = {
  tripNotificationType: DeleteTripNotificationType;
};


export type MutationDeleteTripRuleArgs = {
  tripRule: DeleteTripRule;
};


export type MutationDeleteTripWaypointArgs = {
  waypointId: Scalars['UUID'];
};


export type MutationDeleteUserIdentityArgs = {
  userIdentity: DeleteUserIdentity;
};


export type MutationDeleteUserRecordArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteVehicleArgs = {
  vehicle: DeleteVehicle;
};


export type MutationDeleteVehicleClassArgs = {
  vehicleClass: DeleteVehicleClass;
};


export type MutationDeleteVehicleClassOverrideArgs = {
  vehicleClassOverride: DeleteVehicleClassOverride;
};


export type MutationDeleteVehicleClassRecordArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteVehicleFileArgs = {
  deleteVehicleFileArgs: VehicleDeleteFileArgs;
};


export type MutationDeleteVehicleMakeArgs = {
  vehicleMake: DeleteVehicleMake;
};


export type MutationDeleteVehicleModelArgs = {
  vehicleModel: DeleteVehicleModel;
};


export type MutationDeleteVehicleRecordArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteVehicleSensorReadingArgs = {
  vehicleSensorReading: DeleteVehicleSensorReading;
};


export type MutationDeleteVendorRecordArgs = {
  id: Scalars['UUID'];
};


export type MutationDisconnectUserArgs = {
  accountId: Scalars['UUID'];
};


export type MutationExecuteAcceptNetworkOfferArgs = {
  command: AcceptNetworkOffer;
};


export type MutationExecuteAddTripWaypointArgs = {
  command: AddTripWaypoint;
};


export type MutationExecuteApplyFlatRateOverrideArgs = {
  command: ApplyFlatRateOverride;
};


export type MutationExecuteApplyFlightAlertArgs = {
  command: FlightChanged;
};


export type MutationExecuteApplyRefundArgs = {
  command: ApplyRefund;
};


export type MutationExecuteArriveDropoffArgs = {
  command: ArriveDropoff;
};


export type MutationExecuteArriveGarageArgs = {
  command: ArriveGarage;
};


export type MutationExecuteArrivePickupArgs = {
  command: ArrivePickup;
};


export type MutationExecuteArriveStopArgs = {
  command: ArriveStop;
};


export type MutationExecuteAssignTripArgs = {
  command: AssignTrip;
};


export type MutationExecuteBeginPaymentMethodSetupArgs = {
  command: PaymentMethodSetupBegun;
};


export type MutationExecuteCancelSavoyaSharedTripOfferArgs = {
  command: CancelSavoyaSharedTripOffer;
};


export type MutationExecuteCancelTripArgs = {
  command: CancelTrip;
};


export type MutationExecuteCirclingArgs = {
  command: Circling;
};


export type MutationExecuteCloseTripArgs = {
  command: CloseTrip;
};


export type MutationExecuteConfirmNetworkRequestArgs = {
  command: ConfirmNetworkRequest;
};


export type MutationExecuteCorrectTripTimestampArgs = {
  command: CorrectTripTimestamp;
};


export type MutationExecuteCreateInvoiceDeliveryRequestArgs = {
  command: InvoiceDeliveryRequested;
};


export type MutationExecuteCreateOrUpdateInvoiceArgs = {
  command: CreateOrUpdateInvoice;
};


export type MutationExecuteCreatePaymentMethodArgs = {
  command: PaymentMethodCreated;
};


export type MutationExecuteDeclineNetworkConfirmationRequestArgs = {
  command: DeclineNetworkConfirmationRequest;
};


export type MutationExecuteDeclineNetworkOfferArgs = {
  command: DeclineNetworkOffer;
};


export type MutationExecuteDepartPickupArgs = {
  command: DepartPickup;
};


export type MutationExecuteDepartStopArgs = {
  command: DepartStop;
};


export type MutationExecuteEnRouteToPickupArgs = {
  command: EnRouteToPickup;
};


export type MutationExecuteExpireQuoteArgs = {
  command: ExpireQuote;
};


export type MutationExecuteForceTripStatusArgs = {
  command: ForceTripStatus;
};


export type MutationExecuteInvoicePaidArgs = {
  command: InvoicePaid;
};


export type MutationExecuteInvoiceSubmittedArgs = {
  command: InvoiceSubmitted;
};


export type MutationExecuteOfferToNetworkArgs = {
  command: OfferToNetwork;
};


export type MutationExecuteOverrideBaseRateArgs = {
  command: OverrideBaseRate;
};


export type MutationExecuteOverrideGarageTimeArgs = {
  command: OverrideGarageTime;
};


export type MutationExecuteOverrideWaitTimeArgs = {
  command: OverrideWaitTime;
};


export type MutationExecuteProcessPaymentArgs = {
  command: ProcessPayment;
};


export type MutationExecuteReassignmentRequestedArgs = {
  command: ReassignmentRequested;
};


export type MutationExecuteRecordTransactionArgs = {
  command: RecordTransaction;
};


export type MutationExecuteRequestNetworkConfirmationArgs = {
  command: RequestNetworkConfirmation;
};


export type MutationExecuteResetSavoyaSharedTripArgs = {
  command: ResetSavoyaSharedTrip;
};


export type MutationExecuteRevokeNetworkSharedTripArgs = {
  command: RevokeNetworkSharedTrip;
};


export type MutationExecuteRollbackToOnsiteArgs = {
  command: RollbackToOnsite;
};


export type MutationExecuteRollbackVendorPaymentArgs = {
  command: RollbackPayment;
};


export type MutationExecuteSendQuoteArgs = {
  command: SendQuote;
};


export type MutationExecuteSendTripRemindersArgs = {
  command: TripReminderRequested;
};


export type MutationExecuteSetPaymentMethodArgs = {
  command: PaymentMethodSet;
};


export type MutationExecuteSubmitTripRequestArgs = {
  command: SubmitTripRequest;
};


export type MutationExecuteUpdateEstimatedRevenueIfRequiredArgs = {
  command: UpdateEstimatedRevenueIfRequired;
};


export type MutationExecuteUseDifferentClassRateArgs = {
  command: UseDifferentClassRate;
};


export type MutationExecuteWaitingArgs = {
  command: Waiting;
};


export type MutationExportAnalyticsCsvArgs = {
  columnDictionary?: InputMaybe<Scalars['JSON']>;
  query: Scalars['JSON'];
};


export type MutationImportClientsArgs = {
  accountId: Scalars['UUID'];
  data: Array<Scalars['JSON']>;
  source: ClientImportSource;
};


export type MutationImportContactsArgs = {
  input: ImportContactsInput;
};


export type MutationInactivateVehicleArgs = {
  id: Scalars['UUID'];
};


export type MutationInactivateVehicleClassArgs = {
  id: Scalars['UUID'];
};


export type MutationInsertAccountArgs = {
  account: InsertAccount;
};


export type MutationInsertAccountAdjustmentArgs = {
  accountAdjustment: InsertAccountAdjustment;
};


export type MutationInsertAccountDefaultNotificationsArgs = {
  accountDefaultNotifications: InsertAccountDefaultNotifications;
};


export type MutationInsertAirlineArgs = {
  airline: InsertAirline;
};


export type MutationInsertBookingArgs = {
  email: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type MutationInsertClientArgs = {
  accountId: Scalars['UUID'];
  addresses?: InputMaybe<Array<ClientAddressInput>>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<ClientEmailInput>>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive: Scalars['Boolean'];
  isMigration?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<ClientPhoneInput>>;
  primaryRole: ClientRole;
  rates?: InputMaybe<Array<ClientRateInput>>;
  title?: InputMaybe<Scalars['String']>;
  tripClient?: InputMaybe<TripClientInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
};


export type MutationInsertClientRateArgs = {
  clientId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  rateSetId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['String']>;
};


export type MutationInsertCompanyArgs = {
  accountId: Scalars['UUID'];
  addresses?: InputMaybe<Array<ClientAddressInput>>;
  createdAt?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<ClientEmailInput>>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<ClientPhoneInput>>;
  rates?: InputMaybe<Array<CompanyRateInput>>;
  type: CompanyTypeEnum;
  updatedAt?: InputMaybe<Scalars['String']>;
};


export type MutationInsertCompanyRateArgs = {
  companyId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  rateSetId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['String']>;
};


export type MutationInsertContactArgs = {
  contact: InsertContact;
  fileType?: InputMaybe<Scalars['String']>;
  useWithSavoya?: InputMaybe<Scalars['Boolean']>;
};


export type MutationInsertCustomerArgs = {
  customer: InsertCustomer;
};


export type MutationInsertCustomerContactArgs = {
  contactId?: InputMaybe<Scalars['String']>;
  customerContact: InsertCustomerContact;
};


export type MutationInsertCustomerRateSetArgs = {
  customerRateSet: InsertCustomerRateSet;
};


export type MutationInsertDriverArgs = {
  driver: InsertDriver;
};


export type MutationInsertFavoriteDriverArgs = {
  favoriteDriver?: InputMaybe<InsertFavoriteDriverInput>;
};


export type MutationInsertFboArgs = {
  fbo: InsertFbo;
};


export type MutationInsertGarageArgs = {
  garage: InsertGarageWithLocation;
};


export type MutationInsertLocationArgs = {
  location: InsertLocation;
};


export type MutationInsertMarketArgs = {
  market: InsertMarketWithLocation;
};


export type MutationInsertNetworkInvitationArgs = {
  networkInvitation: InsertNetworkInvitation;
};


export type MutationInsertNetworkRelationshipArgs = {
  networkRelationship: InsertNetworkRelationship;
};


export type MutationInsertPaymentMethodArgs = {
  customerContactId: Scalars['UUID'];
  externalPaymentMethodId: Scalars['String'];
  source: CreditCardProcessor;
};


export type MutationInsertRateArgs = {
  rate: InsertRate;
};


export type MutationInsertRatePolicyArgs = {
  ratePolicy: InsertRatePolicy;
};


export type MutationInsertRateSetArgs = {
  rateSet: InsertRateSet;
};


export type MutationInsertRateTypeArgs = {
  rateType: InsertRateType;
};


export type MutationInsertSharedTripArgs = {
  sharedTrip: InsertSharedTrip;
};


export type MutationInsertSystemVehicleClassArgs = {
  systemVehicleClass: InsertSystemVehicleClass;
};


export type MutationInsertTodoArgs = {
  todo: InsertTodo;
};


export type MutationInsertTodoSpecArgs = {
  todoSpec: InsertTodoSpec;
};


export type MutationInsertTransferRateSetArgs = {
  rateSet: InsertTransferRateSet;
};


export type MutationInsertTripArgs = {
  publicToken?: InputMaybe<Scalars['String']>;
  recaptchaToken?: InputMaybe<Scalars['String']>;
  trip: InsertTrip;
};


export type MutationInsertTripAddonArgs = {
  tripAddon: InsertTripAddon;
};


export type MutationInsertTripClientArgs = {
  clientId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPrimary: Scalars['Boolean'];
  role: ClientRole;
  tripId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['String']>;
};


export type MutationInsertTripContactArgs = {
  tripContact: InsertTripContact;
};


export type MutationInsertTripNoteArgs = {
  tripNote: InsertTripNote;
};


export type MutationInsertTripNotificationAttemptArgs = {
  tripNotificationAttempt: InsertTripNotificationAttempt;
};


export type MutationInsertTripNotificationSubscriptionArgs = {
  tripNotificationSubscription: InsertTripNotificationSubscription;
};


export type MutationInsertTripNotificationTypeArgs = {
  tripNotificationType: InsertTripNotificationType;
};


export type MutationInsertTripRuleArgs = {
  tripRule: InsertTripRuleWithLocation;
};


export type MutationInsertTripWaypointArgs = {
  insertAfterWaypointId: Scalars['UUID'];
  waypoint: InsertTripWaypointInput;
};


export type MutationInsertUserArgs = {
  contact: InsertUser;
  fileType?: InputMaybe<Scalars['String']>;
  useWithSavoya?: InputMaybe<Scalars['Boolean']>;
};


export type MutationInsertUserIdentityArgs = {
  userIdentity: InsertUserIdentity;
};


export type MutationInsertVehicleArgs = {
  fileType?: InputMaybe<Scalars['String']>;
  vehicle: InsertVehicleInput;
};


export type MutationInsertVehicleClassArgs = {
  vehicleClass: InsertVehicleClass;
};


export type MutationInsertVehicleClassOverrideArgs = {
  vehicleClassOverride: InsertVehicleClassOverride;
};


export type MutationInsertVehicleMakeArgs = {
  vehicleMake: InsertVehicleMake;
};


export type MutationInsertVehicleModelArgs = {
  vehicleModel: InsertVehicleModel;
};


export type MutationInsertVehicleSensorReadingArgs = {
  vehicleSensorReading: InsertVehicleSensorReading;
};


export type MutationInviteNetworkAssociateArgs = {
  email: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};


export type MutationMutateSharedTripStatusArgs = {
  sharedTripId: Scalars['UUID'];
};


export type MutationOnboardUserArgs = {
  accountId: Scalars['UUID'];
};


export type MutationReportAddonUsageArgs = {
  accountId?: InputMaybe<Scalars['UUID']>;
  addonType?: InputMaybe<AddonType>;
  subscriptionId?: InputMaybe<Scalars['UUID']>;
};


export type MutationResolveTodoArgs = {
  id: Scalars['UUID'];
  status: TodoStatus;
};


export type MutationRevokeNetworkInvitationArgs = {
  invitationToken: Scalars['String'];
};


export type MutationRevokeSharedTripFromVendorArgs = {
  sharedTrip: RevokeShareTripFromVendorArgs;
};


export type MutationRevokeSquareTokenArgs = {
  accountId: Scalars['UUID'];
};


export type MutationSetVehicleAvailabilityArgs = {
  availability: VehicleAvailabilityInput;
};


export type MutationShareTripWithContactArgs = {
  contactId: Scalars['String'];
  token: Scalars['String'];
};


export type MutationShareTripWithVendorArgs = {
  sharedTrip: ShareTripWithVendorArgs;
};


export type MutationStartPaymentMethodSetupArgs = {
  customerContactId: Scalars['UUID'];
};


export type MutationSubscriptionGetNewSetupIntentArgs = {
  accountId: Scalars['UUID'];
};


export type MutationSyncActiveTodosArgs = {
  accountId: Scalars['UUID'];
  entityId: Scalars['UUID'];
  entityType: Scalars['String'];
};


export type MutationSyncSavoyaTripClientsArgs = {
  savoyaPassengers: Array<SavoyaPassengerInput>;
  tripId: Scalars['UUID'];
  vendorId: Scalars['UUID'];
};


export type MutationUpdateAccountArgs = {
  account: UpdateAccount;
};


export type MutationUpdateAccountAdjustmentArgs = {
  accountAdjustment: UpdateAccountAdjustment;
};


export type MutationUpdateAccountDefaultNotificationsArgs = {
  accountDefaultNotifications: UpdateAccountDefaultNotifications;
};


export type MutationUpdateAirlineArgs = {
  airline: UpdateAirline;
};


export type MutationUpdateBookingArgs = {
  booking: UpdateBooking;
};


export type MutationUpdateClientArgs = {
  addresses?: InputMaybe<Array<ClientAddressInput>>;
  booker?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  disconnectCompanyId?: InputMaybe<Scalars['UUID']>;
  emails?: InputMaybe<Array<ClientEmailInput>>;
  id: Scalars['UUID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  passenger?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<ClientPhoneInput>>;
  primaryRole?: InputMaybe<ClientRole>;
  rate?: InputMaybe<ClientRateInput>;
  title?: InputMaybe<Scalars['String']>;
  tripClient?: InputMaybe<TripClientInput>;
  tripClientRole?: InputMaybe<UpdateTripClientRoleInput>;
};


export type MutationUpdateClientPaymentProcessorArgs = {
  clientId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  externalCustomerId: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  paymentProcessor: PaymentProcessor;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};


export type MutationUpdateCompanyArgs = {
  addresses?: InputMaybe<Array<ClientAddressInput>>;
  emails?: InputMaybe<Array<ClientEmailInput>>;
  id: Scalars['UUID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<ClientPhoneInput>>;
  rate?: InputMaybe<CompanyRateInput>;
  type?: InputMaybe<CompanyTypeEnum>;
};


export type MutationUpdateConfirmationStatusArgs = {
  confirmationEmailStatus: TripConfirmationEmailStatus;
  tripId: Scalars['UUID'];
};


export type MutationUpdateContactArgs = {
  contact: UpdateContact;
};


export type MutationUpdateContactNoteArgs = {
  contact: UpdateContactNote;
};


export type MutationUpdateCustomerArgs = {
  customer: UpdateCustomer;
};


export type MutationUpdateDriverArgs = {
  driver: UpdateDriver;
};


export type MutationUpdateDriverExternalIdArgs = {
  updateArgs: UpdateDriverExternalId;
};


export type MutationUpdateDriverRecordArgs = {
  driverUpdateArgs: DriverUpdateArgs;
};


export type MutationUpdateFboArgs = {
  fbo: UpdateFbo;
};


export type MutationUpdateGarageArgs = {
  garage: UpdateGarageWithLocation;
};


export type MutationUpdateLocationArgs = {
  location: UpdateLocation;
};


export type MutationUpdateMarketArgs = {
  market: UpdateMarket;
};


export type MutationUpdateNetworkInvitationArgs = {
  networkInvitation: UpdateNetworkInvitation;
};


export type MutationUpdateNetworkRelationshipArgs = {
  networkRelationship: UpdateNetworkRelationship;
};


export type MutationUpdateRateArgs = {
  rate: UpdateRate;
};


export type MutationUpdateRatePolicyArgs = {
  ratePolicy: UpdateRatePolicy;
};


export type MutationUpdateRateSetArgs = {
  rateSet: UpdateRateSet;
};


export type MutationUpdateRateTypeArgs = {
  rateType: UpdateRateType;
};


export type MutationUpdateSharedTripArgs = {
  sharedTrip: UpdateSharedTrip;
};


export type MutationUpdateSystemVehicleClassArgs = {
  systemVehicleClass: UpdateSystemVehicleClass;
};


export type MutationUpdateTodoArgs = {
  todo: UpdateTodo;
};


export type MutationUpdateTodoSpecArgs = {
  todoSpec: UpdateTodoSpec;
};


export type MutationUpdateTransferRateSetArgs = {
  rateSet: UpdateTransferRateSet;
};


export type MutationUpdateTripArgs = {
  trip: UpdateTrip;
};


export type MutationUpdateTripAddonArgs = {
  tripAddon: UpdateTripAddon;
};


export type MutationUpdateTripContactArgs = {
  tripContact: UpdateTripContact;
};


export type MutationUpdateTripNoteArgs = {
  tripNote: UpdateTripNote;
};


export type MutationUpdateTripNotificationAttemptArgs = {
  tripNotificationAttempt: UpdateTripNotificationAttempt;
};


export type MutationUpdateTripNotificationSubscriptionArgs = {
  tripNotificationSubscription: UpdateTripNotificationSubscription;
};


export type MutationUpdateTripNotificationSubscriptionByTripClientArgs = {
  tripClientId: Scalars['UUID'];
  tripNotificationSubscriptions: Array<UpdateTripNotificationSubscriptionByTripClientId>;
};


export type MutationUpdateTripNotificationTypeArgs = {
  tripNotificationType: UpdateTripNotificationType;
};


export type MutationUpdateTripRateArgs = {
  tripRate: UpdateTripRate;
};


export type MutationUpdateTripRuleArgs = {
  tripRule: UpdateTripRule;
};


export type MutationUpdateTripWaypointArgs = {
  waypoint: UpdateTripWaypointInput;
};


export type MutationUpdateUserAuthIdentityArgs = {
  userUpdateArgs: UserUpdateArgs;
};


export type MutationUpdateVehicleArgs = {
  vehicle: UpdateVehicle;
};


export type MutationUpdateVehicleClassArgs = {
  vehicleClass: UpdateVehicleClass;
};


export type MutationUpdateVehicleClassOverrideArgs = {
  vehicleClassOverride: UpdateVehicleClassOverride;
};


export type MutationUpdateVehicleExternalIdArgs = {
  updateArgs: UpdateVehicleExternalId;
};


export type MutationUpdateVehicleMakeArgs = {
  vehicleMake: UpdateVehicleMake;
};


export type MutationUpdateVehicleModelArgs = {
  vehicleModel: UpdateVehicleModel;
};


export type MutationUpdateVehicleRecordArgs = {
  vehicleUpdateArgs: VehicleUpdateArgs;
};


export type MutationUpdateVendorArgs = {
  vendorUpdateArgs: VendorUpdateArgs;
};


export type MutationUpsertClientArgs = {
  accountId: Scalars['UUID'];
  addresses?: InputMaybe<Array<ClientAddressInput>>;
  companyId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<ClientEmailInput>>;
  id?: InputMaybe<Scalars['UUID']>;
  isActive: Scalars['Boolean'];
  isMigration?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<ClientPhoneInput>>;
  primaryRole: ClientRole;
  rates?: InputMaybe<Array<ClientRateInput>>;
  title?: InputMaybe<Scalars['String']>;
  tripClient?: InputMaybe<TripClientInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
};


export type MutationUpsertClientDiscountArgs = {
  clientDiscountRate: UpsertClientDiscountInput;
};


export type MutationUpsertClientPaymentProcessorArgs = {
  clientId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  externalCustomerId: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  paymentProcessor: PaymentProcessor;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};


export type MutationUpsertCustomerDiscountArgs = {
  customerDiscount: UpsertCustomerDiscountInput;
};


export type MutationVerifyTripWaypointFlightArgs = {
  travelDate?: InputMaybe<Scalars['String']>;
  waypoint: UpsertTripWaypointInput;
};


export type MutationVerifyUserArgs = {
  accountId: Scalars['UUID'];
};

export type MutationError = {
  __typename?: 'MutationError';
  code?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type MutationResult = {
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type NetworkConfirmationFailedEvent = TripEvent & {
  __typename?: 'NetworkConfirmationFailedEvent';
  id: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type NetworkConfirmationReceivedEvent = TripEvent & {
  __typename?: 'NetworkConfirmationReceivedEvent';
  driverId: Scalars['UUID'];
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
  vehicleId: Scalars['UUID'];
};

export type NetworkConfirmationReceivedWithoutAssignmentEvent = TripEvent & {
  __typename?: 'NetworkConfirmationReceivedWithoutAssignmentEvent';
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type NetworkConfirmationRequestedEvent = TripEvent & {
  __typename?: 'NetworkConfirmationRequestedEvent';
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type NetworkInvitation = {
  __typename?: 'NetworkInvitation';
  account: Account;
  accountId: Scalars['UUID'];
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  fromContact: Contact;
  fromContactId: Scalars['UUID'];
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  relationship?: Maybe<NetworkRelationship>;
  relationshipId?: Maybe<Scalars['UUID']>;
  resentAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  sentAt: Scalars['DateTime'];
  status: NetworkInvitationStatus;
  toContact?: Maybe<Contact>;
  toContactId?: Maybe<Scalars['UUID']>;
  toEmail: Scalars['String'];
  toName: Scalars['String'];
  token: Scalars['String'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type NetworkInvitationCollectionResult = {
  __typename?: 'NetworkInvitationCollectionResult';
  items: Array<NetworkInvitation>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type NetworkInvitationCriteria = {
  unresolved?: InputMaybe<Scalars['Boolean']>;
};

export type NetworkInvitationQueries = {
  __typename?: 'NetworkInvitationQueries';
  all: NetworkInvitationCollectionResult;
  byId?: Maybe<NetworkInvitation>;
};


export type NetworkInvitationQueriesAllArgs = {
  accountId: Scalars['UUID'];
  criteria?: InputMaybe<NetworkInvitationCriteria>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type NetworkInvitationQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export enum NetworkInvitationResponse {
  AwaitingAccountOnboarding = 'AwaitingAccountOnboarding',
  AwaitingUserIdentity = 'AwaitingUserIdentity',
  Error = 'Error',
  Success = 'Success'
}

export type NetworkInvitationResult = {
  __typename?: 'NetworkInvitationResult';
  errors?: Maybe<Array<MutationError>>;
  invitation?: Maybe<NetworkInvitation>;
  response?: Maybe<NetworkInvitationResponse>;
};

export enum NetworkInvitationStatus {
  Accepted = 'Accepted',
  AcceptedPendingOnboarding = 'AcceptedPendingOnboarding',
  Created = 'Created',
  Declined = 'Declined',
  Revoked = 'Revoked',
  Sent = 'Sent'
}

export type NetworkOfferAcceptedEvent = TripEvent & {
  __typename?: 'NetworkOfferAcceptedEvent';
  driverId: Scalars['UUID'];
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
  vehicleId: Scalars['UUID'];
};

export type NetworkOfferAcceptedWithoutAssignmnentEvent = TripEvent & {
  __typename?: 'NetworkOfferAcceptedWithoutAssignmnentEvent';
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type NetworkOfferFailedEvent = TripEvent & {
  __typename?: 'NetworkOfferFailedEvent';
  id: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type NetworkRelationship = {
  __typename?: 'NetworkRelationship';
  account: Account;
  accountId: Scalars['UUID'];
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['UUID'];
  invitation?: Maybe<NetworkInvitation>;
  invitationId?: Maybe<Scalars['UUID']>;
  isReciprocal: Scalars['Boolean'];
  toAccount: Account;
  toAccountId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type NetworkRelationshipCollectionResult = {
  __typename?: 'NetworkRelationshipCollectionResult';
  items: Array<NetworkRelationship>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type NetworkRelationshipCriteria = {
  direction?: InputMaybe<NetworkRelationshipDirection>;
};

export enum NetworkRelationshipDirection {
  Any = 'Any',
  From = 'From',
  To = 'To'
}

export type NetworkRelationshipQueries = {
  __typename?: 'NetworkRelationshipQueries';
  all: NetworkRelationshipCollectionResult;
  byId?: Maybe<NetworkRelationship>;
  toShare: NetworkRelationshipCollectionResult;
};


export type NetworkRelationshipQueriesAllArgs = {
  accountId: Scalars['UUID'];
  criteria?: InputMaybe<NetworkRelationshipCriteria>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type NetworkRelationshipQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type NetworkRelationshipQueriesToShareArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  tripId: Scalars['UUID'];
};

export type NetworkSharedTripRevokedEvent = TripEvent & {
  __typename?: 'NetworkSharedTripRevokedEvent';
  id: Scalars['UUID'];
  reason?: Maybe<Scalars['String']>;
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export enum NotificationProvider {
  Courier = 'Courier',
  Debug = 'Debug'
}

export type OfferToNetwork = {
  tripId: Scalars['UUID'];
};

export type OnboardUserResponse = MutationResult & {
  __typename?: 'OnboardUserResponse';
  errors?: Maybe<Array<MutationError>>;
  link?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum OpType {
  Insert = 'Insert',
  Remove = 'Remove',
  Update = 'Update'
}

export enum OrderByDirection {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export type OtherItemSummary = {
  __typename?: 'OtherItemSummary';
  addonId?: Maybe<Scalars['UUID']>;
  category: RateCategory;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  quantity: Scalars['Float'];
  total: Scalars['Float'];
  unitPrice: Scalars['Float'];
};

export type OverrideBaseRate = {
  newBaseRate?: InputMaybe<Scalars['Float']>;
  tripId: Scalars['UUID'];
};

export type OverrideGarageTime = {
  garageTimeType: TripWaypointRole;
  newGarageTime: Scalars['Float'];
  tripId: Scalars['UUID'];
};

export type OverrideWaitTime = {
  newWaitTime: Scalars['Float'];
  tripId: Scalars['UUID'];
};

/** This is used when a parent owns this location and will supply its name */
export type OwnedLocationInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<LocationCategory>;
  city?: InputMaybe<Scalars['String']>;
  coordinates?: InputMaybe<Scalars['Coordinates']>;
  country?: InputMaybe<Scalars['String']>;
  geoType: AreaType;
  placeFoursquareId?: InputMaybe<Scalars['String']>;
  placeName?: InputMaybe<Scalars['String']>;
  placeWikidataId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  radiusInKm?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  zoneType: ZoneType;
};

export type ParsedLocation = {
  __typename?: 'ParsedLocation';
  address?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  placeCategory?: Maybe<Scalars['String']>;
  placeName?: Maybe<Scalars['String']>;
  placeType?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type PaymentByCustomerContactInput = {
  customerContactId: Scalars['UUID'];
  source?: InputMaybe<CreditCardProcessor>;
};

export type PaymentByTripInput = {
  source?: InputMaybe<CreditCardProcessor>;
  tripId: Scalars['UUID'];
};

export enum PaymentFrequency {
  DelayedWeekly = 'DELAYED_WEEKLY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  createdAt: Scalars['TimestampWithTimezone'];
  customerContact?: Maybe<CustomerContact>;
  customerContactId?: Maybe<Scalars['UUID']>;
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  description: Scalars['String'];
  externalPaymentMethodId: Scalars['String'];
  id: Scalars['UUID'];
  reusable?: Maybe<Scalars['Boolean']>;
  source: CreditCardProcessor;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type PaymentMethodCollectionResult = {
  __typename?: 'PaymentMethodCollectionResult';
  items: Array<PaymentMethod>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type PaymentMethodCreated = {
  customerContactId?: InputMaybe<Scalars['UUID']>;
  externalPaymentMethodId: Scalars['String'];
  source: CreditCardProcessor;
  tripId: Scalars['UUID'];
};

export type PaymentMethodCreatedEvent = TripEvent & {
  __typename?: 'PaymentMethodCreatedEvent';
  customerContactId?: Maybe<Scalars['UUID']>;
  externalPaymentMethodId: Scalars['String'];
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type PaymentMethodQueries = {
  __typename?: 'PaymentMethodQueries';
  all: PaymentMethodCollectionResult;
  byCustomerContact: PaymentMethodCollectionResult;
  byId?: Maybe<PaymentMethod>;
  byTrip: PaymentMethodCollectionResult;
};


export type PaymentMethodQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type PaymentMethodQueriesByCustomerContactArgs = {
  input: PaymentByCustomerContactInput;
};


export type PaymentMethodQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type PaymentMethodQueriesByTripArgs = {
  input: PaymentByTripInput;
};

export type PaymentMethodRecord = {
  __typename?: 'PaymentMethodRecord';
  cardLastFour?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type PaymentMethodSet = {
  paymentMethodId?: InputMaybe<Scalars['UUID']>;
  paymentMethodType?: InputMaybe<PaymentMethodType>;
  tripId: Scalars['UUID'];
};

export type PaymentMethodSetEvent = TripEvent & {
  __typename?: 'PaymentMethodSetEvent';
  id: Scalars['UUID'];
  paymentMethodId?: Maybe<Scalars['UUID']>;
  paymentMethodType?: Maybe<PaymentMethodType>;
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type PaymentMethodSetupBegun = {
  tripId: Scalars['UUID'];
};

export type PaymentMethodSetupBegunEvent = TripEvent & {
  __typename?: 'PaymentMethodSetupBegunEvent';
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type PaymentMethodSummary = {
  __typename?: 'PaymentMethodSummary';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export enum PaymentMethodType {
  Ach = 'ACH',
  Cash = 'Cash',
  CashappVenmo = 'CashappVenmo',
  Check = 'Check',
  CreditCard = 'CreditCard',
  CreditCardOffline = 'CreditCardOffline',
  Other = 'Other',
  WireTransfer = 'WireTransfer'
}

export type PaymentProcessedEvent = TripEvent & {
  __typename?: 'PaymentProcessedEvent';
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  transactionId?: Maybe<Scalars['UUID']>;
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export enum PaymentProcessor {
  BrainTree = 'BRAIN_TREE',
  CardConnect = 'CARD_CONNECT',
  Square = 'SQUARE',
  Stripe = 'STRIPE'
}

export enum PhoneTypeEnum {
  Cell = 'CELL',
  Home = 'HOME',
  Other = 'OTHER',
  Primary = 'PRIMARY',
  Work = 'WORK'
}

export type PlacePrediction = {
  __typename?: 'PlacePrediction';
  placeId?: Maybe<Scalars['String']>;
  placeName?: Maybe<Scalars['String']>;
};

export type PredictionInput = {
  bias?: InputMaybe<CoordsInput>;
  query: Scalars['String'];
};

export type ProcessPayment = {
  paymentMethodId?: InputMaybe<Scalars['UUID']>;
  tripId: Scalars['UUID'];
};

export enum ProductType {
  CapitalDrive = 'CAPITAL_DRIVE',
  Savoya = 'SAVOYA'
}

export enum ProviderAccountSource {
  Savoya = 'SAVOYA'
}

export enum ProviderType {
  CapitalDrive = 'CAPITAL_DRIVE',
  Savoya = 'SAVOYA'
}

export type PublicShareableInfo = {
  __typename?: 'PublicShareableInfo';
  amount?: Maybe<Scalars['Float']>;
  company?: Maybe<Scalars['String']>;
  destination?: Maybe<TripWaypoint>;
  distanceInMiles?: Maybe<Scalars['Float']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  message?: Maybe<Scalars['String']>;
  origin?: Maybe<TripWaypoint>;
  originalTripId?: Maybe<Scalars['String']>;
  originalTripNumber?: Maybe<Scalars['String']>;
  originalTripStatus?: Maybe<TripStatus>;
  passengerCount?: Maybe<Scalars['Int']>;
  paymentMethodType?: Maybe<PaymentMethodType>;
  pickupTime?: Maybe<Scalars['DateTime']>;
  preferredVehicleClass?: Maybe<Scalars['String']>;
  receivedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<SharedTripStatus>;
  tripOwner?: Maybe<Contact>;
};

export type Query = {
  __typename?: 'Query';
  _default?: Maybe<Scalars['String']>;
  accountAdjustments: AccountAdjustmentQueries;
  accountDefaultNotifications: AccountDefaultNotificationsQueries;
  accounts: AccountQueries;
  airlines: AirlineQueries;
  bookings: BookingQueries;
  changeLogs: ChangeLogQueries;
  clientPaymentProcessorByClientId?: Maybe<ClientPaymentProcessorRecord>;
  clientQueries?: Maybe<ClientsQueries>;
  companyQueries?: Maybe<CompanyQueries>;
  contacts: ContactQueries;
  customerContacts: CustomerContactQueries;
  customerRateSets: CustomerRateSetQueries;
  customers: CustomerQueries;
  driverQueries?: Maybe<DriversQueries>;
  drivers: DriverQueries;
  favoriteDrivers: FavoriteDriverQueries;
  fbos: FboQueries;
  garages: GarageQueries;
  getStream?: Maybe<GetstreamQueries>;
  invoices: InvoiceQueries;
  lineItems: LineItemQueries;
  locations: LocationQueries;
  markets: MarketQueries;
  media?: Maybe<MediaQueries>;
  networkInvitations: NetworkInvitationQueries;
  networkRelationships: NetworkRelationshipQueries;
  paymentMethods: PaymentMethodQueries;
  ratePolicies: RatePolicyQueries;
  rateSets: RateSetQueries;
  rateTypes: RateTypeQueries;
  rates: RateQueries;
  sharedTrips: SharedTripQueries;
  square?: Maybe<SquareQueries>;
  stripe?: Maybe<StripeQueries>;
  subscriptionAddons?: Maybe<Array<SubscriptionAddon>>;
  subscriptionAddonsByCode?: Maybe<SubscriptionAddon>;
  subscriptionAddonsByTier?: Maybe<SubscriptionAddon>;
  subscriptionByAccountId?: Maybe<SubscriptionRecord>;
  subscriptionById?: Maybe<SubscriptionRecord>;
  subscriptionFindOrCreate?: Maybe<SubscriptionRecord>;
  subscriptionInvoiceById?: Maybe<SubscriptionInvoice>;
  subscriptionInvoicesByAccountId?: Maybe<Array<SubscriptionInvoice>>;
  subscriptionInvoicesById?: Maybe<Array<SubscriptionInvoice>>;
  subscriptionTierByCode?: Maybe<SubscriptionTier>;
  subscriptionTiersByProduct?: Maybe<Array<SubscriptionTier>>;
  systemVehicleClasses: SystemVehicleClassQueries;
  todoSpecs: TodoSpecQueries;
  todos: TodoQueries;
  transactions: TransactionQueries;
  tripAddons: TripAddonQueries;
  tripContacts: TripContactQueries;
  tripNotes: TripNoteQueries;
  tripNotificationAttempts: TripNotificationAttemptQueries;
  tripNotificationSubscriptions: TripNotificationSubscriptionQueries;
  tripNotificationTypes: TripNotificationTypeQueries;
  tripRules: TripRuleQueries;
  tripSegments: TripSegmentQueries;
  tripStatusTimestamps: TripStatusTimestampQueries;
  tripWaypoints: TripWaypointQueries;
  trips: TripQueries;
  userIdentities: UserIdentityQueries;
  usersQueries?: Maybe<UserQueries>;
  vehicleClassOverrides: VehicleClassOverrideQueries;
  vehicleClassQueries?: Maybe<VehicleClassQueryResolvers>;
  vehicleClasses: VehicleClassQueries;
  vehicleMakes: VehicleMakeQueries;
  vehicleModels: VehicleModelQueries;
  vehicleQueries?: Maybe<VehicleQueryResolvers>;
  vehicleSensorReadings: VehicleSensorReadingQueries;
  vehicles: VehicleQueries;
  vendorsQueries?: Maybe<VendorsQueries>;
};


export type QueryClientPaymentProcessorByClientIdArgs = {
  clientId: Scalars['UUID'];
  paymentProcessor: PaymentProcessor;
};


export type QuerySubscriptionAddonsByCodeArgs = {
  code: AddonCode;
};


export type QuerySubscriptionAddonsByTierArgs = {
  tierType: TierType;
};


export type QuerySubscriptionByAccountIdArgs = {
  accountId?: InputMaybe<Scalars['UUID']>;
  accountName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  selectedTier?: InputMaybe<TierType>;
};


export type QuerySubscriptionByIdArgs = {
  id: Scalars['UUID'];
};


export type QuerySubscriptionFindOrCreateArgs = {
  accountId?: InputMaybe<Scalars['UUID']>;
  accountName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  selectedTier?: InputMaybe<TierType>;
};


export type QuerySubscriptionInvoiceByIdArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QuerySubscriptionInvoicesByAccountIdArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QuerySubscriptionInvoicesByIdArgs = {
  accountId?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
};


export type QuerySubscriptionTierByCodeArgs = {
  code: TierCode;
};


export type QuerySubscriptionTiersByProductArgs = {
  productType: ProductType;
};

export type Rate = AccountEntity & {
  __typename?: 'Rate';
  account: Account;
  accountId: Scalars['UUID'];
  amount?: Maybe<Scalars['Float']>;
  calculation?: Maybe<RateCalculation>;
  createdAt: Scalars['TimestampWithTimezone'];
  defaultRate?: Maybe<Scalars['Boolean']>;
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isPerVehicle: Scalars['Boolean'];
  meteredBillingStrategy?: Maybe<MeteredBillingStrategy>;
  meteredRateIncrement?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  ratePolicies: Array<RatePolicy>;
  rateSet: RateSet;
  rateSetId: Scalars['UUID'];
  rateType: RateType;
  rateTypeId: Scalars['UUID'];
  revertToDynamicForExcessWaitTime?: Maybe<Scalars['Boolean']>;
  revertToDynamicForUnquotedStops?: Maybe<Scalars['Boolean']>;
  targetRateGroup?: Maybe<RateGroup>;
  updatedAt: Scalars['TimestampWithTimezone'];
  vehicleClassOverrides: Array<VehicleClassOverride>;
  version: Scalars['Int'];
};

export enum RateCalculation {
  Flat = 'Flat',
  PerHour = 'PerHour',
  Percentage = 'Percentage'
}

export enum RateCategory {
  Addon = 'Addon',
  Base = 'Base',
  Discount = 'Discount',
  FeePassthrough = 'FeePassthrough',
  Gratuity = 'Gratuity',
  Surcharge = 'Surcharge',
  Tax = 'Tax'
}

export type RateCollectionResult = {
  __typename?: 'RateCollectionResult';
  items: Array<Rate>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export enum RateGroup {
  Base = 'Base',
  Subtotal = 'Subtotal',
  Total = 'Total'
}

export type RatePolicy = {
  __typename?: 'RatePolicy';
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  feePercentage?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  rate: Rate;
  rateId: Scalars['UUID'];
  thresholdValue?: Maybe<Scalars['Float']>;
  thresholdValue2?: Maybe<Scalars['Float']>;
  type: RatePolicyType;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type RatePolicyCollectionResult = {
  __typename?: 'RatePolicyCollectionResult';
  items: Array<RatePolicy>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type RatePolicyQueries = {
  __typename?: 'RatePolicyQueries';
  all: RatePolicyCollectionResult;
  byId?: Maybe<RatePolicy>;
};


export type RatePolicyQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type RatePolicyQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export enum RatePolicyType {
  AirportWaitTime = 'AirportWaitTime',
  Cancellation = 'Cancellation',
  GarageTime = 'GarageTime',
  MinimumCharge = 'MinimumCharge',
  WaitTime = 'WaitTime'
}

export type RateQueries = {
  __typename?: 'RateQueries';
  all: RateCollectionResult;
  byId?: Maybe<Rate>;
  forTrip: AppliedRates;
  ratesForBooking: Array<Maybe<VehicleClassRateForBooking>>;
  search: RateSetCollectionResult;
  searchDefaultRates: RateSetCollectionResult;
  searchTransferRates: RateSetCollectionResult;
};


export type RateQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type RateQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type RateQueriesForTripArgs = {
  tripId: Scalars['UUID'];
};


export type RateQueriesRatesForBookingArgs = {
  bookingToken: Scalars['String'];
  tripForm: InsertTrip;
};


export type RateQueriesSearchArgs = {
  accountId: Scalars['UUID'];
  criteria: RateSearchCriteria;
  customerContactId?: InputMaybe<Scalars['UUID']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type RateQueriesSearchDefaultRatesArgs = {
  accountId: Scalars['UUID'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type RateQueriesSearchTransferRatesArgs = {
  accountId: Scalars['UUID'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type RateSearchCriteria = {
  fromLocation: RateSearchLocation;
  stops?: InputMaybe<Scalars['Int']>;
  toLocation: RateSearchLocation;
  tripDate: Scalars['DateTime'];
};

export type RateSearchLocation = {
  coordinates: Scalars['Coordinates'];
  placeId: Scalars['String'];
};

export type RateSet = AccountEntity & {
  __typename?: 'RateSet';
  account: Account;
  accountId: Scalars['UUID'];
  createdAt: Scalars['TimestampWithTimezone'];
  customers: Array<CustomerRateSet>;
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isCustomerRate?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  rates: Array<Rate>;
  tripRule?: Maybe<TripRule>;
  tripRuleId?: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type RateSetCollectionResult = {
  __typename?: 'RateSetCollectionResult';
  items: Array<RateSet>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type RateSetQueries = {
  __typename?: 'RateSetQueries';
  all: RateSetCollectionResult;
  byId?: Maybe<RateSet>;
  findByIds?: Maybe<Array<Maybe<RateSet>>>;
};


export type RateSetQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type RateSetQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type RateSetQueriesFindByIdsArgs = {
  rateSetIds: Array<InputMaybe<Scalars['UUID']>>;
};

export type RateType = AccountEntity & {
  __typename?: 'RateType';
  account: Account;
  accountAdjustment: Array<AccountAdjustment>;
  accountId: Scalars['UUID'];
  category: RateCategory;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  description?: Maybe<Scalars['String']>;
  favorite?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  rates: Array<Rate>;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type RateTypeCollectionResult = {
  __typename?: 'RateTypeCollectionResult';
  items: Array<RateType>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type RateTypeQueries = {
  __typename?: 'RateTypeQueries';
  all: RateTypeCollectionResult;
  byId?: Maybe<RateType>;
};


export type RateTypeQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type RateTypeQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type ReassignmentRequested = {
  tripId: Scalars['UUID'];
};

export type RecordTransaction = {
  amount: Scalars['Float'];
  method: PaymentMethodType;
  note?: InputMaybe<Scalars['String']>;
  tripId: Scalars['UUID'];
  type: TransactionType;
};

export type RefreshUserResponse = {
  __typename?: 'RefreshUserResponse';
  link?: Maybe<Scalars['String']>;
};

export type RefundAppliedEvent = TripEvent & {
  __typename?: 'RefundAppliedEvent';
  amountRefunded: Scalars['Float'];
  id: Scalars['UUID'];
  note: Scalars['String'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type RelatedTrip = {
  __typename?: 'RelatedTrip';
  estimatedAvailabilityTime: Scalars['DateTime'];
  estimatedOnLocationTime: Scalars['DateTime'];
  id: Scalars['UUID'];
  tripNumber: Scalars['String'];
  tripTime: Scalars['DateTime'];
};

export type RelationOptions = {
  cascade?: InputMaybe<Scalars['Boolean']>;
  nullable?: InputMaybe<Scalars['Boolean']>;
  onDelete?: InputMaybe<Scalars['String']>;
  onUpdate?: InputMaybe<Scalars['String']>;
};

export type RequestNetworkConfirmation = {
  tripId: Scalars['UUID'];
  vendorExternalId?: InputMaybe<Scalars['UUID']>;
};

export type ResendVerificaitonEmailResult = {
  __typename?: 'ResendVerificaitonEmailResult';
  created_at?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  type?: Maybe<Scalars['String']>;
};

export type ResetSavoyaSharedTrip = {
  tripId: Scalars['UUID'];
  vendorExternalId?: InputMaybe<Scalars['UUID']>;
};

export type ResolveTodoResult = MutationResult & {
  __typename?: 'ResolveTodoResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type RevokeNetworkSharedTrip = {
  tripId: Scalars['UUID'];
  vendorExternalId?: InputMaybe<Scalars['UUID']>;
};

export type RevokeShareTripFromVendorArgs = {
  tripId: Scalars['UUID'];
  vendorId: Scalars['String'];
};

export type RevokeSquareTokenResponse = MutationResult & {
  __typename?: 'RevokeSquareTokenResponse';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type RollbackPayment = {
  tripId: Scalars['UUID'];
};

export type RollbackToOnsite = {
  location?: InputMaybe<TripCommandLocation>;
  tripId: Scalars['UUID'];
};

export type SavoyaPassengerInput = {
  displayName: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  guests?: InputMaybe<Scalars['Float']>;
  lead?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export enum SavoyaSharedTripStatus {
  Cancelled = 'Cancelled',
  CancelledAndConfirmed = 'CancelledAndConfirmed',
  Expired = 'Expired',
  ModPending = 'ModPending',
  Pending = 'Pending'
}

export type SendQuote = {
  tripId: Scalars['UUID'];
};

export enum SensorReadingSource {
  CapitalDrive = 'CAPITAL_DRIVE',
  Savoya = 'SAVOYA'
}

export type SetVehicleAvailabilityResult = MutationResult & {
  __typename?: 'SetVehicleAvailabilityResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type ShareTripWithVendorArgs = {
  amount: Scalars['Float'];
  email?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  paymentMethodType: PaymentMethodType;
  savoyaStatus?: InputMaybe<SavoyaSharedTripStatus>;
  tripId: Scalars['UUID'];
  vendorId: Scalars['String'];
};

export type SharedTrip = {
  __typename?: 'SharedTrip';
  amount: Scalars['Float'];
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  networkRelationship?: Maybe<NetworkRelationship>;
  networkRelationshipId?: Maybe<Scalars['UUID']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodId?: Maybe<Scalars['UUID']>;
  paymentMethodType: PaymentMethodType;
  resentAt?: Maybe<Scalars['DateTime']>;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  savoyaAssignmentStatus?: Maybe<SavoyaSharedTripStatus>;
  savoyaAvailableTrip?: Maybe<Scalars['Boolean']>;
  savoyaQuotedTime?: Maybe<Scalars['Float']>;
  sentAt: Scalars['DateTime'];
  status: SharedTripStatus;
  token: Scalars['String'];
  trip: Trip;
  tripId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  vendorExternalId?: Maybe<Scalars['UUID']>;
  version: Scalars['Int'];
};

export type SharedTripCollectionResult = {
  __typename?: 'SharedTripCollectionResult';
  items: Array<SharedTrip>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type SharedTripQueries = {
  __typename?: 'SharedTripQueries';
  all: SharedTripCollectionResult;
  allByTripId?: Maybe<Array<Maybe<SharedTrip>>>;
  byId?: Maybe<SharedTrip>;
  byOriginalTrip?: Maybe<SharedTrip>;
  byToken?: Maybe<SharedTrip>;
  byTripIdAndVendorId?: Maybe<SharedTrip>;
  getSavoyaAvailableTrips: SharedTripCollectionResult;
  publicDetails: PublicShareableInfo;
};


export type SharedTripQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type SharedTripQueriesAllByTripIdArgs = {
  tripId: Scalars['UUID'];
};


export type SharedTripQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type SharedTripQueriesByOriginalTripArgs = {
  tripId: Scalars['UUID'];
};


export type SharedTripQueriesByTokenArgs = {
  sharedTripToken: Scalars['UUID'];
};


export type SharedTripQueriesByTripIdAndVendorIdArgs = {
  tripId: Scalars['UUID'];
  vendorExternalId: Scalars['UUID'];
};


export type SharedTripQueriesGetSavoyaAvailableTripsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  syncWithSavoya?: InputMaybe<Scalars['Boolean']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type SharedTripQueriesPublicDetailsArgs = {
  sharedTripToken: Scalars['String'];
};

export enum SharedTripResponse {
  AwaitingAccountOnboarding = 'AwaitingAccountOnboarding',
  AwaitingUserIdentity = 'AwaitingUserIdentity',
  Error = 'Error',
  Success = 'Success'
}

export type SharedTripResult = {
  __typename?: 'SharedTripResult';
  errors?: Maybe<Array<MutationError>>;
  response?: Maybe<SharedTripResponse>;
  sharedTrip?: Maybe<SharedTrip>;
};

export enum SharedTripStatus {
  Accepted = 'Accepted',
  Billed = 'Billed',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Created = 'Created',
  Declined = 'Declined',
  Paid = 'Paid',
  Revoked = 'Revoked',
  Sent = 'Sent'
}

export type SignedUrl = {
  __typename?: 'SignedURL';
  key: Scalars['String'];
  metadata?: Maybe<FileMetadata>;
  url: Scalars['String'];
};

export type SignedUrlResponse = {
  __typename?: 'SignedUrlResponse';
  key: Scalars['String'];
  mimeType: Scalars['String'];
  signedUrl: Scalars['String'];
};

export type SimpleTripEvent = TripEvent & {
  __typename?: 'SimpleTripEvent';
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type SquareAddress = {
  __typename?: 'SquareAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressLine3?: Maybe<Scalars['String']>;
  administrativeDistrictLevel1?: Maybe<Scalars['String']>;
  administrativeDistrictLevel2?: Maybe<Scalars['String']>;
  administrativeDistrictLevel3?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  sublocality?: Maybe<Scalars['String']>;
  sublocality2?: Maybe<Scalars['String']>;
  sublocality3?: Maybe<Scalars['String']>;
};

export type SquareAddressInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  addressLine3?: InputMaybe<Scalars['String']>;
  administrativeDistrictLevel1?: InputMaybe<Scalars['String']>;
  administrativeDistrictLevel2?: InputMaybe<Scalars['String']>;
  administrativeDistrictLevel3?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  locality?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  sublocality?: InputMaybe<Scalars['String']>;
  sublocality2?: InputMaybe<Scalars['String']>;
  sublocality3?: InputMaybe<Scalars['String']>;
};

export type SquareCard = {
  __typename?: 'SquareCard';
  billingAddress?: Maybe<SquareAddress>;
  bin?: Maybe<Scalars['String']>;
  cardBrand?: Maybe<Scalars['String']>;
  cardCoBrand?: Maybe<Scalars['String']>;
  cardType?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  expMonth?: Maybe<Scalars['Int']>;
  expYear?: Maybe<Scalars['Int']>;
  fingerprint?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last4?: Maybe<Scalars['String']>;
  merchantId?: Maybe<Scalars['String']>;
  prepaidType?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type SquareCardInput = {
  billingAddress?: InputMaybe<SquareAddressInput>;
  cardholderName?: InputMaybe<Scalars['String']>;
  customerId: Scalars['String'];
  expMonth?: InputMaybe<Scalars['Int']>;
  expYear?: InputMaybe<Scalars['Int']>;
  referenceId?: InputMaybe<Scalars['String']>;
  version?: InputMaybe<Scalars['Int']>;
};

export type SquareCustomer = {
  __typename?: 'SquareCustomer';
  birthday?: Maybe<Scalars['String']>;
  cards?: Maybe<Array<Maybe<SquareCard>>>;
  companyName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  creationSource?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  referenceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type SquareMerchant = {
  __typename?: 'SquareMerchant';
  businessName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  mainLocationId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type SquareQueries = {
  __typename?: 'SquareQueries';
  getSquareAuthTokenLink: GetSquareAuthTokenResponse;
  getSquareCards: Array<Maybe<SquareCard>>;
  getSquareMerchant?: Maybe<SquareMerchant>;
  searchSquareCustomers?: Maybe<Array<Maybe<SquareCustomer>>>;
  verifySquareToken?: Maybe<Scalars['Boolean']>;
};


export type SquareQueriesGetSquareCardsArgs = {
  squareCardFilters: GetSquareCardsInput;
};


export type SquareQueriesSearchSquareCustomersArgs = {
  referenceId?: InputMaybe<Scalars['String']>;
};

export type StartPaymentMethodSetupResponse = MutationResult & {
  __typename?: 'StartPaymentMethodSetupResponse';
  clientSecret?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<MutationError>>;
  stripeSetupIntentId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type StripeQueries = {
  __typename?: 'StripeQueries';
  getRefreshLink?: Maybe<RefreshUserResponse>;
  getSetupClientIdForTrip?: Maybe<GetSetupClientIdForTripResponse>;
};


export type StripeQueriesGetRefreshLinkArgs = {
  accountId: Scalars['UUID'];
};


export type StripeQueriesGetSetupClientIdForTripArgs = {
  tripId: Scalars['UUID'];
};

export type SubmitTripRequest = {
  tripId: Scalars['UUID'];
};

export type SubscriptionAddon = {
  __typename?: 'SubscriptionAddon';
  amount: Scalars['BigInt'];
  code: AddonCode;
  currency: CurrencyCode;
  freeQty: Scalars['Int'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  tier?: Maybe<SubscriptionTier>;
  tierId: Scalars['String'];
  type: AddonType;
};

export type SubscriptionInvoice = {
  __typename?: 'SubscriptionInvoice';
  amount: Scalars['BigInt'];
  approved?: Maybe<Scalars['Boolean']>;
  attemptCount?: Maybe<Scalars['Int']>;
  closed?: Maybe<Scalars['Boolean']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: CurrencyCode;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['BigInt']>;
  dueAt?: Maybe<Scalars['DateTime']>;
  externalURL?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  invoiceLines?: Maybe<Array<SubscriptionInvoiceLine>>;
  invoiceNumber: Scalars['String'];
  nextAttemptAt?: Maybe<Scalars['DateTime']>;
  paid?: Maybe<Scalars['Boolean']>;
  paidAt?: Maybe<Scalars['DateTime']>;
  paymentProcessedBy?: Maybe<PaymentProcessor>;
  pdfURL?: Maybe<Scalars['String']>;
  periodEndAt?: Maybe<Scalars['DateTime']>;
  periodStartAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  subscription?: Maybe<SubscriptionRecord>;
  subscriptionId?: Maybe<Scalars['UUID']>;
  tier?: Maybe<SubscriptionTier>;
  tierId?: Maybe<Scalars['UUID']>;
  total: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionInvoiceLine = {
  __typename?: 'SubscriptionInvoiceLine';
  addon?: Maybe<SubscriptionAddon>;
  addonId?: Maybe<Scalars['UUID']>;
  amount: Scalars['BigInt'];
  createdAt?: Maybe<Scalars['DateTime']>;
  currency: CurrencyCode;
  description?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['BigInt']>;
  id: Scalars['UUID'];
  lineNumber: Scalars['Int'];
  qty: Scalars['Int'];
  total: Scalars['BigInt'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SubscriptionRecord = {
  __typename?: 'SubscriptionRecord';
  accountId: Scalars['String'];
  addonUsage?: Maybe<AddonUsageRecord>;
  cancelled?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  clientSecret?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentTier: TierType;
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  inTrialPeriod?: Maybe<Scalars['Boolean']>;
  paymentMethod?: Maybe<PaymentMethodRecord>;
  periodEndAt?: Maybe<Scalars['DateTime']>;
  periodStartAt?: Maybe<Scalars['DateTime']>;
  productType: ProductType;
  renewalAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<SubscriptionStatus>;
  tier?: Maybe<SubscriptionTier>;
  tierId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum SubscriptionStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Incomplete = 'INCOMPLETE',
  IncompleteExpired = 'INCOMPLETE_EXPIRED',
  PastDue = 'PAST_DUE',
  Paused = 'PAUSED',
  Trialing = 'TRIALING',
  Unpaid = 'UNPAID'
}

export type SubscriptionTier = {
  __typename?: 'SubscriptionTier';
  addons?: Maybe<Array<SubscriptionAddon>>;
  amount: Scalars['BigInt'];
  code: TierCode;
  currency: CurrencyCode;
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: ProductType;
  trialPeriodDays: Scalars['Int'];
  type: TierType;
};

export enum SystemClass {
  Bus = 'BUS',
  Greeter = 'GREETER',
  Other = 'OTHER',
  Sedan = 'SEDAN',
  SedanLuxury = 'SEDAN_LUXURY',
  Suv = 'SUV',
  SClass = 'S_CLASS',
  Van = 'VAN'
}

export type SystemVehicleClass = {
  __typename?: 'SystemVehicleClass';
  createdAt: Scalars['TimestampWithTimezone'];
  defaultCostMultiplier: Scalars['Float'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['TimestampWithTimezone'];
  vehicleClasses: Array<Maybe<VehicleClass>>;
  version: Scalars['Int'];
};

export type SystemVehicleClassCollectionResult = {
  __typename?: 'SystemVehicleClassCollectionResult';
  items: Array<SystemVehicleClass>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type SystemVehicleClassQueries = {
  __typename?: 'SystemVehicleClassQueries';
  all: SystemVehicleClassCollectionResult;
  byId?: Maybe<SystemVehicleClass>;
};


export type SystemVehicleClassQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type SystemVehicleClassQueriesByIdArgs = {
  id: Scalars['String'];
};

export enum TierCode {
  CapitalDriveFreeTier = 'CAPITAL_DRIVE_FREE_TIER',
  CapitalDrivePlatinumTier = 'CAPITAL_DRIVE_PLATINUM_TIER',
  CapitalDrivePremiumTier = 'CAPITAL_DRIVE_PREMIUM_TIER'
}

export enum TierType {
  Free = 'FREE',
  Platinum = 'PLATINUM',
  Premium = 'PREMIUM',
  SavoyaVendor = 'SAVOYA_VENDOR'
}

export type TimeZonesResult = {
  __typename?: 'TimeZonesResult';
  dstOffset: Scalars['Float'];
  rawOffset: Scalars['Float'];
  status: Scalars['String'];
  timeZoneId: Scalars['String'];
  timeZoneName: Scalars['String'];
};

export type Todo = {
  __typename?: 'Todo';
  account: Account;
  accountId: Scalars['UUID'];
  actionUrl?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  effectiveDate: Scalars['DateTime'];
  entityId: Scalars['UUID'];
  entityType: Scalars['String'];
  expirationDate?: Maybe<Scalars['DateTime']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  infoText?: Maybe<Scalars['String']>;
  priority: TodoPriority;
  resolvedAt?: Maybe<Scalars['DateTime']>;
  resolvedBy?: Maybe<Contact>;
  resolvedById?: Maybe<Scalars['UUID']>;
  spec?: Maybe<TodoSpec>;
  specId?: Maybe<Scalars['UUID']>;
  status: TodoStatus;
  title: Scalars['String'];
  type: TodoType;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export enum TodoActivationType {
  EntityChange = 'EntityChange',
  Manual = 'Manual'
}

export type TodoCollectionResult = {
  __typename?: 'TodoCollectionResult';
  items: Array<Todo>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export enum TodoPriority {
  High = 'High',
  Low = 'Low',
  Normal = 'Normal',
  Urgent = 'Urgent'
}

export type TodoQueries = {
  __typename?: 'TodoQueries';
  active: TodoCollectionResult;
  all: TodoCollectionResult;
  byId?: Maybe<Todo>;
};


export type TodoQueriesActiveArgs = {
  accountId: Scalars['UUID'];
  asOfDate?: InputMaybe<Scalars['DateTime']>;
};


export type TodoQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type TodoQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type TodoSpec = {
  __typename?: 'TodoSpec';
  account?: Maybe<Account>;
  accountId?: Maybe<Scalars['UUID']>;
  actionUrlTemplate?: Maybe<Scalars['String']>;
  activationRule?: Maybe<Scalars['String']>;
  activationType: TodoActivationType;
  bodyTemplate?: Maybe<Scalars['String']>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  dueInDays?: Maybe<Scalars['Int']>;
  effectiveInDays?: Maybe<Scalars['Int']>;
  entityType: Scalars['String'];
  expiresInDays?: Maybe<Scalars['Int']>;
  iconUrlTemplate?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  infoTextTemplate?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  priority: TodoPriority;
  titleTemplate: Scalars['String'];
  type: TodoType;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type TodoSpecCollectionResult = {
  __typename?: 'TodoSpecCollectionResult';
  items: Array<TodoSpec>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TodoSpecQueries = {
  __typename?: 'TodoSpecQueries';
  all: TodoSpecCollectionResult;
  byId?: Maybe<TodoSpec>;
};


export type TodoSpecQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type TodoSpecQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export enum TodoStatus {
  Active = 'Active',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Dismissed = 'Dismissed'
}

export enum TodoType {
  Alert = 'Alert',
  Task = 'Task'
}

export type TokenResult = {
  __typename?: 'TokenResult';
  token: Scalars['String'];
};

export type Transaction = AccountEntity & {
  __typename?: 'Transaction';
  account: Account;
  accountId: Scalars['UUID'];
  amount: Scalars['Float'];
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  invoice?: Maybe<Invoice>;
  invoiceId?: Maybe<Scalars['UUID']>;
  note?: Maybe<Scalars['String']>;
  paymentMethod: PaymentMethod;
  paymentMethodId?: Maybe<Scalars['UUID']>;
  paymentMethodType: PaymentMethodType;
  refundedAmount?: Maybe<Scalars['Float']>;
  reversalOfTransaction?: Maybe<Transaction>;
  reversalOfTransactionId?: Maybe<Scalars['UUID']>;
  squarePaymentId?: Maybe<Scalars['String']>;
  status: TransactionStatus;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  type: TransactionType;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type TransactionAppliedEvent = TripEvent & {
  __typename?: 'TransactionAppliedEvent';
  id: Scalars['UUID'];
  invoiceId?: Maybe<Scalars['UUID']>;
  timestamp: Scalars['Timestamp'];
  transactionId: Scalars['UUID'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId: Scalars['UUID'];
};

export type TransactionCollectionResult = {
  __typename?: 'TransactionCollectionResult';
  items: Array<Transaction>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TransactionFailedEvent = TripEvent & {
  __typename?: 'TransactionFailedEvent';
  failureReason: Scalars['String'];
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  transactionId: Scalars['UUID'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type TransactionItemSummary = {
  __typename?: 'TransactionItemSummary';
  amount: Scalars['Float'];
  createdAt: Scalars['String'];
  id: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<PaymentMethodSummary>;
  paymentMethodType: PaymentMethodType;
  refundedAmount?: Maybe<Scalars['Float']>;
  status: TransactionStatus;
  stripePaymentIntentId?: Maybe<Scalars['String']>;
  type: TransactionType;
};

export type TransactionQueries = {
  __typename?: 'TransactionQueries';
  all: TransactionCollectionResult;
  byId?: Maybe<Transaction>;
};


export type TransactionQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type TransactionQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export enum TransactionStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Succeeded = 'Succeeded'
}

export enum TransactionType {
  Adjustment = 'Adjustment',
  Authorization = 'Authorization',
  Payment = 'Payment',
  Refund = 'Refund'
}

export enum TransportStatus {
  AtStop = 'AtStop',
  EnRoute = 'EnRoute'
}

export type Trip = {
  __typename?: 'Trip';
  account: Account;
  accountId: Scalars['UUID'];
  addons: Array<TripAddon>;
  assignedAt?: Maybe<Scalars['DateTime']>;
  availableCommands: Array<TripCommandMeta>;
  /** Base Rate Override */
  baseRateOverride?: Maybe<Scalars['Float']>;
  bookingToolTrip?: Maybe<Scalars['Boolean']>;
  cancellationReason?: Maybe<TripCancellationReason>;
  cancellationReasonNotes?: Maybe<Scalars['String']>;
  closedAt?: Maybe<Scalars['DateTime']>;
  /** Confirmation Email Sent */
  confirmationEmailStatus: TripConfirmationEmailStatus;
  createdAt: Scalars['TimestampWithTimezone'];
  currentOrNextWaypoint?: Maybe<TripWaypoint>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['UUID']>;
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  driver?: Maybe<GenericDriver>;
  driverId?: Maybe<Scalars['UUID']>;
  dropoffGarageTimeOverride?: Maybe<Scalars['Float']>;
  dropoffWaypoint?: Maybe<TripWaypoint>;
  estimatedAvailabilityTime?: Maybe<Scalars['DateTime']>;
  estimatedDistanceInMiles?: Maybe<Scalars['Float']>;
  estimatedDurationInMinutes?: Maybe<Scalars['Float']>;
  estimatedDurationInMinutesOverride?: Maybe<Scalars['Float']>;
  estimatedOnLocationTime?: Maybe<Scalars['DateTime']>;
  estimatedRevenue?: Maybe<Scalars['Float']>;
  estimatedSpotTimeInMinutes?: Maybe<Scalars['Int']>;
  flatRateOverride?: Maybe<Scalars['Float']>;
  groundworkTrip?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  invoice?: Maybe<Invoice>;
  invoicePaidAt?: Maybe<Scalars['DateTime']>;
  invoicedAt?: Maybe<Scalars['DateTime']>;
  invoices: Array<Invoice>;
  /** Directed Trips Properties */
  isDirected?: Maybe<Scalars['Boolean']>;
  /** Trip Sharing */
  isShared?: Maybe<Scalars['Boolean']>;
  luggageCount?: Maybe<Scalars['Int']>;
  monitoringToken?: Maybe<Scalars['String']>;
  notes: Array<TripNote>;
  overrideDropoffWaypointDetails?: Maybe<Scalars['Boolean']>;
  passengerCount?: Maybe<Scalars['Int']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodId?: Maybe<Scalars['UUID']>;
  paymentMethodType?: Maybe<PaymentMethodType>;
  /** Billing overrides */
  pickupGarageTimeOverride?: Maybe<Scalars['Float']>;
  pickupTime?: Maybe<Scalars['DateTime']>;
  pickupWaitTimeOverride?: Maybe<Scalars['Float']>;
  pickupWaypoint?: Maybe<TripWaypoint>;
  preferredVehicleClass?: Maybe<GenericVehicleClass>;
  preferredVehicleClassId?: Maybe<Scalars['UUID']>;
  /**
   * The external id of the trip in the provider system
   * It can be a UUID, a string or a number
   */
  providerExternalId?: Maybe<Scalars['String']>;
  providerSource?: Maybe<TripProviderSource>;
  quote?: Maybe<Invoice>;
  rateData?: Maybe<Scalars['JSON']>;
  rateSnapshot?: Maybe<AppliedRateDefinitions>;
  readyForAssignmentAt?: Maybe<Scalars['DateTime']>;
  referenceNumber?: Maybe<Scalars['String']>;
  segments: Array<TripSegment>;
  sharedAvailableCommands: Array<TripCommandMeta>;
  sharedTrip?: Maybe<SharedTrip>;
  stagingNotes?: Maybe<Scalars['String']>;
  stateData?: Maybe<Scalars['JSON']>;
  status: TripStatus;
  stripeSetupIntentId?: Maybe<Scalars['String']>;
  timestamps: Array<TripStatusTimestamp>;
  transportStatus: TransportStatus;
  tripNumber?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['TimestampWithTimezone'];
  vehicle?: Maybe<GenericVehicle>;
  vehicleId?: Maybe<Scalars['UUID']>;
  vehicleSensorReadings: Array<VehicleSensorReading>;
  version: Scalars['Int'];
  wasBookedByPassenger?: Maybe<Scalars['Boolean']>;
  waypoints: Array<TripWaypoint>;
};

export type TripAddon = {
  __typename?: 'TripAddon';
  calculation?: Maybe<AdjustmentCalculation>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  rateType: RateType;
  rateTypeId: Scalars['UUID'];
  total: Scalars['Float'];
  trip: Trip;
  tripId: Scalars['UUID'];
  unitPrice: Scalars['Float'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type TripAddonCollectionResult = {
  __typename?: 'TripAddonCollectionResult';
  items: Array<TripAddon>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TripAddonQueries = {
  __typename?: 'TripAddonQueries';
  byId?: Maybe<TripAddon>;
};


export type TripAddonQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type TripAssignedEvent = TripEvent & {
  __typename?: 'TripAssignedEvent';
  driverId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId: Scalars['UUID'];
  vehicleId?: Maybe<Scalars['UUID']>;
};

export enum TripCancellationReason {
  CustomerCancelled = 'CustomerCancelled',
  CustomerNoShow = 'CustomerNoShow',
  NoAvailability = 'NoAvailability',
  Other = 'Other'
}

export type TripCancelledEvent = TripEvent & {
  __typename?: 'TripCancelledEvent';
  id: Scalars['UUID'];
  notes?: Maybe<Scalars['String']>;
  reason: TripCancellationReason;
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId: Scalars['UUID'];
};

export type TripClientInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  guests?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPrimary: Scalars['Boolean'];
  role: ClientRole;
  tripId: Scalars['UUID'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type TripClientRecord = {
  __typename?: 'TripClientRecord';
  client?: Maybe<ClientRecord>;
  clientId: Scalars['UUID'];
  guests?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  isPrimary: Scalars['Boolean'];
  role: ClientRole;
  tripId: Scalars['UUID'];
};

export type TripCollectionResult = {
  __typename?: 'TripCollectionResult';
  items: Array<Trip>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TripCommandLocation = {
  latitude?: InputMaybe<Scalars['Float']>;
  locationOverride?: InputMaybe<Scalars['Boolean']>;
  longitude?: InputMaybe<Scalars['Float']>;
};

export type TripCommandMeta = {
  __typename?: 'TripCommandMeta';
  description?: Maybe<Scalars['String']>;
  disabled?: Maybe<Scalars['Boolean']>;
  events: Array<TripEventType>;
  hidden: Scalars['Boolean'];
  isPrimary?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  typeName: Scalars['String'];
};

export type TripCommandResult = {
  __typename?: 'TripCommandResult';
  changes?: Maybe<ChangeLogResult>;
  errors?: Maybe<Array<Scalars['String']>>;
  events?: Maybe<Array<TripEvent>>;
  succeeded: Scalars['Boolean'];
  trip?: Maybe<Trip>;
};

export enum TripCompletionStatus {
  AllActive = 'AllActive',
  Closed = 'Closed',
  Complete = 'Complete',
  CompleteOrClosed = 'CompleteOrClosed',
  Confirmed = 'Confirmed',
  Draft = 'Draft',
  InProcess = 'InProcess',
  Unassigned = 'Unassigned',
  Upcoming = 'Upcoming'
}

export enum TripConfirmationEmailStatus {
  Send = 'Send',
  Sent = 'Sent',
  Unsent = 'Unsent'
}

export type TripContact = {
  __typename?: 'TripContact';
  contact?: Maybe<Contact>;
  contactId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['TimestampWithTimezone'];
  customerContact: CustomerContact;
  customerContactId: Scalars['UUID'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isPrimaryPassenger?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notificationSubscriptions: Array<TripNotificationSubscription>;
  overrideCustomerContactInfo?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role: CustomerRole;
  stripeCustomerId?: Maybe<Scalars['String']>;
  trip: Trip;
  tripId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type TripContactCollectionResult = {
  __typename?: 'TripContactCollectionResult';
  items: Array<TripContact>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TripContactQueries = {
  __typename?: 'TripContactQueries';
  all: TripContactCollectionResult;
  byId?: Maybe<TripContact>;
};


export type TripContactQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  tripId: Scalars['UUID'];
};


export type TripContactQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type TripEvent = {
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export enum TripEventType {
  AddTripWaypoint = 'AddTripWaypoint',
  ArriveDropoff = 'ArriveDropoff',
  ArriveGarage = 'ArriveGarage',
  ArrivePickup = 'ArrivePickup',
  ArriveStop = 'ArriveStop',
  BaseRateOverriden = 'BaseRateOverriden',
  ChangeConfirmed = 'ChangeConfirmed',
  ChangeRequested = 'ChangeRequested',
  Circling = 'Circling',
  DepartDropoff = 'DepartDropoff',
  DepartPickup = 'DepartPickup',
  DepartStop = 'DepartStop',
  EnRouteToPickup = 'EnRouteToPickup',
  FlatRateApplied = 'FlatRateApplied',
  FlightChanged = 'FlightChanged',
  GarageTimeOverridden = 'GarageTimeOverridden',
  InvoiceDeliveryRequested = 'InvoiceDeliveryRequested',
  InvoicePaid = 'InvoicePaid',
  InvoiceSubmitted = 'InvoiceSubmitted',
  InvoiceUpdated = 'InvoiceUpdated',
  NetworkConfirmationFailed = 'NetworkConfirmationFailed',
  NetworkConfirmationReceived = 'NetworkConfirmationReceived',
  NetworkConfirmationReceivedWithoutAssignment = 'NetworkConfirmationReceivedWithoutAssignment',
  NetworkConfirmationRequested = 'NetworkConfirmationRequested',
  NetworkOfferAccepted = 'NetworkOfferAccepted',
  NetworkOfferAcceptedWithoutAssignmnent = 'NetworkOfferAcceptedWithoutAssignmnent',
  NetworkOfferFailed = 'NetworkOfferFailed',
  NetworkSharedTripRevoked = 'NetworkSharedTripRevoked',
  NewTripStarted = 'NewTripStarted',
  OfferedToNetwork = 'OfferedToNetwork',
  PaymentMethodCreated = 'PaymentMethodCreated',
  PaymentMethodSet = 'PaymentMethodSet',
  PaymentMethodSetupBegun = 'PaymentMethodSetupBegun',
  PaymentProcessed = 'PaymentProcessed',
  QuoteAccepted = 'QuoteAccepted',
  QuoteExpired = 'QuoteExpired',
  QuoteSent = 'QuoteSent',
  ReassignmentRequested = 'ReassignmentRequested',
  RefundApplied = 'RefundApplied',
  ResetSavoyaSharedTrip = 'ResetSavoyaSharedTrip',
  RollbackPayment = 'RollbackPayment',
  RollbackToOnsite = 'RollbackToOnsite',
  TransactionApplied = 'TransactionApplied',
  TransactionFailed = 'TransactionFailed',
  TripAssigned = 'TripAssigned',
  TripCancelled = 'TripCancelled',
  TripClosed = 'TripClosed',
  TripOfferedToNetwork = 'TripOfferedToNetwork',
  TripPreparationStarted = 'TripPreparationStarted',
  TripReminder = 'TripReminder',
  TripRequestCreated = 'TripRequestCreated',
  TripRevenueChanged = 'TripRevenueChanged',
  TripStatusForced = 'TripStatusForced',
  TripTimestampCorrected = 'TripTimestampCorrected',
  WaitTimeOverriden = 'WaitTimeOverriden',
  Waiting = 'Waiting'
}

export type TripItineraryUpdatedResult = {
  __typename?: 'TripItineraryUpdatedResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  trip?: Maybe<Trip>;
};

export type TripNote = {
  __typename?: 'TripNote';
  author?: Maybe<Contact>;
  authorId?: Maybe<Scalars['UUID']>;
  content: Scalars['String'];
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['UUID'];
  time: Scalars['Timestamp'];
  trip?: Maybe<Trip>;
  tripId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type TripNoteCollectionResult = {
  __typename?: 'TripNoteCollectionResult';
  items: Array<TripNote>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TripNoteQueries = {
  __typename?: 'TripNoteQueries';
  all: TripNoteCollectionResult;
  byId?: Maybe<TripNote>;
};


export type TripNoteQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  tripId: Scalars['UUID'];
};


export type TripNoteQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type TripNotificationAttempt = {
  __typename?: 'TripNotificationAttempt';
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['UUID'];
  payload?: Maybe<Scalars['JSON']>;
  provider: NotificationProvider;
  response?: Maybe<Scalars['String']>;
  responseCode?: Maybe<Scalars['String']>;
  result: DeliveryResult;
  subscription: TripNotificationSubscription;
  subscriptionId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type TripNotificationAttemptCollectionResult = {
  __typename?: 'TripNotificationAttemptCollectionResult';
  items: Array<TripNotificationAttempt>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TripNotificationAttemptQueries = {
  __typename?: 'TripNotificationAttemptQueries';
  all: TripNotificationAttemptCollectionResult;
  byId?: Maybe<TripNotificationAttempt>;
};


export type TripNotificationAttemptQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type TripNotificationAttemptQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type TripNotificationSubscription = {
  __typename?: 'TripNotificationSubscription';
  channels: Array<MessageChannel>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['UUID'];
  notificationType: TripNotificationType;
  notificationTypeId: Scalars['UUID'];
  tripContactId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type TripNotificationSubscriptionCollectionResult = {
  __typename?: 'TripNotificationSubscriptionCollectionResult';
  items: Array<TripNotificationSubscription>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TripNotificationSubscriptionQueries = {
  __typename?: 'TripNotificationSubscriptionQueries';
  all: TripNotificationSubscriptionCollectionResult;
  byId?: Maybe<TripNotificationSubscription>;
  byTripClientId: TripNotificationSubscriptionCollectionResult;
  byType: TripNotificationSubscriptionCollectionResult;
};


export type TripNotificationSubscriptionQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type TripNotificationSubscriptionQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type TripNotificationSubscriptionQueriesByTripClientIdArgs = {
  tripClientId: Scalars['UUID'];
};


export type TripNotificationSubscriptionQueriesByTypeArgs = {
  eventType: TripEventType;
  tripId: Scalars['UUID'];
};

export type TripNotificationType = {
  __typename?: 'TripNotificationType';
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  enabled?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  order: Scalars['Int'];
  trigger: TripEventType;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type TripNotificationTypeCollectionResult = {
  __typename?: 'TripNotificationTypeCollectionResult';
  items: Array<TripNotificationType>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TripNotificationTypeQueries = {
  __typename?: 'TripNotificationTypeQueries';
  all: TripNotificationTypeCollectionResult;
  byId?: Maybe<TripNotificationType>;
  publicAll: TripNotificationTypeCollectionResult;
};


export type TripNotificationTypeQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type TripNotificationTypeQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type TripNotificationTypeQueriesPublicAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type TripOfferedToNetworkEvent = TripEvent & {
  __typename?: 'TripOfferedToNetworkEvent';
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type TripOrderBy = {
  pickupTime: OrderByDirection;
};

export enum TripProviderSource {
  Savoya = 'SAVOYA'
}

export type TripQueries = {
  __typename?: 'TripQueries';
  accountMonitoringSummary: MonitoringSummary;
  all: TripCollectionResult;
  availableDrivers: AvailableDrivers;
  availableVehicles: AvailableVehicles;
  byId?: Maybe<Trip>;
  findOneActive?: Maybe<Trip>;
  getExpiringQuoteIds: Array<Scalars['String']>;
  getSharedTrips: TripCollectionResult;
  monitoringSummary: MonitoringSummary;
  search: TripCollectionResult;
  searchByFlightAwareAlertId: TripCollectionResult;
  searchByNumber: TripCollectionResult;
  searchIndexed: TripCollectionResult;
};


export type TripQueriesAccountMonitoringSummaryArgs = {
  tripId: Scalars['UUID'];
};


export type TripQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type TripQueriesAvailableDriversArgs = {
  criteria: AvailableDriverCriteria;
};


export type TripQueriesAvailableVehiclesArgs = {
  criteria: AvailableDriverCriteria;
};


export type TripQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type TripQueriesFindOneActiveArgs = {
  tripIds: Array<Scalars['UUID']>;
};


export type TripQueriesGetSharedTripsArgs = {
  accountId: Scalars['UUID'];
  filter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TripOrderBy>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TripQueriesMonitoringSummaryArgs = {
  monitoringToken: Scalars['String'];
};


export type TripQueriesSearchArgs = {
  accountId: Scalars['UUID'];
  filter: TripSearchCriteria;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TripOrderBy>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type TripQueriesSearchByFlightAwareAlertIdArgs = {
  alertId: Scalars['Int'];
};


export type TripQueriesSearchByNumberArgs = {
  accountId?: InputMaybe<Scalars['UUID']>;
  query: Scalars['String'];
};


export type TripQueriesSearchIndexedArgs = {
  accountId: Scalars['UUID'];
  filter?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TripOrderBy>;
  skip?: InputMaybe<Scalars['Int']>;
};

export type TripReminderRequested = {
  rangeMinutes: Scalars['Int'];
};

export type TripReminderRequestedEvent = TripEvent & {
  __typename?: 'TripReminderRequestedEvent';
  contacts: Array<Contact>;
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type TripRevenueChangedEvent = TripEvent & {
  __typename?: 'TripRevenueChangedEvent';
  from: Scalars['Float'];
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  to: Scalars['Float'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type TripRule = {
  __typename?: 'TripRule';
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  endTime?: Maybe<Scalars['DateTime']>;
  firstLocation?: Maybe<Location>;
  firstLocationId?: Maybe<Scalars['UUID']>;
  firstLocationMatchType?: Maybe<LocationMatchType>;
  id: Scalars['UUID'];
  maxStops?: Maybe<Scalars['Int']>;
  rateSet: RateSet;
  secondLocation?: Maybe<Location>;
  secondLocationId?: Maybe<Scalars['UUID']>;
  secondLocationMatchType?: Maybe<LocationMatchType>;
  startTime?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type TripRuleCollectionResult = {
  __typename?: 'TripRuleCollectionResult';
  items: Array<TripRule>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TripRuleQueries = {
  __typename?: 'TripRuleQueries';
  all: TripRuleCollectionResult;
  byId?: Maybe<TripRule>;
};


export type TripRuleQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type TripRuleQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type TripSearchCriteria = {
  completionStatus?: InputMaybe<TripCompletionStatus>;
  customerContactId?: InputMaybe<Scalars['UUID']>;
  customerId?: InputMaybe<Scalars['UUID']>;
  driverId?: InputMaybe<Scalars['UUID']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  providerExternalId?: InputMaybe<Scalars['String']>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  savoyaSharedTripStatuses?: InputMaybe<Array<SavoyaSharedTripStatus>>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  statuses?: InputMaybe<Array<TripStatus>>;
  vehicleId?: InputMaybe<Scalars['UUID']>;
};

export type TripSegment = {
  __typename?: 'TripSegment';
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  distanceInMiles?: Maybe<Scalars['Float']>;
  durationInMinutes?: Maybe<Scalars['Float']>;
  endWaypoint?: Maybe<TripWaypoint>;
  endWaypointId?: Maybe<Scalars['UUID']>;
  estimatedDistanceInMiles?: Maybe<Scalars['Float']>;
  estimatedDurationInMinutes?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  order: Scalars['Int'];
  startWaypoint?: Maybe<TripWaypoint>;
  startWaypointId?: Maybe<Scalars['UUID']>;
  trip: Trip;
  tripId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type TripSegmentCollectionResult = {
  __typename?: 'TripSegmentCollectionResult';
  items: Array<TripSegment>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TripSegmentQueries = {
  __typename?: 'TripSegmentQueries';
  all: TripSegmentCollectionResult;
  byId?: Maybe<TripSegment>;
};


export type TripSegmentQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type TripSegmentQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export enum TripStatus {
  AwaitingAssignment = 'AwaitingAssignment',
  Billed = 'Billed',
  Cancelled = 'Cancelled',
  Circling = 'Circling',
  Closed = 'Closed',
  Confirmed = 'Confirmed',
  Draft = 'Draft',
  EnRouteToGarage = 'EnRouteToGarage',
  EnRouteToPickup = 'EnRouteToPickup',
  NetworkUnavailable = 'NetworkUnavailable',
  OfferedToNetwork = 'OfferedToNetwork',
  OnLocation = 'OnLocation',
  Paid = 'Paid',
  PassengerOnboard = 'PassengerOnboard',
  PendingChangeRequest = 'PendingChangeRequest',
  PendingNetworkConfirmation = 'PendingNetworkConfirmation',
  Preparing = 'Preparing',
  Quoted = 'Quoted',
  TransportComplete = 'TransportComplete',
  TripComplete = 'TripComplete',
  Waiting = 'Waiting'
}

export type TripStatusForcedEvent = TripEvent & {
  __typename?: 'TripStatusForcedEvent';
  id: Scalars['UUID'];
  newStatus: TripStatus;
  previousStatus: TripStatus;
  timestamp: Scalars['Timestamp'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId: Scalars['UUID'];
};

export enum TripStatusTimeCorrectionReason {
  BillingAdjustment = 'BillingAdjustment',
  IncorrectTimestamp = 'IncorrectTimestamp',
  Other = 'Other'
}

export type TripStatusTimestamp = {
  __typename?: 'TripStatusTimestamp';
  correctedBy?: Maybe<Contact>;
  correctedById?: Maybe<Scalars['UUID']>;
  correctedTime?: Maybe<Scalars['DateTime']>;
  correctionNote?: Maybe<Scalars['String']>;
  correctionReason?: Maybe<TripStatusTimeCorrectionReason>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  effectiveTime?: Maybe<Scalars['DateTime']>;
  estimatedTime?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  recordedBy?: Maybe<Contact>;
  recordedById?: Maybe<Scalars['UUID']>;
  recordedTime?: Maybe<Scalars['DateTime']>;
  status: TripStatus;
  trip: Trip;
  tripId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type TripStatusTimestampCollectionResult = {
  __typename?: 'TripStatusTimestampCollectionResult';
  items: Array<TripStatusTimestamp>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TripStatusTimestampQueries = {
  __typename?: 'TripStatusTimestampQueries';
  byId?: Maybe<TripStatusTimestamp>;
};


export type TripStatusTimestampQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type TripTimestampCorrectedEvent = TripEvent & {
  __typename?: 'TripTimestampCorrectedEvent';
  from?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  reason: TripStatusTimeCorrectionReason;
  status: TripStatus;
  timestamp: Scalars['Timestamp'];
  timestampId: Scalars['UUID'];
  to: Scalars['DateTime'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type TripWaypoint = {
  __typename?: 'TripWaypoint';
  airline?: Maybe<Airline>;
  airlineId?: Maybe<Scalars['UUID']>;
  arrivalTime?: Maybe<Scalars['DateTime']>;
  arrivingSegment?: Maybe<TripSegment>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  departingSegment?: Maybe<TripSegment>;
  departureTime?: Maybe<Scalars['DateTime']>;
  durationInMinutes?: Maybe<Scalars['Float']>;
  estimatedArrivalTime?: Maybe<Scalars['DateTime']>;
  estimatedDepartureTime?: Maybe<Scalars['DateTime']>;
  estimatedDurationInMinutes?: Maybe<Scalars['Float']>;
  fbo?: Maybe<Fbo>;
  fboId?: Maybe<Scalars['UUID']>;
  flightAwareAlertId?: Maybe<Scalars['Int']>;
  flightNumber?: Maybe<Scalars['String']>;
  flightTime?: Maybe<Scalars['DateTime']>;
  flightType?: Maybe<FlightType>;
  iataCode?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  location: Location;
  locationId: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  order: Scalars['Int'];
  role: TripWaypointRole;
  savoyaStop?: Maybe<Scalars['JSON']>;
  /** Sync Flight Time */
  syncFlightTime?: Maybe<Scalars['Boolean']>;
  syncFlightTimeDelayInMinutes?: Maybe<Scalars['Float']>;
  trip: Trip;
  tripId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  verifiedFlight?: Maybe<Scalars['JSON']>;
  verifiedFlightId?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};

export type TripWaypointCollectionResult = {
  __typename?: 'TripWaypointCollectionResult';
  items: Array<TripWaypoint>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type TripWaypointQueries = {
  __typename?: 'TripWaypointQueries';
  all: TripWaypointCollectionResult;
  byId?: Maybe<TripWaypoint>;
};


export type TripWaypointQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type TripWaypointQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export enum TripWaypointRole {
  Dropoff = 'Dropoff',
  Garage = 'Garage',
  Pickup = 'Pickup',
  Stop = 'Stop'
}

export type UnavailablePeriod = {
  __typename?: 'UnavailablePeriod';
  /** The availability status of this period. Must be Committed or OffDuty. */
  availability: DriverAvailability;
  /** When this availability period ends. The last period will not have an end date, meaning there are no future commitments and, except for any repeating blackount windows, the driver is available for all trips after the start date. */
  endTime?: Maybe<Scalars['DateTime']>;
  /** When this availability period begins */
  startTime: Scalars['DateTime'];
  /** For committed periods, the trip to which this period is committed */
  trip?: Maybe<RelatedTrip>;
};

export type UpdateAccount = {
  activeCardProcessor?: InputMaybe<CreditCardProcessor>;
  bodilyInjuryPerAccident?: InputMaybe<Scalars['Float']>;
  bodilyInjuryPerPerson?: InputMaybe<Scalars['Float']>;
  bookingToken?: InputMaybe<Scalars['String']>;
  bookingToolEnabled?: InputMaybe<Scalars['Boolean']>;
  childSeat?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  displayRatesInBookingTool?: InputMaybe<Scalars['Boolean']>;
  established?: InputMaybe<Scalars['TimestampWithTimezone']>;
  externalId?: InputMaybe<Scalars['UUID']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  instagramUrl?: InputMaybe<Scalars['String']>;
  insuranceCombinedSingleLimitPerAccident?: InputMaybe<Scalars['Float']>;
  isFavorite?: InputMaybe<Scalars['Boolean']>;
  isInternal?: InputMaybe<Scalars['Boolean']>;
  legalName?: InputMaybe<Scalars['String']>;
  licensesAndCertifications?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  petPolicy?: InputMaybe<Scalars['String']>;
  primaryEmailAddress?: InputMaybe<Scalars['String']>;
  primaryPhoneNumber?: InputMaybe<Scalars['String']>;
  propertyDamagePerAccident?: InputMaybe<Scalars['Float']>;
  providerAccount?: InputMaybe<ProviderAccountSource>;
  salesPitch?: InputMaybe<Scalars['String']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']>>;
  squareAccessToken?: InputMaybe<Scalars['String']>;
  squareMerchantId?: InputMaybe<Scalars['String']>;
  squareRefreshToken?: InputMaybe<Scalars['String']>;
  squareTokenExpiresAt?: InputMaybe<Scalars['String']>;
  stripeAccountCanCharge?: InputMaybe<Scalars['Boolean']>;
  stripeAccountId?: InputMaybe<Scalars['String']>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  venmoHandle?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  workersCompensantionLiabilityCoverage?: InputMaybe<Scalars['Boolean']>;
  yearsInBusiness?: InputMaybe<Scalars['Int']>;
  zelleHandle?: InputMaybe<Scalars['String']>;
};

export type UpdateAccountAdjustment = {
  accountId?: InputMaybe<Scalars['UUID']>;
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Float']>;
  calculation?: InputMaybe<AdjustmentCalculation>;
  id: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
  rateTypeId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateAccountAdjustmentResult = MutationResult & {
  __typename?: 'UpdateAccountAdjustmentResult';
  accountAdjustment?: Maybe<AccountAdjustment>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type UpdateAccountDefaultNotifications = {
  accountId?: InputMaybe<Scalars['UUID']>;
  channels?: InputMaybe<Array<MessageChannel>>;
  customerRole?: InputMaybe<CustomerRole>;
  customerType?: InputMaybe<CustomerType>;
  id: Scalars['UUID'];
  tripNotificationTypeId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateAccountDefaultNotificationsResult = MutationResult & {
  __typename?: 'UpdateAccountDefaultNotificationsResult';
  accountDefaultNotifications?: Maybe<AccountDefaultNotifications>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type UpdateAccountResult = MutationResult & {
  __typename?: 'UpdateAccountResult';
  account?: Maybe<Account>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type UpdateAirline = {
  IATA?: InputMaybe<Scalars['String']>;
  ICAO?: InputMaybe<Scalars['String']>;
  callsign?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  hub?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateAirlineResult = MutationResult & {
  __typename?: 'UpdateAirlineResult';
  airline?: Maybe<Airline>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type UpdateBooking = {
  accountId?: InputMaybe<Scalars['UUID']>;
  contactId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<BookingStatus>;
  token?: InputMaybe<Scalars['String']>;
  tripId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateBookingResult = MutationResult & {
  __typename?: 'UpdateBookingResult';
  booking?: Maybe<Booking>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type UpdateConfirmationStatusResult = MutationResult & {
  __typename?: 'UpdateConfirmationStatusResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type UpdateContact = {
  accountId?: InputMaybe<Scalars['UUID']>;
  addresses?: InputMaybe<Array<AddressInput>>;
  analyticsToken?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<LocationCategory>;
  contactType?: InputMaybe<ContactType>;
  email?: InputMaybe<Scalars['String']>;
  firebaseToken?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userRole?: InputMaybe<UserRole>;
};

export type UpdateContactNote = {
  contactId: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
};

export type UpdateContactNoteResult = MutationResult & {
  __typename?: 'UpdateContactNoteResult';
  errors?: Maybe<Array<MutationError>>;
  note?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpdateContactResult = MutationResult & {
  __typename?: 'UpdateContactResult';
  contact?: Maybe<Contact>;
  errors?: Maybe<Array<MutationError>>;
  existingContact?: Maybe<Contact>;
  success: Scalars['Boolean'];
};

export type UpdateCustomer = {
  accountId?: InputMaybe<Scalars['UUID']>;
  discount?: InputMaybe<Scalars['Float']>;
  id: Scalars['UUID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  stripeCustomerId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CustomerType>;
};

export type UpdateCustomerResult = MutationResult & {
  __typename?: 'UpdateCustomerResult';
  customer?: Maybe<Customer>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type UpdateDriver = {
  accountId?: InputMaybe<Scalars['UUID']>;
  contactId?: InputMaybe<Scalars['UUID']>;
  drivingSince?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<Scalars['UUID']>;
  garageId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  marketingDescription?: InputMaybe<Scalars['String']>;
  profileImageUrl?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
};

export type UpdateDriverExternalId = {
  externalId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
};

export type UpdateDriverExternalIdResult = MutationResult & {
  __typename?: 'UpdateDriverExternalIdResult';
  driver?: Maybe<Driver>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type UpdateDriverResult = MutationResult & {
  __typename?: 'UpdateDriverResult';
  driver?: Maybe<Driver>;
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
};

export type UpdateEstimatedRevenueIfRequired = {
  tripId: Scalars['UUID'];
};

export type UpdateFbo = {
  fbo_address?: InputMaybe<Scalars['String']>;
  fbo_name?: InputMaybe<Scalars['String']>;
  fbo_postal_code?: InputMaybe<Scalars['String']>;
  iata_code?: InputMaybe<Scalars['String']>;
  icao_code?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export type UpdateFboResult = MutationResult & {
  __typename?: 'UpdateFboResult';
  errors?: Maybe<Array<MutationError>>;
  fbo?: Maybe<Fbo>;
  success: Scalars['Boolean'];
};

export type UpdateGarage = {
  accountId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateGarageResult = MutationResult & {
  __typename?: 'UpdateGarageResult';
  errors?: Maybe<Array<MutationError>>;
  garage?: Maybe<Garage>;
  success: Scalars['Boolean'];
};

export type UpdateGarageWithLocation = {
  id: Scalars['UUID'];
  location?: InputMaybe<OwnedLocationInput>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateLocation = {
  abbreviation?: InputMaybe<Scalars['String']>;
  accountId?: InputMaybe<Scalars['UUID']>;
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<LocationCategory>;
  city?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['UUID']>;
  coordinates?: InputMaybe<Scalars['Coordinates']>;
  country?: InputMaybe<Scalars['String']>;
  garageId?: InputMaybe<Scalars['UUID']>;
  geoType?: InputMaybe<AreaType>;
  id: Scalars['UUID'];
  marketId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  placeCategory?: InputMaybe<Scalars['String']>;
  placeFoursquareId?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  placeName?: InputMaybe<Scalars['String']>;
  placeType?: InputMaybe<Scalars['String']>;
  placeWikidataId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  radiusInKm?: InputMaybe<Scalars['Float']>;
  state?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
  zoneType?: InputMaybe<ZoneType>;
};

export type UpdateLocationResult = MutationResult & {
  __typename?: 'UpdateLocationResult';
  errors?: Maybe<Array<MutationError>>;
  location?: Maybe<Location>;
  success: Scalars['Boolean'];
};

export type UpdateMarket = {
  abbreviation?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateMarketResult = MutationResult & {
  __typename?: 'UpdateMarketResult';
  errors?: Maybe<Array<MutationError>>;
  market?: Maybe<Market>;
  success: Scalars['Boolean'];
};

export type UpdateNetworkInvitation = {
  accountId?: InputMaybe<Scalars['UUID']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  fromContactId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  message?: InputMaybe<Scalars['String']>;
  relationshipId?: InputMaybe<Scalars['UUID']>;
  resentAt?: InputMaybe<Scalars['DateTime']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<NetworkInvitationStatus>;
  toContactId?: InputMaybe<Scalars['UUID']>;
  toEmail?: InputMaybe<Scalars['String']>;
  toName?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

export type UpdateNetworkInvitationResult = MutationResult & {
  __typename?: 'UpdateNetworkInvitationResult';
  errors?: Maybe<Array<MutationError>>;
  networkInvitation?: Maybe<NetworkInvitation>;
  success: Scalars['Boolean'];
};

export type UpdateNetworkRelationship = {
  accountId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  invitationId?: InputMaybe<Scalars['UUID']>;
  isReciprocal?: InputMaybe<Scalars['Boolean']>;
  toAccountId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateNetworkRelationshipResult = MutationResult & {
  __typename?: 'UpdateNetworkRelationshipResult';
  errors?: Maybe<Array<MutationError>>;
  networkRelationship?: Maybe<NetworkRelationship>;
  success: Scalars['Boolean'];
};

export type UpdateRate = {
  accountId?: InputMaybe<Scalars['UUID']>;
  amount?: InputMaybe<Scalars['Float']>;
  calculation?: InputMaybe<RateCalculation>;
  defaultRate?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isPerVehicle?: InputMaybe<Scalars['Boolean']>;
  meteredBillingStrategy?: InputMaybe<MeteredBillingStrategy>;
  meteredRateIncrement?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  rateSetId?: InputMaybe<Scalars['UUID']>;
  rateTypeId?: InputMaybe<Scalars['UUID']>;
  revertToDynamicForExcessWaitTime?: InputMaybe<Scalars['Boolean']>;
  revertToDynamicForUnquotedStops?: InputMaybe<Scalars['Boolean']>;
  targetRateGroup?: InputMaybe<RateGroup>;
};

export type UpdateRatePolicy = {
  feePercentage?: InputMaybe<Scalars['Float']>;
  id: Scalars['UUID'];
  rateId?: InputMaybe<Scalars['UUID']>;
  thresholdValue?: InputMaybe<Scalars['Float']>;
  thresholdValue2?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<RatePolicyType>;
};

export type UpdateRatePolicyResult = MutationResult & {
  __typename?: 'UpdateRatePolicyResult';
  errors?: Maybe<Array<MutationError>>;
  ratePolicy?: Maybe<RatePolicy>;
  success: Scalars['Boolean'];
};

export type UpdateRateResult = MutationResult & {
  __typename?: 'UpdateRateResult';
  errors?: Maybe<Array<MutationError>>;
  rate?: Maybe<Rate>;
  success: Scalars['Boolean'];
};

export type UpdateRateSet = {
  accountId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isCustomerRate?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  tripRuleId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateRateSetResult = MutationResult & {
  __typename?: 'UpdateRateSetResult';
  errors?: Maybe<Array<MutationError>>;
  rateSet?: Maybe<RateSet>;
  success: Scalars['Boolean'];
};

export type UpdateRateType = {
  accountId?: InputMaybe<Scalars['UUID']>;
  category?: InputMaybe<RateCategory>;
  description?: InputMaybe<Scalars['String']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateRateTypeResult = MutationResult & {
  __typename?: 'UpdateRateTypeResult';
  errors?: Maybe<Array<MutationError>>;
  rateType?: Maybe<RateType>;
  success: Scalars['Boolean'];
};

export type UpdateSharedTrip = {
  amount?: InputMaybe<Scalars['Float']>;
  contactId?: InputMaybe<Scalars['UUID']>;
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  message?: InputMaybe<Scalars['String']>;
  networkRelationshipId?: InputMaybe<Scalars['UUID']>;
  paymentMethodId?: InputMaybe<Scalars['UUID']>;
  paymentMethodType?: InputMaybe<PaymentMethodType>;
  resentAt?: InputMaybe<Scalars['DateTime']>;
  resolvedAt?: InputMaybe<Scalars['DateTime']>;
  savoyaAssignmentStatus?: InputMaybe<SavoyaSharedTripStatus>;
  savoyaAvailableTrip?: InputMaybe<Scalars['Boolean']>;
  savoyaQuotedTime?: InputMaybe<Scalars['Float']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<SharedTripStatus>;
  token?: InputMaybe<Scalars['String']>;
  tripId?: InputMaybe<Scalars['UUID']>;
  vendorExternalId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateSharedTripResult = MutationResult & {
  __typename?: 'UpdateSharedTripResult';
  errors?: Maybe<Array<MutationError>>;
  sharedTrip?: Maybe<SharedTrip>;
  success: Scalars['Boolean'];
};

export type UpdateSystemVehicleClass = {
  defaultCostMultiplier?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSystemVehicleClassResult = MutationResult & {
  __typename?: 'UpdateSystemVehicleClassResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  systemVehicleClass?: Maybe<SystemVehicleClass>;
};

export type UpdateTodo = {
  accountId?: InputMaybe<Scalars['UUID']>;
  actionUrl?: InputMaybe<Scalars['String']>;
  body?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['DateTime']>;
  effectiveDate?: InputMaybe<Scalars['DateTime']>;
  entityId?: InputMaybe<Scalars['UUID']>;
  entityType?: InputMaybe<Scalars['String']>;
  expirationDate?: InputMaybe<Scalars['DateTime']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  infoText?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<TodoPriority>;
  resolvedAt?: InputMaybe<Scalars['DateTime']>;
  resolvedById?: InputMaybe<Scalars['UUID']>;
  specId?: InputMaybe<Scalars['UUID']>;
  status?: InputMaybe<TodoStatus>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TodoType>;
};

export type UpdateTodoResult = MutationResult & {
  __typename?: 'UpdateTodoResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  todo?: Maybe<Todo>;
};

export type UpdateTodoSpec = {
  accountId?: InputMaybe<Scalars['UUID']>;
  actionUrlTemplate?: InputMaybe<Scalars['String']>;
  activationRule?: InputMaybe<Scalars['String']>;
  activationType?: InputMaybe<TodoActivationType>;
  bodyTemplate?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  dueInDays?: InputMaybe<Scalars['Int']>;
  effectiveInDays?: InputMaybe<Scalars['Int']>;
  entityType?: InputMaybe<Scalars['String']>;
  expiresInDays?: InputMaybe<Scalars['Int']>;
  iconUrlTemplate?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  infoTextTemplate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<TodoPriority>;
  titleTemplate?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TodoType>;
};

export type UpdateTodoSpecResult = MutationResult & {
  __typename?: 'UpdateTodoSpecResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  todoSpec?: Maybe<TodoSpec>;
};

export type UpdateTransferRate = {
  accountId: Scalars['UUID'];
  amount?: InputMaybe<Scalars['Float']>;
  calculation?: InputMaybe<RateCalculation>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isPerVehicle?: InputMaybe<Scalars['Boolean']>;
  meteredBillingStrategy?: InputMaybe<MeteredBillingStrategy>;
  meteredRateIncrement?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  rateSetId: Scalars['UUID'];
  rateTypeId: Scalars['UUID'];
  revertToDynamicForExcessWaitTime?: InputMaybe<Scalars['Boolean']>;
  revertToDynamicForUnquotedStops?: InputMaybe<Scalars['Boolean']>;
  targetRateGroup?: InputMaybe<RateGroup>;
  vehicleClassOverride: Array<VehicleClassOverrideLite>;
};

export type UpdateTransferRateSet = {
  accountId: Scalars['UUID'];
  clients?: InputMaybe<Array<Scalars['UUID']>>;
  companies?: InputMaybe<Array<Scalars['UUID']>>;
  customers?: InputMaybe<Array<Scalars['UUID']>>;
  description?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  firstLocation?: InputMaybe<UpsertPlaceInput>;
  firstLocationGeoType?: InputMaybe<AreaType>;
  firstLocationId?: InputMaybe<Scalars['UUID']>;
  firstLocationMatchType?: InputMaybe<LocationMatchType>;
  firstLocationRadiusInKm?: InputMaybe<Scalars['Float']>;
  firstLocationZoneType?: InputMaybe<ZoneType>;
  id: Scalars['UUID'];
  maxStops?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  secondLocation?: InputMaybe<UpsertPlaceInput>;
  secondLocationGeoType?: InputMaybe<AreaType>;
  secondLocationId?: InputMaybe<Scalars['UUID']>;
  secondLocationMatchType?: InputMaybe<LocationMatchType>;
  secondLocationRadiusInKm?: InputMaybe<Scalars['Float']>;
  secondLocationZoneType?: InputMaybe<ZoneType>;
  startTime?: InputMaybe<Scalars['DateTime']>;
  tripRuleId: Scalars['UUID'];
  vehicleClassOverride: Array<VehicleClassOverrideLite>;
};

export type UpdateTrip = {
  accountId: Scalars['UUID'];
  bookingContact?: InputMaybe<CreateTripContactInput>;
  confirmationEmailStatus?: InputMaybe<TripConfirmationEmailStatus>;
  customerId?: InputMaybe<Scalars['UUID']>;
  distancesAndTime?: InputMaybe<Array<DistancesAndTime>>;
  driverId?: InputMaybe<Scalars['UUID']>;
  estimatedDurationInMinutesOverride?: InputMaybe<Scalars['Float']>;
  estimatedSpotTimeInMinutes?: InputMaybe<Scalars['Int']>;
  groundworkTrip?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  isDirected?: InputMaybe<Scalars['Boolean']>;
  luggageCount?: InputMaybe<Scalars['Int']>;
  newCompanyData?: InputMaybe<CreateTripCompanyInput>;
  passengerContact?: InputMaybe<CreateTripContactInput>;
  passengerCount?: InputMaybe<Scalars['Int']>;
  pickupTime?: InputMaybe<Scalars['DateTime']>;
  preferredVehicleClassId?: InputMaybe<Scalars['UUID']>;
  /**
   * The external id of the trip in the provider system
   * It can be a UUID, a string or a number
   */
  providerExternalId?: InputMaybe<Scalars['String']>;
  providerSource?: InputMaybe<TripProviderSource>;
  referenceNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<TripStatus>;
  submit?: InputMaybe<Scalars['Boolean']>;
  tripNumber?: InputMaybe<Scalars['Int']>;
  vehicleId?: InputMaybe<Scalars['UUID']>;
  wasBookedByPassenger?: InputMaybe<Scalars['Boolean']>;
  waypoints?: InputMaybe<Array<UpsertTripWaypointInput>>;
};

export type UpdateTripAddon = {
  calculation?: InputMaybe<AdjustmentCalculation>;
  id: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  rateTypeId?: InputMaybe<Scalars['UUID']>;
  total?: InputMaybe<Scalars['Float']>;
  tripId?: InputMaybe<Scalars['UUID']>;
  unitPrice?: InputMaybe<Scalars['Float']>;
};

export type UpdateTripAddonResult = MutationResult & {
  __typename?: 'UpdateTripAddonResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripAddon?: Maybe<TripAddon>;
};

export type UpdateTripClientRoleInput = {
  role: ClientRole;
  tripClientId: Scalars['UUID'];
};

export type UpdateTripContact = {
  accountId: Scalars['UUID'];
  customerContactId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
  existingContactId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  notificationSubscriptions?: InputMaybe<Array<InsertTripNotificationSubscription>>;
  overrideCustomerContactInfo?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<CustomerRole>;
  tripId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateTripContactResult = MutationResult & {
  __typename?: 'UpdateTripContactResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripContact?: Maybe<TripContact>;
};

export type UpdateTripNote = {
  authorId?: InputMaybe<Scalars['UUID']>;
  content?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  time?: InputMaybe<Scalars['Timestamp']>;
  tripId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateTripNoteResult = MutationResult & {
  __typename?: 'UpdateTripNoteResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripNote?: Maybe<TripNote>;
};

export type UpdateTripNotificationAttempt = {
  id: Scalars['UUID'];
  payload?: InputMaybe<Scalars['JSON']>;
  provider?: InputMaybe<NotificationProvider>;
  response?: InputMaybe<Scalars['String']>;
  responseCode?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<DeliveryResult>;
  subscriptionId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateTripNotificationAttemptResult = MutationResult & {
  __typename?: 'UpdateTripNotificationAttemptResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripNotificationAttempt?: Maybe<TripNotificationAttempt>;
};

export type UpdateTripNotificationSubscription = {
  channels?: InputMaybe<Array<MessageChannel>>;
  id: Scalars['UUID'];
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  tripContactId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateTripNotificationSubscriptionByTripClientId = {
  channels?: InputMaybe<Array<MessageChannel>>;
  notificationTypeId?: InputMaybe<Scalars['UUID']>;
  tripContactId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateTripNotificationSubscriptionResult = MutationResult & {
  __typename?: 'UpdateTripNotificationSubscriptionResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripNotificationSubscription?: Maybe<TripNotificationSubscription>;
};

export type UpdateTripNotificationSubscriptionsByTripClientResult = MutationResult & {
  __typename?: 'UpdateTripNotificationSubscriptionsByTripClientResult';
  errors?: Maybe<Array<MutationError>>;
  notificationSubscriptions?: Maybe<Array<TripNotificationSubscription>>;
  success: Scalars['Boolean'];
};

export type UpdateTripNotificationType = {
  enabled?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  trigger?: InputMaybe<TripEventType>;
};

export type UpdateTripNotificationTypeResult = MutationResult & {
  __typename?: 'UpdateTripNotificationTypeResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripNotificationType?: Maybe<TripNotificationType>;
};

export type UpdateTripRate = {
  newRateVehicleClassId: Scalars['UUID'];
  tripId: Scalars['UUID'];
};

export type UpdateTripRateResult = MutationResult & {
  __typename?: 'UpdateTripRateResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripAddOn?: Maybe<TripAddon>;
};

export type UpdateTripResult = MutationResult & {
  __typename?: 'UpdateTripResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  trip?: Maybe<Trip>;
};

export type UpdateTripRule = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  firstLocationId?: InputMaybe<Scalars['UUID']>;
  firstLocationMatchType?: InputMaybe<LocationMatchType>;
  id: Scalars['UUID'];
  maxStops?: InputMaybe<Scalars['Int']>;
  secondLocationId?: InputMaybe<Scalars['UUID']>;
  secondLocationMatchType?: InputMaybe<LocationMatchType>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateTripRuleResult = MutationResult & {
  __typename?: 'UpdateTripRuleResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  tripRule?: Maybe<TripRule>;
};

export type UpdateTripRuleWithLocation = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  firstLocation?: InputMaybe<UpsertPlaceInput>;
  firstLocationGeoType?: InputMaybe<AreaType>;
  firstLocationId?: InputMaybe<Scalars['UUID']>;
  firstLocationMatchType?: InputMaybe<LocationMatchType>;
  firstLocationRadiusInKm?: InputMaybe<Scalars['Int']>;
  firstLocationZoneType?: InputMaybe<ZoneType>;
  id: Scalars['UUID'];
  maxStops?: InputMaybe<Scalars['Int']>;
  secondLocation?: InputMaybe<UpsertPlaceInput>;
  secondLocationGeoType?: InputMaybe<AreaType>;
  secondLocationId?: InputMaybe<Scalars['UUID']>;
  secondLocationMatchType?: InputMaybe<LocationMatchType>;
  secondLocationRadiusInKm?: InputMaybe<Scalars['Int']>;
  secondLocationZoneType?: InputMaybe<ZoneType>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateTripWaypointInput = {
  airlineId?: InputMaybe<Scalars['UUID']>;
  fboId?: InputMaybe<Scalars['UUID']>;
  flightNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  place: UpsertPlaceInput;
  role: TripWaypointRole;
};

export type UpdateVehicle = {
  accountId?: InputMaybe<Scalars['UUID']>;
  availability?: InputMaybe<VehicleAvailability>;
  availabilityComments?: InputMaybe<Scalars['String']>;
  availabilityEstEndTime?: InputMaybe<Scalars['TimestampWithTimezone']>;
  availabilityStartTime?: InputMaybe<Scalars['TimestampWithTimezone']>;
  color: Scalars['String'];
  externalId?: InputMaybe<Scalars['UUID']>;
  garageId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  licenseNumber?: InputMaybe<Scalars['String']>;
  makeName: Scalars['String'];
  middleSeatType?: InputMaybe<VehicleMiddleSeatType>;
  modelId?: InputMaybe<Scalars['UUID']>;
  modelName: Scalars['String'];
  vehicleClassId?: InputMaybe<Scalars['UUID']>;
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Int']>;
};

export type UpdateVehicleClass = {
  accountId?: InputMaybe<Scalars['UUID']>;
  cancellationPolicyHours?: InputMaybe<Scalars['Int']>;
  externalId?: InputMaybe<Scalars['UUID']>;
  hourlyRate?: InputMaybe<Scalars['Float']>;
  id: Scalars['UUID'];
  imageUrl?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  luggageCount?: InputMaybe<Scalars['Int']>;
  minimumHours?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  passengerCount?: InputMaybe<Scalars['Int']>;
  systemClassId?: InputMaybe<Scalars['String']>;
  systemCreated?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateVehicleClassOverride = {
  amount?: InputMaybe<Scalars['Float']>;
  id: Scalars['UUID'];
  rateId?: InputMaybe<Scalars['UUID']>;
  vehicleClassId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateVehicleClassOverrideResult = MutationResult & {
  __typename?: 'UpdateVehicleClassOverrideResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicleClassOverride?: Maybe<VehicleClassOverride>;
};

export type UpdateVehicleClassResult = MutationResult & {
  __typename?: 'UpdateVehicleClassResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicleClass?: Maybe<VehicleClass>;
};

export type UpdateVehicleExternalId = {
  externalId?: InputMaybe<Scalars['UUID']>;
  id: Scalars['UUID'];
};

export type UpdateVehicleExternalIdResult = MutationResult & {
  __typename?: 'UpdateVehicleExternalIdResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicle?: Maybe<Vehicle>;
};

export type UpdateVehicleMake = {
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateVehicleMakeResult = MutationResult & {
  __typename?: 'UpdateVehicleMakeResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicleMake?: Maybe<VehicleMake>;
};

export type UpdateVehicleModel = {
  endYear?: InputMaybe<Scalars['Int']>;
  id: Scalars['UUID'];
  makeId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  startYear?: InputMaybe<Scalars['Int']>;
};

export type UpdateVehicleModelResult = MutationResult & {
  __typename?: 'UpdateVehicleModelResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicleModel?: Maybe<VehicleModel>;
};

export type UpdateVehicleResult = MutationResult & {
  __typename?: 'UpdateVehicleResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  vehicle?: Maybe<Vehicle>;
};

export type UpsertClientDiscountInput = {
  actionType: OpType;
  clientAccountId: Scalars['String'];
  discount: Scalars['Float'];
  rateSetId?: InputMaybe<Scalars['String']>;
};

export type UpsertClientDiscountResult = MutationResult & {
  __typename?: 'UpsertClientDiscountResult';
  errors?: Maybe<Array<MutationError>>;
  rateSetId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type UpsertCustomerDiscountInput = {
  actionType: OpType;
  customerAccountId: Scalars['String'];
  customerId: Scalars['String'];
  discount: Scalars['Float'];
};

export type UpsertCustomerDiscountResult = MutationResult & {
  __typename?: 'UpsertCustomerDiscountResult';
  errors?: Maybe<Array<MutationError>>;
  rateSetId?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** This is used when a an entity references a place from a geoproviders place search */
export type UpsertPlaceInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  coordinates: Scalars['Coordinates'];
  country?: InputMaybe<Scalars['String']>;
  placeCategory?: InputMaybe<Scalars['String']>;
  placeFoursquareId?: InputMaybe<Scalars['String']>;
  placeId?: InputMaybe<Scalars['String']>;
  placeName: Scalars['String'];
  placeType?: InputMaybe<Scalars['String']>;
  placeWikidataId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UpsertTripPassengerInput = {
  contactId?: InputMaybe<Scalars['UUID']>;
  customerContactId?: InputMaybe<Scalars['UUID']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpsertTripWaypointInput = {
  airlineId?: InputMaybe<Scalars['UUID']>;
  estimatedDurationInMinutes?: InputMaybe<Scalars['Float']>;
  fboId?: InputMaybe<Scalars['UUID']>;
  flightNumber?: InputMaybe<Scalars['String']>;
  flightTime?: InputMaybe<Scalars['DateTime']>;
  iataCode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  place?: InputMaybe<UpsertPlaceInput>;
  role: TripWaypointRole;
  savoyaStop?: InputMaybe<Scalars['JSON']>;
  syncFlightTime?: InputMaybe<Scalars['Boolean']>;
  syncFlightTimeDelayInMinutes?: InputMaybe<Scalars['Float']>;
  verifiedFlight?: InputMaybe<Scalars['JSON']>;
};

export type UseDifferentClassRate = {
  isTransfer: Scalars['Boolean'];
  rateId: Scalars['UUID'];
  requestedVehicleClassId: Scalars['UUID'];
  tripId: Scalars['UUID'];
};

export type UserCreateArgs = {
  email: Scalars['String'];
  externalId?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserIdentityRole>;
  skipCoreReplication?: InputMaybe<Scalars['Boolean']>;
  vendorId: Scalars['UUID'];
};

export type UserDeletedResult = {
  __typename?: 'UserDeletedResult';
  deleted: Scalars['Boolean'];
  id: Scalars['UUID'];
};

export type UserIdentity = {
  __typename?: 'UserIdentity';
  contact: Contact;
  contactId: Scalars['UUID'];
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  email?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['UUID']>;
  id: Scalars['String'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type UserIdentityCollectionResult = {
  __typename?: 'UserIdentityCollectionResult';
  items: Array<UserIdentity>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type UserIdentityQueries = {
  __typename?: 'UserIdentityQueries';
  all: UserIdentityCollectionResult;
  byId?: Maybe<UserIdentity>;
};


export type UserIdentityQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type UserIdentityQueriesByIdArgs = {
  id: Scalars['String'];
};

export enum UserIdentityRole {
  Accountant = 'ACCOUNTANT',
  AccountOwner = 'ACCOUNT_OWNER',
  Admin = 'ADMIN',
  ClientExperienceAgent = 'CLIENT_EXPERIENCE_AGENT',
  CustomerSuccessManager = 'CUSTOMER_SUCCESS_MANAGER',
  Driver = 'DRIVER',
  ExperienceManager = 'EXPERIENCE_MANAGER',
  Greeter = 'GREETER',
  Manager = 'MANAGER',
  Passenger = 'PASSENGER',
  SalesAgent = 'SALES_AGENT',
  TravelCoordinator = 'TRAVEL_COORDINATOR',
  Vendor = 'VENDOR',
  VendorAgent = 'VENDOR_AGENT'
}

export type UserQueries = {
  __typename?: 'UserQueries';
  getByExternalId?: Maybe<UserRecord>;
  getById?: Maybe<UserRecord>;
  getByName?: Maybe<Array<UserRecord>>;
  getByProductType?: Maybe<Array<UserRecord>>;
  getByUserRole?: Maybe<Array<UserRecord>>;
  getByVendorId?: Maybe<Array<UserRecord>>;
  getUserByToken?: Maybe<UserRecord>;
};


export type UserQueriesGetByExternalIdArgs = {
  authExternalId: Scalars['String'];
};


export type UserQueriesGetByIdArgs = {
  id: Scalars['UUID'];
};


export type UserQueriesGetByNameArgs = {
  name: Scalars['String'];
};


export type UserQueriesGetByProductTypeArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  orderBy?: InputMaybe<OrderByDirection>;
  productType?: InputMaybe<ProductType>;
  role?: InputMaybe<UserIdentityRole>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
  vendorId?: InputMaybe<Scalars['UUID']>;
};


export type UserQueriesGetByUserRoleArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  orderBy?: InputMaybe<OrderByDirection>;
  productType?: InputMaybe<ProductType>;
  role?: InputMaybe<UserIdentityRole>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
  vendorId?: InputMaybe<Scalars['UUID']>;
};


export type UserQueriesGetByVendorIdArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  orderBy?: InputMaybe<OrderByDirection>;
  productType?: InputMaybe<ProductType>;
  role?: InputMaybe<UserIdentityRole>;
  skip?: Scalars['Int'];
  take?: Scalars['Int'];
  vendorId?: InputMaybe<Scalars['UUID']>;
};

export type UserRecord = {
  __typename?: 'UserRecord';
  createdAt: Scalars['DateTime'];
  deleted: Scalars['DateTime'];
  email: Scalars['String'];
  externalId: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  identityProvider: IdentityProvider;
  isSavoyaUser?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  productType?: Maybe<Array<ProductType>>;
  role: UserIdentityRole;
  updatedAt: Scalars['DateTime'];
  vendorId?: Maybe<Scalars['UUID']>;
};

export enum UserRole {
  AccountOwner = 'AccountOwner',
  Administrator = 'Administrator',
  CapitalDrive = 'CapitalDrive',
  Customer = 'Customer',
  Driver = 'Driver',
  None = 'None',
  SuperAdministrator = 'SuperAdministrator',
  Viewer = 'Viewer'
}

export type UserUpdateArgs = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserIdentityRole>;
  skipCoreReplication?: InputMaybe<Scalars['Boolean']>;
  vendorId?: InputMaybe<Scalars['UUID']>;
};

export type Vehicle = AccountEntity & {
  __typename?: 'Vehicle';
  account: Account;
  accountId: Scalars['UUID'];
  availability: VehicleAvailability;
  availabilityComments?: Maybe<Scalars['String']>;
  availabilityEstEndTime?: Maybe<Scalars['TimestampWithTimezone']>;
  availabilityStartTime?: Maybe<Scalars['TimestampWithTimezone']>;
  color: Scalars['String'];
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  externalId?: Maybe<Scalars['UUID']>;
  garage?: Maybe<Garage>;
  garageId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isActive: Scalars['Boolean'];
  licenseNumber?: Maybe<Scalars['String']>;
  middleSeatType?: Maybe<VehicleMiddleSeatType>;
  model: VehicleModel;
  modelId: Scalars['UUID'];
  sensorReadings: Array<VehicleSensorReading>;
  updatedAt: Scalars['TimestampWithTimezone'];
  vehicleClass: VehicleClass;
  vehicleClassId: Scalars['UUID'];
  version: Scalars['Int'];
  vin?: Maybe<Scalars['String']>;
  year: Scalars['Int'];
};

export enum VehicleAvailability {
  Busy = 'Busy',
  InService = 'InService',
  OutOfService = 'OutOfService',
  Unknown = 'Unknown'
}

export type VehicleAvailabilityInput = {
  availability: VehicleAvailability;
  availabilityComments?: InputMaybe<Scalars['String']>;
  availabilityEstEndTime?: InputMaybe<Scalars['TimestampWithTimezone']>;
  availabilityStartTime?: InputMaybe<Scalars['TimestampWithTimezone']>;
  vehicleId: Scalars['UUID'];
};

export type VehicleAvailabilitySummary = {
  __typename?: 'VehicleAvailabilitySummary';
  availability: VehicleAvailability;
  next?: Maybe<VehicleUnavailablePeriod>;
  overlapping: Array<VehicleUnavailablePeriod>;
  previous?: Maybe<VehicleUnavailablePeriod>;
  vehicle: AvailableVehicle;
};

export type VehicleClass = AccountEntity & {
  __typename?: 'VehicleClass';
  account: Account;
  accountId: Scalars['UUID'];
  cancellationPolicyHours?: Maybe<Scalars['Int']>;
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  externalId?: Maybe<Scalars['UUID']>;
  hourlyRate?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  imageUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  luggageCount?: Maybe<Scalars['Int']>;
  minimumHours?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  passengerCount?: Maybe<Scalars['Int']>;
  systemClass: SystemVehicleClass;
  systemClassId: Scalars['String'];
  systemCreated?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['TimestampWithTimezone'];
  vehicles: Array<Maybe<Vehicle>>;
  version: Scalars['Int'];
};

export type VehicleClassCollectionResult = {
  __typename?: 'VehicleClassCollectionResult';
  items: Array<VehicleClass>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type VehicleClassInputArgs = {
  canBeQuoatedWithoutRates: Scalars['Boolean'];
  cancellationPolicyHours?: InputMaybe<Scalars['Float']>;
  clientCanBook: Scalars['Boolean'];
  displayOrder: Scalars['Float'];
  dwellTime: Scalars['Float'];
  hourlyRate?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['UUID']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isActive?: Scalars['Boolean'];
  limitedAvailability: Scalars['Boolean'];
  luggageCount?: InputMaybe<Scalars['Float']>;
  minimumHours?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  passengerCount?: InputMaybe<Scalars['Float']>;
  providerType: ProviderType;
  signageRequired: Scalars['Boolean'];
  skipCoreReplication?: InputMaybe<Scalars['Boolean']>;
  systemClass?: InputMaybe<SystemClass>;
  systemCreated?: InputMaybe<Scalars['Boolean']>;
  systemVehicleClassId?: InputMaybe<Scalars['String']>;
  vendorId?: InputMaybe<Scalars['UUID']>;
};

export type VehicleClassOverride = {
  __typename?: 'VehicleClassOverride';
  amount: Scalars['Float'];
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['UUID'];
  rate: Rate;
  rateId: Scalars['UUID'];
  updatedAt: Scalars['TimestampWithTimezone'];
  vehicleClass: VehicleClass;
  vehicleClassId: Scalars['UUID'];
  version: Scalars['Int'];
};

export type VehicleClassOverrideCollectionResult = {
  __typename?: 'VehicleClassOverrideCollectionResult';
  items: Array<VehicleClassOverride>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type VehicleClassOverrideLite = {
  amount: Scalars['Float'];
  id?: InputMaybe<Scalars['UUID']>;
  vehicleClassId: Scalars['UUID'];
};

export type VehicleClassOverrideQueries = {
  __typename?: 'VehicleClassOverrideQueries';
  all: VehicleClassOverrideCollectionResult;
  byId?: Maybe<VehicleClassOverride>;
};


export type VehicleClassOverrideQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type VehicleClassOverrideQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type VehicleClassQueries = {
  __typename?: 'VehicleClassQueries';
  all: VehicleClassCollectionResult;
  allVehicleClassPublic: VehicleClassCollectionResult;
  byId?: Maybe<VehicleClass>;
};


export type VehicleClassQueriesAllArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderByDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type VehicleClassQueriesAllVehicleClassPublicArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderByDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type VehicleClassQueriesByIdArgs = {
  id: Scalars['UUID'];
};

export type VehicleClassQueryResolvers = {
  __typename?: 'VehicleClassQueryResolvers';
  getSavoyaVehicleClasses?: Maybe<Array<VehicleClassRecord>>;
  vehicleClassById?: Maybe<VehicleClassRecord>;
  vehicleClassByVendorId?: Maybe<Array<VehicleClassRecord>>;
};


export type VehicleClassQueryResolversVehicleClassByIdArgs = {
  id: Scalars['UUID'];
};


export type VehicleClassQueryResolversVehicleClassByVendorIdArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  providerType?: InputMaybe<ProviderType>;
  vendorId?: InputMaybe<Scalars['UUID']>;
};

export type VehicleClassRateForBooking = {
  __typename?: 'VehicleClassRateForBooking';
  total: Scalars['Float'];
  vehicleClass: VehicleClass;
};

export type VehicleClassRecord = {
  __typename?: 'VehicleClassRecord';
  canBeQuoatedWithoutRates: Scalars['Boolean'];
  cancellationPolicyHours?: Maybe<Scalars['Float']>;
  clientCanBook: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  deleted?: Maybe<Scalars['DateTime']>;
  displayOrder?: Maybe<Scalars['Float']>;
  dwellTime: Scalars['Float'];
  hourlyRate?: Maybe<Scalars['Decimal']>;
  id: Scalars['UUID'];
  imageUrl?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  limitedAvailability: Scalars['Boolean'];
  luggageCount?: Maybe<Scalars['Float']>;
  minimumHours?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  passengerCount?: Maybe<Scalars['Float']>;
  providerType: ProviderType;
  signageRequired: Scalars['Boolean'];
  systemClass: SystemClass;
  systemVehicleClassId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vendor?: Maybe<VendorRecord>;
  vendorId?: Maybe<Scalars['UUID']>;
};

export type VehicleCollectionResult = {
  __typename?: 'VehicleCollectionResult';
  items: Array<Vehicle>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export enum VehicleColor {
  Beige = 'Beige',
  Black = 'Black',
  Blue = 'Blue',
  Brown = 'Brown',
  Copper = 'Copper',
  DarkBlue = 'DarkBlue',
  DarkGreen = 'DarkGreen',
  Gold = 'Gold',
  Gray = 'Gray',
  Green = 'Green',
  LightBlue = 'LightBlue',
  LightGreen = 'LightGreen',
  Maroon = 'Maroon',
  Navy = 'Navy',
  Orange = 'Orange',
  Other = 'Other',
  Pink = 'Pink',
  Purple = 'Purple',
  Red = 'Red',
  Silver = 'Silver',
  Tan = 'Tan',
  Teal = 'Teal',
  White = 'White',
  Yellow = 'Yellow'
}

export type VehicleCreateArgs = {
  capitalDriveProvider?: InputMaybe<VehicleProviderInputArgs>;
  color?: InputMaybe<Scalars['String']>;
  documentFile?: InputMaybe<FileUploadArgs>;
  id?: InputMaybe<Scalars['UUID']>;
  imageFilename?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  licensePlateNumber?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  /** Vehicle make id for Capital Drive */
  makeId?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  rentalExpirationDate?: InputMaybe<Scalars['DateTime']>;
  savoyaProvider?: InputMaybe<VehicleProviderInputArgs>;
  seatingArrangement?: InputMaybe<Scalars['String']>;
  skipCoreReplication?: InputMaybe<Scalars['Boolean']>;
  vehicleClassId: Scalars['UUID'];
  vehicleModel?: InputMaybe<VehicleModelInputArgs>;
  vendorId: Scalars['UUID'];
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Float']>;
};

export type VehicleDeleteFileArgs = {
  key: Scalars['String'];
};

export type VehicleFilesUploadArgs = {
  files: Array<FileUploadArgs>;
  vehicleId: Scalars['UUID'];
};

export type VehicleMake = {
  __typename?: 'VehicleMake';
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  id: Scalars['String'];
  models: Array<Maybe<VehicleModel>>;
  name: Scalars['String'];
  updatedAt: Scalars['TimestampWithTimezone'];
  version: Scalars['Int'];
};

export type VehicleMakeCollectionResult = {
  __typename?: 'VehicleMakeCollectionResult';
  items: Array<VehicleMake>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type VehicleMakeInputArgs = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type VehicleMakeQueries = {
  __typename?: 'VehicleMakeQueries';
  all: VehicleMakeCollectionResult;
  byId?: Maybe<VehicleMake>;
};


export type VehicleMakeQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type VehicleMakeQueriesByIdArgs = {
  id: Scalars['String'];
};

export type VehicleMakeRecord = {
  __typename?: 'VehicleMakeRecord';
  createdAt?: Maybe<Scalars['DateTime']>;
  deleted?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  vehicleModels?: Maybe<Array<VehicleModelRecord>>;
};

export type VehicleMakeSearchResponse = {
  __typename?: 'VehicleMakeSearchResponse';
  items: Array<VehicleMakeRecord>;
  total: Scalars['Float'];
};

export enum VehicleMiddleSeatType {
  Bench = 'Bench',
  Captains = 'Captains',
  Executive = 'Executive'
}

export type VehicleModel = {
  __typename?: 'VehicleModel';
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  endYear?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  make: VehicleMake;
  makeId: Scalars['String'];
  name: Scalars['String'];
  startYear: Scalars['Int'];
  updatedAt: Scalars['TimestampWithTimezone'];
  vehicles: Array<Maybe<Vehicle>>;
  version: Scalars['Int'];
};

export type VehicleModelCollectionResult = {
  __typename?: 'VehicleModelCollectionResult';
  items: Array<VehicleModel>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type VehicleModelInputArgs = {
  endYear?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['UUID']>;
  make: VehicleMakeInputArgs;
  name: Scalars['String'];
  startYear?: InputMaybe<Scalars['Float']>;
};

export type VehicleModelLabel = {
  __typename?: 'VehicleModelLabel';
  id: Scalars['UUID'];
  label: Scalars['String'];
};

export type VehicleModelQueries = {
  __typename?: 'VehicleModelQueries';
  all: VehicleModelCollectionResult;
  byId?: Maybe<VehicleModel>;
  byMake?: Maybe<VehicleModelCollectionResult>;
  vehicleModelAutocomplete: Array<Maybe<VehicleModelLabel>>;
};


export type VehicleModelQueriesAllArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type VehicleModelQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type VehicleModelQueriesByMakeArgs = {
  makeId: Scalars['String'];
};


export type VehicleModelQueriesVehicleModelAutocompleteArgs = {
  query: Scalars['String'];
};

export type VehicleModelRecord = {
  __typename?: 'VehicleModelRecord';
  createdAt?: Maybe<Scalars['DateTime']>;
  deleted?: Maybe<Scalars['DateTime']>;
  endYear?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  make?: Maybe<VehicleMakeRecord>;
  makeId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  startYear?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vehicles?: Maybe<Array<VehicleRecord>>;
};

export type VehicleProviderInputArgs = {
  documentUrl?: InputMaybe<Scalars['String']>;
  groundwork: Scalars['Boolean'];
  id?: InputMaybe<Scalars['UUID']>;
  insuranceChecked: Scalars['Boolean'];
  providerType: ProviderType;
  rejectionReason?: InputMaybe<Scalars['String']>;
  status: VehicleStatus;
  vehicleId?: InputMaybe<Scalars['UUID']>;
};

export type VehicleProviderRecord = {
  __typename?: 'VehicleProviderRecord';
  createdAt?: Maybe<Scalars['DateTime']>;
  deleted?: Maybe<Scalars['DateTime']>;
  documentUpdatedAt?: Maybe<Scalars['DateTime']>;
  documentUrl?: Maybe<Scalars['String']>;
  groundwork: Scalars['Boolean'];
  id: Scalars['UUID'];
  insuranceChecked: Scalars['Boolean'];
  providerType: ProviderType;
  rejectionReason?: Maybe<Scalars['String']>;
  status: VehicleStatus;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vehicleId: Scalars['UUID'];
};

export type VehicleQueries = {
  __typename?: 'VehicleQueries';
  all: VehicleCollectionResult;
  available: Array<VehicleAvailabilitySummary>;
  byId?: Maybe<Vehicle>;
  search: VehicleCollectionResult;
};


export type VehicleQueriesAllArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderByDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  vehicleClassId?: InputMaybe<Scalars['UUID']>;
};


export type VehicleQueriesAvailableArgs = {
  criteria: AvailabilityQueryCriteria;
};


export type VehicleQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type VehicleQueriesSearchArgs = {
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderByDirection>;
  query?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  vehicleClassId?: InputMaybe<Scalars['UUID']>;
};

export type VehicleQueryResolvers = {
  __typename?: 'VehicleQueryResolvers';
  getAllVehicleMakes?: Maybe<VehicleMakeSearchResponse>;
  getVehicleModelsByMake?: Maybe<VehicleMakeSearchResponse>;
  vehicleById?: Maybe<VehicleRecord>;
  vehicleByName?: Maybe<VehicleRecord>;
  vehicleFiles?: Maybe<FilesResponse>;
  vehiclesByProviderType?: Maybe<Array<VehicleRecord>>;
  vehiclesByVendorId?: Maybe<VehicleSearchResponse>;
};


export type VehicleQueryResolversGetAllVehicleMakesArgs = {
  orderBy?: InputMaybe<OrderByDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type VehicleQueryResolversGetVehicleModelsByMakeArgs = {
  makeId: Scalars['String'];
};


export type VehicleQueryResolversVehicleByIdArgs = {
  id: Scalars['UUID'];
};


export type VehicleQueryResolversVehicleByNameArgs = {
  name: Scalars['String'];
};


export type VehicleQueryResolversVehicleFilesArgs = {
  id: Scalars['UUID'];
};


export type VehicleQueryResolversVehiclesByProviderTypeArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderByDirection>;
  providerType?: InputMaybe<ProviderType>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<VehicleStatus>;
  systemClasses?: InputMaybe<Array<SystemClass>>;
  take?: InputMaybe<Scalars['Int']>;
  vehicleClassId?: InputMaybe<Scalars['UUID']>;
  vendorId?: InputMaybe<Scalars['UUID']>;
};


export type VehicleQueryResolversVehiclesByVendorIdArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<OrderByDirection>;
  providerType?: InputMaybe<ProviderType>;
  skip?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<VehicleStatus>;
  systemClasses?: InputMaybe<Array<SystemClass>>;
  take?: InputMaybe<Scalars['Int']>;
  vehicleClassId?: InputMaybe<Scalars['UUID']>;
  vendorId?: InputMaybe<Scalars['UUID']>;
};

export type VehicleRecord = {
  __typename?: 'VehicleRecord';
  color?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  deleted?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  imageUpdatedAt?: Maybe<Scalars['DateTime']>;
  imageUrl?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  licensePlateNumber?: Maybe<Scalars['String']>;
  make?: Maybe<Scalars['String']>;
  model?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rentalExpirationDate?: Maybe<Scalars['DateTime']>;
  seatingArrangement?: Maybe<Scalars['String']>;
  signedUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vehicleClass?: Maybe<VehicleClassRecord>;
  vehicleClassId: Scalars['UUID'];
  vehicleModel?: Maybe<VehicleModelRecord>;
  vehicleProvider?: Maybe<Array<VehicleProviderRecord>>;
  vendor?: Maybe<VendorRecord>;
  vendorId: Scalars['UUID'];
  vin?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Float']>;
};

export type VehicleSearchResponse = {
  __typename?: 'VehicleSearchResponse';
  items: Array<VehicleRecord>;
  total: Scalars['Float'];
};

export type VehicleSensorReading = {
  __typename?: 'VehicleSensorReading';
  accountId: Scalars['UUID'];
  coordinates: Scalars['Coordinates'];
  createdAt: Scalars['TimestampWithTimezone'];
  deletedAt?: Maybe<Scalars['TimestampWithTimezone']>;
  driverId?: Maybe<Scalars['UUID']>;
  heading: Scalars['Float'];
  id: Scalars['UUID'];
  sensorTimestamp: Scalars['TimestampWithTimezone'];
  source?: Maybe<SensorReadingSource>;
  speed: Scalars['Float'];
  trip?: Maybe<Trip>;
  tripId?: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['TimestampWithTimezone'];
  vehicleId?: Maybe<Scalars['UUID']>;
  version: Scalars['Int'];
};

export type VehicleSensorReadingCollectionResult = {
  __typename?: 'VehicleSensorReadingCollectionResult';
  items: Array<VehicleSensorReading>;
  refetchAfter?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type VehicleSensorReadingQueries = {
  __typename?: 'VehicleSensorReadingQueries';
  all: VehicleSensorReadingCollectionResult;
  byId?: Maybe<VehicleSensorReading>;
  byTrip?: Maybe<VehicleSensorReadingCollectionResult>;
  byTripActualRoute?: Maybe<VehicleSensorReadingCollectionResult>;
};


export type VehicleSensorReadingQueriesAllArgs = {
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type VehicleSensorReadingQueriesByIdArgs = {
  id: Scalars['UUID'];
};


export type VehicleSensorReadingQueriesByTripArgs = {
  tripId: Scalars['UUID'];
};


export type VehicleSensorReadingQueriesByTripActualRouteArgs = {
  tripId: Scalars['UUID'];
};

export enum VehicleStatus {
  Approved = 'APPROVED',
  Busy = 'BUSY',
  InService = 'IN_SERVICE',
  OutOfService = 'OUT_OF_SERVICE',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  SavoyaDeleted = 'SAVOYA_DELETED',
  Unknown = 'UNKNOWN'
}

export type VehicleSummary = {
  __typename?: 'VehicleSummary';
  licenseNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
};

export type VehicleUnavailablePeriod = {
  __typename?: 'VehicleUnavailablePeriod';
  /** The availability status of this period. Must be InService or OutOfService. */
  availability: VehicleAvailability;
  /** When this availability period ends. The last period will not have an end date, meaning there are no future commitments and, except for any repeating blackount windows, the driver is available for all trips after the start date. */
  endTime?: Maybe<Scalars['DateTime']>;
  /** When this availability period begins */
  startTime: Scalars['DateTime'];
  /** For committed periods, the trip to which this period is committed */
  trip?: Maybe<RelatedTrip>;
};

export type VehicleUpdateArgs = {
  capitalDriveProvider?: InputMaybe<VehicleProviderInputArgs>;
  color?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  imageFilename?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  licensePlateNumber?: InputMaybe<Scalars['String']>;
  make?: InputMaybe<Scalars['String']>;
  /** Vehicle make id for Capital Drive */
  makeId?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  rentalExpirationDate?: InputMaybe<Scalars['DateTime']>;
  savoyaProvider?: InputMaybe<VehicleProviderInputArgs>;
  seatingArrangement?: InputMaybe<Scalars['String']>;
  skipCoreReplication?: InputMaybe<Scalars['Boolean']>;
  vehicleClassId: Scalars['UUID'];
  vehicleModel?: InputMaybe<VehicleModelInputArgs>;
  vendorId: Scalars['UUID'];
  vin?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['Float']>;
};

export type VendorCreateArgs = {
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isInternal?: InputMaybe<Scalars['Boolean']>;
  legalName: Scalars['String'];
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  skipCoreReplication?: InputMaybe<Scalars['Boolean']>;
  skipIdentityCreation?: InputMaybe<Scalars['Boolean']>;
  vendorProvider?: InputMaybe<VendorProviderInputArgs>;
  website?: InputMaybe<Scalars['String']>;
};

export type VendorProviderInputArgs = {
  acceptsShortNoticeTrips?: InputMaybe<Scalars['Boolean']>;
  accountingAddress1?: InputMaybe<Scalars['String']>;
  accountingAddress2?: InputMaybe<Scalars['String']>;
  accountingCountry?: InputMaybe<Scalars['String']>;
  accountingEmail?: InputMaybe<Scalars['String']>;
  accountingFirstName?: InputMaybe<Scalars['String']>;
  accountingLastName?: InputMaybe<Scalars['String']>;
  accountingPhoneNumber?: InputMaybe<Scalars['String']>;
  accountingPostalCode?: InputMaybe<Scalars['String']>;
  automaticCloseout?: InputMaybe<Scalars['Boolean']>;
  bodilyInjuryPerAccident?: InputMaybe<Scalars['Float']>;
  bodilyInjuryPerPerson?: InputMaybe<Scalars['Float']>;
  bookingToken?: InputMaybe<Scalars['String']>;
  bookingToolEnabled?: InputMaybe<Scalars['Boolean']>;
  canEditCosts?: InputMaybe<Scalars['Boolean']>;
  creditCardFeePercentage?: InputMaybe<Scalars['Float']>;
  dispatchPhoneNumber?: InputMaybe<Scalars['String']>;
  displayRatesInBookingTool?: InputMaybe<Scalars['Boolean']>;
  eid?: InputMaybe<Scalars['String']>;
  establishedAt?: InputMaybe<Scalars['DateTime']>;
  facebookUrl?: InputMaybe<Scalars['String']>;
  holdForPayment?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  instagramUrl?: InputMaybe<Scalars['String']>;
  insuranceCombinedSingleLimitPerAccident?: InputMaybe<Scalars['Float']>;
  licensesAndCertifications?: InputMaybe<Scalars['String']>;
  linkedinUrl?: InputMaybe<Scalars['String']>;
  lockedGreeter?: InputMaybe<Scalars['Boolean']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  missionOnly?: InputMaybe<Scalars['Boolean']>;
  mobileEnabled?: InputMaybe<Scalars['Boolean']>;
  noCompUpgrades?: InputMaybe<Scalars['Boolean']>;
  notificationsDisabled?: InputMaybe<Scalars['Boolean']>;
  operationCertified?: InputMaybe<Scalars['Boolean']>;
  ownerEmail?: InputMaybe<Scalars['String']>;
  ownerFirstName?: InputMaybe<Scalars['String']>;
  ownerLastName?: InputMaybe<Scalars['String']>;
  ownerPhoneNumber?: InputMaybe<Scalars['String']>;
  payTo?: InputMaybe<Scalars['String']>;
  paymentFrequency?: InputMaybe<PaymentFrequency>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  petPolicy?: InputMaybe<Scalars['String']>;
  preferredMethodOfContact?: InputMaybe<Scalars['String']>;
  primaryContactFirstName?: InputMaybe<Scalars['String']>;
  primaryContactLastName?: InputMaybe<Scalars['String']>;
  propertyDamagePerAccident?: InputMaybe<Scalars['Float']>;
  providerType: ProviderType;
  providesChildSeats?: InputMaybe<Scalars['Boolean']>;
  receiveEmailNotificationsOverride?: InputMaybe<Scalars['Boolean']>;
  relationsManagerId?: InputMaybe<Scalars['Float']>;
  reservationsEmail?: InputMaybe<Scalars['String']>;
  reservationsPhoneNumber?: InputMaybe<Scalars['String']>;
  robocallDtmf?: InputMaybe<Scalars['String']>;
  salesPitch?: InputMaybe<Scalars['String']>;
  savoyaApproved?: InputMaybe<Scalars['Boolean']>;
  savoyaPreferred?: InputMaybe<Scalars['Boolean']>;
  spokenLanguages?: InputMaybe<Array<Scalars['String']>>;
  squareAccessToken?: InputMaybe<Scalars['String']>;
  squareMerchantId?: InputMaybe<Scalars['String']>;
  squareRefreshToken?: InputMaybe<Scalars['String']>;
  squareTokenExpiresAt?: InputMaybe<Scalars['DateTime']>;
  stripeAccountCanCharge?: InputMaybe<Scalars['Boolean']>;
  stripeAccountId?: InputMaybe<Scalars['String']>;
  temporaryHold?: InputMaybe<Scalars['Boolean']>;
  transferRatePlusWaitTime?: InputMaybe<Scalars['Boolean']>;
  trialMode?: InputMaybe<Scalars['Boolean']>;
  twitterUrl?: InputMaybe<Scalars['String']>;
  underServiceAgreement?: InputMaybe<Scalars['Boolean']>;
  useDriverScoreOverride?: InputMaybe<Scalars['Boolean']>;
  vendorFuelSurcharge?: InputMaybe<Scalars['Float']>;
  vendorType?: InputMaybe<VendorType>;
  venmoHandle?: InputMaybe<Scalars['String']>;
  videoUrl?: InputMaybe<Scalars['String']>;
  workersCompensantionLiabilityCoverage?: InputMaybe<Scalars['Boolean']>;
  yearsInBusiness?: InputMaybe<Scalars['Float']>;
  zelleHandle?: InputMaybe<Scalars['String']>;
};

export type VendorProviderRecord = {
  __typename?: 'VendorProviderRecord';
  acceptsShortNoticeTrips?: Maybe<Scalars['Boolean']>;
  accountingAddress1?: Maybe<Scalars['String']>;
  accountingAddress2?: Maybe<Scalars['String']>;
  accountingCountry?: Maybe<Scalars['String']>;
  accountingEmail?: Maybe<Scalars['String']>;
  accountingFirstName?: Maybe<Scalars['String']>;
  accountingLastName?: Maybe<Scalars['String']>;
  accountingPhoneNumber?: Maybe<Scalars['String']>;
  accountingPostalCode?: Maybe<Scalars['String']>;
  automaticCloseout?: Maybe<Scalars['Boolean']>;
  bodilyInjuryPerAccident?: Maybe<Scalars['Float']>;
  bodilyInjuryPerPerson?: Maybe<Scalars['Float']>;
  bookingToken?: Maybe<Scalars['String']>;
  bookingToolEnabled?: Maybe<Scalars['Boolean']>;
  canEditCosts?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  creditCardFeePercentage?: Maybe<Scalars['Float']>;
  deleted?: Maybe<Scalars['DateTime']>;
  dispatchPhoneNumber?: Maybe<Scalars['String']>;
  displayRatesInBookingTool?: Maybe<Scalars['Boolean']>;
  eid?: Maybe<Scalars['String']>;
  establishedAt?: Maybe<Scalars['DateTime']>;
  facebookUrl?: Maybe<Scalars['String']>;
  holdForPayment?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  instagramUrl?: Maybe<Scalars['String']>;
  insuranceCombinedSingleLimitPerAccident?: Maybe<Scalars['Float']>;
  licensesAndCertifications?: Maybe<Scalars['String']>;
  linkedinUrl?: Maybe<Scalars['String']>;
  lockedGreeter?: Maybe<Scalars['Boolean']>;
  logoUrl?: Maybe<Scalars['String']>;
  missionOnly?: Maybe<Scalars['Boolean']>;
  mobileEnabled?: Maybe<Scalars['Boolean']>;
  noCompUpgrades?: Maybe<Scalars['Boolean']>;
  notificationsDisabled?: Maybe<Scalars['Boolean']>;
  operationCertified?: Maybe<Scalars['Boolean']>;
  ownerEmail?: Maybe<Scalars['String']>;
  ownerFirstName?: Maybe<Scalars['String']>;
  ownerLastName?: Maybe<Scalars['String']>;
  ownerPhoneNumber?: Maybe<Scalars['String']>;
  payTo?: Maybe<Scalars['String']>;
  paymentFrequency?: Maybe<PaymentFrequency>;
  paymentMethod?: Maybe<Scalars['String']>;
  petPolicy?: Maybe<Scalars['String']>;
  preferredMethodOfContact?: Maybe<Scalars['String']>;
  primaryContactFirstName?: Maybe<Scalars['String']>;
  primaryContactLastName?: Maybe<Scalars['String']>;
  propertyDamagePerAccident?: Maybe<Scalars['Float']>;
  providerType: ProviderType;
  providesChildSeats: Scalars['Boolean'];
  receiveEmailNotificationsOverride?: Maybe<Scalars['Boolean']>;
  relationsManagerId?: Maybe<Scalars['String']>;
  reservationsEmail?: Maybe<Scalars['String']>;
  reservationsPhoneNumber?: Maybe<Scalars['String']>;
  robocallDtmf?: Maybe<Scalars['String']>;
  salesPitch?: Maybe<Scalars['String']>;
  savoyaApproved?: Maybe<Scalars['Boolean']>;
  savoyaPreferred?: Maybe<Scalars['Boolean']>;
  spokenLanguages?: Maybe<Array<Scalars['String']>>;
  squareAccessToken?: Maybe<Scalars['String']>;
  squareMerchantId?: Maybe<Scalars['String']>;
  squareRefreshToken?: Maybe<Scalars['String']>;
  squareTokenExpiresAt?: Maybe<Scalars['DateTime']>;
  stripeAccountCanCharge?: Maybe<Scalars['Boolean']>;
  stripeAccountId?: Maybe<Scalars['String']>;
  temporaryHold?: Maybe<Scalars['Boolean']>;
  transferRatePlusWaitTime?: Maybe<Scalars['Boolean']>;
  trialMode?: Maybe<Scalars['Boolean']>;
  twitterUrl?: Maybe<Scalars['String']>;
  underServiceAgreement?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  useDriverScoreOverride?: Maybe<Scalars['Boolean']>;
  vendorFuelSurcharge?: Maybe<Scalars['Float']>;
  vendorId: Scalars['UUID'];
  vendorType?: Maybe<VendorType>;
  venmoHandle?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  workersCompensantionLiabilityCoverage: Scalars['Boolean'];
  yearsInBusiness?: Maybe<Scalars['Float']>;
  zelleHandle?: Maybe<Scalars['String']>;
};

export type VendorRecord = {
  __typename?: 'VendorRecord';
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  deleted?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  drivers?: Maybe<Array<DriverRecord>>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive?: Maybe<Scalars['Boolean']>;
  isInternal?: Maybe<Scalars['Boolean']>;
  legalName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vendorProviders?: Maybe<Array<VendorProviderRecord>>;
  website?: Maybe<Scalars['String']>;
};

export enum VendorType {
  AsapGarage = 'ASAP_GARAGE',
  Garage = 'GARAGE',
  Groundwork = 'GROUNDWORK',
  GroundworkGarage = 'GROUNDWORK_GARAGE',
  Independent = 'INDEPENDENT'
}

export type VendorUpdateArgs = {
  capitalDriveVendorProvider?: InputMaybe<VendorProviderInputArgs>;
  currency?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  isInternal?: InputMaybe<Scalars['Boolean']>;
  legalName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  savoyaVendorProvider?: InputMaybe<VendorProviderInputArgs>;
  skipCoreReplication?: InputMaybe<Scalars['Boolean']>;
  website?: InputMaybe<Scalars['String']>;
};

export type VendorsQueries = {
  __typename?: 'VendorsQueries';
  getVendorByEmail?: Maybe<VendorRecord>;
  getVendorByName?: Maybe<VendorRecord>;
  getVendorByToken?: Maybe<VendorRecord>;
  getVendorsByProviderType?: Maybe<Array<VendorRecord>>;
  getVendortById?: Maybe<VendorRecord>;
};


export type VendorsQueriesGetVendorByEmailArgs = {
  email: Scalars['String'];
};


export type VendorsQueriesGetVendorByNameArgs = {
  name: Scalars['String'];
};


export type VendorsQueriesGetVendorsByProviderTypeArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  orderBy?: InputMaybe<OrderByDirection>;
  providerType?: InputMaybe<ProviderType>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type VendorsQueriesGetVendortByIdArgs = {
  id: Scalars['UUID'];
};

export type VerifiedFlightResult = {
  __typename?: 'VerifiedFlightResult';
  errors?: Maybe<Array<MutationError>>;
  success: Scalars['Boolean'];
  verifiedFlight?: Maybe<Scalars['JSON']>;
};

export type VerifyUserResponse = MutationResult & {
  __typename?: 'VerifyUserResponse';
  chargesEnabled?: Maybe<Scalars['Boolean']>;
  detailsSubmitted?: Maybe<Scalars['Boolean']>;
  errors?: Maybe<Array<MutationError>>;
  onboardingStarted?: Maybe<Scalars['Boolean']>;
  pendingVerification?: Maybe<Scalars['Boolean']>;
  success: Scalars['Boolean'];
};

export type WaitTimeOverriddenEvent = TripEvent & {
  __typename?: 'WaitTimeOverriddenEvent';
  from?: Maybe<Scalars['Float']>;
  id: Scalars['UUID'];
  timestamp: Scalars['Timestamp'];
  to: Scalars['Float'];
  tripId: Scalars['UUID'];
  type: TripEventType;
  userId?: Maybe<Scalars['UUID']>;
};

export type Waiting = {
  location?: InputMaybe<TripCommandLocation>;
  tripId: Scalars['UUID'];
};

export enum ZoneType {
  Address = 'Address',
  Area = 'Area'
}

export type AddAccountMutationVariables = Exact<{
  account: InsertAccount;
}>;


export type AddAccountMutation = { __typename?: 'Mutation', insertAccount?: { __typename?: 'InsertAccountResult', account?: { __typename?: 'Account', id: any, name: string, description?: string | null, salesPitch?: string | null, legalName?: string | null, logoUrl?: string | null, videoUrl?: string | null, established?: any | null, primaryPhoneNumber?: string | null, primaryEmailAddress?: string | null } | null } | null };

export type UpdateAccountMutationVariables = Exact<{
  account: UpdateAccount;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount?: { __typename?: 'UpdateAccountResult', account?: { __typename?: 'Account', id: any, name: string, description?: string | null, salesPitch?: string | null, legalName?: string | null, logoUrl?: string | null, videoUrl?: string | null, established?: any | null, primaryPhoneNumber?: string | null, primaryEmailAddress?: string | null, website?: string | null } | null } | null };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetAccountQuery = { __typename?: 'Query', accounts: { __typename?: 'AccountQueries', byId?: { __typename?: 'Account', id: any, name: string, description?: string | null, salesPitch?: string | null, legalName?: string | null, logoUrl?: string | null, videoUrl?: string | null, established?: any | null, primaryPhoneNumber?: string | null, primaryEmailAddress?: string | null, website?: string | null, bookingToken?: string | null, displayRatesInBookingTool?: boolean | null, squareAccessToken?: string | null, squareMerchantId?: string | null, yearsInBusiness?: number | null, spokenLanguages: Array<string>, licensesAndCertifications?: string | null, insuranceCombinedSingleLimitPerAccident?: number | null, zelleHandle?: string | null, venmoHandle?: string | null, bodilyInjuryPerPerson?: number | null, bodilyInjuryPerAccident?: number | null, propertyDamagePerAccident?: number | null, workersCompensantionLiabilityCoverage?: boolean | null, childSeat?: boolean | null, petPolicy?: string | null, facebookUrl?: string | null, linkedinUrl?: string | null, instagramUrl?: string | null, twitterUrl?: string | null, garages: Array<{ __typename?: 'Garage', location: { __typename?: 'Location', city?: string | null, state?: string | null } }>, accountOwner?: { __typename?: 'Contact', id: any, name?: string | null, email: string, phoneNumber?: string | null } | null, drivers: Array<{ __typename?: 'Driver', id: any }>, vehicles?: Array<{ __typename?: 'Vehicle', year: number, model: { __typename?: 'VehicleModel', name: string, make: { __typename?: 'VehicleMake', name: string } } }> | null } | null }, vendorsQueries?: { __typename?: 'VendorsQueries', getVendortById?: { __typename?: 'VendorRecord', id: any, name: string, legalName?: string | null, description?: string | null, email?: string | null, currency?: string | null, phoneNumber?: string | null, website?: string | null, isActive?: boolean | null, isInternal?: boolean | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, vendorProviders?: Array<{ __typename?: 'VendorProviderRecord', id: any, vendorId: any, providerType: ProviderType, providesChildSeats: boolean, eid?: string | null, ownerFirstName?: string | null, ownerLastName?: string | null, ownerEmail?: string | null, ownerPhoneNumber?: string | null, acceptsShortNoticeTrips?: boolean | null, savoyaApproved?: boolean | null, savoyaPreferred?: boolean | null, automaticCloseout?: boolean | null, canEditCosts?: boolean | null, creditCardFeePercentage?: number | null, holdForPayment?: boolean | null, lockedGreeter?: boolean | null, missionOnly?: boolean | null, mobileEnabled?: boolean | null, noCompUpgrades?: boolean | null, notificationsDisabled?: boolean | null, operationCertified?: boolean | null, temporaryHold?: boolean | null, transferRatePlusWaitTime?: boolean | null, trialMode?: boolean | null, underServiceAgreement?: boolean | null, useDriverScoreOverride?: boolean | null, receiveEmailNotificationsOverride?: boolean | null, vendorFuelSurcharge?: number | null, vendorType?: VendorType | null, robocallDtmf?: string | null, dispatchPhoneNumber?: string | null, reservationsEmail?: string | null, reservationsPhoneNumber?: string | null, accountingAddress1?: string | null, accountingAddress2?: string | null, accountingPostalCode?: string | null, accountingEmail?: string | null, accountingFirstName?: string | null, accountingLastName?: string | null, accountingPhoneNumber?: string | null, payTo?: string | null, paymentFrequency?: PaymentFrequency | null, paymentMethod?: string | null, preferredMethodOfContact?: string | null, primaryContactFirstName?: string | null, primaryContactLastName?: string | null, relationsManagerId?: string | null, establishedAt?: any | null, yearsInBusiness?: number | null, salesPitch?: string | null, licensesAndCertifications?: string | null, petPolicy?: string | null, bookingToken?: string | null, displayRatesInBookingTool?: boolean | null, videoUrl?: string | null, logoUrl?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, linkedinUrl?: string | null, twitterUrl?: string | null, venmoHandle?: string | null, zelleHandle?: string | null, stripeAccountId?: string | null, stripeAccountCanCharge?: boolean | null, squareMerchantId?: string | null, squareAccessToken?: string | null, squareRefreshToken?: string | null, squareTokenExpiresAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, bodilyInjuryPerAccident?: number | null, bodilyInjuryPerPerson?: number | null, insuranceCombinedSingleLimitPerAccident?: number | null, propertyDamagePerAccident?: number | null, workersCompensantionLiabilityCoverage: boolean, spokenLanguages?: Array<string> | null }> | null } | null } | null };

export type SearchAccountQueryVariables = Exact<{
  query: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  includeFavorites?: InputMaybe<Scalars['Boolean']>;
  networkPartners?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchAccountQuery = { __typename?: 'Query', accounts: { __typename?: 'AccountQueries', search: { __typename?: 'AccountCollectionResult', total: number, items: Array<{ __typename?: 'Account', id: any, name: string, logoUrl?: string | null, website?: string | null, isFavorite?: boolean | null }> } } };

export type SearchUserQueryVariables = Exact<{
  query: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<ContactType>;
  userRole?: InputMaybe<UserRole>;
  orderBy?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<Scalars['UUID']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchUserQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactQueries', search: { __typename?: 'ContactCollectionResult', total: number, items: Array<{ __typename?: 'Contact', id: any, name?: string | null, email: string, title?: string | null, phoneNumber?: string | null, profileImageUrl?: string | null, userRole: UserRole, isActive: boolean, driver?: { __typename?: 'Driver', id: any, isActive: boolean } | null }> } } };

export type GetContactByEmailQueryVariables = Exact<{
  email: Scalars['String'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetContactByEmailQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactQueries', byEmail?: { __typename?: 'Contact', id: any, name?: string | null, email: string, title?: string | null, phoneNumber?: string | null, isActive: boolean } | null } };

export type DeleteContactMutationVariables = Exact<{
  contact: DeleteContact;
}>;


export type DeleteContactMutation = { __typename?: 'Mutation', deleteContact?: { __typename?: 'DeleteContactResult', success: boolean, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null } | null };

export type UpdateVendorMutationVariables = Exact<{
  vendorUpdateArgs: VendorUpdateArgs;
}>;


export type UpdateVendorMutation = { __typename?: 'Mutation', updateVendor: { __typename?: 'VendorRecord', createdAt?: any | null, currency?: string | null, description?: string | null, email?: string | null, id: any, isActive?: boolean | null, isInternal?: boolean | null, legalName?: string | null, name: string, phoneNumber?: string | null, updatedAt?: any | null, website?: string | null } };

export type GetVendorVehicleClassesQueryVariables = Exact<{
  vendorId?: InputMaybe<Scalars['UUID']>;
  providerType?: InputMaybe<ProviderType>;
}>;


export type GetVendorVehicleClassesQuery = { __typename?: 'Query', vehicleClassQueries?: { __typename?: 'VehicleClassQueryResolvers', vehicleClassByVendorId?: Array<{ __typename?: 'VehicleClassRecord', id: any, vendorId?: any | null, systemClass: SystemClass, name: string, dwellTime: number, limitedAvailability: boolean, canBeQuoatedWithoutRates: boolean, signageRequired: boolean, clientCanBook: boolean, displayOrder?: number | null, isActive: boolean, imageUrl?: string | null, hourlyRate?: any | null, passengerCount?: number | null, luggageCount?: number | null, cancellationPolicyHours?: number | null, minimumHours?: number | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, providerType: ProviderType }> | null } | null };

export type GetSavoyaVehicleClassesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavoyaVehicleClassesQuery = { __typename?: 'Query', vehicleClassQueries?: { __typename?: 'VehicleClassQueryResolvers', getSavoyaVehicleClasses?: Array<{ __typename?: 'VehicleClassRecord', id: any, vendorId?: any | null, systemClass: SystemClass, systemVehicleClassId?: string | null, name: string, dwellTime: number, limitedAvailability: boolean, providerType: ProviderType, canBeQuoatedWithoutRates: boolean, signageRequired: boolean, clientCanBook: boolean, displayOrder?: number | null, isActive: boolean, imageUrl?: string | null, hourlyRate?: any | null, passengerCount?: number | null, luggageCount?: number | null, cancellationPolicyHours?: number | null, minimumHours?: number | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null }> | null } | null };

export type CreateVendorVehicleMutationVariables = Exact<{
  vehicleCreateArgs: VehicleCreateArgs;
}>;


export type CreateVendorVehicleMutation = { __typename?: 'Mutation', createVehicleRecord: { __typename?: 'VehicleRecord', signedUrl?: string | null, id: any, isActive?: boolean | null, vendorId: any, vehicleClassId: any, name: string, imageUrl?: string | null, year?: number | null, color?: string | null, make?: string | null, model?: string | null, vin?: string | null, licensePlateNumber?: string | null, seatingArrangement?: string | null, rentalExpirationDate?: any | null, imageUpdatedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, vehicleProvider?: Array<{ __typename?: 'VehicleProviderRecord', id: any, providerType: ProviderType, vehicleId: any, groundwork: boolean, insuranceChecked: boolean, status: VehicleStatus, rejectionReason?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null }> | null, vehicleModel?: { __typename?: 'VehicleModelRecord', id: any, name: string, startYear?: number | null, endYear?: number | null, makeId?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, make?: { __typename?: 'VehicleMakeRecord', id: string, name: string, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null } | null } | null, vehicleClass?: { __typename?: 'VehicleClassRecord', id: any, vendorId?: any | null, systemClass: SystemClass, name: string, dwellTime: number, limitedAvailability: boolean, canBeQuoatedWithoutRates: boolean, signageRequired: boolean, clientCanBook: boolean, displayOrder?: number | null, isActive: boolean, imageUrl?: string | null, hourlyRate?: any | null, passengerCount?: number | null, luggageCount?: number | null, cancellationPolicyHours?: number | null, minimumHours?: number | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, providerType: ProviderType } | null } };

export type UpdateVehicleRecordMutationVariables = Exact<{
  vehicleUpdateArgs: VehicleUpdateArgs;
}>;


export type UpdateVehicleRecordMutation = { __typename?: 'Mutation', updateVehicleRecord: { __typename?: 'VehicleRecord', id: any, vendorId: any, vehicleClassId: any, name: string, year?: number | null, color?: string | null, make?: string | null, model?: string | null, isActive?: boolean | null, vin?: string | null, licensePlateNumber?: string | null, seatingArrangement?: string | null, rentalExpirationDate?: any | null, imageUrl?: string | null, imageUpdatedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, vehicleProvider?: Array<{ __typename?: 'VehicleProviderRecord', id: any, providerType: ProviderType, vehicleId: any, groundwork: boolean, insuranceChecked: boolean, status: VehicleStatus, rejectionReason?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null }> | null, vehicleModel?: { __typename?: 'VehicleModelRecord', id: any, name: string, startYear?: number | null, endYear?: number | null, makeId?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, make?: { __typename?: 'VehicleMakeRecord', id: string, name: string, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null } | null } | null, vehicleClass?: { __typename?: 'VehicleClassRecord', id: any, vendorId?: any | null, systemClass: SystemClass, name: string, dwellTime: number, limitedAvailability: boolean, canBeQuoatedWithoutRates: boolean, signageRequired: boolean, clientCanBook: boolean, displayOrder?: number | null, isActive: boolean, imageUrl?: string | null, hourlyRate?: any | null, passengerCount?: number | null, luggageCount?: number | null, cancellationPolicyHours?: number | null, minimumHours?: number | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null } | null } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactQueries', me?: { __typename?: 'Contact', id: any, name?: string | null, email: string, userRole: UserRole, contactType: ContactType, profileImageUrl?: string | null, analyticsToken?: string | null, accountId?: any | null, createdAt: any, account?: { __typename?: 'Account', stripeAccountCanCharge?: boolean | null, stripeAccountId?: string | null, name: string, squareAccessToken?: string | null, squareMerchantId?: string | null, squareRefreshToken?: string | null, squareTokenExpiresAt?: string | null, activeCardProcessor?: CreditCardProcessor | null } | null, driver?: { __typename?: 'Driver', id: any, videoUrl?: string | null, marketingDescription?: string | null, garage?: { __typename?: 'Garage', id: any, name: string, location: { __typename?: 'Location', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null, coordinates: any, placeType?: string | null, placeCategory?: string | null, placeName?: string | null } } | null } | null } | null }, usersQueries?: { __typename?: 'UserQueries', getUserByToken?: { __typename?: 'UserRecord', id: any, name: string, firstName: string, lastName: string, email: string, phoneNumber?: string | null, role: UserIdentityRole, productType?: Array<ProductType> | null, vendorId?: any | null, externalId: string, isSavoyaUser?: boolean | null } | null } | null, subscriptionByAccountId?: { __typename?: 'SubscriptionRecord', id: any, accountId: string, externalId?: string | null, clientSecret?: string | null, productType: ProductType, tierId?: string | null, currentTier: TierType, status?: SubscriptionStatus | null, inTrialPeriod?: boolean | null, renewalAt?: any | null, periodStartAt?: any | null, periodEndAt?: any | null, cancelled?: boolean | null, cancelledAt?: any | null, createdAt?: any | null, updatedAt?: any | null, paymentMethod?: { __typename?: 'PaymentMethodRecord', cardLastFour?: string | null, cardType?: string | null, country?: string | null, zipCode?: string | null } | null, tier?: { __typename?: 'SubscriptionTier', id: string, name: string, description: string, code: TierCode, type: TierType, productType: ProductType, amount: any, currency: CurrencyCode, trialPeriodDays: number, addons?: Array<{ __typename?: 'SubscriptionAddon', amount: any, code: AddonCode, currency: CurrencyCode, id: any, name: string, freeQty: number, type: AddonType }> | null } | null, addonUsage?: { __typename?: 'AddonUsageRecord', SHARED_TRIPS?: number | null } | null } | null, vendorsQueries?: { __typename?: 'VendorsQueries', getVendorByToken?: { __typename?: 'VendorRecord', id: any, name: string, legalName?: string | null, description?: string | null, email?: string | null, currency?: string | null, phoneNumber?: string | null, website?: string | null, isActive?: boolean | null, isInternal?: boolean | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, vendorProviders?: Array<{ __typename?: 'VendorProviderRecord', id: any, vendorId: any, providerType: ProviderType, providesChildSeats: boolean, eid?: string | null, ownerFirstName?: string | null, ownerLastName?: string | null, ownerEmail?: string | null, ownerPhoneNumber?: string | null, acceptsShortNoticeTrips?: boolean | null, savoyaApproved?: boolean | null, savoyaPreferred?: boolean | null, automaticCloseout?: boolean | null, canEditCosts?: boolean | null, creditCardFeePercentage?: number | null, holdForPayment?: boolean | null, lockedGreeter?: boolean | null, missionOnly?: boolean | null, mobileEnabled?: boolean | null, noCompUpgrades?: boolean | null, notificationsDisabled?: boolean | null, operationCertified?: boolean | null, temporaryHold?: boolean | null, transferRatePlusWaitTime?: boolean | null, trialMode?: boolean | null, underServiceAgreement?: boolean | null, useDriverScoreOverride?: boolean | null, receiveEmailNotificationsOverride?: boolean | null, vendorFuelSurcharge?: number | null, vendorType?: VendorType | null, robocallDtmf?: string | null, dispatchPhoneNumber?: string | null, reservationsEmail?: string | null, reservationsPhoneNumber?: string | null, accountingAddress1?: string | null, accountingAddress2?: string | null, accountingPostalCode?: string | null, accountingCountry?: string | null, accountingEmail?: string | null, accountingFirstName?: string | null, accountingLastName?: string | null, accountingPhoneNumber?: string | null, payTo?: string | null, paymentFrequency?: PaymentFrequency | null, paymentMethod?: string | null, preferredMethodOfContact?: string | null, primaryContactFirstName?: string | null, primaryContactLastName?: string | null, relationsManagerId?: string | null, establishedAt?: any | null, yearsInBusiness?: number | null, salesPitch?: string | null, licensesAndCertifications?: string | null, petPolicy?: string | null, bookingToken?: string | null, bookingToolEnabled?: boolean | null, displayRatesInBookingTool?: boolean | null, videoUrl?: string | null, logoUrl?: string | null, facebookUrl?: string | null, instagramUrl?: string | null, twitterUrl?: string | null, linkedinUrl?: string | null, venmoHandle?: string | null, zelleHandle?: string | null, spokenLanguages?: Array<string> | null, stripeAccountId?: string | null, stripeAccountCanCharge?: boolean | null, squareMerchantId?: string | null, squareAccessToken?: string | null, squareRefreshToken?: string | null, squareTokenExpiresAt?: any | null, bodilyInjuryPerPerson?: number | null, insuranceCombinedSingleLimitPerAccident?: number | null, bodilyInjuryPerAccident?: number | null, propertyDamagePerAccident?: number | null, workersCompensantionLiabilityCoverage: boolean, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null }> | null } | null } | null };

export type LinkUserIdentityMutationVariables = Exact<{ [key: string]: never; }>;


export type LinkUserIdentityMutation = { __typename?: 'Mutation', linkUserIdentity?: { __typename?: 'LinkUserIdentityResult', userIdentity?: { __typename?: 'UserIdentity', id: string } | null } | null };

export type GetAllCompaniesQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  perPage?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAllCompaniesQuery = { __typename?: 'Query', companyQueries?: { __typename?: 'CompanyQueries', findByAccount?: Array<{ __typename?: 'CompanyRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, sourceProduct: ProductType, type: CompanyTypeEnum, addresses?: Array<{ __typename?: 'CompanyAddressRecord', id: any, type: AddressTypeEnum, addressLineOne: string, addressLineTwo?: string | null, addressLineThree?: string | null, addressLineFour?: string | null, locality: string, region: string, postalCode: string, country: string, formattedAddress: string }> | null, emails?: Array<{ __typename?: 'CompanyEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, phoneNumbers?: Array<{ __typename?: 'CompanyPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, rates?: Array<{ __typename?: 'CompanyRateSetRecord', id: any, companyId: any, rateSetId: any }> | null, clients?: Array<{ __typename?: 'ClientRecord', accountId: string, isActive?: boolean | null, id: any, name?: string | null, primaryRole: ClientRole, sourceProduct: ProductType, title?: string | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, addresses?: Array<{ __typename?: 'ClientAddressRecord', id: any, type: AddressTypeEnum, addressLineOne: string, addressLineTwo?: string | null, addressLineThree?: string | null, addressLineFour?: string | null, locality: string, region: string, postalCode: string, country: string, formattedAddress: string }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, rates?: Array<{ __typename?: 'ClientRateSetRecord', id: any, clientId: any, rateSetId: any }> | null }> | null }> | null } | null };

export type FilterCompaniesQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  type?: InputMaybe<CompanyTypeEnum>;
  name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  perPage?: InputMaybe<Scalars['Float']>;
  skip?: InputMaybe<Scalars['Float']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<OrderByDirection>;
}>;


export type FilterCompaniesQuery = { __typename?: 'Query', companyQueries?: { __typename?: 'CompanyQueries', search?: { __typename?: 'CompanySearchResponse', total: number, items: Array<{ __typename?: 'CompanyRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, sourceProduct: ProductType, type: CompanyTypeEnum, addresses?: Array<{ __typename?: 'CompanyAddressRecord', id: any, type: AddressTypeEnum, addressLineOne: string, addressLineTwo?: string | null, addressLineThree?: string | null, addressLineFour?: string | null, locality: string, region: string, postalCode: string, country: string, formattedAddress: string }> | null, emails?: Array<{ __typename?: 'CompanyEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, phoneNumbers?: Array<{ __typename?: 'CompanyPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, rates?: Array<{ __typename?: 'CompanyRateSetRecord', id: any, companyId: any, rateSetId: any }> | null, clients?: Array<{ __typename?: 'ClientRecord', accountId: string, isActive?: boolean | null, id: any, name?: string | null, primaryRole: ClientRole, sourceProduct: ProductType, title?: string | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, addresses?: Array<{ __typename?: 'ClientAddressRecord', id: any, type: AddressTypeEnum, addressLineOne: string, addressLineTwo?: string | null, addressLineThree?: string | null, addressLineFour?: string | null, locality: string, region: string, postalCode: string, country: string, formattedAddress: string }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, rates?: Array<{ __typename?: 'ClientRateSetRecord', id: any, clientId: any, rateSetId: any }> | null }> | null }> } | null } | null };

export type AddCompanyMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  type: CompanyTypeEnum;
  isActive: Scalars['Boolean'];
  insertCompanyId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  rates?: InputMaybe<Array<CompanyRateInput> | CompanyRateInput>;
}>;


export type AddCompanyMutation = { __typename?: 'Mutation', insertCompany: { __typename?: 'CompanyRecord', accountId: string, id: any, name?: string | null, note?: string | null, type: CompanyTypeEnum, rates?: Array<{ __typename?: 'CompanyRateSetRecord', companyId: any, id: any, rateSetId: any }> | null } };

export type InsertClientMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  primaryRole: ClientRole;
  isActive: Scalars['Boolean'];
  insertClientId?: InputMaybe<Scalars['UUID']>;
  companyId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<ClientEmailInput> | ClientEmailInput>;
  phoneNumbers?: InputMaybe<Array<ClientPhoneInput> | ClientPhoneInput>;
  rates?: InputMaybe<Array<ClientRateInput> | ClientRateInput>;
  tripClient?: InputMaybe<TripClientInput>;
  note?: InputMaybe<Scalars['String']>;
}>;


export type InsertClientMutation = { __typename?: 'Mutation', insertClient: { __typename?: 'ClientRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, primaryRole: ClientRole, sourceProduct: ProductType, title?: string | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, rates?: Array<{ __typename?: 'ClientRateSetRecord', id: any, clientId: any, rateSetId: any }> | null, tripClients?: Array<{ __typename?: 'TripClientRecord', id: any, role: ClientRole, tripId: any, clientId: any }> | null } };

export type UpdateClientMutationVariables = Exact<{
  updateClientId: Scalars['UUID'];
  companyId?: InputMaybe<Scalars['UUID']>;
  primaryRole?: InputMaybe<ClientRole>;
  title?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<ClientRateInput>;
  emails?: InputMaybe<Array<ClientEmailInput> | ClientEmailInput>;
  phoneNumbers?: InputMaybe<Array<ClientPhoneInput> | ClientPhoneInput>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  booker?: InputMaybe<Scalars['String']>;
  passenger?: InputMaybe<Scalars['String']>;
  tripClient?: InputMaybe<TripClientInput>;
  note?: InputMaybe<Scalars['String']>;
  disconnectCompanyId?: InputMaybe<Scalars['UUID']>;
  tripClientRole?: InputMaybe<UpdateTripClientRoleInput>;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'ClientRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, primaryRole: ClientRole, sourceProduct: ProductType, title?: string | null, bookers?: Array<{ __typename?: 'ClientRecord', id: any, name?: string | null, isActive?: boolean | null, primaryRole: ClientRole }> | null, companies?: Array<{ __typename?: 'CompanyRecord', accountId: string, id: any, name?: string | null, isActive?: boolean | null, note?: string | null }> | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, passengers?: Array<{ __typename?: 'ClientRecord', id: any, name?: string | null, isActive?: boolean | null }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, rates?: Array<{ __typename?: 'ClientRateSetRecord', id: any, clientId: any, rateSetId: any }> | null, tripClients?: Array<{ __typename?: 'TripClientRecord', id: any, tripId: any, clientId: any, isPrimary: boolean, role: ClientRole, guests?: number | null }> | null } };

export type ClientByIdQueryVariables = Exact<{
  clientId: Scalars['UUID'];
}>;


export type ClientByIdQuery = { __typename?: 'Query', clientQueries?: { __typename?: 'ClientsQueries', getClientById?: { __typename?: 'ClientRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, primaryRole: ClientRole, title?: string | null, addresses?: Array<{ __typename?: 'ClientAddressRecord', id: any, type: AddressTypeEnum, addressLineOne: string, addressLineTwo?: string | null, addressLineThree?: string | null, addressLineFour?: string | null, locality: string, region: string, postalCode: string, country: string, formattedAddress: string }> | null, bookers?: Array<{ __typename?: 'ClientRecord', id: any, name?: string | null, title?: string | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null }> | null, companies?: Array<{ __typename?: 'CompanyRecord', id: any, name?: string | null, note?: string | null, type: CompanyTypeEnum }> | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, passengers?: Array<{ __typename?: 'ClientRecord', id: any, name?: string | null, isActive?: boolean | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, rates?: Array<{ __typename?: 'ClientRateSetRecord', id: any, clientId: any, rateSetId: any }> | null, tripClients?: Array<{ __typename?: 'TripClientRecord', id: any, tripId: any, clientId: any, isPrimary: boolean, role: ClientRole, guests?: number | null }> | null } | null } | null };

export type CompanyByIdQueryVariables = Exact<{
  companyId: Scalars['UUID'];
}>;


export type CompanyByIdQuery = { __typename?: 'Query', companyQueries?: { __typename?: 'CompanyQueries', getById?: { __typename?: 'CompanyRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, type: CompanyTypeEnum, emails?: Array<{ __typename?: 'CompanyEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, phoneNumbers?: Array<{ __typename?: 'CompanyPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, rates?: Array<{ __typename?: 'CompanyRateSetRecord', id: any, companyId: any, rateSetId: any }> | null, clients?: Array<{ __typename?: 'ClientRecord', tripClients?: Array<{ __typename?: 'TripClientRecord', tripId: any }> | null }> | null } | null } | null };

export type ClientsByCompanyIdQueryVariables = Exact<{
  companyId: Scalars['UUID'];
  skip?: Scalars['Float'];
  perPage?: Scalars['Float'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type ClientsByCompanyIdQuery = { __typename?: 'Query', clientQueries?: { __typename?: 'ClientsQueries', getClientsByCompanyId?: Array<{ __typename?: 'ClientRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, primaryRole: ClientRole, sourceProduct: ProductType, title?: string | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, rates?: Array<{ __typename?: 'ClientRateSetRecord', id: any, clientId: any, rateSetId: any }> | null }> | null } | null };

export type UpdateCompanyMutationVariables = Exact<{
  updateCompanyId: Scalars['UUID'];
  type?: InputMaybe<CompanyTypeEnum>;
  name?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<ClientEmailInput> | ClientEmailInput>;
  phoneNumbers?: InputMaybe<Array<ClientPhoneInput> | ClientPhoneInput>;
  rate?: InputMaybe<CompanyRateInput>;
  isActive?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCompanyMutation = { __typename?: 'Mutation', updateCompany: { __typename?: 'CompanyRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, type: CompanyTypeEnum, emails?: Array<{ __typename?: 'CompanyEmailRecord', email: string, id: any, type: EmailTypeEnum }> | null, phoneNumbers?: Array<{ __typename?: 'CompanyPhoneRecord', id: any, phoneNumber: string, type: PhoneTypeEnum }> | null, rates?: Array<{ __typename?: 'CompanyRateSetRecord', companyId: any, id: any, rateSetId: any }> | null } };

export type GetAllAccountClientsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  companyId?: InputMaybe<Scalars['UUID']>;
  clientId?: InputMaybe<Scalars['UUID']>;
  orderBy?: InputMaybe<OrderByDirection>;
  primaryRole?: InputMaybe<ClientRole>;
  skip?: Scalars['Float'];
  perPage?: Scalars['Float'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  tripIds?: InputMaybe<Array<Scalars['UUID']> | Scalars['UUID']>;
}>;


export type GetAllAccountClientsQuery = { __typename?: 'Query', clientQueries?: { __typename?: 'ClientsQueries', searchClients?: { __typename?: 'ClientSearchResponse', total: number, items: Array<{ __typename?: 'ClientRecord', accountId: string, id: any, name?: string | null, isActive?: boolean | null, primaryRole: ClientRole, title?: string | null, addresses?: Array<{ __typename?: 'ClientAddressRecord', id: any, type: AddressTypeEnum, addressLineOne: string, addressLineTwo?: string | null, addressLineThree?: string | null, addressLineFour?: string | null, locality: string, region: string, postalCode: string, country: string, formattedAddress: string }> | null, bookers?: Array<{ __typename?: 'ClientRecord', id: any, name?: string | null, note?: string | null, isActive?: boolean | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null }> | null, companies?: Array<{ __typename?: 'CompanyRecord', id: any, isActive?: boolean | null, name?: string | null, note?: string | null, accountId: string }> | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, passengers?: Array<{ __typename?: 'ClientRecord', id: any, name?: string | null, isActive?: boolean | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, rates?: Array<{ __typename?: 'ClientRateSetRecord', id: any, clientId: any, rateSetId: any }> | null, tripClients?: Array<{ __typename?: 'TripClientRecord', id: any, tripId: any, clientId: any, isPrimary: boolean, role: ClientRole, guests?: number | null }> | null }> } | null } | null };

export type GetTripClientsByTripIdsQueryVariables = Exact<{
  tripIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetTripClientsByTripIdsQuery = { __typename?: 'Query', clientQueries?: { __typename?: 'ClientsQueries', getTripClientsByTripIds?: Array<{ __typename?: 'TripClientRecord', isPrimary: boolean, id: any, role: ClientRole, tripId: any, clientId: any, guests?: number | null, client?: { __typename?: 'ClientRecord', id: any, accountId: string, name?: string | null, sourceProduct: ProductType, primaryRole: ClientRole, title?: string | null, note?: string | null, isActive?: boolean | null, companies?: Array<{ __typename?: 'CompanyRecord', accountId: string, id: any, name?: string | null, isActive?: boolean | null, note?: string | null, sourceProduct: ProductType, type: CompanyTypeEnum, emails?: Array<{ __typename?: 'CompanyEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, addresses?: Array<{ __typename?: 'CompanyAddressRecord', id: any, type: AddressTypeEnum, addressLineOne: string, addressLineTwo?: string | null, addressLineThree?: string | null, addressLineFour?: string | null, locality: string, region: string, postalCode: string, country: string, formattedAddress: string }> | null, phoneNumbers?: Array<{ __typename?: 'CompanyPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, addresses?: Array<{ __typename?: 'ClientAddressRecord', id: any, type: AddressTypeEnum, addressLineOne: string, addressLineTwo?: string | null, addressLineThree?: string | null, addressLineFour?: string | null, locality: string, region: string, postalCode: string, country: string, formattedAddress: string }> | null } | null }> | null } | null };

export type GetClientsByNameAndAccountQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  query: Scalars['String'];
}>;


export type GetClientsByNameAndAccountQuery = { __typename?: 'Query', clientQueries?: { __typename?: 'ClientsQueries', getByNameAndAccount?: Array<{ __typename?: 'ClientRecord', accountId: string, name?: string | null, id: any, primaryRole: ClientRole, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, companies?: Array<{ __typename?: 'CompanyRecord', name?: string | null, id: any, emails?: Array<{ __typename?: 'CompanyEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null }> | null }> | null } | null };

export type GetClientsByTripIdQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  tripId: Scalars['UUID'];
}>;


export type GetClientsByTripIdQuery = { __typename?: 'Query', clientQueries?: { __typename?: 'ClientsQueries', searchClients?: { __typename?: 'ClientSearchResponse', items: Array<{ __typename?: 'ClientRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, primaryRole: ClientRole, title?: string | null, addresses?: Array<{ __typename?: 'ClientAddressRecord', id: any, type: AddressTypeEnum, addressLineOne: string, addressLineTwo?: string | null, addressLineThree?: string | null, addressLineFour?: string | null, locality: string, region: string, postalCode: string, country: string, formattedAddress: string }> | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null }> } | null } | null };

export type FindCompanyByAccountAndNameQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  query: Scalars['String'];
}>;


export type FindCompanyByAccountAndNameQuery = { __typename?: 'Query', companyQueries?: { __typename?: 'CompanyQueries', findByAccountAndName?: Array<{ __typename?: 'CompanyRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, type: CompanyTypeEnum }> | null } | null };

export type GetClientsByRateSetsQueryVariables = Exact<{
  rateSetIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetClientsByRateSetsQuery = { __typename?: 'Query', clientQueries?: { __typename?: 'ClientsQueries', getClientsByRateSetIds?: Array<{ __typename?: 'ClientsByRateResponse', rateSetId: any, clients: Array<{ __typename?: 'ClientRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, primaryRole: ClientRole, title?: string | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null }> }> | null } | null };

export type GetCompaniesByRateSetsQueryVariables = Exact<{
  rateSetIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetCompaniesByRateSetsQuery = { __typename?: 'Query', companyQueries?: { __typename?: 'CompanyQueries', getCompaniesByRateSets?: Array<{ __typename?: 'CompaniesByRateResponse', rateSetId: any, companies: Array<{ __typename?: 'CompanyRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, type: CompanyTypeEnum, emails?: Array<{ __typename?: 'CompanyEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, phoneNumbers?: Array<{ __typename?: 'CompanyPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null }> }> | null } | null };

export type GetClientsByEmailAndAccountQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  query: Scalars['String'];
}>;


export type GetClientsByEmailAndAccountQuery = { __typename?: 'Query', clientQueries?: { __typename?: 'ClientsQueries', getByEmailAndAccount?: Array<{ __typename?: 'ClientRecord', accountId: string, id: any, isActive?: boolean | null, name?: string | null, note?: string | null, primaryRole: ClientRole, companies?: Array<{ __typename?: 'CompanyRecord', id: any, isActive?: boolean | null, name?: string | null, note?: string | null, accountId: string, type: CompanyTypeEnum }> | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, tripClients?: Array<{ __typename?: 'TripClientRecord', clientId: any, id: any, isPrimary: boolean, role: ClientRole, tripId: any, guests?: number | null }> | null }> | null } | null };

export type GetTripClientsByTripQueryVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type GetTripClientsByTripQuery = { __typename?: 'Query', clientQueries?: { __typename?: 'ClientsQueries', getTripClientsByTrip?: Array<{ __typename?: 'TripClientRecord', id: any, isPrimary: boolean, clientId: any, role: ClientRole, tripId: any, guests?: number | null, client?: { __typename?: 'ClientRecord', isActive?: boolean | null, id: any, name?: string | null, note?: string | null, primaryRole: ClientRole, companies?: Array<{ __typename?: 'CompanyRecord', id: any, name?: string | null, note?: string | null, isActive?: boolean | null }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null } | null }> | null } | null };

export type DeleteTripClientMutationVariables = Exact<{
  tripClientId: Scalars['UUID'];
}>;


export type DeleteTripClientMutation = { __typename?: 'Mutation', deleteTripClient: boolean };

export type FilterAllContactsQueryVariables = Exact<{
  query: Scalars['String'];
  type?: InputMaybe<ContactType>;
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderByDirection>;
  userRole?: InputMaybe<UserRole>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type FilterAllContactsQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactQueries', search: { __typename?: 'ContactCollectionResult', items: Array<{ __typename?: 'Contact', id: any, name?: string | null, email: string, phoneNumber?: string | null, isActive: boolean, userRole: UserRole, contactType: ContactType, note?: string | null, addresses?: Array<{ __typename?: 'Location', id: any, name: string, category?: LocationCategory | null, addressLine1?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null, timezone?: string | null, coordinates: any }> | null }> } } };

export type GetContactByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetContactByIdQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactQueries', byId?: { __typename?: 'Contact', id: any, name?: string | null, email: string, phoneNumber?: string | null, isActive: boolean, userRole: UserRole, contactType: ContactType, note?: string | null, addresses?: Array<{ __typename?: 'Location', id: any, name: string, category?: LocationCategory | null, addressLine1?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null, timezone?: string | null, coordinates: any }> | null } | null } };

export type UpdateContactNoteMutationVariables = Exact<{
  contact: UpdateContactNote;
}>;


export type UpdateContactNoteMutation = { __typename?: 'Mutation', updateContactNote?: { __typename?: 'UpdateContactNoteResult', success: boolean, note?: string | null, errors?: Array<{ __typename?: 'MutationError', message: string }> | null } | null };

export type GetAllDriversQueryVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type GetAllDriversQuery = { __typename?: 'Query', drivers: { __typename?: 'DriverQueries', all: { __typename?: 'DriverCollectionResult', items: Array<{ __typename?: 'Driver', id: any, contact: { __typename?: 'Contact', name?: string | null } }> } } };

export type SearchDriversQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderByDirection>;
  driverId?: InputMaybe<Scalars['UUID']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  userRole?: InputMaybe<UserRole>;
}>;


export type SearchDriversQuery = { __typename?: 'Query', drivers: { __typename?: 'DriverQueries', all: { __typename?: 'DriverCollectionResult', total: number, items: Array<{ __typename?: 'Driver', id: any, isActive: boolean, garageId?: any | null, contact: { __typename?: 'Contact', email: string, name?: string | null, id: any, title?: string | null, phoneNumber?: string | null, profileImageUrl?: string | null, userRole: UserRole } }> } } };

export type SearchDriversFromVendorsMicroServiceQueryVariables = Exact<{
  searchDriversId?: InputMaybe<Scalars['UUID']>;
  vendorId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  includeInactive: Scalars['Boolean'];
  providerType?: InputMaybe<ProviderType>;
  status?: InputMaybe<DriverStatus>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderByDirection>;
}>;


export type SearchDriversFromVendorsMicroServiceQuery = { __typename?: 'Query', driverQueries?: { __typename?: 'DriversQueries', searchDrivers?: Array<{ __typename?: 'DriverRecord', id: any, vendorId: any, userId?: any | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, drivingSince?: any | null, isPrimary?: boolean | null, isActive?: boolean | null, profileImageUrl?: string | null, profileImageUpdatedAt?: any | null, profileImageSignedUrl?: string | null, bio?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, driverProviders?: Array<{ __typename?: 'DriverProviderRecord', id: any, driverId: any, providerType: ProviderType, agentProfileUrl?: string | null, agentProfileFileUpdatedAt?: any | null, agentProfileSignedUrl?: string | null, backgroundCheckDate?: any | null, drugTestDate?: any | null, profileImageVerified?: boolean | null, approved?: boolean | null, status: DriverStatus, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null }> | null }> | null } | null };

export type GetAvailableDriversQueryVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type GetAvailableDriversQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', availableDrivers: { __typename?: 'AvailableDrivers', internal: Array<{ __typename?: 'DriverAvailabilitySummary', availability: DriverAvailability, next?: { __typename?: 'UnavailablePeriod', startTime: any, endTime?: any | null, availability: DriverAvailability, trip?: { __typename?: 'RelatedTrip', id: any, tripNumber: string, estimatedAvailabilityTime: any } | null } | null, overlapping: Array<{ __typename?: 'UnavailablePeriod', startTime: any, endTime?: any | null, availability: DriverAvailability, trip?: { __typename?: 'RelatedTrip', id: any, tripNumber: string, estimatedAvailabilityTime: any } | null }>, previous?: { __typename?: 'UnavailablePeriod', startTime: any, endTime?: any | null, availability: DriverAvailability, trip?: { __typename?: 'RelatedTrip', id: any, tripNumber: string, estimatedAvailabilityTime: any } | null } | null, driver: { __typename?: 'AvailableDriver', id: any, name: string, imageUrl?: string | null } }> } } };

export type GetDriversAvailabilityQueryVariables = Exact<{
  criteria: AvailabilityQueryCriteria;
}>;


export type GetDriversAvailabilityQuery = { __typename?: 'Query', drivers: { __typename?: 'DriverQueries', available: Array<{ __typename?: 'DriverAvailabilitySummary', availability: DriverAvailability, driver: { __typename?: 'AvailableDriver', id: any, imageUrl?: string | null, name: string }, next?: { __typename?: 'UnavailablePeriod', startTime: any, endTime?: any | null } | null, previous?: { __typename?: 'UnavailablePeriod', startTime: any, endTime?: any | null } | null, overlapping: Array<{ __typename?: 'UnavailablePeriod', startTime: any, endTime?: any | null, availability: DriverAvailability, trip?: { __typename?: 'RelatedTrip', id: any } | null }> }> } };

export type FetchDriverByIdQueryVariables = Exact<{
  driverId: Scalars['UUID'];
}>;


export type FetchDriverByIdQuery = { __typename?: 'Query', drivers: { __typename?: 'DriverQueries', byId?: { __typename?: 'Driver', drivingSince?: any | null, id: any, marketingDescription?: string | null, videoUrl?: string | null, accountId: any, garage?: { __typename?: 'Garage', id: any, location: { __typename?: 'Location', addressLine1?: string | null, addressLine2?: string | null, coordinates: any, city?: string | null, state?: string | null, postalCode?: string | null } } | null, contact: { __typename?: 'Contact', email: string, name?: string | null, id: any, title?: string | null, phoneNumber?: string | null, profileImageUrl?: string | null, userRole: UserRole } } | null } };

export type UpdateDriverMutationVariables = Exact<{
  driver: UpdateDriver;
}>;


export type UpdateDriverMutation = { __typename?: 'Mutation', updateDriver?: { __typename?: 'UpdateDriverResult', success: boolean, driver?: { __typename?: 'Driver', marketingDescription?: string | null, drivingSince?: any | null, accountId: any, id: any, contact: { __typename?: 'Contact', email: string, name?: string | null, id: any, title?: string | null, phoneNumber?: string | null, profileImageUrl?: string | null, userRole: UserRole } } | null, errors?: Array<{ __typename?: 'MutationError', message: string }> | null } | null };

export type CreateMsDriverRecordMutationVariables = Exact<{
  driverCreateArgs: DriverCreateArgs;
}>;


export type CreateMsDriverRecordMutation = { __typename?: 'Mutation', createDriverRecord: { __typename?: 'DriverRecord', id: any, vendorId: any, userId?: any | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, drivingSince?: any | null, isPrimary?: boolean | null, isActive?: boolean | null, profileImageUrl?: string | null, profileImageUpdatedAt?: any | null, profileImageSignedUrl?: string | null, bio?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, driverProviders?: Array<{ __typename?: 'DriverProviderRecord', id: any, driverId: any, providerType: ProviderType, agentProfileUrl?: string | null, agentProfileFileUpdatedAt?: any | null, agentProfileSignedUrl?: string | null, backgroundCheckDate?: any | null, drugTestDate?: any | null, profileImageVerified?: boolean | null, approved?: boolean | null, status: DriverStatus, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null }> | null } };

export type UpdateMsDriverRecordMutationVariables = Exact<{
  driverUpdateArgs: DriverUpdateArgs;
}>;


export type UpdateMsDriverRecordMutation = { __typename?: 'Mutation', updateDriverRecord: { __typename?: 'DriverRecord', id: any, vendorId: any, userId?: any | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, drivingSince?: any | null, isPrimary?: boolean | null, isActive?: boolean | null, profileImageUrl?: string | null, profileImageUpdatedAt?: any | null, profileImageSignedUrl?: string | null, bio?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, driverProviders?: Array<{ __typename?: 'DriverProviderRecord', id: any, driverId: any, providerType: ProviderType, agentProfileUrl?: string | null, agentProfileFileUpdatedAt?: any | null, agentProfileSignedUrl?: string | null, backgroundCheckDate?: any | null, drugTestDate?: any | null, profileImageVerified?: boolean | null, approved?: boolean | null, status: DriverStatus, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null }> | null } };

export type GetDriversByVendorIdQueryVariables = Exact<{
  vendorId?: InputMaybe<Scalars['UUID']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetDriversByVendorIdQuery = { __typename?: 'Query', driverQueries?: { __typename?: 'DriversQueries', getDriversByVendorId?: Array<{ __typename?: 'DriverRecord', id: any, vendorId: any, userId?: any | null, firstName?: string | null, lastName?: string | null, email?: string | null, bio?: string | null, drivingSince?: any | null, isPrimary?: boolean | null, phoneNumber?: string | null, profileImageSignedUrl?: string | null, profileImageUpdatedAt?: any | null, profileImageUrl?: string | null, isActive?: boolean | null, deleted?: any | null, createdAt?: any | null, updatedAt?: any | null, driverProviders?: Array<{ __typename?: 'DriverProviderRecord', id: any, agentProfileFileUpdatedAt?: any | null, agentProfileSignedUrl?: string | null, agentProfileUrl?: string | null, approved?: boolean | null, status: DriverStatus, backgroundCheckDate?: any | null, driverId: any, drugTestDate?: any | null, profileImageVerified?: boolean | null, providerType: ProviderType, deleted?: any | null, createdAt?: any | null, updatedAt?: any | null }> | null }> | null } | null };

export type GetDriverByIdQueryVariables = Exact<{
  driverId: Scalars['UUID'];
}>;


export type GetDriverByIdQuery = { __typename?: 'Query', driverQueries?: { __typename?: 'DriversQueries', getDriverById?: { __typename?: 'DriverRecord', id: any, vendorId: any, userId?: any | null, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, drivingSince?: any | null, isPrimary?: boolean | null, isActive?: boolean | null, profileImageUrl?: string | null, profileImageUpdatedAt?: any | null, profileImageSignedUrl?: string | null, bio?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, driverProviders?: Array<{ __typename?: 'DriverProviderRecord', id: any, driverId: any, providerType: ProviderType, agentProfileUrl?: string | null, agentProfileFileUpdatedAt?: any | null, agentProfileSignedUrl?: string | null, backgroundCheckDate?: any | null, drugTestDate?: any | null, profileImageVerified?: boolean | null, approved?: boolean | null, status: DriverStatus, rejectionReason?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null }> | null } | null } | null };

export type GetMsDriverFilesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetMsDriverFilesQuery = { __typename?: 'Query', driverQueries?: { __typename?: 'DriversQueries', driverFiles?: { __typename?: 'FilesResponse', documents?: Array<{ __typename?: 'SignedUrlResponse', key: string, signedUrl: string, mimeType: string }> | null, images?: Array<{ __typename?: 'SignedUrlResponse', key: string, signedUrl: string, mimeType: string }> | null } | null } | null };

export type DeleteMsDriverFileMutationVariables = Exact<{
  deleteDriverFileArgs: DriverDeleteFileArgs;
}>;


export type DeleteMsDriverFileMutation = { __typename?: 'Mutation', deleteDriverFile: { __typename?: 'DeletedResult', deleted: boolean } };

export type CreateMsDriverFilesUploadSignedUrlsMutationVariables = Exact<{
  driverFilesUploadArgs: DriverFilesUploadArgs;
}>;


export type CreateMsDriverFilesUploadSignedUrlsMutation = { __typename?: 'Mutation', createDriverFilesUploadSignedUrls: Array<{ __typename?: 'FileSignedUrl', filetype: FileTypeEnum, key?: string | null, filename?: string | null, signedUrl: string, mimeType?: string | null }> };

export type DeleteSavoyaDriverMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteSavoyaDriverMutation = { __typename?: 'Mutation', deleteSavoyaDriver: { __typename?: 'DeletedResult', deleted: boolean } };

export type GetGaragesQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetGaragesQuery = { __typename?: 'Query', garages: { __typename?: 'GarageQueries', byId?: { __typename?: 'Garage', id: any, name: string, location: { __typename?: 'Location', id: any, name: string, city?: string | null, state?: string | null, postalCode?: string | null, timezone?: string | null, addressLine1?: string | null, abbreviation?: string | null, coordinates: any, placeName?: string | null } } | null } };

export type UpdateGarageMutationVariables = Exact<{
  garage: UpdateGarageWithLocation;
}>;


export type UpdateGarageMutation = { __typename?: 'Mutation', updateGarage?: { __typename?: 'UpdateGarageResult', success: boolean } | null };

export type GetMarketsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type GetMarketsQuery = { __typename?: 'Query', markets: { __typename?: 'MarketQueries', all: { __typename?: 'MarketCollectionResult', total: number, items: Array<{ __typename?: 'Market', id: any, name: string, abbreviation: string }> } } };

export type GetSystemVehicleClassesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type GetSystemVehicleClassesQuery = { __typename?: 'Query', systemVehicleClasses: { __typename?: 'SystemVehicleClassQueries', all: { __typename?: 'SystemVehicleClassCollectionResult', total: number, items: Array<{ __typename?: 'SystemVehicleClass', id: string, name: string }> } } };

export type CreateAccountFromTemplateMutationVariables = Exact<{
  onboardingTemplate: IndependentOperatorOnboardingTemplate;
}>;


export type CreateAccountFromTemplateMutation = { __typename?: 'Mutation', createAccountFromTemplate?: { __typename?: 'AccountTemplateResult', success?: boolean | null, account?: { __typename?: 'Account', id: any } | null } | null };

export type GetTimeZonesQueryVariables = Exact<{
  timezone: MapTimeZoneInput;
}>;


export type GetTimeZonesQuery = { __typename?: 'Query', locations: { __typename?: 'LocationQueries', timeZones?: { __typename?: 'TimeZonesResult', status: string, timeZoneName: string, timeZoneId: string } | null } };

export type QueryAllTransferRatesQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type QueryAllTransferRatesQuery = { __typename?: 'Query', rates: { __typename?: 'RateQueries', searchTransferRates: { __typename?: 'RateSetCollectionResult', items: Array<{ __typename?: 'RateSet', id: any, name: string, description?: string | null, rates: Array<{ __typename?: 'Rate', id: any, name: string, calculation?: RateCalculation | null, vehicleClassOverrides: Array<{ __typename?: 'VehicleClassOverride', id: any, amount: number, vehicleClass: { __typename?: 'VehicleClass', name: string, id: any } }> }>, customers: Array<{ __typename?: 'CustomerRateSet', customer: { __typename?: 'Customer', id: any, name: string } }>, tripRule?: { __typename?: 'TripRule', id: any, firstLocationMatchType?: LocationMatchType | null, secondLocationMatchType?: LocationMatchType | null, firstLocation?: { __typename?: 'Location', id: any, placeId?: string | null, zoneType: ZoneType, radiusInKm?: number | null, placeName?: string | null, name: string, coordinates: any } | null, secondLocation?: { __typename?: 'Location', id: any, placeId?: string | null, zoneType: ZoneType, radiusInKm?: number | null, placeName?: string | null, name: string, coordinates: any } | null } | null }> } } };

export type GetVehicleHourlyRatesQueryVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type GetVehicleHourlyRatesQuery = { __typename?: 'Query', vehicleClasses: { __typename?: 'VehicleClassQueries', all: { __typename?: 'VehicleClassCollectionResult', items: Array<{ __typename?: 'VehicleClass', name: string, hourlyRate?: number | null, id: any, minimumHours?: number | null, cancellationPolicyHours?: number | null }> } } };

export type UpdateVehicleHourlyRateMutationVariables = Exact<{
  id: Scalars['UUID'];
  hourlyRate: Scalars['Float'];
}>;


export type UpdateVehicleHourlyRateMutation = { __typename?: 'Mutation', updateVehicleClass?: { __typename?: 'UpdateVehicleClassResult', vehicleClass?: { __typename?: 'VehicleClass', id: any } | null } | null };

export type GetDefaultRatesQueryVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type GetDefaultRatesQuery = { __typename?: 'Query', rates: { __typename?: 'RateQueries', searchDefaultRates: { __typename?: 'RateSetCollectionResult', items: Array<{ __typename?: 'RateSet', rates: Array<{ __typename?: 'Rate', meteredRateIncrement?: number | null, revertToDynamicForExcessWaitTime?: boolean | null, id: any, ratePolicies: Array<{ __typename?: 'RatePolicy', type: RatePolicyType, thresholdValue?: number | null, thresholdValue2?: number | null, id: any }> }> }> } } };

export type UpdateMeteredRateIncrementMutationVariables = Exact<{
  rateId: Scalars['UUID'];
  meteredRateIncrement: Scalars['Int'];
}>;


export type UpdateMeteredRateIncrementMutation = { __typename?: 'Mutation', updateRate?: { __typename?: 'UpdateRateResult', rate?: { __typename?: 'Rate', id: any } | null } | null };

export type UpdateRevertToDynamicForExcessWaitTimeMutationVariables = Exact<{
  rateId: Scalars['UUID'];
  revertToDynamicForExcessWaitTime: Scalars['Boolean'];
}>;


export type UpdateRevertToDynamicForExcessWaitTimeMutation = { __typename?: 'Mutation', updateRate?: { __typename?: 'UpdateRateResult', rate?: { __typename?: 'Rate', id: any } | null } | null };

export type UpdateDefaultRatesMutationVariables = Exact<{
  id: Scalars['UUID'];
  thresholdValue: Scalars['Float'];
  thresholdValue2?: InputMaybe<Scalars['Float']>;
}>;


export type UpdateDefaultRatesMutation = { __typename?: 'Mutation', updateRatePolicy?: { __typename?: 'UpdateRatePolicyResult', ratePolicy?: { __typename?: 'RatePolicy', id: any, thresholdValue?: number | null, thresholdValue2?: number | null, type: RatePolicyType } | null } | null };

export type CreateTransferRateSetMutationVariables = Exact<{
  newRateSet: InsertTransferRateSet;
}>;


export type CreateTransferRateSetMutation = { __typename?: 'Mutation', insertTransferRateSet?: { __typename?: 'InsertRateSetResult', success: boolean, rateSet?: { __typename?: 'RateSet', id: any, description?: string | null, name: string } | null } | null };

export type UpdateTransferRateSetMutationVariables = Exact<{
  newRateSet: UpdateTransferRateSet;
}>;


export type UpdateTransferRateSetMutation = { __typename?: 'Mutation', updateTransferRateSet?: { __typename?: 'UpdateRateSetResult', success: boolean, rateSet?: { __typename?: 'RateSet', id: any } | null } | null };

export type GetRateSetByIdsQueryVariables = Exact<{
  rateSetIds: Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>;
}>;


export type GetRateSetByIdsQuery = { __typename?: 'Query', rateSets: { __typename?: 'RateSetQueries', findByIds?: Array<{ __typename?: 'RateSet', isCustomerRate?: boolean | null, id: any, rates: Array<{ __typename?: 'Rate', id: any, calculation?: RateCalculation | null, amount?: number | null, defaultRate?: boolean | null, name: string, description?: string | null, accountId: any, rateType: { __typename?: 'RateType', category: RateCategory } }> } | null> | null } };

export type UpdateRateMutationVariables = Exact<{
  rate: UpdateRate;
}>;


export type UpdateRateMutation = { __typename?: 'Mutation', updateRate?: { __typename?: 'UpdateRateResult', success: boolean, rate?: { __typename?: 'Rate', id: any, amount?: number | null } | null, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null } | null };

export type UpsertCustomerDiscountMutationVariables = Exact<{
  customerDiscount: UpsertCustomerDiscountInput;
}>;


export type UpsertCustomerDiscountMutation = { __typename?: 'Mutation', upsertCustomerDiscount?: { __typename?: 'UpsertCustomerDiscountResult', rateSetId?: string | null, success: boolean, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null } | null };

export type UpsertClientDiscountMutationVariables = Exact<{
  clientDiscountRate: UpsertClientDiscountInput;
}>;


export type UpsertClientDiscountMutation = { __typename?: 'Mutation', upsertClientDiscount?: { __typename?: 'UpsertClientDiscountResult', rateSetId?: string | null, success: boolean, errors?: Array<{ __typename?: 'MutationError', code?: string | null, message: string }> | null } | null };

export type GetRateTypesQueryVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type GetRateTypesQuery = { __typename?: 'Query', rateTypes: { __typename?: 'RateTypeQueries', all: { __typename?: 'RateTypeCollectionResult', items: Array<{ __typename?: 'RateType', id: any, name: string, description?: string | null, category: RateCategory, favorite?: boolean | null }> } } };

export type InsertRateTypeMutationVariables = Exact<{
  name: Scalars['String'];
  category: RateCategory;
  accountId: Scalars['UUID'];
  description: Scalars['String'];
  favorite: Scalars['Boolean'];
}>;


export type InsertRateTypeMutation = { __typename?: 'Mutation', insertRateType?: { __typename?: 'InsertRateTypeResult', rateType?: { __typename?: 'RateType', id: any } | null } | null };

export type UpdateRateTypeMutationVariables = Exact<{
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<RateCategory>;
  description?: InputMaybe<Scalars['String']>;
  favorite?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateRateTypeMutation = { __typename?: 'Mutation', updateRateType?: { __typename?: 'UpdateRateTypeResult', rateType?: { __typename?: 'RateType', id: any } | null } | null };

export type DeleteRateTypeMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteRateTypeMutation = { __typename?: 'Mutation', deleteRateType?: { __typename?: 'DeleteRateTypeResult', success: boolean } | null };

export type DeleteRateSetMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteRateSetMutation = { __typename?: 'Mutation', deleteRateSet?: { __typename?: 'DeleteRateSetResult', success: boolean } | null };

export type ExportAnalyticsCsvMutationVariables = Exact<{
  query: Scalars['JSON'];
  columnDictionary: Scalars['JSON'];
}>;


export type ExportAnalyticsCsvMutation = { __typename?: 'Mutation', exportAnalyticsCSV: { __typename?: 'ExportAnalyticsCSVResult', url?: string | null, success: boolean, errors?: Array<{ __typename?: 'MutationError', code?: string | null, message: string }> | null } };

export type GetSquareAuthTokenLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSquareAuthTokenLinkQuery = { __typename?: 'Query', square?: { __typename?: 'SquareQueries', getSquareAuthTokenLink: { __typename?: 'GetSquareAuthTokenResponse', link: string, state?: string | null } } | null };

export type VerifySquareTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type VerifySquareTokenQuery = { __typename?: 'Query', square?: { __typename?: 'SquareQueries', verifySquareToken?: boolean | null } | null };

export type StripeGetRefreshLinkQueryVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type StripeGetRefreshLinkQuery = { __typename?: 'Query', stripe?: { __typename?: 'StripeQueries', getRefreshLink?: { __typename?: 'RefreshUserResponse', link?: string | null } | null } | null };

export type StripeOnboardUserMutationVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type StripeOnboardUserMutation = { __typename?: 'Mutation', onboardUser?: { __typename?: 'OnboardUserResponse', link?: string | null } | null };

export type StripeVerifyUserMutationVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type StripeVerifyUserMutation = { __typename?: 'Mutation', verifyUser?: { __typename?: 'VerifyUserResponse', chargesEnabled?: boolean | null, detailsSubmitted?: boolean | null, onboardingStarted?: boolean | null, pendingVerification?: boolean | null } | null };

export type StripeDisconnectUserMutationVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type StripeDisconnectUserMutation = { __typename?: 'Mutation', disconnectUser?: { __typename?: 'DisconnectUserResponse', chargesEnabled?: boolean | null, detailsSubmitted?: boolean | null, onboardingStarted?: boolean | null, pendingVerification?: boolean | null } | null };

export type RevokeSquareTokenMutationVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type RevokeSquareTokenMutation = { __typename?: 'Mutation', revokeSquareToken?: { __typename?: 'RevokeSquareTokenResponse', success: boolean, errors?: Array<{ __typename?: 'MutationError', code?: string | null, message: string }> | null } | null };

export type GetAccountAdjustmentsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type GetAccountAdjustmentsQuery = { __typename?: 'Query', accountAdjustments: { __typename?: 'AccountAdjustmentQueries', all: { __typename?: 'AccountAdjustmentCollectionResult', items: Array<{ __typename?: 'AccountAdjustment', active?: boolean | null, id: any, note?: string | null, amount: number, calculation?: AdjustmentCalculation | null, rateType: { __typename?: 'RateType', category: RateCategory, name: string } }> } } };

export type UpdateAccountAdjustmentMutationVariables = Exact<{
  accountAdjustment: UpdateAccountAdjustment;
}>;


export type UpdateAccountAdjustmentMutation = { __typename?: 'Mutation', updateAccountAdjustment?: { __typename?: 'UpdateAccountAdjustmentResult', accountAdjustment?: { __typename?: 'AccountAdjustment', id: any, amount: number, rateTypeId: any, calculation?: AdjustmentCalculation | null, active?: boolean | null } | null } | null };

export type GetDefaultNotificationPreferencesQueryVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type GetDefaultNotificationPreferencesQuery = { __typename?: 'Query', accountDefaultNotifications: { __typename?: 'AccountDefaultNotificationsQueries', all: { __typename?: 'AccountDefaultNotificationsCollectionResult', items: Array<{ __typename?: 'AccountDefaultNotifications', id: any, channels: Array<MessageChannel>, customerRole: CustomerRole, customerType: CustomerType, tripNotificationTypeId: any }> } } };

export type InsertAccountNotificationPreferencesMutationVariables = Exact<{
  accountDefaultNotifications: InsertAccountDefaultNotifications;
}>;


export type InsertAccountNotificationPreferencesMutation = { __typename?: 'Mutation', insertAccountDefaultNotifications?: { __typename?: 'InsertAccountDefaultNotificationsResult', accountDefaultNotifications?: { __typename?: 'AccountDefaultNotifications', id: any } | null } | null };

export type UpdateAccountNotificationPreferencesMutationVariables = Exact<{
  accountDefaultNotifications: UpdateAccountDefaultNotifications;
}>;


export type UpdateAccountNotificationPreferencesMutation = { __typename?: 'Mutation', updateAccountDefaultNotifications?: { __typename?: 'UpdateAccountDefaultNotificationsResult', accountDefaultNotifications?: { __typename?: 'AccountDefaultNotifications', id: any } | null } | null };

export type DeleteAccountNotificationPreferencesMutationVariables = Exact<{
  notificationId: Scalars['UUID'];
}>;


export type DeleteAccountNotificationPreferencesMutation = { __typename?: 'Mutation', deleteAccountDefaultNotifications?: { __typename?: 'DeleteAccountDefaultNotificationsResult', success: boolean } | null };

export type SubscriptionTiersByProductQueryVariables = Exact<{
  productType: ProductType;
}>;


export type SubscriptionTiersByProductQuery = { __typename?: 'Query', subscriptionTiersByProduct?: Array<{ __typename?: 'SubscriptionTier', id: string, name: string, description: string, code: TierCode, type: TierType, productType: ProductType, amount: any, currency: CurrencyCode, trialPeriodDays: number }> | null };

export type SignedUrlQueryVariables = Exact<{
  bucket: Scalars['String'];
  files: Array<FileData> | FileData;
}>;


export type SignedUrlQuery = { __typename?: 'Query', media?: { __typename?: 'MediaQueries', signedUrl: Array<{ __typename?: 'SignedURL', url: string, key: string, metadata?: { __typename?: 'FileMetadata', type?: string | null } | null } | null> } | null };

export type GetSignedUrlsQueryVariables = Exact<{
  bucket: Scalars['String'];
  key: Scalars['String'];
}>;


export type GetSignedUrlsQuery = { __typename?: 'Query', media?: { __typename?: 'MediaQueries', filesFromPath?: { __typename?: 'FileInfo', signedUrls: Array<{ __typename?: 'SignedURL', url: string, key: string, metadata?: { __typename?: 'FileMetadata', type?: string | null } | null } | null> } | null } | null };

export type DeleteFileMutationVariables = Exact<{
  fileInfo: FilesLocation;
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile?: { __typename?: 'DeleteFileResult', success: boolean, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null } | null };

export type ResendEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendEmailMutation = { __typename?: 'Mutation', resendVerificationEmail?: { __typename?: 'ResendVerificaitonEmailResult', success: boolean, error?: string | null } | null };

export type GetPreictionsQueryVariables = Exact<{
  predictionInput: PredictionInput;
}>;


export type GetPreictionsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationQueries', getPredictions: Array<{ __typename?: 'PlacePrediction', placeName?: string | null, placeId?: string | null }> } };

export type GetPlaceInfoQueryVariables = Exact<{
  placeId: Scalars['String'];
}>;


export type GetPlaceInfoQuery = { __typename?: 'Query', locations: { __typename?: 'LocationQueries', getPlaceInfo: { __typename?: 'GooglePlaceResponse', formatted_address?: string | null, name?: string | null, place_id?: string | null, types?: Array<string | null> | null, address_components?: Array<{ __typename?: 'GoogleAddressComponent', long_name?: string | null, short_name?: string | null, types?: Array<string | null> | null } | null> | null, geometry?: { __typename?: 'GoogleGeometry', location?: { __typename?: 'GoogleGeoLocation', lng?: number | null, lat?: number | null } | null, viewport?: { __typename?: 'GoogleViewport', south?: number | null, west?: number | null, east?: number | null, north?: number | null } | null } | null } } };

export type GetMerchantQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMerchantQuery = { __typename?: 'Query', square?: { __typename?: 'SquareQueries', getSquareMerchant?: { __typename?: 'SquareMerchant', mainLocationId?: string | null } | null } | null };

export type CreateSquareCustomerMutationVariables = Exact<{
  customerContactId: Scalars['UUID'];
}>;


export type CreateSquareCustomerMutation = { __typename?: 'Mutation', createSquareCustomer?: { __typename?: 'CreateSquareCustomerResponse', success: boolean, squareId?: string | null } | null };

export type CreateSquareCardMutationVariables = Exact<{
  input: CreateSquareCardInput;
}>;


export type CreateSquareCardMutation = { __typename?: 'Mutation', createSquareCard?: { __typename?: 'CreateSquareCardResponse', squareId?: string | null, success: boolean, errors?: Array<{ __typename?: 'MutationError', code?: string | null, message: string }> | null } | null };

export type SearchSquareCustomersQueryVariables = Exact<{
  referenceId?: InputMaybe<Scalars['String']>;
}>;


export type SearchSquareCustomersQuery = { __typename?: 'Query', square?: { __typename?: 'SquareQueries', searchSquareCustomers?: Array<{ __typename?: 'SquareCustomer', id?: string | null, referenceId?: string | null, givenName?: string | null } | null> | null } | null };

export type ImportCustomerContactMutationVariables = Exact<{
  input: ImportContactsInput;
}>;


export type ImportCustomerContactMutation = { __typename?: 'Mutation', importContacts?: { __typename?: 'ImportContactsResult', importDuplicates?: number | null, importErrors?: number | null, success: boolean, totalImported: number, errors?: Array<{ __typename?: 'MutationError', code?: string | null, message: string }> | null } | null };

export type GetNewSetupIntentMutationVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type GetNewSetupIntentMutation = { __typename?: 'Mutation', subscriptionGetNewSetupIntent?: string | null };

export type SubscriptionByAccountIdQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionByAccountIdQuery = { __typename?: 'Query', subscriptionByAccountId?: { __typename?: 'SubscriptionRecord', id: any, accountId: string, externalId?: string | null, clientSecret?: string | null, productType: ProductType, tierId?: string | null, currentTier: TierType, status?: SubscriptionStatus | null, inTrialPeriod?: boolean | null, renewalAt?: any | null, periodStartAt?: any | null, periodEndAt?: any | null, cancelled?: boolean | null, cancelledAt?: any | null, createdAt?: any | null, updatedAt?: any | null, paymentMethod?: { __typename?: 'PaymentMethodRecord', cardLastFour?: string | null, cardType?: string | null, country?: string | null, zipCode?: string | null } | null, tier?: { __typename?: 'SubscriptionTier', id: string, name: string, description: string, code: TierCode, type: TierType, productType: ProductType, amount: any, currency: CurrencyCode, trialPeriodDays: number, addons?: Array<{ __typename?: 'SubscriptionAddon', amount: any, code: AddonCode, currency: CurrencyCode, id: any, name: string, freeQty: number, type: AddonType }> | null } | null, addonUsage?: { __typename?: 'AddonUsageRecord', SHARED_TRIPS?: number | null } | null } | null };

export type SubscriptionInvoicesByAccountIdQueryVariables = Exact<{
  accountId: Scalars['ID'];
  skip: Scalars['Int'];
  take: Scalars['Int'];
}>;


export type SubscriptionInvoicesByAccountIdQuery = { __typename?: 'Query', subscriptionInvoicesByAccountId?: Array<{ __typename?: 'SubscriptionInvoice', id: any, description?: string | null, amount: any, total: any, currency: CurrencyCode, discount?: any | null, invoiceNumber: string, approved?: boolean | null, status?: string | null, dueAt?: any | null, pdfURL?: string | null, externalURL?: string | null, createdAt?: any | null, updatedAt?: any | null }> | null };

export type SubscriptionFindOrCreateQueryVariables = Exact<{
  accountName?: InputMaybe<Scalars['String']>;
  selectedTier?: InputMaybe<TierType>;
}>;


export type SubscriptionFindOrCreateQuery = { __typename?: 'Query', subscriptionFindOrCreate?: { __typename?: 'SubscriptionRecord', id: any, accountId: string, externalId?: string | null, clientSecret?: string | null, productType: ProductType, tierId?: string | null, currentTier: TierType, inTrialPeriod?: boolean | null, renewalAt?: any | null, periodStartAt?: any | null, periodEndAt?: any | null, createdAt?: any | null, updatedAt?: any | null, tier?: { __typename?: 'SubscriptionTier', id: string, name: string, description: string, code: TierCode, type: TierType, productType: ProductType, amount: any, currency: CurrencyCode, trialPeriodDays: number } | null } | null };

export type CreateOrUpdateSubscriptionMutationVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
  accountId: Scalars['UUID'];
  selectedTier: TierType;
  paymentMethodId?: InputMaybe<Scalars['String']>;
  cancel?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateOrUpdateSubscriptionMutation = { __typename?: 'Mutation', createOrUpdateSubscription: { __typename?: 'SubscriptionRecord', id: any, accountId: string, productType: ProductType, tierId?: string | null, currentTier: TierType, inTrialPeriod?: boolean | null, renewalAt?: any | null, periodStartAt?: any | null, periodEndAt?: any | null, createdAt?: any | null, updatedAt?: any | null, tier?: { __typename?: 'SubscriptionTier', id: string, name: string, description: string, code: TierCode, type: TierType, productType: ProductType, amount: any, currency: CurrencyCode, trialPeriodDays: number } | null } };

export type ReportAddonUsageMutationVariables = Exact<{
  subscriptionId?: InputMaybe<Scalars['UUID']>;
  accountId?: InputMaybe<Scalars['UUID']>;
  addonType?: InputMaybe<AddonType>;
}>;


export type ReportAddonUsageMutation = { __typename?: 'Mutation', reportAddonUsage: number };

export type GetFavoriteAccountsQueryVariables = Exact<{
  criteria?: InputMaybe<FavoriteDriverSearchQueryCriteria>;
}>;


export type GetFavoriteAccountsQuery = { __typename?: 'Query', favoriteDrivers: { __typename?: 'FavoriteDriverQueries', search: { __typename?: 'FavoriteDriverCollectionResult', items: Array<{ __typename?: 'FavoriteDriver', id: any, account?: { __typename?: 'Account', name: string, id: any, primaryPhoneNumber?: string | null, description?: string | null, legalName?: string | null } | null }> } } };

export type GetFavoriteAccountQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetFavoriteAccountQuery = { __typename?: 'Query', favoriteDrivers: { __typename?: 'FavoriteDriverQueries', byId?: { __typename?: 'FavoriteDriver', id: any, account?: { __typename?: 'Account', name: string, id: any, primaryPhoneNumber?: string | null, description?: string | null, legalName?: string | null } | null, accountOwner?: { __typename?: 'Contact', id: any, name?: string | null } | null } | null } };

export type AddFavoriteAccountMutationVariables = Exact<{
  favoriteDriver: InsertFavoriteDriverInput;
}>;


export type AddFavoriteAccountMutation = { __typename?: 'Mutation', insertFavoriteDriver?: { __typename?: 'InsertFavoriteDriverResult', favoriteDriver?: { __typename?: 'FavoriteDriver', id: any } | null, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null } | null };

export type DeleteFavoriteAccountMutationVariables = Exact<{
  favoriteDriver: DeleteFavoriteDriverAccount;
}>;


export type DeleteFavoriteAccountMutation = { __typename?: 'Mutation', deleteFavoriteDriver?: { __typename?: 'DeleteFavoriteDriverResult', success: boolean } | null };

export type InviteNetworkAssociateMutationVariables = Exact<{
  name: Scalars['String'];
  email: Scalars['String'];
  message?: InputMaybe<Scalars['String']>;
}>;


export type InviteNetworkAssociateMutation = { __typename?: 'Mutation', inviteNetworkAssociate?: { __typename?: 'NetworkInvitationResult', response?: NetworkInvitationResponse | null, invitation?: { __typename?: 'NetworkInvitation', id: any, accountId: any, status: NetworkInvitationStatus, toName: string, toEmail: string, sentAt: any, resentAt?: any | null, expiresAt?: any | null, resolvedAt?: any | null, token: string, message?: string | null } | null, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null } | null };

export type RevokeNetworkInvitationMutationVariables = Exact<{
  invitationToken: Scalars['String'];
}>;


export type RevokeNetworkInvitationMutation = { __typename?: 'Mutation', revokeNetworkInvitation?: { __typename?: 'NetworkInvitationResult', response?: NetworkInvitationResponse | null, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null } | null };

export type GetAllNetworkInvitationsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  criteria?: InputMaybe<NetworkInvitationCriteria>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllNetworkInvitationsQuery = { __typename?: 'Query', networkInvitations: { __typename?: 'NetworkInvitationQueries', all: { __typename?: 'NetworkInvitationCollectionResult', total: number, items: Array<{ __typename?: 'NetworkInvitation', id: any, accountId: any, status: NetworkInvitationStatus, toName: string, toEmail: string, sentAt: any, resentAt?: any | null, expiresAt?: any | null, resolvedAt?: any | null, token: string, message?: string | null }> } } };

export type GetAllNetworkRelationshipsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  criteria?: InputMaybe<NetworkRelationshipCriteria>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllNetworkRelationshipsQuery = { __typename?: 'Query', networkRelationships: { __typename?: 'NetworkRelationshipQueries', all: { __typename?: 'NetworkRelationshipCollectionResult', total: number, items: Array<{ __typename?: 'NetworkRelationship', id: any, accountId: any, toAccountId: any, isReciprocal: boolean, invitationId?: any | null, account: { __typename?: 'Account', name: string, legalName?: string | null, accountOwner?: { __typename?: 'Contact', name?: string | null, email: string } | null, garages: Array<{ __typename?: 'Garage', id: any, location: { __typename?: 'Location', addressLine1?: string | null, addressLine2?: string | null, coordinates: any, city?: string | null, state?: string | null, postalCode?: string | null } }> }, toAccount: { __typename?: 'Account', name: string, legalName?: string | null, accountOwner?: { __typename?: 'Contact', name?: string | null, email: string } | null, garages: Array<{ __typename?: 'Garage', id: any, location: { __typename?: 'Location', addressLine1?: string | null, addressLine2?: string | null, coordinates: any, city?: string | null, state?: string | null, postalCode?: string | null } }> } }> } } };

export type PublicDetailsQueryVariables = Exact<{
  sharedTripToken: Scalars['String'];
}>;


export type PublicDetailsQuery = { __typename?: 'Query', sharedTrips: { __typename?: 'SharedTripQueries', publicDetails: { __typename?: 'PublicShareableInfo', status?: SharedTripStatus | null, amount?: number | null, paymentMethodType?: PaymentMethodType | null, message?: string | null, company?: string | null, originalTripStatus?: TripStatus | null, originalTripNumber?: string | null, passengerCount?: number | null, preferredVehicleClass?: string | null, originalTripId?: string | null, pickupTime?: any | null, distanceInMiles?: number | null, receivedAt?: any | null, expiresAt?: any | null, tripOwner?: { __typename?: 'Contact', name?: string | null, email: string, phoneNumber?: string | null } | null, origin?: { __typename?: 'TripWaypoint', location: { __typename?: 'Location', name: string } } | null, destination?: { __typename?: 'TripWaypoint', location: { __typename?: 'Location', name: string } } | null } } };

export type CreateSharedTripMutationVariables = Exact<{
  paymentMethodType: PaymentMethodType;
  amount: Scalars['Float'];
  tripId: Scalars['UUID'];
}>;


export type CreateSharedTripMutation = { __typename?: 'Mutation', createSharedTrip?: { __typename?: 'SharedTripResult', response?: SharedTripResponse | null, errors?: Array<{ __typename?: 'MutationError', message: string }> | null, sharedTrip?: { __typename?: 'SharedTrip', id: any, status: SharedTripStatus, amount: number, paymentMethodType: PaymentMethodType, token: string, sentAt: any, tripId: any, contact?: { __typename?: 'Contact', id: any, name?: string | null } | null } | null } | null };

export type GetSharedTripByOriginalTripIdQueryVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type GetSharedTripByOriginalTripIdQuery = { __typename?: 'Query', sharedTrips: { __typename?: 'SharedTripQueries', byOriginalTrip?: { __typename?: 'SharedTrip', id: any, status: SharedTripStatus, amount: number, token: string, sentAt: any, expiresAt?: any | null, contact?: { __typename?: 'Contact', id: any, name?: string | null } | null, trip: { __typename?: 'Trip', pickupTime?: any | null, isShared?: boolean | null, pickupWaypoint?: { __typename?: 'TripWaypoint', location: { __typename?: 'Location', name: string } } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', location: { __typename?: 'Location', name: string } } | null, preferredVehicleClass?: { __typename?: 'GenericVehicleClass', systemClassId: string } | null } } | null } };

export type GetAllReceivedTripsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type GetAllReceivedTripsQuery = { __typename?: 'Query', sharedTrips: { __typename?: 'SharedTripQueries', all: { __typename?: 'SharedTripCollectionResult', total: number, refetchAfter?: number | null, items: Array<{ __typename?: 'SharedTrip', id: any, status: SharedTripStatus, savoyaAssignmentStatus?: SavoyaSharedTripStatus | null, savoyaAvailableTrip?: boolean | null, savoyaQuotedTime?: number | null, amount: number, token: string, sentAt: any, expiresAt?: any | null, tripId: any, contact?: { __typename?: 'Contact', id: any, name?: string | null } | null, trip: { __typename?: 'Trip', id: any, accountId: any, tripNumber?: number | null, status: TripStatus, passengerCount?: number | null, estimatedDurationInMinutes?: number | null, pickupTime?: any | null, isShared?: boolean | null, providerSource?: TripProviderSource | null, providerExternalId?: string | null, pickupWaypoint?: { __typename?: 'TripWaypoint', estimatedArrivalTime?: any | null, estimatedDepartureTime?: any | null, location: { __typename?: 'Location', name: string } } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', estimatedArrivalTime?: any | null, estimatedDepartureTime?: any | null, location: { __typename?: 'Location', name: string } } | null, waypoints: Array<{ __typename?: 'TripWaypoint', id: any, role: TripWaypointRole, order: number, airlineId?: any | null, fboId?: any | null, iataCode?: string | null, flightNumber?: string | null, verifiedFlight?: any | null, flightTime?: any | null, estimatedDurationInMinutes?: number | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', id: any, iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null, placeFoursquareId?: string | null, placeWikidataId?: string | null, placeType?: string | null } }> } }> } } };

export type GetSavoyaAvailableTripsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavoyaAvailableTripsQuery = { __typename?: 'Query', sharedTrips: { __typename?: 'SharedTripQueries', getSavoyaAvailableTrips: { __typename?: 'SharedTripCollectionResult', total: number, refetchAfter?: number | null, items: Array<{ __typename?: 'SharedTrip', id: any, status: SharedTripStatus, savoyaAssignmentStatus?: SavoyaSharedTripStatus | null, savoyaAvailableTrip?: boolean | null, savoyaQuotedTime?: number | null, amount: number, token: string, sentAt: any, expiresAt?: any | null, tripId: any, vendorExternalId?: any | null, paymentMethodType: PaymentMethodType, contact?: { __typename?: 'Contact', id: any, name?: string | null, email: string, phoneNumber?: string | null } | null, trip: { __typename?: 'Trip', id: any, isShared?: boolean | null, providerSource?: TripProviderSource | null, passengerCount?: number | null, luggageCount?: number | null, paymentMethodId?: any | null, paymentMethodType?: PaymentMethodType | null, estimatedSpotTimeInMinutes?: number | null, wasBookedByPassenger?: boolean | null, accountId: any, pickupTime?: any | null, estimatedDurationInMinutes?: number | null, estimatedRevenue?: number | null, status: TripStatus, tripNumber?: number | null, customerId?: any | null, stagingNotes?: string | null, estimatedDistanceInMiles?: number | null, estimatedOnLocationTime?: any | null, estimatedAvailabilityTime?: any | null, isDirected?: boolean | null, estimatedDurationInMinutesOverride?: number | null, overrideDropoffWaypointDetails?: boolean | null, referenceNumber?: string | null, providerExternalId?: string | null, currentOrNextWaypoint?: { __typename?: 'TripWaypoint', id: any, role: TripWaypointRole } | null, preferredVehicleClass?: { __typename?: 'GenericVehicleClass', name: string } | null, notes: Array<{ __typename?: 'TripNote', id: any, content: string }>, driver?: { __typename?: 'GenericDriver', accountId: any, drivingSince?: any | null, id: any, isActive: boolean, name?: string | null, imageUrl?: string | null } | null, vehicle?: { __typename?: 'GenericVehicle', id: any, makeName: string, modelName: string, name: string, vin?: string | null, year?: number | null, licenseNumber?: string | null, color: string } | null, pickupWaypoint?: { __typename?: 'TripWaypoint', savoyaStop?: any | null, role: TripWaypointRole, flightNumber?: string | null, departureTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, location: { __typename?: 'Location', coordinates: any, name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', savoyaStop?: any | null, role: TripWaypointRole, flightNumber?: string | null, departureTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, location: { __typename?: 'Location', coordinates: any, name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null, waypoints: Array<{ __typename?: 'TripWaypoint', id: any, role: TripWaypointRole, order: number, estimatedDurationInMinutes?: number | null, savoyaStop?: any | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, coordinates: any, city?: string | null, state?: string | null, postalCode?: string | null } }>, invoice?: { __typename?: 'Invoice', id: any, status: InvoiceStatus, type: InvoiceType, total?: number | null, payments?: number | null, balance?: number | null, externalId?: string | null, invoiceProcessor?: CreditCardProcessor | null, externalInvoiceLink?: string | null, lineItems: Array<{ __typename?: 'LineItem', id: any, name?: string | null, unitPrice: number, quantity: number, total: number }>, transactions: Array<{ __typename?: 'Transaction', id: any, type: TransactionType, status: TransactionStatus, paymentMethodType: PaymentMethodType, note?: string | null, amount: number, reversalOfTransactionId?: any | null, accountId: any, invoiceId?: any | null, refundedAmount?: number | null }> } | null, segments: Array<{ __typename?: 'TripSegment', startWaypointId?: any | null, endWaypointId?: any | null, estimatedDistanceInMiles?: number | null, estimatedDurationInMinutes?: number | null, durationInMinutes?: number | null, distanceInMiles?: number | null, order: number }>, availableCommands: Array<{ __typename?: 'TripCommandMeta', typeName: string, name: string, isPrimary?: boolean | null, disabled?: boolean | null, description?: string | null, events: Array<TripEventType>, hidden: boolean }>, sharedAvailableCommands: Array<{ __typename?: 'TripCommandMeta', typeName: string, name: string, isPrimary?: boolean | null, disabled?: boolean | null, description?: string | null, events: Array<TripEventType>, hidden: boolean }> } }> } } };

export type GetSharedTripByTokenQueryVariables = Exact<{
  sharedTripToken: Scalars['UUID'];
}>;


export type GetSharedTripByTokenQuery = { __typename?: 'Query', sharedTrips: { __typename?: 'SharedTripQueries', byToken?: { __typename?: 'SharedTrip', id: any, status: SharedTripStatus, amount: number, message?: string | null, paymentMethodType: PaymentMethodType, token: string, sentAt: any, expiresAt?: any | null, contact?: { __typename?: 'Contact', id: any, name?: string | null } | null, trip: { __typename?: 'Trip', status: TripStatus, tripNumber?: number | null, id: any, pickupTime?: any | null, estimatedDistanceInMiles?: number | null, passengerCount?: number | null, confirmationEmailStatus: TripConfirmationEmailStatus, providerSource?: TripProviderSource | null, providerExternalId?: string | null, groundworkTrip?: boolean | null, account: { __typename?: 'Account', name: string, accountOwner?: { __typename?: 'Contact', name?: string | null, email: string, phoneNumber?: string | null } | null }, pickupWaypoint?: { __typename?: 'TripWaypoint', location: { __typename?: 'Location', name: string } } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', location: { __typename?: 'Location', name: string } } | null, vehicle?: { __typename?: 'GenericVehicle', id: any, accountId: any, vehicleClassId: any, licenseNumber?: string | null, vin?: string | null, year?: number | null, modelName: string, makeName: string, isActive: boolean, color: string, middleSeatType?: string | null, vehicleClass: { __typename?: 'GenericVehicleClass', id: any, accountId?: any | null, systemClassId: string, passengerCount?: number | null, luggageCount?: number | null, name: string, hourlyRate?: number | null, isActive: boolean, cancellationPolicyHours?: number | null, minimumHours?: number | null } } | null, driver?: { __typename?: 'GenericDriver', id: any, name?: string | null } | null, preferredVehicleClass?: { __typename?: 'GenericVehicleClass', id: any, name: string, systemClassId: string } | null } } | null } };

export type GetNetworkAccountsQueryVariables = Exact<{
  tripId: Scalars['UUID'];
  query: Scalars['String'];
  range?: InputMaybe<Scalars['Int']>;
  systemClassId?: InputMaybe<Scalars['String']>;
  includeFavorites?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetNetworkAccountsQuery = { __typename?: 'Query', accounts: { __typename?: 'AccountQueries', searchByTrip: { __typename?: 'AccountCollectionResult', total: number, items: Array<{ __typename?: 'Account', id: any, name: string, logoUrl?: string | null, isFavorite?: boolean | null, garages: Array<{ __typename?: 'Garage', location: { __typename?: 'Location', city?: string | null, state?: string | null }, vehicles?: Array<{ __typename?: 'Vehicle', modelId: any, vehicleClass: { __typename?: 'VehicleClass', systemClassId: string } } | null> | null }>, accountOwner?: { __typename?: 'Contact', id: any, name?: string | null, email: string, phoneNumber?: string | null } | null }> } } };

export type ShareTripWithContactMutationVariables = Exact<{
  contactId: Scalars['String'];
  token: Scalars['String'];
}>;


export type ShareTripWithContactMutation = { __typename?: 'Mutation', shareTripWithContact?: { __typename?: 'SharedTripResult', response?: SharedTripResponse | null, sharedTrip?: { __typename?: 'SharedTrip', id: any, status: SharedTripStatus, contactId?: any | null, trip: { __typename?: 'Trip', id: any, status: TripStatus }, contact?: { __typename?: 'Contact', name?: string | null } | null } | null, errors?: Array<{ __typename?: 'MutationError', message: string }> | null } | null };

export type MutateSharedTripStatusMutationVariables = Exact<{
  sharedTripId: Scalars['UUID'];
}>;


export type MutateSharedTripStatusMutation = { __typename?: 'Mutation', mutateSharedTripStatus?: { __typename?: 'SharedTripResult', response?: SharedTripResponse | null, sharedTrip?: { __typename?: 'SharedTrip', id: any, status: SharedTripStatus, amount: number, paymentMethodType: PaymentMethodType, token: string, sentAt: any, tripId: any, contact?: { __typename?: 'Contact', id: any, name?: string | null } | null } | null } | null };

export type GetActiveTodosQueryVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type GetActiveTodosQuery = { __typename?: 'Query', todos: { __typename?: 'TodoQueries', active: { __typename?: 'TodoCollectionResult', total: number, items: Array<{ __typename?: 'Todo', title: string, body?: string | null, expirationDate?: any | null, id: any, actionUrl?: string | null, status: TodoStatus, dueDate?: any | null, infoText?: string | null, accountId: any, type: TodoType, entityType: string, entityId: any, specId?: any | null }> } } };

export type GetTripExpensesQueryVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type GetTripExpensesQuery = { __typename?: 'Query', rates: { __typename?: 'RateQueries', forTrip: { __typename?: 'AppliedRates', tripId: any, total: number, baseGroup: { __typename?: 'AppliedRateGroup', rates: Array<{ __typename?: 'AppliedRate', quantity: number, unitPrice: number, total: number, rate?: { __typename?: 'AppliedRateDefinition', name: string, amount?: number | null } | null, addon?: { __typename?: 'TripAddon', total: number, note?: string | null, rateType: { __typename?: 'RateType', name: string } } | null, ratePolicy?: { __typename?: 'AppliedRatePolicyDefinition', type: RatePolicyType } | null }> }, subtotalGroup: { __typename?: 'AppliedRateGroup', rates: Array<{ __typename?: 'AppliedRate', quantity: number, unitPrice: number, total: number, rate?: { __typename?: 'AppliedRateDefinition', name: string, amount?: number | null } | null, addon?: { __typename?: 'TripAddon', total: number, note?: string | null, rateType: { __typename?: 'RateType', name: string } } | null }> }, totalGroup: { __typename?: 'AppliedRateGroup', rates: Array<{ __typename?: 'AppliedRate', quantity: number, unitPrice: number, total: number, rate?: { __typename?: 'AppliedRateDefinition', name: string, amount?: number | null } | null, addon?: { __typename?: 'TripAddon', total: number, note?: string | null, rateType: { __typename?: 'RateType', name: string } } | null }> } } } };

export type SearchByContactNameAndAccountIdQueryVariables = Exact<{
  query: Scalars['String'];
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type SearchByContactNameAndAccountIdQuery = { __typename?: 'Query', customerContacts: { __typename?: 'CustomerContactQueries', searchByContactNameAndAccountId: { __typename?: 'CustomerContactCollectionResult', items: Array<{ __typename?: 'CustomerContact', id: any, customerId: any, primaryRole: CustomerRole, contact: { __typename?: 'Contact', id: any, name?: string | null, email: string, phoneNumber?: string | null }, customer: { __typename?: 'Customer', id: any, name: string, type: CustomerType } }> } } };

export type SearchByContactEmailAndAccountIdQueryVariables = Exact<{
  query: Scalars['String'];
  accountId: Scalars['UUID'];
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type SearchByContactEmailAndAccountIdQuery = { __typename?: 'Query', customerContacts: { __typename?: 'CustomerContactQueries', searchByContactEmailAndAccountId: { __typename?: 'CustomerContactCollectionResult', items: Array<{ __typename?: 'CustomerContact', id: any, customerId: any, contact: { __typename?: 'Contact', id: any, name?: string | null, email: string, phoneNumber?: string | null }, customer: { __typename?: 'Customer', id: any, name: string, type: CustomerType } }> } } };

export type QuerySearchByEmailAndAccountQueryVariables = Exact<{
  email: Scalars['String'];
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type QuerySearchByEmailAndAccountQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactQueries', byEmailAndAccount?: { __typename?: 'Contact', email: string, phoneNumber?: string | null, id: any, name?: string | null, isActive: boolean } | null } };

export type DeleteTripByIdMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteTripByIdMutation = { __typename?: 'Mutation', deleteTrip?: { __typename?: 'DeleteTripResult', success: boolean } | null };

export type DeleteTripContactMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteTripContactMutation = { __typename?: 'Mutation', deleteTripContact?: { __typename?: 'DeleteTripContactResult', success: boolean, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null } | null };

export type UpdateTripContactMutationVariables = Exact<{
  tripContact: UpdateTripContact;
}>;


export type UpdateTripContactMutation = { __typename?: 'Mutation', updateTripContact?: { __typename?: 'UpdateTripContactResult', success: boolean, tripContact?: { __typename?: 'TripContact', email?: string | null, name?: string | null, phoneNumber?: string | null, id: any, notificationSubscriptions: Array<{ __typename?: 'TripNotificationSubscription', id: any, notificationTypeId: any, tripContactId: any, channels: Array<MessageChannel> }> } | null, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null } | null };

export type InsertTripContactMutationVariables = Exact<{
  tripContact: InsertTripContact;
}>;


export type InsertTripContactMutation = { __typename?: 'Mutation', insertTripContact?: { __typename?: 'InsertTripContactResult', success: boolean, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null, tripContact?: { __typename?: 'TripContact', id: any, customerContactId: any } | null } | null };

export type UpdateTripNotificationSubscriptionByTripClientMutationVariables = Exact<{
  tripNotificationSubscriptions: Array<UpdateTripNotificationSubscriptionByTripClientId> | UpdateTripNotificationSubscriptionByTripClientId;
  tripClientId: Scalars['UUID'];
}>;


export type UpdateTripNotificationSubscriptionByTripClientMutation = { __typename?: 'Mutation', updateTripNotificationSubscriptionByTripClient?: { __typename?: 'UpdateTripNotificationSubscriptionsByTripClientResult', success: boolean, notificationSubscriptions?: Array<{ __typename?: 'TripNotificationSubscription', channels: Array<MessageChannel>, id: any, notificationTypeId: any, tripContactId: any, version: number, notificationType: { __typename?: 'TripNotificationType', id: any, trigger: TripEventType, order: number, version: number, enabled?: boolean | null } }> | null } | null };

export type DepartPickupMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type DepartPickupMutation = { __typename?: 'Mutation', executeDepartPickup: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', pickupWaypoint?: { __typename?: 'TripWaypoint', id: any, tripId: any, role: TripWaypointRole, order: number, locationId: any, airlineId?: any | null, flightType?: FlightType | null, flightNumber?: string | null, estimatedArrivalTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, departureTime?: any | null, estimatedDurationInMinutes?: number | null, durationInMinutes?: number | null, savoyaStop?: any | null } | null } | null } };

export type InvoiceSubmittedMutationVariables = Exact<{
  tripId: Scalars['UUID'];
  sendToBooker?: InputMaybe<Scalars['Boolean']>;
}>;


export type InvoiceSubmittedMutation = { __typename?: 'Mutation', executeInvoiceSubmitted: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type InvoicePaidMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type InvoicePaidMutation = { __typename?: 'Mutation', executeInvoicePaid: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type ArriveGarageMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type ArriveGarageMutation = { __typename?: 'Mutation', executeArriveGarage: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type DepartStopMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type DepartStopMutation = { __typename?: 'Mutation', executeDepartStop: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', currentOrNextWaypoint?: { __typename?: 'TripWaypoint', id: any, tripId: any, role: TripWaypointRole, order: number, locationId: any, airlineId?: any | null, flightType?: FlightType | null, flightNumber?: string | null, estimatedArrivalTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, departureTime?: any | null, estimatedDurationInMinutes?: number | null, durationInMinutes?: number | null } | null } | null } };

export type ArriveDropoffMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type ArriveDropoffMutation = { __typename?: 'Mutation', executeArriveDropoff: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', dropoffWaypoint?: { __typename?: 'TripWaypoint', id: any, tripId: any, role: TripWaypointRole, order: number, locationId: any, airlineId?: any | null, flightType?: FlightType | null, flightNumber?: string | null, estimatedArrivalTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, departureTime?: any | null, estimatedDurationInMinutes?: number | null, durationInMinutes?: number | null } | null } | null } };

export type ExpireQuoteMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type ExpireQuoteMutation = { __typename?: 'Mutation', executeExpireQuote: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type ArriveStopMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type ArriveStopMutation = { __typename?: 'Mutation', executeArriveStop: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', currentOrNextWaypoint?: { __typename?: 'TripWaypoint', id: any, tripId: any, role: TripWaypointRole, order: number, locationId: any, airlineId?: any | null, flightType?: FlightType | null, flightNumber?: string | null, estimatedArrivalTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, departureTime?: any | null, estimatedDurationInMinutes?: number | null, durationInMinutes?: number | null } | null } | null } };

export type ArrivePickupMutationVariables = Exact<{
  tripId: Scalars['UUID'];
  stagingNotes?: InputMaybe<Scalars['String']>;
}>;


export type ArrivePickupMutation = { __typename?: 'Mutation', executeArrivePickup: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', pickupWaypoint?: { __typename?: 'TripWaypoint', id: any, tripId: any, role: TripWaypointRole, order: number, locationId: any, airlineId?: any | null, flightType?: FlightType | null, flightNumber?: string | null, estimatedArrivalTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, departureTime?: any | null, estimatedDurationInMinutes?: number | null, durationInMinutes?: number | null, savoyaStop?: any | null } | null } | null } };

export type CloseTripMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type CloseTripMutation = { __typename?: 'Mutation', executeCloseTrip: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type RecordTransactionMutationVariables = Exact<{
  command: RecordTransaction;
}>;


export type RecordTransactionMutation = { __typename?: 'Mutation', executeRecordTransaction: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type CancelTripMutationVariables = Exact<{
  tripId: Scalars['UUID'];
  reason: TripCancellationReason;
  notes?: InputMaybe<Scalars['String']>;
}>;


export type CancelTripMutation = { __typename?: 'Mutation', executeCancelTrip: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type CirclingMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type CirclingMutation = { __typename?: 'Mutation', executeCircling: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', pickupWaypoint?: { __typename?: 'TripWaypoint', id: any, tripId: any, role: TripWaypointRole, order: number, locationId: any, airlineId?: any | null, flightType?: FlightType | null, flightNumber?: string | null, estimatedArrivalTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, departureTime?: any | null, estimatedDurationInMinutes?: number | null, durationInMinutes?: number | null, savoyaStop?: any | null } | null } | null } };

export type WaitingMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type WaitingMutation = { __typename?: 'Mutation', executeWaiting: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', pickupWaypoint?: { __typename?: 'TripWaypoint', id: any, tripId: any, role: TripWaypointRole, order: number, locationId: any, airlineId?: any | null, flightType?: FlightType | null, flightNumber?: string | null, estimatedArrivalTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, departureTime?: any | null, estimatedDurationInMinutes?: number | null, durationInMinutes?: number | null, savoyaStop?: any | null } | null } | null } };

export type EnRouteToPickupMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type EnRouteToPickupMutation = { __typename?: 'Mutation', executeEnRouteToPickup: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type SubmitTripRequestMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type SubmitTripRequestMutation = { __typename?: 'Mutation', executeSubmitTripRequest: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type RequestReassignmentMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type RequestReassignmentMutation = { __typename?: 'Mutation', executeReassignmentRequested: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type GetAllTripsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type GetAllTripsQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', all: { __typename?: 'TripCollectionResult', total: number, items: Array<{ __typename?: 'Trip', id: any, accountId: any, pickupTime?: any | null, tripNumber?: number | null, stagingNotes?: string | null, status: TripStatus, estimatedDistanceInMiles?: number | null, estimatedSpotTimeInMinutes?: number | null, estimatedRevenue?: number | null, estimatedDurationInMinutes?: number | null, providerExternalId?: string | null, groundworkTrip?: boolean | null, driver?: { __typename?: 'GenericDriver', accountId: any, drivingSince?: any | null, id: any, isActive: boolean, name?: string | null, imageUrl?: string | null } | null, vehicle?: { __typename?: 'GenericVehicle', id: any, name: string, accountId: any, vehicleClassId: any, licenseNumber?: string | null, vin?: string | null, year?: number | null, modelName: string, makeName: string, isActive: boolean, color: string, middleSeatType?: string | null, vehicleClass: { __typename?: 'GenericVehicleClass', id: any, accountId?: any | null, systemClassId: string, passengerCount?: number | null, luggageCount?: number | null, name: string, hourlyRate?: number | null, isActive: boolean, cancellationPolicyHours?: number | null, minimumHours?: number | null } } | null, pickupWaypoint?: { __typename?: 'TripWaypoint', flightNumber?: string | null, departureTime?: any | null, savoyaStop?: any | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null } } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', flightNumber?: string | null, savoyaStop?: any | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null } } | null, preferredVehicleClass?: { __typename?: 'GenericVehicleClass', name: string } | null, waypoints: Array<{ __typename?: 'TripWaypoint', id: any, role: TripWaypointRole, order: number, estimatedDurationInMinutes?: number | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, coordinates: any, city?: string | null, state?: string | null, postalCode?: string | null } }>, segments: Array<{ __typename?: 'TripSegment', startWaypointId?: any | null, endWaypointId?: any | null, estimatedDistanceInMiles?: number | null, estimatedDurationInMinutes?: number | null, order: number }> }> } } };

export type GetTripByIdQueryVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type GetTripByIdQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', byId?: { __typename?: 'Trip', id: any, accountId: any, tripNumber?: number | null, stagingNotes?: string | null, pickupTime?: any | null, passengerCount?: number | null, luggageCount?: number | null, status: TripStatus, customerId?: any | null, paymentMethodId?: any | null, paymentMethodType?: PaymentMethodType | null, estimatedDistanceInMiles?: number | null, estimatedSpotTimeInMinutes?: number | null, estimatedAvailabilityTime?: any | null, estimatedRevenue?: number | null, wasBookedByPassenger?: boolean | null, driverId?: any | null, vehicleId?: any | null, estimatedDurationInMinutes?: number | null, rateData?: any | null, baseRateOverride?: number | null, flatRateOverride?: number | null, isDirected?: boolean | null, estimatedDurationInMinutesOverride?: number | null, overrideDropoffWaypointDetails?: boolean | null, isShared?: boolean | null, providerSource?: TripProviderSource | null, providerExternalId?: string | null, groundworkTrip?: boolean | null, confirmationEmailStatus: TripConfirmationEmailStatus, referenceNumber?: string | null, currentOrNextWaypoint?: { __typename?: 'TripWaypoint', id: any, role: TripWaypointRole } | null, addons: Array<{ __typename?: 'TripAddon', id: any, total: number, calculation?: AdjustmentCalculation | null, rateType: { __typename?: 'RateType', name: string } }>, paymentMethod?: { __typename?: 'PaymentMethod', description: string, source: CreditCardProcessor } | null, notes: Array<{ __typename?: 'TripNote', id: any, content: string }>, driver?: { __typename?: 'GenericDriver', accountId: any, drivingSince?: any | null, id: any, isActive: boolean, name?: string | null, imageUrl?: string | null } | null, vehicle?: { __typename?: 'GenericVehicle', id: any, name: string, accountId: any, vehicleClassId: any, licenseNumber?: string | null, vin?: string | null, year?: number | null, modelName: string, makeName: string, isActive: boolean, color: string, middleSeatType?: string | null, vehicleClass: { __typename?: 'GenericVehicleClass', id: any, accountId?: any | null, systemClassId: string, passengerCount?: number | null, luggageCount?: number | null, name: string, hourlyRate?: number | null, isActive: boolean, cancellationPolicyHours?: number | null, minimumHours?: number | null } } | null, pickupWaypoint?: { __typename?: 'TripWaypoint', role: TripWaypointRole, airlineId?: any | null, fboId?: any | null, iataCode?: string | null, flightNumber?: string | null, departureTime?: any | null, arrivalTime?: any | null, verifiedFlightId?: string | null, verifiedFlight?: any | null, flightTime?: any | null, estimatedDurationInMinutes?: number | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', id: any, iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', timezone?: string | null, name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null, placeWikidataId?: string | null, placeFoursquareId?: string | null, placeType?: string | null } } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', role: TripWaypointRole, airlineId?: any | null, fboId?: any | null, iataCode?: string | null, flightNumber?: string | null, departureTime?: any | null, arrivalTime?: any | null, verifiedFlightId?: string | null, verifiedFlight?: any | null, flightTime?: any | null, estimatedDurationInMinutes?: number | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', id: any, iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null, placeFoursquareId?: string | null, placeWikidataId?: string | null, placeType?: string | null } } | null, invoice?: { __typename?: 'Invoice', id: any, status: InvoiceStatus, type: InvoiceType, total?: number | null, payments?: number | null, balance?: number | null, externalId?: string | null, invoiceProcessor?: CreditCardProcessor | null, externalInvoiceLink?: string | null, lineItems: Array<{ __typename?: 'LineItem', id: any, name?: string | null, unitPrice: number, quantity: number, total: number }>, transactions: Array<{ __typename?: 'Transaction', id: any, type: TransactionType, status: TransactionStatus, paymentMethodType: PaymentMethodType, note?: string | null, amount: number, reversalOfTransactionId?: any | null, accountId: any, invoiceId?: any | null, refundedAmount?: number | null }> } | null, quote?: { __typename?: 'Invoice', id: any } | null, preferredVehicleClass?: { __typename?: 'GenericVehicleClass', id: any, name: string, hourlyRate?: number | null, minimumHours?: number | null, cancellationPolicyHours?: number | null } | null, waypoints: Array<{ __typename?: 'TripWaypoint', id: any, role: TripWaypointRole, order: number, airlineId?: any | null, fboId?: any | null, iataCode?: string | null, flightNumber?: string | null, verifiedFlight?: any | null, flightTime?: any | null, estimatedDurationInMinutes?: number | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, note?: string | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', id: any, iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null, placeFoursquareId?: string | null, placeWikidataId?: string | null, placeType?: string | null } }>, segments: Array<{ __typename?: 'TripSegment', startWaypointId?: any | null, endWaypointId?: any | null, estimatedDistanceInMiles?: number | null, estimatedDurationInMinutes?: number | null, durationInMinutes?: number | null, distanceInMiles?: number | null, order: number }>, timestamps: Array<{ __typename?: 'TripStatusTimestamp', id: any, tripId: any, status: TripStatus, effectiveTime?: any | null, estimatedTime?: any | null, recordedById?: any | null, recordedTime?: any | null, correctedById?: any | null, correctedTime?: any | null, correctionReason?: TripStatusTimeCorrectionReason | null, correctionNote?: string | null }>, sharedTrip?: { __typename?: 'SharedTrip', contactId?: any | null, amount: number, token: string, id: any, paymentMethodType: PaymentMethodType, status: SharedTripStatus, savoyaAssignmentStatus?: SavoyaSharedTripStatus | null, vendorExternalId?: any | null, contact?: { __typename?: 'Contact', name?: string | null, email: string, phoneNumber?: string | null } | null } | null, account: { __typename?: 'Account', accountOwner?: { __typename?: 'Contact', email: string, phoneNumber?: string | null, name?: string | null } | null }, availableCommands: Array<{ __typename?: 'TripCommandMeta', typeName: string, name: string, isPrimary?: boolean | null, disabled?: boolean | null, description?: string | null, events: Array<TripEventType>, hidden: boolean }>, sharedAvailableCommands: Array<{ __typename?: 'TripCommandMeta', typeName: string, name: string, isPrimary?: boolean | null, disabled?: boolean | null, description?: string | null, events: Array<TripEventType>, hidden: boolean }> } | null }, clientQueries?: { __typename?: 'ClientsQueries', getTripClientsByTrip?: Array<{ __typename?: 'TripClientRecord', isPrimary: boolean, id: any, role: ClientRole, tripId: any, clientId: any, guests?: number | null, client?: { __typename?: 'ClientRecord', id: any, accountId: string, name?: string | null, sourceProduct: ProductType, primaryRole: ClientRole, title?: string | null, note?: string | null, isActive?: boolean | null, companies?: Array<{ __typename?: 'CompanyRecord', accountId: string, id: any, name?: string | null, isActive?: boolean | null, note?: string | null, sourceProduct: ProductType, type: CompanyTypeEnum, emails?: Array<{ __typename?: 'CompanyEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, addresses?: Array<{ __typename?: 'CompanyAddressRecord', id: any, type: AddressTypeEnum, addressLineOne: string, addressLineTwo?: string | null, addressLineThree?: string | null, addressLineFour?: string | null, locality: string, region: string, postalCode: string, country: string, formattedAddress: string }> | null, phoneNumbers?: Array<{ __typename?: 'CompanyPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null }> | null, phoneNumbers?: Array<{ __typename?: 'ClientPhoneRecord', id: any, type: PhoneTypeEnum, phoneNumber: string }> | null, emails?: Array<{ __typename?: 'ClientEmailRecord', id: any, type: EmailTypeEnum, email: string }> | null, addresses?: Array<{ __typename?: 'ClientAddressRecord', id: any, type: AddressTypeEnum, addressLineOne: string, addressLineTwo?: string | null, addressLineThree?: string | null, addressLineFour?: string | null, locality: string, region: string, postalCode: string, country: string, formattedAddress: string }> | null } | null }> | null } | null };

export type GetAvailableCommandsByTripIdQueryVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type GetAvailableCommandsByTripIdQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', byId?: { __typename?: 'Trip', transportStatus: TransportStatus, confirmationEmailStatus: TripConfirmationEmailStatus, accountId: any, isShared?: boolean | null, providerSource?: TripProviderSource | null, providerExternalId?: string | null, groundworkTrip?: boolean | null, currentOrNextWaypoint?: { __typename?: 'TripWaypoint', id: any, role: TripWaypointRole } | null, availableCommands: Array<{ __typename?: 'TripCommandMeta', typeName: string, name: string, description?: string | null, events: Array<TripEventType>, hidden: boolean, disabled?: boolean | null }>, sharedAvailableCommands: Array<{ __typename?: 'TripCommandMeta', typeName: string, name: string, description?: string | null, events: Array<TripEventType>, hidden: boolean, disabled?: boolean | null }>, sharedTrip?: { __typename?: 'SharedTrip', contactId?: any | null, savoyaAssignmentStatus?: SavoyaSharedTripStatus | null } | null } | null } };

export type NextTripQueryVariables = Exact<{
  currentTime?: InputMaybe<Scalars['DateTime']>;
  accountId: Scalars['UUID'];
  driverId?: InputMaybe<Scalars['UUID']>;
  completionStatus?: InputMaybe<TripCompletionStatus>;
}>;


export type NextTripQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', search: { __typename?: 'TripCollectionResult', items: Array<{ __typename?: 'Trip', id: any, accountId: any, pickupTime?: any | null, stagingNotes?: string | null, status: TripStatus, tripNumber?: number | null, estimatedDurationInMinutes?: number | null, estimatedDistanceInMiles?: number | null, isDirected?: boolean | null, estimatedDurationInMinutesOverride?: number | null, overrideDropoffWaypointDetails?: boolean | null, isShared?: boolean | null, providerSource?: TripProviderSource | null, providerExternalId?: string | null, groundworkTrip?: boolean | null, driver?: { __typename?: 'GenericDriver', accountId: any, drivingSince?: any | null, id: any, isActive: boolean, name?: string | null, imageUrl?: string | null } | null, vehicle?: { __typename?: 'GenericVehicle', id: any, accountId: any, name: string, vehicleClassId: any, licenseNumber?: string | null, vin?: string | null, year?: number | null, modelName: string, makeName: string, isActive: boolean, color: string, middleSeatType?: string | null, vehicleClass: { __typename?: 'GenericVehicleClass', id: any, accountId?: any | null, systemClassId: string, passengerCount?: number | null, luggageCount?: number | null, name: string, hourlyRate?: number | null, isActive: boolean, cancellationPolicyHours?: number | null, minimumHours?: number | null } } | null, preferredVehicleClass?: { __typename?: 'GenericVehicleClass', name: string } | null, pickupWaypoint?: { __typename?: 'TripWaypoint', role: TripWaypointRole, verifiedFlightId?: string | null, verifiedFlight?: any | null, flightTime?: any | null, airlineId?: any | null, fboId?: any | null, departureTime?: any | null, arrivalTime?: any | null, flightNumber?: string | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, location: { __typename?: 'Location', category?: LocationCategory | null, coordinates: any, name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', role: TripWaypointRole, verifiedFlightId?: string | null, verifiedFlight?: any | null, flightTime?: any | null, airlineId?: any | null, fboId?: any | null, departureTime?: any | null, arrivalTime?: any | null, flightNumber?: string | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, location: { __typename?: 'Location', category?: LocationCategory | null, coordinates: any, name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null, waypoints: Array<{ __typename?: 'TripWaypoint', id: any, role: TripWaypointRole, order: number, estimatedDurationInMinutes?: number | null, savoyaStop?: any | null, location: { __typename?: 'Location', category?: LocationCategory | null, name: string, addressLine1?: string | null, addressLine2?: string | null, coordinates: any, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null } }>, segments: Array<{ __typename?: 'TripSegment', startWaypointId?: any | null, endWaypointId?: any | null, estimatedDistanceInMiles?: number | null, estimatedDurationInMinutes?: number | null, order: number }>, sharedTrip?: { __typename?: 'SharedTrip', amount: number, token: string, id: any, paymentMethodType: PaymentMethodType, status: SharedTripStatus, savoyaAssignmentStatus?: SavoyaSharedTripStatus | null, contact?: { __typename?: 'Contact', name?: string | null, email: string, phoneNumber?: string | null } | null } | null }> } } };

export type UpcomingTripsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  driverId?: InputMaybe<Scalars['UUID']>;
  currentTime?: InputMaybe<Scalars['DateTime']>;
  completionStatus?: InputMaybe<TripCompletionStatus>;
}>;


export type UpcomingTripsQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', search: { __typename?: 'TripCollectionResult', items: Array<{ __typename?: 'Trip', id: any, accountId: any, pickupTime?: any | null, status: TripStatus, tripNumber?: number | null, stagingNotes?: string | null, estimatedDistanceInMiles?: number | null, estimatedDurationInMinutes?: number | null, isDirected?: boolean | null, estimatedDurationInMinutesOverride?: number | null, overrideDropoffWaypointDetails?: boolean | null, isShared?: boolean | null, providerSource?: TripProviderSource | null, providerExternalId?: string | null, groundworkTrip?: boolean | null, driver?: { __typename?: 'GenericDriver', accountId: any, drivingSince?: any | null, id: any, isActive: boolean, name?: string | null, imageUrl?: string | null } | null, vehicle?: { __typename?: 'GenericVehicle', id: any, accountId: any, name: string, vehicleClassId: any, licenseNumber?: string | null, vin?: string | null, year?: number | null, modelName: string, makeName: string, isActive: boolean, color: string, middleSeatType?: string | null, vehicleClass: { __typename?: 'GenericVehicleClass', id: any, accountId?: any | null, systemClassId: string, passengerCount?: number | null, luggageCount?: number | null, name: string, hourlyRate?: number | null, isActive: boolean, cancellationPolicyHours?: number | null, minimumHours?: number | null } } | null, pickupWaypoint?: { __typename?: 'TripWaypoint', role: TripWaypointRole, verifiedFlightId?: string | null, verifiedFlight?: any | null, flightTime?: any | null, airlineId?: any | null, fboId?: any | null, departureTime?: any | null, arrivalTime?: any | null, flightNumber?: string | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', role: TripWaypointRole, verifiedFlightId?: string | null, verifiedFlight?: any | null, flightTime?: any | null, airlineId?: any | null, fboId?: any | null, departureTime?: any | null, arrivalTime?: any | null, flightNumber?: string | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null, waypoints: Array<{ __typename?: 'TripWaypoint', id: any, role: TripWaypointRole, order: number, estimatedDurationInMinutes?: number | null, savoyaStop?: any | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, placeName?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null } }>, segments: Array<{ __typename?: 'TripSegment', startWaypointId?: any | null, endWaypointId?: any | null, estimatedDistanceInMiles?: number | null, estimatedDurationInMinutes?: number | null, durationInMinutes?: number | null, distanceInMiles?: number | null, order: number }>, sharedTrip?: { __typename?: 'SharedTrip', amount: number, token: string, id: any, paymentMethodType: PaymentMethodType, status: SharedTripStatus, savoyaAssignmentStatus?: SavoyaSharedTripStatus | null, contact?: { __typename?: 'Contact', name?: string | null, email: string, phoneNumber?: string | null } | null } | null }> } } };

export type DraftedTripsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  driverId?: InputMaybe<Scalars['UUID']>;
}>;


export type DraftedTripsQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', search: { __typename?: 'TripCollectionResult', items: Array<{ __typename?: 'Trip', id: any, accountId: any, pickupTime?: any | null, stagingNotes?: string | null, status: TripStatus, tripNumber?: number | null, estimatedDistanceInMiles?: number | null, estimatedDurationInMinutes?: number | null, isShared?: boolean | null, providerSource?: TripProviderSource | null, providerExternalId?: string | null, groundworkTrip?: boolean | null, driver?: { __typename?: 'GenericDriver', accountId: any, drivingSince?: any | null, id: any, isActive: boolean, name?: string | null, imageUrl?: string | null } | null, vehicle?: { __typename?: 'GenericVehicle', id: any, accountId: any, name: string, vehicleClassId: any, licenseNumber?: string | null, vin?: string | null, year?: number | null, modelName: string, makeName: string, isActive: boolean, color: string, middleSeatType?: string | null, vehicleClass: { __typename?: 'GenericVehicleClass', id: any, accountId?: any | null, systemClassId: string, passengerCount?: number | null, luggageCount?: number | null, name: string, hourlyRate?: number | null, isActive: boolean, cancellationPolicyHours?: number | null, minimumHours?: number | null } } | null, preferredVehicleClass?: { __typename?: 'GenericVehicleClass', name: string } | null, pickupWaypoint?: { __typename?: 'TripWaypoint', flightNumber?: string | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', flightNumber?: string | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null, waypoints: Array<{ __typename?: 'TripWaypoint', id: any, role: TripWaypointRole, order: number, estimatedDurationInMinutes?: number | null, savoyaStop?: any | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, coordinates: any, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null } }>, segments: Array<{ __typename?: 'TripSegment', startWaypointId?: any | null, endWaypointId?: any | null, estimatedDistanceInMiles?: number | null, estimatedDurationInMinutes?: number | null, order: number }>, sharedTrip?: { __typename?: 'SharedTrip', amount: number, token: string, id: any, paymentMethodType: PaymentMethodType, status: SharedTripStatus, savoyaAssignmentStatus?: SavoyaSharedTripStatus | null, contact?: { __typename?: 'Contact', name?: string | null, email: string, phoneNumber?: string | null } | null } | null }> } } };

export type AwaitingAsignmentTripsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  driverId?: InputMaybe<Scalars['UUID']>;
}>;


export type AwaitingAsignmentTripsQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', search: { __typename?: 'TripCollectionResult', items: Array<{ __typename?: 'Trip', id: any, accountId: any, pickupTime?: any | null, stagingNotes?: string | null, status: TripStatus, tripNumber?: number | null, estimatedDurationInMinutes?: number | null, estimatedDistanceInMiles?: number | null, isShared?: boolean | null, providerSource?: TripProviderSource | null, providerExternalId?: string | null, groundworkTrip?: boolean | null, driver?: { __typename?: 'GenericDriver', accountId: any, drivingSince?: any | null, id: any, isActive: boolean, name?: string | null, imageUrl?: string | null } | null, vehicle?: { __typename?: 'GenericVehicle', id: any, accountId: any, name: string, vehicleClassId: any, licenseNumber?: string | null, vin?: string | null, year?: number | null, modelName: string, makeName: string, isActive: boolean, color: string, middleSeatType?: string | null, vehicleClass: { __typename?: 'GenericVehicleClass', id: any, accountId?: any | null, systemClassId: string, passengerCount?: number | null, luggageCount?: number | null, name: string, hourlyRate?: number | null, isActive: boolean, cancellationPolicyHours?: number | null, minimumHours?: number | null } } | null, preferredVehicleClass?: { __typename?: 'GenericVehicleClass', name: string } | null, pickupWaypoint?: { __typename?: 'TripWaypoint', flightNumber?: string | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, location: { __typename?: 'Location', coordinates: any, name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', flightNumber?: string | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, location: { __typename?: 'Location', coordinates: any, name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null, waypoints: Array<{ __typename?: 'TripWaypoint', id: any, role: TripWaypointRole, order: number, estimatedDurationInMinutes?: number | null, savoyaStop?: any | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, coordinates: any, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null } }>, segments: Array<{ __typename?: 'TripSegment', startWaypointId?: any | null, endWaypointId?: any | null, estimatedDistanceInMiles?: number | null, estimatedDurationInMinutes?: number | null, order: number }>, sharedTrip?: { __typename?: 'SharedTrip', amount: number, token: string, id: any, paymentMethodType: PaymentMethodType, status: SharedTripStatus, savoyaAssignmentStatus?: SavoyaSharedTripStatus | null, contact?: { __typename?: 'Contact', name?: string | null, email: string, phoneNumber?: string | null } | null } | null }> } } };

export type RecentTripsQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  accountId: Scalars['UUID'];
  driverId?: InputMaybe<Scalars['UUID']>;
}>;


export type RecentTripsQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', search: { __typename?: 'TripCollectionResult', items: Array<{ __typename?: 'Trip', id: any, accountId: any, pickupTime?: any | null, tripNumber?: number | null, stagingNotes?: string | null, status: TripStatus, estimatedDurationInMinutes?: number | null, estimatedDistanceInMiles?: number | null, isDirected?: boolean | null, estimatedDurationInMinutesOverride?: number | null, overrideDropoffWaypointDetails?: boolean | null, isShared?: boolean | null, providerSource?: TripProviderSource | null, providerExternalId?: string | null, groundworkTrip?: boolean | null, driver?: { __typename?: 'GenericDriver', accountId: any, drivingSince?: any | null, id: any, isActive: boolean, name?: string | null, imageUrl?: string | null } | null, vehicle?: { __typename?: 'GenericVehicle', id: any, accountId: any, name: string, vehicleClassId: any, licenseNumber?: string | null, vin?: string | null, year?: number | null, modelName: string, makeName: string, isActive: boolean, color: string, middleSeatType?: string | null, vehicleClass: { __typename?: 'GenericVehicleClass', id: any, accountId?: any | null, systemClassId: string, passengerCount?: number | null, luggageCount?: number | null, name: string, hourlyRate?: number | null, isActive: boolean, cancellationPolicyHours?: number | null, minimumHours?: number | null } } | null, preferredVehicleClass?: { __typename?: 'GenericVehicleClass', name: string } | null, pickupWaypoint?: { __typename?: 'TripWaypoint', role: TripWaypointRole, verifiedFlightId?: string | null, verifiedFlight?: any | null, flightTime?: any | null, airlineId?: any | null, fboId?: any | null, flightNumber?: string | null, departureTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, location: { __typename?: 'Location', coordinates: any, name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', role: TripWaypointRole, verifiedFlightId?: string | null, verifiedFlight?: any | null, flightTime?: any | null, airlineId?: any | null, fboId?: any | null, flightNumber?: string | null, departureTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, location: { __typename?: 'Location', coordinates: any, name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null, waypoints: Array<{ __typename?: 'TripWaypoint', id: any, role: TripWaypointRole, order: number, estimatedDurationInMinutes?: number | null, savoyaStop?: any | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, coordinates: any, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null } }>, segments: Array<{ __typename?: 'TripSegment', startWaypointId?: any | null, endWaypointId?: any | null, estimatedDistanceInMiles?: number | null, estimatedDurationInMinutes?: number | null, durationInMinutes?: number | null, distanceInMiles?: number | null, order: number }>, sharedTrip?: { __typename?: 'SharedTrip', amount: number, token: string, id: any, paymentMethodType: PaymentMethodType, status: SharedTripStatus, savoyaAssignmentStatus?: SavoyaSharedTripStatus | null, contact?: { __typename?: 'Contact', name?: string | null, email: string, phoneNumber?: string | null } | null } | null }> } } };

export type AddTripMutationVariables = Exact<{
  trip: InsertTrip;
  publicToken?: InputMaybe<Scalars['String']>;
  recaptchaToken?: InputMaybe<Scalars['String']>;
}>;


export type AddTripMutation = { __typename?: 'Mutation', insertTrip?: { __typename?: 'InsertTripResult', trip?: { __typename?: 'Trip', id: any, customerId?: any | null, pickupWaypoint?: { __typename?: 'TripWaypoint', id: any, location: { __typename?: 'Location', name: string } } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', id: any, location: { __typename?: 'Location', name: string } } | null } | null } | null };

export type SetTripAsQuoteMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type SetTripAsQuoteMutation = { __typename?: 'Mutation', executeSendQuote: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', id: any } | null } };

export type ExecuteCreateInvoiceDeliveryRequestMutationVariables = Exact<{
  command: InvoiceDeliveryRequested;
}>;


export type ExecuteCreateInvoiceDeliveryRequestMutation = { __typename?: 'Mutation', executeCreateInvoiceDeliveryRequest: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type UpdateTripMutationVariables = Exact<{
  trip: UpdateTrip;
}>;


export type UpdateTripMutation = { __typename?: 'Mutation', updateTrip?: { __typename?: 'UpdateTripResult', success: boolean, trip?: { __typename?: 'Trip', id: any, status: TripStatus } | null } | null };

export type UpdateConfirmationEmailStatusMutationVariables = Exact<{
  tripId: Scalars['UUID'];
  confirmationEmailStatus: TripConfirmationEmailStatus;
}>;


export type UpdateConfirmationEmailStatusMutation = { __typename?: 'Mutation', updateConfirmationStatus: { __typename?: 'UpdateConfirmationStatusResult', success: boolean, errors?: Array<{ __typename?: 'MutationError', message: string }> | null } };

export type AirlinesQueryVariables = Exact<{ [key: string]: never; }>;


export type AirlinesQuery = { __typename?: 'Query', airlines: { __typename?: 'AirlineQueries', all: { __typename?: 'AirlineCollectionResult', items: Array<{ __typename?: 'Airline', id: any, name: string }> } } };

export type AirlinesAutocompleteQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type AirlinesAutocompleteQuery = { __typename?: 'Query', airlines: { __typename?: 'AirlineQueries', airlinesAutocomplete: Array<{ __typename?: 'AirlineLabel', id: any, label: string } | null> } };

export type GetTripsByNumberQueryVariables = Exact<{
  query: Scalars['String'];
  accountId?: InputMaybe<Scalars['UUID']>;
}>;


export type GetTripsByNumberQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', searchByNumber: { __typename?: 'TripCollectionResult', items: Array<{ __typename?: 'Trip', id: any, isShared?: boolean | null, providerSource?: TripProviderSource | null, tripNumber?: number | null, stagingNotes?: string | null, pickupTime?: any | null, status: TripStatus, estimatedSpotTimeInMinutes?: number | null, sharedTrip?: { __typename?: 'SharedTrip', amount: number, token: string, id: any, paymentMethodType: PaymentMethodType, status: SharedTripStatus, savoyaAssignmentStatus?: SavoyaSharedTripStatus | null, contact?: { __typename?: 'Contact', name?: string | null, email: string, phoneNumber?: string | null } | null } | null, pickupWaypoint?: { __typename?: 'TripWaypoint', flightNumber?: string | null, departureTime?: any | null, savoyaStop?: any | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null } } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', flightNumber?: string | null, savoyaStop?: any | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null } } | null }> } } };

export type GetStreamTokenQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetStreamTokenQuery = { __typename?: 'Query', getStream?: { __typename?: 'GetstreamQueries', getFeedToken?: { __typename?: 'TokenResult', token: string } | null } | null };

export type InsertTripNoteMutationVariables = Exact<{
  tripNote: InsertTripNote;
}>;


export type InsertTripNoteMutation = { __typename?: 'Mutation', insertTripNote?: { __typename?: 'InsertTripNoteResult', tripNote?: { __typename?: 'TripNote', id: any, time: any } | null } | null };

export type AssignTripMutationVariables = Exact<{
  tripId: Scalars['UUID'];
  driverId: Scalars['UUID'];
  vehicleId: Scalars['UUID'];
}>;


export type AssignTripMutation = { __typename?: 'Mutation', executeAssignTrip: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', id: any } | null } };

export type MakeTripConfirmedMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type MakeTripConfirmedMutation = { __typename?: 'Mutation', executeForceTripStatus: { __typename?: 'TripCommandResult', trip?: { __typename?: 'Trip', status: TripStatus } | null } };

export type SearchTripsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  filter: TripSearchCriteria;
  orderBy?: InputMaybe<TripOrderBy>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchTripsQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', search: { __typename?: 'TripCollectionResult', total: number, items: Array<{ __typename?: 'Trip', id: any, isShared?: boolean | null, providerSource?: TripProviderSource | null, passengerCount?: number | null, luggageCount?: number | null, paymentMethodId?: any | null, paymentMethodType?: PaymentMethodType | null, estimatedSpotTimeInMinutes?: number | null, wasBookedByPassenger?: boolean | null, accountId: any, pickupTime?: any | null, estimatedDurationInMinutes?: number | null, estimatedRevenue?: number | null, status: TripStatus, tripNumber?: number | null, customerId?: any | null, stagingNotes?: string | null, driverId?: any | null, vehicleId?: any | null, estimatedDistanceInMiles?: number | null, estimatedOnLocationTime?: any | null, estimatedAvailabilityTime?: any | null, isDirected?: boolean | null, estimatedDurationInMinutesOverride?: number | null, overrideDropoffWaypointDetails?: boolean | null, referenceNumber?: string | null, providerExternalId?: string | null, groundworkTrip?: boolean | null, currentOrNextWaypoint?: { __typename?: 'TripWaypoint', id: any, role: TripWaypointRole } | null, sharedTrip?: { __typename?: 'SharedTrip', amount: number, token: string, id: any, paymentMethodType: PaymentMethodType, status: SharedTripStatus, savoyaAssignmentStatus?: SavoyaSharedTripStatus | null, vendorExternalId?: any | null, contact?: { __typename?: 'Contact', name?: string | null, email: string, phoneNumber?: string | null } | null } | null, preferredVehicleClass?: { __typename?: 'GenericVehicleClass', name: string } | null, notes: Array<{ __typename?: 'TripNote', id: any, content: string }>, driver?: { __typename?: 'GenericDriver', accountId: any, drivingSince?: any | null, id: any, isActive: boolean, name?: string | null, imageUrl?: string | null } | null, vehicle?: { __typename?: 'GenericVehicle', id: any, makeName: string, modelName: string, name: string, vin?: string | null, year?: number | null, licenseNumber?: string | null, color: string } | null, pickupWaypoint?: { __typename?: 'TripWaypoint', role: TripWaypointRole, airlineId?: any | null, fboId?: any | null, iataCode?: string | null, flightNumber?: string | null, departureTime?: any | null, arrivalTime?: any | null, verifiedFlightId?: string | null, verifiedFlight?: any | null, flightTime?: any | null, estimatedDurationInMinutes?: number | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', id: any, iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', timezone?: string | null, name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null, placeWikidataId?: string | null, placeFoursquareId?: string | null, placeType?: string | null } } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', role: TripWaypointRole, airlineId?: any | null, fboId?: any | null, iataCode?: string | null, flightNumber?: string | null, departureTime?: any | null, arrivalTime?: any | null, verifiedFlightId?: string | null, verifiedFlight?: any | null, flightTime?: any | null, estimatedDurationInMinutes?: number | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', id: any, iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null, placeFoursquareId?: string | null, placeWikidataId?: string | null, placeType?: string | null } } | null, waypoints: Array<{ __typename?: 'TripWaypoint', id: any, role: TripWaypointRole, order: number, airlineId?: any | null, fboId?: any | null, iataCode?: string | null, flightNumber?: string | null, verifiedFlight?: any | null, flightTime?: any | null, estimatedDurationInMinutes?: number | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, note?: string | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', id: any, iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null, placeFoursquareId?: string | null, placeWikidataId?: string | null, placeType?: string | null } }>, invoice?: { __typename?: 'Invoice', id: any, status: InvoiceStatus, type: InvoiceType, total?: number | null, payments?: number | null, balance?: number | null, externalId?: string | null, invoiceProcessor?: CreditCardProcessor | null, externalInvoiceLink?: string | null, lineItems: Array<{ __typename?: 'LineItem', id: any, name?: string | null, unitPrice: number, quantity: number, total: number }>, transactions: Array<{ __typename?: 'Transaction', id: any, type: TransactionType, status: TransactionStatus, paymentMethodType: PaymentMethodType, note?: string | null, amount: number, reversalOfTransactionId?: any | null, accountId: any, invoiceId?: any | null, refundedAmount?: number | null }> } | null, segments: Array<{ __typename?: 'TripSegment', startWaypointId?: any | null, endWaypointId?: any | null, estimatedDistanceInMiles?: number | null, estimatedDurationInMinutes?: number | null, durationInMinutes?: number | null, distanceInMiles?: number | null, order: number }>, availableCommands: Array<{ __typename?: 'TripCommandMeta', typeName: string, name: string, isPrimary?: boolean | null, disabled?: boolean | null, description?: string | null, events: Array<TripEventType>, hidden: boolean }>, sharedAvailableCommands: Array<{ __typename?: 'TripCommandMeta', typeName: string, name: string, isPrimary?: boolean | null, disabled?: boolean | null, description?: string | null, events: Array<TripEventType>, hidden: boolean }> }> } } };

export type SearchTripsByCustomerQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  filter: TripSearchCriteria;
  orderBy?: InputMaybe<TripOrderBy>;
  skip?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type SearchTripsByCustomerQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', search: { __typename?: 'TripCollectionResult', total: number, items: Array<{ __typename?: 'Trip', id: any, accountId: any, status: TripStatus, tripNumber?: number | null, pickupTime?: any | null, preferredVehicleClassId?: any | null, referenceNumber?: string | null, providerExternalId?: string | null, groundworkTrip?: boolean | null, vehicle?: { __typename?: 'GenericVehicle', vehicleClass: { __typename?: 'GenericVehicleClass', name: string } } | null, invoice?: { __typename?: 'Invoice', total?: number | null } | null, pickupWaypoint?: { __typename?: 'TripWaypoint', savoyaStop?: any | null, role: TripWaypointRole, flightNumber?: string | null, location: { __typename?: 'Location', coordinates: any, name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null }, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null } | null }> } } };

export type SensorReadingsByTripIdQueryVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type SensorReadingsByTripIdQuery = { __typename?: 'Query', vehicleSensorReadings: { __typename?: 'VehicleSensorReadingQueries', byTrip?: { __typename?: 'VehicleSensorReadingCollectionResult', items: Array<{ __typename?: 'VehicleSensorReading', coordinates: any }> } | null } };

export type SensorReadingsByTripActualRouteQueryVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type SensorReadingsByTripActualRouteQuery = { __typename?: 'Query', vehicleSensorReadings: { __typename?: 'VehicleSensorReadingQueries', byTripActualRoute?: { __typename?: 'VehicleSensorReadingCollectionResult', items: Array<{ __typename?: 'VehicleSensorReading', coordinates: any }> } | null } };

export type SearchCustomerByNameQueryVariables = Exact<{
  accountId?: InputMaybe<Scalars['UUID']>;
  query: Scalars['String'];
}>;


export type SearchCustomerByNameQuery = { __typename?: 'Query', customers: { __typename?: 'CustomerQueries', searchByName: { __typename?: 'CustomerCollectionResult', total: number, items: Array<{ __typename?: 'Customer', accountId: any, id: any, name: string, type: CustomerType }> } } };

export type SearchByContactNameQueryVariables = Exact<{
  customerId?: InputMaybe<Scalars['UUID']>;
  query: Scalars['String'];
}>;


export type SearchByContactNameQuery = { __typename?: 'Query', customerContacts: { __typename?: 'CustomerContactQueries', searchByContactName: { __typename?: 'CustomerContactCollectionResult', total: number, items: Array<{ __typename?: 'CustomerContact', id: any, contact: { __typename?: 'Contact', id: any, name?: string | null, phoneNumber?: string | null, email: string } }> } } };

export type GetContactsByCustomerQueryVariables = Exact<{
  customerId: Scalars['UUID'];
}>;


export type GetContactsByCustomerQuery = { __typename?: 'Query', customerContacts: { __typename?: 'CustomerContactQueries', all: { __typename?: 'CustomerContactCollectionResult', total: number, items: Array<{ __typename?: 'CustomerContact', id: any, primaryRole: CustomerRole, contact: { __typename?: 'Contact', id: any, name?: string | null, phoneNumber?: string | null, email: string } }> } } };

export type GetInProcessTripsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
}>;


export type GetInProcessTripsQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', search: { __typename?: 'TripCollectionResult', items: Array<{ __typename?: 'Trip', id: any, isShared?: boolean | null, providerSource?: TripProviderSource | null, accountId: any, pickupTime?: any | null, status: TripStatus, tripNumber?: number | null, sharedTrip?: { __typename?: 'SharedTrip', amount: number, token: string, id: any, paymentMethodType: PaymentMethodType, status: SharedTripStatus, savoyaAssignmentStatus?: SavoyaSharedTripStatus | null, contact?: { __typename?: 'Contact', name?: string | null, email: string, phoneNumber?: string | null } | null } | null, availableCommands: Array<{ __typename?: 'TripCommandMeta', name: string, typeName: string, events: Array<TripEventType>, description?: string | null, hidden: boolean, disabled?: boolean | null }>, pickupWaypoint?: { __typename?: 'TripWaypoint', flightNumber?: string | null, departureTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, savoyaStop?: any | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', placeName?: string | null, addressLine1?: string | null, coordinates: any, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null } } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', savoyaStop?: any | null, flightNumber?: string | null, departureTime?: any | null, arrivalTime?: any | null, estimatedDepartureTime?: any | null, estimatedArrivalTime?: any | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', placeName?: string | null, addressLine1?: string | null, coordinates: any, city?: string | null, state?: string | null, postalCode?: string | null, placeCategory?: string | null } } | null, waypoints: Array<{ __typename?: 'TripWaypoint', id: any, role: TripWaypointRole, order: number, savoyaStop?: any | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, coordinates: any, city?: string | null, state?: string | null, postalCode?: string | null } }>, preferredVehicleClass?: { __typename?: 'GenericVehicleClass', name: string } | null }> } } };

export type GetNotificationTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationTypesQuery = { __typename?: 'Query', tripNotificationTypes: { __typename?: 'TripNotificationTypeQueries', all: { __typename?: 'TripNotificationTypeCollectionResult', items: Array<{ __typename?: 'TripNotificationType', id: any, name: string, trigger: TripEventType, order: number, enabled?: boolean | null }> } } };

export type InsertTripAddonMutationVariables = Exact<{
  tripAddon: InsertTripAddon;
}>;


export type InsertTripAddonMutation = { __typename?: 'Mutation', insertTripAddon?: { __typename?: 'InsertTripAddonResult', tripAddon?: { __typename?: 'TripAddon', id: any, tripId: any, rateTypeId: any, quantity: number, unitPrice: number, total: number, note?: string | null, calculation?: AdjustmentCalculation | null } | null } | null };

export type UpdateTripAddonMutationVariables = Exact<{
  tripAddon: UpdateTripAddon;
}>;


export type UpdateTripAddonMutation = { __typename?: 'Mutation', updateTripAddon?: { __typename?: 'UpdateTripAddonResult', tripAddon?: { __typename?: 'TripAddon', id: any, tripId: any, rateTypeId: any, quantity: number, unitPrice: number, total: number, note?: string | null } | null } | null };

export type DeleteTripAddonMutationVariables = Exact<{
  tripAddonId: Scalars['UUID'];
}>;


export type DeleteTripAddonMutation = { __typename?: 'Mutation', deleteTripAddon?: { __typename?: 'DeleteTripAddonResult', success: boolean, errors?: Array<{ __typename?: 'MutationError', message: string }> | null } | null };

export type ListFbOsByIataCodeQueryVariables = Exact<{
  iata: Scalars['String'];
}>;


export type ListFbOsByIataCodeQuery = { __typename?: 'Query', fbos: { __typename?: 'FboQueries', byIataCode?: { __typename?: 'FboCollectionResult', items: Array<{ __typename?: 'Fbo', id: any, iata_code?: string | null, icao_code?: string | null, fbo_name?: string | null, fbo_address?: string | null, fbo_postal_code?: string | null }> } | null } };

export type VerifyTripWaypointFlightMutationVariables = Exact<{
  waypoint: UpsertTripWaypointInput;
  travelDate?: InputMaybe<Scalars['String']>;
}>;


export type VerifyTripWaypointFlightMutation = { __typename?: 'Mutation', verifyTripWaypointFlight: { __typename?: 'VerifiedFlightResult', verifiedFlight?: any | null, success: boolean, errors?: Array<{ __typename?: 'MutationError', code?: string | null, message: string }> | null } };

export type ExecuteCorrectTripTimestampMutationVariables = Exact<{
  command: CorrectTripTimestamp;
}>;


export type ExecuteCorrectTripTimestampMutation = { __typename?: 'Mutation', executeCorrectTripTimestamp: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type ExecuteOverrideGarageTimeMutationVariables = Exact<{
  command: OverrideGarageTime;
}>;


export type ExecuteOverrideGarageTimeMutation = { __typename?: 'Mutation', executeOverrideGarageTime: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type ExecuteOverrideWaitTimeMutationVariables = Exact<{
  command: OverrideWaitTime;
}>;


export type ExecuteOverrideWaitTimeMutation = { __typename?: 'Mutation', executeOverrideWaitTime: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type CreateOrUpdateInvoiceSummaryForTripMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type CreateOrUpdateInvoiceSummaryForTripMutation = { __typename?: 'Mutation', createOrUpdateInvoiceSummaryForTrip: { __typename?: 'InvoiceSummary', id: any, type?: InvoiceType | null, calculation: RateCalculation, baseQuantity: number, baseUnitPrice: number, baseTotal: number, waitQuantity?: number | null, waitUnitPrice?: number | null, waitTotal?: number | null, rateId?: any | null, total: number, payments?: number | null, balance?: number | null, pickupGarageTime?: number | null, dropoffGarageTime?: number | null, otherItems: Array<{ __typename?: 'OtherItemSummary', addonId?: any | null, name: string, category: RateCategory, description?: string | null, unitPrice: number, quantity: number, total: number }>, tripStartedTime?: { __typename?: 'InvoiceTime', scheduledTime?: any | null, billedTime?: any | null } | null, pickupTime?: { __typename?: 'InvoiceTime', scheduledTime?: any | null, billedTime?: any | null } | null, dropoffTime?: { __typename?: 'InvoiceTime', scheduledTime?: any | null, billedTime?: any | null } | null, tripCompletedTime?: { __typename?: 'InvoiceTime', scheduledTime?: any | null, billedTime?: any | null } | null, transactions: Array<{ __typename?: 'TransactionItemSummary', type: TransactionType, amount: number, refundedAmount?: number | null, status: TransactionStatus, createdAt: string, paymentMethodType: PaymentMethodType, id: any, stripePaymentIntentId?: string | null, note?: string | null, paymentMethod?: { __typename?: 'PaymentMethodSummary', id: string, description?: string | null } | null }> } };

export type MonitoringSummaryQueryVariables = Exact<{
  monitoringToken: Scalars['String'];
}>;


export type MonitoringSummaryQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', monitoringSummary: { __typename?: 'MonitoringSummary', accountName?: string | null, status?: TripStatus | null, stagingNotes?: string | null, destination?: { __typename?: 'TripWaypoint', role: TripWaypointRole, location: { __typename?: 'Location', id: any, name: string, addressLine1?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any } } | null, position?: { __typename?: 'VehicleSensorReading', createdAt: any, coordinates: any, heading: number } | null, driver?: { __typename?: 'DriverSummary', name?: string | null, phoneNumber?: string | null, picture?: string | null } | null, vehicle?: { __typename?: 'VehicleSummary', name?: string | null, licenseNumber?: string | null, picture?: string | null } | null } } };

export type AccountMonitoringSummaryQueryVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type AccountMonitoringSummaryQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', accountMonitoringSummary: { __typename?: 'MonitoringSummary', accountName?: string | null, status?: TripStatus | null, stagingNotes?: string | null, destination?: { __typename?: 'TripWaypoint', role: TripWaypointRole, location: { __typename?: 'Location', id: any, name: string, addressLine1?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any } } | null, position?: { __typename?: 'VehicleSensorReading', createdAt: any, coordinates: any, heading: number } | null, driver?: { __typename?: 'DriverSummary', name?: string | null, phoneNumber?: string | null, picture?: string | null } | null, vehicle?: { __typename?: 'VehicleSummary', name?: string | null, licenseNumber?: string | null, picture?: string | null } | null } } };

export type GetInvoiceSummaryByTripQueryVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type GetInvoiceSummaryByTripQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceQueries', getSummaryByTripId: { __typename?: 'InvoiceSummary', id: any, type?: InvoiceType | null, calculation: RateCalculation, baseQuantity: number, baseUnitPrice: number, baseTotal: number, waitQuantity?: number | null, waitUnitPrice?: number | null, waitTotal?: number | null, rateId?: any | null, total: number, payments?: number | null, balance?: number | null, pickupGarageTime?: number | null, dropoffGarageTime?: number | null, otherItems: Array<{ __typename?: 'OtherItemSummary', addonId?: any | null, name: string, category: RateCategory, description?: string | null, unitPrice: number, quantity: number, total: number }>, tripStartedTime?: { __typename?: 'InvoiceTime', scheduledTime?: any | null, billedTime?: any | null } | null, pickupTime?: { __typename?: 'InvoiceTime', scheduledTime?: any | null, billedTime?: any | null } | null, dropoffTime?: { __typename?: 'InvoiceTime', scheduledTime?: any | null, billedTime?: any | null } | null, tripCompletedTime?: { __typename?: 'InvoiceTime', scheduledTime?: any | null, billedTime?: any | null } | null, transactions: Array<{ __typename?: 'TransactionItemSummary', type: TransactionType, amount: number, refundedAmount?: number | null, status: TransactionStatus, createdAt: string, paymentMethodType: PaymentMethodType, id: any, stripePaymentIntentId?: string | null, note?: string | null, paymentMethod?: { __typename?: 'PaymentMethodSummary', id: string, description?: string | null } | null }> } } };

export type ExecuteOverrideBaseRateMutationVariables = Exact<{
  command: OverrideBaseRate;
}>;


export type ExecuteOverrideBaseRateMutation = { __typename?: 'Mutation', executeOverrideBaseRate: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type ExecuteUseDifferentClassRateMutationVariables = Exact<{
  command: UseDifferentClassRate;
}>;


export type ExecuteUseDifferentClassRateMutation = { __typename?: 'Mutation', executeUseDifferentClassRate: { __typename?: 'TripCommandResult', errors?: Array<string> | null, succeeded: boolean, trip?: { __typename?: 'Trip', id: any } | null } };

export type ExecuteApplyFlatRateOverrideMutationVariables = Exact<{
  command: ApplyFlatRateOverride;
}>;


export type ExecuteApplyFlatRateOverrideMutation = { __typename?: 'Mutation', executeApplyFlatRateOverride: { __typename?: 'TripCommandResult', errors?: Array<string> | null, succeeded: boolean, trip?: { __typename?: 'Trip', id: any } | null } };

export type ExecuteAcceptNetworkOfferMutationVariables = Exact<{
  command: AcceptNetworkOffer;
}>;


export type ExecuteAcceptNetworkOfferMutation = { __typename?: 'Mutation', executeAcceptNetworkOffer: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', id: any } | null } };

export type ExecuteConfirmNetworkRequestMutationVariables = Exact<{
  command: ConfirmNetworkRequest;
}>;


export type ExecuteConfirmNetworkRequestMutation = { __typename?: 'Mutation', executeConfirmNetworkRequest: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', id: any } | null } };

export type DeclineNetworkOfferMutationVariables = Exact<{
  tripId: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type DeclineNetworkOfferMutation = { __typename?: 'Mutation', executeDeclineNetworkOffer: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', id: any, status: TripStatus, isShared?: boolean | null, providerSource?: TripProviderSource | null } | null } };

export type DeclineNetworkConfirmationRequestMutationVariables = Exact<{
  tripId: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type DeclineNetworkConfirmationRequestMutation = { __typename?: 'Mutation', executeDeclineNetworkConfirmationRequest: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', id: any, status: TripStatus, isShared?: boolean | null, providerSource?: TripProviderSource | null } | null } };

export type RevokeNetworkSharedTripMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type RevokeNetworkSharedTripMutation = { __typename?: 'Mutation', executeRevokeNetworkSharedTrip: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', id: any, status: TripStatus, isShared?: boolean | null, providerSource?: TripProviderSource | null } | null } };

export type RollbackToOnsiteMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type RollbackToOnsiteMutation = { __typename?: 'Mutation', executeRollbackToOnsite: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', id: any, status: TripStatus, isShared?: boolean | null, providerSource?: TripProviderSource | null } | null } };

export type GetNotificationSubscriptionByTripClientIdQueryVariables = Exact<{
  tripClientId: Scalars['UUID'];
}>;


export type GetNotificationSubscriptionByTripClientIdQuery = { __typename?: 'Query', tripNotificationSubscriptions: { __typename?: 'TripNotificationSubscriptionQueries', byTripClientId: { __typename?: 'TripNotificationSubscriptionCollectionResult', total: number, items: Array<{ __typename?: 'TripNotificationSubscription', id: any, notificationTypeId: any, tripContactId: any, channels: Array<MessageChannel>, createdAt: any, updatedAt: any, deletedAt?: any | null, version: number, notificationType: { __typename?: 'TripNotificationType', id: any, name: string, order: number, trigger: TripEventType, version: number, updatedAt: any, enabled?: boolean | null } }> } } };

export type GetOneActiveTripByIdsQueryVariables = Exact<{
  tripIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type GetOneActiveTripByIdsQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', findOneActive?: { __typename?: 'Trip', id: any } | null } };

export type PublicDetailsAccountQueryVariables = Exact<{
  bookingToken: Scalars['String'];
}>;


export type PublicDetailsAccountQuery = { __typename?: 'Query', accounts: { __typename?: 'AccountQueries', publicDetailsAccount?: { __typename?: 'Account', id: any, name: string, description?: string | null, salesPitch?: string | null, legalName?: string | null, logoUrl?: string | null, videoUrl?: string | null, established?: any | null, primaryPhoneNumber?: string | null, primaryEmailAddress?: string | null, website?: string | null, bookingToken?: string | null, bookingToolEnabled?: boolean | null, displayRatesInBookingTool?: boolean | null, rates: Array<{ __typename?: 'Rate', defaultRate?: boolean | null, calculation?: RateCalculation | null, meteredRateIncrement?: number | null, revertToDynamicForExcessWaitTime?: boolean | null, ratePolicies: Array<{ __typename?: 'RatePolicy', thresholdValue?: number | null, thresholdValue2?: number | null, type: RatePolicyType }> }>, garages: Array<{ __typename?: 'Garage', name: string, id: any, location: { __typename?: 'Location', addressLine1?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeName?: string | null, placeType?: string | null, placeCategory?: string | null } }> } | null } };

export type PublicAllQueryVariables = Exact<{ [key: string]: never; }>;


export type PublicAllQuery = { __typename?: 'Query', tripNotificationTypes: { __typename?: 'TripNotificationTypeQueries', publicAll: { __typename?: 'TripNotificationTypeCollectionResult', items: Array<{ __typename?: 'TripNotificationType', id: any, name: string, trigger: TripEventType, order: number, enabled?: boolean | null }> } } };

export type AllVehicleClassPublicQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type AllVehicleClassPublicQuery = { __typename?: 'Query', vehicleClasses: { __typename?: 'VehicleClassQueries', allVehicleClassPublic: { __typename?: 'VehicleClassCollectionResult', total: number, items: Array<{ __typename?: 'VehicleClass', id: any, accountId: any, systemClassId: string, name: string, imageUrl?: string | null, hourlyRate?: number | null, minimumHours?: number | null, cancellationPolicyHours?: number | null, systemClass: { __typename?: 'SystemVehicleClass', id: string, name: string, description?: string | null, defaultCostMultiplier: number } }> } } };

export type RatesForBookingQueryVariables = Exact<{
  bookingToken: Scalars['String'];
  tripForm: InsertTrip;
}>;


export type RatesForBookingQuery = { __typename?: 'Query', rates: { __typename?: 'RateQueries', ratesForBooking: Array<{ __typename?: 'VehicleClassRateForBooking', total: number, vehicleClass: { __typename?: 'VehicleClass', id: any, accountId: any, systemClassId: string, name: string, imageUrl?: string | null, hourlyRate?: number | null, minimumHours?: number | null, cancellationPolicyHours?: number | null, systemClass: { __typename?: 'SystemVehicleClass', id: string, name: string, description?: string | null, defaultCostMultiplier: number } } } | null> } };

export type FilesFromPathQueryVariables = Exact<{
  bucket: Scalars['String'];
  key: Scalars['String'];
}>;


export type FilesFromPathQuery = { __typename?: 'Query', media?: { __typename?: 'MediaQueries', filesFromPath?: { __typename?: 'FileInfo', signedUrls: Array<{ __typename?: 'SignedURL', url: string, key: string, metadata?: { __typename?: 'FileMetadata', type?: string | null } | null } | null> } | null } | null };

export type CurrentGarageQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  driverId?: InputMaybe<Scalars['UUID']>;
}>;


export type CurrentGarageQuery = { __typename?: 'Query', garages: { __typename?: 'GarageQueries', current?: { __typename?: 'Garage', name: string, location: { __typename?: 'Location', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null, coordinates: any, placeType?: string | null, placeCategory?: string | null, placeName?: string | null, placeId?: string | null } } | null } };

export type ExecuteCreateOrUpdateInvoiceMutationVariables = Exact<{
  tripId: Scalars['UUID'];
  type?: InputMaybe<InvoiceType>;
}>;


export type ExecuteCreateOrUpdateInvoiceMutation = { __typename?: 'Mutation', executeCreateOrUpdateInvoice: { __typename?: 'TripCommandResult', succeeded: boolean } };

export type GetInvoicePdfQueryVariables = Exact<{
  invoiceId: Scalars['UUID'];
  timeZone?: InputMaybe<Scalars['String']>;
}>;


export type GetInvoicePdfQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceQueries', getPDF: string } };

export type SearchIndexedTripsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  filter?: InputMaybe<Scalars['String']>;
}>;


export type SearchIndexedTripsQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', searchIndexed: { __typename?: 'TripCollectionResult', total: number, items: Array<{ __typename?: 'Trip', id: any, tripNumber?: number | null, stagingNotes?: string | null, pickupTime?: any | null, status: TripStatus, estimatedSpotTimeInMinutes?: number | null, providerExternalId?: string | null, groundworkTrip?: boolean | null, vehicleId?: any | null, driverId?: any | null, pickupWaypoint?: { __typename?: 'TripWaypoint', flightNumber?: string | null, departureTime?: any | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null } } | null, dropoffWaypoint?: { __typename?: 'TripWaypoint', flightNumber?: string | null, airline?: { __typename?: 'Airline', IATA: string, name: string } | null, fbo?: { __typename?: 'Fbo', iata_code?: string | null, fbo_name?: string | null } | null, location: { __typename?: 'Location', name: string, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, postalCode?: string | null, coordinates: any, placeCategory?: string | null } } | null }> } } };

export type ExecuteBeginPaymentMethodSetupMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type ExecuteBeginPaymentMethodSetupMutation = { __typename?: 'Mutation', executeBeginPaymentMethodSetup: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', stripeSetupIntentId?: string | null } | null } };

export type ExecuteCreatePaymentMethodMutationVariables = Exact<{
  tripId: Scalars['UUID'];
  externalPaymentMethodId: Scalars['String'];
  customerContactId?: InputMaybe<Scalars['UUID']>;
  source: CreditCardProcessor;
}>;


export type ExecuteCreatePaymentMethodMutation = { __typename?: 'Mutation', executeCreatePaymentMethod: { __typename?: 'TripCommandResult', succeeded: boolean, trip?: { __typename?: 'Trip', paymentMethodId?: any | null, paymentMethod?: { __typename?: 'PaymentMethod', description: string } | null } | null } };

export type ExecuteSetPaymentMethodMutationVariables = Exact<{
  tripId: Scalars['UUID'];
  paymentMethodId?: InputMaybe<Scalars['UUID']>;
  paymentMethodType?: InputMaybe<PaymentMethodType>;
}>;


export type ExecuteSetPaymentMethodMutation = { __typename?: 'Mutation', executeSetPaymentMethod: { __typename?: 'TripCommandResult', succeeded: boolean, trip?: { __typename?: 'Trip', paymentMethodId?: any | null, paymentMethodType?: PaymentMethodType | null, paymentMethod?: { __typename?: 'PaymentMethod', description: string } | null } | null } };

export type GetPaymentMethodByTripQueryVariables = Exact<{
  input: PaymentByTripInput;
}>;


export type GetPaymentMethodByTripQuery = { __typename?: 'Query', paymentMethods: { __typename?: 'PaymentMethodQueries', byTrip: { __typename?: 'PaymentMethodCollectionResult', total: number, items: Array<{ __typename?: 'PaymentMethod', id: any, description: string, externalPaymentMethodId: string, customerContactId?: any | null, source: CreditCardProcessor }> } } };

export type GetSetupClientIdForTripQueryVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type GetSetupClientIdForTripQuery = { __typename?: 'Query', stripe?: { __typename?: 'StripeQueries', getSetupClientIdForTrip?: { __typename?: 'GetSetupClientIdForTripResponse', clientSecret?: string | null } | null } | null };

export type ExecuteProcessPaymentMutationVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type ExecuteProcessPaymentMutation = { __typename?: 'Mutation', executeProcessPayment: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null, trip?: { __typename?: 'Trip', paymentMethodType?: PaymentMethodType | null, invoice?: { __typename?: 'Invoice', balance?: number | null } | null, paymentMethod?: { __typename?: 'PaymentMethod', id: any } | null } | null } };

export type GetPaymentMethodByCustomerContactQueryVariables = Exact<{
  input: PaymentByCustomerContactInput;
}>;


export type GetPaymentMethodByCustomerContactQuery = { __typename?: 'Query', paymentMethods: { __typename?: 'PaymentMethodQueries', byCustomerContact: { __typename?: 'PaymentMethodCollectionResult', total: number, items: Array<{ __typename?: 'PaymentMethod', id: any, description: string, externalPaymentMethodId: string, customerContactId?: any | null, source: CreditCardProcessor }> } } };

export type StartPaymentMethodSetupMutationVariables = Exact<{
  customerContactId: Scalars['UUID'];
}>;


export type StartPaymentMethodSetupMutation = { __typename?: 'Mutation', startPaymentMethodSetup?: { __typename?: 'StartPaymentMethodSetupResponse', stripeSetupIntentId?: string | null, clientSecret?: string | null, success: boolean, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null } | null };

export type InsertPaymentMethodMutationVariables = Exact<{
  customerContactId: Scalars['UUID'];
  externalPaymentMethodId: Scalars['String'];
  source: CreditCardProcessor;
}>;


export type InsertPaymentMethodMutation = { __typename?: 'Mutation', insertPaymentMethod?: { __typename?: 'InsertPaymentMethodResult', paymentMethodId?: string | null, paymentMethodDescription?: string | null, success: boolean } | null };

export type DeletePaymentMethodMutationVariables = Exact<{
  paymentMethodId: Scalars['UUID'];
}>;


export type DeletePaymentMethodMutation = { __typename?: 'Mutation', deletePaymentMethod?: { __typename?: 'DeletePaymentMethodResult', success: boolean } | null };

export type ExecuteApplyRefundMutationVariables = Exact<{
  tripId: Scalars['UUID'];
  amountRefunded: Scalars['Float'];
  refundReason: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
}>;


export type ExecuteApplyRefundMutation = { __typename?: 'Mutation', executeApplyRefund: { __typename?: 'TripCommandResult', succeeded: boolean, errors?: Array<string> | null } };

export type UpdateTripNoteMutationVariables = Exact<{
  tripNote: UpdateTripNote;
}>;


export type UpdateTripNoteMutation = { __typename?: 'Mutation', updateTripNote?: { __typename?: 'UpdateTripNoteResult', tripNote?: { __typename?: 'TripNote', id: any, time: any, content: string } | null } | null };

export type GetCustomersAndContacsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  filter?: InputMaybe<Scalars['String']>;
}>;


export type GetCustomersAndContacsQuery = { __typename?: 'Query', customerContacts: { __typename?: 'CustomerContactQueries', searchByIndex: { __typename?: 'CustomerContactSearchResult', customerContacts?: { __typename?: 'CustomerContactCollectionResult', total: number, items: Array<{ __typename?: 'CustomerContact', customerId: any, id: any, primaryRole: CustomerRole, contact: { __typename?: 'Contact', name?: string | null, email: string, phoneNumber?: string | null }, customer: { __typename?: 'Customer', name: string, type: CustomerType } }> } | null, customers?: { __typename?: 'CustomerCollectionResult', items: Array<{ __typename?: 'Customer', name: string, type: CustomerType, id: any }> } | null } } };

export type GetEstimatedSummaryQueryVariables = Exact<{
  tripId: Scalars['UUID'];
  vehicleClassId: Scalars['UUID'];
}>;


export type GetEstimatedSummaryQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceQueries', getEstimatedSummary: { __typename?: 'InvoiceSummary', id: any, type?: InvoiceType | null, calculation: RateCalculation, baseQuantity: number, baseUnitPrice: number, baseTotal: number, waitQuantity?: number | null, waitUnitPrice?: number | null, waitTotal?: number | null, rateId?: any | null, total: number, payments?: number | null, balance?: number | null, pickupGarageTime?: number | null, dropoffGarageTime?: number | null, otherItems: Array<{ __typename?: 'OtherItemSummary', addonId?: any | null, name: string, category: RateCategory, description?: string | null, unitPrice: number, quantity: number, total: number }>, tripStartedTime?: { __typename?: 'InvoiceTime', scheduledTime?: any | null, billedTime?: any | null } | null, pickupTime?: { __typename?: 'InvoiceTime', scheduledTime?: any | null, billedTime?: any | null } | null, dropoffTime?: { __typename?: 'InvoiceTime', scheduledTime?: any | null, billedTime?: any | null } | null, tripCompletedTime?: { __typename?: 'InvoiceTime', scheduledTime?: any | null, billedTime?: any | null } | null, transactions: Array<{ __typename?: 'TransactionItemSummary', type: TransactionType, amount: number, refundedAmount?: number | null, status: TransactionStatus, createdAt: string, paymentMethodType: PaymentMethodType, id: any, stripePaymentIntentId?: string | null, note?: string | null, paymentMethod?: { __typename?: 'PaymentMethodSummary', id: string, description?: string | null } | null }> } } };

export type ListAllUsersByAccountQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type ListAllUsersByAccountQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactQueries', usersByAccount: { __typename?: 'ContactCollectionResult', total: number, items: Array<{ __typename?: 'Contact', id: any, name?: string | null, email: string, isActive: boolean, driver?: { __typename?: 'Driver', id: any, externalId?: any | null } | null }> } } };

export type FetchContactByIdQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;


export type FetchContactByIdQuery = { __typename?: 'Query', contacts: { __typename?: 'ContactQueries', byId?: { __typename?: 'Contact', id: any, name?: string | null, email: string, title?: string | null, userRole: UserRole, phoneNumber?: string | null, contactType: ContactType, isActive: boolean, driver?: { __typename?: 'Driver', id: any, marketingDescription?: string | null, isActive: boolean, externalId?: any | null } | null } | null } };

export type GetUserByTokenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserByTokenQuery = { __typename?: 'Query', usersQueries?: { __typename?: 'UserQueries', getUserByToken?: { __typename?: 'UserRecord', id: any, email: string, phoneNumber?: string | null, firstName: string, lastName: string, name: string, role: UserIdentityRole, productType?: Array<ProductType> | null, vendorId?: any | null, isSavoyaUser?: boolean | null } | null } | null };

export type GetMicroServiceUserByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetMicroServiceUserByIdQuery = { __typename?: 'Query', usersQueries?: { __typename?: 'UserQueries', getById?: { __typename?: 'UserRecord', id: any, email: string, phoneNumber?: string | null, role: UserIdentityRole, productType?: Array<ProductType> | null, identityProvider: IdentityProvider, externalId: string, name: string, firstName: string, lastName: string, vendorId?: any | null, createdAt: any, updatedAt: any } | null } | null };

export type GetMicroServiceUsersByRoleQueryVariables = Exact<{
  skip: Scalars['Int'];
  take: Scalars['Int'];
  role?: InputMaybe<UserIdentityRole>;
  orderBy?: InputMaybe<OrderByDirection>;
}>;


export type GetMicroServiceUsersByRoleQuery = { __typename?: 'Query', usersQueries?: { __typename?: 'UserQueries', getByUserRole?: Array<{ __typename?: 'UserRecord', id: any, email: string, phoneNumber?: string | null, role: UserIdentityRole, productType?: Array<ProductType> | null, identityProvider: IdentityProvider, externalId: string, name: string, firstName: string, lastName: string, vendorId?: any | null, createdAt: any, updatedAt: any }> | null } | null };

export type AddContactMutationVariables = Exact<{
  contact: InsertContact;
}>;


export type AddContactMutation = { __typename?: 'Mutation', insertContact?: { __typename?: 'InsertContactResult', success: boolean, contact?: { __typename?: 'Contact', id: any, email: string, name?: string | null, phoneNumber?: string | null, title?: string | null, profileImageUrl?: string | null, contactType: ContactType, userRole: UserRole, accountId?: any | null, analyticsToken?: string | null, firebaseToken?: string | null, isActive: boolean, driver?: { __typename?: 'Driver', id: any, marketingDescription?: string | null, externalId?: any | null } | null, addresses?: Array<{ __typename?: 'Location', name: string, category?: LocationCategory | null, addressLine1?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null }> | null } | null, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null, existingContact?: { __typename?: 'Contact', id: any, email: string, name?: string | null } | null } | null };

export type UpdateContactMutationVariables = Exact<{
  contact: UpdateContact;
}>;


export type UpdateContactMutation = { __typename?: 'Mutation', updateContact?: { __typename?: 'UpdateContactResult', success: boolean, contact?: { __typename?: 'Contact', id: any, email: string, name?: string | null, phoneNumber?: string | null, title?: string | null, profileImageUrl?: string | null, contactType: ContactType, userRole: UserRole, accountId?: any | null, analyticsToken?: string | null, firebaseToken?: string | null, isActive: boolean, driver?: { __typename?: 'Driver', id: any, marketingDescription?: string | null, externalId?: any | null } | null, addresses?: Array<{ __typename?: 'Location', name: string, category?: LocationCategory | null, addressLine1?: string | null, city?: string | null, state?: string | null, country?: string | null, postalCode?: string | null }> | null } | null, errors?: Array<{ __typename?: 'MutationError', message: string, code?: string | null }> | null, existingContact?: { __typename?: 'Contact', id: any, email: string, name?: string | null } | null } | null };

export type InsertUserMutationVariables = Exact<{
  contact: InsertUser;
  fileType?: InputMaybe<Scalars['String']>;
  useWithSavoya?: InputMaybe<Scalars['Boolean']>;
}>;


export type InsertUserMutation = { __typename?: 'Mutation', insertUser?: { __typename?: 'InsertUserResult', signedUrl?: string | null, contact?: { __typename?: 'Contact', id: any, name?: string | null, email: string, title?: string | null, contactType: ContactType, userRole: UserRole, phoneNumber?: string | null, driver?: { __typename?: 'Driver', id: any, marketingDescription?: string | null, externalId?: any | null } | null } | null } | null };

export type AddVehicleClassMutationVariables = Exact<{
  vehicleClass: InsertVehicleClass;
}>;


export type AddVehicleClassMutation = { __typename?: 'Mutation', insertVehicleClass?: { __typename?: 'InsertVehicleClassResult', vehicleClass?: { __typename?: 'VehicleClass', id: any, name: string } | null } | null };

export type UpdateVehicleClassMutationVariables = Exact<{
  vehicleClass: UpdateVehicleClass;
}>;


export type UpdateVehicleClassMutation = { __typename?: 'Mutation', updateVehicleClass?: { __typename?: 'UpdateVehicleClassResult', vehicleClass?: { __typename?: 'VehicleClass', id: any, name: string } | null } | null };

export type InactivateVehicleClassMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type InactivateVehicleClassMutation = { __typename?: 'Mutation', inactivateVehicleClass?: { __typename?: 'InactivateVehicleClassResult', success: boolean, errors?: Array<{ __typename?: 'MutationError', code?: string | null, message: string }> | null, vehicleClass?: { __typename?: 'VehicleClass', id: any } | null } | null };

export type InactivateVehicleMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type InactivateVehicleMutation = { __typename?: 'Mutation', inactivateVehicle?: { __typename?: 'InactivateVehicleResult', success: boolean, errors?: Array<{ __typename?: 'MutationError', code?: string | null, message: string }> | null, vehicle?: { __typename?: 'Vehicle', id: any } | null } | null };

export type ListAllVehicleClassesQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type ListAllVehicleClassesQuery = { __typename?: 'Query', vehicleClasses: { __typename?: 'VehicleClassQueries', all: { __typename?: 'VehicleClassCollectionResult', total: number, items: Array<{ __typename?: 'VehicleClass', id: any, accountId: any, systemClassId: string, luggageCount?: number | null, passengerCount?: number | null, name: string, imageUrl?: string | null, hourlyRate?: number | null, cancellationPolicyHours?: number | null, minimumHours?: number | null, systemClass: { __typename?: 'SystemVehicleClass', id: string, name: string, description?: string | null, defaultCostMultiplier: number } }> } } };

export type GetVehiclesQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetVehiclesQuery = { __typename?: 'Query', vehicles: { __typename?: 'VehicleQueries', all: { __typename?: 'VehicleCollectionResult', total: number, items: Array<{ __typename?: 'Vehicle', id: any, availability: VehicleAvailability, year: number, isActive: boolean, externalId?: any | null, model: { __typename?: 'VehicleModel', id: any, name: string, makeId: string, make: { __typename?: 'VehicleMake', id: string, name: string } }, vehicleClass: { __typename?: 'VehicleClass', name: string } }> } } };

export type GetVehiclesFilteredQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  vehicleClassId?: InputMaybe<Scalars['UUID']>;
  orderBy?: InputMaybe<OrderByDirection>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetVehiclesFilteredQuery = { __typename?: 'Query', vehicles: { __typename?: 'VehicleQueries', search: { __typename?: 'VehicleCollectionResult', total: number, items: Array<{ __typename?: 'Vehicle', id: any, availability: VehicleAvailability, color: string, middleSeatType?: VehicleMiddleSeatType | null, vin?: string | null, licenseNumber?: string | null, year: number, isActive: boolean, externalId?: any | null, model: { __typename?: 'VehicleModel', id: any, name: string, makeId: string, make: { __typename?: 'VehicleMake', id: string, name: string } }, vehicleClass: { __typename?: 'VehicleClass', name: string, id: any } }> } } };

export type GetSavoyaVehiclesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderByDirection>;
  vendorId?: InputMaybe<Scalars['UUID']>;
  vehicleId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  providerType?: InputMaybe<ProviderType>;
  status?: InputMaybe<VehicleStatus>;
  vehicleClassId?: InputMaybe<Scalars['UUID']>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSavoyaVehiclesQuery = { __typename?: 'Query', vehicleQueries?: { __typename?: 'VehicleQueryResolvers', vehiclesByVendorId?: { __typename?: 'VehicleSearchResponse', total: number, items: Array<{ __typename?: 'VehicleRecord', id: any, isActive?: boolean | null, vendorId: any, vehicleClassId: any, name: string, imageUrl?: string | null, year?: number | null, color?: string | null, make?: string | null, model?: string | null, vin?: string | null, licensePlateNumber?: string | null, seatingArrangement?: string | null, rentalExpirationDate?: any | null, imageUpdatedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, vehicleProvider?: Array<{ __typename?: 'VehicleProviderRecord', id: any, providerType: ProviderType, vehicleId: any, groundwork: boolean, insuranceChecked: boolean, status: VehicleStatus, rejectionReason?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null }> | null, vehicleModel?: { __typename?: 'VehicleModelRecord', id: any, name: string, startYear?: number | null, endYear?: number | null, makeId?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, make?: { __typename?: 'VehicleMakeRecord', id: string, name: string, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null } | null } | null, vehicleClass?: { __typename?: 'VehicleClassRecord', id: any, vendorId?: any | null, systemClass: SystemClass, name: string, dwellTime: number, limitedAvailability: boolean, canBeQuoatedWithoutRates: boolean, signageRequired: boolean, clientCanBook: boolean, displayOrder?: number | null, isActive: boolean, imageUrl?: string | null, hourlyRate?: any | null, passengerCount?: number | null, luggageCount?: number | null, cancellationPolicyHours?: number | null, minimumHours?: number | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, providerType: ProviderType } | null }> } | null } | null };

export type GetVehicleRecordByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetVehicleRecordByIdQuery = { __typename?: 'Query', vehicleQueries?: { __typename?: 'VehicleQueryResolvers', vehicleById?: { __typename?: 'VehicleRecord', id: any, vendorId: any, vehicleClassId: any, name: string, year?: number | null, color?: string | null, make?: string | null, isActive?: boolean | null, model?: string | null, vin?: string | null, licensePlateNumber?: string | null, seatingArrangement?: string | null, rentalExpirationDate?: any | null, imageUrl?: string | null, imageUpdatedAt?: any | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, vehicleProvider?: Array<{ __typename?: 'VehicleProviderRecord', id: any, providerType: ProviderType, vehicleId: any, groundwork: boolean, insuranceChecked: boolean, status: VehicleStatus, rejectionReason?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null }> | null, vehicleModel?: { __typename?: 'VehicleModelRecord', id: any, name: string, startYear?: number | null, endYear?: number | null, makeId?: string | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null, make?: { __typename?: 'VehicleMakeRecord', id: string, name: string, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null } | null } | null, vehicleClass?: { __typename?: 'VehicleClassRecord', id: any, vendorId?: any | null, systemClass: SystemClass, name: string, dwellTime: number, limitedAvailability: boolean, providerType: ProviderType, canBeQuoatedWithoutRates: boolean, signageRequired: boolean, clientCanBook: boolean, displayOrder?: number | null, isActive: boolean, imageUrl?: string | null, hourlyRate?: any | null, passengerCount?: number | null, luggageCount?: number | null, cancellationPolicyHours?: number | null, minimumHours?: number | null, createdAt?: any | null, updatedAt?: any | null, deleted?: any | null } | null } | null } | null };

export type SearchVehicleQueryVariables = Exact<{
  query: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<OrderByDirection>;
  accountId: Scalars['UUID'];
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchVehicleQuery = { __typename?: 'Query', vehicles: { __typename?: 'VehicleQueries', search: { __typename?: 'VehicleCollectionResult', total: number, items: Array<{ __typename?: 'Vehicle', id: any, availability: VehicleAvailability, year: number, licenseNumber?: string | null, isActive: boolean, externalId?: any | null, model: { __typename?: 'VehicleModel', id: any, name: string, makeId: string, make: { __typename?: 'VehicleMake', id: string, name: string } }, vehicleClass: { __typename?: 'VehicleClass', name: string } }> } } };

export type GetVehicleQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetVehicleQuery = { __typename?: 'Query', vehicles: { __typename?: 'VehicleQueries', byId?: { __typename?: 'Vehicle', id: any, licenseNumber?: string | null, availability: VehicleAvailability, year: number, vin?: string | null, availabilityComments?: string | null, isActive: boolean, color: string, middleSeatType?: VehicleMiddleSeatType | null, externalId?: any | null, vehicleClass: { __typename?: 'VehicleClass', id: any, name: string }, model: { __typename?: 'VehicleModel', id: any, name: string, make: { __typename?: 'VehicleMake', name: string } } } | null } };

export type CreateVehicleFilesUploadSignedUrlsMutationVariables = Exact<{
  vehicleFilesUploadArgs: VehicleFilesUploadArgs;
}>;


export type CreateVehicleFilesUploadSignedUrlsMutation = { __typename?: 'Mutation', createVehicleFilesUploadSignedUrls: Array<{ __typename?: 'FileSignedUrl', filename?: string | null, filetype: FileTypeEnum, key?: string | null, mimeType?: string | null, signedUrl: string }> };

export type GetVehicleFilesQueryVariables = Exact<{
  vehicleFilesId: Scalars['UUID'];
}>;


export type GetVehicleFilesQuery = { __typename?: 'Query', vehicleQueries?: { __typename?: 'VehicleQueryResolvers', vehicleFiles?: { __typename?: 'FilesResponse', documents?: Array<{ __typename?: 'SignedUrlResponse', key: string, mimeType: string, signedUrl: string }> | null } | null } | null };

export type DeleteVehicleFileMutationVariables = Exact<{
  deleteVehicleFileArgs: VehicleDeleteFileArgs;
}>;


export type DeleteVehicleFileMutation = { __typename?: 'Mutation', deleteVehicleFile: boolean };

export type AddVehicleMutationVariables = Exact<{
  vehicle: InsertVehicleInput;
  fileType?: InputMaybe<Scalars['String']>;
}>;


export type AddVehicleMutation = { __typename?: 'Mutation', insertVehicle?: { __typename?: 'InsertVehicleResult', signedUrl?: string | null, success: boolean, errors?: Array<{ __typename?: 'MutationError', code?: string | null, message: string }> | null, vehicle?: { __typename?: 'Vehicle', id: any, licenseNumber?: string | null, availabilityComments?: string | null, vin?: string | null, year: number, color: string, middleSeatType?: VehicleMiddleSeatType | null, externalId?: any | null } | null } | null };

export type UpdateVehicleMutationVariables = Exact<{
  vehicle: UpdateVehicle;
}>;


export type UpdateVehicleMutation = { __typename?: 'Mutation', updateVehicle?: { __typename?: 'UpdateVehicleResult', vehicle?: { __typename?: 'Vehicle', id: any, availability: VehicleAvailability, color: string, middleSeatType?: VehicleMiddleSeatType | null, vin?: string | null, licenseNumber?: string | null, year: number, isActive: boolean, model: { __typename?: 'VehicleModel', id: any, name: string, makeId: string, make: { __typename?: 'VehicleMake', id: string, name: string } }, vehicleClass: { __typename?: 'VehicleClass', name: string, id: any } } | null } | null };

export type GetVehicleModelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVehicleModelsQuery = { __typename?: 'Query', vehicleModels: { __typename?: 'VehicleModelQueries', all: { __typename?: 'VehicleModelCollectionResult', items: Array<{ __typename?: 'VehicleModel', id: any, name: string, makeId: string, startYear: number, endYear?: number | null }> } } };

export type GetVehicleModelByIdQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetVehicleModelByIdQuery = { __typename?: 'Query', vehicleModels: { __typename?: 'VehicleModelQueries', byId?: { __typename?: 'VehicleModel', id: any, name: string, make: { __typename?: 'VehicleMake', id: string, name: string } } | null } };

export type GetVehicleClassesQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  orderBy?: InputMaybe<OrderByDirection>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetVehicleClassesQuery = { __typename?: 'Query', vehicleClasses: { __typename?: 'VehicleClassQueries', all: { __typename?: 'VehicleClassCollectionResult', items: Array<{ __typename?: 'VehicleClass', id: any, name: string, systemClassId: string, hourlyRate?: number | null, luggageCount?: number | null, passengerCount?: number | null, isActive: boolean, cancellationPolicyHours?: number | null, minimumHours?: number | null, systemClass: { __typename?: 'SystemVehicleClass', id: string, name: string } }> } } };

export type GetVehicleClassByIdQueryVariables = Exact<{
  vehicleClassId: Scalars['UUID'];
}>;


export type GetVehicleClassByIdQuery = { __typename?: 'Query', vehicleClasses: { __typename?: 'VehicleClassQueries', byId?: { __typename?: 'VehicleClass', id: any, name: string, luggageCount?: number | null, passengerCount?: number | null, isActive: boolean, minimumHours?: number | null, cancellationPolicyHours?: number | null, systemClass: { __typename?: 'SystemVehicleClass', id: string, name: string } } | null } };

export type ModelAutocompleteQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type ModelAutocompleteQuery = { __typename?: 'Query', vehicleModels: { __typename?: 'VehicleModelQueries', vehicleModelAutocomplete: Array<{ __typename?: 'VehicleModelLabel', id: any, label: string } | null> } };

export type GetVehicleMakesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVehicleMakesQuery = { __typename?: 'Query', vehicleMakes: { __typename?: 'VehicleMakeQueries', all: { __typename?: 'VehicleMakeCollectionResult', items: Array<{ __typename?: 'VehicleMake', id: string, name: string }> } } };

export type GetVehicleModelsByMakeQueryVariables = Exact<{
  makeId: Scalars['String'];
}>;


export type GetVehicleModelsByMakeQuery = { __typename?: 'Query', vehicleModels: { __typename?: 'VehicleModelQueries', byMake?: { __typename?: 'VehicleModelCollectionResult', items: Array<{ __typename?: 'VehicleModel', id: any, name: string, makeId: string }> } | null } };

export type GetAvailableVehiclesQueryVariables = Exact<{
  tripId: Scalars['UUID'];
}>;


export type GetAvailableVehiclesQuery = { __typename?: 'Query', trips: { __typename?: 'TripQueries', availableVehicles: { __typename?: 'AvailableVehicles', internal: Array<{ __typename?: 'VehicleAvailabilitySummary', availability: VehicleAvailability, next?: { __typename?: 'VehicleUnavailablePeriod', startTime: any, endTime?: any | null, availability: VehicleAvailability, trip?: { __typename?: 'RelatedTrip', id: any, tripNumber: string, estimatedAvailabilityTime: any } | null } | null, overlapping: Array<{ __typename?: 'VehicleUnavailablePeriod', startTime: any, endTime?: any | null, availability: VehicleAvailability, trip?: { __typename?: 'RelatedTrip', id: any, tripNumber: string, estimatedAvailabilityTime: any } | null }>, previous?: { __typename?: 'VehicleUnavailablePeriod', startTime: any, endTime?: any | null, availability: VehicleAvailability, trip?: { __typename?: 'RelatedTrip', id: any, tripNumber: string, estimatedAvailabilityTime: any } | null } | null, vehicle: { __typename?: 'AvailableVehicle', id: any, name?: string | null, vehicleClassId: any, vehicleClassName?: string | null, vehicleSystemClass?: string | null, modelName?: string | null, makeName?: string | null, licenseNumber?: string | null, year?: number | null } }> } } };

export type GetVehiclesAvailabilityQueryVariables = Exact<{
  criteria: AvailabilityQueryCriteria;
}>;


export type GetVehiclesAvailabilityQuery = { __typename?: 'Query', vehicles: { __typename?: 'VehicleQueries', available: Array<{ __typename?: 'VehicleAvailabilitySummary', availability: VehicleAvailability, vehicle: { __typename?: 'AvailableVehicle', id: any, vehicleClassId: any, vehicleClassName?: string | null, vehicleSystemClass?: string | null, modelName?: string | null, makeName?: string | null, licenseNumber?: string | null, year?: number | null }, next?: { __typename?: 'VehicleUnavailablePeriod', startTime: any, endTime?: any | null } | null, previous?: { __typename?: 'VehicleUnavailablePeriod', startTime: any, endTime?: any | null } | null, overlapping: Array<{ __typename?: 'VehicleUnavailablePeriod', startTime: any, endTime?: any | null, availability: VehicleAvailability, trip?: { __typename?: 'RelatedTrip', id: any } | null }> }> } };

export type DeleteSavoyaVehicleMutationVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type DeleteSavoyaVehicleMutation = { __typename?: 'Mutation', deleteSavoyaVehicle: { __typename?: 'DeletedResult', deleted: boolean } };


export const AddAccountDocument = gql`
    mutation AddAccount($account: InsertAccount!) {
  insertAccount(account: $account) {
    account {
      id
      name
      description
      salesPitch
      legalName
      logoUrl
      videoUrl
      established
      primaryPhoneNumber
      primaryEmailAddress
    }
  }
}
    `;
export type AddAccountMutationFn = Apollo.MutationFunction<AddAccountMutation, AddAccountMutationVariables>;

/**
 * __useAddAccountMutation__
 *
 * To run a mutation, you first call `useAddAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAccountMutation, { data, loading, error }] = useAddAccountMutation({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useAddAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddAccountMutation, AddAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAccountMutation, AddAccountMutationVariables>(AddAccountDocument, options);
      }
export type AddAccountMutationHookResult = ReturnType<typeof useAddAccountMutation>;
export type AddAccountMutationResult = Apollo.MutationResult<AddAccountMutation>;
export type AddAccountMutationOptions = Apollo.BaseMutationOptions<AddAccountMutation, AddAccountMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($account: UpdateAccount!) {
  updateAccount(account: $account) {
    account {
      id
      name
      description
      salesPitch
      legalName
      logoUrl
      videoUrl
      established
      primaryPhoneNumber
      primaryEmailAddress
      website
    }
  }
}
    `;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      account: // value for 'account'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const GetAccountDocument = gql`
    query GetAccount($id: UUID!) {
  accounts {
    byId(id: $id) {
      id
      name
      description
      salesPitch
      legalName
      logoUrl
      videoUrl
      established
      primaryPhoneNumber
      primaryEmailAddress
      website
      bookingToken
      displayRatesInBookingTool
      squareAccessToken
      squareMerchantId
      yearsInBusiness
      spokenLanguages
      licensesAndCertifications
      insuranceCombinedSingleLimitPerAccident
      zelleHandle
      venmoHandle
      garages {
        location {
          city
          state
        }
      }
      accountOwner {
        id
        name
        email
        phoneNumber
      }
      drivers {
        id
      }
      vehicles {
        model {
          name
          make {
            name
          }
        }
        year
      }
      bodilyInjuryPerPerson
      bodilyInjuryPerAccident
      propertyDamagePerAccident
      workersCompensantionLiabilityCoverage
      childSeat
      petPolicy
      facebookUrl
      linkedinUrl
      instagramUrl
      twitterUrl
    }
  }
  vendorsQueries {
    getVendortById(id: $id) {
      id
      name
      legalName
      description
      email
      currency
      phoneNumber
      website
      isActive
      isInternal
      vendorProviders {
        id
        vendorId
        providerType
        providesChildSeats
        eid
        ownerFirstName
        ownerLastName
        ownerEmail
        ownerPhoneNumber
        acceptsShortNoticeTrips
        savoyaApproved
        savoyaPreferred
        automaticCloseout
        canEditCosts
        creditCardFeePercentage
        holdForPayment
        lockedGreeter
        missionOnly
        mobileEnabled
        noCompUpgrades
        notificationsDisabled
        operationCertified
        temporaryHold
        transferRatePlusWaitTime
        trialMode
        underServiceAgreement
        useDriverScoreOverride
        receiveEmailNotificationsOverride
        vendorFuelSurcharge
        vendorType
        robocallDtmf
        dispatchPhoneNumber
        reservationsEmail
        reservationsPhoneNumber
        accountingAddress1
        accountingAddress2
        accountingPostalCode
        accountingEmail
        accountingFirstName
        accountingLastName
        accountingPhoneNumber
        payTo
        paymentFrequency
        paymentMethod
        preferredMethodOfContact
        primaryContactFirstName
        primaryContactLastName
        relationsManagerId
        establishedAt
        yearsInBusiness
        salesPitch
        licensesAndCertifications
        petPolicy
        bookingToken
        displayRatesInBookingTool
        videoUrl
        logoUrl
        facebookUrl
        instagramUrl
        linkedinUrl
        twitterUrl
        venmoHandle
        zelleHandle
        stripeAccountId
        stripeAccountCanCharge
        squareMerchantId
        squareAccessToken
        squareRefreshToken
        squareTokenExpiresAt
        createdAt
        updatedAt
        deleted
        bodilyInjuryPerAccident
        bodilyInjuryPerPerson
        insuranceCombinedSingleLimitPerAccident
        propertyDamagePerAccident
        workersCompensantionLiabilityCoverage
        spokenLanguages
      }
      createdAt
      updatedAt
      deleted
    }
  }
}
    `;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const SearchAccountDocument = gql`
    query searchAccount($query: String!, $offset: Int = 0, $perPage: Int = 20, $includeFavorites: Boolean, $networkPartners: Boolean = false) {
  accounts {
    search(
      query: $query
      skip: $offset
      take: $perPage
      includeFavorites: $includeFavorites
      networkPartners: $networkPartners
    ) {
      items {
        id
        name
        logoUrl
        website
        isFavorite
      }
      total
    }
  }
}
    `;

/**
 * __useSearchAccountQuery__
 *
 * To run a query within a React component, call `useSearchAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAccountQuery({
 *   variables: {
 *      query: // value for 'query'
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *      includeFavorites: // value for 'includeFavorites'
 *      networkPartners: // value for 'networkPartners'
 *   },
 * });
 */
export function useSearchAccountQuery(baseOptions: Apollo.QueryHookOptions<SearchAccountQuery, SearchAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAccountQuery, SearchAccountQueryVariables>(SearchAccountDocument, options);
      }
export function useSearchAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAccountQuery, SearchAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAccountQuery, SearchAccountQueryVariables>(SearchAccountDocument, options);
        }
export type SearchAccountQueryHookResult = ReturnType<typeof useSearchAccountQuery>;
export type SearchAccountLazyQueryHookResult = ReturnType<typeof useSearchAccountLazyQuery>;
export type SearchAccountQueryResult = Apollo.QueryResult<SearchAccountQuery, SearchAccountQueryVariables>;
export const SearchUserDocument = gql`
    query searchUser($query: String!, $offset: Int = 0, $perPage: Int = 20, $type: ContactType = User, $userRole: UserRole, $orderBy: OrderByDirection, $userId: UUID, $includeInactive: Boolean) {
  contacts {
    search(
      query: $query
      type: $type
      skip: $offset
      take: $perPage
      userRole: $userRole
      orderBy: $orderBy
      userId: $userId
      includeInactive: $includeInactive
    ) {
      items {
        id
        name
        email
        title
        phoneNumber
        profileImageUrl
        userRole
        isActive
        driver {
          id
          isActive
        }
      }
      total
    }
  }
}
    `;

/**
 * __useSearchUserQuery__
 *
 * To run a query within a React component, call `useSearchUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUserQuery({
 *   variables: {
 *      query: // value for 'query'
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *      type: // value for 'type'
 *      userRole: // value for 'userRole'
 *      orderBy: // value for 'orderBy'
 *      userId: // value for 'userId'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useSearchUserQuery(baseOptions: Apollo.QueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
      }
export function useSearchUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUserQuery, SearchUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUserQuery, SearchUserQueryVariables>(SearchUserDocument, options);
        }
export type SearchUserQueryHookResult = ReturnType<typeof useSearchUserQuery>;
export type SearchUserLazyQueryHookResult = ReturnType<typeof useSearchUserLazyQuery>;
export type SearchUserQueryResult = Apollo.QueryResult<SearchUserQuery, SearchUserQueryVariables>;
export const GetContactByEmailDocument = gql`
    query getContactByEmail($email: String!, $includeInactive: Boolean) {
  contacts {
    byEmail(email: $email, includeInactive: $includeInactive) {
      id
      name
      email
      title
      phoneNumber
      isActive
    }
  }
}
    `;

/**
 * __useGetContactByEmailQuery__
 *
 * To run a query within a React component, call `useGetContactByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetContactByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetContactByEmailQuery, GetContactByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactByEmailQuery, GetContactByEmailQueryVariables>(GetContactByEmailDocument, options);
      }
export function useGetContactByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactByEmailQuery, GetContactByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactByEmailQuery, GetContactByEmailQueryVariables>(GetContactByEmailDocument, options);
        }
export type GetContactByEmailQueryHookResult = ReturnType<typeof useGetContactByEmailQuery>;
export type GetContactByEmailLazyQueryHookResult = ReturnType<typeof useGetContactByEmailLazyQuery>;
export type GetContactByEmailQueryResult = Apollo.QueryResult<GetContactByEmailQuery, GetContactByEmailQueryVariables>;
export const DeleteContactDocument = gql`
    mutation DeleteContact($contact: DeleteContact!) {
  deleteContact(contact: $contact) {
    success
    errors {
      message
      code
    }
  }
}
    `;
export type DeleteContactMutationFn = Apollo.MutationFunction<DeleteContactMutation, DeleteContactMutationVariables>;

/**
 * __useDeleteContactMutation__
 *
 * To run a mutation, you first call `useDeleteContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactMutation, { data, loading, error }] = useDeleteContactMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useDeleteContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContactMutation, DeleteContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactMutation, DeleteContactMutationVariables>(DeleteContactDocument, options);
      }
export type DeleteContactMutationHookResult = ReturnType<typeof useDeleteContactMutation>;
export type DeleteContactMutationResult = Apollo.MutationResult<DeleteContactMutation>;
export type DeleteContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactMutation, DeleteContactMutationVariables>;
export const UpdateVendorDocument = gql`
    mutation UpdateVendor($vendorUpdateArgs: VendorUpdateArgs!) {
  updateVendor(vendorUpdateArgs: $vendorUpdateArgs) {
    createdAt
    currency
    description
    email
    id
    isActive
    isInternal
    legalName
    name
    phoneNumber
    updatedAt
    website
  }
}
    `;
export type UpdateVendorMutationFn = Apollo.MutationFunction<UpdateVendorMutation, UpdateVendorMutationVariables>;

/**
 * __useUpdateVendorMutation__
 *
 * To run a mutation, you first call `useUpdateVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVendorMutation, { data, loading, error }] = useUpdateVendorMutation({
 *   variables: {
 *      vendorUpdateArgs: // value for 'vendorUpdateArgs'
 *   },
 * });
 */
export function useUpdateVendorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVendorMutation, UpdateVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVendorMutation, UpdateVendorMutationVariables>(UpdateVendorDocument, options);
      }
export type UpdateVendorMutationHookResult = ReturnType<typeof useUpdateVendorMutation>;
export type UpdateVendorMutationResult = Apollo.MutationResult<UpdateVendorMutation>;
export type UpdateVendorMutationOptions = Apollo.BaseMutationOptions<UpdateVendorMutation, UpdateVendorMutationVariables>;
export const GetVendorVehicleClassesDocument = gql`
    query GetVendorVehicleClasses($vendorId: UUID, $providerType: ProviderType) {
  vehicleClassQueries {
    vehicleClassByVendorId(vendorId: $vendorId, providerType: $providerType) {
      id
      vendorId
      systemClass
      name
      dwellTime
      limitedAvailability
      canBeQuoatedWithoutRates
      signageRequired
      clientCanBook
      displayOrder
      isActive
      imageUrl
      hourlyRate
      passengerCount
      luggageCount
      cancellationPolicyHours
      minimumHours
      createdAt
      updatedAt
      deleted
      providerType
    }
  }
}
    `;

/**
 * __useGetVendorVehicleClassesQuery__
 *
 * To run a query within a React component, call `useGetVendorVehicleClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorVehicleClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorVehicleClassesQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      providerType: // value for 'providerType'
 *   },
 * });
 */
export function useGetVendorVehicleClassesQuery(baseOptions?: Apollo.QueryHookOptions<GetVendorVehicleClassesQuery, GetVendorVehicleClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorVehicleClassesQuery, GetVendorVehicleClassesQueryVariables>(GetVendorVehicleClassesDocument, options);
      }
export function useGetVendorVehicleClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorVehicleClassesQuery, GetVendorVehicleClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorVehicleClassesQuery, GetVendorVehicleClassesQueryVariables>(GetVendorVehicleClassesDocument, options);
        }
export type GetVendorVehicleClassesQueryHookResult = ReturnType<typeof useGetVendorVehicleClassesQuery>;
export type GetVendorVehicleClassesLazyQueryHookResult = ReturnType<typeof useGetVendorVehicleClassesLazyQuery>;
export type GetVendorVehicleClassesQueryResult = Apollo.QueryResult<GetVendorVehicleClassesQuery, GetVendorVehicleClassesQueryVariables>;
export const GetSavoyaVehicleClassesDocument = gql`
    query GetSavoyaVehicleClasses {
  vehicleClassQueries {
    getSavoyaVehicleClasses {
      id
      vendorId
      systemClass
      systemVehicleClassId
      name
      dwellTime
      limitedAvailability
      providerType
      canBeQuoatedWithoutRates
      signageRequired
      clientCanBook
      displayOrder
      isActive
      imageUrl
      hourlyRate
      passengerCount
      luggageCount
      cancellationPolicyHours
      minimumHours
      createdAt
      updatedAt
      deleted
    }
  }
}
    `;

/**
 * __useGetSavoyaVehicleClassesQuery__
 *
 * To run a query within a React component, call `useGetSavoyaVehicleClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavoyaVehicleClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavoyaVehicleClassesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSavoyaVehicleClassesQuery(baseOptions?: Apollo.QueryHookOptions<GetSavoyaVehicleClassesQuery, GetSavoyaVehicleClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavoyaVehicleClassesQuery, GetSavoyaVehicleClassesQueryVariables>(GetSavoyaVehicleClassesDocument, options);
      }
export function useGetSavoyaVehicleClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavoyaVehicleClassesQuery, GetSavoyaVehicleClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavoyaVehicleClassesQuery, GetSavoyaVehicleClassesQueryVariables>(GetSavoyaVehicleClassesDocument, options);
        }
export type GetSavoyaVehicleClassesQueryHookResult = ReturnType<typeof useGetSavoyaVehicleClassesQuery>;
export type GetSavoyaVehicleClassesLazyQueryHookResult = ReturnType<typeof useGetSavoyaVehicleClassesLazyQuery>;
export type GetSavoyaVehicleClassesQueryResult = Apollo.QueryResult<GetSavoyaVehicleClassesQuery, GetSavoyaVehicleClassesQueryVariables>;
export const CreateVendorVehicleDocument = gql`
    mutation CreateVendorVehicle($vehicleCreateArgs: VehicleCreateArgs!) {
  createVehicleRecord(vehicleCreateArgs: $vehicleCreateArgs) {
    signedUrl
    id
    isActive
    vendorId
    vehicleClassId
    name
    imageUrl
    year
    color
    make
    model
    vin
    licensePlateNumber
    seatingArrangement
    rentalExpirationDate
    imageUrl
    imageUpdatedAt
    vehicleProvider {
      id
      providerType
      vehicleId
      groundwork
      insuranceChecked
      status
      rejectionReason
      createdAt
      updatedAt
      deleted
    }
    vehicleModel {
      id
      name
      startYear
      endYear
      makeId
      make {
        id
        name
        createdAt
        updatedAt
        deleted
      }
      createdAt
      updatedAt
      deleted
    }
    vehicleClass {
      id
      vendorId
      systemClass
      name
      dwellTime
      limitedAvailability
      canBeQuoatedWithoutRates
      signageRequired
      clientCanBook
      displayOrder
      isActive
      imageUrl
      hourlyRate
      passengerCount
      luggageCount
      cancellationPolicyHours
      minimumHours
      createdAt
      updatedAt
      deleted
      providerType
    }
    createdAt
    updatedAt
    deleted
  }
}
    `;
export type CreateVendorVehicleMutationFn = Apollo.MutationFunction<CreateVendorVehicleMutation, CreateVendorVehicleMutationVariables>;

/**
 * __useCreateVendorVehicleMutation__
 *
 * To run a mutation, you first call `useCreateVendorVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVendorVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVendorVehicleMutation, { data, loading, error }] = useCreateVendorVehicleMutation({
 *   variables: {
 *      vehicleCreateArgs: // value for 'vehicleCreateArgs'
 *   },
 * });
 */
export function useCreateVendorVehicleMutation(baseOptions?: Apollo.MutationHookOptions<CreateVendorVehicleMutation, CreateVendorVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVendorVehicleMutation, CreateVendorVehicleMutationVariables>(CreateVendorVehicleDocument, options);
      }
export type CreateVendorVehicleMutationHookResult = ReturnType<typeof useCreateVendorVehicleMutation>;
export type CreateVendorVehicleMutationResult = Apollo.MutationResult<CreateVendorVehicleMutation>;
export type CreateVendorVehicleMutationOptions = Apollo.BaseMutationOptions<CreateVendorVehicleMutation, CreateVendorVehicleMutationVariables>;
export const UpdateVehicleRecordDocument = gql`
    mutation UpdateVehicleRecord($vehicleUpdateArgs: VehicleUpdateArgs!) {
  updateVehicleRecord(vehicleUpdateArgs: $vehicleUpdateArgs) {
    id
    vendorId
    vehicleClassId
    name
    year
    color
    make
    model
    isActive
    vin
    licensePlateNumber
    seatingArrangement
    rentalExpirationDate
    imageUrl
    imageUpdatedAt
    vehicleProvider {
      id
      providerType
      vehicleId
      groundwork
      insuranceChecked
      status
      rejectionReason
      createdAt
      updatedAt
      deleted
    }
    vehicleModel {
      id
      name
      startYear
      endYear
      makeId
      make {
        id
        name
        createdAt
        updatedAt
        deleted
      }
      createdAt
      updatedAt
      deleted
    }
    vehicleClass {
      id
      vendorId
      systemClass
      name
      dwellTime
      limitedAvailability
      canBeQuoatedWithoutRates
      signageRequired
      clientCanBook
      displayOrder
      isActive
      imageUrl
      hourlyRate
      passengerCount
      luggageCount
      cancellationPolicyHours
      minimumHours
      createdAt
      updatedAt
      deleted
    }
    createdAt
    updatedAt
    deleted
  }
}
    `;
export type UpdateVehicleRecordMutationFn = Apollo.MutationFunction<UpdateVehicleRecordMutation, UpdateVehicleRecordMutationVariables>;

/**
 * __useUpdateVehicleRecordMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleRecordMutation, { data, loading, error }] = useUpdateVehicleRecordMutation({
 *   variables: {
 *      vehicleUpdateArgs: // value for 'vehicleUpdateArgs'
 *   },
 * });
 */
export function useUpdateVehicleRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVehicleRecordMutation, UpdateVehicleRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVehicleRecordMutation, UpdateVehicleRecordMutationVariables>(UpdateVehicleRecordDocument, options);
      }
export type UpdateVehicleRecordMutationHookResult = ReturnType<typeof useUpdateVehicleRecordMutation>;
export type UpdateVehicleRecordMutationResult = Apollo.MutationResult<UpdateVehicleRecordMutation>;
export type UpdateVehicleRecordMutationOptions = Apollo.BaseMutationOptions<UpdateVehicleRecordMutation, UpdateVehicleRecordMutationVariables>;
export const MeDocument = gql`
    query Me {
  contacts {
    me {
      id
      name
      email
      userRole
      contactType
      profileImageUrl
      analyticsToken
      accountId
      account {
        stripeAccountCanCharge
        stripeAccountId
        name
        squareAccessToken
        squareMerchantId
        squareRefreshToken
        squareTokenExpiresAt
        activeCardProcessor
      }
      createdAt
      driver {
        id
        videoUrl
        marketingDescription
        garage {
          id
          name
          location {
            addressLine1
            addressLine2
            city
            state
            country
            postalCode
            coordinates
            placeType
            placeCategory
            placeName
          }
        }
      }
    }
  }
  usersQueries {
    getUserByToken {
      id
      name
      firstName
      lastName
      email
      phoneNumber
      role
      productType
      vendorId
      externalId
      isSavoyaUser
    }
  }
  subscriptionByAccountId {
    id
    accountId
    externalId
    clientSecret
    productType
    tierId
    currentTier
    status
    inTrialPeriod
    renewalAt
    periodStartAt
    periodEndAt
    cancelled
    cancelledAt
    createdAt
    updatedAt
    paymentMethod {
      cardLastFour
      cardType
      country
      zipCode
    }
    tier {
      id
      name
      description
      code
      type
      productType
      amount
      currency
      trialPeriodDays
      addons {
        amount
        code
        currency
        id
        name
        freeQty
        type
      }
    }
    addonUsage {
      SHARED_TRIPS
    }
  }
  vendorsQueries {
    getVendorByToken {
      id
      name
      legalName
      description
      email
      currency
      phoneNumber
      website
      isActive
      isInternal
      vendorProviders {
        id
        vendorId
        providerType
        providesChildSeats
        eid
        ownerFirstName
        ownerLastName
        ownerEmail
        ownerPhoneNumber
        acceptsShortNoticeTrips
        savoyaApproved
        savoyaPreferred
        automaticCloseout
        canEditCosts
        creditCardFeePercentage
        holdForPayment
        lockedGreeter
        missionOnly
        mobileEnabled
        noCompUpgrades
        notificationsDisabled
        operationCertified
        temporaryHold
        transferRatePlusWaitTime
        trialMode
        underServiceAgreement
        useDriverScoreOverride
        receiveEmailNotificationsOverride
        vendorFuelSurcharge
        vendorType
        robocallDtmf
        dispatchPhoneNumber
        reservationsEmail
        reservationsPhoneNumber
        accountingAddress1
        accountingAddress2
        accountingPostalCode
        accountingCountry
        accountingEmail
        accountingFirstName
        accountingLastName
        accountingPhoneNumber
        payTo
        paymentFrequency
        paymentMethod
        preferredMethodOfContact
        primaryContactFirstName
        primaryContactLastName
        relationsManagerId
        establishedAt
        yearsInBusiness
        salesPitch
        licensesAndCertifications
        petPolicy
        bookingToken
        bookingToolEnabled
        displayRatesInBookingTool
        videoUrl
        logoUrl
        facebookUrl
        instagramUrl
        twitterUrl
        linkedinUrl
        venmoHandle
        zelleHandle
        spokenLanguages
        stripeAccountId
        stripeAccountCanCharge
        squareMerchantId
        squareAccessToken
        squareRefreshToken
        squareTokenExpiresAt
        bodilyInjuryPerPerson
        insuranceCombinedSingleLimitPerAccident
        bodilyInjuryPerAccident
        propertyDamagePerAccident
        workersCompensantionLiabilityCoverage
        createdAt
        updatedAt
        deleted
      }
      createdAt
      updatedAt
      deleted
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const LinkUserIdentityDocument = gql`
    mutation LinkUserIdentity {
  linkUserIdentity {
    userIdentity {
      id
    }
  }
}
    `;
export type LinkUserIdentityMutationFn = Apollo.MutationFunction<LinkUserIdentityMutation, LinkUserIdentityMutationVariables>;

/**
 * __useLinkUserIdentityMutation__
 *
 * To run a mutation, you first call `useLinkUserIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkUserIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkUserIdentityMutation, { data, loading, error }] = useLinkUserIdentityMutation({
 *   variables: {
 *   },
 * });
 */
export function useLinkUserIdentityMutation(baseOptions?: Apollo.MutationHookOptions<LinkUserIdentityMutation, LinkUserIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkUserIdentityMutation, LinkUserIdentityMutationVariables>(LinkUserIdentityDocument, options);
      }
export type LinkUserIdentityMutationHookResult = ReturnType<typeof useLinkUserIdentityMutation>;
export type LinkUserIdentityMutationResult = Apollo.MutationResult<LinkUserIdentityMutation>;
export type LinkUserIdentityMutationOptions = Apollo.BaseMutationOptions<LinkUserIdentityMutation, LinkUserIdentityMutationVariables>;
export const GetAllCompaniesDocument = gql`
    query getAllCompanies($accountId: UUID!, $perPage: Float, $skip: Float, $includeInactive: Boolean) {
  companyQueries {
    findByAccount(
      accountId: $accountId
      take: $perPage
      skip: $skip
      includeInactive: $includeInactive
    ) {
      accountId
      addresses {
        id
        type
        addressLineOne
        addressLineTwo
        addressLineThree
        addressLineFour
        locality
        region
        postalCode
        country
        formattedAddress
      }
      emails {
        id
        type
        email
      }
      id
      isActive
      name
      note
      phoneNumbers {
        id
        type
        phoneNumber
      }
      rates {
        id
        companyId
        rateSetId
      }
      sourceProduct
      type
      clients {
        emails {
          id
          type
          email
        }
        accountId
        addresses {
          id
          type
          addressLineOne
          addressLineTwo
          addressLineThree
          addressLineFour
          locality
          region
          postalCode
          country
          formattedAddress
        }
        isActive
        id
        name
        phoneNumbers {
          id
          type
          phoneNumber
        }
        primaryRole
        rates {
          id
          clientId
          rateSetId
        }
        sourceProduct
        title
      }
    }
  }
}
    `;

/**
 * __useGetAllCompaniesQuery__
 *
 * To run a query within a React component, call `useGetAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCompaniesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      perPage: // value for 'perPage'
 *      skip: // value for 'skip'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetAllCompaniesQuery(baseOptions: Apollo.QueryHookOptions<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>(GetAllCompaniesDocument, options);
      }
export function useGetAllCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>(GetAllCompaniesDocument, options);
        }
export type GetAllCompaniesQueryHookResult = ReturnType<typeof useGetAllCompaniesQuery>;
export type GetAllCompaniesLazyQueryHookResult = ReturnType<typeof useGetAllCompaniesLazyQuery>;
export type GetAllCompaniesQueryResult = Apollo.QueryResult<GetAllCompaniesQuery, GetAllCompaniesQueryVariables>;
export const FilterCompaniesDocument = gql`
    query filterCompanies($accountId: UUID!, $type: CompanyTypeEnum, $name: String, $email: String, $phoneNumber: String, $companyId: UUID, $perPage: Float, $skip: Float, $includeInactive: Boolean, $orderBy: OrderByDirection) {
  companyQueries {
    search(
      accountId: $accountId
      type: $type
      name: $name
      email: $email
      phoneNumber: $phoneNumber
      companyId: $companyId
      take: $perPage
      skip: $skip
      includeInactive: $includeInactive
      orderBy: $orderBy
    ) {
      total
      items {
        accountId
        addresses {
          id
          type
          addressLineOne
          addressLineTwo
          addressLineThree
          addressLineFour
          locality
          region
          postalCode
          country
          formattedAddress
        }
        emails {
          id
          type
          email
        }
        id
        isActive
        name
        note
        phoneNumbers {
          id
          type
          phoneNumber
        }
        rates {
          id
          companyId
          rateSetId
        }
        sourceProduct
        type
        clients {
          emails {
            id
            type
            email
          }
          accountId
          addresses {
            id
            type
            addressLineOne
            addressLineTwo
            addressLineThree
            addressLineFour
            locality
            region
            postalCode
            country
            formattedAddress
          }
          isActive
          id
          name
          phoneNumbers {
            id
            type
            phoneNumber
          }
          primaryRole
          rates {
            id
            clientId
            rateSetId
          }
          sourceProduct
          title
        }
      }
    }
  }
}
    `;

/**
 * __useFilterCompaniesQuery__
 *
 * To run a query within a React component, call `useFilterCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterCompaniesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *      companyId: // value for 'companyId'
 *      perPage: // value for 'perPage'
 *      skip: // value for 'skip'
 *      includeInactive: // value for 'includeInactive'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFilterCompaniesQuery(baseOptions: Apollo.QueryHookOptions<FilterCompaniesQuery, FilterCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterCompaniesQuery, FilterCompaniesQueryVariables>(FilterCompaniesDocument, options);
      }
export function useFilterCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterCompaniesQuery, FilterCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterCompaniesQuery, FilterCompaniesQueryVariables>(FilterCompaniesDocument, options);
        }
export type FilterCompaniesQueryHookResult = ReturnType<typeof useFilterCompaniesQuery>;
export type FilterCompaniesLazyQueryHookResult = ReturnType<typeof useFilterCompaniesLazyQuery>;
export type FilterCompaniesQueryResult = Apollo.QueryResult<FilterCompaniesQuery, FilterCompaniesQueryVariables>;
export const AddCompanyDocument = gql`
    mutation AddCompany($accountId: UUID!, $type: CompanyTypeEnum!, $isActive: Boolean!, $insertCompanyId: UUID, $name: String, $note: String, $rates: [CompanyRateInput!]) {
  insertCompany(
    accountId: $accountId
    type: $type
    isActive: $isActive
    id: $insertCompanyId
    name: $name
    note: $note
    rates: $rates
  ) {
    accountId
    id
    name
    note
    type
    rates {
      companyId
      id
      rateSetId
    }
  }
}
    `;
export type AddCompanyMutationFn = Apollo.MutationFunction<AddCompanyMutation, AddCompanyMutationVariables>;

/**
 * __useAddCompanyMutation__
 *
 * To run a mutation, you first call `useAddCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCompanyMutation, { data, loading, error }] = useAddCompanyMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      type: // value for 'type'
 *      isActive: // value for 'isActive'
 *      insertCompanyId: // value for 'insertCompanyId'
 *      name: // value for 'name'
 *      note: // value for 'note'
 *      rates: // value for 'rates'
 *   },
 * });
 */
export function useAddCompanyMutation(baseOptions?: Apollo.MutationHookOptions<AddCompanyMutation, AddCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCompanyMutation, AddCompanyMutationVariables>(AddCompanyDocument, options);
      }
export type AddCompanyMutationHookResult = ReturnType<typeof useAddCompanyMutation>;
export type AddCompanyMutationResult = Apollo.MutationResult<AddCompanyMutation>;
export type AddCompanyMutationOptions = Apollo.BaseMutationOptions<AddCompanyMutation, AddCompanyMutationVariables>;
export const InsertClientDocument = gql`
    mutation InsertClient($accountId: UUID!, $primaryRole: ClientRole!, $isActive: Boolean!, $insertClientId: UUID, $companyId: UUID, $title: String, $name: String, $emails: [ClientEmailInput!], $phoneNumbers: [ClientPhoneInput!], $rates: [ClientRateInput!], $tripClient: TripClientInput, $note: String) {
  insertClient(
    accountId: $accountId
    primaryRole: $primaryRole
    isActive: $isActive
    id: $insertClientId
    companyId: $companyId
    title: $title
    name: $name
    note: $note
    emails: $emails
    phoneNumbers: $phoneNumbers
    rates: $rates
    tripClient: $tripClient
  ) {
    accountId
    emails {
      id
      type
      email
    }
    id
    isActive
    name
    note
    phoneNumbers {
      id
      type
      phoneNumber
    }
    primaryRole
    rates {
      id
      clientId
      rateSetId
    }
    tripClients {
      id
      role
      tripId
      clientId
    }
    sourceProduct
    title
  }
}
    `;
export type InsertClientMutationFn = Apollo.MutationFunction<InsertClientMutation, InsertClientMutationVariables>;

/**
 * __useInsertClientMutation__
 *
 * To run a mutation, you first call `useInsertClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertClientMutation, { data, loading, error }] = useInsertClientMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      primaryRole: // value for 'primaryRole'
 *      isActive: // value for 'isActive'
 *      insertClientId: // value for 'insertClientId'
 *      companyId: // value for 'companyId'
 *      title: // value for 'title'
 *      name: // value for 'name'
 *      emails: // value for 'emails'
 *      phoneNumbers: // value for 'phoneNumbers'
 *      rates: // value for 'rates'
 *      tripClient: // value for 'tripClient'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useInsertClientMutation(baseOptions?: Apollo.MutationHookOptions<InsertClientMutation, InsertClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertClientMutation, InsertClientMutationVariables>(InsertClientDocument, options);
      }
export type InsertClientMutationHookResult = ReturnType<typeof useInsertClientMutation>;
export type InsertClientMutationResult = Apollo.MutationResult<InsertClientMutation>;
export type InsertClientMutationOptions = Apollo.BaseMutationOptions<InsertClientMutation, InsertClientMutationVariables>;
export const UpdateClientDocument = gql`
    mutation UpdateClient($updateClientId: UUID!, $companyId: UUID, $primaryRole: ClientRole, $title: String, $name: String, $rate: ClientRateInput, $emails: [ClientEmailInput!], $phoneNumbers: [ClientPhoneInput!], $isActive: Boolean, $booker: String, $passenger: String, $tripClient: TripClientInput, $note: String, $disconnectCompanyId: UUID, $tripClientRole: UpdateTripClientRoleInput) {
  updateClient(
    id: $updateClientId
    companyId: $companyId
    primaryRole: $primaryRole
    title: $title
    name: $name
    note: $note
    rate: $rate
    emails: $emails
    phoneNumbers: $phoneNumbers
    isActive: $isActive
    booker: $booker
    passenger: $passenger
    tripClient: $tripClient
    disconnectCompanyId: $disconnectCompanyId
    tripClientRole: $tripClientRole
  ) {
    accountId
    bookers {
      id
      name
      isActive
      primaryRole
    }
    companies {
      accountId
      id
      name
      isActive
      note
    }
    emails {
      id
      type
      email
    }
    id
    isActive
    name
    note
    passengers {
      id
      name
      isActive
    }
    phoneNumbers {
      id
      type
      phoneNumber
    }
    primaryRole
    rates {
      id
      clientId
      rateSetId
    }
    sourceProduct
    title
    tripClients {
      id
      tripId
      clientId
      isPrimary
      role
      guests
    }
  }
}
    `;
export type UpdateClientMutationFn = Apollo.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      updateClientId: // value for 'updateClientId'
 *      companyId: // value for 'companyId'
 *      primaryRole: // value for 'primaryRole'
 *      title: // value for 'title'
 *      name: // value for 'name'
 *      rate: // value for 'rate'
 *      emails: // value for 'emails'
 *      phoneNumbers: // value for 'phoneNumbers'
 *      isActive: // value for 'isActive'
 *      booker: // value for 'booker'
 *      passenger: // value for 'passenger'
 *      tripClient: // value for 'tripClient'
 *      note: // value for 'note'
 *      disconnectCompanyId: // value for 'disconnectCompanyId'
 *      tripClientRole: // value for 'tripClientRole'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const ClientByIdDocument = gql`
    query ClientById($clientId: UUID!) {
  clientQueries {
    getClientById(clientId: $clientId) {
      accountId
      addresses {
        id
        type
        addressLineOne
        addressLineTwo
        addressLineThree
        addressLineFour
        locality
        region
        postalCode
        country
        formattedAddress
      }
      bookers {
        id
        name
        emails {
          id
          type
          email
        }
        phoneNumbers {
          id
          type
          phoneNumber
        }
        title
      }
      companies {
        id
        name
        note
        type
      }
      emails {
        id
        type
        email
      }
      id
      isActive
      name
      note
      passengers {
        id
        name
        isActive
        emails {
          id
          type
          email
        }
        phoneNumbers {
          id
          type
          phoneNumber
        }
      }
      phoneNumbers {
        id
        type
        phoneNumber
      }
      primaryRole
      rates {
        id
        clientId
        rateSetId
      }
      title
      tripClients {
        id
        tripId
        clientId
        isPrimary
        role
        guests
      }
    }
  }
}
    `;

/**
 * __useClientByIdQuery__
 *
 * To run a query within a React component, call `useClientByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientByIdQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useClientByIdQuery(baseOptions: Apollo.QueryHookOptions<ClientByIdQuery, ClientByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientByIdQuery, ClientByIdQueryVariables>(ClientByIdDocument, options);
      }
export function useClientByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientByIdQuery, ClientByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientByIdQuery, ClientByIdQueryVariables>(ClientByIdDocument, options);
        }
export type ClientByIdQueryHookResult = ReturnType<typeof useClientByIdQuery>;
export type ClientByIdLazyQueryHookResult = ReturnType<typeof useClientByIdLazyQuery>;
export type ClientByIdQueryResult = Apollo.QueryResult<ClientByIdQuery, ClientByIdQueryVariables>;
export const CompanyByIdDocument = gql`
    query CompanyById($companyId: UUID!) {
  companyQueries {
    getById(companyId: $companyId) {
      accountId
      emails {
        id
        type
        email
      }
      id
      isActive
      name
      note
      phoneNumbers {
        id
        type
        phoneNumber
      }
      rates {
        id
        companyId
        rateSetId
      }
      type
      clients {
        tripClients {
          tripId
        }
      }
    }
  }
}
    `;

/**
 * __useCompanyByIdQuery__
 *
 * To run a query within a React component, call `useCompanyByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyByIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanyByIdQuery(baseOptions: Apollo.QueryHookOptions<CompanyByIdQuery, CompanyByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyByIdQuery, CompanyByIdQueryVariables>(CompanyByIdDocument, options);
      }
export function useCompanyByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyByIdQuery, CompanyByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyByIdQuery, CompanyByIdQueryVariables>(CompanyByIdDocument, options);
        }
export type CompanyByIdQueryHookResult = ReturnType<typeof useCompanyByIdQuery>;
export type CompanyByIdLazyQueryHookResult = ReturnType<typeof useCompanyByIdLazyQuery>;
export type CompanyByIdQueryResult = Apollo.QueryResult<CompanyByIdQuery, CompanyByIdQueryVariables>;
export const ClientsByCompanyIdDocument = gql`
    query ClientsByCompanyId($companyId: UUID!, $skip: Float! = 0, $perPage: Float! = 20, $includeInactive: Boolean) {
  clientQueries {
    getClientsByCompanyId(
      companyId: $companyId
      skip: $skip
      take: $perPage
      includeInactive: $includeInactive
    ) {
      accountId
      emails {
        id
        type
        email
      }
      id
      isActive
      name
      note
      phoneNumbers {
        id
        type
        phoneNumber
      }
      primaryRole
      rates {
        id
        clientId
        rateSetId
      }
      sourceProduct
      title
    }
  }
}
    `;

/**
 * __useClientsByCompanyIdQuery__
 *
 * To run a query within a React component, call `useClientsByCompanyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientsByCompanyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientsByCompanyIdQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      skip: // value for 'skip'
 *      perPage: // value for 'perPage'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useClientsByCompanyIdQuery(baseOptions: Apollo.QueryHookOptions<ClientsByCompanyIdQuery, ClientsByCompanyIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientsByCompanyIdQuery, ClientsByCompanyIdQueryVariables>(ClientsByCompanyIdDocument, options);
      }
export function useClientsByCompanyIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientsByCompanyIdQuery, ClientsByCompanyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientsByCompanyIdQuery, ClientsByCompanyIdQueryVariables>(ClientsByCompanyIdDocument, options);
        }
export type ClientsByCompanyIdQueryHookResult = ReturnType<typeof useClientsByCompanyIdQuery>;
export type ClientsByCompanyIdLazyQueryHookResult = ReturnType<typeof useClientsByCompanyIdLazyQuery>;
export type ClientsByCompanyIdQueryResult = Apollo.QueryResult<ClientsByCompanyIdQuery, ClientsByCompanyIdQueryVariables>;
export const UpdateCompanyDocument = gql`
    mutation UpdateCompany($updateCompanyId: UUID!, $type: CompanyTypeEnum, $name: String, $note: String, $emails: [ClientEmailInput!], $phoneNumbers: [ClientPhoneInput!], $rate: CompanyRateInput, $isActive: Boolean) {
  updateCompany(
    id: $updateCompanyId
    type: $type
    name: $name
    note: $note
    emails: $emails
    phoneNumbers: $phoneNumbers
    rate: $rate
    isActive: $isActive
  ) {
    accountId
    emails {
      email
      id
      type
    }
    id
    isActive
    name
    note
    phoneNumbers {
      id
      phoneNumber
      type
    }
    rates {
      companyId
      id
      rateSetId
    }
    type
  }
}
    `;
export type UpdateCompanyMutationFn = Apollo.MutationFunction<UpdateCompanyMutation, UpdateCompanyMutationVariables>;

/**
 * __useUpdateCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCompanyMutation, { data, loading, error }] = useUpdateCompanyMutation({
 *   variables: {
 *      updateCompanyId: // value for 'updateCompanyId'
 *      type: // value for 'type'
 *      name: // value for 'name'
 *      note: // value for 'note'
 *      emails: // value for 'emails'
 *      phoneNumbers: // value for 'phoneNumbers'
 *      rate: // value for 'rate'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useUpdateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCompanyMutation, UpdateCompanyMutationVariables>(UpdateCompanyDocument, options);
      }
export type UpdateCompanyMutationHookResult = ReturnType<typeof useUpdateCompanyMutation>;
export type UpdateCompanyMutationResult = Apollo.MutationResult<UpdateCompanyMutation>;
export type UpdateCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const GetAllAccountClientsDocument = gql`
    query GetAllAccountClients($accountId: UUID!, $companyId: UUID, $clientId: UUID, $orderBy: OrderByDirection, $primaryRole: ClientRole, $skip: Float! = 0, $perPage: Float! = 200, $includeInactive: Boolean, $tripIds: [UUID!]) {
  clientQueries {
    searchClients(
      accountId: $accountId
      companyId: $companyId
      clientId: $clientId
      orderBy: $orderBy
      primaryRole: $primaryRole
      skip: $skip
      take: $perPage
      includeInactive: $includeInactive
      tripIds: $tripIds
    ) {
      total
      items {
        accountId
        addresses {
          id
          type
          addressLineOne
          addressLineTwo
          addressLineThree
          addressLineFour
          locality
          region
          postalCode
          country
          formattedAddress
        }
        bookers {
          id
          name
          note
          isActive
          emails {
            id
            type
            email
          }
        }
        companies {
          id
          isActive
          name
          note
          accountId
        }
        emails {
          id
          type
          email
        }
        id
        name
        isActive
        passengers {
          id
          emails {
            id
            type
            email
          }
          name
          isActive
        }
        phoneNumbers {
          id
          type
          phoneNumber
        }
        primaryRole
        rates {
          id
          clientId
          rateSetId
        }
        title
        tripClients {
          id
          tripId
          clientId
          isPrimary
          role
          guests
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllAccountClientsQuery__
 *
 * To run a query within a React component, call `useGetAllAccountClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllAccountClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllAccountClientsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      companyId: // value for 'companyId'
 *      clientId: // value for 'clientId'
 *      orderBy: // value for 'orderBy'
 *      primaryRole: // value for 'primaryRole'
 *      skip: // value for 'skip'
 *      perPage: // value for 'perPage'
 *      includeInactive: // value for 'includeInactive'
 *      tripIds: // value for 'tripIds'
 *   },
 * });
 */
export function useGetAllAccountClientsQuery(baseOptions: Apollo.QueryHookOptions<GetAllAccountClientsQuery, GetAllAccountClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllAccountClientsQuery, GetAllAccountClientsQueryVariables>(GetAllAccountClientsDocument, options);
      }
export function useGetAllAccountClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllAccountClientsQuery, GetAllAccountClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllAccountClientsQuery, GetAllAccountClientsQueryVariables>(GetAllAccountClientsDocument, options);
        }
export type GetAllAccountClientsQueryHookResult = ReturnType<typeof useGetAllAccountClientsQuery>;
export type GetAllAccountClientsLazyQueryHookResult = ReturnType<typeof useGetAllAccountClientsLazyQuery>;
export type GetAllAccountClientsQueryResult = Apollo.QueryResult<GetAllAccountClientsQuery, GetAllAccountClientsQueryVariables>;
export const GetTripClientsByTripIdsDocument = gql`
    query GetTripClientsByTripIds($tripIds: [UUID!]!) {
  clientQueries {
    getTripClientsByTripIds(tripIds: $tripIds) {
      client {
        id
        accountId
        name
        sourceProduct
        primaryRole
        title
        note
        isActive
        companies {
          accountId
          emails {
            id
            type
            email
          }
          addresses {
            id
            type
            addressLineOne
            addressLineTwo
            addressLineThree
            addressLineFour
            locality
            region
            postalCode
            country
            formattedAddress
          }
          id
          name
          isActive
          note
          phoneNumbers {
            id
            type
            phoneNumber
          }
          sourceProduct
          type
        }
        phoneNumbers {
          id
          type
          phoneNumber
        }
        emails {
          id
          type
          email
        }
        addresses {
          id
          type
          addressLineOne
          addressLineTwo
          addressLineThree
          addressLineFour
          locality
          region
          postalCode
          country
          formattedAddress
        }
      }
      isPrimary
      id
      role
      tripId
      clientId
      guests
    }
  }
}
    `;

/**
 * __useGetTripClientsByTripIdsQuery__
 *
 * To run a query within a React component, call `useGetTripClientsByTripIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTripClientsByTripIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTripClientsByTripIdsQuery({
 *   variables: {
 *      tripIds: // value for 'tripIds'
 *   },
 * });
 */
export function useGetTripClientsByTripIdsQuery(baseOptions: Apollo.QueryHookOptions<GetTripClientsByTripIdsQuery, GetTripClientsByTripIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTripClientsByTripIdsQuery, GetTripClientsByTripIdsQueryVariables>(GetTripClientsByTripIdsDocument, options);
      }
export function useGetTripClientsByTripIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTripClientsByTripIdsQuery, GetTripClientsByTripIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTripClientsByTripIdsQuery, GetTripClientsByTripIdsQueryVariables>(GetTripClientsByTripIdsDocument, options);
        }
export type GetTripClientsByTripIdsQueryHookResult = ReturnType<typeof useGetTripClientsByTripIdsQuery>;
export type GetTripClientsByTripIdsLazyQueryHookResult = ReturnType<typeof useGetTripClientsByTripIdsLazyQuery>;
export type GetTripClientsByTripIdsQueryResult = Apollo.QueryResult<GetTripClientsByTripIdsQuery, GetTripClientsByTripIdsQueryVariables>;
export const GetClientsByNameAndAccountDocument = gql`
    query GetClientsByNameAndAccount($accountId: UUID!, $query: String!) {
  clientQueries {
    getByNameAndAccount(accountId: $accountId, query: $query) {
      accountId
      emails {
        id
        type
        email
      }
      phoneNumbers {
        id
        type
        phoneNumber
      }
      name
      id
      companies {
        emails {
          id
          type
          email
        }
        name
        id
      }
      primaryRole
    }
  }
}
    `;

/**
 * __useGetClientsByNameAndAccountQuery__
 *
 * To run a query within a React component, call `useGetClientsByNameAndAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsByNameAndAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsByNameAndAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetClientsByNameAndAccountQuery(baseOptions: Apollo.QueryHookOptions<GetClientsByNameAndAccountQuery, GetClientsByNameAndAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsByNameAndAccountQuery, GetClientsByNameAndAccountQueryVariables>(GetClientsByNameAndAccountDocument, options);
      }
export function useGetClientsByNameAndAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsByNameAndAccountQuery, GetClientsByNameAndAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsByNameAndAccountQuery, GetClientsByNameAndAccountQueryVariables>(GetClientsByNameAndAccountDocument, options);
        }
export type GetClientsByNameAndAccountQueryHookResult = ReturnType<typeof useGetClientsByNameAndAccountQuery>;
export type GetClientsByNameAndAccountLazyQueryHookResult = ReturnType<typeof useGetClientsByNameAndAccountLazyQuery>;
export type GetClientsByNameAndAccountQueryResult = Apollo.QueryResult<GetClientsByNameAndAccountQuery, GetClientsByNameAndAccountQueryVariables>;
export const GetClientsByTripIdDocument = gql`
    query GetClientsByTripId($accountId: UUID!, $tripId: UUID!) {
  clientQueries {
    searchClients(accountId: $accountId, tripIds: [$tripId]) {
      items {
        accountId
        addresses {
          id
          type
          addressLineOne
          addressLineTwo
          addressLineThree
          addressLineFour
          locality
          region
          postalCode
          country
          formattedAddress
        }
        emails {
          id
          type
          email
        }
        id
        isActive
        name
        note
        phoneNumbers {
          id
          type
          phoneNumber
        }
        primaryRole
        title
      }
    }
  }
}
    `;

/**
 * __useGetClientsByTripIdQuery__
 *
 * To run a query within a React component, call `useGetClientsByTripIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsByTripIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsByTripIdQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useGetClientsByTripIdQuery(baseOptions: Apollo.QueryHookOptions<GetClientsByTripIdQuery, GetClientsByTripIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsByTripIdQuery, GetClientsByTripIdQueryVariables>(GetClientsByTripIdDocument, options);
      }
export function useGetClientsByTripIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsByTripIdQuery, GetClientsByTripIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsByTripIdQuery, GetClientsByTripIdQueryVariables>(GetClientsByTripIdDocument, options);
        }
export type GetClientsByTripIdQueryHookResult = ReturnType<typeof useGetClientsByTripIdQuery>;
export type GetClientsByTripIdLazyQueryHookResult = ReturnType<typeof useGetClientsByTripIdLazyQuery>;
export type GetClientsByTripIdQueryResult = Apollo.QueryResult<GetClientsByTripIdQuery, GetClientsByTripIdQueryVariables>;
export const FindCompanyByAccountAndNameDocument = gql`
    query FindCompanyByAccountAndName($accountId: UUID!, $query: String!) {
  companyQueries {
    findByAccountAndName(accountId: $accountId, name: $query) {
      accountId
      id
      isActive
      name
      note
      type
    }
  }
}
    `;

/**
 * __useFindCompanyByAccountAndNameQuery__
 *
 * To run a query within a React component, call `useFindCompanyByAccountAndNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCompanyByAccountAndNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCompanyByAccountAndNameQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useFindCompanyByAccountAndNameQuery(baseOptions: Apollo.QueryHookOptions<FindCompanyByAccountAndNameQuery, FindCompanyByAccountAndNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCompanyByAccountAndNameQuery, FindCompanyByAccountAndNameQueryVariables>(FindCompanyByAccountAndNameDocument, options);
      }
export function useFindCompanyByAccountAndNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCompanyByAccountAndNameQuery, FindCompanyByAccountAndNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCompanyByAccountAndNameQuery, FindCompanyByAccountAndNameQueryVariables>(FindCompanyByAccountAndNameDocument, options);
        }
export type FindCompanyByAccountAndNameQueryHookResult = ReturnType<typeof useFindCompanyByAccountAndNameQuery>;
export type FindCompanyByAccountAndNameLazyQueryHookResult = ReturnType<typeof useFindCompanyByAccountAndNameLazyQuery>;
export type FindCompanyByAccountAndNameQueryResult = Apollo.QueryResult<FindCompanyByAccountAndNameQuery, FindCompanyByAccountAndNameQueryVariables>;
export const GetClientsByRateSetsDocument = gql`
    query GetClientsByRateSets($rateSetIds: [UUID!]!) {
  clientQueries {
    getClientsByRateSetIds(rateSetIds: $rateSetIds) {
      clients {
        accountId
        emails {
          id
          type
          email
        }
        id
        isActive
        name
        note
        phoneNumbers {
          id
          type
          phoneNumber
        }
        primaryRole
        title
      }
      rateSetId
    }
  }
}
    `;

/**
 * __useGetClientsByRateSetsQuery__
 *
 * To run a query within a React component, call `useGetClientsByRateSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsByRateSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsByRateSetsQuery({
 *   variables: {
 *      rateSetIds: // value for 'rateSetIds'
 *   },
 * });
 */
export function useGetClientsByRateSetsQuery(baseOptions: Apollo.QueryHookOptions<GetClientsByRateSetsQuery, GetClientsByRateSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsByRateSetsQuery, GetClientsByRateSetsQueryVariables>(GetClientsByRateSetsDocument, options);
      }
export function useGetClientsByRateSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsByRateSetsQuery, GetClientsByRateSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsByRateSetsQuery, GetClientsByRateSetsQueryVariables>(GetClientsByRateSetsDocument, options);
        }
export type GetClientsByRateSetsQueryHookResult = ReturnType<typeof useGetClientsByRateSetsQuery>;
export type GetClientsByRateSetsLazyQueryHookResult = ReturnType<typeof useGetClientsByRateSetsLazyQuery>;
export type GetClientsByRateSetsQueryResult = Apollo.QueryResult<GetClientsByRateSetsQuery, GetClientsByRateSetsQueryVariables>;
export const GetCompaniesByRateSetsDocument = gql`
    query GetCompaniesByRateSets($rateSetIds: [UUID!]!) {
  companyQueries {
    getCompaniesByRateSets(rateSetIds: $rateSetIds) {
      companies {
        accountId
        emails {
          id
          type
          email
        }
        id
        isActive
        name
        note
        phoneNumbers {
          id
          type
          phoneNumber
        }
        type
      }
      rateSetId
    }
  }
}
    `;

/**
 * __useGetCompaniesByRateSetsQuery__
 *
 * To run a query within a React component, call `useGetCompaniesByRateSetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesByRateSetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesByRateSetsQuery({
 *   variables: {
 *      rateSetIds: // value for 'rateSetIds'
 *   },
 * });
 */
export function useGetCompaniesByRateSetsQuery(baseOptions: Apollo.QueryHookOptions<GetCompaniesByRateSetsQuery, GetCompaniesByRateSetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesByRateSetsQuery, GetCompaniesByRateSetsQueryVariables>(GetCompaniesByRateSetsDocument, options);
      }
export function useGetCompaniesByRateSetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesByRateSetsQuery, GetCompaniesByRateSetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesByRateSetsQuery, GetCompaniesByRateSetsQueryVariables>(GetCompaniesByRateSetsDocument, options);
        }
export type GetCompaniesByRateSetsQueryHookResult = ReturnType<typeof useGetCompaniesByRateSetsQuery>;
export type GetCompaniesByRateSetsLazyQueryHookResult = ReturnType<typeof useGetCompaniesByRateSetsLazyQuery>;
export type GetCompaniesByRateSetsQueryResult = Apollo.QueryResult<GetCompaniesByRateSetsQuery, GetCompaniesByRateSetsQueryVariables>;
export const GetClientsByEmailAndAccountDocument = gql`
    query GetClientsByEmailAndAccount($accountId: UUID!, $query: String!) {
  clientQueries {
    getByEmailAndAccount(accountId: $accountId, query: $query) {
      accountId
      companies {
        id
        isActive
        name
        note
        accountId
        type
      }
      id
      emails {
        id
        type
        email
      }
      isActive
      name
      note
      primaryRole
      phoneNumbers {
        id
        type
        phoneNumber
      }
      tripClients {
        clientId
        id
        isPrimary
        role
        tripId
        guests
      }
    }
  }
}
    `;

/**
 * __useGetClientsByEmailAndAccountQuery__
 *
 * To run a query within a React component, call `useGetClientsByEmailAndAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsByEmailAndAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsByEmailAndAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useGetClientsByEmailAndAccountQuery(baseOptions: Apollo.QueryHookOptions<GetClientsByEmailAndAccountQuery, GetClientsByEmailAndAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientsByEmailAndAccountQuery, GetClientsByEmailAndAccountQueryVariables>(GetClientsByEmailAndAccountDocument, options);
      }
export function useGetClientsByEmailAndAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientsByEmailAndAccountQuery, GetClientsByEmailAndAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientsByEmailAndAccountQuery, GetClientsByEmailAndAccountQueryVariables>(GetClientsByEmailAndAccountDocument, options);
        }
export type GetClientsByEmailAndAccountQueryHookResult = ReturnType<typeof useGetClientsByEmailAndAccountQuery>;
export type GetClientsByEmailAndAccountLazyQueryHookResult = ReturnType<typeof useGetClientsByEmailAndAccountLazyQuery>;
export type GetClientsByEmailAndAccountQueryResult = Apollo.QueryResult<GetClientsByEmailAndAccountQuery, GetClientsByEmailAndAccountQueryVariables>;
export const GetTripClientsByTripDocument = gql`
    query GetTripClientsByTrip($tripId: UUID!) {
  clientQueries {
    getTripClientsByTrip(tripId: $tripId) {
      client {
        companies {
          id
          name
          note
          isActive
        }
        isActive
        id
        name
        note
        phoneNumbers {
          id
          type
          phoneNumber
        }
        emails {
          id
          type
          email
        }
        primaryRole
      }
      id
      isPrimary
      clientId
      role
      tripId
      guests
    }
  }
}
    `;

/**
 * __useGetTripClientsByTripQuery__
 *
 * To run a query within a React component, call `useGetTripClientsByTripQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTripClientsByTripQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTripClientsByTripQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useGetTripClientsByTripQuery(baseOptions: Apollo.QueryHookOptions<GetTripClientsByTripQuery, GetTripClientsByTripQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTripClientsByTripQuery, GetTripClientsByTripQueryVariables>(GetTripClientsByTripDocument, options);
      }
export function useGetTripClientsByTripLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTripClientsByTripQuery, GetTripClientsByTripQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTripClientsByTripQuery, GetTripClientsByTripQueryVariables>(GetTripClientsByTripDocument, options);
        }
export type GetTripClientsByTripQueryHookResult = ReturnType<typeof useGetTripClientsByTripQuery>;
export type GetTripClientsByTripLazyQueryHookResult = ReturnType<typeof useGetTripClientsByTripLazyQuery>;
export type GetTripClientsByTripQueryResult = Apollo.QueryResult<GetTripClientsByTripQuery, GetTripClientsByTripQueryVariables>;
export const DeleteTripClientDocument = gql`
    mutation DeleteTripClient($tripClientId: UUID!) {
  deleteTripClient(tripClientId: $tripClientId)
}
    `;
export type DeleteTripClientMutationFn = Apollo.MutationFunction<DeleteTripClientMutation, DeleteTripClientMutationVariables>;

/**
 * __useDeleteTripClientMutation__
 *
 * To run a mutation, you first call `useDeleteTripClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTripClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTripClientMutation, { data, loading, error }] = useDeleteTripClientMutation({
 *   variables: {
 *      tripClientId: // value for 'tripClientId'
 *   },
 * });
 */
export function useDeleteTripClientMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTripClientMutation, DeleteTripClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTripClientMutation, DeleteTripClientMutationVariables>(DeleteTripClientDocument, options);
      }
export type DeleteTripClientMutationHookResult = ReturnType<typeof useDeleteTripClientMutation>;
export type DeleteTripClientMutationResult = Apollo.MutationResult<DeleteTripClientMutation>;
export type DeleteTripClientMutationOptions = Apollo.BaseMutationOptions<DeleteTripClientMutation, DeleteTripClientMutationVariables>;
export const FilterAllContactsDocument = gql`
    query filterAllContacts($query: String!, $type: ContactType, $offset: Int = 0, $perPage: Int = 200, $orderBy: OrderByDirection, $userRole: UserRole, $includeInactive: Boolean = false) {
  contacts {
    search(
      query: $query
      type: $type
      skip: $offset
      take: $perPage
      orderBy: $orderBy
      userRole: $userRole
      includeInactive: $includeInactive
    ) {
      items {
        id
        name
        email
        phoneNumber
        isActive
        userRole
        contactType
        note
        addresses {
          id
          name
          category
          addressLine1
          city
          state
          country
          postalCode
          timezone
          coordinates
        }
      }
    }
  }
}
    `;

/**
 * __useFilterAllContactsQuery__
 *
 * To run a query within a React component, call `useFilterAllContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilterAllContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilterAllContactsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      type: // value for 'type'
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      userRole: // value for 'userRole'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useFilterAllContactsQuery(baseOptions: Apollo.QueryHookOptions<FilterAllContactsQuery, FilterAllContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilterAllContactsQuery, FilterAllContactsQueryVariables>(FilterAllContactsDocument, options);
      }
export function useFilterAllContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilterAllContactsQuery, FilterAllContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilterAllContactsQuery, FilterAllContactsQueryVariables>(FilterAllContactsDocument, options);
        }
export type FilterAllContactsQueryHookResult = ReturnType<typeof useFilterAllContactsQuery>;
export type FilterAllContactsLazyQueryHookResult = ReturnType<typeof useFilterAllContactsLazyQuery>;
export type FilterAllContactsQueryResult = Apollo.QueryResult<FilterAllContactsQuery, FilterAllContactsQueryVariables>;
export const GetContactByIdDocument = gql`
    query getContactById($id: UUID!) {
  contacts {
    byId(id: $id) {
      id
      name
      email
      phoneNumber
      isActive
      userRole
      contactType
      note
      addresses {
        id
        name
        category
        addressLine1
        city
        state
        country
        postalCode
        timezone
        coordinates
      }
    }
  }
}
    `;

/**
 * __useGetContactByIdQuery__
 *
 * To run a query within a React component, call `useGetContactByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContactByIdQuery(baseOptions: Apollo.QueryHookOptions<GetContactByIdQuery, GetContactByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactByIdQuery, GetContactByIdQueryVariables>(GetContactByIdDocument, options);
      }
export function useGetContactByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactByIdQuery, GetContactByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactByIdQuery, GetContactByIdQueryVariables>(GetContactByIdDocument, options);
        }
export type GetContactByIdQueryHookResult = ReturnType<typeof useGetContactByIdQuery>;
export type GetContactByIdLazyQueryHookResult = ReturnType<typeof useGetContactByIdLazyQuery>;
export type GetContactByIdQueryResult = Apollo.QueryResult<GetContactByIdQuery, GetContactByIdQueryVariables>;
export const UpdateContactNoteDocument = gql`
    mutation updateContactNote($contact: UpdateContactNote!) {
  updateContactNote(contact: $contact) {
    success
    note
    errors {
      message
    }
  }
}
    `;
export type UpdateContactNoteMutationFn = Apollo.MutationFunction<UpdateContactNoteMutation, UpdateContactNoteMutationVariables>;

/**
 * __useUpdateContactNoteMutation__
 *
 * To run a mutation, you first call `useUpdateContactNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactNoteMutation, { data, loading, error }] = useUpdateContactNoteMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useUpdateContactNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactNoteMutation, UpdateContactNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactNoteMutation, UpdateContactNoteMutationVariables>(UpdateContactNoteDocument, options);
      }
export type UpdateContactNoteMutationHookResult = ReturnType<typeof useUpdateContactNoteMutation>;
export type UpdateContactNoteMutationResult = Apollo.MutationResult<UpdateContactNoteMutation>;
export type UpdateContactNoteMutationOptions = Apollo.BaseMutationOptions<UpdateContactNoteMutation, UpdateContactNoteMutationVariables>;
export const GetAllDriversDocument = gql`
    query getAllDrivers($accountId: UUID!) {
  drivers {
    all(accountId: $accountId) {
      items {
        id
        contact {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllDriversQuery__
 *
 * To run a query within a React component, call `useGetAllDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllDriversQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAllDriversQuery(baseOptions: Apollo.QueryHookOptions<GetAllDriversQuery, GetAllDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllDriversQuery, GetAllDriversQueryVariables>(GetAllDriversDocument, options);
      }
export function useGetAllDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllDriversQuery, GetAllDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllDriversQuery, GetAllDriversQueryVariables>(GetAllDriversDocument, options);
        }
export type GetAllDriversQueryHookResult = ReturnType<typeof useGetAllDriversQuery>;
export type GetAllDriversLazyQueryHookResult = ReturnType<typeof useGetAllDriversLazyQuery>;
export type GetAllDriversQueryResult = Apollo.QueryResult<GetAllDriversQuery, GetAllDriversQueryVariables>;
export const SearchDriversDocument = gql`
    query searchDrivers($accountId: UUID!, $offset: Int = 0, $perPage: Int = 20, $orderBy: OrderByDirection, $driverId: UUID, $includeInactive: Boolean = false, $userRole: UserRole) {
  drivers {
    all(
      accountId: $accountId
      skip: $offset
      take: $perPage
      includeInactive: $includeInactive
      orderBy: $orderBy
      driverId: $driverId
      userRole: $userRole
    ) {
      items {
        id
        isActive
        garageId
        contact {
          email
          name
          id
          title
          phoneNumber
          profileImageUrl
          userRole
        }
      }
      total
    }
  }
}
    `;

/**
 * __useSearchDriversQuery__
 *
 * To run a query within a React component, call `useSearchDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDriversQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      driverId: // value for 'driverId'
 *      includeInactive: // value for 'includeInactive'
 *      userRole: // value for 'userRole'
 *   },
 * });
 */
export function useSearchDriversQuery(baseOptions: Apollo.QueryHookOptions<SearchDriversQuery, SearchDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDriversQuery, SearchDriversQueryVariables>(SearchDriversDocument, options);
      }
export function useSearchDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDriversQuery, SearchDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDriversQuery, SearchDriversQueryVariables>(SearchDriversDocument, options);
        }
export type SearchDriversQueryHookResult = ReturnType<typeof useSearchDriversQuery>;
export type SearchDriversLazyQueryHookResult = ReturnType<typeof useSearchDriversLazyQuery>;
export type SearchDriversQueryResult = Apollo.QueryResult<SearchDriversQuery, SearchDriversQueryVariables>;
export const SearchDriversFromVendorsMicroServiceDocument = gql`
    query SearchDriversFromVendorsMicroService($searchDriversId: UUID, $vendorId: UUID, $name: String, $includeInactive: Boolean!, $providerType: ProviderType, $status: DriverStatus, $skip: Int, $take: Int, $orderBy: OrderByDirection) {
  driverQueries {
    searchDrivers(
      id: $searchDriversId
      vendorId: $vendorId
      name: $name
      includeInactive: $includeInactive
      providerType: $providerType
      status: $status
      skip: $skip
      take: $take
      orderBy: $orderBy
    ) {
      id
      vendorId
      userId
      firstName
      lastName
      email
      phoneNumber
      drivingSince
      isPrimary
      isActive
      profileImageUrl
      profileImageUpdatedAt
      profileImageSignedUrl
      bio
      driverProviders {
        id
        driverId
        providerType
        agentProfileUrl
        agentProfileFileUpdatedAt
        agentProfileSignedUrl
        backgroundCheckDate
        drugTestDate
        profileImageVerified
        approved
        status
        createdAt
        updatedAt
        deleted
      }
      createdAt
      updatedAt
      deleted
    }
  }
}
    `;

/**
 * __useSearchDriversFromVendorsMicroServiceQuery__
 *
 * To run a query within a React component, call `useSearchDriversFromVendorsMicroServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDriversFromVendorsMicroServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDriversFromVendorsMicroServiceQuery({
 *   variables: {
 *      searchDriversId: // value for 'searchDriversId'
 *      vendorId: // value for 'vendorId'
 *      name: // value for 'name'
 *      includeInactive: // value for 'includeInactive'
 *      providerType: // value for 'providerType'
 *      status: // value for 'status'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSearchDriversFromVendorsMicroServiceQuery(baseOptions: Apollo.QueryHookOptions<SearchDriversFromVendorsMicroServiceQuery, SearchDriversFromVendorsMicroServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDriversFromVendorsMicroServiceQuery, SearchDriversFromVendorsMicroServiceQueryVariables>(SearchDriversFromVendorsMicroServiceDocument, options);
      }
export function useSearchDriversFromVendorsMicroServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDriversFromVendorsMicroServiceQuery, SearchDriversFromVendorsMicroServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDriversFromVendorsMicroServiceQuery, SearchDriversFromVendorsMicroServiceQueryVariables>(SearchDriversFromVendorsMicroServiceDocument, options);
        }
export type SearchDriversFromVendorsMicroServiceQueryHookResult = ReturnType<typeof useSearchDriversFromVendorsMicroServiceQuery>;
export type SearchDriversFromVendorsMicroServiceLazyQueryHookResult = ReturnType<typeof useSearchDriversFromVendorsMicroServiceLazyQuery>;
export type SearchDriversFromVendorsMicroServiceQueryResult = Apollo.QueryResult<SearchDriversFromVendorsMicroServiceQuery, SearchDriversFromVendorsMicroServiceQueryVariables>;
export const GetAvailableDriversDocument = gql`
    query GetAvailableDrivers($tripId: UUID!) {
  trips {
    availableDrivers(criteria: {tripId: $tripId}) {
      internal {
        next {
          startTime
          endTime
          availability
          trip {
            id
            tripNumber
            estimatedAvailabilityTime
          }
        }
        overlapping {
          startTime
          endTime
          availability
          trip {
            id
            tripNumber
            estimatedAvailabilityTime
          }
        }
        previous {
          startTime
          endTime
          availability
          trip {
            id
            tripNumber
            estimatedAvailabilityTime
          }
        }
        driver {
          id
          name
          imageUrl
        }
        availability
      }
    }
  }
}
    `;

/**
 * __useGetAvailableDriversQuery__
 *
 * To run a query within a React component, call `useGetAvailableDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableDriversQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useGetAvailableDriversQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableDriversQuery, GetAvailableDriversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableDriversQuery, GetAvailableDriversQueryVariables>(GetAvailableDriversDocument, options);
      }
export function useGetAvailableDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableDriversQuery, GetAvailableDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableDriversQuery, GetAvailableDriversQueryVariables>(GetAvailableDriversDocument, options);
        }
export type GetAvailableDriversQueryHookResult = ReturnType<typeof useGetAvailableDriversQuery>;
export type GetAvailableDriversLazyQueryHookResult = ReturnType<typeof useGetAvailableDriversLazyQuery>;
export type GetAvailableDriversQueryResult = Apollo.QueryResult<GetAvailableDriversQuery, GetAvailableDriversQueryVariables>;
export const GetDriversAvailabilityDocument = gql`
    query getDriversAvailability($criteria: AvailabilityQueryCriteria!) {
  drivers {
    available(criteria: $criteria) {
      driver {
        id
        imageUrl
        name
      }
      availability
      next {
        startTime
        endTime
      }
      previous {
        startTime
        endTime
      }
      overlapping {
        startTime
        endTime
        availability
        trip {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetDriversAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetDriversAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriversAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriversAvailabilityQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useGetDriversAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GetDriversAvailabilityQuery, GetDriversAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriversAvailabilityQuery, GetDriversAvailabilityQueryVariables>(GetDriversAvailabilityDocument, options);
      }
export function useGetDriversAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriversAvailabilityQuery, GetDriversAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriversAvailabilityQuery, GetDriversAvailabilityQueryVariables>(GetDriversAvailabilityDocument, options);
        }
export type GetDriversAvailabilityQueryHookResult = ReturnType<typeof useGetDriversAvailabilityQuery>;
export type GetDriversAvailabilityLazyQueryHookResult = ReturnType<typeof useGetDriversAvailabilityLazyQuery>;
export type GetDriversAvailabilityQueryResult = Apollo.QueryResult<GetDriversAvailabilityQuery, GetDriversAvailabilityQueryVariables>;
export const FetchDriverByIdDocument = gql`
    query FetchDriverById($driverId: UUID!) {
  drivers {
    byId(id: $driverId) {
      drivingSince
      id
      garage {
        id
        location {
          addressLine1
          addressLine2
          coordinates
          city
          state
          postalCode
        }
      }
      marketingDescription
      videoUrl
      accountId
      contact {
        email
        name
        id
        title
        phoneNumber
        profileImageUrl
        userRole
      }
    }
  }
}
    `;

/**
 * __useFetchDriverByIdQuery__
 *
 * To run a query within a React component, call `useFetchDriverByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchDriverByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchDriverByIdQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useFetchDriverByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchDriverByIdQuery, FetchDriverByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchDriverByIdQuery, FetchDriverByIdQueryVariables>(FetchDriverByIdDocument, options);
      }
export function useFetchDriverByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchDriverByIdQuery, FetchDriverByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchDriverByIdQuery, FetchDriverByIdQueryVariables>(FetchDriverByIdDocument, options);
        }
export type FetchDriverByIdQueryHookResult = ReturnType<typeof useFetchDriverByIdQuery>;
export type FetchDriverByIdLazyQueryHookResult = ReturnType<typeof useFetchDriverByIdLazyQuery>;
export type FetchDriverByIdQueryResult = Apollo.QueryResult<FetchDriverByIdQuery, FetchDriverByIdQueryVariables>;
export const UpdateDriverDocument = gql`
    mutation UpdateDriver($driver: UpdateDriver!) {
  updateDriver(driver: $driver) {
    driver {
      marketingDescription
      drivingSince
      accountId
      id
      contact {
        email
        name
        id
        title
        phoneNumber
        profileImageUrl
        userRole
      }
    }
    success
    errors {
      message
    }
  }
}
    `;
export type UpdateDriverMutationFn = Apollo.MutationFunction<UpdateDriverMutation, UpdateDriverMutationVariables>;

/**
 * __useUpdateDriverMutation__
 *
 * To run a mutation, you first call `useUpdateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDriverMutation, { data, loading, error }] = useUpdateDriverMutation({
 *   variables: {
 *      driver: // value for 'driver'
 *   },
 * });
 */
export function useUpdateDriverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDriverMutation, UpdateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDriverMutation, UpdateDriverMutationVariables>(UpdateDriverDocument, options);
      }
export type UpdateDriverMutationHookResult = ReturnType<typeof useUpdateDriverMutation>;
export type UpdateDriverMutationResult = Apollo.MutationResult<UpdateDriverMutation>;
export type UpdateDriverMutationOptions = Apollo.BaseMutationOptions<UpdateDriverMutation, UpdateDriverMutationVariables>;
export const CreateMsDriverRecordDocument = gql`
    mutation CreateMsDriverRecord($driverCreateArgs: DriverCreateArgs!) {
  createDriverRecord(driverCreateArgs: $driverCreateArgs) {
    id
    vendorId
    userId
    firstName
    lastName
    email
    phoneNumber
    drivingSince
    isPrimary
    isActive
    profileImageUrl
    profileImageUpdatedAt
    profileImageSignedUrl
    bio
    driverProviders {
      id
      driverId
      providerType
      agentProfileUrl
      agentProfileFileUpdatedAt
      agentProfileSignedUrl
      backgroundCheckDate
      drugTestDate
      profileImageVerified
      approved
      status
      createdAt
      updatedAt
      deleted
    }
    createdAt
    updatedAt
    deleted
  }
}
    `;
export type CreateMsDriverRecordMutationFn = Apollo.MutationFunction<CreateMsDriverRecordMutation, CreateMsDriverRecordMutationVariables>;

/**
 * __useCreateMsDriverRecordMutation__
 *
 * To run a mutation, you first call `useCreateMsDriverRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMsDriverRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMsDriverRecordMutation, { data, loading, error }] = useCreateMsDriverRecordMutation({
 *   variables: {
 *      driverCreateArgs: // value for 'driverCreateArgs'
 *   },
 * });
 */
export function useCreateMsDriverRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateMsDriverRecordMutation, CreateMsDriverRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMsDriverRecordMutation, CreateMsDriverRecordMutationVariables>(CreateMsDriverRecordDocument, options);
      }
export type CreateMsDriverRecordMutationHookResult = ReturnType<typeof useCreateMsDriverRecordMutation>;
export type CreateMsDriverRecordMutationResult = Apollo.MutationResult<CreateMsDriverRecordMutation>;
export type CreateMsDriverRecordMutationOptions = Apollo.BaseMutationOptions<CreateMsDriverRecordMutation, CreateMsDriverRecordMutationVariables>;
export const UpdateMsDriverRecordDocument = gql`
    mutation UpdateMsDriverRecord($driverUpdateArgs: DriverUpdateArgs!) {
  updateDriverRecord(driverUpdateArgs: $driverUpdateArgs) {
    id
    vendorId
    userId
    firstName
    lastName
    email
    phoneNumber
    drivingSince
    isPrimary
    isActive
    profileImageUrl
    profileImageUpdatedAt
    profileImageSignedUrl
    bio
    driverProviders {
      id
      driverId
      providerType
      agentProfileUrl
      agentProfileFileUpdatedAt
      agentProfileSignedUrl
      backgroundCheckDate
      drugTestDate
      profileImageVerified
      approved
      status
      createdAt
      updatedAt
      deleted
    }
    createdAt
    updatedAt
    deleted
  }
}
    `;
export type UpdateMsDriverRecordMutationFn = Apollo.MutationFunction<UpdateMsDriverRecordMutation, UpdateMsDriverRecordMutationVariables>;

/**
 * __useUpdateMsDriverRecordMutation__
 *
 * To run a mutation, you first call `useUpdateMsDriverRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMsDriverRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMsDriverRecordMutation, { data, loading, error }] = useUpdateMsDriverRecordMutation({
 *   variables: {
 *      driverUpdateArgs: // value for 'driverUpdateArgs'
 *   },
 * });
 */
export function useUpdateMsDriverRecordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMsDriverRecordMutation, UpdateMsDriverRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMsDriverRecordMutation, UpdateMsDriverRecordMutationVariables>(UpdateMsDriverRecordDocument, options);
      }
export type UpdateMsDriverRecordMutationHookResult = ReturnType<typeof useUpdateMsDriverRecordMutation>;
export type UpdateMsDriverRecordMutationResult = Apollo.MutationResult<UpdateMsDriverRecordMutation>;
export type UpdateMsDriverRecordMutationOptions = Apollo.BaseMutationOptions<UpdateMsDriverRecordMutation, UpdateMsDriverRecordMutationVariables>;
export const GetDriversByVendorIdDocument = gql`
    query GetDriversByVendorId($vendorId: UUID, $take: Int) {
  driverQueries {
    getDriversByVendorId(vendorId: $vendorId, take: $take) {
      id
      vendorId
      userId
      firstName
      lastName
      email
      bio
      drivingSince
      isPrimary
      phoneNumber
      profileImageSignedUrl
      profileImageUpdatedAt
      profileImageUrl
      isActive
      deleted
      createdAt
      updatedAt
      driverProviders {
        id
        agentProfileFileUpdatedAt
        agentProfileSignedUrl
        agentProfileUrl
        approved
        status
        backgroundCheckDate
        driverId
        drugTestDate
        profileImageVerified
        providerType
        deleted
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetDriversByVendorIdQuery__
 *
 * To run a query within a React component, call `useGetDriversByVendorIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriversByVendorIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriversByVendorIdQuery({
 *   variables: {
 *      vendorId: // value for 'vendorId'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetDriversByVendorIdQuery(baseOptions?: Apollo.QueryHookOptions<GetDriversByVendorIdQuery, GetDriversByVendorIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriversByVendorIdQuery, GetDriversByVendorIdQueryVariables>(GetDriversByVendorIdDocument, options);
      }
export function useGetDriversByVendorIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriversByVendorIdQuery, GetDriversByVendorIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriversByVendorIdQuery, GetDriversByVendorIdQueryVariables>(GetDriversByVendorIdDocument, options);
        }
export type GetDriversByVendorIdQueryHookResult = ReturnType<typeof useGetDriversByVendorIdQuery>;
export type GetDriversByVendorIdLazyQueryHookResult = ReturnType<typeof useGetDriversByVendorIdLazyQuery>;
export type GetDriversByVendorIdQueryResult = Apollo.QueryResult<GetDriversByVendorIdQuery, GetDriversByVendorIdQueryVariables>;
export const GetDriverByIdDocument = gql`
    query GetDriverById($driverId: UUID!) {
  driverQueries {
    getDriverById(id: $driverId) {
      id
      vendorId
      userId
      firstName
      lastName
      email
      phoneNumber
      drivingSince
      isPrimary
      isActive
      profileImageUrl
      profileImageUpdatedAt
      profileImageSignedUrl
      bio
      driverProviders {
        id
        driverId
        providerType
        agentProfileUrl
        agentProfileFileUpdatedAt
        agentProfileSignedUrl
        backgroundCheckDate
        drugTestDate
        profileImageVerified
        approved
        status
        rejectionReason
        createdAt
        updatedAt
        deleted
      }
      createdAt
      updatedAt
      deleted
    }
  }
}
    `;

/**
 * __useGetDriverByIdQuery__
 *
 * To run a query within a React component, call `useGetDriverByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDriverByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDriverByIdQuery({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useGetDriverByIdQuery(baseOptions: Apollo.QueryHookOptions<GetDriverByIdQuery, GetDriverByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDriverByIdQuery, GetDriverByIdQueryVariables>(GetDriverByIdDocument, options);
      }
export function useGetDriverByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDriverByIdQuery, GetDriverByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDriverByIdQuery, GetDriverByIdQueryVariables>(GetDriverByIdDocument, options);
        }
export type GetDriverByIdQueryHookResult = ReturnType<typeof useGetDriverByIdQuery>;
export type GetDriverByIdLazyQueryHookResult = ReturnType<typeof useGetDriverByIdLazyQuery>;
export type GetDriverByIdQueryResult = Apollo.QueryResult<GetDriverByIdQuery, GetDriverByIdQueryVariables>;
export const GetMsDriverFilesDocument = gql`
    query GetMsDriverFiles($id: UUID!) {
  driverQueries {
    driverFiles(id: $id) {
      documents {
        key
        signedUrl
        mimeType
      }
      images {
        key
        signedUrl
        mimeType
      }
    }
  }
}
    `;

/**
 * __useGetMsDriverFilesQuery__
 *
 * To run a query within a React component, call `useGetMsDriverFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMsDriverFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMsDriverFilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMsDriverFilesQuery(baseOptions: Apollo.QueryHookOptions<GetMsDriverFilesQuery, GetMsDriverFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMsDriverFilesQuery, GetMsDriverFilesQueryVariables>(GetMsDriverFilesDocument, options);
      }
export function useGetMsDriverFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMsDriverFilesQuery, GetMsDriverFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMsDriverFilesQuery, GetMsDriverFilesQueryVariables>(GetMsDriverFilesDocument, options);
        }
export type GetMsDriverFilesQueryHookResult = ReturnType<typeof useGetMsDriverFilesQuery>;
export type GetMsDriverFilesLazyQueryHookResult = ReturnType<typeof useGetMsDriverFilesLazyQuery>;
export type GetMsDriverFilesQueryResult = Apollo.QueryResult<GetMsDriverFilesQuery, GetMsDriverFilesQueryVariables>;
export const DeleteMsDriverFileDocument = gql`
    mutation DeleteMsDriverFile($deleteDriverFileArgs: DriverDeleteFileArgs!) {
  deleteDriverFile(deleteDriverFileArgs: $deleteDriverFileArgs) {
    deleted
  }
}
    `;
export type DeleteMsDriverFileMutationFn = Apollo.MutationFunction<DeleteMsDriverFileMutation, DeleteMsDriverFileMutationVariables>;

/**
 * __useDeleteMsDriverFileMutation__
 *
 * To run a mutation, you first call `useDeleteMsDriverFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMsDriverFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMsDriverFileMutation, { data, loading, error }] = useDeleteMsDriverFileMutation({
 *   variables: {
 *      deleteDriverFileArgs: // value for 'deleteDriverFileArgs'
 *   },
 * });
 */
export function useDeleteMsDriverFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMsDriverFileMutation, DeleteMsDriverFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMsDriverFileMutation, DeleteMsDriverFileMutationVariables>(DeleteMsDriverFileDocument, options);
      }
export type DeleteMsDriverFileMutationHookResult = ReturnType<typeof useDeleteMsDriverFileMutation>;
export type DeleteMsDriverFileMutationResult = Apollo.MutationResult<DeleteMsDriverFileMutation>;
export type DeleteMsDriverFileMutationOptions = Apollo.BaseMutationOptions<DeleteMsDriverFileMutation, DeleteMsDriverFileMutationVariables>;
export const CreateMsDriverFilesUploadSignedUrlsDocument = gql`
    mutation CreateMsDriverFilesUploadSignedUrls($driverFilesUploadArgs: DriverFilesUploadArgs!) {
  createDriverFilesUploadSignedUrls(driverFilesUploadArgs: $driverFilesUploadArgs) {
    filetype
    key
    filename
    signedUrl
    mimeType
  }
}
    `;
export type CreateMsDriverFilesUploadSignedUrlsMutationFn = Apollo.MutationFunction<CreateMsDriverFilesUploadSignedUrlsMutation, CreateMsDriverFilesUploadSignedUrlsMutationVariables>;

/**
 * __useCreateMsDriverFilesUploadSignedUrlsMutation__
 *
 * To run a mutation, you first call `useCreateMsDriverFilesUploadSignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMsDriverFilesUploadSignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMsDriverFilesUploadSignedUrlsMutation, { data, loading, error }] = useCreateMsDriverFilesUploadSignedUrlsMutation({
 *   variables: {
 *      driverFilesUploadArgs: // value for 'driverFilesUploadArgs'
 *   },
 * });
 */
export function useCreateMsDriverFilesUploadSignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<CreateMsDriverFilesUploadSignedUrlsMutation, CreateMsDriverFilesUploadSignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMsDriverFilesUploadSignedUrlsMutation, CreateMsDriverFilesUploadSignedUrlsMutationVariables>(CreateMsDriverFilesUploadSignedUrlsDocument, options);
      }
export type CreateMsDriverFilesUploadSignedUrlsMutationHookResult = ReturnType<typeof useCreateMsDriverFilesUploadSignedUrlsMutation>;
export type CreateMsDriverFilesUploadSignedUrlsMutationResult = Apollo.MutationResult<CreateMsDriverFilesUploadSignedUrlsMutation>;
export type CreateMsDriverFilesUploadSignedUrlsMutationOptions = Apollo.BaseMutationOptions<CreateMsDriverFilesUploadSignedUrlsMutation, CreateMsDriverFilesUploadSignedUrlsMutationVariables>;
export const DeleteSavoyaDriverDocument = gql`
    mutation DeleteSavoyaDriver($id: UUID!) {
  deleteSavoyaDriver(id: $id) {
    deleted
  }
}
    `;
export type DeleteSavoyaDriverMutationFn = Apollo.MutationFunction<DeleteSavoyaDriverMutation, DeleteSavoyaDriverMutationVariables>;

/**
 * __useDeleteSavoyaDriverMutation__
 *
 * To run a mutation, you first call `useDeleteSavoyaDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavoyaDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavoyaDriverMutation, { data, loading, error }] = useDeleteSavoyaDriverMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSavoyaDriverMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSavoyaDriverMutation, DeleteSavoyaDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSavoyaDriverMutation, DeleteSavoyaDriverMutationVariables>(DeleteSavoyaDriverDocument, options);
      }
export type DeleteSavoyaDriverMutationHookResult = ReturnType<typeof useDeleteSavoyaDriverMutation>;
export type DeleteSavoyaDriverMutationResult = Apollo.MutationResult<DeleteSavoyaDriverMutation>;
export type DeleteSavoyaDriverMutationOptions = Apollo.BaseMutationOptions<DeleteSavoyaDriverMutation, DeleteSavoyaDriverMutationVariables>;
export const GetGaragesDocument = gql`
    query getGarages($id: UUID!) {
  garages {
    byId(id: $id) {
      id
      name
      location {
        id
        name
        city
        state
        postalCode
        timezone
        addressLine1
        abbreviation
        coordinates
        placeName
      }
    }
  }
}
    `;

/**
 * __useGetGaragesQuery__
 *
 * To run a query within a React component, call `useGetGaragesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGaragesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGaragesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetGaragesQuery(baseOptions: Apollo.QueryHookOptions<GetGaragesQuery, GetGaragesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGaragesQuery, GetGaragesQueryVariables>(GetGaragesDocument, options);
      }
export function useGetGaragesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGaragesQuery, GetGaragesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGaragesQuery, GetGaragesQueryVariables>(GetGaragesDocument, options);
        }
export type GetGaragesQueryHookResult = ReturnType<typeof useGetGaragesQuery>;
export type GetGaragesLazyQueryHookResult = ReturnType<typeof useGetGaragesLazyQuery>;
export type GetGaragesQueryResult = Apollo.QueryResult<GetGaragesQuery, GetGaragesQueryVariables>;
export const UpdateGarageDocument = gql`
    mutation updateGarage($garage: UpdateGarageWithLocation!) {
  updateGarage(garage: $garage) {
    success
  }
}
    `;
export type UpdateGarageMutationFn = Apollo.MutationFunction<UpdateGarageMutation, UpdateGarageMutationVariables>;

/**
 * __useUpdateGarageMutation__
 *
 * To run a mutation, you first call `useUpdateGarageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGarageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGarageMutation, { data, loading, error }] = useUpdateGarageMutation({
 *   variables: {
 *      garage: // value for 'garage'
 *   },
 * });
 */
export function useUpdateGarageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGarageMutation, UpdateGarageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGarageMutation, UpdateGarageMutationVariables>(UpdateGarageDocument, options);
      }
export type UpdateGarageMutationHookResult = ReturnType<typeof useUpdateGarageMutation>;
export type UpdateGarageMutationResult = Apollo.MutationResult<UpdateGarageMutation>;
export type UpdateGarageMutationOptions = Apollo.BaseMutationOptions<UpdateGarageMutation, UpdateGarageMutationVariables>;
export const GetMarketsDocument = gql`
    query getMarkets($offset: Int = 0, $perPage: Int = 50) {
  markets {
    all(skip: $offset, take: $perPage) {
      total
      items {
        id
        name
        abbreviation
      }
    }
  }
}
    `;

/**
 * __useGetMarketsQuery__
 *
 * To run a query within a React component, call `useGetMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMarketsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetMarketsQuery(baseOptions?: Apollo.QueryHookOptions<GetMarketsQuery, GetMarketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMarketsQuery, GetMarketsQueryVariables>(GetMarketsDocument, options);
      }
export function useGetMarketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMarketsQuery, GetMarketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMarketsQuery, GetMarketsQueryVariables>(GetMarketsDocument, options);
        }
export type GetMarketsQueryHookResult = ReturnType<typeof useGetMarketsQuery>;
export type GetMarketsLazyQueryHookResult = ReturnType<typeof useGetMarketsLazyQuery>;
export type GetMarketsQueryResult = Apollo.QueryResult<GetMarketsQuery, GetMarketsQueryVariables>;
export const GetSystemVehicleClassesDocument = gql`
    query getSystemVehicleClasses($offset: Int = 0, $perPage: Int = 50) {
  systemVehicleClasses {
    all(skip: $offset, take: $perPage) {
      total
      items {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetSystemVehicleClassesQuery__
 *
 * To run a query within a React component, call `useGetSystemVehicleClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemVehicleClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemVehicleClassesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetSystemVehicleClassesQuery(baseOptions?: Apollo.QueryHookOptions<GetSystemVehicleClassesQuery, GetSystemVehicleClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemVehicleClassesQuery, GetSystemVehicleClassesQueryVariables>(GetSystemVehicleClassesDocument, options);
      }
export function useGetSystemVehicleClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemVehicleClassesQuery, GetSystemVehicleClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemVehicleClassesQuery, GetSystemVehicleClassesQueryVariables>(GetSystemVehicleClassesDocument, options);
        }
export type GetSystemVehicleClassesQueryHookResult = ReturnType<typeof useGetSystemVehicleClassesQuery>;
export type GetSystemVehicleClassesLazyQueryHookResult = ReturnType<typeof useGetSystemVehicleClassesLazyQuery>;
export type GetSystemVehicleClassesQueryResult = Apollo.QueryResult<GetSystemVehicleClassesQuery, GetSystemVehicleClassesQueryVariables>;
export const CreateAccountFromTemplateDocument = gql`
    mutation CreateAccountFromTemplate($onboardingTemplate: IndependentOperatorOnboardingTemplate!) {
  createAccountFromTemplate(template: $onboardingTemplate) {
    account {
      id
    }
    success
  }
}
    `;
export type CreateAccountFromTemplateMutationFn = Apollo.MutationFunction<CreateAccountFromTemplateMutation, CreateAccountFromTemplateMutationVariables>;

/**
 * __useCreateAccountFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateAccountFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountFromTemplateMutation, { data, loading, error }] = useCreateAccountFromTemplateMutation({
 *   variables: {
 *      onboardingTemplate: // value for 'onboardingTemplate'
 *   },
 * });
 */
export function useCreateAccountFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountFromTemplateMutation, CreateAccountFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountFromTemplateMutation, CreateAccountFromTemplateMutationVariables>(CreateAccountFromTemplateDocument, options);
      }
export type CreateAccountFromTemplateMutationHookResult = ReturnType<typeof useCreateAccountFromTemplateMutation>;
export type CreateAccountFromTemplateMutationResult = Apollo.MutationResult<CreateAccountFromTemplateMutation>;
export type CreateAccountFromTemplateMutationOptions = Apollo.BaseMutationOptions<CreateAccountFromTemplateMutation, CreateAccountFromTemplateMutationVariables>;
export const GetTimeZonesDocument = gql`
    query getTimeZones($timezone: MapTimeZoneInput!) {
  locations {
    timeZones(timeZoneInput: $timezone) {
      status
      timeZoneName
      timeZoneId
    }
  }
}
    `;

/**
 * __useGetTimeZonesQuery__
 *
 * To run a query within a React component, call `useGetTimeZonesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTimeZonesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTimeZonesQuery({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetTimeZonesQuery(baseOptions: Apollo.QueryHookOptions<GetTimeZonesQuery, GetTimeZonesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, options);
      }
export function useGetTimeZonesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTimeZonesQuery, GetTimeZonesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTimeZonesQuery, GetTimeZonesQueryVariables>(GetTimeZonesDocument, options);
        }
export type GetTimeZonesQueryHookResult = ReturnType<typeof useGetTimeZonesQuery>;
export type GetTimeZonesLazyQueryHookResult = ReturnType<typeof useGetTimeZonesLazyQuery>;
export type GetTimeZonesQueryResult = Apollo.QueryResult<GetTimeZonesQuery, GetTimeZonesQueryVariables>;
export const QueryAllTransferRatesDocument = gql`
    query queryAllTransferRates($accountId: UUID!, $skip: Int = 0, $limit: Int = 100) {
  rates {
    searchTransferRates(accountId: $accountId, skip: $skip, limit: $limit) {
      items {
        id
        name
        description
        rates {
          id
          name
          calculation
          vehicleClassOverrides {
            id
            vehicleClass {
              name
              id
            }
            amount
          }
        }
        customers {
          customer {
            id
            name
          }
        }
        tripRule {
          id
          firstLocationMatchType
          firstLocation {
            id
            placeId
            zoneType
            radiusInKm
            placeName
            name
            coordinates
          }
          secondLocationMatchType
          secondLocation {
            id
            placeId
            zoneType
            radiusInKm
            placeName
            name
            coordinates
          }
        }
      }
    }
  }
}
    `;

/**
 * __useQueryAllTransferRatesQuery__
 *
 * To run a query within a React component, call `useQueryAllTransferRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAllTransferRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAllTransferRatesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useQueryAllTransferRatesQuery(baseOptions: Apollo.QueryHookOptions<QueryAllTransferRatesQuery, QueryAllTransferRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryAllTransferRatesQuery, QueryAllTransferRatesQueryVariables>(QueryAllTransferRatesDocument, options);
      }
export function useQueryAllTransferRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryAllTransferRatesQuery, QueryAllTransferRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryAllTransferRatesQuery, QueryAllTransferRatesQueryVariables>(QueryAllTransferRatesDocument, options);
        }
export type QueryAllTransferRatesQueryHookResult = ReturnType<typeof useQueryAllTransferRatesQuery>;
export type QueryAllTransferRatesLazyQueryHookResult = ReturnType<typeof useQueryAllTransferRatesLazyQuery>;
export type QueryAllTransferRatesQueryResult = Apollo.QueryResult<QueryAllTransferRatesQuery, QueryAllTransferRatesQueryVariables>;
export const GetVehicleHourlyRatesDocument = gql`
    query getVehicleHourlyRates($accountId: UUID!) {
  vehicleClasses {
    all(accountId: $accountId) {
      items {
        name
        hourlyRate
        id
        minimumHours
        cancellationPolicyHours
      }
    }
  }
}
    `;

/**
 * __useGetVehicleHourlyRatesQuery__
 *
 * To run a query within a React component, call `useGetVehicleHourlyRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleHourlyRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleHourlyRatesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetVehicleHourlyRatesQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleHourlyRatesQuery, GetVehicleHourlyRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleHourlyRatesQuery, GetVehicleHourlyRatesQueryVariables>(GetVehicleHourlyRatesDocument, options);
      }
export function useGetVehicleHourlyRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleHourlyRatesQuery, GetVehicleHourlyRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleHourlyRatesQuery, GetVehicleHourlyRatesQueryVariables>(GetVehicleHourlyRatesDocument, options);
        }
export type GetVehicleHourlyRatesQueryHookResult = ReturnType<typeof useGetVehicleHourlyRatesQuery>;
export type GetVehicleHourlyRatesLazyQueryHookResult = ReturnType<typeof useGetVehicleHourlyRatesLazyQuery>;
export type GetVehicleHourlyRatesQueryResult = Apollo.QueryResult<GetVehicleHourlyRatesQuery, GetVehicleHourlyRatesQueryVariables>;
export const UpdateVehicleHourlyRateDocument = gql`
    mutation UpdateVehicleHourlyRate($id: UUID!, $hourlyRate: Float!) {
  updateVehicleClass(vehicleClass: {id: $id, hourlyRate: $hourlyRate}) {
    vehicleClass {
      id
    }
  }
}
    `;
export type UpdateVehicleHourlyRateMutationFn = Apollo.MutationFunction<UpdateVehicleHourlyRateMutation, UpdateVehicleHourlyRateMutationVariables>;

/**
 * __useUpdateVehicleHourlyRateMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleHourlyRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleHourlyRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleHourlyRateMutation, { data, loading, error }] = useUpdateVehicleHourlyRateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hourlyRate: // value for 'hourlyRate'
 *   },
 * });
 */
export function useUpdateVehicleHourlyRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVehicleHourlyRateMutation, UpdateVehicleHourlyRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVehicleHourlyRateMutation, UpdateVehicleHourlyRateMutationVariables>(UpdateVehicleHourlyRateDocument, options);
      }
export type UpdateVehicleHourlyRateMutationHookResult = ReturnType<typeof useUpdateVehicleHourlyRateMutation>;
export type UpdateVehicleHourlyRateMutationResult = Apollo.MutationResult<UpdateVehicleHourlyRateMutation>;
export type UpdateVehicleHourlyRateMutationOptions = Apollo.BaseMutationOptions<UpdateVehicleHourlyRateMutation, UpdateVehicleHourlyRateMutationVariables>;
export const GetDefaultRatesDocument = gql`
    query getDefaultRates($accountId: UUID!) {
  rates {
    searchDefaultRates(accountId: $accountId) {
      items {
        rates {
          ratePolicies {
            type
            thresholdValue
            thresholdValue2
            id
          }
          meteredRateIncrement
          revertToDynamicForExcessWaitTime
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetDefaultRatesQuery__
 *
 * To run a query within a React component, call `useGetDefaultRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultRatesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetDefaultRatesQuery(baseOptions: Apollo.QueryHookOptions<GetDefaultRatesQuery, GetDefaultRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultRatesQuery, GetDefaultRatesQueryVariables>(GetDefaultRatesDocument, options);
      }
export function useGetDefaultRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultRatesQuery, GetDefaultRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultRatesQuery, GetDefaultRatesQueryVariables>(GetDefaultRatesDocument, options);
        }
export type GetDefaultRatesQueryHookResult = ReturnType<typeof useGetDefaultRatesQuery>;
export type GetDefaultRatesLazyQueryHookResult = ReturnType<typeof useGetDefaultRatesLazyQuery>;
export type GetDefaultRatesQueryResult = Apollo.QueryResult<GetDefaultRatesQuery, GetDefaultRatesQueryVariables>;
export const UpdateMeteredRateIncrementDocument = gql`
    mutation updateMeteredRateIncrement($rateId: UUID!, $meteredRateIncrement: Int!) {
  updateRate(rate: {id: $rateId, meteredRateIncrement: $meteredRateIncrement}) {
    rate {
      id
    }
  }
}
    `;
export type UpdateMeteredRateIncrementMutationFn = Apollo.MutationFunction<UpdateMeteredRateIncrementMutation, UpdateMeteredRateIncrementMutationVariables>;

/**
 * __useUpdateMeteredRateIncrementMutation__
 *
 * To run a mutation, you first call `useUpdateMeteredRateIncrementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeteredRateIncrementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeteredRateIncrementMutation, { data, loading, error }] = useUpdateMeteredRateIncrementMutation({
 *   variables: {
 *      rateId: // value for 'rateId'
 *      meteredRateIncrement: // value for 'meteredRateIncrement'
 *   },
 * });
 */
export function useUpdateMeteredRateIncrementMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeteredRateIncrementMutation, UpdateMeteredRateIncrementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeteredRateIncrementMutation, UpdateMeteredRateIncrementMutationVariables>(UpdateMeteredRateIncrementDocument, options);
      }
export type UpdateMeteredRateIncrementMutationHookResult = ReturnType<typeof useUpdateMeteredRateIncrementMutation>;
export type UpdateMeteredRateIncrementMutationResult = Apollo.MutationResult<UpdateMeteredRateIncrementMutation>;
export type UpdateMeteredRateIncrementMutationOptions = Apollo.BaseMutationOptions<UpdateMeteredRateIncrementMutation, UpdateMeteredRateIncrementMutationVariables>;
export const UpdateRevertToDynamicForExcessWaitTimeDocument = gql`
    mutation updateRevertToDynamicForExcessWaitTime($rateId: UUID!, $revertToDynamicForExcessWaitTime: Boolean!) {
  updateRate(
    rate: {id: $rateId, revertToDynamicForExcessWaitTime: $revertToDynamicForExcessWaitTime}
  ) {
    rate {
      id
    }
  }
}
    `;
export type UpdateRevertToDynamicForExcessWaitTimeMutationFn = Apollo.MutationFunction<UpdateRevertToDynamicForExcessWaitTimeMutation, UpdateRevertToDynamicForExcessWaitTimeMutationVariables>;

/**
 * __useUpdateRevertToDynamicForExcessWaitTimeMutation__
 *
 * To run a mutation, you first call `useUpdateRevertToDynamicForExcessWaitTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRevertToDynamicForExcessWaitTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRevertToDynamicForExcessWaitTimeMutation, { data, loading, error }] = useUpdateRevertToDynamicForExcessWaitTimeMutation({
 *   variables: {
 *      rateId: // value for 'rateId'
 *      revertToDynamicForExcessWaitTime: // value for 'revertToDynamicForExcessWaitTime'
 *   },
 * });
 */
export function useUpdateRevertToDynamicForExcessWaitTimeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRevertToDynamicForExcessWaitTimeMutation, UpdateRevertToDynamicForExcessWaitTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRevertToDynamicForExcessWaitTimeMutation, UpdateRevertToDynamicForExcessWaitTimeMutationVariables>(UpdateRevertToDynamicForExcessWaitTimeDocument, options);
      }
export type UpdateRevertToDynamicForExcessWaitTimeMutationHookResult = ReturnType<typeof useUpdateRevertToDynamicForExcessWaitTimeMutation>;
export type UpdateRevertToDynamicForExcessWaitTimeMutationResult = Apollo.MutationResult<UpdateRevertToDynamicForExcessWaitTimeMutation>;
export type UpdateRevertToDynamicForExcessWaitTimeMutationOptions = Apollo.BaseMutationOptions<UpdateRevertToDynamicForExcessWaitTimeMutation, UpdateRevertToDynamicForExcessWaitTimeMutationVariables>;
export const UpdateDefaultRatesDocument = gql`
    mutation updateDefaultRates($id: UUID!, $thresholdValue: Float!, $thresholdValue2: Float) {
  updateRatePolicy(
    ratePolicy: {id: $id, thresholdValue: $thresholdValue, thresholdValue2: $thresholdValue2}
  ) {
    ratePolicy {
      id
      thresholdValue
      thresholdValue2
      type
    }
  }
}
    `;
export type UpdateDefaultRatesMutationFn = Apollo.MutationFunction<UpdateDefaultRatesMutation, UpdateDefaultRatesMutationVariables>;

/**
 * __useUpdateDefaultRatesMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultRatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultRatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultRatesMutation, { data, loading, error }] = useUpdateDefaultRatesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      thresholdValue: // value for 'thresholdValue'
 *      thresholdValue2: // value for 'thresholdValue2'
 *   },
 * });
 */
export function useUpdateDefaultRatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDefaultRatesMutation, UpdateDefaultRatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDefaultRatesMutation, UpdateDefaultRatesMutationVariables>(UpdateDefaultRatesDocument, options);
      }
export type UpdateDefaultRatesMutationHookResult = ReturnType<typeof useUpdateDefaultRatesMutation>;
export type UpdateDefaultRatesMutationResult = Apollo.MutationResult<UpdateDefaultRatesMutation>;
export type UpdateDefaultRatesMutationOptions = Apollo.BaseMutationOptions<UpdateDefaultRatesMutation, UpdateDefaultRatesMutationVariables>;
export const CreateTransferRateSetDocument = gql`
    mutation CreateTransferRateSet($newRateSet: InsertTransferRateSet!) {
  insertTransferRateSet(rateSet: $newRateSet) {
    rateSet {
      id
      description
      name
    }
    success
  }
}
    `;
export type CreateTransferRateSetMutationFn = Apollo.MutationFunction<CreateTransferRateSetMutation, CreateTransferRateSetMutationVariables>;

/**
 * __useCreateTransferRateSetMutation__
 *
 * To run a mutation, you first call `useCreateTransferRateSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransferRateSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransferRateSetMutation, { data, loading, error }] = useCreateTransferRateSetMutation({
 *   variables: {
 *      newRateSet: // value for 'newRateSet'
 *   },
 * });
 */
export function useCreateTransferRateSetMutation(baseOptions?: Apollo.MutationHookOptions<CreateTransferRateSetMutation, CreateTransferRateSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTransferRateSetMutation, CreateTransferRateSetMutationVariables>(CreateTransferRateSetDocument, options);
      }
export type CreateTransferRateSetMutationHookResult = ReturnType<typeof useCreateTransferRateSetMutation>;
export type CreateTransferRateSetMutationResult = Apollo.MutationResult<CreateTransferRateSetMutation>;
export type CreateTransferRateSetMutationOptions = Apollo.BaseMutationOptions<CreateTransferRateSetMutation, CreateTransferRateSetMutationVariables>;
export const UpdateTransferRateSetDocument = gql`
    mutation UpdateTransferRateSet($newRateSet: UpdateTransferRateSet!) {
  updateTransferRateSet(rateSet: $newRateSet) {
    rateSet {
      id
    }
    success
  }
}
    `;
export type UpdateTransferRateSetMutationFn = Apollo.MutationFunction<UpdateTransferRateSetMutation, UpdateTransferRateSetMutationVariables>;

/**
 * __useUpdateTransferRateSetMutation__
 *
 * To run a mutation, you first call `useUpdateTransferRateSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransferRateSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransferRateSetMutation, { data, loading, error }] = useUpdateTransferRateSetMutation({
 *   variables: {
 *      newRateSet: // value for 'newRateSet'
 *   },
 * });
 */
export function useUpdateTransferRateSetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTransferRateSetMutation, UpdateTransferRateSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTransferRateSetMutation, UpdateTransferRateSetMutationVariables>(UpdateTransferRateSetDocument, options);
      }
export type UpdateTransferRateSetMutationHookResult = ReturnType<typeof useUpdateTransferRateSetMutation>;
export type UpdateTransferRateSetMutationResult = Apollo.MutationResult<UpdateTransferRateSetMutation>;
export type UpdateTransferRateSetMutationOptions = Apollo.BaseMutationOptions<UpdateTransferRateSetMutation, UpdateTransferRateSetMutationVariables>;
export const GetRateSetByIdsDocument = gql`
    query GetRateSetByIds($rateSetIds: [UUID]!) {
  rateSets {
    findByIds(rateSetIds: $rateSetIds) {
      isCustomerRate
      id
      rates {
        id
        calculation
        amount
        defaultRate
        name
        description
        accountId
        rateType {
          category
        }
      }
    }
  }
}
    `;

/**
 * __useGetRateSetByIdsQuery__
 *
 * To run a query within a React component, call `useGetRateSetByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRateSetByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRateSetByIdsQuery({
 *   variables: {
 *      rateSetIds: // value for 'rateSetIds'
 *   },
 * });
 */
export function useGetRateSetByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetRateSetByIdsQuery, GetRateSetByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRateSetByIdsQuery, GetRateSetByIdsQueryVariables>(GetRateSetByIdsDocument, options);
      }
export function useGetRateSetByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRateSetByIdsQuery, GetRateSetByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRateSetByIdsQuery, GetRateSetByIdsQueryVariables>(GetRateSetByIdsDocument, options);
        }
export type GetRateSetByIdsQueryHookResult = ReturnType<typeof useGetRateSetByIdsQuery>;
export type GetRateSetByIdsLazyQueryHookResult = ReturnType<typeof useGetRateSetByIdsLazyQuery>;
export type GetRateSetByIdsQueryResult = Apollo.QueryResult<GetRateSetByIdsQuery, GetRateSetByIdsQueryVariables>;
export const UpdateRateDocument = gql`
    mutation UpdateRate($rate: UpdateRate!) {
  updateRate(rate: $rate) {
    rate {
      id
      amount
    }
    errors {
      message
      code
    }
    success
  }
}
    `;
export type UpdateRateMutationFn = Apollo.MutationFunction<UpdateRateMutation, UpdateRateMutationVariables>;

/**
 * __useUpdateRateMutation__
 *
 * To run a mutation, you first call `useUpdateRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRateMutation, { data, loading, error }] = useUpdateRateMutation({
 *   variables: {
 *      rate: // value for 'rate'
 *   },
 * });
 */
export function useUpdateRateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRateMutation, UpdateRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRateMutation, UpdateRateMutationVariables>(UpdateRateDocument, options);
      }
export type UpdateRateMutationHookResult = ReturnType<typeof useUpdateRateMutation>;
export type UpdateRateMutationResult = Apollo.MutationResult<UpdateRateMutation>;
export type UpdateRateMutationOptions = Apollo.BaseMutationOptions<UpdateRateMutation, UpdateRateMutationVariables>;
export const UpsertCustomerDiscountDocument = gql`
    mutation UpsertCustomerDiscount($customerDiscount: UpsertCustomerDiscountInput!) {
  upsertCustomerDiscount(customerDiscount: $customerDiscount) {
    errors {
      message
      code
    }
    rateSetId
    success
  }
}
    `;
export type UpsertCustomerDiscountMutationFn = Apollo.MutationFunction<UpsertCustomerDiscountMutation, UpsertCustomerDiscountMutationVariables>;

/**
 * __useUpsertCustomerDiscountMutation__
 *
 * To run a mutation, you first call `useUpsertCustomerDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCustomerDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCustomerDiscountMutation, { data, loading, error }] = useUpsertCustomerDiscountMutation({
 *   variables: {
 *      customerDiscount: // value for 'customerDiscount'
 *   },
 * });
 */
export function useUpsertCustomerDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCustomerDiscountMutation, UpsertCustomerDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCustomerDiscountMutation, UpsertCustomerDiscountMutationVariables>(UpsertCustomerDiscountDocument, options);
      }
export type UpsertCustomerDiscountMutationHookResult = ReturnType<typeof useUpsertCustomerDiscountMutation>;
export type UpsertCustomerDiscountMutationResult = Apollo.MutationResult<UpsertCustomerDiscountMutation>;
export type UpsertCustomerDiscountMutationOptions = Apollo.BaseMutationOptions<UpsertCustomerDiscountMutation, UpsertCustomerDiscountMutationVariables>;
export const UpsertClientDiscountDocument = gql`
    mutation UpsertClientDiscount($clientDiscountRate: UpsertClientDiscountInput!) {
  upsertClientDiscount(clientDiscountRate: $clientDiscountRate) {
    errors {
      code
      message
    }
    rateSetId
    success
  }
}
    `;
export type UpsertClientDiscountMutationFn = Apollo.MutationFunction<UpsertClientDiscountMutation, UpsertClientDiscountMutationVariables>;

/**
 * __useUpsertClientDiscountMutation__
 *
 * To run a mutation, you first call `useUpsertClientDiscountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertClientDiscountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertClientDiscountMutation, { data, loading, error }] = useUpsertClientDiscountMutation({
 *   variables: {
 *      clientDiscountRate: // value for 'clientDiscountRate'
 *   },
 * });
 */
export function useUpsertClientDiscountMutation(baseOptions?: Apollo.MutationHookOptions<UpsertClientDiscountMutation, UpsertClientDiscountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertClientDiscountMutation, UpsertClientDiscountMutationVariables>(UpsertClientDiscountDocument, options);
      }
export type UpsertClientDiscountMutationHookResult = ReturnType<typeof useUpsertClientDiscountMutation>;
export type UpsertClientDiscountMutationResult = Apollo.MutationResult<UpsertClientDiscountMutation>;
export type UpsertClientDiscountMutationOptions = Apollo.BaseMutationOptions<UpsertClientDiscountMutation, UpsertClientDiscountMutationVariables>;
export const GetRateTypesDocument = gql`
    query getRateTypes($accountId: UUID!) {
  rateTypes {
    all(accountId: $accountId) {
      items {
        id
        name
        description
        category
        favorite
      }
    }
  }
}
    `;

/**
 * __useGetRateTypesQuery__
 *
 * To run a query within a React component, call `useGetRateTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRateTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRateTypesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetRateTypesQuery(baseOptions: Apollo.QueryHookOptions<GetRateTypesQuery, GetRateTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRateTypesQuery, GetRateTypesQueryVariables>(GetRateTypesDocument, options);
      }
export function useGetRateTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRateTypesQuery, GetRateTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRateTypesQuery, GetRateTypesQueryVariables>(GetRateTypesDocument, options);
        }
export type GetRateTypesQueryHookResult = ReturnType<typeof useGetRateTypesQuery>;
export type GetRateTypesLazyQueryHookResult = ReturnType<typeof useGetRateTypesLazyQuery>;
export type GetRateTypesQueryResult = Apollo.QueryResult<GetRateTypesQuery, GetRateTypesQueryVariables>;
export const InsertRateTypeDocument = gql`
    mutation insertRateType($name: String!, $category: RateCategory!, $accountId: UUID!, $description: String!, $favorite: Boolean!) {
  insertRateType(
    rateType: {name: $name, category: $category, accountId: $accountId, description: $description, favorite: $favorite}
  ) {
    rateType {
      id
    }
  }
}
    `;
export type InsertRateTypeMutationFn = Apollo.MutationFunction<InsertRateTypeMutation, InsertRateTypeMutationVariables>;

/**
 * __useInsertRateTypeMutation__
 *
 * To run a mutation, you first call `useInsertRateTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertRateTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertRateTypeMutation, { data, loading, error }] = useInsertRateTypeMutation({
 *   variables: {
 *      name: // value for 'name'
 *      category: // value for 'category'
 *      accountId: // value for 'accountId'
 *      description: // value for 'description'
 *      favorite: // value for 'favorite'
 *   },
 * });
 */
export function useInsertRateTypeMutation(baseOptions?: Apollo.MutationHookOptions<InsertRateTypeMutation, InsertRateTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertRateTypeMutation, InsertRateTypeMutationVariables>(InsertRateTypeDocument, options);
      }
export type InsertRateTypeMutationHookResult = ReturnType<typeof useInsertRateTypeMutation>;
export type InsertRateTypeMutationResult = Apollo.MutationResult<InsertRateTypeMutation>;
export type InsertRateTypeMutationOptions = Apollo.BaseMutationOptions<InsertRateTypeMutation, InsertRateTypeMutationVariables>;
export const UpdateRateTypeDocument = gql`
    mutation updateRateType($id: UUID!, $name: String, $category: RateCategory, $description: String, $favorite: Boolean) {
  updateRateType(
    rateType: {id: $id, name: $name, category: $category, description: $description, favorite: $favorite}
  ) {
    rateType {
      id
    }
  }
}
    `;
export type UpdateRateTypeMutationFn = Apollo.MutationFunction<UpdateRateTypeMutation, UpdateRateTypeMutationVariables>;

/**
 * __useUpdateRateTypeMutation__
 *
 * To run a mutation, you first call `useUpdateRateTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRateTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRateTypeMutation, { data, loading, error }] = useUpdateRateTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      category: // value for 'category'
 *      description: // value for 'description'
 *      favorite: // value for 'favorite'
 *   },
 * });
 */
export function useUpdateRateTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRateTypeMutation, UpdateRateTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRateTypeMutation, UpdateRateTypeMutationVariables>(UpdateRateTypeDocument, options);
      }
export type UpdateRateTypeMutationHookResult = ReturnType<typeof useUpdateRateTypeMutation>;
export type UpdateRateTypeMutationResult = Apollo.MutationResult<UpdateRateTypeMutation>;
export type UpdateRateTypeMutationOptions = Apollo.BaseMutationOptions<UpdateRateTypeMutation, UpdateRateTypeMutationVariables>;
export const DeleteRateTypeDocument = gql`
    mutation deleteRateType($id: UUID!) {
  deleteRateType(rateType: {id: $id}) {
    success
  }
}
    `;
export type DeleteRateTypeMutationFn = Apollo.MutationFunction<DeleteRateTypeMutation, DeleteRateTypeMutationVariables>;

/**
 * __useDeleteRateTypeMutation__
 *
 * To run a mutation, you first call `useDeleteRateTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRateTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRateTypeMutation, { data, loading, error }] = useDeleteRateTypeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRateTypeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRateTypeMutation, DeleteRateTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRateTypeMutation, DeleteRateTypeMutationVariables>(DeleteRateTypeDocument, options);
      }
export type DeleteRateTypeMutationHookResult = ReturnType<typeof useDeleteRateTypeMutation>;
export type DeleteRateTypeMutationResult = Apollo.MutationResult<DeleteRateTypeMutation>;
export type DeleteRateTypeMutationOptions = Apollo.BaseMutationOptions<DeleteRateTypeMutation, DeleteRateTypeMutationVariables>;
export const DeleteRateSetDocument = gql`
    mutation deleteRateSet($id: UUID!) {
  deleteRateSet(rateSet: {id: $id}) {
    success
  }
}
    `;
export type DeleteRateSetMutationFn = Apollo.MutationFunction<DeleteRateSetMutation, DeleteRateSetMutationVariables>;

/**
 * __useDeleteRateSetMutation__
 *
 * To run a mutation, you first call `useDeleteRateSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRateSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRateSetMutation, { data, loading, error }] = useDeleteRateSetMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRateSetMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRateSetMutation, DeleteRateSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRateSetMutation, DeleteRateSetMutationVariables>(DeleteRateSetDocument, options);
      }
export type DeleteRateSetMutationHookResult = ReturnType<typeof useDeleteRateSetMutation>;
export type DeleteRateSetMutationResult = Apollo.MutationResult<DeleteRateSetMutation>;
export type DeleteRateSetMutationOptions = Apollo.BaseMutationOptions<DeleteRateSetMutation, DeleteRateSetMutationVariables>;
export const ExportAnalyticsCsvDocument = gql`
    mutation exportAnalyticsCSV($query: JSON!, $columnDictionary: JSON!) {
  exportAnalyticsCSV(query: $query, columnDictionary: $columnDictionary) {
    url
    success
    errors {
      code
      message
    }
  }
}
    `;
export type ExportAnalyticsCsvMutationFn = Apollo.MutationFunction<ExportAnalyticsCsvMutation, ExportAnalyticsCsvMutationVariables>;

/**
 * __useExportAnalyticsCsvMutation__
 *
 * To run a mutation, you first call `useExportAnalyticsCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAnalyticsCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAnalyticsCsvMutation, { data, loading, error }] = useExportAnalyticsCsvMutation({
 *   variables: {
 *      query: // value for 'query'
 *      columnDictionary: // value for 'columnDictionary'
 *   },
 * });
 */
export function useExportAnalyticsCsvMutation(baseOptions?: Apollo.MutationHookOptions<ExportAnalyticsCsvMutation, ExportAnalyticsCsvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportAnalyticsCsvMutation, ExportAnalyticsCsvMutationVariables>(ExportAnalyticsCsvDocument, options);
      }
export type ExportAnalyticsCsvMutationHookResult = ReturnType<typeof useExportAnalyticsCsvMutation>;
export type ExportAnalyticsCsvMutationResult = Apollo.MutationResult<ExportAnalyticsCsvMutation>;
export type ExportAnalyticsCsvMutationOptions = Apollo.BaseMutationOptions<ExportAnalyticsCsvMutation, ExportAnalyticsCsvMutationVariables>;
export const GetSquareAuthTokenLinkDocument = gql`
    query getSquareAuthTokenLink {
  square {
    getSquareAuthTokenLink {
      link
      state
    }
  }
}
    `;

/**
 * __useGetSquareAuthTokenLinkQuery__
 *
 * To run a query within a React component, call `useGetSquareAuthTokenLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSquareAuthTokenLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSquareAuthTokenLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSquareAuthTokenLinkQuery(baseOptions?: Apollo.QueryHookOptions<GetSquareAuthTokenLinkQuery, GetSquareAuthTokenLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSquareAuthTokenLinkQuery, GetSquareAuthTokenLinkQueryVariables>(GetSquareAuthTokenLinkDocument, options);
      }
export function useGetSquareAuthTokenLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSquareAuthTokenLinkQuery, GetSquareAuthTokenLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSquareAuthTokenLinkQuery, GetSquareAuthTokenLinkQueryVariables>(GetSquareAuthTokenLinkDocument, options);
        }
export type GetSquareAuthTokenLinkQueryHookResult = ReturnType<typeof useGetSquareAuthTokenLinkQuery>;
export type GetSquareAuthTokenLinkLazyQueryHookResult = ReturnType<typeof useGetSquareAuthTokenLinkLazyQuery>;
export type GetSquareAuthTokenLinkQueryResult = Apollo.QueryResult<GetSquareAuthTokenLinkQuery, GetSquareAuthTokenLinkQueryVariables>;
export const VerifySquareTokenDocument = gql`
    query verifySquareToken {
  square {
    verifySquareToken
  }
}
    `;

/**
 * __useVerifySquareTokenQuery__
 *
 * To run a query within a React component, call `useVerifySquareTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifySquareTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifySquareTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerifySquareTokenQuery(baseOptions?: Apollo.QueryHookOptions<VerifySquareTokenQuery, VerifySquareTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifySquareTokenQuery, VerifySquareTokenQueryVariables>(VerifySquareTokenDocument, options);
      }
export function useVerifySquareTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifySquareTokenQuery, VerifySquareTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifySquareTokenQuery, VerifySquareTokenQueryVariables>(VerifySquareTokenDocument, options);
        }
export type VerifySquareTokenQueryHookResult = ReturnType<typeof useVerifySquareTokenQuery>;
export type VerifySquareTokenLazyQueryHookResult = ReturnType<typeof useVerifySquareTokenLazyQuery>;
export type VerifySquareTokenQueryResult = Apollo.QueryResult<VerifySquareTokenQuery, VerifySquareTokenQueryVariables>;
export const StripeGetRefreshLinkDocument = gql`
    query stripeGetRefreshLink($accountId: UUID!) {
  stripe {
    getRefreshLink(accountId: $accountId) {
      link
    }
  }
}
    `;

/**
 * __useStripeGetRefreshLinkQuery__
 *
 * To run a query within a React component, call `useStripeGetRefreshLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeGetRefreshLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeGetRefreshLinkQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useStripeGetRefreshLinkQuery(baseOptions: Apollo.QueryHookOptions<StripeGetRefreshLinkQuery, StripeGetRefreshLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeGetRefreshLinkQuery, StripeGetRefreshLinkQueryVariables>(StripeGetRefreshLinkDocument, options);
      }
export function useStripeGetRefreshLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeGetRefreshLinkQuery, StripeGetRefreshLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeGetRefreshLinkQuery, StripeGetRefreshLinkQueryVariables>(StripeGetRefreshLinkDocument, options);
        }
export type StripeGetRefreshLinkQueryHookResult = ReturnType<typeof useStripeGetRefreshLinkQuery>;
export type StripeGetRefreshLinkLazyQueryHookResult = ReturnType<typeof useStripeGetRefreshLinkLazyQuery>;
export type StripeGetRefreshLinkQueryResult = Apollo.QueryResult<StripeGetRefreshLinkQuery, StripeGetRefreshLinkQueryVariables>;
export const StripeOnboardUserDocument = gql`
    mutation stripeOnboardUser($accountId: UUID!) {
  onboardUser(accountId: $accountId) {
    link
  }
}
    `;
export type StripeOnboardUserMutationFn = Apollo.MutationFunction<StripeOnboardUserMutation, StripeOnboardUserMutationVariables>;

/**
 * __useStripeOnboardUserMutation__
 *
 * To run a mutation, you first call `useStripeOnboardUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeOnboardUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeOnboardUserMutation, { data, loading, error }] = useStripeOnboardUserMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useStripeOnboardUserMutation(baseOptions?: Apollo.MutationHookOptions<StripeOnboardUserMutation, StripeOnboardUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeOnboardUserMutation, StripeOnboardUserMutationVariables>(StripeOnboardUserDocument, options);
      }
export type StripeOnboardUserMutationHookResult = ReturnType<typeof useStripeOnboardUserMutation>;
export type StripeOnboardUserMutationResult = Apollo.MutationResult<StripeOnboardUserMutation>;
export type StripeOnboardUserMutationOptions = Apollo.BaseMutationOptions<StripeOnboardUserMutation, StripeOnboardUserMutationVariables>;
export const StripeVerifyUserDocument = gql`
    mutation stripeVerifyUser($accountId: UUID!) {
  verifyUser(accountId: $accountId) {
    chargesEnabled
    detailsSubmitted
    onboardingStarted
    pendingVerification
  }
}
    `;
export type StripeVerifyUserMutationFn = Apollo.MutationFunction<StripeVerifyUserMutation, StripeVerifyUserMutationVariables>;

/**
 * __useStripeVerifyUserMutation__
 *
 * To run a mutation, you first call `useStripeVerifyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeVerifyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeVerifyUserMutation, { data, loading, error }] = useStripeVerifyUserMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useStripeVerifyUserMutation(baseOptions?: Apollo.MutationHookOptions<StripeVerifyUserMutation, StripeVerifyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeVerifyUserMutation, StripeVerifyUserMutationVariables>(StripeVerifyUserDocument, options);
      }
export type StripeVerifyUserMutationHookResult = ReturnType<typeof useStripeVerifyUserMutation>;
export type StripeVerifyUserMutationResult = Apollo.MutationResult<StripeVerifyUserMutation>;
export type StripeVerifyUserMutationOptions = Apollo.BaseMutationOptions<StripeVerifyUserMutation, StripeVerifyUserMutationVariables>;
export const StripeDisconnectUserDocument = gql`
    mutation stripeDisconnectUser($accountId: UUID!) {
  disconnectUser(accountId: $accountId) {
    chargesEnabled
    detailsSubmitted
    onboardingStarted
    pendingVerification
  }
}
    `;
export type StripeDisconnectUserMutationFn = Apollo.MutationFunction<StripeDisconnectUserMutation, StripeDisconnectUserMutationVariables>;

/**
 * __useStripeDisconnectUserMutation__
 *
 * To run a mutation, you first call `useStripeDisconnectUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStripeDisconnectUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stripeDisconnectUserMutation, { data, loading, error }] = useStripeDisconnectUserMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useStripeDisconnectUserMutation(baseOptions?: Apollo.MutationHookOptions<StripeDisconnectUserMutation, StripeDisconnectUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StripeDisconnectUserMutation, StripeDisconnectUserMutationVariables>(StripeDisconnectUserDocument, options);
      }
export type StripeDisconnectUserMutationHookResult = ReturnType<typeof useStripeDisconnectUserMutation>;
export type StripeDisconnectUserMutationResult = Apollo.MutationResult<StripeDisconnectUserMutation>;
export type StripeDisconnectUserMutationOptions = Apollo.BaseMutationOptions<StripeDisconnectUserMutation, StripeDisconnectUserMutationVariables>;
export const RevokeSquareTokenDocument = gql`
    mutation revokeSquareToken($accountId: UUID!) {
  revokeSquareToken(accountId: $accountId) {
    success
    errors {
      code
      message
    }
  }
}
    `;
export type RevokeSquareTokenMutationFn = Apollo.MutationFunction<RevokeSquareTokenMutation, RevokeSquareTokenMutationVariables>;

/**
 * __useRevokeSquareTokenMutation__
 *
 * To run a mutation, you first call `useRevokeSquareTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeSquareTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeSquareTokenMutation, { data, loading, error }] = useRevokeSquareTokenMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useRevokeSquareTokenMutation(baseOptions?: Apollo.MutationHookOptions<RevokeSquareTokenMutation, RevokeSquareTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeSquareTokenMutation, RevokeSquareTokenMutationVariables>(RevokeSquareTokenDocument, options);
      }
export type RevokeSquareTokenMutationHookResult = ReturnType<typeof useRevokeSquareTokenMutation>;
export type RevokeSquareTokenMutationResult = Apollo.MutationResult<RevokeSquareTokenMutation>;
export type RevokeSquareTokenMutationOptions = Apollo.BaseMutationOptions<RevokeSquareTokenMutation, RevokeSquareTokenMutationVariables>;
export const GetAccountAdjustmentsDocument = gql`
    query getAccountAdjustments($accountId: UUID!) {
  accountAdjustments {
    all(accountId: $accountId) {
      items {
        active
        id
        rateType {
          category
          name
        }
        note
        amount
        calculation
      }
    }
  }
}
    `;

/**
 * __useGetAccountAdjustmentsQuery__
 *
 * To run a query within a React component, call `useGetAccountAdjustmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountAdjustmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountAdjustmentsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAccountAdjustmentsQuery(baseOptions: Apollo.QueryHookOptions<GetAccountAdjustmentsQuery, GetAccountAdjustmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountAdjustmentsQuery, GetAccountAdjustmentsQueryVariables>(GetAccountAdjustmentsDocument, options);
      }
export function useGetAccountAdjustmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountAdjustmentsQuery, GetAccountAdjustmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountAdjustmentsQuery, GetAccountAdjustmentsQueryVariables>(GetAccountAdjustmentsDocument, options);
        }
export type GetAccountAdjustmentsQueryHookResult = ReturnType<typeof useGetAccountAdjustmentsQuery>;
export type GetAccountAdjustmentsLazyQueryHookResult = ReturnType<typeof useGetAccountAdjustmentsLazyQuery>;
export type GetAccountAdjustmentsQueryResult = Apollo.QueryResult<GetAccountAdjustmentsQuery, GetAccountAdjustmentsQueryVariables>;
export const UpdateAccountAdjustmentDocument = gql`
    mutation updateAccountAdjustment($accountAdjustment: UpdateAccountAdjustment!) {
  updateAccountAdjustment(accountAdjustment: $accountAdjustment) {
    accountAdjustment {
      id
      amount
      rateTypeId
      calculation
      active
    }
  }
}
    `;
export type UpdateAccountAdjustmentMutationFn = Apollo.MutationFunction<UpdateAccountAdjustmentMutation, UpdateAccountAdjustmentMutationVariables>;

/**
 * __useUpdateAccountAdjustmentMutation__
 *
 * To run a mutation, you first call `useUpdateAccountAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountAdjustmentMutation, { data, loading, error }] = useUpdateAccountAdjustmentMutation({
 *   variables: {
 *      accountAdjustment: // value for 'accountAdjustment'
 *   },
 * });
 */
export function useUpdateAccountAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountAdjustmentMutation, UpdateAccountAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountAdjustmentMutation, UpdateAccountAdjustmentMutationVariables>(UpdateAccountAdjustmentDocument, options);
      }
export type UpdateAccountAdjustmentMutationHookResult = ReturnType<typeof useUpdateAccountAdjustmentMutation>;
export type UpdateAccountAdjustmentMutationResult = Apollo.MutationResult<UpdateAccountAdjustmentMutation>;
export type UpdateAccountAdjustmentMutationOptions = Apollo.BaseMutationOptions<UpdateAccountAdjustmentMutation, UpdateAccountAdjustmentMutationVariables>;
export const GetDefaultNotificationPreferencesDocument = gql`
    query getDefaultNotificationPreferences($accountId: UUID!) {
  accountDefaultNotifications {
    all(accountId: $accountId, skip: 0, take: 1000) {
      items {
        id
        channels
        customerRole
        customerType
        tripNotificationTypeId
      }
    }
  }
}
    `;

/**
 * __useGetDefaultNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useGetDefaultNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultNotificationPreferencesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetDefaultNotificationPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetDefaultNotificationPreferencesQuery, GetDefaultNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultNotificationPreferencesQuery, GetDefaultNotificationPreferencesQueryVariables>(GetDefaultNotificationPreferencesDocument, options);
      }
export function useGetDefaultNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultNotificationPreferencesQuery, GetDefaultNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultNotificationPreferencesQuery, GetDefaultNotificationPreferencesQueryVariables>(GetDefaultNotificationPreferencesDocument, options);
        }
export type GetDefaultNotificationPreferencesQueryHookResult = ReturnType<typeof useGetDefaultNotificationPreferencesQuery>;
export type GetDefaultNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useGetDefaultNotificationPreferencesLazyQuery>;
export type GetDefaultNotificationPreferencesQueryResult = Apollo.QueryResult<GetDefaultNotificationPreferencesQuery, GetDefaultNotificationPreferencesQueryVariables>;
export const InsertAccountNotificationPreferencesDocument = gql`
    mutation insertAccountNotificationPreferences($accountDefaultNotifications: InsertAccountDefaultNotifications!) {
  insertAccountDefaultNotifications(
    accountDefaultNotifications: $accountDefaultNotifications
  ) {
    accountDefaultNotifications {
      id
    }
  }
}
    `;
export type InsertAccountNotificationPreferencesMutationFn = Apollo.MutationFunction<InsertAccountNotificationPreferencesMutation, InsertAccountNotificationPreferencesMutationVariables>;

/**
 * __useInsertAccountNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useInsertAccountNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAccountNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAccountNotificationPreferencesMutation, { data, loading, error }] = useInsertAccountNotificationPreferencesMutation({
 *   variables: {
 *      accountDefaultNotifications: // value for 'accountDefaultNotifications'
 *   },
 * });
 */
export function useInsertAccountNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<InsertAccountNotificationPreferencesMutation, InsertAccountNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAccountNotificationPreferencesMutation, InsertAccountNotificationPreferencesMutationVariables>(InsertAccountNotificationPreferencesDocument, options);
      }
export type InsertAccountNotificationPreferencesMutationHookResult = ReturnType<typeof useInsertAccountNotificationPreferencesMutation>;
export type InsertAccountNotificationPreferencesMutationResult = Apollo.MutationResult<InsertAccountNotificationPreferencesMutation>;
export type InsertAccountNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<InsertAccountNotificationPreferencesMutation, InsertAccountNotificationPreferencesMutationVariables>;
export const UpdateAccountNotificationPreferencesDocument = gql`
    mutation updateAccountNotificationPreferences($accountDefaultNotifications: UpdateAccountDefaultNotifications!) {
  updateAccountDefaultNotifications(
    accountDefaultNotifications: $accountDefaultNotifications
  ) {
    accountDefaultNotifications {
      id
    }
  }
}
    `;
export type UpdateAccountNotificationPreferencesMutationFn = Apollo.MutationFunction<UpdateAccountNotificationPreferencesMutation, UpdateAccountNotificationPreferencesMutationVariables>;

/**
 * __useUpdateAccountNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateAccountNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountNotificationPreferencesMutation, { data, loading, error }] = useUpdateAccountNotificationPreferencesMutation({
 *   variables: {
 *      accountDefaultNotifications: // value for 'accountDefaultNotifications'
 *   },
 * });
 */
export function useUpdateAccountNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountNotificationPreferencesMutation, UpdateAccountNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountNotificationPreferencesMutation, UpdateAccountNotificationPreferencesMutationVariables>(UpdateAccountNotificationPreferencesDocument, options);
      }
export type UpdateAccountNotificationPreferencesMutationHookResult = ReturnType<typeof useUpdateAccountNotificationPreferencesMutation>;
export type UpdateAccountNotificationPreferencesMutationResult = Apollo.MutationResult<UpdateAccountNotificationPreferencesMutation>;
export type UpdateAccountNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateAccountNotificationPreferencesMutation, UpdateAccountNotificationPreferencesMutationVariables>;
export const DeleteAccountNotificationPreferencesDocument = gql`
    mutation deleteAccountNotificationPreferences($notificationId: UUID!) {
  deleteAccountDefaultNotifications(
    accountDefaultNotifications: {id: $notificationId}
  ) {
    success
  }
}
    `;
export type DeleteAccountNotificationPreferencesMutationFn = Apollo.MutationFunction<DeleteAccountNotificationPreferencesMutation, DeleteAccountNotificationPreferencesMutationVariables>;

/**
 * __useDeleteAccountNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useDeleteAccountNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountNotificationPreferencesMutation, { data, loading, error }] = useDeleteAccountNotificationPreferencesMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useDeleteAccountNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAccountNotificationPreferencesMutation, DeleteAccountNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAccountNotificationPreferencesMutation, DeleteAccountNotificationPreferencesMutationVariables>(DeleteAccountNotificationPreferencesDocument, options);
      }
export type DeleteAccountNotificationPreferencesMutationHookResult = ReturnType<typeof useDeleteAccountNotificationPreferencesMutation>;
export type DeleteAccountNotificationPreferencesMutationResult = Apollo.MutationResult<DeleteAccountNotificationPreferencesMutation>;
export type DeleteAccountNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<DeleteAccountNotificationPreferencesMutation, DeleteAccountNotificationPreferencesMutationVariables>;
export const SubscriptionTiersByProductDocument = gql`
    query SubscriptionTiersByProduct($productType: ProductType!) {
  subscriptionTiersByProduct(productType: $productType) {
    id
    name
    description
    code
    type
    productType
    amount
    currency
    trialPeriodDays
  }
}
    `;

/**
 * __useSubscriptionTiersByProductQuery__
 *
 * To run a query within a React component, call `useSubscriptionTiersByProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionTiersByProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionTiersByProductQuery({
 *   variables: {
 *      productType: // value for 'productType'
 *   },
 * });
 */
export function useSubscriptionTiersByProductQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionTiersByProductQuery, SubscriptionTiersByProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionTiersByProductQuery, SubscriptionTiersByProductQueryVariables>(SubscriptionTiersByProductDocument, options);
      }
export function useSubscriptionTiersByProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionTiersByProductQuery, SubscriptionTiersByProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionTiersByProductQuery, SubscriptionTiersByProductQueryVariables>(SubscriptionTiersByProductDocument, options);
        }
export type SubscriptionTiersByProductQueryHookResult = ReturnType<typeof useSubscriptionTiersByProductQuery>;
export type SubscriptionTiersByProductLazyQueryHookResult = ReturnType<typeof useSubscriptionTiersByProductLazyQuery>;
export type SubscriptionTiersByProductQueryResult = Apollo.QueryResult<SubscriptionTiersByProductQuery, SubscriptionTiersByProductQueryVariables>;
export const SignedUrlDocument = gql`
    query signedUrl($bucket: String!, $files: [FileData!]!) {
  media {
    signedUrl(fileInfo: {bucket: $bucket, files: $files}) {
      url
      key
      metadata {
        type
      }
    }
  }
}
    `;

/**
 * __useSignedUrlQuery__
 *
 * To run a query within a React component, call `useSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignedUrlQuery({
 *   variables: {
 *      bucket: // value for 'bucket'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<SignedUrlQuery, SignedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SignedUrlQuery, SignedUrlQueryVariables>(SignedUrlDocument, options);
      }
export function useSignedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SignedUrlQuery, SignedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SignedUrlQuery, SignedUrlQueryVariables>(SignedUrlDocument, options);
        }
export type SignedUrlQueryHookResult = ReturnType<typeof useSignedUrlQuery>;
export type SignedUrlLazyQueryHookResult = ReturnType<typeof useSignedUrlLazyQuery>;
export type SignedUrlQueryResult = Apollo.QueryResult<SignedUrlQuery, SignedUrlQueryVariables>;
export const GetSignedUrlsDocument = gql`
    query getSignedUrls($bucket: String!, $key: String!) {
  media {
    filesFromPath(fileInfo: {bucket: $bucket, key: $key}) {
      signedUrls {
        url
        key
        metadata {
          type
        }
      }
    }
  }
}
    `;

/**
 * __useGetSignedUrlsQuery__
 *
 * To run a query within a React component, call `useGetSignedUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedUrlsQuery({
 *   variables: {
 *      bucket: // value for 'bucket'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useGetSignedUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetSignedUrlsQuery, GetSignedUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedUrlsQuery, GetSignedUrlsQueryVariables>(GetSignedUrlsDocument, options);
      }
export function useGetSignedUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedUrlsQuery, GetSignedUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedUrlsQuery, GetSignedUrlsQueryVariables>(GetSignedUrlsDocument, options);
        }
export type GetSignedUrlsQueryHookResult = ReturnType<typeof useGetSignedUrlsQuery>;
export type GetSignedUrlsLazyQueryHookResult = ReturnType<typeof useGetSignedUrlsLazyQuery>;
export type GetSignedUrlsQueryResult = Apollo.QueryResult<GetSignedUrlsQuery, GetSignedUrlsQueryVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($fileInfo: FilesLocation!) {
  deleteFile(fileInfo: $fileInfo) {
    errors {
      message
      code
    }
    success
  }
}
    `;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      fileInfo: // value for 'fileInfo'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const ResendEmailDocument = gql`
    mutation resendEmail {
  resendVerificationEmail {
    success
    error
  }
}
    `;
export type ResendEmailMutationFn = Apollo.MutationFunction<ResendEmailMutation, ResendEmailMutationVariables>;

/**
 * __useResendEmailMutation__
 *
 * To run a mutation, you first call `useResendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmailMutation, { data, loading, error }] = useResendEmailMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendEmailMutation, ResendEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEmailMutation, ResendEmailMutationVariables>(ResendEmailDocument, options);
      }
export type ResendEmailMutationHookResult = ReturnType<typeof useResendEmailMutation>;
export type ResendEmailMutationResult = Apollo.MutationResult<ResendEmailMutation>;
export type ResendEmailMutationOptions = Apollo.BaseMutationOptions<ResendEmailMutation, ResendEmailMutationVariables>;
export const GetPreictionsDocument = gql`
    query GetPreictions($predictionInput: PredictionInput!) {
  locations {
    getPredictions(predictionInput: $predictionInput) {
      placeName
      placeId
    }
  }
}
    `;

/**
 * __useGetPreictionsQuery__
 *
 * To run a query within a React component, call `useGetPreictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreictionsQuery({
 *   variables: {
 *      predictionInput: // value for 'predictionInput'
 *   },
 * });
 */
export function useGetPreictionsQuery(baseOptions: Apollo.QueryHookOptions<GetPreictionsQuery, GetPreictionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreictionsQuery, GetPreictionsQueryVariables>(GetPreictionsDocument, options);
      }
export function useGetPreictionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreictionsQuery, GetPreictionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreictionsQuery, GetPreictionsQueryVariables>(GetPreictionsDocument, options);
        }
export type GetPreictionsQueryHookResult = ReturnType<typeof useGetPreictionsQuery>;
export type GetPreictionsLazyQueryHookResult = ReturnType<typeof useGetPreictionsLazyQuery>;
export type GetPreictionsQueryResult = Apollo.QueryResult<GetPreictionsQuery, GetPreictionsQueryVariables>;
export const GetPlaceInfoDocument = gql`
    query GetPlaceInfo($placeId: String!) {
  locations {
    getPlaceInfo(placeId: $placeId) {
      address_components {
        long_name
        short_name
        types
      }
      formatted_address
      name
      geometry {
        location {
          lng
          lat
        }
        viewport {
          south
          west
          east
          north
        }
      }
      place_id
      types
    }
  }
}
    `;

/**
 * __useGetPlaceInfoQuery__
 *
 * To run a query within a React component, call `useGetPlaceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlaceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlaceInfoQuery({
 *   variables: {
 *      placeId: // value for 'placeId'
 *   },
 * });
 */
export function useGetPlaceInfoQuery(baseOptions: Apollo.QueryHookOptions<GetPlaceInfoQuery, GetPlaceInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlaceInfoQuery, GetPlaceInfoQueryVariables>(GetPlaceInfoDocument, options);
      }
export function useGetPlaceInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlaceInfoQuery, GetPlaceInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlaceInfoQuery, GetPlaceInfoQueryVariables>(GetPlaceInfoDocument, options);
        }
export type GetPlaceInfoQueryHookResult = ReturnType<typeof useGetPlaceInfoQuery>;
export type GetPlaceInfoLazyQueryHookResult = ReturnType<typeof useGetPlaceInfoLazyQuery>;
export type GetPlaceInfoQueryResult = Apollo.QueryResult<GetPlaceInfoQuery, GetPlaceInfoQueryVariables>;
export const GetMerchantDocument = gql`
    query GetMerchant {
  square {
    getSquareMerchant {
      mainLocationId
    }
  }
}
    `;

/**
 * __useGetMerchantQuery__
 *
 * To run a query within a React component, call `useGetMerchantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMerchantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMerchantQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMerchantQuery(baseOptions?: Apollo.QueryHookOptions<GetMerchantQuery, GetMerchantQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMerchantQuery, GetMerchantQueryVariables>(GetMerchantDocument, options);
      }
export function useGetMerchantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMerchantQuery, GetMerchantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMerchantQuery, GetMerchantQueryVariables>(GetMerchantDocument, options);
        }
export type GetMerchantQueryHookResult = ReturnType<typeof useGetMerchantQuery>;
export type GetMerchantLazyQueryHookResult = ReturnType<typeof useGetMerchantLazyQuery>;
export type GetMerchantQueryResult = Apollo.QueryResult<GetMerchantQuery, GetMerchantQueryVariables>;
export const CreateSquareCustomerDocument = gql`
    mutation CreateSquareCustomer($customerContactId: UUID!) {
  createSquareCustomer(customerContactId: $customerContactId) {
    success
    squareId
  }
}
    `;
export type CreateSquareCustomerMutationFn = Apollo.MutationFunction<CreateSquareCustomerMutation, CreateSquareCustomerMutationVariables>;

/**
 * __useCreateSquareCustomerMutation__
 *
 * To run a mutation, you first call `useCreateSquareCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSquareCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSquareCustomerMutation, { data, loading, error }] = useCreateSquareCustomerMutation({
 *   variables: {
 *      customerContactId: // value for 'customerContactId'
 *   },
 * });
 */
export function useCreateSquareCustomerMutation(baseOptions?: Apollo.MutationHookOptions<CreateSquareCustomerMutation, CreateSquareCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSquareCustomerMutation, CreateSquareCustomerMutationVariables>(CreateSquareCustomerDocument, options);
      }
export type CreateSquareCustomerMutationHookResult = ReturnType<typeof useCreateSquareCustomerMutation>;
export type CreateSquareCustomerMutationResult = Apollo.MutationResult<CreateSquareCustomerMutation>;
export type CreateSquareCustomerMutationOptions = Apollo.BaseMutationOptions<CreateSquareCustomerMutation, CreateSquareCustomerMutationVariables>;
export const CreateSquareCardDocument = gql`
    mutation CreateSquareCard($input: CreateSquareCardInput!) {
  createSquareCard(input: $input) {
    squareId
    success
    errors {
      code
      message
    }
  }
}
    `;
export type CreateSquareCardMutationFn = Apollo.MutationFunction<CreateSquareCardMutation, CreateSquareCardMutationVariables>;

/**
 * __useCreateSquareCardMutation__
 *
 * To run a mutation, you first call `useCreateSquareCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSquareCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSquareCardMutation, { data, loading, error }] = useCreateSquareCardMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSquareCardMutation(baseOptions?: Apollo.MutationHookOptions<CreateSquareCardMutation, CreateSquareCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSquareCardMutation, CreateSquareCardMutationVariables>(CreateSquareCardDocument, options);
      }
export type CreateSquareCardMutationHookResult = ReturnType<typeof useCreateSquareCardMutation>;
export type CreateSquareCardMutationResult = Apollo.MutationResult<CreateSquareCardMutation>;
export type CreateSquareCardMutationOptions = Apollo.BaseMutationOptions<CreateSquareCardMutation, CreateSquareCardMutationVariables>;
export const SearchSquareCustomersDocument = gql`
    query SearchSquareCustomers($referenceId: String) {
  square {
    searchSquareCustomers(referenceId: $referenceId) {
      id
      referenceId
      givenName
    }
  }
}
    `;

/**
 * __useSearchSquareCustomersQuery__
 *
 * To run a query within a React component, call `useSearchSquareCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSquareCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSquareCustomersQuery({
 *   variables: {
 *      referenceId: // value for 'referenceId'
 *   },
 * });
 */
export function useSearchSquareCustomersQuery(baseOptions?: Apollo.QueryHookOptions<SearchSquareCustomersQuery, SearchSquareCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSquareCustomersQuery, SearchSquareCustomersQueryVariables>(SearchSquareCustomersDocument, options);
      }
export function useSearchSquareCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSquareCustomersQuery, SearchSquareCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSquareCustomersQuery, SearchSquareCustomersQueryVariables>(SearchSquareCustomersDocument, options);
        }
export type SearchSquareCustomersQueryHookResult = ReturnType<typeof useSearchSquareCustomersQuery>;
export type SearchSquareCustomersLazyQueryHookResult = ReturnType<typeof useSearchSquareCustomersLazyQuery>;
export type SearchSquareCustomersQueryResult = Apollo.QueryResult<SearchSquareCustomersQuery, SearchSquareCustomersQueryVariables>;
export const ImportCustomerContactDocument = gql`
    mutation ImportCustomerContact($input: ImportContactsInput!) {
  importContacts(input: $input) {
    importDuplicates
    importErrors
    errors {
      code
      message
    }
    success
    totalImported
  }
}
    `;
export type ImportCustomerContactMutationFn = Apollo.MutationFunction<ImportCustomerContactMutation, ImportCustomerContactMutationVariables>;

/**
 * __useImportCustomerContactMutation__
 *
 * To run a mutation, you first call `useImportCustomerContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportCustomerContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importCustomerContactMutation, { data, loading, error }] = useImportCustomerContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportCustomerContactMutation(baseOptions?: Apollo.MutationHookOptions<ImportCustomerContactMutation, ImportCustomerContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportCustomerContactMutation, ImportCustomerContactMutationVariables>(ImportCustomerContactDocument, options);
      }
export type ImportCustomerContactMutationHookResult = ReturnType<typeof useImportCustomerContactMutation>;
export type ImportCustomerContactMutationResult = Apollo.MutationResult<ImportCustomerContactMutation>;
export type ImportCustomerContactMutationOptions = Apollo.BaseMutationOptions<ImportCustomerContactMutation, ImportCustomerContactMutationVariables>;
export const GetNewSetupIntentDocument = gql`
    mutation GetNewSetupIntent($accountId: UUID!) {
  subscriptionGetNewSetupIntent(accountId: $accountId)
}
    `;
export type GetNewSetupIntentMutationFn = Apollo.MutationFunction<GetNewSetupIntentMutation, GetNewSetupIntentMutationVariables>;

/**
 * __useGetNewSetupIntentMutation__
 *
 * To run a mutation, you first call `useGetNewSetupIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetNewSetupIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getNewSetupIntentMutation, { data, loading, error }] = useGetNewSetupIntentMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetNewSetupIntentMutation(baseOptions?: Apollo.MutationHookOptions<GetNewSetupIntentMutation, GetNewSetupIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetNewSetupIntentMutation, GetNewSetupIntentMutationVariables>(GetNewSetupIntentDocument, options);
      }
export type GetNewSetupIntentMutationHookResult = ReturnType<typeof useGetNewSetupIntentMutation>;
export type GetNewSetupIntentMutationResult = Apollo.MutationResult<GetNewSetupIntentMutation>;
export type GetNewSetupIntentMutationOptions = Apollo.BaseMutationOptions<GetNewSetupIntentMutation, GetNewSetupIntentMutationVariables>;
export const SubscriptionByAccountIdDocument = gql`
    query SubscriptionByAccountId {
  subscriptionByAccountId {
    id
    accountId
    externalId
    clientSecret
    productType
    tierId
    currentTier
    status
    inTrialPeriod
    renewalAt
    periodStartAt
    periodEndAt
    cancelled
    cancelledAt
    createdAt
    updatedAt
    paymentMethod {
      cardLastFour
      cardType
      country
      zipCode
    }
    tier {
      id
      name
      description
      code
      type
      productType
      amount
      currency
      trialPeriodDays
      addons {
        amount
        code
        currency
        id
        name
        freeQty
        type
      }
    }
    addonUsage {
      SHARED_TRIPS
    }
  }
}
    `;

/**
 * __useSubscriptionByAccountIdQuery__
 *
 * To run a query within a React component, call `useSubscriptionByAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionByAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionByAccountIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionByAccountIdQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionByAccountIdQuery, SubscriptionByAccountIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionByAccountIdQuery, SubscriptionByAccountIdQueryVariables>(SubscriptionByAccountIdDocument, options);
      }
export function useSubscriptionByAccountIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionByAccountIdQuery, SubscriptionByAccountIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionByAccountIdQuery, SubscriptionByAccountIdQueryVariables>(SubscriptionByAccountIdDocument, options);
        }
export type SubscriptionByAccountIdQueryHookResult = ReturnType<typeof useSubscriptionByAccountIdQuery>;
export type SubscriptionByAccountIdLazyQueryHookResult = ReturnType<typeof useSubscriptionByAccountIdLazyQuery>;
export type SubscriptionByAccountIdQueryResult = Apollo.QueryResult<SubscriptionByAccountIdQuery, SubscriptionByAccountIdQueryVariables>;
export const SubscriptionInvoicesByAccountIdDocument = gql`
    query SubscriptionInvoicesByAccountId($accountId: ID!, $skip: Int!, $take: Int!) {
  subscriptionInvoicesByAccountId(id: $accountId, skip: $skip, take: $take) {
    id
    description
    amount
    total
    currency
    discount
    invoiceNumber
    approved
    status
    dueAt
    pdfURL
    externalURL
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSubscriptionInvoicesByAccountIdQuery__
 *
 * To run a query within a React component, call `useSubscriptionInvoicesByAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionInvoicesByAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionInvoicesByAccountIdQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useSubscriptionInvoicesByAccountIdQuery(baseOptions: Apollo.QueryHookOptions<SubscriptionInvoicesByAccountIdQuery, SubscriptionInvoicesByAccountIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionInvoicesByAccountIdQuery, SubscriptionInvoicesByAccountIdQueryVariables>(SubscriptionInvoicesByAccountIdDocument, options);
      }
export function useSubscriptionInvoicesByAccountIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionInvoicesByAccountIdQuery, SubscriptionInvoicesByAccountIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionInvoicesByAccountIdQuery, SubscriptionInvoicesByAccountIdQueryVariables>(SubscriptionInvoicesByAccountIdDocument, options);
        }
export type SubscriptionInvoicesByAccountIdQueryHookResult = ReturnType<typeof useSubscriptionInvoicesByAccountIdQuery>;
export type SubscriptionInvoicesByAccountIdLazyQueryHookResult = ReturnType<typeof useSubscriptionInvoicesByAccountIdLazyQuery>;
export type SubscriptionInvoicesByAccountIdQueryResult = Apollo.QueryResult<SubscriptionInvoicesByAccountIdQuery, SubscriptionInvoicesByAccountIdQueryVariables>;
export const SubscriptionFindOrCreateDocument = gql`
    query SubscriptionFindOrCreate($accountName: String, $selectedTier: TierType) {
  subscriptionFindOrCreate(accountName: $accountName, selectedTier: $selectedTier) {
    id
    accountId
    externalId
    clientSecret
    productType
    tier {
      id
      name
      description
      code
      type
      productType
      amount
      currency
      trialPeriodDays
    }
    tierId
    currentTier
    inTrialPeriod
    renewalAt
    periodStartAt
    periodEndAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSubscriptionFindOrCreateQuery__
 *
 * To run a query within a React component, call `useSubscriptionFindOrCreateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionFindOrCreateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionFindOrCreateQuery({
 *   variables: {
 *      accountName: // value for 'accountName'
 *      selectedTier: // value for 'selectedTier'
 *   },
 * });
 */
export function useSubscriptionFindOrCreateQuery(baseOptions?: Apollo.QueryHookOptions<SubscriptionFindOrCreateQuery, SubscriptionFindOrCreateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionFindOrCreateQuery, SubscriptionFindOrCreateQueryVariables>(SubscriptionFindOrCreateDocument, options);
      }
export function useSubscriptionFindOrCreateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionFindOrCreateQuery, SubscriptionFindOrCreateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionFindOrCreateQuery, SubscriptionFindOrCreateQueryVariables>(SubscriptionFindOrCreateDocument, options);
        }
export type SubscriptionFindOrCreateQueryHookResult = ReturnType<typeof useSubscriptionFindOrCreateQuery>;
export type SubscriptionFindOrCreateLazyQueryHookResult = ReturnType<typeof useSubscriptionFindOrCreateLazyQuery>;
export type SubscriptionFindOrCreateQueryResult = Apollo.QueryResult<SubscriptionFindOrCreateQuery, SubscriptionFindOrCreateQueryVariables>;
export const CreateOrUpdateSubscriptionDocument = gql`
    mutation CreateOrUpdateSubscription($id: UUID, $accountId: UUID!, $selectedTier: TierType!, $paymentMethodId: String, $cancel: Boolean) {
  createOrUpdateSubscription(
    id: $id
    accountId: $accountId
    selectedTier: $selectedTier
    paymentMethodId: $paymentMethodId
    cancel: $cancel
  ) {
    id
    accountId
    productType
    tier {
      id
      name
      description
      code
      type
      productType
      amount
      currency
      trialPeriodDays
    }
    tierId
    currentTier
    inTrialPeriod
    renewalAt
    periodStartAt
    periodEndAt
    createdAt
    updatedAt
  }
}
    `;
export type CreateOrUpdateSubscriptionMutationFn = Apollo.MutationFunction<CreateOrUpdateSubscriptionMutation, CreateOrUpdateSubscriptionMutationVariables>;

/**
 * __useCreateOrUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateSubscriptionMutation, { data, loading, error }] = useCreateOrUpdateSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accountId: // value for 'accountId'
 *      selectedTier: // value for 'selectedTier'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      cancel: // value for 'cancel'
 *   },
 * });
 */
export function useCreateOrUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateSubscriptionMutation, CreateOrUpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateSubscriptionMutation, CreateOrUpdateSubscriptionMutationVariables>(CreateOrUpdateSubscriptionDocument, options);
      }
export type CreateOrUpdateSubscriptionMutationHookResult = ReturnType<typeof useCreateOrUpdateSubscriptionMutation>;
export type CreateOrUpdateSubscriptionMutationResult = Apollo.MutationResult<CreateOrUpdateSubscriptionMutation>;
export type CreateOrUpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateSubscriptionMutation, CreateOrUpdateSubscriptionMutationVariables>;
export const ReportAddonUsageDocument = gql`
    mutation ReportAddonUsage($subscriptionId: UUID, $accountId: UUID, $addonType: AddonType) {
  reportAddonUsage(
    subscriptionId: $subscriptionId
    accountId: $accountId
    addonType: $addonType
  )
}
    `;
export type ReportAddonUsageMutationFn = Apollo.MutationFunction<ReportAddonUsageMutation, ReportAddonUsageMutationVariables>;

/**
 * __useReportAddonUsageMutation__
 *
 * To run a mutation, you first call `useReportAddonUsageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportAddonUsageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportAddonUsageMutation, { data, loading, error }] = useReportAddonUsageMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *      accountId: // value for 'accountId'
 *      addonType: // value for 'addonType'
 *   },
 * });
 */
export function useReportAddonUsageMutation(baseOptions?: Apollo.MutationHookOptions<ReportAddonUsageMutation, ReportAddonUsageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReportAddonUsageMutation, ReportAddonUsageMutationVariables>(ReportAddonUsageDocument, options);
      }
export type ReportAddonUsageMutationHookResult = ReturnType<typeof useReportAddonUsageMutation>;
export type ReportAddonUsageMutationResult = Apollo.MutationResult<ReportAddonUsageMutation>;
export type ReportAddonUsageMutationOptions = Apollo.BaseMutationOptions<ReportAddonUsageMutation, ReportAddonUsageMutationVariables>;
export const GetFavoriteAccountsDocument = gql`
    query getFavoriteAccounts($criteria: FavoriteDriverSearchQueryCriteria) {
  favoriteDrivers {
    search(criteria: $criteria) {
      items {
        account {
          name
          id
          primaryPhoneNumber
          description
          legalName
        }
        id
      }
    }
  }
}
    `;

/**
 * __useGetFavoriteAccountsQuery__
 *
 * To run a query within a React component, call `useGetFavoriteAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoriteAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoriteAccountsQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useGetFavoriteAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetFavoriteAccountsQuery, GetFavoriteAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoriteAccountsQuery, GetFavoriteAccountsQueryVariables>(GetFavoriteAccountsDocument, options);
      }
export function useGetFavoriteAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoriteAccountsQuery, GetFavoriteAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoriteAccountsQuery, GetFavoriteAccountsQueryVariables>(GetFavoriteAccountsDocument, options);
        }
export type GetFavoriteAccountsQueryHookResult = ReturnType<typeof useGetFavoriteAccountsQuery>;
export type GetFavoriteAccountsLazyQueryHookResult = ReturnType<typeof useGetFavoriteAccountsLazyQuery>;
export type GetFavoriteAccountsQueryResult = Apollo.QueryResult<GetFavoriteAccountsQuery, GetFavoriteAccountsQueryVariables>;
export const GetFavoriteAccountDocument = gql`
    query getFavoriteAccount($id: UUID!) {
  favoriteDrivers {
    byId(id: $id) {
      account {
        name
        id
        primaryPhoneNumber
        description
        legalName
      }
      accountOwner {
        id
        name
      }
      id
    }
  }
}
    `;

/**
 * __useGetFavoriteAccountQuery__
 *
 * To run a query within a React component, call `useGetFavoriteAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFavoriteAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFavoriteAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetFavoriteAccountQuery(baseOptions: Apollo.QueryHookOptions<GetFavoriteAccountQuery, GetFavoriteAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFavoriteAccountQuery, GetFavoriteAccountQueryVariables>(GetFavoriteAccountDocument, options);
      }
export function useGetFavoriteAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFavoriteAccountQuery, GetFavoriteAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFavoriteAccountQuery, GetFavoriteAccountQueryVariables>(GetFavoriteAccountDocument, options);
        }
export type GetFavoriteAccountQueryHookResult = ReturnType<typeof useGetFavoriteAccountQuery>;
export type GetFavoriteAccountLazyQueryHookResult = ReturnType<typeof useGetFavoriteAccountLazyQuery>;
export type GetFavoriteAccountQueryResult = Apollo.QueryResult<GetFavoriteAccountQuery, GetFavoriteAccountQueryVariables>;
export const AddFavoriteAccountDocument = gql`
    mutation addFavoriteAccount($favoriteDriver: InsertFavoriteDriverInput!) {
  insertFavoriteDriver(favoriteDriver: $favoriteDriver) {
    favoriteDriver {
      id
    }
    errors {
      message
      code
    }
  }
}
    `;
export type AddFavoriteAccountMutationFn = Apollo.MutationFunction<AddFavoriteAccountMutation, AddFavoriteAccountMutationVariables>;

/**
 * __useAddFavoriteAccountMutation__
 *
 * To run a mutation, you first call `useAddFavoriteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFavoriteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFavoriteAccountMutation, { data, loading, error }] = useAddFavoriteAccountMutation({
 *   variables: {
 *      favoriteDriver: // value for 'favoriteDriver'
 *   },
 * });
 */
export function useAddFavoriteAccountMutation(baseOptions?: Apollo.MutationHookOptions<AddFavoriteAccountMutation, AddFavoriteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFavoriteAccountMutation, AddFavoriteAccountMutationVariables>(AddFavoriteAccountDocument, options);
      }
export type AddFavoriteAccountMutationHookResult = ReturnType<typeof useAddFavoriteAccountMutation>;
export type AddFavoriteAccountMutationResult = Apollo.MutationResult<AddFavoriteAccountMutation>;
export type AddFavoriteAccountMutationOptions = Apollo.BaseMutationOptions<AddFavoriteAccountMutation, AddFavoriteAccountMutationVariables>;
export const DeleteFavoriteAccountDocument = gql`
    mutation deleteFavoriteAccount($favoriteDriver: DeleteFavoriteDriverAccount!) {
  deleteFavoriteDriver(favoriteDriver: $favoriteDriver) {
    success
  }
}
    `;
export type DeleteFavoriteAccountMutationFn = Apollo.MutationFunction<DeleteFavoriteAccountMutation, DeleteFavoriteAccountMutationVariables>;

/**
 * __useDeleteFavoriteAccountMutation__
 *
 * To run a mutation, you first call `useDeleteFavoriteAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFavoriteAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFavoriteAccountMutation, { data, loading, error }] = useDeleteFavoriteAccountMutation({
 *   variables: {
 *      favoriteDriver: // value for 'favoriteDriver'
 *   },
 * });
 */
export function useDeleteFavoriteAccountMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFavoriteAccountMutation, DeleteFavoriteAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFavoriteAccountMutation, DeleteFavoriteAccountMutationVariables>(DeleteFavoriteAccountDocument, options);
      }
export type DeleteFavoriteAccountMutationHookResult = ReturnType<typeof useDeleteFavoriteAccountMutation>;
export type DeleteFavoriteAccountMutationResult = Apollo.MutationResult<DeleteFavoriteAccountMutation>;
export type DeleteFavoriteAccountMutationOptions = Apollo.BaseMutationOptions<DeleteFavoriteAccountMutation, DeleteFavoriteAccountMutationVariables>;
export const InviteNetworkAssociateDocument = gql`
    mutation inviteNetworkAssociate($name: String!, $email: String!, $message: String) {
  inviteNetworkAssociate(name: $name, email: $email, message: $message) {
    invitation {
      id
      accountId
      status
      toName
      toEmail
      sentAt
      resentAt
      expiresAt
      resolvedAt
      token
      message
    }
    response
    errors {
      message
      code
    }
  }
}
    `;
export type InviteNetworkAssociateMutationFn = Apollo.MutationFunction<InviteNetworkAssociateMutation, InviteNetworkAssociateMutationVariables>;

/**
 * __useInviteNetworkAssociateMutation__
 *
 * To run a mutation, you first call `useInviteNetworkAssociateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteNetworkAssociateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteNetworkAssociateMutation, { data, loading, error }] = useInviteNetworkAssociateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      email: // value for 'email'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useInviteNetworkAssociateMutation(baseOptions?: Apollo.MutationHookOptions<InviteNetworkAssociateMutation, InviteNetworkAssociateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteNetworkAssociateMutation, InviteNetworkAssociateMutationVariables>(InviteNetworkAssociateDocument, options);
      }
export type InviteNetworkAssociateMutationHookResult = ReturnType<typeof useInviteNetworkAssociateMutation>;
export type InviteNetworkAssociateMutationResult = Apollo.MutationResult<InviteNetworkAssociateMutation>;
export type InviteNetworkAssociateMutationOptions = Apollo.BaseMutationOptions<InviteNetworkAssociateMutation, InviteNetworkAssociateMutationVariables>;
export const RevokeNetworkInvitationDocument = gql`
    mutation revokeNetworkInvitation($invitationToken: String!) {
  revokeNetworkInvitation(invitationToken: $invitationToken) {
    response
    errors {
      message
      code
    }
  }
}
    `;
export type RevokeNetworkInvitationMutationFn = Apollo.MutationFunction<RevokeNetworkInvitationMutation, RevokeNetworkInvitationMutationVariables>;

/**
 * __useRevokeNetworkInvitationMutation__
 *
 * To run a mutation, you first call `useRevokeNetworkInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeNetworkInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeNetworkInvitationMutation, { data, loading, error }] = useRevokeNetworkInvitationMutation({
 *   variables: {
 *      invitationToken: // value for 'invitationToken'
 *   },
 * });
 */
export function useRevokeNetworkInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RevokeNetworkInvitationMutation, RevokeNetworkInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeNetworkInvitationMutation, RevokeNetworkInvitationMutationVariables>(RevokeNetworkInvitationDocument, options);
      }
export type RevokeNetworkInvitationMutationHookResult = ReturnType<typeof useRevokeNetworkInvitationMutation>;
export type RevokeNetworkInvitationMutationResult = Apollo.MutationResult<RevokeNetworkInvitationMutation>;
export type RevokeNetworkInvitationMutationOptions = Apollo.BaseMutationOptions<RevokeNetworkInvitationMutation, RevokeNetworkInvitationMutationVariables>;
export const GetAllNetworkInvitationsDocument = gql`
    query getAllNetworkInvitations($accountId: UUID!, $criteria: NetworkInvitationCriteria, $skip: Int, $take: Int) {
  networkInvitations {
    all(accountId: $accountId, criteria: $criteria, skip: $skip, take: $take) {
      items {
        id
        accountId
        status
        toName
        toEmail
        sentAt
        resentAt
        expiresAt
        resolvedAt
        token
        message
      }
      total
    }
  }
}
    `;

/**
 * __useGetAllNetworkInvitationsQuery__
 *
 * To run a query within a React component, call `useGetAllNetworkInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNetworkInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNetworkInvitationsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      criteria: // value for 'criteria'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAllNetworkInvitationsQuery(baseOptions: Apollo.QueryHookOptions<GetAllNetworkInvitationsQuery, GetAllNetworkInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNetworkInvitationsQuery, GetAllNetworkInvitationsQueryVariables>(GetAllNetworkInvitationsDocument, options);
      }
export function useGetAllNetworkInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNetworkInvitationsQuery, GetAllNetworkInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNetworkInvitationsQuery, GetAllNetworkInvitationsQueryVariables>(GetAllNetworkInvitationsDocument, options);
        }
export type GetAllNetworkInvitationsQueryHookResult = ReturnType<typeof useGetAllNetworkInvitationsQuery>;
export type GetAllNetworkInvitationsLazyQueryHookResult = ReturnType<typeof useGetAllNetworkInvitationsLazyQuery>;
export type GetAllNetworkInvitationsQueryResult = Apollo.QueryResult<GetAllNetworkInvitationsQuery, GetAllNetworkInvitationsQueryVariables>;
export const GetAllNetworkRelationshipsDocument = gql`
    query getAllNetworkRelationships($accountId: UUID!, $criteria: NetworkRelationshipCriteria, $skip: Int, $take: Int) {
  networkRelationships {
    all(accountId: $accountId, criteria: $criteria, skip: $skip, take: $take) {
      items {
        id
        accountId
        account {
          name
          legalName
          accountOwner {
            name
            email
          }
          garages {
            id
            location {
              addressLine1
              addressLine2
              coordinates
              city
              state
              postalCode
            }
          }
        }
        toAccountId
        toAccount {
          name
          legalName
          accountOwner {
            name
            email
          }
          garages {
            id
            location {
              addressLine1
              addressLine2
              coordinates
              city
              state
              postalCode
            }
          }
        }
        isReciprocal
        invitationId
      }
      total
    }
  }
}
    `;

/**
 * __useGetAllNetworkRelationshipsQuery__
 *
 * To run a query within a React component, call `useGetAllNetworkRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNetworkRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNetworkRelationshipsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      criteria: // value for 'criteria'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAllNetworkRelationshipsQuery(baseOptions: Apollo.QueryHookOptions<GetAllNetworkRelationshipsQuery, GetAllNetworkRelationshipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNetworkRelationshipsQuery, GetAllNetworkRelationshipsQueryVariables>(GetAllNetworkRelationshipsDocument, options);
      }
export function useGetAllNetworkRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNetworkRelationshipsQuery, GetAllNetworkRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNetworkRelationshipsQuery, GetAllNetworkRelationshipsQueryVariables>(GetAllNetworkRelationshipsDocument, options);
        }
export type GetAllNetworkRelationshipsQueryHookResult = ReturnType<typeof useGetAllNetworkRelationshipsQuery>;
export type GetAllNetworkRelationshipsLazyQueryHookResult = ReturnType<typeof useGetAllNetworkRelationshipsLazyQuery>;
export type GetAllNetworkRelationshipsQueryResult = Apollo.QueryResult<GetAllNetworkRelationshipsQuery, GetAllNetworkRelationshipsQueryVariables>;
export const PublicDetailsDocument = gql`
    query publicDetails($sharedTripToken: String!) {
  sharedTrips {
    publicDetails(sharedTripToken: $sharedTripToken) {
      status
      amount
      paymentMethodType
      message
      tripOwner {
        name
        email
        phoneNumber
      }
      company
      originalTripStatus
      originalTripNumber
      passengerCount
      preferredVehicleClass
      originalTripId
      pickupTime
      distanceInMiles
      origin {
        location {
          name
        }
      }
      destination {
        location {
          name
        }
      }
      receivedAt
      expiresAt
    }
  }
}
    `;

/**
 * __usePublicDetailsQuery__
 *
 * To run a query within a React component, call `usePublicDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicDetailsQuery({
 *   variables: {
 *      sharedTripToken: // value for 'sharedTripToken'
 *   },
 * });
 */
export function usePublicDetailsQuery(baseOptions: Apollo.QueryHookOptions<PublicDetailsQuery, PublicDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicDetailsQuery, PublicDetailsQueryVariables>(PublicDetailsDocument, options);
      }
export function usePublicDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicDetailsQuery, PublicDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicDetailsQuery, PublicDetailsQueryVariables>(PublicDetailsDocument, options);
        }
export type PublicDetailsQueryHookResult = ReturnType<typeof usePublicDetailsQuery>;
export type PublicDetailsLazyQueryHookResult = ReturnType<typeof usePublicDetailsLazyQuery>;
export type PublicDetailsQueryResult = Apollo.QueryResult<PublicDetailsQuery, PublicDetailsQueryVariables>;
export const CreateSharedTripDocument = gql`
    mutation createSharedTrip($paymentMethodType: PaymentMethodType!, $amount: Float!, $tripId: UUID!) {
  createSharedTrip(
    paymentMethodType: $paymentMethodType
    tripId: $tripId
    amount: $amount
  ) {
    errors {
      message
    }
    response
    sharedTrip {
      id
      status
      contact {
        id
        name
      }
      amount
      paymentMethodType
      token
      sentAt
      tripId
    }
  }
}
    `;
export type CreateSharedTripMutationFn = Apollo.MutationFunction<CreateSharedTripMutation, CreateSharedTripMutationVariables>;

/**
 * __useCreateSharedTripMutation__
 *
 * To run a mutation, you first call `useCreateSharedTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSharedTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSharedTripMutation, { data, loading, error }] = useCreateSharedTripMutation({
 *   variables: {
 *      paymentMethodType: // value for 'paymentMethodType'
 *      amount: // value for 'amount'
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useCreateSharedTripMutation(baseOptions?: Apollo.MutationHookOptions<CreateSharedTripMutation, CreateSharedTripMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSharedTripMutation, CreateSharedTripMutationVariables>(CreateSharedTripDocument, options);
      }
export type CreateSharedTripMutationHookResult = ReturnType<typeof useCreateSharedTripMutation>;
export type CreateSharedTripMutationResult = Apollo.MutationResult<CreateSharedTripMutation>;
export type CreateSharedTripMutationOptions = Apollo.BaseMutationOptions<CreateSharedTripMutation, CreateSharedTripMutationVariables>;
export const GetSharedTripByOriginalTripIdDocument = gql`
    query getSharedTripByOriginalTripId($tripId: UUID!) {
  sharedTrips {
    byOriginalTrip(tripId: $tripId) {
      id
      status
      amount
      contact {
        id
        name
      }
      token
      sentAt
      expiresAt
      trip {
        pickupTime
        pickupWaypoint {
          location {
            name
          }
        }
        dropoffWaypoint {
          location {
            name
          }
        }
        preferredVehicleClass {
          systemClassId
        }
        isShared
      }
    }
  }
}
    `;

/**
 * __useGetSharedTripByOriginalTripIdQuery__
 *
 * To run a query within a React component, call `useGetSharedTripByOriginalTripIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedTripByOriginalTripIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedTripByOriginalTripIdQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useGetSharedTripByOriginalTripIdQuery(baseOptions: Apollo.QueryHookOptions<GetSharedTripByOriginalTripIdQuery, GetSharedTripByOriginalTripIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedTripByOriginalTripIdQuery, GetSharedTripByOriginalTripIdQueryVariables>(GetSharedTripByOriginalTripIdDocument, options);
      }
export function useGetSharedTripByOriginalTripIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedTripByOriginalTripIdQuery, GetSharedTripByOriginalTripIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedTripByOriginalTripIdQuery, GetSharedTripByOriginalTripIdQueryVariables>(GetSharedTripByOriginalTripIdDocument, options);
        }
export type GetSharedTripByOriginalTripIdQueryHookResult = ReturnType<typeof useGetSharedTripByOriginalTripIdQuery>;
export type GetSharedTripByOriginalTripIdLazyQueryHookResult = ReturnType<typeof useGetSharedTripByOriginalTripIdLazyQuery>;
export type GetSharedTripByOriginalTripIdQueryResult = Apollo.QueryResult<GetSharedTripByOriginalTripIdQuery, GetSharedTripByOriginalTripIdQueryVariables>;
export const GetAllReceivedTripsDocument = gql`
    query getAllReceivedTrips($accountId: UUID!) {
  sharedTrips {
    all(accountId: $accountId) {
      items {
        id
        status
        savoyaAssignmentStatus
        savoyaAvailableTrip
        savoyaQuotedTime
        amount
        contact {
          id
          name
        }
        token
        sentAt
        expiresAt
        tripId
        trip {
          id
          accountId
          tripNumber
          status
          passengerCount
          estimatedDurationInMinutes
          pickupTime
          pickupWaypoint {
            estimatedArrivalTime
            estimatedDepartureTime
            location {
              name
            }
          }
          dropoffWaypoint {
            estimatedArrivalTime
            estimatedDepartureTime
            location {
              name
            }
          }
          waypoints {
            id
            role
            order
            airline {
              IATA
              name
            }
            airlineId
            fbo {
              id
              iata_code
              fbo_name
            }
            fboId
            iataCode
            flightNumber
            verifiedFlight
            flightTime
            location {
              name
              addressLine1
              addressLine2
              city
              state
              postalCode
              coordinates
              placeCategory
              placeFoursquareId
              placeWikidataId
              placeType
            }
            estimatedDurationInMinutes
            estimatedDepartureTime
            estimatedArrivalTime
            order
          }
          isShared
          providerSource
          providerExternalId
        }
      }
      total
      refetchAfter
    }
  }
}
    `;

/**
 * __useGetAllReceivedTripsQuery__
 *
 * To run a query within a React component, call `useGetAllReceivedTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllReceivedTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllReceivedTripsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetAllReceivedTripsQuery(baseOptions: Apollo.QueryHookOptions<GetAllReceivedTripsQuery, GetAllReceivedTripsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllReceivedTripsQuery, GetAllReceivedTripsQueryVariables>(GetAllReceivedTripsDocument, options);
      }
export function useGetAllReceivedTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllReceivedTripsQuery, GetAllReceivedTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllReceivedTripsQuery, GetAllReceivedTripsQueryVariables>(GetAllReceivedTripsDocument, options);
        }
export type GetAllReceivedTripsQueryHookResult = ReturnType<typeof useGetAllReceivedTripsQuery>;
export type GetAllReceivedTripsLazyQueryHookResult = ReturnType<typeof useGetAllReceivedTripsLazyQuery>;
export type GetAllReceivedTripsQueryResult = Apollo.QueryResult<GetAllReceivedTripsQuery, GetAllReceivedTripsQueryVariables>;
export const GetSavoyaAvailableTripsDocument = gql`
    query getSavoyaAvailableTrips {
  sharedTrips {
    getSavoyaAvailableTrips {
      items {
        id
        status
        savoyaAssignmentStatus
        savoyaAvailableTrip
        savoyaQuotedTime
        amount
        contact {
          id
          name
          email
          phoneNumber
        }
        token
        sentAt
        expiresAt
        tripId
        vendorExternalId
        paymentMethodType
        trip {
          id
          currentOrNextWaypoint {
            id
            role
          }
          isShared
          providerSource
          passengerCount
          luggageCount
          paymentMethodId
          paymentMethodType
          estimatedSpotTimeInMinutes
          wasBookedByPassenger
          accountId
          pickupTime
          estimatedDurationInMinutes
          estimatedRevenue
          status
          tripNumber
          customerId
          stagingNotes
          preferredVehicleClass {
            name
          }
          notes {
            id
            content
          }
          driver {
            accountId
            drivingSince
            id
            isActive
            name
            imageUrl
          }
          vehicle {
            id
            makeName
            modelName
            name
            vin
            year
            licenseNumber
            color
          }
          estimatedDurationInMinutes
          estimatedDistanceInMiles
          estimatedOnLocationTime
          estimatedAvailabilityTime
          pickupWaypoint {
            savoyaStop
            role
            location {
              coordinates
              name
              addressLine1
              addressLine2
              city
              state
              postalCode
              placeCategory
            }
            airline {
              IATA
              name
            }
            fbo {
              iata_code
              fbo_name
            }
            flightNumber
            departureTime
            arrivalTime
            estimatedDepartureTime
            estimatedArrivalTime
            savoyaStop
          }
          dropoffWaypoint {
            savoyaStop
            role
            location {
              coordinates
              name
              addressLine1
              addressLine2
              city
              state
              postalCode
              placeCategory
            }
            airline {
              IATA
              name
            }
            fbo {
              iata_code
              fbo_name
            }
            flightNumber
            departureTime
            arrivalTime
            estimatedDepartureTime
            estimatedArrivalTime
            savoyaStop
          }
          waypoints {
            id
            role
            order
            location {
              name
              addressLine1
              addressLine2
              coordinates
              city
              state
              postalCode
            }
            estimatedDurationInMinutes
            savoyaStop
          }
          invoice {
            id
            status
            type
            total
            lineItems {
              id
              name
              unitPrice
              quantity
              total
            }
            transactions {
              id
              type
              status
              paymentMethodType
              note
              amount
              reversalOfTransactionId
              accountId
              invoiceId
              refundedAmount
            }
            payments
            balance
            externalId
            invoiceProcessor
            externalInvoiceLink
          }
          segments {
            startWaypointId
            endWaypointId
            estimatedDistanceInMiles
            estimatedDurationInMinutes
            durationInMinutes
            distanceInMiles
            order
          }
          isDirected
          estimatedDurationInMinutesOverride
          overrideDropoffWaypointDetails
          referenceNumber
          providerExternalId
          availableCommands {
            typeName
            name
            isPrimary
            disabled
            description
            events
            hidden
          }
          sharedAvailableCommands {
            typeName
            name
            isPrimary
            disabled
            description
            events
            hidden
          }
        }
      }
      total
      refetchAfter
    }
  }
}
    `;

/**
 * __useGetSavoyaAvailableTripsQuery__
 *
 * To run a query within a React component, call `useGetSavoyaAvailableTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavoyaAvailableTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavoyaAvailableTripsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSavoyaAvailableTripsQuery(baseOptions?: Apollo.QueryHookOptions<GetSavoyaAvailableTripsQuery, GetSavoyaAvailableTripsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavoyaAvailableTripsQuery, GetSavoyaAvailableTripsQueryVariables>(GetSavoyaAvailableTripsDocument, options);
      }
export function useGetSavoyaAvailableTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavoyaAvailableTripsQuery, GetSavoyaAvailableTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavoyaAvailableTripsQuery, GetSavoyaAvailableTripsQueryVariables>(GetSavoyaAvailableTripsDocument, options);
        }
export type GetSavoyaAvailableTripsQueryHookResult = ReturnType<typeof useGetSavoyaAvailableTripsQuery>;
export type GetSavoyaAvailableTripsLazyQueryHookResult = ReturnType<typeof useGetSavoyaAvailableTripsLazyQuery>;
export type GetSavoyaAvailableTripsQueryResult = Apollo.QueryResult<GetSavoyaAvailableTripsQuery, GetSavoyaAvailableTripsQueryVariables>;
export const GetSharedTripByTokenDocument = gql`
    query getSharedTripByToken($sharedTripToken: UUID!) {
  sharedTrips {
    byToken(sharedTripToken: $sharedTripToken) {
      id
      status
      amount
      message
      paymentMethodType
      contact {
        id
        name
      }
      token
      sentAt
      expiresAt
      trip {
        status
        tripNumber
        id
        pickupTime
        estimatedDistanceInMiles
        passengerCount
        account {
          accountOwner {
            name
            email
            phoneNumber
          }
          name
        }
        pickupWaypoint {
          location {
            name
          }
        }
        dropoffWaypoint {
          location {
            name
          }
        }
        vehicle {
          id
          accountId
          vehicleClassId
          vehicleClass {
            id
            accountId
            systemClassId
            passengerCount
            luggageCount
            name
            hourlyRate
            isActive
            cancellationPolicyHours
            minimumHours
          }
          licenseNumber
          vin
          year
          modelName
          makeName
          isActive
          color
          middleSeatType
        }
        driver {
          id
          name
        }
        preferredVehicleClass {
          id
          name
          systemClassId
        }
        confirmationEmailStatus
        providerSource
        providerExternalId
        groundworkTrip
      }
    }
  }
}
    `;

/**
 * __useGetSharedTripByTokenQuery__
 *
 * To run a query within a React component, call `useGetSharedTripByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSharedTripByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSharedTripByTokenQuery({
 *   variables: {
 *      sharedTripToken: // value for 'sharedTripToken'
 *   },
 * });
 */
export function useGetSharedTripByTokenQuery(baseOptions: Apollo.QueryHookOptions<GetSharedTripByTokenQuery, GetSharedTripByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSharedTripByTokenQuery, GetSharedTripByTokenQueryVariables>(GetSharedTripByTokenDocument, options);
      }
export function useGetSharedTripByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSharedTripByTokenQuery, GetSharedTripByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSharedTripByTokenQuery, GetSharedTripByTokenQueryVariables>(GetSharedTripByTokenDocument, options);
        }
export type GetSharedTripByTokenQueryHookResult = ReturnType<typeof useGetSharedTripByTokenQuery>;
export type GetSharedTripByTokenLazyQueryHookResult = ReturnType<typeof useGetSharedTripByTokenLazyQuery>;
export type GetSharedTripByTokenQueryResult = Apollo.QueryResult<GetSharedTripByTokenQuery, GetSharedTripByTokenQueryVariables>;
export const GetNetworkAccountsDocument = gql`
    query getNetworkAccounts($tripId: UUID!, $query: String!, $range: Int, $systemClassId: String, $includeFavorites: Boolean) {
  accounts {
    searchByTrip(
      tripId: $tripId
      query: $query
      range: $range
      systemClassId: $systemClassId
      includeFavorites: $includeFavorites
    ) {
      total
      items {
        id
        name
        logoUrl
        isFavorite
        garages {
          location {
            city
            state
          }
          vehicles {
            modelId
            vehicleClass {
              systemClassId
            }
          }
        }
        accountOwner {
          id
          name
          email
          phoneNumber
        }
      }
    }
  }
}
    `;

/**
 * __useGetNetworkAccountsQuery__
 *
 * To run a query within a React component, call `useGetNetworkAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetworkAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetworkAccountsQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      query: // value for 'query'
 *      range: // value for 'range'
 *      systemClassId: // value for 'systemClassId'
 *      includeFavorites: // value for 'includeFavorites'
 *   },
 * });
 */
export function useGetNetworkAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetNetworkAccountsQuery, GetNetworkAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNetworkAccountsQuery, GetNetworkAccountsQueryVariables>(GetNetworkAccountsDocument, options);
      }
export function useGetNetworkAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNetworkAccountsQuery, GetNetworkAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNetworkAccountsQuery, GetNetworkAccountsQueryVariables>(GetNetworkAccountsDocument, options);
        }
export type GetNetworkAccountsQueryHookResult = ReturnType<typeof useGetNetworkAccountsQuery>;
export type GetNetworkAccountsLazyQueryHookResult = ReturnType<typeof useGetNetworkAccountsLazyQuery>;
export type GetNetworkAccountsQueryResult = Apollo.QueryResult<GetNetworkAccountsQuery, GetNetworkAccountsQueryVariables>;
export const ShareTripWithContactDocument = gql`
    mutation shareTripWithContact($contactId: String!, $token: String!) {
  shareTripWithContact(contactId: $contactId, token: $token) {
    sharedTrip {
      id
      status
      trip {
        id
        status
      }
      contactId
      contact {
        name
      }
    }
    response
    errors {
      message
    }
  }
}
    `;
export type ShareTripWithContactMutationFn = Apollo.MutationFunction<ShareTripWithContactMutation, ShareTripWithContactMutationVariables>;

/**
 * __useShareTripWithContactMutation__
 *
 * To run a mutation, you first call `useShareTripWithContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareTripWithContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareTripWithContactMutation, { data, loading, error }] = useShareTripWithContactMutation({
 *   variables: {
 *      contactId: // value for 'contactId'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useShareTripWithContactMutation(baseOptions?: Apollo.MutationHookOptions<ShareTripWithContactMutation, ShareTripWithContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShareTripWithContactMutation, ShareTripWithContactMutationVariables>(ShareTripWithContactDocument, options);
      }
export type ShareTripWithContactMutationHookResult = ReturnType<typeof useShareTripWithContactMutation>;
export type ShareTripWithContactMutationResult = Apollo.MutationResult<ShareTripWithContactMutation>;
export type ShareTripWithContactMutationOptions = Apollo.BaseMutationOptions<ShareTripWithContactMutation, ShareTripWithContactMutationVariables>;
export const MutateSharedTripStatusDocument = gql`
    mutation mutateSharedTripStatus($sharedTripId: UUID!) {
  mutateSharedTripStatus(sharedTripId: $sharedTripId) {
    response
    sharedTrip {
      id
      status
      contact {
        id
        name
      }
      amount
      paymentMethodType
      token
      sentAt
      tripId
    }
  }
}
    `;
export type MutateSharedTripStatusMutationFn = Apollo.MutationFunction<MutateSharedTripStatusMutation, MutateSharedTripStatusMutationVariables>;

/**
 * __useMutateSharedTripStatusMutation__
 *
 * To run a mutation, you first call `useMutateSharedTripStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateSharedTripStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateSharedTripStatusMutation, { data, loading, error }] = useMutateSharedTripStatusMutation({
 *   variables: {
 *      sharedTripId: // value for 'sharedTripId'
 *   },
 * });
 */
export function useMutateSharedTripStatusMutation(baseOptions?: Apollo.MutationHookOptions<MutateSharedTripStatusMutation, MutateSharedTripStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateSharedTripStatusMutation, MutateSharedTripStatusMutationVariables>(MutateSharedTripStatusDocument, options);
      }
export type MutateSharedTripStatusMutationHookResult = ReturnType<typeof useMutateSharedTripStatusMutation>;
export type MutateSharedTripStatusMutationResult = Apollo.MutationResult<MutateSharedTripStatusMutation>;
export type MutateSharedTripStatusMutationOptions = Apollo.BaseMutationOptions<MutateSharedTripStatusMutation, MutateSharedTripStatusMutationVariables>;
export const GetActiveTodosDocument = gql`
    query getActiveTodos($accountId: UUID!) {
  todos {
    active(accountId: $accountId) {
      items {
        title
        body
        expirationDate
        id
        actionUrl
        status
        dueDate
        infoText
        accountId
        type
        entityType
        entityId
        specId
      }
      total
    }
  }
}
    `;

/**
 * __useGetActiveTodosQuery__
 *
 * To run a query within a React component, call `useGetActiveTodosQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveTodosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveTodosQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetActiveTodosQuery(baseOptions: Apollo.QueryHookOptions<GetActiveTodosQuery, GetActiveTodosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveTodosQuery, GetActiveTodosQueryVariables>(GetActiveTodosDocument, options);
      }
export function useGetActiveTodosLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveTodosQuery, GetActiveTodosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveTodosQuery, GetActiveTodosQueryVariables>(GetActiveTodosDocument, options);
        }
export type GetActiveTodosQueryHookResult = ReturnType<typeof useGetActiveTodosQuery>;
export type GetActiveTodosLazyQueryHookResult = ReturnType<typeof useGetActiveTodosLazyQuery>;
export type GetActiveTodosQueryResult = Apollo.QueryResult<GetActiveTodosQuery, GetActiveTodosQueryVariables>;
export const GetTripExpensesDocument = gql`
    query getTripExpenses($tripId: UUID!) {
  rates {
    forTrip(tripId: $tripId) {
      tripId
      total
      baseGroup {
        rates {
          rate {
            name
            amount
          }
          addon {
            total
            note
            rateType {
              name
            }
          }
          quantity
          unitPrice
          total
          ratePolicy {
            type
          }
        }
      }
      subtotalGroup {
        rates {
          rate {
            name
            amount
          }
          addon {
            total
            note
            rateType {
              name
            }
          }
          quantity
          unitPrice
          total
        }
      }
      totalGroup {
        rates {
          rate {
            name
            amount
          }
          addon {
            total
            note
            rateType {
              name
            }
          }
          quantity
          unitPrice
          total
        }
      }
    }
  }
}
    `;

/**
 * __useGetTripExpensesQuery__
 *
 * To run a query within a React component, call `useGetTripExpensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTripExpensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTripExpensesQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useGetTripExpensesQuery(baseOptions: Apollo.QueryHookOptions<GetTripExpensesQuery, GetTripExpensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTripExpensesQuery, GetTripExpensesQueryVariables>(GetTripExpensesDocument, options);
      }
export function useGetTripExpensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTripExpensesQuery, GetTripExpensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTripExpensesQuery, GetTripExpensesQueryVariables>(GetTripExpensesDocument, options);
        }
export type GetTripExpensesQueryHookResult = ReturnType<typeof useGetTripExpensesQuery>;
export type GetTripExpensesLazyQueryHookResult = ReturnType<typeof useGetTripExpensesLazyQuery>;
export type GetTripExpensesQueryResult = Apollo.QueryResult<GetTripExpensesQuery, GetTripExpensesQueryVariables>;
export const SearchByContactNameAndAccountIdDocument = gql`
    query searchByContactNameAndAccountId($query: String!, $accountId: UUID!, $skip: Int, $take: Int) {
  customerContacts {
    searchByContactNameAndAccountId(
      query: $query
      accountId: $accountId
      skip: $skip
      take: $take
    ) {
      items {
        id
        customerId
        primaryRole
        contact {
          id
          name
          email
          phoneNumber
        }
        customer {
          id
          name
          type
        }
      }
    }
  }
}
    `;

/**
 * __useSearchByContactNameAndAccountIdQuery__
 *
 * To run a query within a React component, call `useSearchByContactNameAndAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchByContactNameAndAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchByContactNameAndAccountIdQuery({
 *   variables: {
 *      query: // value for 'query'
 *      accountId: // value for 'accountId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useSearchByContactNameAndAccountIdQuery(baseOptions: Apollo.QueryHookOptions<SearchByContactNameAndAccountIdQuery, SearchByContactNameAndAccountIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchByContactNameAndAccountIdQuery, SearchByContactNameAndAccountIdQueryVariables>(SearchByContactNameAndAccountIdDocument, options);
      }
export function useSearchByContactNameAndAccountIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchByContactNameAndAccountIdQuery, SearchByContactNameAndAccountIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchByContactNameAndAccountIdQuery, SearchByContactNameAndAccountIdQueryVariables>(SearchByContactNameAndAccountIdDocument, options);
        }
export type SearchByContactNameAndAccountIdQueryHookResult = ReturnType<typeof useSearchByContactNameAndAccountIdQuery>;
export type SearchByContactNameAndAccountIdLazyQueryHookResult = ReturnType<typeof useSearchByContactNameAndAccountIdLazyQuery>;
export type SearchByContactNameAndAccountIdQueryResult = Apollo.QueryResult<SearchByContactNameAndAccountIdQuery, SearchByContactNameAndAccountIdQueryVariables>;
export const SearchByContactEmailAndAccountIdDocument = gql`
    query searchByContactEmailAndAccountId($query: String!, $accountId: UUID!, $skip: Int, $take: Int) {
  customerContacts {
    searchByContactEmailAndAccountId(
      query: $query
      accountId: $accountId
      skip: $skip
      take: $take
    ) {
      items {
        id
        customerId
        contact {
          id
          name
          email
          phoneNumber
        }
        customer {
          id
          name
          type
        }
      }
    }
  }
}
    `;

/**
 * __useSearchByContactEmailAndAccountIdQuery__
 *
 * To run a query within a React component, call `useSearchByContactEmailAndAccountIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchByContactEmailAndAccountIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchByContactEmailAndAccountIdQuery({
 *   variables: {
 *      query: // value for 'query'
 *      accountId: // value for 'accountId'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useSearchByContactEmailAndAccountIdQuery(baseOptions: Apollo.QueryHookOptions<SearchByContactEmailAndAccountIdQuery, SearchByContactEmailAndAccountIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchByContactEmailAndAccountIdQuery, SearchByContactEmailAndAccountIdQueryVariables>(SearchByContactEmailAndAccountIdDocument, options);
      }
export function useSearchByContactEmailAndAccountIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchByContactEmailAndAccountIdQuery, SearchByContactEmailAndAccountIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchByContactEmailAndAccountIdQuery, SearchByContactEmailAndAccountIdQueryVariables>(SearchByContactEmailAndAccountIdDocument, options);
        }
export type SearchByContactEmailAndAccountIdQueryHookResult = ReturnType<typeof useSearchByContactEmailAndAccountIdQuery>;
export type SearchByContactEmailAndAccountIdLazyQueryHookResult = ReturnType<typeof useSearchByContactEmailAndAccountIdLazyQuery>;
export type SearchByContactEmailAndAccountIdQueryResult = Apollo.QueryResult<SearchByContactEmailAndAccountIdQuery, SearchByContactEmailAndAccountIdQueryVariables>;
export const QuerySearchByEmailAndAccountDocument = gql`
    query QuerySearchByEmailAndAccount($email: String!, $accountId: UUID!, $includeInactive: Boolean) {
  contacts {
    byEmailAndAccount(
      email: $email
      accountId: $accountId
      includeInactive: $includeInactive
    ) {
      email
      phoneNumber
      id
      name
      isActive
    }
  }
}
    `;

/**
 * __useQuerySearchByEmailAndAccountQuery__
 *
 * To run a query within a React component, call `useQuerySearchByEmailAndAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuerySearchByEmailAndAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuerySearchByEmailAndAccountQuery({
 *   variables: {
 *      email: // value for 'email'
 *      accountId: // value for 'accountId'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useQuerySearchByEmailAndAccountQuery(baseOptions: Apollo.QueryHookOptions<QuerySearchByEmailAndAccountQuery, QuerySearchByEmailAndAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuerySearchByEmailAndAccountQuery, QuerySearchByEmailAndAccountQueryVariables>(QuerySearchByEmailAndAccountDocument, options);
      }
export function useQuerySearchByEmailAndAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuerySearchByEmailAndAccountQuery, QuerySearchByEmailAndAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuerySearchByEmailAndAccountQuery, QuerySearchByEmailAndAccountQueryVariables>(QuerySearchByEmailAndAccountDocument, options);
        }
export type QuerySearchByEmailAndAccountQueryHookResult = ReturnType<typeof useQuerySearchByEmailAndAccountQuery>;
export type QuerySearchByEmailAndAccountLazyQueryHookResult = ReturnType<typeof useQuerySearchByEmailAndAccountLazyQuery>;
export type QuerySearchByEmailAndAccountQueryResult = Apollo.QueryResult<QuerySearchByEmailAndAccountQuery, QuerySearchByEmailAndAccountQueryVariables>;
export const DeleteTripByIdDocument = gql`
    mutation DeleteTripById($id: UUID!) {
  deleteTrip(trip: {id: $id}) {
    success
  }
}
    `;
export type DeleteTripByIdMutationFn = Apollo.MutationFunction<DeleteTripByIdMutation, DeleteTripByIdMutationVariables>;

/**
 * __useDeleteTripByIdMutation__
 *
 * To run a mutation, you first call `useDeleteTripByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTripByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTripByIdMutation, { data, loading, error }] = useDeleteTripByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTripByIdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTripByIdMutation, DeleteTripByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTripByIdMutation, DeleteTripByIdMutationVariables>(DeleteTripByIdDocument, options);
      }
export type DeleteTripByIdMutationHookResult = ReturnType<typeof useDeleteTripByIdMutation>;
export type DeleteTripByIdMutationResult = Apollo.MutationResult<DeleteTripByIdMutation>;
export type DeleteTripByIdMutationOptions = Apollo.BaseMutationOptions<DeleteTripByIdMutation, DeleteTripByIdMutationVariables>;
export const DeleteTripContactDocument = gql`
    mutation deleteTripContact($id: UUID!) {
  deleteTripContact(tripContact: {id: $id}) {
    success
    errors {
      message
      code
    }
  }
}
    `;
export type DeleteTripContactMutationFn = Apollo.MutationFunction<DeleteTripContactMutation, DeleteTripContactMutationVariables>;

/**
 * __useDeleteTripContactMutation__
 *
 * To run a mutation, you first call `useDeleteTripContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTripContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTripContactMutation, { data, loading, error }] = useDeleteTripContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTripContactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTripContactMutation, DeleteTripContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTripContactMutation, DeleteTripContactMutationVariables>(DeleteTripContactDocument, options);
      }
export type DeleteTripContactMutationHookResult = ReturnType<typeof useDeleteTripContactMutation>;
export type DeleteTripContactMutationResult = Apollo.MutationResult<DeleteTripContactMutation>;
export type DeleteTripContactMutationOptions = Apollo.BaseMutationOptions<DeleteTripContactMutation, DeleteTripContactMutationVariables>;
export const UpdateTripContactDocument = gql`
    mutation updateTripContact($tripContact: UpdateTripContact!) {
  updateTripContact(tripContact: $tripContact) {
    tripContact {
      email
      name
      phoneNumber
      id
      notificationSubscriptions {
        id
        notificationTypeId
        tripContactId
        channels
      }
    }
    success
    errors {
      message
      code
    }
  }
}
    `;
export type UpdateTripContactMutationFn = Apollo.MutationFunction<UpdateTripContactMutation, UpdateTripContactMutationVariables>;

/**
 * __useUpdateTripContactMutation__
 *
 * To run a mutation, you first call `useUpdateTripContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTripContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTripContactMutation, { data, loading, error }] = useUpdateTripContactMutation({
 *   variables: {
 *      tripContact: // value for 'tripContact'
 *   },
 * });
 */
export function useUpdateTripContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTripContactMutation, UpdateTripContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTripContactMutation, UpdateTripContactMutationVariables>(UpdateTripContactDocument, options);
      }
export type UpdateTripContactMutationHookResult = ReturnType<typeof useUpdateTripContactMutation>;
export type UpdateTripContactMutationResult = Apollo.MutationResult<UpdateTripContactMutation>;
export type UpdateTripContactMutationOptions = Apollo.BaseMutationOptions<UpdateTripContactMutation, UpdateTripContactMutationVariables>;
export const InsertTripContactDocument = gql`
    mutation insertTripContact($tripContact: InsertTripContact!) {
  insertTripContact(tripContact: $tripContact) {
    success
    errors {
      message
      code
    }
    tripContact {
      id
      customerContactId
    }
  }
}
    `;
export type InsertTripContactMutationFn = Apollo.MutationFunction<InsertTripContactMutation, InsertTripContactMutationVariables>;

/**
 * __useInsertTripContactMutation__
 *
 * To run a mutation, you first call `useInsertTripContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertTripContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertTripContactMutation, { data, loading, error }] = useInsertTripContactMutation({
 *   variables: {
 *      tripContact: // value for 'tripContact'
 *   },
 * });
 */
export function useInsertTripContactMutation(baseOptions?: Apollo.MutationHookOptions<InsertTripContactMutation, InsertTripContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertTripContactMutation, InsertTripContactMutationVariables>(InsertTripContactDocument, options);
      }
export type InsertTripContactMutationHookResult = ReturnType<typeof useInsertTripContactMutation>;
export type InsertTripContactMutationResult = Apollo.MutationResult<InsertTripContactMutation>;
export type InsertTripContactMutationOptions = Apollo.BaseMutationOptions<InsertTripContactMutation, InsertTripContactMutationVariables>;
export const UpdateTripNotificationSubscriptionByTripClientDocument = gql`
    mutation UpdateTripNotificationSubscriptionByTripClient($tripNotificationSubscriptions: [UpdateTripNotificationSubscriptionByTripClientId!]!, $tripClientId: UUID!) {
  updateTripNotificationSubscriptionByTripClient(
    tripNotificationSubscriptions: $tripNotificationSubscriptions
    tripClientId: $tripClientId
  ) {
    success
    notificationSubscriptions {
      channels
      id
      notificationType {
        id
        trigger
        order
        version
        enabled
      }
      notificationTypeId
      tripContactId
      version
    }
  }
}
    `;
export type UpdateTripNotificationSubscriptionByTripClientMutationFn = Apollo.MutationFunction<UpdateTripNotificationSubscriptionByTripClientMutation, UpdateTripNotificationSubscriptionByTripClientMutationVariables>;

/**
 * __useUpdateTripNotificationSubscriptionByTripClientMutation__
 *
 * To run a mutation, you first call `useUpdateTripNotificationSubscriptionByTripClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTripNotificationSubscriptionByTripClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTripNotificationSubscriptionByTripClientMutation, { data, loading, error }] = useUpdateTripNotificationSubscriptionByTripClientMutation({
 *   variables: {
 *      tripNotificationSubscriptions: // value for 'tripNotificationSubscriptions'
 *      tripClientId: // value for 'tripClientId'
 *   },
 * });
 */
export function useUpdateTripNotificationSubscriptionByTripClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTripNotificationSubscriptionByTripClientMutation, UpdateTripNotificationSubscriptionByTripClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTripNotificationSubscriptionByTripClientMutation, UpdateTripNotificationSubscriptionByTripClientMutationVariables>(UpdateTripNotificationSubscriptionByTripClientDocument, options);
      }
export type UpdateTripNotificationSubscriptionByTripClientMutationHookResult = ReturnType<typeof useUpdateTripNotificationSubscriptionByTripClientMutation>;
export type UpdateTripNotificationSubscriptionByTripClientMutationResult = Apollo.MutationResult<UpdateTripNotificationSubscriptionByTripClientMutation>;
export type UpdateTripNotificationSubscriptionByTripClientMutationOptions = Apollo.BaseMutationOptions<UpdateTripNotificationSubscriptionByTripClientMutation, UpdateTripNotificationSubscriptionByTripClientMutationVariables>;
export const DepartPickupDocument = gql`
    mutation departPickup($tripId: UUID!) {
  executeDepartPickup(command: {tripId: $tripId}) {
    trip {
      pickupWaypoint {
        id
        tripId
        role
        order
        locationId
        airlineId
        flightType
        flightNumber
        estimatedArrivalTime
        arrivalTime
        estimatedDepartureTime
        departureTime
        estimatedDurationInMinutes
        durationInMinutes
        savoyaStop
      }
    }
    succeeded
    errors
  }
}
    `;
export type DepartPickupMutationFn = Apollo.MutationFunction<DepartPickupMutation, DepartPickupMutationVariables>;

/**
 * __useDepartPickupMutation__
 *
 * To run a mutation, you first call `useDepartPickupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepartPickupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [departPickupMutation, { data, loading, error }] = useDepartPickupMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useDepartPickupMutation(baseOptions?: Apollo.MutationHookOptions<DepartPickupMutation, DepartPickupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DepartPickupMutation, DepartPickupMutationVariables>(DepartPickupDocument, options);
      }
export type DepartPickupMutationHookResult = ReturnType<typeof useDepartPickupMutation>;
export type DepartPickupMutationResult = Apollo.MutationResult<DepartPickupMutation>;
export type DepartPickupMutationOptions = Apollo.BaseMutationOptions<DepartPickupMutation, DepartPickupMutationVariables>;
export const InvoiceSubmittedDocument = gql`
    mutation invoiceSubmitted($tripId: UUID!, $sendToBooker: Boolean) {
  executeInvoiceSubmitted(command: {tripId: $tripId, sendToBooker: $sendToBooker}) {
    succeeded
    errors
  }
}
    `;
export type InvoiceSubmittedMutationFn = Apollo.MutationFunction<InvoiceSubmittedMutation, InvoiceSubmittedMutationVariables>;

/**
 * __useInvoiceSubmittedMutation__
 *
 * To run a mutation, you first call `useInvoiceSubmittedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceSubmittedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceSubmittedMutation, { data, loading, error }] = useInvoiceSubmittedMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      sendToBooker: // value for 'sendToBooker'
 *   },
 * });
 */
export function useInvoiceSubmittedMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceSubmittedMutation, InvoiceSubmittedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoiceSubmittedMutation, InvoiceSubmittedMutationVariables>(InvoiceSubmittedDocument, options);
      }
export type InvoiceSubmittedMutationHookResult = ReturnType<typeof useInvoiceSubmittedMutation>;
export type InvoiceSubmittedMutationResult = Apollo.MutationResult<InvoiceSubmittedMutation>;
export type InvoiceSubmittedMutationOptions = Apollo.BaseMutationOptions<InvoiceSubmittedMutation, InvoiceSubmittedMutationVariables>;
export const InvoicePaidDocument = gql`
    mutation invoicePaid($tripId: UUID!) {
  executeInvoicePaid(command: {tripId: $tripId}) {
    succeeded
    errors
  }
}
    `;
export type InvoicePaidMutationFn = Apollo.MutationFunction<InvoicePaidMutation, InvoicePaidMutationVariables>;

/**
 * __useInvoicePaidMutation__
 *
 * To run a mutation, you first call `useInvoicePaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoicePaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoicePaidMutation, { data, loading, error }] = useInvoicePaidMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useInvoicePaidMutation(baseOptions?: Apollo.MutationHookOptions<InvoicePaidMutation, InvoicePaidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvoicePaidMutation, InvoicePaidMutationVariables>(InvoicePaidDocument, options);
      }
export type InvoicePaidMutationHookResult = ReturnType<typeof useInvoicePaidMutation>;
export type InvoicePaidMutationResult = Apollo.MutationResult<InvoicePaidMutation>;
export type InvoicePaidMutationOptions = Apollo.BaseMutationOptions<InvoicePaidMutation, InvoicePaidMutationVariables>;
export const ArriveGarageDocument = gql`
    mutation arriveGarage($tripId: UUID!) {
  executeArriveGarage(command: {tripId: $tripId}) {
    succeeded
    errors
  }
}
    `;
export type ArriveGarageMutationFn = Apollo.MutationFunction<ArriveGarageMutation, ArriveGarageMutationVariables>;

/**
 * __useArriveGarageMutation__
 *
 * To run a mutation, you first call `useArriveGarageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArriveGarageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arriveGarageMutation, { data, loading, error }] = useArriveGarageMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useArriveGarageMutation(baseOptions?: Apollo.MutationHookOptions<ArriveGarageMutation, ArriveGarageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArriveGarageMutation, ArriveGarageMutationVariables>(ArriveGarageDocument, options);
      }
export type ArriveGarageMutationHookResult = ReturnType<typeof useArriveGarageMutation>;
export type ArriveGarageMutationResult = Apollo.MutationResult<ArriveGarageMutation>;
export type ArriveGarageMutationOptions = Apollo.BaseMutationOptions<ArriveGarageMutation, ArriveGarageMutationVariables>;
export const DepartStopDocument = gql`
    mutation departStop($tripId: UUID!) {
  executeDepartStop(command: {tripId: $tripId}) {
    trip {
      currentOrNextWaypoint {
        id
        tripId
        role
        order
        locationId
        airlineId
        flightType
        flightNumber
        estimatedArrivalTime
        arrivalTime
        estimatedDepartureTime
        departureTime
        estimatedDurationInMinutes
        durationInMinutes
      }
    }
    succeeded
    errors
  }
}
    `;
export type DepartStopMutationFn = Apollo.MutationFunction<DepartStopMutation, DepartStopMutationVariables>;

/**
 * __useDepartStopMutation__
 *
 * To run a mutation, you first call `useDepartStopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDepartStopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [departStopMutation, { data, loading, error }] = useDepartStopMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useDepartStopMutation(baseOptions?: Apollo.MutationHookOptions<DepartStopMutation, DepartStopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DepartStopMutation, DepartStopMutationVariables>(DepartStopDocument, options);
      }
export type DepartStopMutationHookResult = ReturnType<typeof useDepartStopMutation>;
export type DepartStopMutationResult = Apollo.MutationResult<DepartStopMutation>;
export type DepartStopMutationOptions = Apollo.BaseMutationOptions<DepartStopMutation, DepartStopMutationVariables>;
export const ArriveDropoffDocument = gql`
    mutation arriveDropoff($tripId: UUID!) {
  executeArriveDropoff(command: {tripId: $tripId}) {
    trip {
      dropoffWaypoint {
        id
        tripId
        role
        order
        locationId
        airlineId
        flightType
        flightNumber
        estimatedArrivalTime
        arrivalTime
        estimatedDepartureTime
        departureTime
        estimatedDurationInMinutes
        durationInMinutes
      }
    }
    succeeded
    errors
  }
}
    `;
export type ArriveDropoffMutationFn = Apollo.MutationFunction<ArriveDropoffMutation, ArriveDropoffMutationVariables>;

/**
 * __useArriveDropoffMutation__
 *
 * To run a mutation, you first call `useArriveDropoffMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArriveDropoffMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arriveDropoffMutation, { data, loading, error }] = useArriveDropoffMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useArriveDropoffMutation(baseOptions?: Apollo.MutationHookOptions<ArriveDropoffMutation, ArriveDropoffMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArriveDropoffMutation, ArriveDropoffMutationVariables>(ArriveDropoffDocument, options);
      }
export type ArriveDropoffMutationHookResult = ReturnType<typeof useArriveDropoffMutation>;
export type ArriveDropoffMutationResult = Apollo.MutationResult<ArriveDropoffMutation>;
export type ArriveDropoffMutationOptions = Apollo.BaseMutationOptions<ArriveDropoffMutation, ArriveDropoffMutationVariables>;
export const ExpireQuoteDocument = gql`
    mutation expireQuote($tripId: UUID!) {
  executeExpireQuote(command: {tripId: $tripId}) {
    succeeded
    errors
  }
}
    `;
export type ExpireQuoteMutationFn = Apollo.MutationFunction<ExpireQuoteMutation, ExpireQuoteMutationVariables>;

/**
 * __useExpireQuoteMutation__
 *
 * To run a mutation, you first call `useExpireQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExpireQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [expireQuoteMutation, { data, loading, error }] = useExpireQuoteMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useExpireQuoteMutation(baseOptions?: Apollo.MutationHookOptions<ExpireQuoteMutation, ExpireQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExpireQuoteMutation, ExpireQuoteMutationVariables>(ExpireQuoteDocument, options);
      }
export type ExpireQuoteMutationHookResult = ReturnType<typeof useExpireQuoteMutation>;
export type ExpireQuoteMutationResult = Apollo.MutationResult<ExpireQuoteMutation>;
export type ExpireQuoteMutationOptions = Apollo.BaseMutationOptions<ExpireQuoteMutation, ExpireQuoteMutationVariables>;
export const ArriveStopDocument = gql`
    mutation arriveStop($tripId: UUID!) {
  executeArriveStop(command: {tripId: $tripId}) {
    trip {
      currentOrNextWaypoint {
        id
        tripId
        role
        order
        locationId
        airlineId
        flightType
        flightNumber
        estimatedArrivalTime
        arrivalTime
        estimatedDepartureTime
        departureTime
        estimatedDurationInMinutes
        durationInMinutes
      }
    }
    succeeded
    errors
  }
}
    `;
export type ArriveStopMutationFn = Apollo.MutationFunction<ArriveStopMutation, ArriveStopMutationVariables>;

/**
 * __useArriveStopMutation__
 *
 * To run a mutation, you first call `useArriveStopMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArriveStopMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arriveStopMutation, { data, loading, error }] = useArriveStopMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useArriveStopMutation(baseOptions?: Apollo.MutationHookOptions<ArriveStopMutation, ArriveStopMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArriveStopMutation, ArriveStopMutationVariables>(ArriveStopDocument, options);
      }
export type ArriveStopMutationHookResult = ReturnType<typeof useArriveStopMutation>;
export type ArriveStopMutationResult = Apollo.MutationResult<ArriveStopMutation>;
export type ArriveStopMutationOptions = Apollo.BaseMutationOptions<ArriveStopMutation, ArriveStopMutationVariables>;
export const ArrivePickupDocument = gql`
    mutation arrivePickup($tripId: UUID!, $stagingNotes: String) {
  executeArrivePickup(command: {tripId: $tripId, stagingNotes: $stagingNotes}) {
    trip {
      pickupWaypoint {
        id
        tripId
        role
        order
        locationId
        airlineId
        flightType
        flightNumber
        estimatedArrivalTime
        arrivalTime
        estimatedDepartureTime
        departureTime
        estimatedDurationInMinutes
        durationInMinutes
        savoyaStop
      }
    }
    succeeded
    errors
  }
}
    `;
export type ArrivePickupMutationFn = Apollo.MutationFunction<ArrivePickupMutation, ArrivePickupMutationVariables>;

/**
 * __useArrivePickupMutation__
 *
 * To run a mutation, you first call `useArrivePickupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArrivePickupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [arrivePickupMutation, { data, loading, error }] = useArrivePickupMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      stagingNotes: // value for 'stagingNotes'
 *   },
 * });
 */
export function useArrivePickupMutation(baseOptions?: Apollo.MutationHookOptions<ArrivePickupMutation, ArrivePickupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArrivePickupMutation, ArrivePickupMutationVariables>(ArrivePickupDocument, options);
      }
export type ArrivePickupMutationHookResult = ReturnType<typeof useArrivePickupMutation>;
export type ArrivePickupMutationResult = Apollo.MutationResult<ArrivePickupMutation>;
export type ArrivePickupMutationOptions = Apollo.BaseMutationOptions<ArrivePickupMutation, ArrivePickupMutationVariables>;
export const CloseTripDocument = gql`
    mutation closeTrip($tripId: UUID!) {
  executeCloseTrip(command: {tripId: $tripId}) {
    succeeded
    errors
  }
}
    `;
export type CloseTripMutationFn = Apollo.MutationFunction<CloseTripMutation, CloseTripMutationVariables>;

/**
 * __useCloseTripMutation__
 *
 * To run a mutation, you first call `useCloseTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeTripMutation, { data, loading, error }] = useCloseTripMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useCloseTripMutation(baseOptions?: Apollo.MutationHookOptions<CloseTripMutation, CloseTripMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseTripMutation, CloseTripMutationVariables>(CloseTripDocument, options);
      }
export type CloseTripMutationHookResult = ReturnType<typeof useCloseTripMutation>;
export type CloseTripMutationResult = Apollo.MutationResult<CloseTripMutation>;
export type CloseTripMutationOptions = Apollo.BaseMutationOptions<CloseTripMutation, CloseTripMutationVariables>;
export const RecordTransactionDocument = gql`
    mutation recordTransaction($command: RecordTransaction!) {
  executeRecordTransaction(command: $command) {
    succeeded
    errors
  }
}
    `;
export type RecordTransactionMutationFn = Apollo.MutationFunction<RecordTransactionMutation, RecordTransactionMutationVariables>;

/**
 * __useRecordTransactionMutation__
 *
 * To run a mutation, you first call `useRecordTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordTransactionMutation, { data, loading, error }] = useRecordTransactionMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useRecordTransactionMutation(baseOptions?: Apollo.MutationHookOptions<RecordTransactionMutation, RecordTransactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordTransactionMutation, RecordTransactionMutationVariables>(RecordTransactionDocument, options);
      }
export type RecordTransactionMutationHookResult = ReturnType<typeof useRecordTransactionMutation>;
export type RecordTransactionMutationResult = Apollo.MutationResult<RecordTransactionMutation>;
export type RecordTransactionMutationOptions = Apollo.BaseMutationOptions<RecordTransactionMutation, RecordTransactionMutationVariables>;
export const CancelTripDocument = gql`
    mutation cancelTrip($tripId: UUID!, $reason: TripCancellationReason!, $notes: String) {
  executeCancelTrip(command: {tripId: $tripId, reason: $reason, notes: $notes}) {
    succeeded
    errors
  }
}
    `;
export type CancelTripMutationFn = Apollo.MutationFunction<CancelTripMutation, CancelTripMutationVariables>;

/**
 * __useCancelTripMutation__
 *
 * To run a mutation, you first call `useCancelTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTripMutation, { data, loading, error }] = useCancelTripMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      reason: // value for 'reason'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useCancelTripMutation(baseOptions?: Apollo.MutationHookOptions<CancelTripMutation, CancelTripMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTripMutation, CancelTripMutationVariables>(CancelTripDocument, options);
      }
export type CancelTripMutationHookResult = ReturnType<typeof useCancelTripMutation>;
export type CancelTripMutationResult = Apollo.MutationResult<CancelTripMutation>;
export type CancelTripMutationOptions = Apollo.BaseMutationOptions<CancelTripMutation, CancelTripMutationVariables>;
export const CirclingDocument = gql`
    mutation circling($tripId: UUID!) {
  executeCircling(command: {tripId: $tripId}) {
    trip {
      pickupWaypoint {
        id
        tripId
        role
        order
        locationId
        airlineId
        flightType
        flightNumber
        estimatedArrivalTime
        arrivalTime
        estimatedDepartureTime
        departureTime
        estimatedDurationInMinutes
        durationInMinutes
        savoyaStop
      }
    }
    succeeded
    errors
  }
}
    `;
export type CirclingMutationFn = Apollo.MutationFunction<CirclingMutation, CirclingMutationVariables>;

/**
 * __useCirclingMutation__
 *
 * To run a mutation, you first call `useCirclingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCirclingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [circlingMutation, { data, loading, error }] = useCirclingMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useCirclingMutation(baseOptions?: Apollo.MutationHookOptions<CirclingMutation, CirclingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CirclingMutation, CirclingMutationVariables>(CirclingDocument, options);
      }
export type CirclingMutationHookResult = ReturnType<typeof useCirclingMutation>;
export type CirclingMutationResult = Apollo.MutationResult<CirclingMutation>;
export type CirclingMutationOptions = Apollo.BaseMutationOptions<CirclingMutation, CirclingMutationVariables>;
export const WaitingDocument = gql`
    mutation waiting($tripId: UUID!) {
  executeWaiting(command: {tripId: $tripId}) {
    trip {
      pickupWaypoint {
        id
        tripId
        role
        order
        locationId
        airlineId
        flightType
        flightNumber
        estimatedArrivalTime
        arrivalTime
        estimatedDepartureTime
        departureTime
        estimatedDurationInMinutes
        durationInMinutes
        savoyaStop
      }
    }
    succeeded
    errors
  }
}
    `;
export type WaitingMutationFn = Apollo.MutationFunction<WaitingMutation, WaitingMutationVariables>;

/**
 * __useWaitingMutation__
 *
 * To run a mutation, you first call `useWaitingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWaitingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [waitingMutation, { data, loading, error }] = useWaitingMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useWaitingMutation(baseOptions?: Apollo.MutationHookOptions<WaitingMutation, WaitingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WaitingMutation, WaitingMutationVariables>(WaitingDocument, options);
      }
export type WaitingMutationHookResult = ReturnType<typeof useWaitingMutation>;
export type WaitingMutationResult = Apollo.MutationResult<WaitingMutation>;
export type WaitingMutationOptions = Apollo.BaseMutationOptions<WaitingMutation, WaitingMutationVariables>;
export const EnRouteToPickupDocument = gql`
    mutation enRouteToPickup($tripId: UUID!) {
  executeEnRouteToPickup(command: {tripId: $tripId}) {
    succeeded
    errors
  }
}
    `;
export type EnRouteToPickupMutationFn = Apollo.MutationFunction<EnRouteToPickupMutation, EnRouteToPickupMutationVariables>;

/**
 * __useEnRouteToPickupMutation__
 *
 * To run a mutation, you first call `useEnRouteToPickupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnRouteToPickupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enRouteToPickupMutation, { data, loading, error }] = useEnRouteToPickupMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useEnRouteToPickupMutation(baseOptions?: Apollo.MutationHookOptions<EnRouteToPickupMutation, EnRouteToPickupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnRouteToPickupMutation, EnRouteToPickupMutationVariables>(EnRouteToPickupDocument, options);
      }
export type EnRouteToPickupMutationHookResult = ReturnType<typeof useEnRouteToPickupMutation>;
export type EnRouteToPickupMutationResult = Apollo.MutationResult<EnRouteToPickupMutation>;
export type EnRouteToPickupMutationOptions = Apollo.BaseMutationOptions<EnRouteToPickupMutation, EnRouteToPickupMutationVariables>;
export const SubmitTripRequestDocument = gql`
    mutation submitTripRequest($tripId: UUID!) {
  executeSubmitTripRequest(command: {tripId: $tripId}) {
    succeeded
    errors
  }
}
    `;
export type SubmitTripRequestMutationFn = Apollo.MutationFunction<SubmitTripRequestMutation, SubmitTripRequestMutationVariables>;

/**
 * __useSubmitTripRequestMutation__
 *
 * To run a mutation, you first call `useSubmitTripRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitTripRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitTripRequestMutation, { data, loading, error }] = useSubmitTripRequestMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useSubmitTripRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitTripRequestMutation, SubmitTripRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitTripRequestMutation, SubmitTripRequestMutationVariables>(SubmitTripRequestDocument, options);
      }
export type SubmitTripRequestMutationHookResult = ReturnType<typeof useSubmitTripRequestMutation>;
export type SubmitTripRequestMutationResult = Apollo.MutationResult<SubmitTripRequestMutation>;
export type SubmitTripRequestMutationOptions = Apollo.BaseMutationOptions<SubmitTripRequestMutation, SubmitTripRequestMutationVariables>;
export const RequestReassignmentDocument = gql`
    mutation requestReassignment($tripId: UUID!) {
  executeReassignmentRequested(command: {tripId: $tripId}) {
    succeeded
    errors
  }
}
    `;
export type RequestReassignmentMutationFn = Apollo.MutationFunction<RequestReassignmentMutation, RequestReassignmentMutationVariables>;

/**
 * __useRequestReassignmentMutation__
 *
 * To run a mutation, you first call `useRequestReassignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestReassignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestReassignmentMutation, { data, loading, error }] = useRequestReassignmentMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useRequestReassignmentMutation(baseOptions?: Apollo.MutationHookOptions<RequestReassignmentMutation, RequestReassignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestReassignmentMutation, RequestReassignmentMutationVariables>(RequestReassignmentDocument, options);
      }
export type RequestReassignmentMutationHookResult = ReturnType<typeof useRequestReassignmentMutation>;
export type RequestReassignmentMutationResult = Apollo.MutationResult<RequestReassignmentMutation>;
export type RequestReassignmentMutationOptions = Apollo.BaseMutationOptions<RequestReassignmentMutation, RequestReassignmentMutationVariables>;
export const GetAllTripsDocument = gql`
    query getAllTrips($accountId: UUID!, $offset: Int = 0, $perPage: Int = 20) {
  trips {
    all(accountId: $accountId, skip: $offset, take: $perPage) {
      items {
        id
        accountId
        pickupTime
        tripNumber
        stagingNotes
        status
        estimatedDistanceInMiles
        estimatedSpotTimeInMinutes
        estimatedRevenue
        driver {
          accountId
          drivingSince
          id
          isActive
          name
          imageUrl
        }
        vehicle {
          id
          name
          accountId
          vehicleClassId
          vehicleClass {
            id
            accountId
            systemClassId
            passengerCount
            luggageCount
            name
            hourlyRate
            isActive
            cancellationPolicyHours
            minimumHours
          }
          licenseNumber
          vin
          year
          modelName
          makeName
          isActive
          color
          middleSeatType
        }
        estimatedDurationInMinutes
        pickupWaypoint {
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
          departureTime
          location {
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            coordinates
            placeCategory
          }
          savoyaStop
        }
        dropoffWaypoint {
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
          location {
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            coordinates
            placeCategory
          }
          savoyaStop
        }
        preferredVehicleClass {
          name
        }
        waypoints {
          id
          role
          order
          location {
            name
            addressLine1
            addressLine2
            coordinates
            city
            state
            postalCode
          }
          estimatedDurationInMinutes
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        providerExternalId
        groundworkTrip
        segments {
          startWaypointId
          endWaypointId
          estimatedDistanceInMiles
          estimatedDurationInMinutes
          order
        }
      }
      total
    }
  }
}
    `;

/**
 * __useGetAllTripsQuery__
 *
 * To run a query within a React component, call `useGetAllTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTripsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetAllTripsQuery(baseOptions: Apollo.QueryHookOptions<GetAllTripsQuery, GetAllTripsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTripsQuery, GetAllTripsQueryVariables>(GetAllTripsDocument, options);
      }
export function useGetAllTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTripsQuery, GetAllTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTripsQuery, GetAllTripsQueryVariables>(GetAllTripsDocument, options);
        }
export type GetAllTripsQueryHookResult = ReturnType<typeof useGetAllTripsQuery>;
export type GetAllTripsLazyQueryHookResult = ReturnType<typeof useGetAllTripsLazyQuery>;
export type GetAllTripsQueryResult = Apollo.QueryResult<GetAllTripsQuery, GetAllTripsQueryVariables>;
export const GetTripByIdDocument = gql`
    query GetTripById($tripId: UUID!) {
  trips {
    byId(id: $tripId) {
      id
      currentOrNextWaypoint {
        id
        role
      }
      accountId
      tripNumber
      stagingNotes
      pickupTime
      passengerCount
      luggageCount
      status
      tripNumber
      customerId
      addons {
        id
        rateType {
          name
        }
        total
        calculation
      }
      paymentMethod {
        description
        source
      }
      notes {
        id
        content
      }
      paymentMethodId
      paymentMethodType
      estimatedDistanceInMiles
      estimatedSpotTimeInMinutes
      estimatedAvailabilityTime
      estimatedRevenue
      wasBookedByPassenger
      driverId
      driver {
        accountId
        drivingSince
        id
        isActive
        name
        imageUrl
      }
      vehicleId
      vehicle {
        id
        name
        accountId
        vehicleClassId
        vehicleClass {
          id
          accountId
          systemClassId
          passengerCount
          luggageCount
          name
          hourlyRate
          isActive
          cancellationPolicyHours
          minimumHours
        }
        licenseNumber
        vin
        year
        modelName
        makeName
        isActive
        color
        middleSeatType
      }
      estimatedDurationInMinutes
      pickupWaypoint {
        role
        airline {
          IATA
          name
        }
        airlineId
        fbo {
          id
          iata_code
          fbo_name
        }
        fboId
        iataCode
        flightNumber
        departureTime
        arrivalTime
        verifiedFlightId
        verifiedFlight
        flightTime
        location {
          timezone
          name
          addressLine1
          addressLine2
          city
          state
          postalCode
          coordinates
          placeCategory
          placeWikidataId
          placeFoursquareId
          placeType
        }
        estimatedDurationInMinutes
        estimatedDepartureTime
        estimatedArrivalTime
        savoyaStop
      }
      dropoffWaypoint {
        role
        airline {
          IATA
          name
        }
        airlineId
        fbo {
          id
          iata_code
          fbo_name
        }
        fboId
        iataCode
        flightNumber
        departureTime
        arrivalTime
        verifiedFlightId
        verifiedFlight
        flightTime
        location {
          name
          addressLine1
          addressLine2
          city
          state
          postalCode
          coordinates
          placeCategory
          placeFoursquareId
          placeWikidataId
          placeType
        }
        estimatedDurationInMinutes
        estimatedDepartureTime
        estimatedArrivalTime
        savoyaStop
      }
      invoice {
        id
        status
        type
        total
        lineItems {
          id
          name
          unitPrice
          quantity
          total
        }
        transactions {
          id
          type
          status
          paymentMethodType
          note
          amount
          reversalOfTransactionId
          accountId
          invoiceId
          refundedAmount
        }
        payments
        balance
        externalId
        invoiceProcessor
        externalInvoiceLink
      }
      quote {
        id
      }
      preferredVehicleClass {
        id
        name
        hourlyRate
        minimumHours
        cancellationPolicyHours
      }
      waypoints {
        id
        role
        order
        airline {
          IATA
          name
        }
        airlineId
        fbo {
          id
          iata_code
          fbo_name
        }
        fboId
        iataCode
        flightNumber
        verifiedFlight
        flightTime
        location {
          name
          addressLine1
          addressLine2
          city
          state
          postalCode
          coordinates
          placeCategory
          placeFoursquareId
          placeWikidataId
          placeType
        }
        estimatedDurationInMinutes
        estimatedDepartureTime
        estimatedArrivalTime
        order
        savoyaStop
        note
      }
      segments {
        startWaypointId
        endWaypointId
        estimatedDistanceInMiles
        estimatedDurationInMinutes
        durationInMinutes
        distanceInMiles
        order
      }
      timestamps {
        id
        tripId
        status
        effectiveTime
        estimatedTime
        recordedById
        recordedTime
        correctedById
        correctedTime
        correctionReason
        correctionNote
      }
      rateData
      baseRateOverride
      flatRateOverride
      isDirected
      estimatedDurationInMinutesOverride
      overrideDropoffWaypointDetails
      isShared
      providerSource
      providerExternalId
      groundworkTrip
      sharedTrip {
        contactId
        amount
        token
        id
        paymentMethodType
        contact {
          name
          email
          phoneNumber
        }
        status
        savoyaAssignmentStatus
        vendorExternalId
        savoyaAssignmentStatus
      }
      account {
        accountOwner {
          email
          phoneNumber
          name
        }
      }
      confirmationEmailStatus
      referenceNumber
      providerExternalId
      groundworkTrip
      availableCommands {
        typeName
        name
        isPrimary
        disabled
        description
        events
        hidden
      }
      sharedAvailableCommands {
        typeName
        name
        isPrimary
        disabled
        description
        events
        hidden
      }
    }
  }
  clientQueries {
    getTripClientsByTrip(tripId: $tripId) {
      client {
        id
        accountId
        name
        sourceProduct
        primaryRole
        title
        note
        isActive
        companies {
          accountId
          emails {
            id
            type
            email
          }
          addresses {
            id
            type
            addressLineOne
            addressLineTwo
            addressLineThree
            addressLineFour
            locality
            region
            postalCode
            country
            formattedAddress
          }
          id
          name
          isActive
          note
          phoneNumbers {
            id
            type
            phoneNumber
          }
          sourceProduct
          type
        }
        phoneNumbers {
          id
          type
          phoneNumber
        }
        emails {
          id
          type
          email
        }
        addresses {
          id
          type
          addressLineOne
          addressLineTwo
          addressLineThree
          addressLineFour
          locality
          region
          postalCode
          country
          formattedAddress
        }
      }
      isPrimary
      id
      role
      tripId
      clientId
      guests
    }
  }
}
    `;

/**
 * __useGetTripByIdQuery__
 *
 * To run a query within a React component, call `useGetTripByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTripByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTripByIdQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useGetTripByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTripByIdQuery, GetTripByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTripByIdQuery, GetTripByIdQueryVariables>(GetTripByIdDocument, options);
      }
export function useGetTripByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTripByIdQuery, GetTripByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTripByIdQuery, GetTripByIdQueryVariables>(GetTripByIdDocument, options);
        }
export type GetTripByIdQueryHookResult = ReturnType<typeof useGetTripByIdQuery>;
export type GetTripByIdLazyQueryHookResult = ReturnType<typeof useGetTripByIdLazyQuery>;
export type GetTripByIdQueryResult = Apollo.QueryResult<GetTripByIdQuery, GetTripByIdQueryVariables>;
export const GetAvailableCommandsByTripIdDocument = gql`
    query getAvailableCommandsByTripId($tripId: UUID!) {
  trips {
    byId(id: $tripId) {
      transportStatus
      currentOrNextWaypoint {
        id
        role
      }
      availableCommands {
        typeName
        name
        description
        events
        hidden
        disabled
      }
      sharedAvailableCommands {
        typeName
        name
        description
        events
        hidden
        disabled
      }
      confirmationEmailStatus
      accountId
      isShared
      providerSource
      providerExternalId
      groundworkTrip
      sharedTrip {
        contactId
        savoyaAssignmentStatus
      }
    }
  }
}
    `;

/**
 * __useGetAvailableCommandsByTripIdQuery__
 *
 * To run a query within a React component, call `useGetAvailableCommandsByTripIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableCommandsByTripIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableCommandsByTripIdQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useGetAvailableCommandsByTripIdQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableCommandsByTripIdQuery, GetAvailableCommandsByTripIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableCommandsByTripIdQuery, GetAvailableCommandsByTripIdQueryVariables>(GetAvailableCommandsByTripIdDocument, options);
      }
export function useGetAvailableCommandsByTripIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableCommandsByTripIdQuery, GetAvailableCommandsByTripIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableCommandsByTripIdQuery, GetAvailableCommandsByTripIdQueryVariables>(GetAvailableCommandsByTripIdDocument, options);
        }
export type GetAvailableCommandsByTripIdQueryHookResult = ReturnType<typeof useGetAvailableCommandsByTripIdQuery>;
export type GetAvailableCommandsByTripIdLazyQueryHookResult = ReturnType<typeof useGetAvailableCommandsByTripIdLazyQuery>;
export type GetAvailableCommandsByTripIdQueryResult = Apollo.QueryResult<GetAvailableCommandsByTripIdQuery, GetAvailableCommandsByTripIdQueryVariables>;
export const NextTripDocument = gql`
    query NextTrip($currentTime: DateTime, $accountId: UUID!, $driverId: UUID, $completionStatus: TripCompletionStatus) {
  trips {
    search(
      accountId: $accountId
      filter: {startDate: $currentTime, completionStatus: $completionStatus, driverId: $driverId}
      orderBy: {pickupTime: Ascending}
      limit: 1
    ) {
      items {
        id
        accountId
        pickupTime
        stagingNotes
        status
        tripNumber
        driver {
          accountId
          drivingSince
          id
          isActive
          name
          imageUrl
        }
        vehicle {
          id
          accountId
          name
          vehicleClassId
          vehicleClass {
            id
            accountId
            systemClassId
            passengerCount
            luggageCount
            name
            hourlyRate
            isActive
            cancellationPolicyHours
            minimumHours
          }
          licenseNumber
          vin
          year
          modelName
          makeName
          isActive
          color
          middleSeatType
        }
        preferredVehicleClass {
          name
        }
        estimatedDurationInMinutes
        estimatedDistanceInMiles
        pickupWaypoint {
          role
          verifiedFlightId
          verifiedFlight
          flightTime
          location {
            category
            coordinates
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            placeCategory
          }
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          airlineId
          fboId
          departureTime
          arrivalTime
          flightNumber
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        dropoffWaypoint {
          role
          verifiedFlightId
          verifiedFlight
          flightTime
          location {
            category
            coordinates
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            placeCategory
          }
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          airlineId
          fboId
          departureTime
          arrivalTime
          flightNumber
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        waypoints {
          id
          role
          order
          location {
            category
            name
            addressLine1
            addressLine2
            coordinates
            city
            state
            postalCode
            placeCategory
          }
          estimatedDurationInMinutes
          savoyaStop
        }
        segments {
          startWaypointId
          endWaypointId
          estimatedDistanceInMiles
          estimatedDurationInMinutes
          order
        }
        isDirected
        estimatedDurationInMinutesOverride
        overrideDropoffWaypointDetails
        isShared
        providerSource
        providerExternalId
        groundworkTrip
        sharedTrip {
          amount
          token
          id
          paymentMethodType
          contact {
            name
            email
            phoneNumber
          }
          status
          savoyaAssignmentStatus
        }
      }
    }
  }
}
    `;

/**
 * __useNextTripQuery__
 *
 * To run a query within a React component, call `useNextTripQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextTripQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextTripQuery({
 *   variables: {
 *      currentTime: // value for 'currentTime'
 *      accountId: // value for 'accountId'
 *      driverId: // value for 'driverId'
 *      completionStatus: // value for 'completionStatus'
 *   },
 * });
 */
export function useNextTripQuery(baseOptions: Apollo.QueryHookOptions<NextTripQuery, NextTripQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NextTripQuery, NextTripQueryVariables>(NextTripDocument, options);
      }
export function useNextTripLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NextTripQuery, NextTripQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NextTripQuery, NextTripQueryVariables>(NextTripDocument, options);
        }
export type NextTripQueryHookResult = ReturnType<typeof useNextTripQuery>;
export type NextTripLazyQueryHookResult = ReturnType<typeof useNextTripLazyQuery>;
export type NextTripQueryResult = Apollo.QueryResult<NextTripQuery, NextTripQueryVariables>;
export const UpcomingTripsDocument = gql`
    query UpcomingTrips($accountId: UUID!, $driverId: UUID, $currentTime: DateTime, $completionStatus: TripCompletionStatus) {
  trips {
    search(
      accountId: $accountId
      filter: {startDate: $currentTime, completionStatus: $completionStatus, driverId: $driverId}
      orderBy: {pickupTime: Ascending}
      limit: 3
    ) {
      items {
        id
        accountId
        pickupTime
        status
        tripNumber
        stagingNotes
        driver {
          accountId
          drivingSince
          id
          isActive
          name
          imageUrl
        }
        vehicle {
          id
          accountId
          name
          vehicleClassId
          vehicleClass {
            id
            accountId
            systemClassId
            passengerCount
            luggageCount
            name
            hourlyRate
            isActive
            cancellationPolicyHours
            minimumHours
          }
          licenseNumber
          vin
          year
          modelName
          makeName
          isActive
          color
          middleSeatType
        }
        estimatedDistanceInMiles
        estimatedDurationInMinutes
        pickupWaypoint {
          role
          verifiedFlightId
          verifiedFlight
          flightTime
          location {
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            placeCategory
          }
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          airlineId
          fboId
          departureTime
          arrivalTime
          flightNumber
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        dropoffWaypoint {
          role
          verifiedFlightId
          verifiedFlight
          flightTime
          location {
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            placeCategory
          }
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          airlineId
          fboId
          departureTime
          arrivalTime
          flightNumber
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        waypoints {
          id
          role
          order
          location {
            name
            addressLine1
            addressLine2
            city
            state
            placeName
            postalCode
            coordinates
            placeCategory
          }
          estimatedDurationInMinutes
          savoyaStop
        }
        segments {
          startWaypointId
          endWaypointId
          estimatedDistanceInMiles
          estimatedDurationInMinutes
          durationInMinutes
          distanceInMiles
          order
        }
        isDirected
        estimatedDurationInMinutesOverride
        overrideDropoffWaypointDetails
        isShared
        providerSource
        providerExternalId
        groundworkTrip
        sharedTrip {
          amount
          token
          id
          paymentMethodType
          contact {
            name
            email
            phoneNumber
          }
          status
          savoyaAssignmentStatus
        }
      }
    }
  }
}
    `;

/**
 * __useUpcomingTripsQuery__
 *
 * To run a query within a React component, call `useUpcomingTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingTripsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      driverId: // value for 'driverId'
 *      currentTime: // value for 'currentTime'
 *      completionStatus: // value for 'completionStatus'
 *   },
 * });
 */
export function useUpcomingTripsQuery(baseOptions: Apollo.QueryHookOptions<UpcomingTripsQuery, UpcomingTripsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UpcomingTripsQuery, UpcomingTripsQueryVariables>(UpcomingTripsDocument, options);
      }
export function useUpcomingTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UpcomingTripsQuery, UpcomingTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UpcomingTripsQuery, UpcomingTripsQueryVariables>(UpcomingTripsDocument, options);
        }
export type UpcomingTripsQueryHookResult = ReturnType<typeof useUpcomingTripsQuery>;
export type UpcomingTripsLazyQueryHookResult = ReturnType<typeof useUpcomingTripsLazyQuery>;
export type UpcomingTripsQueryResult = Apollo.QueryResult<UpcomingTripsQuery, UpcomingTripsQueryVariables>;
export const DraftedTripsDocument = gql`
    query DraftedTrips($accountId: UUID!, $driverId: UUID) {
  trips {
    search(
      accountId: $accountId
      filter: {completionStatus: Draft, driverId: $driverId}
      orderBy: {pickupTime: Descending}
      limit: 3
    ) {
      items {
        id
        accountId
        pickupTime
        stagingNotes
        status
        tripNumber
        driver {
          accountId
          drivingSince
          id
          isActive
          name
          imageUrl
        }
        vehicle {
          id
          accountId
          name
          vehicleClassId
          vehicleClass {
            id
            accountId
            systemClassId
            passengerCount
            luggageCount
            name
            hourlyRate
            isActive
            cancellationPolicyHours
            minimumHours
          }
          licenseNumber
          vin
          year
          modelName
          makeName
          isActive
          color
          middleSeatType
        }
        preferredVehicleClass {
          name
        }
        estimatedDistanceInMiles
        estimatedDurationInMinutes
        pickupWaypoint {
          location {
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            placeCategory
          }
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        dropoffWaypoint {
          location {
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            placeCategory
          }
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        waypoints {
          id
          role
          order
          location {
            name
            addressLine1
            addressLine2
            coordinates
            city
            state
            postalCode
            placeCategory
          }
          estimatedDurationInMinutes
          savoyaStop
        }
        segments {
          startWaypointId
          endWaypointId
          estimatedDistanceInMiles
          estimatedDurationInMinutes
          order
        }
        isShared
        providerSource
        providerExternalId
        groundworkTrip
        sharedTrip {
          amount
          token
          id
          paymentMethodType
          contact {
            name
            email
            phoneNumber
          }
          status
          savoyaAssignmentStatus
        }
      }
    }
  }
}
    `;

/**
 * __useDraftedTripsQuery__
 *
 * To run a query within a React component, call `useDraftedTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftedTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftedTripsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useDraftedTripsQuery(baseOptions: Apollo.QueryHookOptions<DraftedTripsQuery, DraftedTripsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftedTripsQuery, DraftedTripsQueryVariables>(DraftedTripsDocument, options);
      }
export function useDraftedTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftedTripsQuery, DraftedTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftedTripsQuery, DraftedTripsQueryVariables>(DraftedTripsDocument, options);
        }
export type DraftedTripsQueryHookResult = ReturnType<typeof useDraftedTripsQuery>;
export type DraftedTripsLazyQueryHookResult = ReturnType<typeof useDraftedTripsLazyQuery>;
export type DraftedTripsQueryResult = Apollo.QueryResult<DraftedTripsQuery, DraftedTripsQueryVariables>;
export const AwaitingAsignmentTripsDocument = gql`
    query AwaitingAsignmentTrips($accountId: UUID!, $driverId: UUID) {
  trips {
    search(
      accountId: $accountId
      filter: {statuses: [AwaitingAssignment], driverId: $driverId}
      orderBy: {pickupTime: Descending}
      limit: 3
    ) {
      items {
        id
        accountId
        pickupTime
        stagingNotes
        status
        tripNumber
        driver {
          accountId
          drivingSince
          id
          isActive
          name
          imageUrl
        }
        vehicle {
          id
          accountId
          name
          vehicleClassId
          vehicleClass {
            id
            accountId
            systemClassId
            passengerCount
            luggageCount
            name
            hourlyRate
            isActive
            cancellationPolicyHours
            minimumHours
          }
          licenseNumber
          vin
          year
          modelName
          makeName
          isActive
          color
          middleSeatType
        }
        preferredVehicleClass {
          name
        }
        estimatedDurationInMinutes
        estimatedDistanceInMiles
        pickupWaypoint {
          location {
            coordinates
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            placeCategory
          }
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        dropoffWaypoint {
          location {
            coordinates
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            placeCategory
          }
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        waypoints {
          id
          role
          order
          location {
            name
            addressLine1
            addressLine2
            coordinates
            city
            state
            postalCode
            placeCategory
          }
          estimatedDurationInMinutes
          savoyaStop
        }
        segments {
          startWaypointId
          endWaypointId
          estimatedDistanceInMiles
          estimatedDurationInMinutes
          order
        }
        isShared
        providerSource
        providerExternalId
        groundworkTrip
        sharedTrip {
          amount
          token
          id
          paymentMethodType
          contact {
            name
            email
            phoneNumber
          }
          status
          savoyaAssignmentStatus
        }
      }
    }
  }
}
    `;

/**
 * __useAwaitingAsignmentTripsQuery__
 *
 * To run a query within a React component, call `useAwaitingAsignmentTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAwaitingAsignmentTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAwaitingAsignmentTripsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useAwaitingAsignmentTripsQuery(baseOptions: Apollo.QueryHookOptions<AwaitingAsignmentTripsQuery, AwaitingAsignmentTripsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AwaitingAsignmentTripsQuery, AwaitingAsignmentTripsQueryVariables>(AwaitingAsignmentTripsDocument, options);
      }
export function useAwaitingAsignmentTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AwaitingAsignmentTripsQuery, AwaitingAsignmentTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AwaitingAsignmentTripsQuery, AwaitingAsignmentTripsQueryVariables>(AwaitingAsignmentTripsDocument, options);
        }
export type AwaitingAsignmentTripsQueryHookResult = ReturnType<typeof useAwaitingAsignmentTripsQuery>;
export type AwaitingAsignmentTripsLazyQueryHookResult = ReturnType<typeof useAwaitingAsignmentTripsLazyQuery>;
export type AwaitingAsignmentTripsQueryResult = Apollo.QueryResult<AwaitingAsignmentTripsQuery, AwaitingAsignmentTripsQueryVariables>;
export const RecentTripsDocument = gql`
    query RecentTrips($startDate: DateTime, $endDate: DateTime, $accountId: UUID!, $driverId: UUID) {
  trips {
    search(
      accountId: $accountId
      filter: {startDate: $startDate, endDate: $endDate, completionStatus: CompleteOrClosed, driverId: $driverId}
      orderBy: {pickupTime: Descending}
      limit: 3
    ) {
      items {
        id
        accountId
        pickupTime
        tripNumber
        stagingNotes
        status
        driver {
          accountId
          drivingSince
          id
          isActive
          name
          imageUrl
        }
        vehicle {
          id
          accountId
          name
          vehicleClassId
          vehicleClass {
            id
            accountId
            systemClassId
            passengerCount
            luggageCount
            name
            hourlyRate
            isActive
            cancellationPolicyHours
            minimumHours
          }
          licenseNumber
          vin
          year
          modelName
          makeName
          isActive
          color
          middleSeatType
        }
        preferredVehicleClass {
          name
        }
        estimatedDurationInMinutes
        estimatedDistanceInMiles
        pickupWaypoint {
          role
          verifiedFlightId
          verifiedFlight
          flightTime
          location {
            coordinates
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            placeCategory
          }
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          airlineId
          fboId
          flightNumber
          departureTime
          arrivalTime
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        dropoffWaypoint {
          role
          verifiedFlightId
          verifiedFlight
          flightTime
          location {
            coordinates
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            placeCategory
          }
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          airlineId
          fboId
          flightNumber
          departureTime
          arrivalTime
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        waypoints {
          id
          role
          order
          location {
            name
            addressLine1
            addressLine2
            coordinates
            city
            state
            postalCode
            placeCategory
          }
          estimatedDurationInMinutes
          savoyaStop
        }
        segments {
          startWaypointId
          endWaypointId
          estimatedDistanceInMiles
          estimatedDurationInMinutes
          durationInMinutes
          distanceInMiles
          order
        }
        isDirected
        estimatedDurationInMinutesOverride
        overrideDropoffWaypointDetails
        isShared
        providerSource
        providerExternalId
        groundworkTrip
        sharedTrip {
          amount
          token
          id
          paymentMethodType
          contact {
            name
            email
            phoneNumber
          }
          status
          savoyaAssignmentStatus
        }
      }
    }
  }
}
    `;

/**
 * __useRecentTripsQuery__
 *
 * To run a query within a React component, call `useRecentTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentTripsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      accountId: // value for 'accountId'
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useRecentTripsQuery(baseOptions: Apollo.QueryHookOptions<RecentTripsQuery, RecentTripsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentTripsQuery, RecentTripsQueryVariables>(RecentTripsDocument, options);
      }
export function useRecentTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentTripsQuery, RecentTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentTripsQuery, RecentTripsQueryVariables>(RecentTripsDocument, options);
        }
export type RecentTripsQueryHookResult = ReturnType<typeof useRecentTripsQuery>;
export type RecentTripsLazyQueryHookResult = ReturnType<typeof useRecentTripsLazyQuery>;
export type RecentTripsQueryResult = Apollo.QueryResult<RecentTripsQuery, RecentTripsQueryVariables>;
export const AddTripDocument = gql`
    mutation AddTrip($trip: InsertTrip!, $publicToken: String, $recaptchaToken: String) {
  insertTrip(
    trip: $trip
    publicToken: $publicToken
    recaptchaToken: $recaptchaToken
  ) {
    trip {
      id
      customerId
      pickupWaypoint {
        id
        location {
          name
        }
      }
      dropoffWaypoint {
        id
        location {
          name
        }
      }
    }
  }
}
    `;
export type AddTripMutationFn = Apollo.MutationFunction<AddTripMutation, AddTripMutationVariables>;

/**
 * __useAddTripMutation__
 *
 * To run a mutation, you first call `useAddTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTripMutation, { data, loading, error }] = useAddTripMutation({
 *   variables: {
 *      trip: // value for 'trip'
 *      publicToken: // value for 'publicToken'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useAddTripMutation(baseOptions?: Apollo.MutationHookOptions<AddTripMutation, AddTripMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTripMutation, AddTripMutationVariables>(AddTripDocument, options);
      }
export type AddTripMutationHookResult = ReturnType<typeof useAddTripMutation>;
export type AddTripMutationResult = Apollo.MutationResult<AddTripMutation>;
export type AddTripMutationOptions = Apollo.BaseMutationOptions<AddTripMutation, AddTripMutationVariables>;
export const SetTripAsQuoteDocument = gql`
    mutation SetTripAsQuote($tripId: UUID!) {
  executeSendQuote(command: {tripId: $tripId}) {
    trip {
      id
    }
    succeeded
    errors
  }
}
    `;
export type SetTripAsQuoteMutationFn = Apollo.MutationFunction<SetTripAsQuoteMutation, SetTripAsQuoteMutationVariables>;

/**
 * __useSetTripAsQuoteMutation__
 *
 * To run a mutation, you first call `useSetTripAsQuoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTripAsQuoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTripAsQuoteMutation, { data, loading, error }] = useSetTripAsQuoteMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useSetTripAsQuoteMutation(baseOptions?: Apollo.MutationHookOptions<SetTripAsQuoteMutation, SetTripAsQuoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTripAsQuoteMutation, SetTripAsQuoteMutationVariables>(SetTripAsQuoteDocument, options);
      }
export type SetTripAsQuoteMutationHookResult = ReturnType<typeof useSetTripAsQuoteMutation>;
export type SetTripAsQuoteMutationResult = Apollo.MutationResult<SetTripAsQuoteMutation>;
export type SetTripAsQuoteMutationOptions = Apollo.BaseMutationOptions<SetTripAsQuoteMutation, SetTripAsQuoteMutationVariables>;
export const ExecuteCreateInvoiceDeliveryRequestDocument = gql`
    mutation executeCreateInvoiceDeliveryRequest($command: InvoiceDeliveryRequested!) {
  executeCreateInvoiceDeliveryRequest(command: $command) {
    succeeded
    errors
  }
}
    `;
export type ExecuteCreateInvoiceDeliveryRequestMutationFn = Apollo.MutationFunction<ExecuteCreateInvoiceDeliveryRequestMutation, ExecuteCreateInvoiceDeliveryRequestMutationVariables>;

/**
 * __useExecuteCreateInvoiceDeliveryRequestMutation__
 *
 * To run a mutation, you first call `useExecuteCreateInvoiceDeliveryRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteCreateInvoiceDeliveryRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeCreateInvoiceDeliveryRequestMutation, { data, loading, error }] = useExecuteCreateInvoiceDeliveryRequestMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useExecuteCreateInvoiceDeliveryRequestMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteCreateInvoiceDeliveryRequestMutation, ExecuteCreateInvoiceDeliveryRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteCreateInvoiceDeliveryRequestMutation, ExecuteCreateInvoiceDeliveryRequestMutationVariables>(ExecuteCreateInvoiceDeliveryRequestDocument, options);
      }
export type ExecuteCreateInvoiceDeliveryRequestMutationHookResult = ReturnType<typeof useExecuteCreateInvoiceDeliveryRequestMutation>;
export type ExecuteCreateInvoiceDeliveryRequestMutationResult = Apollo.MutationResult<ExecuteCreateInvoiceDeliveryRequestMutation>;
export type ExecuteCreateInvoiceDeliveryRequestMutationOptions = Apollo.BaseMutationOptions<ExecuteCreateInvoiceDeliveryRequestMutation, ExecuteCreateInvoiceDeliveryRequestMutationVariables>;
export const UpdateTripDocument = gql`
    mutation UpdateTrip($trip: UpdateTrip!) {
  updateTrip(trip: $trip) {
    trip {
      id
      status
    }
    success
  }
}
    `;
export type UpdateTripMutationFn = Apollo.MutationFunction<UpdateTripMutation, UpdateTripMutationVariables>;

/**
 * __useUpdateTripMutation__
 *
 * To run a mutation, you first call `useUpdateTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTripMutation, { data, loading, error }] = useUpdateTripMutation({
 *   variables: {
 *      trip: // value for 'trip'
 *   },
 * });
 */
export function useUpdateTripMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTripMutation, UpdateTripMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTripMutation, UpdateTripMutationVariables>(UpdateTripDocument, options);
      }
export type UpdateTripMutationHookResult = ReturnType<typeof useUpdateTripMutation>;
export type UpdateTripMutationResult = Apollo.MutationResult<UpdateTripMutation>;
export type UpdateTripMutationOptions = Apollo.BaseMutationOptions<UpdateTripMutation, UpdateTripMutationVariables>;
export const UpdateConfirmationEmailStatusDocument = gql`
    mutation UpdateConfirmationEmailStatus($tripId: UUID!, $confirmationEmailStatus: TripConfirmationEmailStatus!) {
  updateConfirmationStatus(
    tripId: $tripId
    confirmationEmailStatus: $confirmationEmailStatus
  ) {
    success
    errors {
      message
    }
  }
}
    `;
export type UpdateConfirmationEmailStatusMutationFn = Apollo.MutationFunction<UpdateConfirmationEmailStatusMutation, UpdateConfirmationEmailStatusMutationVariables>;

/**
 * __useUpdateConfirmationEmailStatusMutation__
 *
 * To run a mutation, you first call `useUpdateConfirmationEmailStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConfirmationEmailStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConfirmationEmailStatusMutation, { data, loading, error }] = useUpdateConfirmationEmailStatusMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      confirmationEmailStatus: // value for 'confirmationEmailStatus'
 *   },
 * });
 */
export function useUpdateConfirmationEmailStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConfirmationEmailStatusMutation, UpdateConfirmationEmailStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConfirmationEmailStatusMutation, UpdateConfirmationEmailStatusMutationVariables>(UpdateConfirmationEmailStatusDocument, options);
      }
export type UpdateConfirmationEmailStatusMutationHookResult = ReturnType<typeof useUpdateConfirmationEmailStatusMutation>;
export type UpdateConfirmationEmailStatusMutationResult = Apollo.MutationResult<UpdateConfirmationEmailStatusMutation>;
export type UpdateConfirmationEmailStatusMutationOptions = Apollo.BaseMutationOptions<UpdateConfirmationEmailStatusMutation, UpdateConfirmationEmailStatusMutationVariables>;
export const AirlinesDocument = gql`
    query Airlines {
  airlines {
    all {
      items {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAirlinesQuery__
 *
 * To run a query within a React component, call `useAirlinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAirlinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAirlinesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAirlinesQuery(baseOptions?: Apollo.QueryHookOptions<AirlinesQuery, AirlinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AirlinesQuery, AirlinesQueryVariables>(AirlinesDocument, options);
      }
export function useAirlinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AirlinesQuery, AirlinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AirlinesQuery, AirlinesQueryVariables>(AirlinesDocument, options);
        }
export type AirlinesQueryHookResult = ReturnType<typeof useAirlinesQuery>;
export type AirlinesLazyQueryHookResult = ReturnType<typeof useAirlinesLazyQuery>;
export type AirlinesQueryResult = Apollo.QueryResult<AirlinesQuery, AirlinesQueryVariables>;
export const AirlinesAutocompleteDocument = gql`
    query airlinesAutocomplete($query: String!) {
  airlines {
    airlinesAutocomplete(query: $query) {
      id
      label
    }
  }
}
    `;

/**
 * __useAirlinesAutocompleteQuery__
 *
 * To run a query within a React component, call `useAirlinesAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAirlinesAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAirlinesAutocompleteQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useAirlinesAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<AirlinesAutocompleteQuery, AirlinesAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AirlinesAutocompleteQuery, AirlinesAutocompleteQueryVariables>(AirlinesAutocompleteDocument, options);
      }
export function useAirlinesAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AirlinesAutocompleteQuery, AirlinesAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AirlinesAutocompleteQuery, AirlinesAutocompleteQueryVariables>(AirlinesAutocompleteDocument, options);
        }
export type AirlinesAutocompleteQueryHookResult = ReturnType<typeof useAirlinesAutocompleteQuery>;
export type AirlinesAutocompleteLazyQueryHookResult = ReturnType<typeof useAirlinesAutocompleteLazyQuery>;
export type AirlinesAutocompleteQueryResult = Apollo.QueryResult<AirlinesAutocompleteQuery, AirlinesAutocompleteQueryVariables>;
export const GetTripsByNumberDocument = gql`
    query getTripsByNumber($query: String!, $accountId: UUID) {
  trips {
    searchByNumber(query: $query, accountId: $accountId) {
      items {
        id
        isShared
        providerSource
        sharedTrip {
          amount
          token
          id
          paymentMethodType
          contact {
            name
            email
            phoneNumber
          }
          status
          savoyaAssignmentStatus
        }
        tripNumber
        stagingNotes
        pickupTime
        status
        estimatedSpotTimeInMinutes
        pickupWaypoint {
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
          departureTime
          location {
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            coordinates
            placeCategory
          }
          savoyaStop
        }
        dropoffWaypoint {
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
          location {
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            coordinates
            placeCategory
          }
          savoyaStop
        }
      }
    }
  }
}
    `;

/**
 * __useGetTripsByNumberQuery__
 *
 * To run a query within a React component, call `useGetTripsByNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTripsByNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTripsByNumberQuery({
 *   variables: {
 *      query: // value for 'query'
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetTripsByNumberQuery(baseOptions: Apollo.QueryHookOptions<GetTripsByNumberQuery, GetTripsByNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTripsByNumberQuery, GetTripsByNumberQueryVariables>(GetTripsByNumberDocument, options);
      }
export function useGetTripsByNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTripsByNumberQuery, GetTripsByNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTripsByNumberQuery, GetTripsByNumberQueryVariables>(GetTripsByNumberDocument, options);
        }
export type GetTripsByNumberQueryHookResult = ReturnType<typeof useGetTripsByNumberQuery>;
export type GetTripsByNumberLazyQueryHookResult = ReturnType<typeof useGetTripsByNumberLazyQuery>;
export type GetTripsByNumberQueryResult = Apollo.QueryResult<GetTripsByNumberQuery, GetTripsByNumberQueryVariables>;
export const GetStreamTokenDocument = gql`
    query getStreamToken($id: UUID!) {
  getStream {
    getFeedToken(feed: {id: $id}) {
      token
    }
  }
}
    `;

/**
 * __useGetStreamTokenQuery__
 *
 * To run a query within a React component, call `useGetStreamTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStreamTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStreamTokenQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStreamTokenQuery(baseOptions: Apollo.QueryHookOptions<GetStreamTokenQuery, GetStreamTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStreamTokenQuery, GetStreamTokenQueryVariables>(GetStreamTokenDocument, options);
      }
export function useGetStreamTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStreamTokenQuery, GetStreamTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStreamTokenQuery, GetStreamTokenQueryVariables>(GetStreamTokenDocument, options);
        }
export type GetStreamTokenQueryHookResult = ReturnType<typeof useGetStreamTokenQuery>;
export type GetStreamTokenLazyQueryHookResult = ReturnType<typeof useGetStreamTokenLazyQuery>;
export type GetStreamTokenQueryResult = Apollo.QueryResult<GetStreamTokenQuery, GetStreamTokenQueryVariables>;
export const InsertTripNoteDocument = gql`
    mutation insertTripNote($tripNote: InsertTripNote!) {
  insertTripNote(tripNote: $tripNote) {
    tripNote {
      id
      time
    }
  }
}
    `;
export type InsertTripNoteMutationFn = Apollo.MutationFunction<InsertTripNoteMutation, InsertTripNoteMutationVariables>;

/**
 * __useInsertTripNoteMutation__
 *
 * To run a mutation, you first call `useInsertTripNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertTripNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertTripNoteMutation, { data, loading, error }] = useInsertTripNoteMutation({
 *   variables: {
 *      tripNote: // value for 'tripNote'
 *   },
 * });
 */
export function useInsertTripNoteMutation(baseOptions?: Apollo.MutationHookOptions<InsertTripNoteMutation, InsertTripNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertTripNoteMutation, InsertTripNoteMutationVariables>(InsertTripNoteDocument, options);
      }
export type InsertTripNoteMutationHookResult = ReturnType<typeof useInsertTripNoteMutation>;
export type InsertTripNoteMutationResult = Apollo.MutationResult<InsertTripNoteMutation>;
export type InsertTripNoteMutationOptions = Apollo.BaseMutationOptions<InsertTripNoteMutation, InsertTripNoteMutationVariables>;
export const AssignTripDocument = gql`
    mutation AssignTrip($tripId: UUID!, $driverId: UUID!, $vehicleId: UUID!) {
  executeAssignTrip(
    command: {tripId: $tripId, driverId: $driverId, vehicleId: $vehicleId}
  ) {
    trip {
      id
    }
    succeeded
    errors
  }
}
    `;
export type AssignTripMutationFn = Apollo.MutationFunction<AssignTripMutation, AssignTripMutationVariables>;

/**
 * __useAssignTripMutation__
 *
 * To run a mutation, you first call `useAssignTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTripMutation, { data, loading, error }] = useAssignTripMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      driverId: // value for 'driverId'
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useAssignTripMutation(baseOptions?: Apollo.MutationHookOptions<AssignTripMutation, AssignTripMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignTripMutation, AssignTripMutationVariables>(AssignTripDocument, options);
      }
export type AssignTripMutationHookResult = ReturnType<typeof useAssignTripMutation>;
export type AssignTripMutationResult = Apollo.MutationResult<AssignTripMutation>;
export type AssignTripMutationOptions = Apollo.BaseMutationOptions<AssignTripMutation, AssignTripMutationVariables>;
export const MakeTripConfirmedDocument = gql`
    mutation makeTripConfirmed($tripId: UUID!) {
  executeForceTripStatus(
    command: {tripId: $tripId, newStatus: AwaitingAssignment}
  ) {
    trip {
      status
    }
  }
}
    `;
export type MakeTripConfirmedMutationFn = Apollo.MutationFunction<MakeTripConfirmedMutation, MakeTripConfirmedMutationVariables>;

/**
 * __useMakeTripConfirmedMutation__
 *
 * To run a mutation, you first call `useMakeTripConfirmedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeTripConfirmedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeTripConfirmedMutation, { data, loading, error }] = useMakeTripConfirmedMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useMakeTripConfirmedMutation(baseOptions?: Apollo.MutationHookOptions<MakeTripConfirmedMutation, MakeTripConfirmedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeTripConfirmedMutation, MakeTripConfirmedMutationVariables>(MakeTripConfirmedDocument, options);
      }
export type MakeTripConfirmedMutationHookResult = ReturnType<typeof useMakeTripConfirmedMutation>;
export type MakeTripConfirmedMutationResult = Apollo.MutationResult<MakeTripConfirmedMutation>;
export type MakeTripConfirmedMutationOptions = Apollo.BaseMutationOptions<MakeTripConfirmedMutation, MakeTripConfirmedMutationVariables>;
export const SearchTripsDocument = gql`
    query searchTrips($accountId: UUID!, $filter: TripSearchCriteria!, $orderBy: TripOrderBy, $skip: Int = 0, $limit: Int = 20) {
  trips {
    search(
      accountId: $accountId
      filter: $filter
      orderBy: $orderBy
      limit: $limit
      skip: $skip
    ) {
      total
      items {
        id
        currentOrNextWaypoint {
          id
          role
        }
        isShared
        providerSource
        passengerCount
        luggageCount
        sharedTrip {
          amount
          token
          id
          paymentMethodType
          contact {
            name
            email
            phoneNumber
          }
          status
          savoyaAssignmentStatus
          vendorExternalId
        }
        paymentMethodId
        paymentMethodType
        estimatedSpotTimeInMinutes
        wasBookedByPassenger
        accountId
        pickupTime
        estimatedDurationInMinutes
        estimatedRevenue
        status
        tripNumber
        customerId
        stagingNotes
        preferredVehicleClass {
          name
        }
        notes {
          id
          content
        }
        driver {
          accountId
          drivingSince
          id
          isActive
          name
          imageUrl
        }
        driverId
        vehicle {
          id
          makeName
          modelName
          name
          vin
          year
          licenseNumber
          color
        }
        vehicleId
        estimatedDurationInMinutes
        estimatedDistanceInMiles
        estimatedOnLocationTime
        estimatedAvailabilityTime
        pickupWaypoint {
          role
          airline {
            IATA
            name
          }
          airlineId
          fbo {
            id
            iata_code
            fbo_name
          }
          fboId
          iataCode
          flightNumber
          departureTime
          arrivalTime
          verifiedFlightId
          verifiedFlight
          flightTime
          location {
            timezone
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            coordinates
            placeCategory
            placeWikidataId
            placeFoursquareId
            placeType
          }
          estimatedDurationInMinutes
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        dropoffWaypoint {
          role
          airline {
            IATA
            name
          }
          airlineId
          fbo {
            id
            iata_code
            fbo_name
          }
          fboId
          iataCode
          flightNumber
          departureTime
          arrivalTime
          verifiedFlightId
          verifiedFlight
          flightTime
          location {
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            coordinates
            placeCategory
            placeFoursquareId
            placeWikidataId
            placeType
          }
          estimatedDurationInMinutes
          estimatedDepartureTime
          estimatedArrivalTime
          savoyaStop
        }
        waypoints {
          id
          role
          order
          airline {
            IATA
            name
          }
          airlineId
          fbo {
            id
            iata_code
            fbo_name
          }
          fboId
          iataCode
          flightNumber
          verifiedFlight
          flightTime
          location {
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            coordinates
            placeCategory
            placeFoursquareId
            placeWikidataId
            placeType
          }
          estimatedDurationInMinutes
          estimatedDepartureTime
          estimatedArrivalTime
          order
          savoyaStop
          note
        }
        invoice {
          id
          status
          type
          total
          lineItems {
            id
            name
            unitPrice
            quantity
            total
          }
          transactions {
            id
            type
            status
            paymentMethodType
            note
            amount
            reversalOfTransactionId
            accountId
            invoiceId
            refundedAmount
          }
          payments
          balance
          externalId
          invoiceProcessor
          externalInvoiceLink
        }
        segments {
          startWaypointId
          endWaypointId
          estimatedDistanceInMiles
          estimatedDurationInMinutes
          durationInMinutes
          distanceInMiles
          order
        }
        isDirected
        estimatedDurationInMinutesOverride
        overrideDropoffWaypointDetails
        referenceNumber
        providerExternalId
        availableCommands {
          typeName
          name
          isPrimary
          disabled
          description
          events
          hidden
        }
        sharedAvailableCommands {
          typeName
          name
          isPrimary
          disabled
          description
          events
          hidden
        }
        groundworkTrip
      }
    }
  }
}
    `;

/**
 * __useSearchTripsQuery__
 *
 * To run a query within a React component, call `useSearchTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTripsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchTripsQuery(baseOptions: Apollo.QueryHookOptions<SearchTripsQuery, SearchTripsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTripsQuery, SearchTripsQueryVariables>(SearchTripsDocument, options);
      }
export function useSearchTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTripsQuery, SearchTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTripsQuery, SearchTripsQueryVariables>(SearchTripsDocument, options);
        }
export type SearchTripsQueryHookResult = ReturnType<typeof useSearchTripsQuery>;
export type SearchTripsLazyQueryHookResult = ReturnType<typeof useSearchTripsLazyQuery>;
export type SearchTripsQueryResult = Apollo.QueryResult<SearchTripsQuery, SearchTripsQueryVariables>;
export const SearchTripsByCustomerDocument = gql`
    query searchTripsByCustomer($accountId: UUID!, $filter: TripSearchCriteria!, $orderBy: TripOrderBy, $skip: Int = 0, $limit: Int = 5) {
  trips {
    search(
      accountId: $accountId
      filter: $filter
      orderBy: $orderBy
      limit: $limit
      skip: $skip
    ) {
      total
      items {
        id
        accountId
        status
        tripNumber
        pickupTime
        preferredVehicleClassId
        vehicle {
          vehicleClass {
            name
          }
        }
        invoice {
          total
        }
        pickupWaypoint {
          savoyaStop
          role
          location {
            coordinates
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            placeCategory
          }
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
        }
        referenceNumber
        providerExternalId
        groundworkTrip
      }
    }
  }
}
    `;

/**
 * __useSearchTripsByCustomerQuery__
 *
 * To run a query within a React component, call `useSearchTripsByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTripsByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTripsByCustomerQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchTripsByCustomerQuery(baseOptions: Apollo.QueryHookOptions<SearchTripsByCustomerQuery, SearchTripsByCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchTripsByCustomerQuery, SearchTripsByCustomerQueryVariables>(SearchTripsByCustomerDocument, options);
      }
export function useSearchTripsByCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchTripsByCustomerQuery, SearchTripsByCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchTripsByCustomerQuery, SearchTripsByCustomerQueryVariables>(SearchTripsByCustomerDocument, options);
        }
export type SearchTripsByCustomerQueryHookResult = ReturnType<typeof useSearchTripsByCustomerQuery>;
export type SearchTripsByCustomerLazyQueryHookResult = ReturnType<typeof useSearchTripsByCustomerLazyQuery>;
export type SearchTripsByCustomerQueryResult = Apollo.QueryResult<SearchTripsByCustomerQuery, SearchTripsByCustomerQueryVariables>;
export const SensorReadingsByTripIdDocument = gql`
    query sensorReadingsByTripId($tripId: UUID!) {
  vehicleSensorReadings {
    byTrip(tripId: $tripId) {
      items {
        coordinates
      }
    }
  }
}
    `;

/**
 * __useSensorReadingsByTripIdQuery__
 *
 * To run a query within a React component, call `useSensorReadingsByTripIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSensorReadingsByTripIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSensorReadingsByTripIdQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useSensorReadingsByTripIdQuery(baseOptions: Apollo.QueryHookOptions<SensorReadingsByTripIdQuery, SensorReadingsByTripIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SensorReadingsByTripIdQuery, SensorReadingsByTripIdQueryVariables>(SensorReadingsByTripIdDocument, options);
      }
export function useSensorReadingsByTripIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SensorReadingsByTripIdQuery, SensorReadingsByTripIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SensorReadingsByTripIdQuery, SensorReadingsByTripIdQueryVariables>(SensorReadingsByTripIdDocument, options);
        }
export type SensorReadingsByTripIdQueryHookResult = ReturnType<typeof useSensorReadingsByTripIdQuery>;
export type SensorReadingsByTripIdLazyQueryHookResult = ReturnType<typeof useSensorReadingsByTripIdLazyQuery>;
export type SensorReadingsByTripIdQueryResult = Apollo.QueryResult<SensorReadingsByTripIdQuery, SensorReadingsByTripIdQueryVariables>;
export const SensorReadingsByTripActualRouteDocument = gql`
    query sensorReadingsByTripActualRoute($tripId: UUID!) {
  vehicleSensorReadings {
    byTripActualRoute(tripId: $tripId) {
      items {
        coordinates
      }
    }
  }
}
    `;

/**
 * __useSensorReadingsByTripActualRouteQuery__
 *
 * To run a query within a React component, call `useSensorReadingsByTripActualRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSensorReadingsByTripActualRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSensorReadingsByTripActualRouteQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useSensorReadingsByTripActualRouteQuery(baseOptions: Apollo.QueryHookOptions<SensorReadingsByTripActualRouteQuery, SensorReadingsByTripActualRouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SensorReadingsByTripActualRouteQuery, SensorReadingsByTripActualRouteQueryVariables>(SensorReadingsByTripActualRouteDocument, options);
      }
export function useSensorReadingsByTripActualRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SensorReadingsByTripActualRouteQuery, SensorReadingsByTripActualRouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SensorReadingsByTripActualRouteQuery, SensorReadingsByTripActualRouteQueryVariables>(SensorReadingsByTripActualRouteDocument, options);
        }
export type SensorReadingsByTripActualRouteQueryHookResult = ReturnType<typeof useSensorReadingsByTripActualRouteQuery>;
export type SensorReadingsByTripActualRouteLazyQueryHookResult = ReturnType<typeof useSensorReadingsByTripActualRouteLazyQuery>;
export type SensorReadingsByTripActualRouteQueryResult = Apollo.QueryResult<SensorReadingsByTripActualRouteQuery, SensorReadingsByTripActualRouteQueryVariables>;
export const SearchCustomerByNameDocument = gql`
    query searchCustomerByName($accountId: UUID, $query: String!) {
  customers {
    searchByName(accountId: $accountId, query: $query) {
      items {
        accountId
        id
        name
        type
      }
      total
    }
  }
}
    `;

/**
 * __useSearchCustomerByNameQuery__
 *
 * To run a query within a React component, call `useSearchCustomerByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomerByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomerByNameQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchCustomerByNameQuery(baseOptions: Apollo.QueryHookOptions<SearchCustomerByNameQuery, SearchCustomerByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomerByNameQuery, SearchCustomerByNameQueryVariables>(SearchCustomerByNameDocument, options);
      }
export function useSearchCustomerByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomerByNameQuery, SearchCustomerByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomerByNameQuery, SearchCustomerByNameQueryVariables>(SearchCustomerByNameDocument, options);
        }
export type SearchCustomerByNameQueryHookResult = ReturnType<typeof useSearchCustomerByNameQuery>;
export type SearchCustomerByNameLazyQueryHookResult = ReturnType<typeof useSearchCustomerByNameLazyQuery>;
export type SearchCustomerByNameQueryResult = Apollo.QueryResult<SearchCustomerByNameQuery, SearchCustomerByNameQueryVariables>;
export const SearchByContactNameDocument = gql`
    query searchByContactName($customerId: UUID, $query: String!) {
  customerContacts {
    searchByContactName(customerId: $customerId, query: $query) {
      items {
        id
        contact {
          id
          name
          phoneNumber
          email
        }
      }
      total
    }
  }
}
    `;

/**
 * __useSearchByContactNameQuery__
 *
 * To run a query within a React component, call `useSearchByContactNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchByContactNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchByContactNameQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchByContactNameQuery(baseOptions: Apollo.QueryHookOptions<SearchByContactNameQuery, SearchByContactNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchByContactNameQuery, SearchByContactNameQueryVariables>(SearchByContactNameDocument, options);
      }
export function useSearchByContactNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchByContactNameQuery, SearchByContactNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchByContactNameQuery, SearchByContactNameQueryVariables>(SearchByContactNameDocument, options);
        }
export type SearchByContactNameQueryHookResult = ReturnType<typeof useSearchByContactNameQuery>;
export type SearchByContactNameLazyQueryHookResult = ReturnType<typeof useSearchByContactNameLazyQuery>;
export type SearchByContactNameQueryResult = Apollo.QueryResult<SearchByContactNameQuery, SearchByContactNameQueryVariables>;
export const GetContactsByCustomerDocument = gql`
    query GetContactsByCustomer($customerId: UUID!) {
  customerContacts {
    all(skip: 0, take: 0, customerId: $customerId) {
      total
      items {
        id
        contact {
          id
          name
          phoneNumber
          email
        }
        primaryRole
      }
    }
  }
}
    `;

/**
 * __useGetContactsByCustomerQuery__
 *
 * To run a query within a React component, call `useGetContactsByCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsByCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsByCustomerQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetContactsByCustomerQuery(baseOptions: Apollo.QueryHookOptions<GetContactsByCustomerQuery, GetContactsByCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsByCustomerQuery, GetContactsByCustomerQueryVariables>(GetContactsByCustomerDocument, options);
      }
export function useGetContactsByCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsByCustomerQuery, GetContactsByCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsByCustomerQuery, GetContactsByCustomerQueryVariables>(GetContactsByCustomerDocument, options);
        }
export type GetContactsByCustomerQueryHookResult = ReturnType<typeof useGetContactsByCustomerQuery>;
export type GetContactsByCustomerLazyQueryHookResult = ReturnType<typeof useGetContactsByCustomerLazyQuery>;
export type GetContactsByCustomerQueryResult = Apollo.QueryResult<GetContactsByCustomerQuery, GetContactsByCustomerQueryVariables>;
export const GetInProcessTripsDocument = gql`
    query getInProcessTrips($accountId: UUID!) {
  trips {
    search(accountId: $accountId, filter: {completionStatus: InProcess}) {
      items {
        id
        isShared
        providerSource
        sharedTrip {
          amount
          token
          id
          paymentMethodType
          contact {
            name
            email
            phoneNumber
          }
          status
          savoyaAssignmentStatus
        }
        accountId
        pickupTime
        status
        tripNumber
        availableCommands {
          name
          typeName
          events
          description
          hidden
          disabled
        }
        pickupWaypoint {
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
          departureTime
          arrivalTime
          estimatedDepartureTime
          estimatedArrivalTime
          location {
            placeName
            addressLine1
            coordinates
            city
            state
            postalCode
            placeCategory
          }
          savoyaStop
        }
        dropoffWaypoint {
          savoyaStop
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
          departureTime
          arrivalTime
          estimatedDepartureTime
          estimatedArrivalTime
          location {
            placeName
            addressLine1
            coordinates
            city
            state
            postalCode
            placeCategory
          }
          savoyaStop
        }
        waypoints {
          id
          role
          order
          location {
            name
            addressLine1
            addressLine2
            coordinates
            city
            state
            postalCode
          }
          savoyaStop
        }
        preferredVehicleClass {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetInProcessTripsQuery__
 *
 * To run a query within a React component, call `useGetInProcessTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInProcessTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInProcessTripsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetInProcessTripsQuery(baseOptions: Apollo.QueryHookOptions<GetInProcessTripsQuery, GetInProcessTripsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInProcessTripsQuery, GetInProcessTripsQueryVariables>(GetInProcessTripsDocument, options);
      }
export function useGetInProcessTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInProcessTripsQuery, GetInProcessTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInProcessTripsQuery, GetInProcessTripsQueryVariables>(GetInProcessTripsDocument, options);
        }
export type GetInProcessTripsQueryHookResult = ReturnType<typeof useGetInProcessTripsQuery>;
export type GetInProcessTripsLazyQueryHookResult = ReturnType<typeof useGetInProcessTripsLazyQuery>;
export type GetInProcessTripsQueryResult = Apollo.QueryResult<GetInProcessTripsQuery, GetInProcessTripsQueryVariables>;
export const GetNotificationTypesDocument = gql`
    query getNotificationTypes {
  tripNotificationTypes {
    all {
      items {
        id
        name
        trigger
        order
        enabled
      }
    }
  }
}
    `;

/**
 * __useGetNotificationTypesQuery__
 *
 * To run a query within a React component, call `useGetNotificationTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetNotificationTypesQuery, GetNotificationTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationTypesQuery, GetNotificationTypesQueryVariables>(GetNotificationTypesDocument, options);
      }
export function useGetNotificationTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationTypesQuery, GetNotificationTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationTypesQuery, GetNotificationTypesQueryVariables>(GetNotificationTypesDocument, options);
        }
export type GetNotificationTypesQueryHookResult = ReturnType<typeof useGetNotificationTypesQuery>;
export type GetNotificationTypesLazyQueryHookResult = ReturnType<typeof useGetNotificationTypesLazyQuery>;
export type GetNotificationTypesQueryResult = Apollo.QueryResult<GetNotificationTypesQuery, GetNotificationTypesQueryVariables>;
export const InsertTripAddonDocument = gql`
    mutation insertTripAddon($tripAddon: InsertTripAddon!) {
  insertTripAddon(tripAddon: $tripAddon) {
    tripAddon {
      id
      tripId
      rateTypeId
      quantity
      unitPrice
      total
      note
      calculation
    }
  }
}
    `;
export type InsertTripAddonMutationFn = Apollo.MutationFunction<InsertTripAddonMutation, InsertTripAddonMutationVariables>;

/**
 * __useInsertTripAddonMutation__
 *
 * To run a mutation, you first call `useInsertTripAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertTripAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertTripAddonMutation, { data, loading, error }] = useInsertTripAddonMutation({
 *   variables: {
 *      tripAddon: // value for 'tripAddon'
 *   },
 * });
 */
export function useInsertTripAddonMutation(baseOptions?: Apollo.MutationHookOptions<InsertTripAddonMutation, InsertTripAddonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertTripAddonMutation, InsertTripAddonMutationVariables>(InsertTripAddonDocument, options);
      }
export type InsertTripAddonMutationHookResult = ReturnType<typeof useInsertTripAddonMutation>;
export type InsertTripAddonMutationResult = Apollo.MutationResult<InsertTripAddonMutation>;
export type InsertTripAddonMutationOptions = Apollo.BaseMutationOptions<InsertTripAddonMutation, InsertTripAddonMutationVariables>;
export const UpdateTripAddonDocument = gql`
    mutation updateTripAddon($tripAddon: UpdateTripAddon!) {
  updateTripAddon(tripAddon: $tripAddon) {
    tripAddon {
      id
      tripId
      rateTypeId
      quantity
      unitPrice
      total
      note
    }
  }
}
    `;
export type UpdateTripAddonMutationFn = Apollo.MutationFunction<UpdateTripAddonMutation, UpdateTripAddonMutationVariables>;

/**
 * __useUpdateTripAddonMutation__
 *
 * To run a mutation, you first call `useUpdateTripAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTripAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTripAddonMutation, { data, loading, error }] = useUpdateTripAddonMutation({
 *   variables: {
 *      tripAddon: // value for 'tripAddon'
 *   },
 * });
 */
export function useUpdateTripAddonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTripAddonMutation, UpdateTripAddonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTripAddonMutation, UpdateTripAddonMutationVariables>(UpdateTripAddonDocument, options);
      }
export type UpdateTripAddonMutationHookResult = ReturnType<typeof useUpdateTripAddonMutation>;
export type UpdateTripAddonMutationResult = Apollo.MutationResult<UpdateTripAddonMutation>;
export type UpdateTripAddonMutationOptions = Apollo.BaseMutationOptions<UpdateTripAddonMutation, UpdateTripAddonMutationVariables>;
export const DeleteTripAddonDocument = gql`
    mutation deleteTripAddon($tripAddonId: UUID!) {
  deleteTripAddon(tripAddon: {id: $tripAddonId}) {
    success
    errors {
      message
    }
  }
}
    `;
export type DeleteTripAddonMutationFn = Apollo.MutationFunction<DeleteTripAddonMutation, DeleteTripAddonMutationVariables>;

/**
 * __useDeleteTripAddonMutation__
 *
 * To run a mutation, you first call `useDeleteTripAddonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTripAddonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTripAddonMutation, { data, loading, error }] = useDeleteTripAddonMutation({
 *   variables: {
 *      tripAddonId: // value for 'tripAddonId'
 *   },
 * });
 */
export function useDeleteTripAddonMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTripAddonMutation, DeleteTripAddonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTripAddonMutation, DeleteTripAddonMutationVariables>(DeleteTripAddonDocument, options);
      }
export type DeleteTripAddonMutationHookResult = ReturnType<typeof useDeleteTripAddonMutation>;
export type DeleteTripAddonMutationResult = Apollo.MutationResult<DeleteTripAddonMutation>;
export type DeleteTripAddonMutationOptions = Apollo.BaseMutationOptions<DeleteTripAddonMutation, DeleteTripAddonMutationVariables>;
export const ListFbOsByIataCodeDocument = gql`
    query listFBOsByIataCode($iata: String!) {
  fbos {
    byIataCode(iata: $iata) {
      items {
        id
        iata_code
        icao_code
        fbo_name
        fbo_address
        fbo_postal_code
      }
    }
  }
}
    `;

/**
 * __useListFbOsByIataCodeQuery__
 *
 * To run a query within a React component, call `useListFbOsByIataCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFbOsByIataCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFbOsByIataCodeQuery({
 *   variables: {
 *      iata: // value for 'iata'
 *   },
 * });
 */
export function useListFbOsByIataCodeQuery(baseOptions: Apollo.QueryHookOptions<ListFbOsByIataCodeQuery, ListFbOsByIataCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFbOsByIataCodeQuery, ListFbOsByIataCodeQueryVariables>(ListFbOsByIataCodeDocument, options);
      }
export function useListFbOsByIataCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFbOsByIataCodeQuery, ListFbOsByIataCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFbOsByIataCodeQuery, ListFbOsByIataCodeQueryVariables>(ListFbOsByIataCodeDocument, options);
        }
export type ListFbOsByIataCodeQueryHookResult = ReturnType<typeof useListFbOsByIataCodeQuery>;
export type ListFbOsByIataCodeLazyQueryHookResult = ReturnType<typeof useListFbOsByIataCodeLazyQuery>;
export type ListFbOsByIataCodeQueryResult = Apollo.QueryResult<ListFbOsByIataCodeQuery, ListFbOsByIataCodeQueryVariables>;
export const VerifyTripWaypointFlightDocument = gql`
    mutation verifyTripWaypointFlight($waypoint: UpsertTripWaypointInput!, $travelDate: String) {
  verifyTripWaypointFlight(waypoint: $waypoint, travelDate: $travelDate) {
    verifiedFlight
    success
    errors {
      code
      message
    }
  }
}
    `;
export type VerifyTripWaypointFlightMutationFn = Apollo.MutationFunction<VerifyTripWaypointFlightMutation, VerifyTripWaypointFlightMutationVariables>;

/**
 * __useVerifyTripWaypointFlightMutation__
 *
 * To run a mutation, you first call `useVerifyTripWaypointFlightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyTripWaypointFlightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyTripWaypointFlightMutation, { data, loading, error }] = useVerifyTripWaypointFlightMutation({
 *   variables: {
 *      waypoint: // value for 'waypoint'
 *      travelDate: // value for 'travelDate'
 *   },
 * });
 */
export function useVerifyTripWaypointFlightMutation(baseOptions?: Apollo.MutationHookOptions<VerifyTripWaypointFlightMutation, VerifyTripWaypointFlightMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyTripWaypointFlightMutation, VerifyTripWaypointFlightMutationVariables>(VerifyTripWaypointFlightDocument, options);
      }
export type VerifyTripWaypointFlightMutationHookResult = ReturnType<typeof useVerifyTripWaypointFlightMutation>;
export type VerifyTripWaypointFlightMutationResult = Apollo.MutationResult<VerifyTripWaypointFlightMutation>;
export type VerifyTripWaypointFlightMutationOptions = Apollo.BaseMutationOptions<VerifyTripWaypointFlightMutation, VerifyTripWaypointFlightMutationVariables>;
export const ExecuteCorrectTripTimestampDocument = gql`
    mutation executeCorrectTripTimestamp($command: CorrectTripTimestamp!) {
  executeCorrectTripTimestamp(command: $command) {
    succeeded
    errors
  }
}
    `;
export type ExecuteCorrectTripTimestampMutationFn = Apollo.MutationFunction<ExecuteCorrectTripTimestampMutation, ExecuteCorrectTripTimestampMutationVariables>;

/**
 * __useExecuteCorrectTripTimestampMutation__
 *
 * To run a mutation, you first call `useExecuteCorrectTripTimestampMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteCorrectTripTimestampMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeCorrectTripTimestampMutation, { data, loading, error }] = useExecuteCorrectTripTimestampMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useExecuteCorrectTripTimestampMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteCorrectTripTimestampMutation, ExecuteCorrectTripTimestampMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteCorrectTripTimestampMutation, ExecuteCorrectTripTimestampMutationVariables>(ExecuteCorrectTripTimestampDocument, options);
      }
export type ExecuteCorrectTripTimestampMutationHookResult = ReturnType<typeof useExecuteCorrectTripTimestampMutation>;
export type ExecuteCorrectTripTimestampMutationResult = Apollo.MutationResult<ExecuteCorrectTripTimestampMutation>;
export type ExecuteCorrectTripTimestampMutationOptions = Apollo.BaseMutationOptions<ExecuteCorrectTripTimestampMutation, ExecuteCorrectTripTimestampMutationVariables>;
export const ExecuteOverrideGarageTimeDocument = gql`
    mutation executeOverrideGarageTime($command: OverrideGarageTime!) {
  executeOverrideGarageTime(command: $command) {
    succeeded
    errors
  }
}
    `;
export type ExecuteOverrideGarageTimeMutationFn = Apollo.MutationFunction<ExecuteOverrideGarageTimeMutation, ExecuteOverrideGarageTimeMutationVariables>;

/**
 * __useExecuteOverrideGarageTimeMutation__
 *
 * To run a mutation, you first call `useExecuteOverrideGarageTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteOverrideGarageTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeOverrideGarageTimeMutation, { data, loading, error }] = useExecuteOverrideGarageTimeMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useExecuteOverrideGarageTimeMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteOverrideGarageTimeMutation, ExecuteOverrideGarageTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteOverrideGarageTimeMutation, ExecuteOverrideGarageTimeMutationVariables>(ExecuteOverrideGarageTimeDocument, options);
      }
export type ExecuteOverrideGarageTimeMutationHookResult = ReturnType<typeof useExecuteOverrideGarageTimeMutation>;
export type ExecuteOverrideGarageTimeMutationResult = Apollo.MutationResult<ExecuteOverrideGarageTimeMutation>;
export type ExecuteOverrideGarageTimeMutationOptions = Apollo.BaseMutationOptions<ExecuteOverrideGarageTimeMutation, ExecuteOverrideGarageTimeMutationVariables>;
export const ExecuteOverrideWaitTimeDocument = gql`
    mutation executeOverrideWaitTime($command: OverrideWaitTime!) {
  executeOverrideWaitTime(command: $command) {
    succeeded
    errors
  }
}
    `;
export type ExecuteOverrideWaitTimeMutationFn = Apollo.MutationFunction<ExecuteOverrideWaitTimeMutation, ExecuteOverrideWaitTimeMutationVariables>;

/**
 * __useExecuteOverrideWaitTimeMutation__
 *
 * To run a mutation, you first call `useExecuteOverrideWaitTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteOverrideWaitTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeOverrideWaitTimeMutation, { data, loading, error }] = useExecuteOverrideWaitTimeMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useExecuteOverrideWaitTimeMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteOverrideWaitTimeMutation, ExecuteOverrideWaitTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteOverrideWaitTimeMutation, ExecuteOverrideWaitTimeMutationVariables>(ExecuteOverrideWaitTimeDocument, options);
      }
export type ExecuteOverrideWaitTimeMutationHookResult = ReturnType<typeof useExecuteOverrideWaitTimeMutation>;
export type ExecuteOverrideWaitTimeMutationResult = Apollo.MutationResult<ExecuteOverrideWaitTimeMutation>;
export type ExecuteOverrideWaitTimeMutationOptions = Apollo.BaseMutationOptions<ExecuteOverrideWaitTimeMutation, ExecuteOverrideWaitTimeMutationVariables>;
export const CreateOrUpdateInvoiceSummaryForTripDocument = gql`
    mutation createOrUpdateInvoiceSummaryForTrip($tripId: UUID!) {
  createOrUpdateInvoiceSummaryForTrip(tripId: $tripId) {
    id
    type
    calculation
    baseQuantity
    baseUnitPrice
    baseTotal
    waitQuantity
    waitUnitPrice
    waitTotal
    rateId
    otherItems {
      addonId
      name
      category
      description
      unitPrice
      quantity
      total
    }
    total
    payments
    balance
    pickupGarageTime
    dropoffGarageTime
    tripStartedTime {
      scheduledTime
      billedTime
    }
    pickupTime {
      scheduledTime
      billedTime
    }
    dropoffTime {
      scheduledTime
      billedTime
    }
    tripCompletedTime {
      scheduledTime
      billedTime
    }
    transactions {
      type
      amount
      refundedAmount
      status
      createdAt
      paymentMethodType
      paymentMethod {
        id
        description
      }
      id
      stripePaymentIntentId
      note
    }
  }
}
    `;
export type CreateOrUpdateInvoiceSummaryForTripMutationFn = Apollo.MutationFunction<CreateOrUpdateInvoiceSummaryForTripMutation, CreateOrUpdateInvoiceSummaryForTripMutationVariables>;

/**
 * __useCreateOrUpdateInvoiceSummaryForTripMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateInvoiceSummaryForTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateInvoiceSummaryForTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateInvoiceSummaryForTripMutation, { data, loading, error }] = useCreateOrUpdateInvoiceSummaryForTripMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useCreateOrUpdateInvoiceSummaryForTripMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateInvoiceSummaryForTripMutation, CreateOrUpdateInvoiceSummaryForTripMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateInvoiceSummaryForTripMutation, CreateOrUpdateInvoiceSummaryForTripMutationVariables>(CreateOrUpdateInvoiceSummaryForTripDocument, options);
      }
export type CreateOrUpdateInvoiceSummaryForTripMutationHookResult = ReturnType<typeof useCreateOrUpdateInvoiceSummaryForTripMutation>;
export type CreateOrUpdateInvoiceSummaryForTripMutationResult = Apollo.MutationResult<CreateOrUpdateInvoiceSummaryForTripMutation>;
export type CreateOrUpdateInvoiceSummaryForTripMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateInvoiceSummaryForTripMutation, CreateOrUpdateInvoiceSummaryForTripMutationVariables>;
export const MonitoringSummaryDocument = gql`
    query monitoringSummary($monitoringToken: String!) {
  trips {
    monitoringSummary(monitoringToken: $monitoringToken) {
      accountName
      destination {
        role
        location {
          id
          name
          addressLine1
          city
          state
          postalCode
          coordinates
        }
      }
      position {
        createdAt
        coordinates
        heading
      }
      driver {
        name
        phoneNumber
        picture
      }
      vehicle {
        name
        licenseNumber
        picture
      }
      status
      stagingNotes
    }
  }
}
    `;

/**
 * __useMonitoringSummaryQuery__
 *
 * To run a query within a React component, call `useMonitoringSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMonitoringSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMonitoringSummaryQuery({
 *   variables: {
 *      monitoringToken: // value for 'monitoringToken'
 *   },
 * });
 */
export function useMonitoringSummaryQuery(baseOptions: Apollo.QueryHookOptions<MonitoringSummaryQuery, MonitoringSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MonitoringSummaryQuery, MonitoringSummaryQueryVariables>(MonitoringSummaryDocument, options);
      }
export function useMonitoringSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MonitoringSummaryQuery, MonitoringSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MonitoringSummaryQuery, MonitoringSummaryQueryVariables>(MonitoringSummaryDocument, options);
        }
export type MonitoringSummaryQueryHookResult = ReturnType<typeof useMonitoringSummaryQuery>;
export type MonitoringSummaryLazyQueryHookResult = ReturnType<typeof useMonitoringSummaryLazyQuery>;
export type MonitoringSummaryQueryResult = Apollo.QueryResult<MonitoringSummaryQuery, MonitoringSummaryQueryVariables>;
export const AccountMonitoringSummaryDocument = gql`
    query accountMonitoringSummary($tripId: UUID!) {
  trips {
    accountMonitoringSummary(tripId: $tripId) {
      accountName
      destination {
        role
        location {
          id
          name
          addressLine1
          city
          state
          postalCode
          coordinates
        }
      }
      position {
        createdAt
        coordinates
        heading
      }
      driver {
        name
        phoneNumber
        picture
      }
      vehicle {
        name
        licenseNumber
        picture
      }
      status
      stagingNotes
    }
  }
}
    `;

/**
 * __useAccountMonitoringSummaryQuery__
 *
 * To run a query within a React component, call `useAccountMonitoringSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountMonitoringSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountMonitoringSummaryQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useAccountMonitoringSummaryQuery(baseOptions: Apollo.QueryHookOptions<AccountMonitoringSummaryQuery, AccountMonitoringSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountMonitoringSummaryQuery, AccountMonitoringSummaryQueryVariables>(AccountMonitoringSummaryDocument, options);
      }
export function useAccountMonitoringSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountMonitoringSummaryQuery, AccountMonitoringSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountMonitoringSummaryQuery, AccountMonitoringSummaryQueryVariables>(AccountMonitoringSummaryDocument, options);
        }
export type AccountMonitoringSummaryQueryHookResult = ReturnType<typeof useAccountMonitoringSummaryQuery>;
export type AccountMonitoringSummaryLazyQueryHookResult = ReturnType<typeof useAccountMonitoringSummaryLazyQuery>;
export type AccountMonitoringSummaryQueryResult = Apollo.QueryResult<AccountMonitoringSummaryQuery, AccountMonitoringSummaryQueryVariables>;
export const GetInvoiceSummaryByTripDocument = gql`
    query getInvoiceSummaryByTrip($tripId: UUID!) {
  invoices {
    getSummaryByTripId(tripId: $tripId) {
      id
      type
      calculation
      baseQuantity
      baseUnitPrice
      baseTotal
      waitQuantity
      waitUnitPrice
      waitTotal
      rateId
      otherItems {
        addonId
        name
        category
        description
        unitPrice
        quantity
        total
      }
      total
      payments
      balance
      pickupGarageTime
      dropoffGarageTime
      tripStartedTime {
        scheduledTime
        billedTime
      }
      pickupTime {
        scheduledTime
        billedTime
      }
      dropoffTime {
        scheduledTime
        billedTime
      }
      tripCompletedTime {
        scheduledTime
        billedTime
      }
      transactions {
        type
        amount
        refundedAmount
        status
        createdAt
        paymentMethodType
        paymentMethod {
          id
          description
        }
        id
        stripePaymentIntentId
        note
      }
    }
  }
}
    `;

/**
 * __useGetInvoiceSummaryByTripQuery__
 *
 * To run a query within a React component, call `useGetInvoiceSummaryByTripQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceSummaryByTripQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceSummaryByTripQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useGetInvoiceSummaryByTripQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceSummaryByTripQuery, GetInvoiceSummaryByTripQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceSummaryByTripQuery, GetInvoiceSummaryByTripQueryVariables>(GetInvoiceSummaryByTripDocument, options);
      }
export function useGetInvoiceSummaryByTripLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceSummaryByTripQuery, GetInvoiceSummaryByTripQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceSummaryByTripQuery, GetInvoiceSummaryByTripQueryVariables>(GetInvoiceSummaryByTripDocument, options);
        }
export type GetInvoiceSummaryByTripQueryHookResult = ReturnType<typeof useGetInvoiceSummaryByTripQuery>;
export type GetInvoiceSummaryByTripLazyQueryHookResult = ReturnType<typeof useGetInvoiceSummaryByTripLazyQuery>;
export type GetInvoiceSummaryByTripQueryResult = Apollo.QueryResult<GetInvoiceSummaryByTripQuery, GetInvoiceSummaryByTripQueryVariables>;
export const ExecuteOverrideBaseRateDocument = gql`
    mutation executeOverrideBaseRate($command: OverrideBaseRate!) {
  executeOverrideBaseRate(command: $command) {
    succeeded
    errors
  }
}
    `;
export type ExecuteOverrideBaseRateMutationFn = Apollo.MutationFunction<ExecuteOverrideBaseRateMutation, ExecuteOverrideBaseRateMutationVariables>;

/**
 * __useExecuteOverrideBaseRateMutation__
 *
 * To run a mutation, you first call `useExecuteOverrideBaseRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteOverrideBaseRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeOverrideBaseRateMutation, { data, loading, error }] = useExecuteOverrideBaseRateMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useExecuteOverrideBaseRateMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteOverrideBaseRateMutation, ExecuteOverrideBaseRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteOverrideBaseRateMutation, ExecuteOverrideBaseRateMutationVariables>(ExecuteOverrideBaseRateDocument, options);
      }
export type ExecuteOverrideBaseRateMutationHookResult = ReturnType<typeof useExecuteOverrideBaseRateMutation>;
export type ExecuteOverrideBaseRateMutationResult = Apollo.MutationResult<ExecuteOverrideBaseRateMutation>;
export type ExecuteOverrideBaseRateMutationOptions = Apollo.BaseMutationOptions<ExecuteOverrideBaseRateMutation, ExecuteOverrideBaseRateMutationVariables>;
export const ExecuteUseDifferentClassRateDocument = gql`
    mutation executeUseDifferentClassRate($command: UseDifferentClassRate!) {
  executeUseDifferentClassRate(command: $command) {
    errors
    succeeded
    trip {
      id
    }
  }
}
    `;
export type ExecuteUseDifferentClassRateMutationFn = Apollo.MutationFunction<ExecuteUseDifferentClassRateMutation, ExecuteUseDifferentClassRateMutationVariables>;

/**
 * __useExecuteUseDifferentClassRateMutation__
 *
 * To run a mutation, you first call `useExecuteUseDifferentClassRateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteUseDifferentClassRateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeUseDifferentClassRateMutation, { data, loading, error }] = useExecuteUseDifferentClassRateMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useExecuteUseDifferentClassRateMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteUseDifferentClassRateMutation, ExecuteUseDifferentClassRateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteUseDifferentClassRateMutation, ExecuteUseDifferentClassRateMutationVariables>(ExecuteUseDifferentClassRateDocument, options);
      }
export type ExecuteUseDifferentClassRateMutationHookResult = ReturnType<typeof useExecuteUseDifferentClassRateMutation>;
export type ExecuteUseDifferentClassRateMutationResult = Apollo.MutationResult<ExecuteUseDifferentClassRateMutation>;
export type ExecuteUseDifferentClassRateMutationOptions = Apollo.BaseMutationOptions<ExecuteUseDifferentClassRateMutation, ExecuteUseDifferentClassRateMutationVariables>;
export const ExecuteApplyFlatRateOverrideDocument = gql`
    mutation executeApplyFlatRateOverride($command: ApplyFlatRateOverride!) {
  executeApplyFlatRateOverride(command: $command) {
    errors
    succeeded
    trip {
      id
    }
  }
}
    `;
export type ExecuteApplyFlatRateOverrideMutationFn = Apollo.MutationFunction<ExecuteApplyFlatRateOverrideMutation, ExecuteApplyFlatRateOverrideMutationVariables>;

/**
 * __useExecuteApplyFlatRateOverrideMutation__
 *
 * To run a mutation, you first call `useExecuteApplyFlatRateOverrideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteApplyFlatRateOverrideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeApplyFlatRateOverrideMutation, { data, loading, error }] = useExecuteApplyFlatRateOverrideMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useExecuteApplyFlatRateOverrideMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteApplyFlatRateOverrideMutation, ExecuteApplyFlatRateOverrideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteApplyFlatRateOverrideMutation, ExecuteApplyFlatRateOverrideMutationVariables>(ExecuteApplyFlatRateOverrideDocument, options);
      }
export type ExecuteApplyFlatRateOverrideMutationHookResult = ReturnType<typeof useExecuteApplyFlatRateOverrideMutation>;
export type ExecuteApplyFlatRateOverrideMutationResult = Apollo.MutationResult<ExecuteApplyFlatRateOverrideMutation>;
export type ExecuteApplyFlatRateOverrideMutationOptions = Apollo.BaseMutationOptions<ExecuteApplyFlatRateOverrideMutation, ExecuteApplyFlatRateOverrideMutationVariables>;
export const ExecuteAcceptNetworkOfferDocument = gql`
    mutation executeAcceptNetworkOffer($command: AcceptNetworkOffer!) {
  executeAcceptNetworkOffer(command: $command) {
    succeeded
    errors
    trip {
      id
    }
  }
}
    `;
export type ExecuteAcceptNetworkOfferMutationFn = Apollo.MutationFunction<ExecuteAcceptNetworkOfferMutation, ExecuteAcceptNetworkOfferMutationVariables>;

/**
 * __useExecuteAcceptNetworkOfferMutation__
 *
 * To run a mutation, you first call `useExecuteAcceptNetworkOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteAcceptNetworkOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeAcceptNetworkOfferMutation, { data, loading, error }] = useExecuteAcceptNetworkOfferMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useExecuteAcceptNetworkOfferMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteAcceptNetworkOfferMutation, ExecuteAcceptNetworkOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteAcceptNetworkOfferMutation, ExecuteAcceptNetworkOfferMutationVariables>(ExecuteAcceptNetworkOfferDocument, options);
      }
export type ExecuteAcceptNetworkOfferMutationHookResult = ReturnType<typeof useExecuteAcceptNetworkOfferMutation>;
export type ExecuteAcceptNetworkOfferMutationResult = Apollo.MutationResult<ExecuteAcceptNetworkOfferMutation>;
export type ExecuteAcceptNetworkOfferMutationOptions = Apollo.BaseMutationOptions<ExecuteAcceptNetworkOfferMutation, ExecuteAcceptNetworkOfferMutationVariables>;
export const ExecuteConfirmNetworkRequestDocument = gql`
    mutation executeConfirmNetworkRequest($command: ConfirmNetworkRequest!) {
  executeConfirmNetworkRequest(command: $command) {
    succeeded
    errors
    trip {
      id
    }
  }
}
    `;
export type ExecuteConfirmNetworkRequestMutationFn = Apollo.MutationFunction<ExecuteConfirmNetworkRequestMutation, ExecuteConfirmNetworkRequestMutationVariables>;

/**
 * __useExecuteConfirmNetworkRequestMutation__
 *
 * To run a mutation, you first call `useExecuteConfirmNetworkRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteConfirmNetworkRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeConfirmNetworkRequestMutation, { data, loading, error }] = useExecuteConfirmNetworkRequestMutation({
 *   variables: {
 *      command: // value for 'command'
 *   },
 * });
 */
export function useExecuteConfirmNetworkRequestMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteConfirmNetworkRequestMutation, ExecuteConfirmNetworkRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteConfirmNetworkRequestMutation, ExecuteConfirmNetworkRequestMutationVariables>(ExecuteConfirmNetworkRequestDocument, options);
      }
export type ExecuteConfirmNetworkRequestMutationHookResult = ReturnType<typeof useExecuteConfirmNetworkRequestMutation>;
export type ExecuteConfirmNetworkRequestMutationResult = Apollo.MutationResult<ExecuteConfirmNetworkRequestMutation>;
export type ExecuteConfirmNetworkRequestMutationOptions = Apollo.BaseMutationOptions<ExecuteConfirmNetworkRequestMutation, ExecuteConfirmNetworkRequestMutationVariables>;
export const DeclineNetworkOfferDocument = gql`
    mutation declineNetworkOffer($tripId: UUID!, $note: String) {
  executeDeclineNetworkOffer(command: {tripId: $tripId, note: $note}) {
    trip {
      id
      status
      isShared
      providerSource
    }
    succeeded
    errors
  }
}
    `;
export type DeclineNetworkOfferMutationFn = Apollo.MutationFunction<DeclineNetworkOfferMutation, DeclineNetworkOfferMutationVariables>;

/**
 * __useDeclineNetworkOfferMutation__
 *
 * To run a mutation, you first call `useDeclineNetworkOfferMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineNetworkOfferMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineNetworkOfferMutation, { data, loading, error }] = useDeclineNetworkOfferMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useDeclineNetworkOfferMutation(baseOptions?: Apollo.MutationHookOptions<DeclineNetworkOfferMutation, DeclineNetworkOfferMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineNetworkOfferMutation, DeclineNetworkOfferMutationVariables>(DeclineNetworkOfferDocument, options);
      }
export type DeclineNetworkOfferMutationHookResult = ReturnType<typeof useDeclineNetworkOfferMutation>;
export type DeclineNetworkOfferMutationResult = Apollo.MutationResult<DeclineNetworkOfferMutation>;
export type DeclineNetworkOfferMutationOptions = Apollo.BaseMutationOptions<DeclineNetworkOfferMutation, DeclineNetworkOfferMutationVariables>;
export const DeclineNetworkConfirmationRequestDocument = gql`
    mutation declineNetworkConfirmationRequest($tripId: UUID!, $note: String) {
  executeDeclineNetworkConfirmationRequest(
    command: {tripId: $tripId, note: $note}
  ) {
    trip {
      id
      status
      isShared
      providerSource
    }
    succeeded
    errors
  }
}
    `;
export type DeclineNetworkConfirmationRequestMutationFn = Apollo.MutationFunction<DeclineNetworkConfirmationRequestMutation, DeclineNetworkConfirmationRequestMutationVariables>;

/**
 * __useDeclineNetworkConfirmationRequestMutation__
 *
 * To run a mutation, you first call `useDeclineNetworkConfirmationRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineNetworkConfirmationRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineNetworkConfirmationRequestMutation, { data, loading, error }] = useDeclineNetworkConfirmationRequestMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useDeclineNetworkConfirmationRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeclineNetworkConfirmationRequestMutation, DeclineNetworkConfirmationRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineNetworkConfirmationRequestMutation, DeclineNetworkConfirmationRequestMutationVariables>(DeclineNetworkConfirmationRequestDocument, options);
      }
export type DeclineNetworkConfirmationRequestMutationHookResult = ReturnType<typeof useDeclineNetworkConfirmationRequestMutation>;
export type DeclineNetworkConfirmationRequestMutationResult = Apollo.MutationResult<DeclineNetworkConfirmationRequestMutation>;
export type DeclineNetworkConfirmationRequestMutationOptions = Apollo.BaseMutationOptions<DeclineNetworkConfirmationRequestMutation, DeclineNetworkConfirmationRequestMutationVariables>;
export const RevokeNetworkSharedTripDocument = gql`
    mutation revokeNetworkSharedTrip($tripId: UUID!) {
  executeRevokeNetworkSharedTrip(command: {tripId: $tripId}) {
    trip {
      id
      status
      isShared
      providerSource
    }
    succeeded
    errors
  }
}
    `;
export type RevokeNetworkSharedTripMutationFn = Apollo.MutationFunction<RevokeNetworkSharedTripMutation, RevokeNetworkSharedTripMutationVariables>;

/**
 * __useRevokeNetworkSharedTripMutation__
 *
 * To run a mutation, you first call `useRevokeNetworkSharedTripMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeNetworkSharedTripMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeNetworkSharedTripMutation, { data, loading, error }] = useRevokeNetworkSharedTripMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useRevokeNetworkSharedTripMutation(baseOptions?: Apollo.MutationHookOptions<RevokeNetworkSharedTripMutation, RevokeNetworkSharedTripMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeNetworkSharedTripMutation, RevokeNetworkSharedTripMutationVariables>(RevokeNetworkSharedTripDocument, options);
      }
export type RevokeNetworkSharedTripMutationHookResult = ReturnType<typeof useRevokeNetworkSharedTripMutation>;
export type RevokeNetworkSharedTripMutationResult = Apollo.MutationResult<RevokeNetworkSharedTripMutation>;
export type RevokeNetworkSharedTripMutationOptions = Apollo.BaseMutationOptions<RevokeNetworkSharedTripMutation, RevokeNetworkSharedTripMutationVariables>;
export const RollbackToOnsiteDocument = gql`
    mutation rollbackToOnsite($tripId: UUID!) {
  executeRollbackToOnsite(command: {tripId: $tripId}) {
    trip {
      id
      status
      isShared
      providerSource
    }
    succeeded
    errors
  }
}
    `;
export type RollbackToOnsiteMutationFn = Apollo.MutationFunction<RollbackToOnsiteMutation, RollbackToOnsiteMutationVariables>;

/**
 * __useRollbackToOnsiteMutation__
 *
 * To run a mutation, you first call `useRollbackToOnsiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRollbackToOnsiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rollbackToOnsiteMutation, { data, loading, error }] = useRollbackToOnsiteMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useRollbackToOnsiteMutation(baseOptions?: Apollo.MutationHookOptions<RollbackToOnsiteMutation, RollbackToOnsiteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RollbackToOnsiteMutation, RollbackToOnsiteMutationVariables>(RollbackToOnsiteDocument, options);
      }
export type RollbackToOnsiteMutationHookResult = ReturnType<typeof useRollbackToOnsiteMutation>;
export type RollbackToOnsiteMutationResult = Apollo.MutationResult<RollbackToOnsiteMutation>;
export type RollbackToOnsiteMutationOptions = Apollo.BaseMutationOptions<RollbackToOnsiteMutation, RollbackToOnsiteMutationVariables>;
export const GetNotificationSubscriptionByTripClientIdDocument = gql`
    query GetNotificationSubscriptionByTripClientId($tripClientId: UUID!) {
  tripNotificationSubscriptions {
    byTripClientId(tripClientId: $tripClientId) {
      items {
        id
        notificationTypeId
        tripContactId
        channels
        createdAt
        updatedAt
        deletedAt
        version
        notificationType {
          id
          name
          order
          trigger
          version
          updatedAt
          enabled
        }
      }
      total
    }
  }
}
    `;

/**
 * __useGetNotificationSubscriptionByTripClientIdQuery__
 *
 * To run a query within a React component, call `useGetNotificationSubscriptionByTripClientIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationSubscriptionByTripClientIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationSubscriptionByTripClientIdQuery({
 *   variables: {
 *      tripClientId: // value for 'tripClientId'
 *   },
 * });
 */
export function useGetNotificationSubscriptionByTripClientIdQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationSubscriptionByTripClientIdQuery, GetNotificationSubscriptionByTripClientIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationSubscriptionByTripClientIdQuery, GetNotificationSubscriptionByTripClientIdQueryVariables>(GetNotificationSubscriptionByTripClientIdDocument, options);
      }
export function useGetNotificationSubscriptionByTripClientIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationSubscriptionByTripClientIdQuery, GetNotificationSubscriptionByTripClientIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationSubscriptionByTripClientIdQuery, GetNotificationSubscriptionByTripClientIdQueryVariables>(GetNotificationSubscriptionByTripClientIdDocument, options);
        }
export type GetNotificationSubscriptionByTripClientIdQueryHookResult = ReturnType<typeof useGetNotificationSubscriptionByTripClientIdQuery>;
export type GetNotificationSubscriptionByTripClientIdLazyQueryHookResult = ReturnType<typeof useGetNotificationSubscriptionByTripClientIdLazyQuery>;
export type GetNotificationSubscriptionByTripClientIdQueryResult = Apollo.QueryResult<GetNotificationSubscriptionByTripClientIdQuery, GetNotificationSubscriptionByTripClientIdQueryVariables>;
export const GetOneActiveTripByIdsDocument = gql`
    query GetOneActiveTripByIds($tripIds: [UUID!]!) {
  trips {
    findOneActive(tripIds: $tripIds) {
      id
    }
  }
}
    `;

/**
 * __useGetOneActiveTripByIdsQuery__
 *
 * To run a query within a React component, call `useGetOneActiveTripByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOneActiveTripByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOneActiveTripByIdsQuery({
 *   variables: {
 *      tripIds: // value for 'tripIds'
 *   },
 * });
 */
export function useGetOneActiveTripByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetOneActiveTripByIdsQuery, GetOneActiveTripByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOneActiveTripByIdsQuery, GetOneActiveTripByIdsQueryVariables>(GetOneActiveTripByIdsDocument, options);
      }
export function useGetOneActiveTripByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOneActiveTripByIdsQuery, GetOneActiveTripByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOneActiveTripByIdsQuery, GetOneActiveTripByIdsQueryVariables>(GetOneActiveTripByIdsDocument, options);
        }
export type GetOneActiveTripByIdsQueryHookResult = ReturnType<typeof useGetOneActiveTripByIdsQuery>;
export type GetOneActiveTripByIdsLazyQueryHookResult = ReturnType<typeof useGetOneActiveTripByIdsLazyQuery>;
export type GetOneActiveTripByIdsQueryResult = Apollo.QueryResult<GetOneActiveTripByIdsQuery, GetOneActiveTripByIdsQueryVariables>;
export const PublicDetailsAccountDocument = gql`
    query publicDetailsAccount($bookingToken: String!) {
  accounts {
    publicDetailsAccount(bookingToken: $bookingToken) {
      id
      name
      description
      salesPitch
      legalName
      logoUrl
      videoUrl
      established
      primaryPhoneNumber
      primaryEmailAddress
      website
      bookingToken
      bookingToolEnabled
      displayRatesInBookingTool
      rates {
        defaultRate
        ratePolicies {
          thresholdValue
          thresholdValue2
          type
        }
        calculation
        meteredRateIncrement
        revertToDynamicForExcessWaitTime
      }
      garages {
        name
        id
        location {
          addressLine1
          city
          state
          postalCode
          coordinates
          placeName
          placeType
          placeCategory
        }
      }
    }
  }
}
    `;

/**
 * __usePublicDetailsAccountQuery__
 *
 * To run a query within a React component, call `usePublicDetailsAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicDetailsAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicDetailsAccountQuery({
 *   variables: {
 *      bookingToken: // value for 'bookingToken'
 *   },
 * });
 */
export function usePublicDetailsAccountQuery(baseOptions: Apollo.QueryHookOptions<PublicDetailsAccountQuery, PublicDetailsAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicDetailsAccountQuery, PublicDetailsAccountQueryVariables>(PublicDetailsAccountDocument, options);
      }
export function usePublicDetailsAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicDetailsAccountQuery, PublicDetailsAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicDetailsAccountQuery, PublicDetailsAccountQueryVariables>(PublicDetailsAccountDocument, options);
        }
export type PublicDetailsAccountQueryHookResult = ReturnType<typeof usePublicDetailsAccountQuery>;
export type PublicDetailsAccountLazyQueryHookResult = ReturnType<typeof usePublicDetailsAccountLazyQuery>;
export type PublicDetailsAccountQueryResult = Apollo.QueryResult<PublicDetailsAccountQuery, PublicDetailsAccountQueryVariables>;
export const PublicAllDocument = gql`
    query publicAll {
  tripNotificationTypes {
    publicAll {
      items {
        id
        name
        trigger
        order
        enabled
      }
    }
  }
}
    `;

/**
 * __usePublicAllQuery__
 *
 * To run a query within a React component, call `usePublicAllQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicAllQuery({
 *   variables: {
 *   },
 * });
 */
export function usePublicAllQuery(baseOptions?: Apollo.QueryHookOptions<PublicAllQuery, PublicAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicAllQuery, PublicAllQueryVariables>(PublicAllDocument, options);
      }
export function usePublicAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicAllQuery, PublicAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicAllQuery, PublicAllQueryVariables>(PublicAllDocument, options);
        }
export type PublicAllQueryHookResult = ReturnType<typeof usePublicAllQuery>;
export type PublicAllLazyQueryHookResult = ReturnType<typeof usePublicAllLazyQuery>;
export type PublicAllQueryResult = Apollo.QueryResult<PublicAllQuery, PublicAllQueryVariables>;
export const AllVehicleClassPublicDocument = gql`
    query allVehicleClassPublic($accountId: UUID!, $offset: Int = 0, $perPage: Int = 100) {
  vehicleClasses {
    allVehicleClassPublic(accountId: $accountId, skip: $offset, take: $perPage) {
      items {
        id
        accountId
        systemClassId
        systemClass {
          id
          name
          description
          defaultCostMultiplier
        }
        name
        imageUrl
        hourlyRate
        minimumHours
        cancellationPolicyHours
      }
      total
    }
  }
}
    `;

/**
 * __useAllVehicleClassPublicQuery__
 *
 * To run a query within a React component, call `useAllVehicleClassPublicQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllVehicleClassPublicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllVehicleClassPublicQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useAllVehicleClassPublicQuery(baseOptions: Apollo.QueryHookOptions<AllVehicleClassPublicQuery, AllVehicleClassPublicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllVehicleClassPublicQuery, AllVehicleClassPublicQueryVariables>(AllVehicleClassPublicDocument, options);
      }
export function useAllVehicleClassPublicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllVehicleClassPublicQuery, AllVehicleClassPublicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllVehicleClassPublicQuery, AllVehicleClassPublicQueryVariables>(AllVehicleClassPublicDocument, options);
        }
export type AllVehicleClassPublicQueryHookResult = ReturnType<typeof useAllVehicleClassPublicQuery>;
export type AllVehicleClassPublicLazyQueryHookResult = ReturnType<typeof useAllVehicleClassPublicLazyQuery>;
export type AllVehicleClassPublicQueryResult = Apollo.QueryResult<AllVehicleClassPublicQuery, AllVehicleClassPublicQueryVariables>;
export const RatesForBookingDocument = gql`
    query ratesForBooking($bookingToken: String!, $tripForm: InsertTrip!) {
  rates {
    ratesForBooking(bookingToken: $bookingToken, tripForm: $tripForm) {
      total
      vehicleClass {
        id
        accountId
        systemClassId
        systemClass {
          id
          name
          description
          defaultCostMultiplier
        }
        name
        imageUrl
        hourlyRate
        minimumHours
        cancellationPolicyHours
      }
    }
  }
}
    `;

/**
 * __useRatesForBookingQuery__
 *
 * To run a query within a React component, call `useRatesForBookingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatesForBookingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatesForBookingQuery({
 *   variables: {
 *      bookingToken: // value for 'bookingToken'
 *      tripForm: // value for 'tripForm'
 *   },
 * });
 */
export function useRatesForBookingQuery(baseOptions: Apollo.QueryHookOptions<RatesForBookingQuery, RatesForBookingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RatesForBookingQuery, RatesForBookingQueryVariables>(RatesForBookingDocument, options);
      }
export function useRatesForBookingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RatesForBookingQuery, RatesForBookingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RatesForBookingQuery, RatesForBookingQueryVariables>(RatesForBookingDocument, options);
        }
export type RatesForBookingQueryHookResult = ReturnType<typeof useRatesForBookingQuery>;
export type RatesForBookingLazyQueryHookResult = ReturnType<typeof useRatesForBookingLazyQuery>;
export type RatesForBookingQueryResult = Apollo.QueryResult<RatesForBookingQuery, RatesForBookingQueryVariables>;
export const FilesFromPathDocument = gql`
    query filesFromPath($bucket: String!, $key: String!) {
  media {
    filesFromPath(fileInfo: {bucket: $bucket, key: $key}) {
      signedUrls {
        url
        key
        metadata {
          type
        }
      }
    }
  }
}
    `;

/**
 * __useFilesFromPathQuery__
 *
 * To run a query within a React component, call `useFilesFromPathQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilesFromPathQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilesFromPathQuery({
 *   variables: {
 *      bucket: // value for 'bucket'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useFilesFromPathQuery(baseOptions: Apollo.QueryHookOptions<FilesFromPathQuery, FilesFromPathQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilesFromPathQuery, FilesFromPathQueryVariables>(FilesFromPathDocument, options);
      }
export function useFilesFromPathLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FilesFromPathQuery, FilesFromPathQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilesFromPathQuery, FilesFromPathQueryVariables>(FilesFromPathDocument, options);
        }
export type FilesFromPathQueryHookResult = ReturnType<typeof useFilesFromPathQuery>;
export type FilesFromPathLazyQueryHookResult = ReturnType<typeof useFilesFromPathLazyQuery>;
export type FilesFromPathQueryResult = Apollo.QueryResult<FilesFromPathQuery, FilesFromPathQueryVariables>;
export const CurrentGarageDocument = gql`
    query currentGarage($accountId: UUID!, $driverId: UUID) {
  garages {
    current(accountId: $accountId, driverId: $driverId) {
      name
      location {
        addressLine1
        addressLine2
        city
        state
        country
        postalCode
        coordinates
        placeType
        placeCategory
        placeName
        placeId
      }
    }
  }
}
    `;

/**
 * __useCurrentGarageQuery__
 *
 * To run a query within a React component, call `useCurrentGarageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentGarageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentGarageQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useCurrentGarageQuery(baseOptions: Apollo.QueryHookOptions<CurrentGarageQuery, CurrentGarageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentGarageQuery, CurrentGarageQueryVariables>(CurrentGarageDocument, options);
      }
export function useCurrentGarageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentGarageQuery, CurrentGarageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentGarageQuery, CurrentGarageQueryVariables>(CurrentGarageDocument, options);
        }
export type CurrentGarageQueryHookResult = ReturnType<typeof useCurrentGarageQuery>;
export type CurrentGarageLazyQueryHookResult = ReturnType<typeof useCurrentGarageLazyQuery>;
export type CurrentGarageQueryResult = Apollo.QueryResult<CurrentGarageQuery, CurrentGarageQueryVariables>;
export const ExecuteCreateOrUpdateInvoiceDocument = gql`
    mutation executeCreateOrUpdateInvoice($tripId: UUID!, $type: InvoiceType) {
  executeCreateOrUpdateInvoice(command: {tripId: $tripId, type: $type}) {
    succeeded
  }
}
    `;
export type ExecuteCreateOrUpdateInvoiceMutationFn = Apollo.MutationFunction<ExecuteCreateOrUpdateInvoiceMutation, ExecuteCreateOrUpdateInvoiceMutationVariables>;

/**
 * __useExecuteCreateOrUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useExecuteCreateOrUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteCreateOrUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeCreateOrUpdateInvoiceMutation, { data, loading, error }] = useExecuteCreateOrUpdateInvoiceMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useExecuteCreateOrUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteCreateOrUpdateInvoiceMutation, ExecuteCreateOrUpdateInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteCreateOrUpdateInvoiceMutation, ExecuteCreateOrUpdateInvoiceMutationVariables>(ExecuteCreateOrUpdateInvoiceDocument, options);
      }
export type ExecuteCreateOrUpdateInvoiceMutationHookResult = ReturnType<typeof useExecuteCreateOrUpdateInvoiceMutation>;
export type ExecuteCreateOrUpdateInvoiceMutationResult = Apollo.MutationResult<ExecuteCreateOrUpdateInvoiceMutation>;
export type ExecuteCreateOrUpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<ExecuteCreateOrUpdateInvoiceMutation, ExecuteCreateOrUpdateInvoiceMutationVariables>;
export const GetInvoicePdfDocument = gql`
    query getInvoicePDF($invoiceId: UUID!, $timeZone: String) {
  invoices {
    getPDF(id: $invoiceId, timeZone: $timeZone)
  }
}
    `;

/**
 * __useGetInvoicePdfQuery__
 *
 * To run a query within a React component, call `useGetInvoicePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePdfQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useGetInvoicePdfQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>(GetInvoicePdfDocument, options);
      }
export function useGetInvoicePdfLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>(GetInvoicePdfDocument, options);
        }
export type GetInvoicePdfQueryHookResult = ReturnType<typeof useGetInvoicePdfQuery>;
export type GetInvoicePdfLazyQueryHookResult = ReturnType<typeof useGetInvoicePdfLazyQuery>;
export type GetInvoicePdfQueryResult = Apollo.QueryResult<GetInvoicePdfQuery, GetInvoicePdfQueryVariables>;
export const SearchIndexedTripsDocument = gql`
    query searchIndexedTrips($accountId: UUID!, $filter: String) {
  trips {
    searchIndexed(accountId: $accountId, filter: $filter) {
      items {
        id
        tripNumber
        stagingNotes
        pickupTime
        status
        estimatedSpotTimeInMinutes
        pickupWaypoint {
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
          departureTime
          location {
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            coordinates
            placeCategory
          }
        }
        dropoffWaypoint {
          airline {
            IATA
            name
          }
          fbo {
            iata_code
            fbo_name
          }
          flightNumber
          location {
            name
            addressLine1
            addressLine2
            city
            state
            postalCode
            coordinates
            placeCategory
          }
        }
        providerExternalId
        groundworkTrip
        vehicleId
        driverId
      }
      total
    }
  }
}
    `;

/**
 * __useSearchIndexedTripsQuery__
 *
 * To run a query within a React component, call `useSearchIndexedTripsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchIndexedTripsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchIndexedTripsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchIndexedTripsQuery(baseOptions: Apollo.QueryHookOptions<SearchIndexedTripsQuery, SearchIndexedTripsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchIndexedTripsQuery, SearchIndexedTripsQueryVariables>(SearchIndexedTripsDocument, options);
      }
export function useSearchIndexedTripsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchIndexedTripsQuery, SearchIndexedTripsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchIndexedTripsQuery, SearchIndexedTripsQueryVariables>(SearchIndexedTripsDocument, options);
        }
export type SearchIndexedTripsQueryHookResult = ReturnType<typeof useSearchIndexedTripsQuery>;
export type SearchIndexedTripsLazyQueryHookResult = ReturnType<typeof useSearchIndexedTripsLazyQuery>;
export type SearchIndexedTripsQueryResult = Apollo.QueryResult<SearchIndexedTripsQuery, SearchIndexedTripsQueryVariables>;
export const ExecuteBeginPaymentMethodSetupDocument = gql`
    mutation executeBeginPaymentMethodSetup($tripId: UUID!) {
  executeBeginPaymentMethodSetup(command: {tripId: $tripId}) {
    trip {
      stripeSetupIntentId
    }
    succeeded
    errors
  }
}
    `;
export type ExecuteBeginPaymentMethodSetupMutationFn = Apollo.MutationFunction<ExecuteBeginPaymentMethodSetupMutation, ExecuteBeginPaymentMethodSetupMutationVariables>;

/**
 * __useExecuteBeginPaymentMethodSetupMutation__
 *
 * To run a mutation, you first call `useExecuteBeginPaymentMethodSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteBeginPaymentMethodSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeBeginPaymentMethodSetupMutation, { data, loading, error }] = useExecuteBeginPaymentMethodSetupMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useExecuteBeginPaymentMethodSetupMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteBeginPaymentMethodSetupMutation, ExecuteBeginPaymentMethodSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteBeginPaymentMethodSetupMutation, ExecuteBeginPaymentMethodSetupMutationVariables>(ExecuteBeginPaymentMethodSetupDocument, options);
      }
export type ExecuteBeginPaymentMethodSetupMutationHookResult = ReturnType<typeof useExecuteBeginPaymentMethodSetupMutation>;
export type ExecuteBeginPaymentMethodSetupMutationResult = Apollo.MutationResult<ExecuteBeginPaymentMethodSetupMutation>;
export type ExecuteBeginPaymentMethodSetupMutationOptions = Apollo.BaseMutationOptions<ExecuteBeginPaymentMethodSetupMutation, ExecuteBeginPaymentMethodSetupMutationVariables>;
export const ExecuteCreatePaymentMethodDocument = gql`
    mutation executeCreatePaymentMethod($tripId: UUID!, $externalPaymentMethodId: String!, $customerContactId: UUID, $source: CreditCardProcessor!) {
  executeCreatePaymentMethod(
    command: {tripId: $tripId, externalPaymentMethodId: $externalPaymentMethodId, customerContactId: $customerContactId, source: $source}
  ) {
    trip {
      paymentMethodId
      paymentMethod {
        description
      }
    }
    succeeded
  }
}
    `;
export type ExecuteCreatePaymentMethodMutationFn = Apollo.MutationFunction<ExecuteCreatePaymentMethodMutation, ExecuteCreatePaymentMethodMutationVariables>;

/**
 * __useExecuteCreatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useExecuteCreatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteCreatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeCreatePaymentMethodMutation, { data, loading, error }] = useExecuteCreatePaymentMethodMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      externalPaymentMethodId: // value for 'externalPaymentMethodId'
 *      customerContactId: // value for 'customerContactId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useExecuteCreatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteCreatePaymentMethodMutation, ExecuteCreatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteCreatePaymentMethodMutation, ExecuteCreatePaymentMethodMutationVariables>(ExecuteCreatePaymentMethodDocument, options);
      }
export type ExecuteCreatePaymentMethodMutationHookResult = ReturnType<typeof useExecuteCreatePaymentMethodMutation>;
export type ExecuteCreatePaymentMethodMutationResult = Apollo.MutationResult<ExecuteCreatePaymentMethodMutation>;
export type ExecuteCreatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<ExecuteCreatePaymentMethodMutation, ExecuteCreatePaymentMethodMutationVariables>;
export const ExecuteSetPaymentMethodDocument = gql`
    mutation executeSetPaymentMethod($tripId: UUID!, $paymentMethodId: UUID, $paymentMethodType: PaymentMethodType) {
  executeSetPaymentMethod(
    command: {tripId: $tripId, paymentMethodId: $paymentMethodId, paymentMethodType: $paymentMethodType}
  ) {
    succeeded
    trip {
      paymentMethod {
        description
      }
      paymentMethodId
      paymentMethodType
    }
  }
}
    `;
export type ExecuteSetPaymentMethodMutationFn = Apollo.MutationFunction<ExecuteSetPaymentMethodMutation, ExecuteSetPaymentMethodMutationVariables>;

/**
 * __useExecuteSetPaymentMethodMutation__
 *
 * To run a mutation, you first call `useExecuteSetPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteSetPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeSetPaymentMethodMutation, { data, loading, error }] = useExecuteSetPaymentMethodMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      paymentMethodId: // value for 'paymentMethodId'
 *      paymentMethodType: // value for 'paymentMethodType'
 *   },
 * });
 */
export function useExecuteSetPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteSetPaymentMethodMutation, ExecuteSetPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteSetPaymentMethodMutation, ExecuteSetPaymentMethodMutationVariables>(ExecuteSetPaymentMethodDocument, options);
      }
export type ExecuteSetPaymentMethodMutationHookResult = ReturnType<typeof useExecuteSetPaymentMethodMutation>;
export type ExecuteSetPaymentMethodMutationResult = Apollo.MutationResult<ExecuteSetPaymentMethodMutation>;
export type ExecuteSetPaymentMethodMutationOptions = Apollo.BaseMutationOptions<ExecuteSetPaymentMethodMutation, ExecuteSetPaymentMethodMutationVariables>;
export const GetPaymentMethodByTripDocument = gql`
    query getPaymentMethodByTrip($input: PaymentByTripInput!) {
  paymentMethods {
    byTrip(input: $input) {
      items {
        id
        description
        externalPaymentMethodId
        customerContactId
        source
      }
      total
    }
  }
}
    `;

/**
 * __useGetPaymentMethodByTripQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodByTripQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodByTripQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodByTripQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaymentMethodByTripQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentMethodByTripQuery, GetPaymentMethodByTripQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodByTripQuery, GetPaymentMethodByTripQueryVariables>(GetPaymentMethodByTripDocument, options);
      }
export function useGetPaymentMethodByTripLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodByTripQuery, GetPaymentMethodByTripQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodByTripQuery, GetPaymentMethodByTripQueryVariables>(GetPaymentMethodByTripDocument, options);
        }
export type GetPaymentMethodByTripQueryHookResult = ReturnType<typeof useGetPaymentMethodByTripQuery>;
export type GetPaymentMethodByTripLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodByTripLazyQuery>;
export type GetPaymentMethodByTripQueryResult = Apollo.QueryResult<GetPaymentMethodByTripQuery, GetPaymentMethodByTripQueryVariables>;
export const GetSetupClientIdForTripDocument = gql`
    query getSetupClientIdForTrip($tripId: UUID!) {
  stripe {
    getSetupClientIdForTrip(tripId: $tripId) {
      clientSecret
    }
  }
}
    `;

/**
 * __useGetSetupClientIdForTripQuery__
 *
 * To run a query within a React component, call `useGetSetupClientIdForTripQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSetupClientIdForTripQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSetupClientIdForTripQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useGetSetupClientIdForTripQuery(baseOptions: Apollo.QueryHookOptions<GetSetupClientIdForTripQuery, GetSetupClientIdForTripQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSetupClientIdForTripQuery, GetSetupClientIdForTripQueryVariables>(GetSetupClientIdForTripDocument, options);
      }
export function useGetSetupClientIdForTripLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSetupClientIdForTripQuery, GetSetupClientIdForTripQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSetupClientIdForTripQuery, GetSetupClientIdForTripQueryVariables>(GetSetupClientIdForTripDocument, options);
        }
export type GetSetupClientIdForTripQueryHookResult = ReturnType<typeof useGetSetupClientIdForTripQuery>;
export type GetSetupClientIdForTripLazyQueryHookResult = ReturnType<typeof useGetSetupClientIdForTripLazyQuery>;
export type GetSetupClientIdForTripQueryResult = Apollo.QueryResult<GetSetupClientIdForTripQuery, GetSetupClientIdForTripQueryVariables>;
export const ExecuteProcessPaymentDocument = gql`
    mutation executeProcessPayment($tripId: UUID!) {
  executeProcessPayment(command: {tripId: $tripId}) {
    trip {
      invoice {
        balance
      }
      paymentMethod {
        id
      }
      paymentMethodType
    }
    succeeded
    errors
  }
}
    `;
export type ExecuteProcessPaymentMutationFn = Apollo.MutationFunction<ExecuteProcessPaymentMutation, ExecuteProcessPaymentMutationVariables>;

/**
 * __useExecuteProcessPaymentMutation__
 *
 * To run a mutation, you first call `useExecuteProcessPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteProcessPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeProcessPaymentMutation, { data, loading, error }] = useExecuteProcessPaymentMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useExecuteProcessPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteProcessPaymentMutation, ExecuteProcessPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteProcessPaymentMutation, ExecuteProcessPaymentMutationVariables>(ExecuteProcessPaymentDocument, options);
      }
export type ExecuteProcessPaymentMutationHookResult = ReturnType<typeof useExecuteProcessPaymentMutation>;
export type ExecuteProcessPaymentMutationResult = Apollo.MutationResult<ExecuteProcessPaymentMutation>;
export type ExecuteProcessPaymentMutationOptions = Apollo.BaseMutationOptions<ExecuteProcessPaymentMutation, ExecuteProcessPaymentMutationVariables>;
export const GetPaymentMethodByCustomerContactDocument = gql`
    query getPaymentMethodByCustomerContact($input: PaymentByCustomerContactInput!) {
  paymentMethods {
    byCustomerContact(input: $input) {
      items {
        id
        description
        externalPaymentMethodId
        customerContactId
        source
      }
      total
    }
  }
}
    `;

/**
 * __useGetPaymentMethodByCustomerContactQuery__
 *
 * To run a query within a React component, call `useGetPaymentMethodByCustomerContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentMethodByCustomerContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentMethodByCustomerContactQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPaymentMethodByCustomerContactQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentMethodByCustomerContactQuery, GetPaymentMethodByCustomerContactQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentMethodByCustomerContactQuery, GetPaymentMethodByCustomerContactQueryVariables>(GetPaymentMethodByCustomerContactDocument, options);
      }
export function useGetPaymentMethodByCustomerContactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentMethodByCustomerContactQuery, GetPaymentMethodByCustomerContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentMethodByCustomerContactQuery, GetPaymentMethodByCustomerContactQueryVariables>(GetPaymentMethodByCustomerContactDocument, options);
        }
export type GetPaymentMethodByCustomerContactQueryHookResult = ReturnType<typeof useGetPaymentMethodByCustomerContactQuery>;
export type GetPaymentMethodByCustomerContactLazyQueryHookResult = ReturnType<typeof useGetPaymentMethodByCustomerContactLazyQuery>;
export type GetPaymentMethodByCustomerContactQueryResult = Apollo.QueryResult<GetPaymentMethodByCustomerContactQuery, GetPaymentMethodByCustomerContactQueryVariables>;
export const StartPaymentMethodSetupDocument = gql`
    mutation startPaymentMethodSetup($customerContactId: UUID!) {
  startPaymentMethodSetup(customerContactId: $customerContactId) {
    stripeSetupIntentId
    clientSecret
    success
    errors {
      message
      code
    }
  }
}
    `;
export type StartPaymentMethodSetupMutationFn = Apollo.MutationFunction<StartPaymentMethodSetupMutation, StartPaymentMethodSetupMutationVariables>;

/**
 * __useStartPaymentMethodSetupMutation__
 *
 * To run a mutation, you first call `useStartPaymentMethodSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPaymentMethodSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPaymentMethodSetupMutation, { data, loading, error }] = useStartPaymentMethodSetupMutation({
 *   variables: {
 *      customerContactId: // value for 'customerContactId'
 *   },
 * });
 */
export function useStartPaymentMethodSetupMutation(baseOptions?: Apollo.MutationHookOptions<StartPaymentMethodSetupMutation, StartPaymentMethodSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPaymentMethodSetupMutation, StartPaymentMethodSetupMutationVariables>(StartPaymentMethodSetupDocument, options);
      }
export type StartPaymentMethodSetupMutationHookResult = ReturnType<typeof useStartPaymentMethodSetupMutation>;
export type StartPaymentMethodSetupMutationResult = Apollo.MutationResult<StartPaymentMethodSetupMutation>;
export type StartPaymentMethodSetupMutationOptions = Apollo.BaseMutationOptions<StartPaymentMethodSetupMutation, StartPaymentMethodSetupMutationVariables>;
export const InsertPaymentMethodDocument = gql`
    mutation insertPaymentMethod($customerContactId: UUID!, $externalPaymentMethodId: String!, $source: CreditCardProcessor!) {
  insertPaymentMethod(
    customerContactId: $customerContactId
    externalPaymentMethodId: $externalPaymentMethodId
    source: $source
  ) {
    paymentMethodId
    paymentMethodDescription
    success
  }
}
    `;
export type InsertPaymentMethodMutationFn = Apollo.MutationFunction<InsertPaymentMethodMutation, InsertPaymentMethodMutationVariables>;

/**
 * __useInsertPaymentMethodMutation__
 *
 * To run a mutation, you first call `useInsertPaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPaymentMethodMutation, { data, loading, error }] = useInsertPaymentMethodMutation({
 *   variables: {
 *      customerContactId: // value for 'customerContactId'
 *      externalPaymentMethodId: // value for 'externalPaymentMethodId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useInsertPaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<InsertPaymentMethodMutation, InsertPaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPaymentMethodMutation, InsertPaymentMethodMutationVariables>(InsertPaymentMethodDocument, options);
      }
export type InsertPaymentMethodMutationHookResult = ReturnType<typeof useInsertPaymentMethodMutation>;
export type InsertPaymentMethodMutationResult = Apollo.MutationResult<InsertPaymentMethodMutation>;
export type InsertPaymentMethodMutationOptions = Apollo.BaseMutationOptions<InsertPaymentMethodMutation, InsertPaymentMethodMutationVariables>;
export const DeletePaymentMethodDocument = gql`
    mutation deletePaymentMethod($paymentMethodId: UUID!) {
  deletePaymentMethod(paymentMethodId: $paymentMethodId) {
    success
  }
}
    `;
export type DeletePaymentMethodMutationFn = Apollo.MutationFunction<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;

/**
 * __useDeletePaymentMethodMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMethodMutation, { data, loading, error }] = useDeletePaymentMethodMutation({
 *   variables: {
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useDeletePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>(DeletePaymentMethodDocument, options);
      }
export type DeletePaymentMethodMutationHookResult = ReturnType<typeof useDeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationResult = Apollo.MutationResult<DeletePaymentMethodMutation>;
export type DeletePaymentMethodMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMethodMutation, DeletePaymentMethodMutationVariables>;
export const ExecuteApplyRefundDocument = gql`
    mutation executeApplyRefund($tripId: UUID!, $amountRefunded: Float!, $refundReason: String!, $note: String) {
  executeApplyRefund(
    command: {tripId: $tripId, amountRefunded: $amountRefunded, refundReason: $refundReason, note: $note}
  ) {
    succeeded
    errors
  }
}
    `;
export type ExecuteApplyRefundMutationFn = Apollo.MutationFunction<ExecuteApplyRefundMutation, ExecuteApplyRefundMutationVariables>;

/**
 * __useExecuteApplyRefundMutation__
 *
 * To run a mutation, you first call `useExecuteApplyRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExecuteApplyRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [executeApplyRefundMutation, { data, loading, error }] = useExecuteApplyRefundMutation({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      amountRefunded: // value for 'amountRefunded'
 *      refundReason: // value for 'refundReason'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useExecuteApplyRefundMutation(baseOptions?: Apollo.MutationHookOptions<ExecuteApplyRefundMutation, ExecuteApplyRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExecuteApplyRefundMutation, ExecuteApplyRefundMutationVariables>(ExecuteApplyRefundDocument, options);
      }
export type ExecuteApplyRefundMutationHookResult = ReturnType<typeof useExecuteApplyRefundMutation>;
export type ExecuteApplyRefundMutationResult = Apollo.MutationResult<ExecuteApplyRefundMutation>;
export type ExecuteApplyRefundMutationOptions = Apollo.BaseMutationOptions<ExecuteApplyRefundMutation, ExecuteApplyRefundMutationVariables>;
export const UpdateTripNoteDocument = gql`
    mutation updateTripNote($tripNote: UpdateTripNote!) {
  updateTripNote(tripNote: $tripNote) {
    tripNote {
      id
      time
      content
    }
  }
}
    `;
export type UpdateTripNoteMutationFn = Apollo.MutationFunction<UpdateTripNoteMutation, UpdateTripNoteMutationVariables>;

/**
 * __useUpdateTripNoteMutation__
 *
 * To run a mutation, you first call `useUpdateTripNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTripNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTripNoteMutation, { data, loading, error }] = useUpdateTripNoteMutation({
 *   variables: {
 *      tripNote: // value for 'tripNote'
 *   },
 * });
 */
export function useUpdateTripNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTripNoteMutation, UpdateTripNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTripNoteMutation, UpdateTripNoteMutationVariables>(UpdateTripNoteDocument, options);
      }
export type UpdateTripNoteMutationHookResult = ReturnType<typeof useUpdateTripNoteMutation>;
export type UpdateTripNoteMutationResult = Apollo.MutationResult<UpdateTripNoteMutation>;
export type UpdateTripNoteMutationOptions = Apollo.BaseMutationOptions<UpdateTripNoteMutation, UpdateTripNoteMutationVariables>;
export const GetCustomersAndContacsDocument = gql`
    query getCustomersAndContacs($accountId: UUID!, $filter: String) {
  customerContacts {
    searchByIndex(accountId: $accountId, filter: $filter) {
      customerContacts {
        items {
          contact {
            name
            email
            phoneNumber
          }
          customer {
            name
            type
          }
          customerId
          id
          primaryRole
        }
        total
      }
      customers {
        items {
          name
          type
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetCustomersAndContacsQuery__
 *
 * To run a query within a React component, call `useGetCustomersAndContacsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersAndContacsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersAndContacsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCustomersAndContacsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersAndContacsQuery, GetCustomersAndContacsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersAndContacsQuery, GetCustomersAndContacsQueryVariables>(GetCustomersAndContacsDocument, options);
      }
export function useGetCustomersAndContacsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersAndContacsQuery, GetCustomersAndContacsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersAndContacsQuery, GetCustomersAndContacsQueryVariables>(GetCustomersAndContacsDocument, options);
        }
export type GetCustomersAndContacsQueryHookResult = ReturnType<typeof useGetCustomersAndContacsQuery>;
export type GetCustomersAndContacsLazyQueryHookResult = ReturnType<typeof useGetCustomersAndContacsLazyQuery>;
export type GetCustomersAndContacsQueryResult = Apollo.QueryResult<GetCustomersAndContacsQuery, GetCustomersAndContacsQueryVariables>;
export const GetEstimatedSummaryDocument = gql`
    query getEstimatedSummary($tripId: UUID!, $vehicleClassId: UUID!) {
  invoices {
    getEstimatedSummary(tripId: $tripId, vehicleClassId: $vehicleClassId) {
      id
      type
      calculation
      baseQuantity
      baseUnitPrice
      baseTotal
      waitQuantity
      waitUnitPrice
      waitTotal
      rateId
      otherItems {
        addonId
        name
        category
        description
        unitPrice
        quantity
        total
      }
      total
      payments
      balance
      pickupGarageTime
      dropoffGarageTime
      tripStartedTime {
        scheduledTime
        billedTime
      }
      pickupTime {
        scheduledTime
        billedTime
      }
      dropoffTime {
        scheduledTime
        billedTime
      }
      tripCompletedTime {
        scheduledTime
        billedTime
      }
      transactions {
        type
        amount
        refundedAmount
        status
        createdAt
        paymentMethodType
        paymentMethod {
          id
          description
        }
        id
        stripePaymentIntentId
        note
      }
    }
  }
}
    `;

/**
 * __useGetEstimatedSummaryQuery__
 *
 * To run a query within a React component, call `useGetEstimatedSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEstimatedSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEstimatedSummaryQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *      vehicleClassId: // value for 'vehicleClassId'
 *   },
 * });
 */
export function useGetEstimatedSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetEstimatedSummaryQuery, GetEstimatedSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEstimatedSummaryQuery, GetEstimatedSummaryQueryVariables>(GetEstimatedSummaryDocument, options);
      }
export function useGetEstimatedSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEstimatedSummaryQuery, GetEstimatedSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEstimatedSummaryQuery, GetEstimatedSummaryQueryVariables>(GetEstimatedSummaryDocument, options);
        }
export type GetEstimatedSummaryQueryHookResult = ReturnType<typeof useGetEstimatedSummaryQuery>;
export type GetEstimatedSummaryLazyQueryHookResult = ReturnType<typeof useGetEstimatedSummaryLazyQuery>;
export type GetEstimatedSummaryQueryResult = Apollo.QueryResult<GetEstimatedSummaryQuery, GetEstimatedSummaryQueryVariables>;
export const ListAllUsersByAccountDocument = gql`
    query ListAllUsersByAccount($accountId: UUID!, $offset: Int = 0, $perPage: Int = 20, $includeInactive: Boolean) {
  contacts {
    usersByAccount(
      accountId: $accountId
      skip: $offset
      take: $perPage
      includeInactive: $includeInactive
    ) {
      items {
        id
        name
        email
        isActive
        driver {
          id
          externalId
        }
      }
      total
    }
  }
}
    `;

/**
 * __useListAllUsersByAccountQuery__
 *
 * To run a query within a React component, call `useListAllUsersByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllUsersByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllUsersByAccountQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useListAllUsersByAccountQuery(baseOptions: Apollo.QueryHookOptions<ListAllUsersByAccountQuery, ListAllUsersByAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllUsersByAccountQuery, ListAllUsersByAccountQueryVariables>(ListAllUsersByAccountDocument, options);
      }
export function useListAllUsersByAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllUsersByAccountQuery, ListAllUsersByAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllUsersByAccountQuery, ListAllUsersByAccountQueryVariables>(ListAllUsersByAccountDocument, options);
        }
export type ListAllUsersByAccountQueryHookResult = ReturnType<typeof useListAllUsersByAccountQuery>;
export type ListAllUsersByAccountLazyQueryHookResult = ReturnType<typeof useListAllUsersByAccountLazyQuery>;
export type ListAllUsersByAccountQueryResult = Apollo.QueryResult<ListAllUsersByAccountQuery, ListAllUsersByAccountQueryVariables>;
export const FetchContactByIdDocument = gql`
    query FetchContactById($userId: UUID!) {
  contacts {
    byId(id: $userId) {
      id
      name
      email
      title
      userRole
      phoneNumber
      contactType
      isActive
      driver {
        id
        marketingDescription
        isActive
        externalId
      }
    }
  }
}
    `;

/**
 * __useFetchContactByIdQuery__
 *
 * To run a query within a React component, call `useFetchContactByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchContactByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchContactByIdQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchContactByIdQuery(baseOptions: Apollo.QueryHookOptions<FetchContactByIdQuery, FetchContactByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchContactByIdQuery, FetchContactByIdQueryVariables>(FetchContactByIdDocument, options);
      }
export function useFetchContactByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchContactByIdQuery, FetchContactByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchContactByIdQuery, FetchContactByIdQueryVariables>(FetchContactByIdDocument, options);
        }
export type FetchContactByIdQueryHookResult = ReturnType<typeof useFetchContactByIdQuery>;
export type FetchContactByIdLazyQueryHookResult = ReturnType<typeof useFetchContactByIdLazyQuery>;
export type FetchContactByIdQueryResult = Apollo.QueryResult<FetchContactByIdQuery, FetchContactByIdQueryVariables>;
export const GetUserByTokenDocument = gql`
    query GetUserByToken {
  usersQueries {
    getUserByToken {
      id
      email
      phoneNumber
      firstName
      lastName
      name
      role
      productType
      vendorId
      isSavoyaUser
    }
  }
}
    `;

/**
 * __useGetUserByTokenQuery__
 *
 * To run a query within a React component, call `useGetUserByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserByTokenQuery(baseOptions?: Apollo.QueryHookOptions<GetUserByTokenQuery, GetUserByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByTokenQuery, GetUserByTokenQueryVariables>(GetUserByTokenDocument, options);
      }
export function useGetUserByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByTokenQuery, GetUserByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByTokenQuery, GetUserByTokenQueryVariables>(GetUserByTokenDocument, options);
        }
export type GetUserByTokenQueryHookResult = ReturnType<typeof useGetUserByTokenQuery>;
export type GetUserByTokenLazyQueryHookResult = ReturnType<typeof useGetUserByTokenLazyQuery>;
export type GetUserByTokenQueryResult = Apollo.QueryResult<GetUserByTokenQuery, GetUserByTokenQueryVariables>;
export const GetMicroServiceUserByIdDocument = gql`
    query GetMicroServiceUserById($id: UUID!) {
  usersQueries {
    getById(id: $id) {
      id
      email
      phoneNumber
      role
      productType
      identityProvider
      externalId
      name
      firstName
      lastName
      vendorId
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetMicroServiceUserByIdQuery__
 *
 * To run a query within a React component, call `useGetMicroServiceUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicroServiceUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicroServiceUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMicroServiceUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMicroServiceUserByIdQuery, GetMicroServiceUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicroServiceUserByIdQuery, GetMicroServiceUserByIdQueryVariables>(GetMicroServiceUserByIdDocument, options);
      }
export function useGetMicroServiceUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicroServiceUserByIdQuery, GetMicroServiceUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicroServiceUserByIdQuery, GetMicroServiceUserByIdQueryVariables>(GetMicroServiceUserByIdDocument, options);
        }
export type GetMicroServiceUserByIdQueryHookResult = ReturnType<typeof useGetMicroServiceUserByIdQuery>;
export type GetMicroServiceUserByIdLazyQueryHookResult = ReturnType<typeof useGetMicroServiceUserByIdLazyQuery>;
export type GetMicroServiceUserByIdQueryResult = Apollo.QueryResult<GetMicroServiceUserByIdQuery, GetMicroServiceUserByIdQueryVariables>;
export const GetMicroServiceUsersByRoleDocument = gql`
    query GetMicroServiceUsersByRole($skip: Int!, $take: Int!, $role: UserIdentityRole, $orderBy: OrderByDirection) {
  usersQueries {
    getByUserRole(skip: $skip, take: $take, role: $role, orderBy: $orderBy) {
      id
      email
      phoneNumber
      role
      productType
      identityProvider
      externalId
      name
      firstName
      lastName
      vendorId
      createdAt
      updatedAt
    }
  }
}
    `;

/**
 * __useGetMicroServiceUsersByRoleQuery__
 *
 * To run a query within a React component, call `useGetMicroServiceUsersByRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMicroServiceUsersByRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMicroServiceUsersByRoleQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      role: // value for 'role'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetMicroServiceUsersByRoleQuery(baseOptions: Apollo.QueryHookOptions<GetMicroServiceUsersByRoleQuery, GetMicroServiceUsersByRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMicroServiceUsersByRoleQuery, GetMicroServiceUsersByRoleQueryVariables>(GetMicroServiceUsersByRoleDocument, options);
      }
export function useGetMicroServiceUsersByRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMicroServiceUsersByRoleQuery, GetMicroServiceUsersByRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMicroServiceUsersByRoleQuery, GetMicroServiceUsersByRoleQueryVariables>(GetMicroServiceUsersByRoleDocument, options);
        }
export type GetMicroServiceUsersByRoleQueryHookResult = ReturnType<typeof useGetMicroServiceUsersByRoleQuery>;
export type GetMicroServiceUsersByRoleLazyQueryHookResult = ReturnType<typeof useGetMicroServiceUsersByRoleLazyQuery>;
export type GetMicroServiceUsersByRoleQueryResult = Apollo.QueryResult<GetMicroServiceUsersByRoleQuery, GetMicroServiceUsersByRoleQueryVariables>;
export const AddContactDocument = gql`
    mutation AddContact($contact: InsertContact!) {
  insertContact(contact: $contact) {
    contact {
      id
      email
      name
      phoneNumber
      title
      profileImageUrl
      contactType
      userRole
      accountId
      analyticsToken
      firebaseToken
      isActive
      driver {
        id
        marketingDescription
        externalId
      }
      addresses {
        name
        category
        addressLine1
        city
        state
        country
        postalCode
      }
    }
    success
    errors {
      message
      code
    }
    existingContact {
      id
      email
      name
    }
  }
}
    `;
export type AddContactMutationFn = Apollo.MutationFunction<AddContactMutation, AddContactMutationVariables>;

/**
 * __useAddContactMutation__
 *
 * To run a mutation, you first call `useAddContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContactMutation, { data, loading, error }] = useAddContactMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useAddContactMutation(baseOptions?: Apollo.MutationHookOptions<AddContactMutation, AddContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContactMutation, AddContactMutationVariables>(AddContactDocument, options);
      }
export type AddContactMutationHookResult = ReturnType<typeof useAddContactMutation>;
export type AddContactMutationResult = Apollo.MutationResult<AddContactMutation>;
export type AddContactMutationOptions = Apollo.BaseMutationOptions<AddContactMutation, AddContactMutationVariables>;
export const UpdateContactDocument = gql`
    mutation UpdateContact($contact: UpdateContact!) {
  updateContact(contact: $contact) {
    contact {
      id
      email
      name
      phoneNumber
      title
      profileImageUrl
      contactType
      userRole
      accountId
      analyticsToken
      firebaseToken
      isActive
      driver {
        id
        marketingDescription
        externalId
      }
      addresses {
        name
        category
        addressLine1
        city
        state
        country
        postalCode
      }
    }
    success
    errors {
      message
      code
    }
    existingContact {
      id
      email
      name
    }
  }
}
    `;
export type UpdateContactMutationFn = Apollo.MutationFunction<UpdateContactMutation, UpdateContactMutationVariables>;

/**
 * __useUpdateContactMutation__
 *
 * To run a mutation, you first call `useUpdateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactMutation, { data, loading, error }] = useUpdateContactMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useUpdateContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactMutation, UpdateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactMutation, UpdateContactMutationVariables>(UpdateContactDocument, options);
      }
export type UpdateContactMutationHookResult = ReturnType<typeof useUpdateContactMutation>;
export type UpdateContactMutationResult = Apollo.MutationResult<UpdateContactMutation>;
export type UpdateContactMutationOptions = Apollo.BaseMutationOptions<UpdateContactMutation, UpdateContactMutationVariables>;
export const InsertUserDocument = gql`
    mutation InsertUser($contact: InsertUser!, $fileType: String, $useWithSavoya: Boolean) {
  insertUser(
    contact: $contact
    fileType: $fileType
    useWithSavoya: $useWithSavoya
  ) {
    signedUrl
    contact {
      id
      name
      email
      title
      contactType
      userRole
      phoneNumber
      driver {
        id
        marketingDescription
        externalId
      }
    }
  }
}
    `;
export type InsertUserMutationFn = Apollo.MutationFunction<InsertUserMutation, InsertUserMutationVariables>;

/**
 * __useInsertUserMutation__
 *
 * To run a mutation, you first call `useInsertUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserMutation, { data, loading, error }] = useInsertUserMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *      fileType: // value for 'fileType'
 *      useWithSavoya: // value for 'useWithSavoya'
 *   },
 * });
 */
export function useInsertUserMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserMutation, InsertUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserMutation, InsertUserMutationVariables>(InsertUserDocument, options);
      }
export type InsertUserMutationHookResult = ReturnType<typeof useInsertUserMutation>;
export type InsertUserMutationResult = Apollo.MutationResult<InsertUserMutation>;
export type InsertUserMutationOptions = Apollo.BaseMutationOptions<InsertUserMutation, InsertUserMutationVariables>;
export const AddVehicleClassDocument = gql`
    mutation AddVehicleClass($vehicleClass: InsertVehicleClass!) {
  insertVehicleClass(vehicleClass: $vehicleClass) {
    vehicleClass {
      id
      name
    }
  }
}
    `;
export type AddVehicleClassMutationFn = Apollo.MutationFunction<AddVehicleClassMutation, AddVehicleClassMutationVariables>;

/**
 * __useAddVehicleClassMutation__
 *
 * To run a mutation, you first call `useAddVehicleClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVehicleClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVehicleClassMutation, { data, loading, error }] = useAddVehicleClassMutation({
 *   variables: {
 *      vehicleClass: // value for 'vehicleClass'
 *   },
 * });
 */
export function useAddVehicleClassMutation(baseOptions?: Apollo.MutationHookOptions<AddVehicleClassMutation, AddVehicleClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVehicleClassMutation, AddVehicleClassMutationVariables>(AddVehicleClassDocument, options);
      }
export type AddVehicleClassMutationHookResult = ReturnType<typeof useAddVehicleClassMutation>;
export type AddVehicleClassMutationResult = Apollo.MutationResult<AddVehicleClassMutation>;
export type AddVehicleClassMutationOptions = Apollo.BaseMutationOptions<AddVehicleClassMutation, AddVehicleClassMutationVariables>;
export const UpdateVehicleClassDocument = gql`
    mutation UpdateVehicleClass($vehicleClass: UpdateVehicleClass!) {
  updateVehicleClass(vehicleClass: $vehicleClass) {
    vehicleClass {
      id
      name
    }
  }
}
    `;
export type UpdateVehicleClassMutationFn = Apollo.MutationFunction<UpdateVehicleClassMutation, UpdateVehicleClassMutationVariables>;

/**
 * __useUpdateVehicleClassMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleClassMutation, { data, loading, error }] = useUpdateVehicleClassMutation({
 *   variables: {
 *      vehicleClass: // value for 'vehicleClass'
 *   },
 * });
 */
export function useUpdateVehicleClassMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVehicleClassMutation, UpdateVehicleClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVehicleClassMutation, UpdateVehicleClassMutationVariables>(UpdateVehicleClassDocument, options);
      }
export type UpdateVehicleClassMutationHookResult = ReturnType<typeof useUpdateVehicleClassMutation>;
export type UpdateVehicleClassMutationResult = Apollo.MutationResult<UpdateVehicleClassMutation>;
export type UpdateVehicleClassMutationOptions = Apollo.BaseMutationOptions<UpdateVehicleClassMutation, UpdateVehicleClassMutationVariables>;
export const InactivateVehicleClassDocument = gql`
    mutation InactivateVehicleClass($id: UUID!) {
  inactivateVehicleClass(id: $id) {
    errors {
      code
      message
    }
    success
    vehicleClass {
      id
    }
  }
}
    `;
export type InactivateVehicleClassMutationFn = Apollo.MutationFunction<InactivateVehicleClassMutation, InactivateVehicleClassMutationVariables>;

/**
 * __useInactivateVehicleClassMutation__
 *
 * To run a mutation, you first call `useInactivateVehicleClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInactivateVehicleClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inactivateVehicleClassMutation, { data, loading, error }] = useInactivateVehicleClassMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInactivateVehicleClassMutation(baseOptions?: Apollo.MutationHookOptions<InactivateVehicleClassMutation, InactivateVehicleClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InactivateVehicleClassMutation, InactivateVehicleClassMutationVariables>(InactivateVehicleClassDocument, options);
      }
export type InactivateVehicleClassMutationHookResult = ReturnType<typeof useInactivateVehicleClassMutation>;
export type InactivateVehicleClassMutationResult = Apollo.MutationResult<InactivateVehicleClassMutation>;
export type InactivateVehicleClassMutationOptions = Apollo.BaseMutationOptions<InactivateVehicleClassMutation, InactivateVehicleClassMutationVariables>;
export const InactivateVehicleDocument = gql`
    mutation InactivateVehicle($id: UUID!) {
  inactivateVehicle(id: $id) {
    errors {
      code
      message
    }
    success
    vehicle {
      id
    }
  }
}
    `;
export type InactivateVehicleMutationFn = Apollo.MutationFunction<InactivateVehicleMutation, InactivateVehicleMutationVariables>;

/**
 * __useInactivateVehicleMutation__
 *
 * To run a mutation, you first call `useInactivateVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInactivateVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inactivateVehicleMutation, { data, loading, error }] = useInactivateVehicleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInactivateVehicleMutation(baseOptions?: Apollo.MutationHookOptions<InactivateVehicleMutation, InactivateVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InactivateVehicleMutation, InactivateVehicleMutationVariables>(InactivateVehicleDocument, options);
      }
export type InactivateVehicleMutationHookResult = ReturnType<typeof useInactivateVehicleMutation>;
export type InactivateVehicleMutationResult = Apollo.MutationResult<InactivateVehicleMutation>;
export type InactivateVehicleMutationOptions = Apollo.BaseMutationOptions<InactivateVehicleMutation, InactivateVehicleMutationVariables>;
export const ListAllVehicleClassesDocument = gql`
    query listAllVehicleClasses($accountId: UUID!, $offset: Int = 0, $perPage: Int = 100, $includeInactive: Boolean = false) {
  vehicleClasses {
    all(
      accountId: $accountId
      skip: $offset
      take: $perPage
      includeInactive: $includeInactive
    ) {
      items {
        id
        accountId
        systemClassId
        systemClass {
          id
          name
          description
          defaultCostMultiplier
        }
        luggageCount
        passengerCount
        name
        imageUrl
        hourlyRate
        cancellationPolicyHours
        minimumHours
      }
      total
    }
  }
}
    `;

/**
 * __useListAllVehicleClassesQuery__
 *
 * To run a query within a React component, call `useListAllVehicleClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAllVehicleClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAllVehicleClassesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useListAllVehicleClassesQuery(baseOptions: Apollo.QueryHookOptions<ListAllVehicleClassesQuery, ListAllVehicleClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAllVehicleClassesQuery, ListAllVehicleClassesQueryVariables>(ListAllVehicleClassesDocument, options);
      }
export function useListAllVehicleClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAllVehicleClassesQuery, ListAllVehicleClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAllVehicleClassesQuery, ListAllVehicleClassesQueryVariables>(ListAllVehicleClassesDocument, options);
        }
export type ListAllVehicleClassesQueryHookResult = ReturnType<typeof useListAllVehicleClassesQuery>;
export type ListAllVehicleClassesLazyQueryHookResult = ReturnType<typeof useListAllVehicleClassesLazyQuery>;
export type ListAllVehicleClassesQueryResult = Apollo.QueryResult<ListAllVehicleClassesQuery, ListAllVehicleClassesQueryVariables>;
export const GetVehiclesDocument = gql`
    query getVehicles($accountId: UUID!, $offset: Int = 0, $perPage: Int = 20, $includeInactive: Boolean = false) {
  vehicles {
    all(
      accountId: $accountId
      skip: $offset
      take: $perPage
      includeInactive: $includeInactive
    ) {
      total
      items {
        id
        availability
        model {
          id
          name
          makeId
          make {
            id
            name
          }
        }
        year
        vehicleClass {
          name
        }
        isActive
        externalId
      }
    }
  }
}
    `;

/**
 * __useGetVehiclesQuery__
 *
 * To run a query within a React component, call `useGetVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehiclesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetVehiclesQuery(baseOptions: Apollo.QueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehiclesQuery, GetVehiclesQueryVariables>(GetVehiclesDocument, options);
      }
export function useGetVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehiclesQuery, GetVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehiclesQuery, GetVehiclesQueryVariables>(GetVehiclesDocument, options);
        }
export type GetVehiclesQueryHookResult = ReturnType<typeof useGetVehiclesQuery>;
export type GetVehiclesLazyQueryHookResult = ReturnType<typeof useGetVehiclesLazyQuery>;
export type GetVehiclesQueryResult = Apollo.QueryResult<GetVehiclesQuery, GetVehiclesQueryVariables>;
export const GetVehiclesFilteredDocument = gql`
    query getVehiclesFiltered($accountId: UUID!, $offset: Int = 0, $perPage: Int = 20, $vehicleClassId: UUID, $orderBy: OrderByDirection, $includeInactive: Boolean = false) {
  vehicles {
    search(
      accountId: $accountId
      skip: $offset
      take: $perPage
      vehicleClassId: $vehicleClassId
      orderBy: $orderBy
      includeInactive: $includeInactive
    ) {
      total
      items {
        id
        availability
        color
        middleSeatType
        vin
        licenseNumber
        model {
          id
          name
          makeId
          make {
            id
            name
          }
        }
        year
        vehicleClass {
          name
          id
        }
        isActive
        externalId
      }
    }
  }
}
    `;

/**
 * __useGetVehiclesFilteredQuery__
 *
 * To run a query within a React component, call `useGetVehiclesFilteredQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehiclesFilteredQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehiclesFilteredQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *      vehicleClassId: // value for 'vehicleClassId'
 *      orderBy: // value for 'orderBy'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetVehiclesFilteredQuery(baseOptions: Apollo.QueryHookOptions<GetVehiclesFilteredQuery, GetVehiclesFilteredQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehiclesFilteredQuery, GetVehiclesFilteredQueryVariables>(GetVehiclesFilteredDocument, options);
      }
export function useGetVehiclesFilteredLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehiclesFilteredQuery, GetVehiclesFilteredQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehiclesFilteredQuery, GetVehiclesFilteredQueryVariables>(GetVehiclesFilteredDocument, options);
        }
export type GetVehiclesFilteredQueryHookResult = ReturnType<typeof useGetVehiclesFilteredQuery>;
export type GetVehiclesFilteredLazyQueryHookResult = ReturnType<typeof useGetVehiclesFilteredLazyQuery>;
export type GetVehiclesFilteredQueryResult = Apollo.QueryResult<GetVehiclesFilteredQuery, GetVehiclesFilteredQueryVariables>;
export const GetSavoyaVehiclesDocument = gql`
    query GetSavoyaVehicles($skip: Int, $take: Int, $orderBy: OrderByDirection, $vendorId: UUID, $vehicleId: UUID, $name: String, $providerType: ProviderType, $status: VehicleStatus, $vehicleClassId: UUID, $includeInactive: Boolean) {
  vehicleQueries {
    vehiclesByVendorId(
      skip: $skip
      take: $take
      orderBy: $orderBy
      id: $vehicleId
      name: $name
      vendorId: $vendorId
      providerType: $providerType
      status: $status
      vehicleClassId: $vehicleClassId
      includeInactive: $includeInactive
    ) {
      total
      items {
        id
        isActive
        vendorId
        vehicleClassId
        name
        imageUrl
        year
        color
        make
        model
        vin
        licensePlateNumber
        seatingArrangement
        rentalExpirationDate
        imageUrl
        imageUpdatedAt
        vehicleProvider {
          id
          providerType
          vehicleId
          groundwork
          insuranceChecked
          status
          rejectionReason
          createdAt
          updatedAt
          deleted
        }
        vehicleModel {
          id
          name
          startYear
          endYear
          makeId
          make {
            id
            name
            createdAt
            updatedAt
            deleted
          }
          createdAt
          updatedAt
          deleted
        }
        vehicleClass {
          id
          vendorId
          systemClass
          name
          dwellTime
          limitedAvailability
          canBeQuoatedWithoutRates
          signageRequired
          clientCanBook
          displayOrder
          isActive
          imageUrl
          hourlyRate
          passengerCount
          luggageCount
          cancellationPolicyHours
          minimumHours
          createdAt
          updatedAt
          deleted
          providerType
        }
        createdAt
        updatedAt
        deleted
      }
    }
  }
}
    `;

/**
 * __useGetSavoyaVehiclesQuery__
 *
 * To run a query within a React component, call `useGetSavoyaVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSavoyaVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSavoyaVehiclesQuery({
 *   variables: {
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *      vendorId: // value for 'vendorId'
 *      vehicleId: // value for 'vehicleId'
 *      name: // value for 'name'
 *      providerType: // value for 'providerType'
 *      status: // value for 'status'
 *      vehicleClassId: // value for 'vehicleClassId'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetSavoyaVehiclesQuery(baseOptions?: Apollo.QueryHookOptions<GetSavoyaVehiclesQuery, GetSavoyaVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSavoyaVehiclesQuery, GetSavoyaVehiclesQueryVariables>(GetSavoyaVehiclesDocument, options);
      }
export function useGetSavoyaVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSavoyaVehiclesQuery, GetSavoyaVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSavoyaVehiclesQuery, GetSavoyaVehiclesQueryVariables>(GetSavoyaVehiclesDocument, options);
        }
export type GetSavoyaVehiclesQueryHookResult = ReturnType<typeof useGetSavoyaVehiclesQuery>;
export type GetSavoyaVehiclesLazyQueryHookResult = ReturnType<typeof useGetSavoyaVehiclesLazyQuery>;
export type GetSavoyaVehiclesQueryResult = Apollo.QueryResult<GetSavoyaVehiclesQuery, GetSavoyaVehiclesQueryVariables>;
export const GetVehicleRecordByIdDocument = gql`
    query GetVehicleRecordById($id: UUID!) {
  vehicleQueries {
    vehicleById(id: $id) {
      id
      vendorId
      vehicleClassId
      name
      year
      color
      make
      isActive
      model
      vin
      licensePlateNumber
      seatingArrangement
      rentalExpirationDate
      imageUrl
      imageUpdatedAt
      vehicleProvider {
        id
        providerType
        vehicleId
        groundwork
        insuranceChecked
        status
        rejectionReason
        createdAt
        updatedAt
        deleted
      }
      vehicleModel {
        id
        name
        startYear
        endYear
        makeId
        createdAt
        updatedAt
        deleted
        make {
          id
          name
          createdAt
          updatedAt
          deleted
        }
      }
      vehicleClass {
        id
        vendorId
        systemClass
        name
        dwellTime
        limitedAvailability
        providerType
        canBeQuoatedWithoutRates
        signageRequired
        clientCanBook
        displayOrder
        isActive
        imageUrl
        hourlyRate
        passengerCount
        luggageCount
        cancellationPolicyHours
        minimumHours
        createdAt
        updatedAt
        deleted
      }
      createdAt
      updatedAt
      deleted
    }
  }
}
    `;

/**
 * __useGetVehicleRecordByIdQuery__
 *
 * To run a query within a React component, call `useGetVehicleRecordByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleRecordByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleRecordByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVehicleRecordByIdQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleRecordByIdQuery, GetVehicleRecordByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleRecordByIdQuery, GetVehicleRecordByIdQueryVariables>(GetVehicleRecordByIdDocument, options);
      }
export function useGetVehicleRecordByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleRecordByIdQuery, GetVehicleRecordByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleRecordByIdQuery, GetVehicleRecordByIdQueryVariables>(GetVehicleRecordByIdDocument, options);
        }
export type GetVehicleRecordByIdQueryHookResult = ReturnType<typeof useGetVehicleRecordByIdQuery>;
export type GetVehicleRecordByIdLazyQueryHookResult = ReturnType<typeof useGetVehicleRecordByIdLazyQuery>;
export type GetVehicleRecordByIdQueryResult = Apollo.QueryResult<GetVehicleRecordByIdQuery, GetVehicleRecordByIdQueryVariables>;
export const SearchVehicleDocument = gql`
    query searchVehicle($query: String!, $offset: Int = 0, $perPage: Int = 20, $orderBy: OrderByDirection, $accountId: UUID!, $includeInactive: Boolean = false) {
  vehicles {
    search(
      accountId: $accountId
      query: $query
      skip: $offset
      take: $perPage
      orderBy: $orderBy
      includeInactive: $includeInactive
    ) {
      items {
        id
        availability
        model {
          id
          name
          makeId
          make {
            id
            name
          }
        }
        year
        licenseNumber
        vehicleClass {
          name
        }
        isActive
        externalId
      }
      total
    }
  }
}
    `;

/**
 * __useSearchVehicleQuery__
 *
 * To run a query within a React component, call `useSearchVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchVehicleQuery({
 *   variables: {
 *      query: // value for 'query'
 *      offset: // value for 'offset'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      accountId: // value for 'accountId'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useSearchVehicleQuery(baseOptions: Apollo.QueryHookOptions<SearchVehicleQuery, SearchVehicleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchVehicleQuery, SearchVehicleQueryVariables>(SearchVehicleDocument, options);
      }
export function useSearchVehicleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchVehicleQuery, SearchVehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchVehicleQuery, SearchVehicleQueryVariables>(SearchVehicleDocument, options);
        }
export type SearchVehicleQueryHookResult = ReturnType<typeof useSearchVehicleQuery>;
export type SearchVehicleLazyQueryHookResult = ReturnType<typeof useSearchVehicleLazyQuery>;
export type SearchVehicleQueryResult = Apollo.QueryResult<SearchVehicleQuery, SearchVehicleQueryVariables>;
export const GetVehicleDocument = gql`
    query GetVehicle($id: UUID!) {
  vehicles {
    byId(id: $id) {
      id
      licenseNumber
      availability
      year
      vin
      availabilityComments
      vehicleClass {
        id
        name
      }
      model {
        id
        name
        make {
          name
        }
      }
      isActive
      color
      middleSeatType
      externalId
    }
  }
}
    `;

/**
 * __useGetVehicleQuery__
 *
 * To run a query within a React component, call `useGetVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVehicleQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleQuery, GetVehicleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleQuery, GetVehicleQueryVariables>(GetVehicleDocument, options);
      }
export function useGetVehicleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleQuery, GetVehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleQuery, GetVehicleQueryVariables>(GetVehicleDocument, options);
        }
export type GetVehicleQueryHookResult = ReturnType<typeof useGetVehicleQuery>;
export type GetVehicleLazyQueryHookResult = ReturnType<typeof useGetVehicleLazyQuery>;
export type GetVehicleQueryResult = Apollo.QueryResult<GetVehicleQuery, GetVehicleQueryVariables>;
export const CreateVehicleFilesUploadSignedUrlsDocument = gql`
    mutation CreateVehicleFilesUploadSignedUrls($vehicleFilesUploadArgs: VehicleFilesUploadArgs!) {
  createVehicleFilesUploadSignedUrls(
    vehicleFilesUploadArgs: $vehicleFilesUploadArgs
  ) {
    filename
    filetype
    key
    mimeType
    signedUrl
  }
}
    `;
export type CreateVehicleFilesUploadSignedUrlsMutationFn = Apollo.MutationFunction<CreateVehicleFilesUploadSignedUrlsMutation, CreateVehicleFilesUploadSignedUrlsMutationVariables>;

/**
 * __useCreateVehicleFilesUploadSignedUrlsMutation__
 *
 * To run a mutation, you first call `useCreateVehicleFilesUploadSignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVehicleFilesUploadSignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVehicleFilesUploadSignedUrlsMutation, { data, loading, error }] = useCreateVehicleFilesUploadSignedUrlsMutation({
 *   variables: {
 *      vehicleFilesUploadArgs: // value for 'vehicleFilesUploadArgs'
 *   },
 * });
 */
export function useCreateVehicleFilesUploadSignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<CreateVehicleFilesUploadSignedUrlsMutation, CreateVehicleFilesUploadSignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVehicleFilesUploadSignedUrlsMutation, CreateVehicleFilesUploadSignedUrlsMutationVariables>(CreateVehicleFilesUploadSignedUrlsDocument, options);
      }
export type CreateVehicleFilesUploadSignedUrlsMutationHookResult = ReturnType<typeof useCreateVehicleFilesUploadSignedUrlsMutation>;
export type CreateVehicleFilesUploadSignedUrlsMutationResult = Apollo.MutationResult<CreateVehicleFilesUploadSignedUrlsMutation>;
export type CreateVehicleFilesUploadSignedUrlsMutationOptions = Apollo.BaseMutationOptions<CreateVehicleFilesUploadSignedUrlsMutation, CreateVehicleFilesUploadSignedUrlsMutationVariables>;
export const GetVehicleFilesDocument = gql`
    query GetVehicleFiles($vehicleFilesId: UUID!) {
  vehicleQueries {
    vehicleFiles(id: $vehicleFilesId) {
      documents {
        key
        mimeType
        signedUrl
      }
    }
  }
}
    `;

/**
 * __useGetVehicleFilesQuery__
 *
 * To run a query within a React component, call `useGetVehicleFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleFilesQuery({
 *   variables: {
 *      vehicleFilesId: // value for 'vehicleFilesId'
 *   },
 * });
 */
export function useGetVehicleFilesQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleFilesQuery, GetVehicleFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleFilesQuery, GetVehicleFilesQueryVariables>(GetVehicleFilesDocument, options);
      }
export function useGetVehicleFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleFilesQuery, GetVehicleFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleFilesQuery, GetVehicleFilesQueryVariables>(GetVehicleFilesDocument, options);
        }
export type GetVehicleFilesQueryHookResult = ReturnType<typeof useGetVehicleFilesQuery>;
export type GetVehicleFilesLazyQueryHookResult = ReturnType<typeof useGetVehicleFilesLazyQuery>;
export type GetVehicleFilesQueryResult = Apollo.QueryResult<GetVehicleFilesQuery, GetVehicleFilesQueryVariables>;
export const DeleteVehicleFileDocument = gql`
    mutation DeleteVehicleFile($deleteVehicleFileArgs: VehicleDeleteFileArgs!) {
  deleteVehicleFile(deleteVehicleFileArgs: $deleteVehicleFileArgs)
}
    `;
export type DeleteVehicleFileMutationFn = Apollo.MutationFunction<DeleteVehicleFileMutation, DeleteVehicleFileMutationVariables>;

/**
 * __useDeleteVehicleFileMutation__
 *
 * To run a mutation, you first call `useDeleteVehicleFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicleFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehicleFileMutation, { data, loading, error }] = useDeleteVehicleFileMutation({
 *   variables: {
 *      deleteVehicleFileArgs: // value for 'deleteVehicleFileArgs'
 *   },
 * });
 */
export function useDeleteVehicleFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVehicleFileMutation, DeleteVehicleFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVehicleFileMutation, DeleteVehicleFileMutationVariables>(DeleteVehicleFileDocument, options);
      }
export type DeleteVehicleFileMutationHookResult = ReturnType<typeof useDeleteVehicleFileMutation>;
export type DeleteVehicleFileMutationResult = Apollo.MutationResult<DeleteVehicleFileMutation>;
export type DeleteVehicleFileMutationOptions = Apollo.BaseMutationOptions<DeleteVehicleFileMutation, DeleteVehicleFileMutationVariables>;
export const AddVehicleDocument = gql`
    mutation AddVehicle($vehicle: InsertVehicleInput!, $fileType: String) {
  insertVehicle(vehicle: $vehicle, fileType: $fileType) {
    signedUrl
    errors {
      code
      message
    }
    success
    vehicle {
      id
      licenseNumber
      availabilityComments
      vin
      year
      color
      middleSeatType
      externalId
    }
  }
}
    `;
export type AddVehicleMutationFn = Apollo.MutationFunction<AddVehicleMutation, AddVehicleMutationVariables>;

/**
 * __useAddVehicleMutation__
 *
 * To run a mutation, you first call `useAddVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVehicleMutation, { data, loading, error }] = useAddVehicleMutation({
 *   variables: {
 *      vehicle: // value for 'vehicle'
 *      fileType: // value for 'fileType'
 *   },
 * });
 */
export function useAddVehicleMutation(baseOptions?: Apollo.MutationHookOptions<AddVehicleMutation, AddVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVehicleMutation, AddVehicleMutationVariables>(AddVehicleDocument, options);
      }
export type AddVehicleMutationHookResult = ReturnType<typeof useAddVehicleMutation>;
export type AddVehicleMutationResult = Apollo.MutationResult<AddVehicleMutation>;
export type AddVehicleMutationOptions = Apollo.BaseMutationOptions<AddVehicleMutation, AddVehicleMutationVariables>;
export const UpdateVehicleDocument = gql`
    mutation UpdateVehicle($vehicle: UpdateVehicle!) {
  updateVehicle(vehicle: $vehicle) {
    vehicle {
      id
      availability
      color
      middleSeatType
      vin
      licenseNumber
      model {
        id
        name
        makeId
        make {
          id
          name
        }
      }
      year
      vehicleClass {
        name
        id
      }
      isActive
    }
  }
}
    `;
export type UpdateVehicleMutationFn = Apollo.MutationFunction<UpdateVehicleMutation, UpdateVehicleMutationVariables>;

/**
 * __useUpdateVehicleMutation__
 *
 * To run a mutation, you first call `useUpdateVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVehicleMutation, { data, loading, error }] = useUpdateVehicleMutation({
 *   variables: {
 *      vehicle: // value for 'vehicle'
 *   },
 * });
 */
export function useUpdateVehicleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVehicleMutation, UpdateVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVehicleMutation, UpdateVehicleMutationVariables>(UpdateVehicleDocument, options);
      }
export type UpdateVehicleMutationHookResult = ReturnType<typeof useUpdateVehicleMutation>;
export type UpdateVehicleMutationResult = Apollo.MutationResult<UpdateVehicleMutation>;
export type UpdateVehicleMutationOptions = Apollo.BaseMutationOptions<UpdateVehicleMutation, UpdateVehicleMutationVariables>;
export const GetVehicleModelsDocument = gql`
    query getVehicleModels {
  vehicleModels {
    all(take: 1200) {
      items {
        id
        name
        makeId
        startYear
        endYear
      }
    }
  }
}
    `;

/**
 * __useGetVehicleModelsQuery__
 *
 * To run a query within a React component, call `useGetVehicleModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleModelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVehicleModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetVehicleModelsQuery, GetVehicleModelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleModelsQuery, GetVehicleModelsQueryVariables>(GetVehicleModelsDocument, options);
      }
export function useGetVehicleModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleModelsQuery, GetVehicleModelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleModelsQuery, GetVehicleModelsQueryVariables>(GetVehicleModelsDocument, options);
        }
export type GetVehicleModelsQueryHookResult = ReturnType<typeof useGetVehicleModelsQuery>;
export type GetVehicleModelsLazyQueryHookResult = ReturnType<typeof useGetVehicleModelsLazyQuery>;
export type GetVehicleModelsQueryResult = Apollo.QueryResult<GetVehicleModelsQuery, GetVehicleModelsQueryVariables>;
export const GetVehicleModelByIdDocument = gql`
    query getVehicleModelById($id: UUID!) {
  vehicleModels {
    byId(id: $id) {
      id
      name
      make {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetVehicleModelByIdQuery__
 *
 * To run a query within a React component, call `useGetVehicleModelByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleModelByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleModelByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVehicleModelByIdQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleModelByIdQuery, GetVehicleModelByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleModelByIdQuery, GetVehicleModelByIdQueryVariables>(GetVehicleModelByIdDocument, options);
      }
export function useGetVehicleModelByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleModelByIdQuery, GetVehicleModelByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleModelByIdQuery, GetVehicleModelByIdQueryVariables>(GetVehicleModelByIdDocument, options);
        }
export type GetVehicleModelByIdQueryHookResult = ReturnType<typeof useGetVehicleModelByIdQuery>;
export type GetVehicleModelByIdLazyQueryHookResult = ReturnType<typeof useGetVehicleModelByIdLazyQuery>;
export type GetVehicleModelByIdQueryResult = Apollo.QueryResult<GetVehicleModelByIdQuery, GetVehicleModelByIdQueryVariables>;
export const GetVehicleClassesDocument = gql`
    query getVehicleClasses($accountId: UUID!, $orderBy: OrderByDirection, $includeInactive: Boolean = false) {
  vehicleClasses {
    all(accountId: $accountId, orderBy: $orderBy, includeInactive: $includeInactive) {
      items {
        id
        name
        systemClassId
        systemClass {
          id
          name
        }
        hourlyRate
        luggageCount
        passengerCount
        isActive
        cancellationPolicyHours
        minimumHours
      }
    }
  }
}
    `;

/**
 * __useGetVehicleClassesQuery__
 *
 * To run a query within a React component, call `useGetVehicleClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleClassesQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      orderBy: // value for 'orderBy'
 *      includeInactive: // value for 'includeInactive'
 *   },
 * });
 */
export function useGetVehicleClassesQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleClassesQuery, GetVehicleClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleClassesQuery, GetVehicleClassesQueryVariables>(GetVehicleClassesDocument, options);
      }
export function useGetVehicleClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleClassesQuery, GetVehicleClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleClassesQuery, GetVehicleClassesQueryVariables>(GetVehicleClassesDocument, options);
        }
export type GetVehicleClassesQueryHookResult = ReturnType<typeof useGetVehicleClassesQuery>;
export type GetVehicleClassesLazyQueryHookResult = ReturnType<typeof useGetVehicleClassesLazyQuery>;
export type GetVehicleClassesQueryResult = Apollo.QueryResult<GetVehicleClassesQuery, GetVehicleClassesQueryVariables>;
export const GetVehicleClassByIdDocument = gql`
    query getVehicleClassById($vehicleClassId: UUID!) {
  vehicleClasses {
    byId(id: $vehicleClassId) {
      id
      name
      systemClass {
        id
        name
      }
      luggageCount
      passengerCount
      isActive
      minimumHours
      cancellationPolicyHours
    }
  }
}
    `;

/**
 * __useGetVehicleClassByIdQuery__
 *
 * To run a query within a React component, call `useGetVehicleClassByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleClassByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleClassByIdQuery({
 *   variables: {
 *      vehicleClassId: // value for 'vehicleClassId'
 *   },
 * });
 */
export function useGetVehicleClassByIdQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleClassByIdQuery, GetVehicleClassByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleClassByIdQuery, GetVehicleClassByIdQueryVariables>(GetVehicleClassByIdDocument, options);
      }
export function useGetVehicleClassByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleClassByIdQuery, GetVehicleClassByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleClassByIdQuery, GetVehicleClassByIdQueryVariables>(GetVehicleClassByIdDocument, options);
        }
export type GetVehicleClassByIdQueryHookResult = ReturnType<typeof useGetVehicleClassByIdQuery>;
export type GetVehicleClassByIdLazyQueryHookResult = ReturnType<typeof useGetVehicleClassByIdLazyQuery>;
export type GetVehicleClassByIdQueryResult = Apollo.QueryResult<GetVehicleClassByIdQuery, GetVehicleClassByIdQueryVariables>;
export const ModelAutocompleteDocument = gql`
    query ModelAutocomplete($query: String!) {
  vehicleModels {
    vehicleModelAutocomplete(query: $query) {
      id
      label
    }
  }
}
    `;

/**
 * __useModelAutocompleteQuery__
 *
 * To run a query within a React component, call `useModelAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useModelAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useModelAutocompleteQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useModelAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<ModelAutocompleteQuery, ModelAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ModelAutocompleteQuery, ModelAutocompleteQueryVariables>(ModelAutocompleteDocument, options);
      }
export function useModelAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ModelAutocompleteQuery, ModelAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ModelAutocompleteQuery, ModelAutocompleteQueryVariables>(ModelAutocompleteDocument, options);
        }
export type ModelAutocompleteQueryHookResult = ReturnType<typeof useModelAutocompleteQuery>;
export type ModelAutocompleteLazyQueryHookResult = ReturnType<typeof useModelAutocompleteLazyQuery>;
export type ModelAutocompleteQueryResult = Apollo.QueryResult<ModelAutocompleteQuery, ModelAutocompleteQueryVariables>;
export const GetVehicleMakesDocument = gql`
    query GetVehicleMakes {
  vehicleMakes {
    all {
      items {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetVehicleMakesQuery__
 *
 * To run a query within a React component, call `useGetVehicleMakesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleMakesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleMakesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVehicleMakesQuery(baseOptions?: Apollo.QueryHookOptions<GetVehicleMakesQuery, GetVehicleMakesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleMakesQuery, GetVehicleMakesQueryVariables>(GetVehicleMakesDocument, options);
      }
export function useGetVehicleMakesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleMakesQuery, GetVehicleMakesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleMakesQuery, GetVehicleMakesQueryVariables>(GetVehicleMakesDocument, options);
        }
export type GetVehicleMakesQueryHookResult = ReturnType<typeof useGetVehicleMakesQuery>;
export type GetVehicleMakesLazyQueryHookResult = ReturnType<typeof useGetVehicleMakesLazyQuery>;
export type GetVehicleMakesQueryResult = Apollo.QueryResult<GetVehicleMakesQuery, GetVehicleMakesQueryVariables>;
export const GetVehicleModelsByMakeDocument = gql`
    query GetVehicleModelsByMake($makeId: String!) {
  vehicleModels {
    byMake(makeId: $makeId) {
      items {
        id
        name
        makeId
      }
    }
  }
}
    `;

/**
 * __useGetVehicleModelsByMakeQuery__
 *
 * To run a query within a React component, call `useGetVehicleModelsByMakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehicleModelsByMakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehicleModelsByMakeQuery({
 *   variables: {
 *      makeId: // value for 'makeId'
 *   },
 * });
 */
export function useGetVehicleModelsByMakeQuery(baseOptions: Apollo.QueryHookOptions<GetVehicleModelsByMakeQuery, GetVehicleModelsByMakeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehicleModelsByMakeQuery, GetVehicleModelsByMakeQueryVariables>(GetVehicleModelsByMakeDocument, options);
      }
export function useGetVehicleModelsByMakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehicleModelsByMakeQuery, GetVehicleModelsByMakeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehicleModelsByMakeQuery, GetVehicleModelsByMakeQueryVariables>(GetVehicleModelsByMakeDocument, options);
        }
export type GetVehicleModelsByMakeQueryHookResult = ReturnType<typeof useGetVehicleModelsByMakeQuery>;
export type GetVehicleModelsByMakeLazyQueryHookResult = ReturnType<typeof useGetVehicleModelsByMakeLazyQuery>;
export type GetVehicleModelsByMakeQueryResult = Apollo.QueryResult<GetVehicleModelsByMakeQuery, GetVehicleModelsByMakeQueryVariables>;
export const GetAvailableVehiclesDocument = gql`
    query GetAvailableVehicles($tripId: UUID!) {
  trips {
    availableVehicles(criteria: {tripId: $tripId}) {
      internal {
        next {
          startTime
          endTime
          availability
          trip {
            id
            tripNumber
            estimatedAvailabilityTime
          }
        }
        overlapping {
          startTime
          endTime
          availability
          trip {
            id
            tripNumber
            estimatedAvailabilityTime
          }
        }
        previous {
          startTime
          endTime
          availability
          trip {
            id
            tripNumber
            estimatedAvailabilityTime
          }
        }
        vehicle {
          id
          name
          vehicleClassId
          vehicleClassName
          vehicleSystemClass
          modelName
          makeName
          licenseNumber
          year
        }
        availability
      }
    }
  }
}
    `;

/**
 * __useGetAvailableVehiclesQuery__
 *
 * To run a query within a React component, call `useGetAvailableVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableVehiclesQuery({
 *   variables: {
 *      tripId: // value for 'tripId'
 *   },
 * });
 */
export function useGetAvailableVehiclesQuery(baseOptions: Apollo.QueryHookOptions<GetAvailableVehiclesQuery, GetAvailableVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableVehiclesQuery, GetAvailableVehiclesQueryVariables>(GetAvailableVehiclesDocument, options);
      }
export function useGetAvailableVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableVehiclesQuery, GetAvailableVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableVehiclesQuery, GetAvailableVehiclesQueryVariables>(GetAvailableVehiclesDocument, options);
        }
export type GetAvailableVehiclesQueryHookResult = ReturnType<typeof useGetAvailableVehiclesQuery>;
export type GetAvailableVehiclesLazyQueryHookResult = ReturnType<typeof useGetAvailableVehiclesLazyQuery>;
export type GetAvailableVehiclesQueryResult = Apollo.QueryResult<GetAvailableVehiclesQuery, GetAvailableVehiclesQueryVariables>;
export const GetVehiclesAvailabilityDocument = gql`
    query getVehiclesAvailability($criteria: AvailabilityQueryCriteria!) {
  vehicles {
    available(criteria: $criteria) {
      vehicle {
        id
        vehicleClassId
        vehicleClassName
        vehicleSystemClass
        modelName
        makeName
        licenseNumber
        year
      }
      availability
      next {
        startTime
        endTime
      }
      previous {
        startTime
        endTime
      }
      overlapping {
        startTime
        endTime
        availability
        trip {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useGetVehiclesAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetVehiclesAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVehiclesAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVehiclesAvailabilityQuery({
 *   variables: {
 *      criteria: // value for 'criteria'
 *   },
 * });
 */
export function useGetVehiclesAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<GetVehiclesAvailabilityQuery, GetVehiclesAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVehiclesAvailabilityQuery, GetVehiclesAvailabilityQueryVariables>(GetVehiclesAvailabilityDocument, options);
      }
export function useGetVehiclesAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVehiclesAvailabilityQuery, GetVehiclesAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVehiclesAvailabilityQuery, GetVehiclesAvailabilityQueryVariables>(GetVehiclesAvailabilityDocument, options);
        }
export type GetVehiclesAvailabilityQueryHookResult = ReturnType<typeof useGetVehiclesAvailabilityQuery>;
export type GetVehiclesAvailabilityLazyQueryHookResult = ReturnType<typeof useGetVehiclesAvailabilityLazyQuery>;
export type GetVehiclesAvailabilityQueryResult = Apollo.QueryResult<GetVehiclesAvailabilityQuery, GetVehiclesAvailabilityQueryVariables>;
export const DeleteSavoyaVehicleDocument = gql`
    mutation DeleteSavoyaVehicle($id: UUID!) {
  deleteSavoyaVehicle(id: $id) {
    deleted
  }
}
    `;
export type DeleteSavoyaVehicleMutationFn = Apollo.MutationFunction<DeleteSavoyaVehicleMutation, DeleteSavoyaVehicleMutationVariables>;

/**
 * __useDeleteSavoyaVehicleMutation__
 *
 * To run a mutation, you first call `useDeleteSavoyaVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSavoyaVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSavoyaVehicleMutation, { data, loading, error }] = useDeleteSavoyaVehicleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSavoyaVehicleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSavoyaVehicleMutation, DeleteSavoyaVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSavoyaVehicleMutation, DeleteSavoyaVehicleMutationVariables>(DeleteSavoyaVehicleDocument, options);
      }
export type DeleteSavoyaVehicleMutationHookResult = ReturnType<typeof useDeleteSavoyaVehicleMutation>;
export type DeleteSavoyaVehicleMutationResult = Apollo.MutationResult<DeleteSavoyaVehicleMutation>;
export type DeleteSavoyaVehicleMutationOptions = Apollo.BaseMutationOptions<DeleteSavoyaVehicleMutation, DeleteSavoyaVehicleMutationVariables>;